/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(259)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.23.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(258)(module)))

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapActions; });
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(248)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(226);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventBus", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_sundair2019_plugin_js__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrollto__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toasted__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_toasted___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_toasted__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_toggle_button__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pretty_checkbox_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pretty_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pretty_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_swal__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_swal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_swal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_ls__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__enrian_vue_pikaday__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__enrian_vue_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__enrian_vue_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__enrian_vue_pikaday_dist_vue_pikaday_min_css__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__enrian_vue_pikaday_dist_vue_pikaday_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__enrian_vue_pikaday_dist_vue_pikaday_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_select__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_select_dist_vue_select_css__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_shared_flightsearch_FlightSearchTab_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_shared_flightsearch_FlightSearchResults_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_services_pagecontent_BookingnoOverview_vue__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_shared_forms_SeatTab_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_shared_forms_LuggageTab_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_shared_forms_HelpTab_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_shared_cart_Cart_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_shared_footer_FirstRow_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_shared_footer_SecondRow_vue__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_shared_footer_ThirdRow_vue__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_shared_header_LanguageList_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_shared_header_NavbarMain_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_shared_header_AgencyLogin_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_shared_header_SundairLogin_vue__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_shared_header_NavbarBreadcrumbs_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__store_store__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__filters_filters__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__routes_modules_booking_routes__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__routes_modules_infos_routes__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__routes_modules_checkout_routes__ = __webpack_require__(535);
/*
 * main.js
 *
 * Description: main.js
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */

 // v0.3









 // Note: css gets loaded in Header








// >>> Module:Shared -----------------------------------------------------------








 // Footer 1st Row
 // Footer 2nd Row
 // Footer 3rd Row
 // Header Language
 // Header Navbar Main

 // Agency Login
 // Sundair Login

 // Header Navbar BreadCrumbs

// >>> Global Store ------------------------------------------------------------ 'Stores'


// >>> Global Filters ---------------------------------------------------------- 'Filters'


// >>> Global Routes ----------------------------------------------------------- 'Routes - Booking'

// >>> Global Routes ----------------------------------------------------------- 'Routes - Services'
// import { routesservices } from './routes/modules/services/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Rebooking'
// import { routesrebooking } from './routes/modules/rebooking/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Career'
// import { routescareer } from './routes/modules/career/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Flightplan'
// import { routesflightplan } from './routes/modules/flightplan/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Infos'

// >>> Global Routes ----------------------------------------------------------- 'Routes - Pressreleases'
// import { routespressreleases } from './routes/modules/pressreleases/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Agency'
// import { routesagency } from './routes/modules/agency/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Travelcenter'
// import { routestravelcenter } from './routes/modules/travelcenter/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Flightstatus'
// import { routesflightstatus } from './routes/modules/flightstatus/routes';
// >>> Global Routes ----------------------------------------------------------- 'Routes - Checkout'

// >>> Global Routes ----------------------------------------------------------- 'Routes - Webshop'
// import { routeswebshop } from './routes/modules/webshop/routes';


// >>> Global Axios - Configs -------------------------------------------------- 'Axios - Config'
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = '/rest';
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers = {
    Accept: 'application/json',
    langCode: 'DE',
    apiKey: '0f27502d43e1c295f693feae8d02cb50', // kayofly key
    Authorization: null
};
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.request.use(function (config) {
    var lang = 'DE',
        user = '',
        pass = '',
        localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')),
        // catch
    localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username')),
        // catch
    localStorageAgencyPass = JSON.parse(localStorage.getItem('sdr__agency_password')); // catch


    // >>> Language in localStorage? ------------
    if (localStorageLanguage !== null) {
        lang = localStorageLanguage.value.toUpperCase();
    }
    config.headers.langCode = lang;

    // >>> Agency in localStorage? --------------
    if (localStorageAgencyUser !== null) {
        user = localStorageAgencyUser.value;
        pass = localStorageAgencyPass.value;
        config.headers.username = user;
        config.headers.password = pass;
    }

    // before a request is made start the nprogress
    // NProgress.start();

    return config;
});
__WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
    // before a response is returned stop nprogress
    // NProgress.done();
    return response;
});

// >>> VueRouter --------------------------------------------------------------- 'VueRouter - Config'
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var routerBooking = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    //mode: 'history',
    routes: __WEBPACK_IMPORTED_MODULE_36__routes_modules_booking_routes__["a" /* routesbooking */]
});
// const routerServices = new VueRouter({
//     //mode: 'history',
//     routes: routesservices
// });
// const routerRebooking = new VueRouter({
//     //mode: 'history',
//     routes: routesrebooking
// });
// const routerCareer = new VueRouter({
//     //mode: 'history',
//     routes: routescareer
// });
// const routerFlightplan = new VueRouter({
//     //mode: 'history',
//     routes: routesflightplan
// });
var routerInfos = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    //mode: 'history',
    routes: __WEBPACK_IMPORTED_MODULE_37__routes_modules_infos_routes__["a" /* routesinfos */]
});
// const routerPressreleases = new VueRouter({
//     //mode: 'history',
//     routes: routespressreleases
// });
// const routerAgency = new VueRouter({
//     //mode: 'history',
//     routes: routesagency
// });
// const routerTravelcenter = new VueRouter({
//     //mode: 'history',
//     routes: routestravelcenter
// });
// const routerFlightstatus = new VueRouter({
//     //mode: 'history',
//     routes: routesflightstatus
// });
var routerCheckout = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    //mode: 'history',
    routes: __WEBPACK_IMPORTED_MODULE_38__routes_modules_checkout_routes__["a" /* routescheckout */]
});
// const routerWebshop = new VueRouter({
//     //mode: 'history',
//     routes: routeswebshop
// });


// >>> Global Plugin -----------------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2__plugins_sundair2019_plugin_js__["a" /* default */]);

// >>> Global ScrollTo ---------------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default.a);

// >>> Global Toast ------------------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_toasted___default.a);
var toastOptionsError = {
    type: 'error',
    icon: 'soap-icon-insurance',
    iconPack: 'custom-class',
    position: 'top-center',
    fullWidth: true,
    fitToScreen: true,
    closeOnSwipe: true,
    duration: 5000
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].toasted.register('sdr_app_error', function (payload) {

    // if there is no message passed show default message
    if (!payload.message) {
        return "Oops.. Something Went Wrong..";
    }

    // if there is a message show it with the message
    return "Oops.. " + payload.message;
}, toastOptionsError);

var toastOptionsInfo = {
    type: 'info',
    icon: 'soap-icon-insurance',
    iconPack: 'custom-class',
    position: 'top-center',
    fullWidth: true,
    fitToScreen: true,
    closeOnSwipe: true,
    duration: 5000
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].toasted.register('sdr_app_info', function (payload) {

    // if there is no message passed show default message
    if (!payload.message) {
        return 'Oops.. Something Went Wrong..';
    }

    // if there is a message show it with the message
    return 'Worked.. ' + payload.message;
}, toastOptionsInfo);

// >>> Init Plugin - Loading ---------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a);

// >>> Init Plugin - VTooltip  -------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* default */]);

// >>> Init Plugin - VModal  ---------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal___default.a, { dialog: true });

// >>> Init Plugin - ToggleButton  ---------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_js_toggle_button___default.a);

// >>> Init Plugin - PrettyCheckbox  -------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_pretty_checkbox_vue___default.a);

// >>> Init Plugin - Vuelidate -------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vuelidate___default.a);

// >>> Init Plugin - VueSwal ---------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_swal___default.a);

// >>> Init Plugin - Storage ---------------------------------------------------
var storageOptions = {
    namespace: 'sdr__', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local' // storage name session, local, memory
};
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_ls___default.a, storageOptions);

// >>> Init Plugin - PikaDay ---------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15__enrian_vue_pikaday___default.a);

// >>> Init Plugin - vSelect ---------------------------------------------------
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_17_vue_select___default.a);

// >>> -------------------------------------------------------------------------
var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// >>> Vue Instance:'Booking' -------------------------------------------------- 'Booking'
var vm_booking = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({

    components: {
        'sdr-shared-flightsearch-tab': __WEBPACK_IMPORTED_MODULE_19__components_shared_flightsearch_FlightSearchTab_vue__["a" /* default */],
        'sdr-shared-seat-tab': __WEBPACK_IMPORTED_MODULE_22__components_shared_forms_SeatTab_vue__["a" /* default */],
        'sdr-shared-luggage-tab': __WEBPACK_IMPORTED_MODULE_23__components_shared_forms_LuggageTab_vue__["a" /* default */],
        'sdr-shared-help-tab': __WEBPACK_IMPORTED_MODULE_24__components_shared_forms_HelpTab_vue__["a" /* default */],
        // --------------------------------------
        'sdr-shared-flightsearchresults': __WEBPACK_IMPORTED_MODULE_20__components_shared_flightsearch_FlightSearchResults_vue__["a" /* default */],
        // --------------------------------------
        'sdr-shared-cart': __WEBPACK_IMPORTED_MODULE_25__components_shared_cart_Cart_vue__["a" /* default */],
        // --------------------------------------
        'sdr-shared-footer-first-row': __WEBPACK_IMPORTED_MODULE_26__components_shared_footer_FirstRow_vue__["a" /* default */], // Footer 1st row
        'sdr-shared-footer-second-row': __WEBPACK_IMPORTED_MODULE_27__components_shared_footer_SecondRow_vue__["a" /* default */], // Footer 2nd row
        'sdr-shared-footer-third-row': __WEBPACK_IMPORTED_MODULE_28__components_shared_footer_ThirdRow_vue__["a" /* default */], // Footer 3d row
        'sdr-shared-languagelist': __WEBPACK_IMPORTED_MODULE_29__components_shared_header_LanguageList_vue__["a" /* default */], // Header Language
        'sdr-shared-navbarbmain': __WEBPACK_IMPORTED_MODULE_30__components_shared_header_NavbarMain_vue__["a" /* default */], // Header Navbar Main
        'sdr-shared-agencylogin': __WEBPACK_IMPORTED_MODULE_31__components_shared_header_AgencyLogin_vue__["a" /* default */], // Agency Login
        'sdr-shared-sundairlogin': __WEBPACK_IMPORTED_MODULE_32__components_shared_header_SundairLogin_vue__["a" /* default */], // Sundair Login
        'sdr-shared-navbarbreadcrumbs': __WEBPACK_IMPORTED_MODULE_33__components_shared_header_NavbarBreadcrumbs_vue__["a" /* default */] // Header Navbar BreadCrumbs
    },
    store: __WEBPACK_IMPORTED_MODULE_34__store_store__["a" /* store */], // global one
    router: routerBooking, // global 'Booking' one


    /***************************************************************************
    * Instant LifeCycle(s)
    *
    * Desc: Build Authorization Header. Language too.
    * Note: See Plugin.
    *
    */
    created: function created() {

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.Authorization = this.$make_basic_auth();
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.langCode = this.$header_language();
    } // eof created()

});
vm_booking.$mount('.ModuleBooking');

// >>> Vue Instance:'Service' -------------------------------------------------- 'Service'
// var vm_services = new Vue({

//     components: {
//         'sdr-shared-flightsearch-tab': FlightSearchTab,
//         'sdr-shared-help-tab': HelpTab,
//         // --------------------------------------
//         'sdr-shared-flightsearchresults': FlightSearchResults,
//         'sdr-services-bookingnooverview': BookingnoOverview,
//         // --------------------------------------
//         'sdr-shared-cart': Cart,
//         // --------------------------------------
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerServices, // global 'Services' one

// });
// vm_services.$mount('.ModuleServices');


// >>> Vue Instance:'Rebooking' ------------------------------------------------ 'Rebooking'
// var vm_rebooking = new Vue({

//     components: {
//         // --------------------------------------
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerRebooking, // global 'Booking' one


//     /***************************************************************************
//     * Instant LifeCycle(s)
//     *
//     * Desc: Build Authorization Header. Language too.
//     * Note: See Plugin.
//     *
//     */
//     created: function () {

//         axios.defaults.headers.Authorization = this.$make_basic_auth();
//         axios.defaults.headers.langCode = this.$header_language();

//     } // eof created()

// });
// vm_rebooking.$mount('.ModuleRebooking');


// >>> Vue Instance:'Career' --------------------------------------------------- 'Career'
// var vm_career = new Vue({

//     components: {
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerCareer, // global 'Career' one

// });
// vm_career.$mount('.ModuleCareer');


// >>> Vue Instance:'Flightplan' -----------------------------------------------'Flightplan'
// var vm_flightplan = new Vue({

//     components: {
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerFlightplan, // global 'Career' one

// });
// vm_flightplan.$mount('.ModuleFlightplan');


// >>> Vue Instance:'Pressreleases' -------------------------------------------- 'Pressreleases'
// var vm_pressreleases = new Vue({

//     components: {
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerPressreleases, // global 'Career' one

// });
// vm_pressreleases.$mount('.ModulePressreleases');


// >>> Vue Instance:'Agency' --------------------------------------------------- 'Agency'
// var vm_agency = new Vue({

//     components: {
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerAgency, // global 'Agency' one

// });
// vm_agency.$mount('.ModuleAgency');


// >>> Vue Instance:'Travelcenter' --------------------------------------------- 'Travelcenter'
// var vm_travelcenter = new Vue({

//     components: {
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerTravelcenter, // global 'Travelcenter' one

// });
// vm_travelcenter.$mount('.ModuleTravelcenter');


// >>> Vue Instance:'Flightstatus' --------------------------------------------- 'Flightstatus'
// var vm_flightstatus = new Vue({

//     components: {
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerFlightstatus, // global 'Flightstatus' one

// });
// vm_flightstatus.$mount('.ModuleFlightstatus');


// >>> Vue Instance:'Checkout' ------------------------------------------------- 'Checkout'
var vm_checkout = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({

    components: {
        'sdr-shared-footer-first-row': __WEBPACK_IMPORTED_MODULE_26__components_shared_footer_FirstRow_vue__["a" /* default */], // Footer 1st row
        'sdr-shared-footer-second-row': __WEBPACK_IMPORTED_MODULE_27__components_shared_footer_SecondRow_vue__["a" /* default */], // Footer 2nd row
        'sdr-shared-footer-third-row': __WEBPACK_IMPORTED_MODULE_28__components_shared_footer_ThirdRow_vue__["a" /* default */], // Footer 3d row
        'sdr-shared-languagelist': __WEBPACK_IMPORTED_MODULE_29__components_shared_header_LanguageList_vue__["a" /* default */], // Header Language
        'sdr-shared-navbarbmain': __WEBPACK_IMPORTED_MODULE_30__components_shared_header_NavbarMain_vue__["a" /* default */], // Header Navbar Main
        'sdr-shared-agencylogin': __WEBPACK_IMPORTED_MODULE_31__components_shared_header_AgencyLogin_vue__["a" /* default */], // Agency Login
        'sdr-shared-sundairlogin': __WEBPACK_IMPORTED_MODULE_32__components_shared_header_SundairLogin_vue__["a" /* default */], // Sundair Login
        'sdr-shared-navbarbreadcrumbs': __WEBPACK_IMPORTED_MODULE_33__components_shared_header_NavbarBreadcrumbs_vue__["a" /* default */] // Header Navbar BreadCrumbs
    },
    store: __WEBPACK_IMPORTED_MODULE_34__store_store__["a" /* store */], // global one
    router: routerCheckout // global 'Flightstatus' one

});
vm_checkout.$mount('.ModuleCheckout');

// >>> Vue Instance:'Checkout' ------------------------------------------------- 'Webshop'
// var vm_checkout = new Vue({

//     components: {
//         'sdr-shared-footer-first-row': FooterFirstRow, // Footer 1st row
//         'sdr-shared-footer-second-row': FooterSecondRow, // Footer 2nd row
//         'sdr-shared-footer-third-row': FooterThirdRow, // Footer 3d row
//         'sdr-shared-languagelist': LanguageList, // Header Language
//         'sdr-shared-navbarbmain': NavbarMain, // Header Navbar Main
//         'sdr-shared-agencylogin': AgencyLogin, // Agency Login
//         'sdr-shared-sundairlogin': SundairLogin, // Sundair Login
//         'sdr-shared-navbarbreadcrumbs': NavbarBreadcrumbs, // Header Navbar BreadCrumbs
//     },
//     store: store, // global one
//     router: routerWebshop, // global 'Flightstatus' one

// });
// vm_checkout.$mount('.ModuleWebshop');


// >>> Vue Instance:'Shared' --------------------------------------------------- 'Shared - Infos'
var vm_shared = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({

    components: {
        // --------------------------------------
        'sdr-shared-footer-first-row': __WEBPACK_IMPORTED_MODULE_26__components_shared_footer_FirstRow_vue__["a" /* default */], // Footer 1st row
        'sdr-shared-footer-second-row': __WEBPACK_IMPORTED_MODULE_27__components_shared_footer_SecondRow_vue__["a" /* default */], // Footer 2nd row
        'sdr-shared-footer-third-row': __WEBPACK_IMPORTED_MODULE_28__components_shared_footer_ThirdRow_vue__["a" /* default */], // Footer 3d row
        'sdr-shared-languagelist': __WEBPACK_IMPORTED_MODULE_29__components_shared_header_LanguageList_vue__["a" /* default */], // Header Language
        'sdr-shared-navbarbmain': __WEBPACK_IMPORTED_MODULE_30__components_shared_header_NavbarMain_vue__["a" /* default */], // Header Navbar Main
        'sdr-shared-agencylogin': __WEBPACK_IMPORTED_MODULE_31__components_shared_header_AgencyLogin_vue__["a" /* default */], // Agency Login
        'sdr-shared-sundairlogin': __WEBPACK_IMPORTED_MODULE_32__components_shared_header_SundairLogin_vue__["a" /* default */], // Sundair Login
        'sdr-shared-navbarbreadcrumbs': __WEBPACK_IMPORTED_MODULE_33__components_shared_header_NavbarBreadcrumbs_vue__["a" /* default */] // Header Navbar BreadCrumbs
    },
    store: __WEBPACK_IMPORTED_MODULE_34__store_store__["a" /* store */], // global one
    router: routerInfos // global 'Infos' one

});
vm_shared.$mount('.ModuleShared');

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(377));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactBox_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2623191e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactBox_vue__ = __webpack_require__(303);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2623191e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2623191e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.17
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.17';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13), __webpack_require__(222).setImmediate))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(24);
var isBuffer = __webpack_require__(227);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSundairBox_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ff234_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutSundairBox_vue__ = __webpack_require__(482);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-084ff234"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutSundairBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_084ff234_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutSundairBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoBox_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755432a9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoBox_vue__ = __webpack_require__(485);
function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-755432a9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_755432a9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477e7a86_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__ = __webpack_require__(273);
function injectStyle (ssrContext) {
  __webpack_require__(271)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-477e7a86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_477e7a86_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CONF_ENVIRONMENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONF_3DSECURE_ORIGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONF_API_BASEURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONF_MOURNING; });
/* unused harmony export CONF_VERSION_NUMBER */
/* unused harmony export CONF_REVISIONS_NUMBER */
/*
* config.js
*
* Description: config.js
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/
/*******************************************************************************
* Config: ENVIRONMENT
*
*/
var CONF_ENVIRONMENT = "DEV"; // DEV or PROD


/*******************************************************************************
* Config: REST - '3D SECURE INFORMATIONS'
*
*/
var CONF_3DSECURE_ORIGIN = CONF_ENVIRONMENT === "DEV" ? "https://test-booking2019-2.sundair.com" : "https://sundair.com";

/*******************************************************************************
* Config: 'API BASE URL'
*
*/
// export const CONF_API_BASEURL = "https://sdr-cms-development.herokuapp.com/graphql"; // DEV
var CONF_API_BASEURL = "https://sdr-cms-test.herokuapp.com/graphql"; // TEST
// export const CONF_API_BASEURL = "https://sdr-cms.herokuapp.com/graphql"; // LIVE
// export const CONF_API_BASEURL = "http://localhost:3000/graphql";


/*******************************************************************************
* Config: MOURNING
* => FlightSearchTab.vue => See style block (Change colors)
* => head.inc.php => style.css, style-mourning.css
*
*/
var CONF_MOURNING = "false";

/*******************************************************************************
* Config: VERSION/REVISION NUMBER
*
*/
var CONF_VERSION_NUMBER = "Kayofly"; // based on: r.2697 v0.Z1
var CONF_REVISIONS_NUMBER = "r.2766";

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5016ec47_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__ = __webpack_require__(292);
function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5016ec47"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5016ec47_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OperationType;
(function (OperationType) {
    OperationType["Mutation"] = "mutation";
    OperationType["Query"] = "query";
    OperationType["Subscription"] = "subscription";
})(OperationType || (OperationType = {}));
exports.default = OperationType;
//# sourceMappingURL=OperationType.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var NestedField_1 = __webpack_require__(323);
var Utils = /** @class */ (function () {
    function Utils() {
    }
    Utils.resolveVariables = function (operations) {
        var ret = {};
        for (var _i = 0, operations_1 = operations; _i < operations_1.length; _i++) {
            var _a = operations_1[_i], variables = _a.variables, fields = _a.fields;
            ret = __assign(__assign(__assign({}, ret), variables), ((fields && Utils.getNestedVariables(fields)) || {}));
        }
        return ret;
    };
    // Convert object to name and argument map. eg: (id: $id)
    Utils.queryDataNameAndArgumentMap = function (variables) {
        return variables && Object.keys(variables).length
            ? "(".concat(Object.entries(variables).reduce(function (dataString, _a, i) {
                var key = _a[0], value = _a[1];
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(value && value.name ? value.name : key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    Utils.queryFieldsMap = function (fields) {
        var _this = this;
        return fields
            ? fields
                .map(function (field) {
                if ((0, NestedField_1.isNestedField)(field)) {
                    return Utils.queryNestedFieldMap(field);
                }
                else if (typeof field === "object") {
                    var values = Object.values(field)[0];
                    return "".concat(Object.keys(field)[0], " ").concat(values.length > 0
                        ? "{ " + _this.queryFieldsMap(values) + " }"
                        : "");
                }
                else {
                    return "".concat(field);
                }
            })
                .join(", ")
            : "";
    };
    Utils.queryNestedFieldMap = function (field) {
        return "".concat(field.operation, " ").concat(this.queryDataNameAndArgumentMap(field.variables), " ").concat(field.fields.length > 0
            ? "{ " + this.queryFieldsMap(field.fields) + " }"
            : "");
    };
    // Variables map. eg: { "id": 1, "name": "Jon Doe" }
    Utils.queryVariablesMap = function (variables, fields) {
        var variablesMapped = {};
        var update = function (vars) {
            if (vars) {
                Object.keys(vars).map(function (key) {
                    variablesMapped[key] =
                        typeof vars[key] === "object" ? vars[key].value : vars[key];
                });
            }
        };
        update(variables);
        if (fields && typeof fields === "object") {
            update(Utils.getNestedVariables(fields));
        }
        return variablesMapped;
    };
    Utils.getNestedVariables = function (fields) {
        var variables = {};
        function getDeepestVariables(innerFields) {
            innerFields === null || innerFields === void 0 ? void 0 : innerFields.forEach(function (field) {
                if ((0, NestedField_1.isNestedField)(field)) {
                    variables = __assign(__assign(__assign({}, field.variables), variables), (field.fields && getDeepestVariables(field.fields)));
                }
                else {
                    if (typeof field === "object") {
                        for (var _i = 0, _a = Object.entries(field); _i < _a.length; _i++) {
                            var _b = _a[_i], value = _b[1];
                            getDeepestVariables(value);
                        }
                    }
                }
            });
            return variables;
        }
        getDeepestVariables(fields);
        return variables;
    };
    Utils.queryDataType = function (variable) {
        var type = "String";
        var value = typeof variable === "object" ? variable.value : variable;
        if ((variable === null || variable === void 0 ? void 0 : variable.type) != null) {
            type = variable.type;
        }
        else {
            // TODO: Should handle the undefined value (either in array value or single value)
            var candidateValue = Array.isArray(value) ? value[0] : value;
            switch (typeof candidateValue) {
                case "object":
                    type = "Object";
                    break;
                case "boolean":
                    type = "Boolean";
                    break;
                case "number":
                    type = candidateValue % 1 === 0 ? "Int" : "Float";
                    break;
            }
        }
        // set object based variable properties
        if (typeof variable === "object") {
            if (variable.list === true) {
                type = "[".concat(type, "]");
            }
            else if (Array.isArray(variable.list)) {
                type = "[".concat(type).concat(variable.list[0] ? "!" : "", "]");
            }
            if (variable.required) {
                type += "!";
            }
        }
        return type;
    };
    return Utils;
}());
exports.default = Utils;
//# sourceMappingURL=Utils.js.map

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(376));

var _alphaNum = _interopRequireDefault(__webpack_require__(379));

var _numeric = _interopRequireDefault(__webpack_require__(380));

var _between = _interopRequireDefault(__webpack_require__(381));

var _email = _interopRequireDefault(__webpack_require__(382));

var _ipAddress = _interopRequireDefault(__webpack_require__(383));

var _macAddress = _interopRequireDefault(__webpack_require__(384));

var _maxLength = _interopRequireDefault(__webpack_require__(385));

var _minLength = _interopRequireDefault(__webpack_require__(386));

var _required = _interopRequireDefault(__webpack_require__(387));

var _requiredIf = _interopRequireDefault(__webpack_require__(388));

var _requiredUnless = _interopRequireDefault(__webpack_require__(389));

var _sameAs = _interopRequireDefault(__webpack_require__(390));

var _url = _interopRequireDefault(__webpack_require__(391));

var _or = _interopRequireDefault(__webpack_require__(392));

var _and = _interopRequireDefault(__webpack_require__(393));

var _not = _interopRequireDefault(__webpack_require__(394));

var _minValue = _interopRequireDefault(__webpack_require__(395));

var _maxValue = _interopRequireDefault(__webpack_require__(396));

var _integer = _interopRequireDefault(__webpack_require__(397));

var _decimal = _interopRequireDefault(__webpack_require__(398));

var helpers = _interopRequireWildcard(__webpack_require__(7));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(10);
var normalizeHeaderName = __webpack_require__(229);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(25);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(25);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global['vue-scrollto'] = factory());
}(this, (function () { 'use strict';

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

var src = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    }
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};

var easings = {
    ease: [0.25, 0.1, 0.25, 1.0],
    linear: [0.00, 0.0, 1.00, 1.0],
    "ease-in": [0.42, 0.0, 1.00, 1.0],
    "ease-out": [0.00, 0.0, 0.58, 1.0],
    "ease-in-out": [0.42, 0.0, 0.58, 1.0]
};

// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
var supportsPassive = false;
try {
    var opts = Object.defineProperty({}, "passive", {
        get: function get() {
            supportsPassive = true;
        }
    });
    window.addEventListener("test", null, opts);
} catch (e) {}

var _ = {
    $: function $(selector) {
        if (typeof selector !== "string") {
            return selector;
        }
        return document.querySelector(selector);
    },
    on: function on(element, events, handler) {
        var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { passive: false };

        if (!(events instanceof Array)) {
            events = [events];
        }
        for (var i = 0; i < events.length; i++) {
            element.addEventListener(events[i], handler, supportsPassive ? opts : false);
        }
    },
    off: function off(element, events, handler) {
        if (!(events instanceof Array)) {
            events = [events];
        }
        for (var i = 0; i < events.length; i++) {
            element.removeEventListener(events[i], handler);
        }
    },
    cumulativeOffset: function cumulativeOffset(element) {
        var top = 0;
        var left = 0;

        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);

        return {
            top: top,
            left: left
        };
    }
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var abortEvents = ["mousedown", "wheel", "DOMMouseScroll", "mousewheel", "keyup", "touchmove"];

var defaults$$1 = {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
};

function setDefaults(options) {
    defaults$$1 = _extends({}, defaults$$1, options);
}

var scroller = function scroller() {
    var element = void 0; // element to scroll to
    var container = void 0; // container to scroll
    var duration = void 0; // duration of the scrolling
    var easing = void 0; // easing to be used when scrolling
    var offset = void 0; // offset to be added (subtracted)
    var force = void 0; // force scroll, even if element is visible
    var cancelable = void 0; // indicates if user can cancel the scroll or not.
    var onStart = void 0; // callback when scrolling is started
    var onDone = void 0; // callback when scrolling is done
    var onCancel = void 0; // callback when scrolling is canceled / aborted
    var x = void 0; // scroll on x axis
    var y = void 0; // scroll on y axis

    var initialX = void 0; // initial X of container
    var targetX = void 0; // target X of container
    var initialY = void 0; // initial Y of container
    var targetY = void 0; // target Y of container
    var diffX = void 0; // difference
    var diffY = void 0; // difference

    var abort = void 0; // is scrolling aborted

    var abortEv = void 0; // event that aborted scrolling
    var abortFn = function abortFn(e) {
        if (!cancelable) return;
        abortEv = e;
        abort = true;
    };
    var easingFn = void 0;

    var timeStart = void 0; // time when scrolling started
    var timeElapsed = void 0; // time elapsed since scrolling started

    var progress = void 0; // progress

    function scrollTop(container) {
        var scrollTop = container.scrollTop;

        if (container.tagName.toLowerCase() === "body") {
            // in firefox body.scrollTop always returns 0
            // thus if we are trying to get scrollTop on a body tag
            // we need to get it from the documentElement
            scrollTop = scrollTop || document.documentElement.scrollTop;
        }

        return scrollTop;
    }

    function scrollLeft(container) {
        var scrollLeft = container.scrollLeft;

        if (container.tagName.toLowerCase() === "body") {
            // in firefox body.scrollLeft always returns 0
            // thus if we are trying to get scrollLeft on a body tag
            // we need to get it from the documentElement
            scrollLeft = scrollLeft || document.documentElement.scrollLeft;
        }

        return scrollLeft;
    }

    function step(timestamp) {
        if (abort) return done();
        if (!timeStart) timeStart = timestamp;

        timeElapsed = timestamp - timeStart;

        progress = Math.min(timeElapsed / duration, 1);
        progress = easingFn(progress);

        topLeft(container, initialY + diffY * progress, initialX + diffX * progress);

        timeElapsed < duration ? window.requestAnimationFrame(step) : done();
    }

    function done() {
        if (!abort) topLeft(container, targetY, targetX);
        timeStart = false;

        _.off(container, abortEvents, abortFn);
        if (abort && onCancel) onCancel(abortEv, element);
        if (!abort && onDone) onDone(element);
    }

    function topLeft(element, top, left) {
        if (y) element.scrollTop = top;
        if (x) element.scrollLeft = left;
        if (element.tagName.toLowerCase() === "body") {
            // in firefox body.scrollTop doesn't scroll the page
            // thus if we are trying to scrollTop on a body tag
            // we need to scroll on the documentElement
            if (y) document.documentElement.scrollTop = top;
            if (x) document.documentElement.scrollLeft = left;
        }
    }

    function scrollTo(target, _duration) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if ((typeof _duration === "undefined" ? "undefined" : _typeof(_duration)) === "object") {
            options = _duration;
        } else if (typeof _duration === "number") {
            options.duration = _duration;
        }

        element = _.$(target);

        if (!element) {
            return console.warn("[vue-scrollto warn]: Trying to scroll to an element that is not on the page: " + target);
        }

        container = _.$(options.container || defaults$$1.container);
        duration = options.duration || defaults$$1.duration;
        easing = options.easing || defaults$$1.easing;
        offset = options.offset || defaults$$1.offset;
        force = options.hasOwnProperty("force") ? options.force !== false : defaults$$1.force;
        cancelable = options.hasOwnProperty("cancelable") ? options.cancelable !== false : defaults$$1.cancelable;
        onStart = options.onStart || defaults$$1.onStart;
        onDone = options.onDone || defaults$$1.onDone;
        onCancel = options.onCancel || defaults$$1.onCancel;
        x = options.x === undefined ? defaults$$1.x : options.x;
        y = options.y === undefined ? defaults$$1.y : options.y;

        var cumulativeOffsetContainer = _.cumulativeOffset(container);
        var cumulativeOffsetElement = _.cumulativeOffset(element);

        if (typeof offset === "function") {
            offset = offset();
        }

        initialY = scrollTop(container);
        targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;

        initialX = scrollLeft(container);
        targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;

        abort = false;

        diffY = targetY - initialY;
        diffX = targetX - initialX;

        if (!force) {
            var containerTop = initialY;
            var containerBottom = containerTop + container.offsetHeight;
            var elementTop = targetY;
            var elementBottom = elementTop + element.offsetHeight;
            if (elementTop >= containerTop && elementBottom <= containerBottom) {
                return;
            }
        }

        if (typeof easing === "string") {
            easing = easings[easing] || easings["ease"];
        }

        easingFn = src.apply(src, easing);

        if (!diffY && !diffX) return;
        if (onStart) onStart(element);

        _.on(container, abortEvents, abortFn, { passive: true });

        window.requestAnimationFrame(step);

        return function () {
            abortEv = null;
            abort = true;
        };
    }

    return scrollTo;
};

var _scroller = scroller();

var bindings = []; // store binding data

function deleteBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
        if (bindings[i].el === el) {
            bindings.splice(i, 1);
            return true;
        }
    }
    return false;
}

function findBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
        if (bindings[i].el === el) {
            return bindings[i];
        }
    }
}

function getBinding(el) {
    var binding = findBinding(el);

    if (binding) {
        return binding;
    }

    bindings.push(binding = {
        el: el,
        binding: {}
    });

    return binding;
}

function handleClick(e) {
    e.preventDefault();
    var ctx = getBinding(this).binding;

    if (typeof ctx.value === "string") {
        return _scroller(ctx.value);
    }
    _scroller(ctx.value.el || ctx.value.element, ctx.value);
}

var VueScrollTo$1 = {
    bind: function bind(el, binding) {
        getBinding(el).binding = binding;
        _.on(el, "click", handleClick);
    },
    unbind: function unbind(el) {
        deleteBinding(el);
        _.off(el, "click", handleClick);
    },
    update: function update(el, binding) {
        getBinding(el).binding = binding;
    },

    scrollTo: _scroller,
    bindings: bindings
};

var install = function install(Vue, options) {
    if (options) setDefaults(options);
    Vue.directive("scroll-to", VueScrollTo$1);
    Vue.prototype.$scrollTo = VueScrollTo$1.scrollTo;
};

if (typeof window !== "undefined" && window.Vue) {
    window.VueScrollTo = VueScrollTo$1;
    window.VueScrollTo.setDefaults = setDefaults;
    window.Vue.use(install);
}

VueScrollTo$1.install = install;

return VueScrollTo$1;

})));


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.adapters = exports.query = exports.mutation = exports.subscription = void 0;
var adapters_1 = __webpack_require__(321);
exports.adapters = adapters_1.default;
var DefaultMutationAdapter_1 = __webpack_require__(325);
var DefaultQueryAdapter_1 = __webpack_require__(326);
var DefaultSubscriptionAdapter_1 = __webpack_require__(327);
function queryOperation(options, adapter, config) {
    var defaultAdapter;
    if (Array.isArray(options)) {
        if (adapter) {
            var customAdapter = new adapter(options, config);
            return customAdapter.queriesBuilder(options);
        }
        defaultAdapter = new DefaultQueryAdapter_1.default(options, config);
        return defaultAdapter.queriesBuilder(options);
    }
    if (adapter) {
        var customAdapter = new adapter(options, config);
        return customAdapter.queryBuilder();
    }
    defaultAdapter = new DefaultQueryAdapter_1.default(options, config);
    return defaultAdapter.queryBuilder();
}
exports.query = queryOperation;
function mutationOperation(options, adapter) {
    var customAdapter;
    var defaultAdapter;
    if (Array.isArray(options)) {
        if (adapter) {
            // @ts-ignore
            customAdapter = new adapter(options);
            return customAdapter.mutationsBuilder(options);
        }
        defaultAdapter = new DefaultMutationAdapter_1.default(options);
        return defaultAdapter.mutationsBuilder(options);
    }
    if (adapter) {
        // @ts-ignore
        customAdapter = new adapter(options);
        return customAdapter.mutationBuilder();
    }
    defaultAdapter = new DefaultMutationAdapter_1.default(options);
    return defaultAdapter.mutationBuilder();
}
exports.mutation = mutationOperation;
function subscriptionOperation(options, adapter) {
    var customAdapter;
    var defaultAdapter;
    if (Array.isArray(options)) {
        if (adapter) {
            // @ts-ignore
            customAdapter = new adapter(options);
            return customAdapter.subscriptionsBuilder(options);
        }
        defaultAdapter = new DefaultSubscriptionAdapter_1.default(options);
        return defaultAdapter.subscriptionsBuilder(options);
    }
    if (adapter) {
        // @ts-ignore
        customAdapter = new adapter(options);
        return customAdapter.subscriptionBuilder();
    }
    defaultAdapter = new DefaultSubscriptionAdapter_1.default(options);
    return defaultAdapter.subscriptionBuilder();
}
exports.subscription = subscriptionOperation;
//# sourceMappingURL=index.js.map

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);
var settle = __webpack_require__(230);
var buildURL = __webpack_require__(232);
var parseHeaders = __webpack_require__(233);
var isURLSameOrigin = __webpack_require__(234);
var createError = __webpack_require__(26);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(235);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(236);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(231);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;
exports._setTarget = exports.target = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var stack = [];
var target = null;
exports.target = target;

var _setTarget = function _setTarget(x) {
  exports.target = target = x;
};

exports._setTarget = _setTarget;

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }

  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;

  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }

    newTarget.$sub.push(lastTarget);
  }

  return lastTarget;
}

function addParams(params) {
  if (_typeof(params) === 'object' && !Array.isArray(params)) {
    exports.target = target = _objectSpread({}, target, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();

    try {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }

  return withParamsClosure(paramsOrClosure);
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsParse : (function (months, monthsShort) {
            var i, _monthsParse = [];
            for (i = 0; i < 12; i++) {
                // use custom parser to solve problem with July (červenec)
                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
            }
            return _monthsParse;
        }(months, monthsShort)),
        shortMonthsParse : (function (monthsShort) {
            var i, _shortMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
            }
            return _shortMonthsParse;
        }(monthsShort)),
        longMonthsParse : (function (months) {
            var i, _longMonthsParse = [];
            for (i = 0; i < 12; i++) {
                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
            }
            return _longMonthsParse;
        }(months)),
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'MMMM [de] D [de] YYYY',
            LLL : 'MMMM [de] D [de] YYYY h:mm A',
            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minutt',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaði',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka horan', 'ek hor'],
            'hh': [number + ' horanim', number + ' horam'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
    months = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم'
    ];


    var ku = moment.defineLocale('ku', {
        months : months,
        monthsShort : months,
        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar : {
            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
            nextDay : '[به‌یانی كاتژمێر] LT',
            nextWeek : 'dddd [كاتژمێر] LT',
            lastDay : '[دوێنێ كاتژمێر] LT',
            lastWeek : 'dddd [كاتژمێر] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'له‌ %s',
            past : '%s',
            s : 'چه‌ند چركه‌یه‌ك',
            ss : 'چركه‌ %d',
            m : 'یه‌ك خوله‌ك',
            mm : '%d خوله‌ك',
            h : 'یه‌ك كاتژمێر',
            hh : '%d كاتژمێر',
            d : 'یه‌ك ڕۆژ',
            dd : '%d ڕۆژ',
            M : 'یه‌ك مانگ',
            MM : '%d مانگ',
            y : 'یه‌ك ساڵ',
            yy : '%d ساڵ'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;

})));


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кечээ саат] LT',
            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(0)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightSearchTab_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb2a166_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightSearchTab_vue__ = __webpack_require__(268);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightSearchTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb2a166_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightSearchTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            // ----------------------------------
            searchboxheadlineflights: {
                en: 'Search and book flights',
                de: 'Flüge suchen und buchen'
            },
            searchboxheadlineservices: {
                en: 'Find flights and add services',
                de: 'Flüge finden und Services hinzubuchen'
            },
            searchboxheadlineflights2: {
                en: 'Discover the world with SUNDAIR!',
                de: 'Entdecke die Welt mit SUNDAIR!'
            },
            // ----------------------------------
            outwardandreturnflight: {
                en: 'Round Trip',
                de: 'Hin- und Rückflug'
            },
            outwardonlyflight: {
                en: 'One way only',
                de: 'nur der Hinflug'
            },
            returntootherflight: {
                en: 'Return new destination',
                de: 'Rückflug neues Ziel'
            },
            // ----------------------------------
            where: {
                en: 'Where',
                de: 'Wohin'
            },
            yourplaceofdeparture: {
                en: 'YOUR DEPARTURE',
                de: 'IHR ABFLUGSORT'
            },
            yourplaceofdestination: {
                en: 'YOUR DESTINATION',
                de: 'IHR ZIELORT'
            },
            yourplaceofdeparturetoother: {
                en: 'YOUR NEW DEPARTURE',
                de: 'IHR NEUER ABFLUGSORT'
            },
            yourplaceofdestinationtoother: {
                en: 'YOUR NEW DESTINATION',
                de: 'IHR NEUER ZIELORT'
            },

            departureairport: {
                en: 'Please choose your departure airport',
                de: 'Wählen Sie Ihren Startflughafen'
            },
            destinationairport: {
                en: 'Please choose your destination airport',
                de: 'Wählen Sie Ihren Zielflughafen'
            },
            departureairporttoother: {
                en: 'Please choose your departure airport',
                de: 'Wählen Sie zuerst Hin-Rückflug'
            },
            destinationairporttoother: {
                en: 'Please choose your new destination airport',
                de: 'Wählen Sie Ihren neuen Zielflughafen'
            },

            // ----------------------------------
            when: {
                en: 'When',
                de: 'Wann'
            },
            departuredate: {
                en: 'Date Departure',
                de: 'Abflugdatum'
            },
            returndate: {
                en: 'Date Return',
                de: 'Rückflugdatum'
            },
            // ----------------------------------
            who: {
                en: 'Who',
                de: 'Wer'
            },
            adult: {
                en: 'Adults',
                de: 'Erwachsene'
            },
            adultyears: {
                en: '(From 12+ Years)',
                de: '(Ab 12+ Jahre)'
            },
            child: {
                en: 'Children',
                de: 'Kinder'
            },
            childyears: {
                en: '(2 to 12 Years)',
                de: '(2 bis 12 Jahre)'
            },
            infant: {
                en: 'Infants',
                de: 'Kleinkinder'
            },
            infantyears: {
                en: '(Up to 2 Years)',
                de: '(Bis 2 Jahre)'
            },
            // ----------------------------------
            findflights: {
                en: 'FIND FLIGHTS',
                de: 'FLÜGE FINDEN'
            },
            tomanypeople: {
                en: 'Please use our group booking form for flight bookings of 11 or more passengers or contact customer service..',
                de: 'Bitte nutzen Sie bei einer Flugbuchung ab 11 Passagiere unser Gruppenbuchungsformular oder wenden Sie sich an den Kundenservice..'
            },
            noretflightonroundtrip: {
                en: 'Dear customer, for your search request outbound or return flights are already fully booked. Please start your search again.',
                de: 'Lieber Kunde, für Ihre Suchanfrage sind bereits Hin- oder Rückflüge ausgebucht. Bitte starten Sie Ihre Suche erneut.'
            },
            // ----------------------------------------
            modal_headline_rebooking_error: {
                en: 'Attention: No Flights anymore',
                de: 'Achtung: Keine Flüge mehr'
            },
            modal_content_rebooking_error: {
                en: 'Dear customer, for your search request outbound or return flights are already fully booked.<br /><br />Please start your search again.',
                de: 'Lieber Kunde, für Ihre Suchanfrage sind bereits Hin- oder Rückflüge ausgebucht.<br /><br />Bitte starten Sie Ihre Suche erneut.'
            },
            closemodal: {
                en: 'Close',
                de: 'Schliessen'
            },
            // >>> ---------------------------------------------------------
            // >>> --------------------------------------------------------- Airport Lists
            airportsOrigins: [],
            airportsDestinations: [],
            airportsReturntoother: [],

            // >>> --------------------------------------------------------- SearchForm Models
            depArprtCode: '', // model, new select Field
            desArprtCode: '', // model, new select Field
            depArprtCode_returntoother: '', // model, new select Field
            desArprtCode_returntoother: '', // model, new select Field

            // >>> --------------------------------------------------------- Flags
            departuresLoaded: false, // Flag: Dep Aiports loaded?
            destinationsLoaded: false, // Flag: Des Aiports loaded?
            returntootherLoaded: false, // Flag: Return to other Aiports loaded?

            outwardonly: false, // Flag/Mode: ReturnFlight too?
            returntoother: false, // Flag/Mode: ReturnFlight to other destination?

            // >>> ---------------------------------------------------------
            today: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'days').format('DD.MM.YYYY'),
            tommorow: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(2, 'days').format('DD.MM.YYYY'),
            listOfPaxes: { 0: '0', 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8', 9: '9' }
            // noADT: 1,
            // noCHD: '0',
            // noINF: '0'
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingUsersSearchData', 'getBookingFlightSearchResults', 'getBookingDepArprtCode'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc: Do '/origines' Call.
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> created');
        this.call_listAirportsOrigines();
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc: Initialize Select Fields.
    * Note:
    *
    */
    mounted: function mounted() {

        var me = this;

        me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> mounted');
        this.$refs.noADT.value = 1; // @startup
        me.$selectInits(this.modulo, this.getCurrentLocale);
    }, // eo function mounted()


    /***********************************************************************
    * Lifecyclehook::updated
    *
    * Desc:
    * Note:
    *
    */
    updated: function updated() {

        var me = this;

        me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> updated');
        me.$selectInits(this.modulo, this.getCurrentLocale);
    }, // eo function updated()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_FlagSharedShowFlightSearchResults', // Control Flag
    'actn_FlagServicesShowBookingnoSearchResults', // Control Flag
    'actn_setBookingAirports', // Part 1
    'actn_setBookingUsersSearchData', // Part 2
    'actn_setBookingFlightSearchResults', // set: SearchResults
    'actn_FlagBookingOutwardFlightSelected', // set: 'Outward Flight selected
    'actn_FlagBookingReturnFlightSelected', // set: 'Return Flight selected
    'actn_setBookingFlightIdSelectedOutward', // set: 'Out Selected Flight Id'
    'actn_setBookingFlightIdSelectedReturn', // set: 'Ret Selected Flight Id'
    'actn_set_areWeInServicesBookingNoMode', // set:
    'actn_setBookingSrvcsSeatExistOnOut', 'actn_setBookingSrvcsSeatExistOnRet']), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: SearchForm gets submitted.
        * Note:
        * Note:
        *
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                depAfter = '',
                myDepPickerDate = void 0,
                myRetPickerDate = void 0,
                theActualTime = void 0,
                isToday = void 0,
                isTodayRet = void 0,
                date_to = void 0,
                date_from = void 0,
                requestParamObject = {};

            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onSubmit');
            // >>> 0. Empty Airports 1 ------------------------------------- // Mode: '!returntoother'
            if (this.returntoother === false) {
                if (this.depArprtCode === null || this.desArprtCode === null || this.depArprtCode === '' || this.desArprtCode === '') {
                    return;
                }
            }

            // >>> 0a. Empty Airports 2 ------------------------------------ // Mode: 'returntoother'
            if (this.returntoother === true) {
                if (this.depArprtCode === null || this.desArprtCode === null || this.desArprtCode_returntoother === '') {
                    return;
                }
            }

            // >>> 0b. To many Pax -----------------------------------------
            if (+this.$refs.noADT.value + +this.$refs.noCHD.value + +this.$refs.noINF.value > 10) {
                me.$toasted.global.sdr_app_error({
                    message: this.tomanypeople[this.getCurrentLocale]
                });
                return;
            }

            // >>> ---------------------------------------------------------
            me.actn_setBookingSrvcsSeatExistOnOut(false);
            me.actn_setBookingSrvcsSeatExistOnRet(false);

            // >>> 1. Check for Today&depAfter-Time ------------------------
            date_from = submitEvent.target.elements.date_from.value.split('.');
            myDepPickerDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DD');

            theActualTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HH:mm:ss');
            isToday = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(myDepPickerDate)).isSame(__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'));
            if (isToday) {
                depAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT') + theActualTime;
            }
            if (!isToday) {
                depAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT00:00:ss+0000');
            }

            // >>> 2. Builds Object ----------------------------------------
            requestParamObject = {
                depArprtCode: this.depArprtCode.i, // submitEvent.target.elements.depArprtCode.value,
                desArprtCode: this.desArprtCode.i, // submitEvent.target.elements.desArprtCode.value,
                noADT: this.$refs.noADT.value, // this.noADT,
                noCHD: this.$refs.noCHD.value, // this.noCHD,
                noINF: this.$refs.noINF.value, // this.noINF,
                ojArprtCode: '', // not clear
                ojType: '', // not clear
                depAfter: depAfter,
                rTrip: false,
                limit: 5
            };

            // >>> 3. Oneway || Roundtrip ? --------------------------------
            if (this.outwardonly === false) {
                date_to = submitEvent.target.elements.date_to.value.split('.');

                myRetPickerDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DD');
                isTodayRet = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(myRetPickerDate)).isSame(__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'));

                if (isTodayRet) {
                    requestParamObject.retAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DDT23:59:59');
                }
                if (!isTodayRet) {
                    requestParamObject.retAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DDTHH:mm:ss+0000');
                }
                requestParamObject.rTrip = true;
            }

            // >>> 3. Returntoother ? --------------------------------------
            if (this.returntoother === true) {
                requestParamObject.ojType = 'LEFT';
                requestParamObject.ojArprtCode = this.desArprtCode_returntoother.i;
            }

            // >>> 4. Go Go Go ---------------------------------------------
            if (requestParamObject.depArprtCode !== '' && requestParamObject.desArprtCode !== '') {
                me.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
                me.actn_FlagServicesShowBookingnoSearchResults(false); // Hide 'Section'

                this.actn_setBookingAirports({ // remember in state
                    depArprtCode: requestParamObject.depArprtCode,
                    depArprtName: this.depArprtCode.l,
                    desArprtCode: requestParamObject.desArprtCode,
                    desArprtName: this.desArprtCode.l,
                    depArprtCode_returntoother: this.returntoother === true ? requestParamObject.desArprtCode : null,
                    depArprtName_returntoother: this.returntoother === true ? this.desArprtCode.l : null,
                    desArprtCode_returntoother: this.returntoother === true ? requestParamObject.ojArprtCode : null,
                    desArprtName_returntoother: this.returntoother === true ? this.desArprtCode_returntoother.l : null
                });
                this.actn_setBookingUsersSearchData(requestParamObject); // remember in state

                this.actn_set_areWeInServicesBookingNoMode(false); // remember in state, set flag


                this.call_listFlights(requestParamObject); // call
            }
        }, // eo function onSubmit()


        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /******************************************************************* Shared: 'Booking', 'Services'
        * Call::'/booking/origines'
        * Call::'/registration/destinations/ZRH'
        *
        * Desc: Getting Airports - Origines ('listAirports').
        * Note: Via Endpoint '/booking' or '/registration'.
        *
        */
        call_listAirportsOrigines: function call_listAirportsOrigines() {

            var me = this,
                hdrs = '',
                url = '';

            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsOrigines');
            // >>> Decide Modulo -------------------------------------------
            if (this.modulo === 'booking') {
                url = '/booking/origines/';
            }
            if (this.modulo === 'services') {
                url = '/registration/origines';
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.airportsOrigins = response.data.originesRS.dep;
                        me.airportsOrigins.sort(function (a, b) {
                            return a.l > b.l ? 1 : b.l > a.l ? -1 : 0;
                        });
                        me.departuresLoaded = true;
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo funtion call_listAirportsOrigines()


        /******************************************************************* Shared: 'Booking', 'Services'
        * Call::'/booking/destinations/ZRH'
        * Call::'/registration/destinations/ZRH'
        *
        * Desc: Getting Airports - Destinations ('listAirports').
        * Note: Via Endpoint '/booking' or '/registration'.
        *
        */
        call_listAirportsDestinations: function call_listAirportsDestinations(event) {

            var me = this,
                hdrs = '',
                url = '';

            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsDestinations');
            // >>> Resets --------------------------------------------------
            this.desArprtCode = ''; // reset model & co
            this.depArprtCode_returntoother = '';
            this.desArprtCode_returntoother = '';
            this.airportsReturntoother = [];
            this.returntootherLoaded = false;

            this.onChange_FlightsSearchForm(); // reset


            // >>> Decide Modulo -------------------------------------------
            if (this.modulo === 'booking') {
                url = '/booking/destinations/';
            }
            if (this.modulo === 'services') {
                url = '/registration/destinations/';
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url + event.i).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.airportsDestinations = response.data.destinationsRS.des;
                        me.airportsDestinations.sort(function (a, b) {
                            return a.l > b.l ? 1 : b.l > a.l ? -1 : 0;
                        });
                        me.destinationsLoaded = true;
                        break;
                    default:
                        // 'ERROR'
                        // me.$toc('I am in Header Error');
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo funtion call_listAirportsDestinations()


        /******************************************************************* Shared: 'Booking'
        * Call::'/booking/destinations/ZRH'
        *
        * Desc: Getting Airports - 'Return to other' ('listAirports').
        * Note:
        *
        */
        call_listAirportsReturnToOther: function call_listAirportsReturnToOther(event) {

            var me = this,
                hdrs = '',
                url = '';

            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsReturnToOther');
            if (this.returntoother === false) {
                // Guard
                return;
            };

            this.depArprtCode_returntoother = this.desArprtCode; // set
            this.desArprtCode_returntoother = ''; // reset model (return to other)


            // >>> Decide Modulo -------------------------------------------
            if (this.modulo === 'booking') {
                url = '/booking/destinations/';
            }
            if (this.modulo === 'services') {
                url = '/registration/destinations/';
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url + this.desArprtCode.i).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'

                        me.airportsReturntoother = response.data.destinationsRS.des;
                        me.airportsReturntoother.sort(function (a, b) {
                            return a.l > b.l ? 1 : b.l > a.l ? -1 : 0;
                        });
                        me.returntootherLoaded = true;
                        break;
                    default:
                        // 'ERROR'
                        // me.$toc('I am in Header Error');
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo funtion call_listAirportsReturnToOther()


        /******************************************************************* Shared: 'Booking', 'Services'
        * Call::'/booking/listflights'
        * Call::'/registration/flights'
        *
        * Desc: Getting Flights ('listflights').
        * Note: Via Endpoint '/booking' or '/registration'.
        *
        */
        call_listFlights: function call_listFlights(params) {

            var me = this,
                hdrs = '',
                options = {},
                url = '';

            me.$toc('>>> booking/flightsearch/FlighSearchTab.vue >>> call_listFlights');
            this.onChange_FlightsSearchForm(); // reset
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Decide Modulo -------------------------------------------
            if (this.modulo === 'booking') {
                url = '/booking/listflights/';
            }
            if (this.modulo === 'services') {
                url = '/registration/flights/';
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, params).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.actn_setBookingFlightSearchResults(response.data.listFlightsRS.flts);
                        me.actn_FlagSharedShowFlightSearchResults(true); // Show 'Section'


                        setTimeout(function () {
                            me.check_NoReturnFlightsOnRoundtrip();
                            me.$scrollTo('#contentElement', 200, options);
                        }, 300);
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo funtion call_listFlights()


        /******************************************************************* 'Listeners'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onChange_Radio_checkIfSomethingAlreadyChosen()
        *
        * Desc:
        * Note:
        *
        */
        onChange_Radio_checkIfSomethingAlreadyChosen: function onChange_Radio_checkIfSomethingAlreadyChosen() {

            var me = this;

            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onChange_Radio_checkIfSomethingAlreadyChosen');
            if (this.returntoother === true && this.destinationsLoaded === true && this.desArprtCode !== '') {
                this.call_listAirportsReturnToOther();
            }

            if (this.returntoother === false) {
                this.depArprtCode_returntoother = ''; // reset everything
                this.desArprtCode_returntoother = '';
                this.airportsReturntoother = [];
                this.returntootherLoaded = false;
            }
        }, // eo function onChange_Radio_checkIfSomethingAlreadyChosen()


        /*******************************************************************
        * onChange_FlightsSearchForm()
        *
        * Desc:
        * Note: Kind of Reset here.
        *
        */
        onChange_FlightsSearchForm: function onChange_FlightsSearchForm() {

            var me = this;

            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onChange_FlightsSearchForm');
            me.actn_setBookingFlightSearchResults({});
            me.actn_FlagSharedShowFlightSearchResults(false); // set: 'Hide Section'
            me.actn_FlagBookingOutwardFlightSelected(false); // set: 'No Outward selected'
            me.actn_FlagBookingReturnFlightSelected(false); // set: 'No Return selected'
            me.actn_setBookingFlightIdSelectedOutward(null); // set: selected flight id out -> null
            me.actn_setBookingFlightIdSelectedReturn(null); // set: selected flight id ret -> null

            __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$emit('needtorerender');
        }, // eo function onChange_FlightsSearchForm()


        /*******************************************************************
        * check_NoReturnFlightsOnRoundtrip()
        *
        * Desc: Check if Roundtrip has no Ret Flights. Show Message.
        * Note:
        *
        */
        check_NoReturnFlightsOnRoundtrip: function check_NoReturnFlightsOnRoundtrip() {

            var me = this;

            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> check_NoReturnFlightsOnRoundtrip');
            if (this.getBookingUsersSearchData.rTrip === true && (this.filterOutwardOnly(this.getBookingFlightSearchResults).length === 0 || this.filterReturnOnly(this.getBookingFlightSearchResults).length === 0)) {
                // me.$toasted.global.sdr_app_error({
                //     message : me.noretflightonroundtrip[me.getCurrentLocale]
                // });
                me.$modal.show('booking-error-modal');
            }
        }, // eo function check_NoReturnFlightsOnRoundtrip()


        /*******************************************************************
        * filterOutwardOnly()
        *
        * Desc:
        *
        * @param {Object} flights (All Search Results Object)
        * @return {string}
        */
        filterOutwardOnly: function filterOutwardOnly(flights) {

            var me = this;

            return flights.filter(function (flight) {
                return flight.depArprt.i === me.getBookingDepArprtCode;
            });
        }, // eof filterOutwardOnly()


        /*******************************************************************
        * filterReturnOnly()
        *
        * Desc:
        *
        * @param {Object} flights (All Search Results Object)
        * @return {string}
        */
        filterReturnOnly: function filterReturnOnly(flights) {

            var me = this;

            // me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> filterReturnOnly');
            return flights.filter(function (flight) {
                return flight.depArprt.i !== me.getBookingDepArprtCode;
            });
        }, // eof filterReturnOnly()


        /*******************************************************************
        * onClick_CloseModal()
        *
        * Desc:
        * Note: Method Name is misleading. Only for reasons of equality.
        *
        */
        onClick_CloseModal: function onClick_CloseModal() {

            var me = this;

            me.$modal.hide('booking-error-modal');
        } // eo function onClick_CloseModal()

    }) // eof methods()
    /* <<< ****************************************************************/
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightSearchResults_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551dc5b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightSearchResults_vue__ = __webpack_require__(293);
function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-551dc5b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightSearchResults_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_551dc5b0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightSearchResults_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_fsr_Flight_vue__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_flightsearch_ModifySearchBox_vue__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_cart_Cart_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-shared-fsr-flight': __WEBPACK_IMPORTED_MODULE_1__components_fsr_Flight_vue__["a" /* default */], // fsr=>flight search results
        'sdr-modifysearch-box': __WEBPACK_IMPORTED_MODULE_2__booking_flightsearch_ModifySearchBox_vue__["a" /* default */],
        'sdr-shared-cart': __WEBPACK_IMPORTED_MODULE_3__shared_cart_Cart_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            // >>> ---------------------------------------------------------
            isActive: 'outwardsearchresults',
            // >>> ---------------------------------------------------------
            callCounter: 0,
            // >>> ---------------------------------------------------------
            pleaseselectflightheadline: {
                en: 'Step 1: Please select your Flight(s).',
                de: 'Schritt 1: Bitte wählen Sie Ihre Flug/Flüge aus.'
            },
            pleaseselectflightservicesheadline: {
                en: 'Step 1: Please select your already booked flight(s).',
                de: 'Schritt 1: Bitte wählen Sie Ihre bereits gebuchten Flug/Flüge aus.'
            },
            out: {
                en: 'SOLD OUT',
                de: 'AUSV.'
            },
            outwardflight: {
                en: 'Outward Flight',
                de: 'Hinflug'
            },
            returnflight: {
                en: 'Return Flight',
                de: 'Rückflug'
            },
            departureflightlist: {
                en: 'Departure Flight List',
                de: 'Hinflüge'
            },
            returnflightlist: {
                en: 'Return Flight List',
                de: 'Rückflüge'
            },
            totaltime: {
                en: 'total time',
                de: 'Dauer'
            },
            takeoff: {
                en: 'Take off',
                de: 'Abflug'
            },
            landing: {
                en: 'Landing',
                de: 'Ankunft'
            },
            to: {
                en: 'to',
                de: 'nach'
            },
            hourstxt: {
                en: 'HOURS',
                de: 'STUNDEN'
            },
            minutestxt: {
                en: 'MINUTES',
                de: 'MINUTEN'
            },
            selectflight: {
                en: 'SELECT FLIGHT',
                de: 'FLUG WÄHLEN'
            },
            selectbookedflight: {
                en: 'YES, MY FLIGHT',
                de: 'JA, MEIN FLUG'
            },
            taxesandfees: {
                en: 'Taxes and Fees',
                de: 'Steuern und Gebühren'
            },
            airfare: {
                en: 'Airfare',
                de: 'Flugpreis'
            },
            airporttaxes: {
                en: 'Airport taxes',
                de: 'Flughafengebühren'
            },
            aviationtax: {
                en: 'Aviation tax',
                de: 'Luftverkehrssteuer'
            },
            kerosenesurcharge: {
                en: 'Kerosene surcharge',
                de: 'Kerosinzuschlag'
            },
            securitycharges: {
                en: 'Security charges',
                de: 'Sicherheitsgebühren'
            },
            servicecharges: {
                en: 'Service charges',
                de: 'Servicegebühren'
            },
            resultsshown: {
                en: 'flights (out/ret) found',
                de: 'Flüge (Hin/Rück)'
            },
            avgpers: {
                en: 'AVG/PERSON',
                de: 'PRO PERSON'
            },
            departuredate: {
                en: 'Date Departure',
                de: 'Abflugdatum'
            },
            returndate: {
                en: 'Date Return',
                de: 'Rückflugdatum'
            },
            proceed: {
                en: 'PROCEED TO PASSENGER DATA',
                de: 'WEITER ZU PASSAGIERDATEN'
            },
            modifysearch: {
                en: 'Modify Search',
                de: 'Suche verändern'
            },
            seetaxes: {
                en: 'See Taxes & Fees',
                de: 'Steuern & Gebühren ansehen'
            },
            isthisyourflight: {
                en: 'Your Flight?',
                de: 'Ihr Flug?'
            },
            thisismyflight: {
                en: 'Yes, my Flight',
                de: 'Ja, mein Flug'
            },
            thisis: {
                en: 'Is this',
                de: 'Ist das'
            },
            noresultsout: {
                en: 'Attention: No more outward flights found!',
                de: 'Achtung: Keine Hinflüge mehr gefunden!'
            },
            noresultsret: {
                en: 'Attention: No more return flights found!',
                de: 'Achtung: Keine Rückflüge mehr gefunden!'
            },
            soldout: {
                en: 'Selected!',
                de: 'Gewählt!'
            },
            soldoutsrvcs: {
                en: 'Your Flight!',
                de: 'Ihr Flug!'
            },

            errornoseatsrvcsonoutward: {
                en: 'Attention: No more seats on your outbound flight!',
                de: 'Achtung: Keine Sitze mehr auf Ihren Hinflug!'
            },
            errornoseatsrvcsonreturn: {
                en: 'Attention: No more seats on your return flight!',
                de: 'Achtung: Keine Sitze mehr auf Ihren Rückflug!'
            },
            // >>> ---------------------------------------------------------
            amenities_services: {
                en: 'Additional services can be reserved on this flight: Seats',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Sitzplätze'
            },
            amenities_meal: {
                en: 'Additional services can be reserved on this flight.: Meals',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Essen'
            },
            amenities_lugagge: {
                en: 'Additional services can be reserved on this flight.: Additional Luggage',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Zusätzliches Gepäck'
            },
            // >>> ---------------------------------------------------------
            modal_headline_rebooking_error: {
                en: 'Attention: Flights same day',
                de: 'Achtung: Flüge am gleichen Tag'
            },
            modal_content_rebooking_error: {
                en: 'Dear customer, you have selected outbound and return flights on the same day. Are you sure?',
                de: 'Lieber Kunde, sie haben Hin- und Rückflug am selben Tag ausgewählt. Sind Sie sich sicher?'
            },
            closemodal: {
                en: 'Close',
                de: 'Schliessen'
            },
            // >>> ---------------------------------------------------------
            // currentLocale: 'de',
            gotSeatOnOut: false, // Flag
            gotSeatOnRet: false, // Flag
            bookableServicesCallOutDidRun: false, // Flag
            bookableServicesCallRetDidRun: false // Flag
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedShowFlightSearchResults', 'getBookingFlightSearchResults', 'getBookingDepArprtCode', // Users Search Data, Part 1
    'getBookingDesArprtCode', 'getBookingDepArprtName', 'getBookingDesArprtName', 'getBookingUsersSearchData', // Users Search Data, Part 2
    'getFlagBookingOutwardFlightSelected', // CONTROL FLAG
    'getFlagBookingReturnFlightSelected', // CONTROL FLAG
    'getBookingFlightIdSelectedOutward', // get: selected Flight id out
    'getBookingFlightIdSelectedReturn', // get: selected Flight id ret
    'getBookingPriceIdSelectedOutward', // get: selected Price id out
    'getBookingPriceIdSelectedReturn', // get: selected Price id ret
    'getBookingSrvcsSeatExistOnOut', 'getBookingSrvcsSeatExistOnRet', 'getBookingCart'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note: Catch Event 'readytopushpassengersnotbookingno' ('All Calls done ...').
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> created');
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$on('readytopushpassengersnotbookingno', this.onEmit_ReadyToPushPassengers);
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$on('needtorerender', this.onEmit_NeedToRerender);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> created');
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$off('readytopushpassengersnotbookingno', this.onEmit_ReadyToPushPassengers);
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$off('needtorerender', this.onEmit_NeedToRerender);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['actn_setBookingUpdateCart', 'actn_setBookingLockfaresResults', // set: 'Lockfares Results'
    'actn_bookingSeatReservationLockingCodeResults', // set: 'Lockingcodes Results'
    'actn_bookingSeatplanResults', // set: 'Seatplan Results'
    'actn_setBookingSrvcsSeatExistOnOut', // set: 'Srvcs SEAT exist on OUT'
    'actn_setBookingSrvcsSeatExistOnRet', // set: 'Srvcs SEAT exist on RET'
    'actn_setServicesBookableServicesResults', // set: 'Bookable Services Results' (srvcs)
    'actn_call_registrationBookingoptions', // Call: get 'bookingoptions'
    'actn_call_bookableServices', // Call: get 'bookable services'
    'actn_Flag_bookableServicesCallRetDidRun', 'actn_call_getSeatReservationLockingCode'] // call:
    ), {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * call_nextCallBookingOrServices()
        *
        * Desc: Decides which Calls are next?! 'Booking' or 'Services'.
        * Note: PreCheck, 'Same day?' #804
        *
        * @param {String} modulo ('booking', 'services')
        */
        call_nextCallBookingOrServices: function call_nextCallBookingOrServices(modulo) {

            var me = this;

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_nextCallBookingOrServices');
            // >>> precheck -----------------------------------
            if (this.getBookingUsersSearchData.rTrip === true && this.getBookingCart[0].outward.depDT.substr(0, 10) === this.getBookingCart[0].return.depDT.substr(0, 10)) {

                me.$modal.show('booking-error-modal-sameday');
            } else {

                if (modulo === 'booking') {
                    this.call_showFares(); // 1st Call in a Row ..
                }

                if (modulo === 'services') {
                    this.call_registrationBookingoptions(); // Call 1: 'get bookingoptions'
                    this.call_bookableServices('outward'); // Call 2: 'get bookableservices' - outward

                    if (this.getBookingFlightIdSelectedReturn !== null) {
                        this.call_bookableServices('return'); // Call 2: 'get bookableservices' - return
                    } else {
                        // this.bookableServicesCallRetDidRun = true; // no RET Flight, we pretend call for RET  did run
                        this.actn_Flag_bookableServicesCallRetDidRun(true); // we fake it
                    }
                }
            }
        }, // eof call_nextCallBookingOrServices()


        /*******************************************************************
        * onClick_CloseModal()
        *
        * Desc: Decides which Calls are next?! 'Booking' or 'Services'.
        * Note: Close and Go on ...
        *
        */
        onClick_CloseModal: function onClick_CloseModal(modulo) {

            var me = this;

            me.$modal.hide('booking-error-modal-sameday');
            if (modulo === 'booking') {
                this.call_showFares(); // 1st Call in a Row ..
            }

            if (modulo === 'services') {
                this.call_registrationBookingoptions(); // Call 1: 'get bookingoptions'
                this.call_bookableServices('outward'); // Call 2: 'get bookableservices' - outward

                if (this.getBookingFlightIdSelectedReturn !== null) {
                    this.call_bookableServices('return'); // Call 2: 'get bookableservices' - return
                } else {
                    // this.bookableServicesCallRetDidRun = true; // no RET Flight, we pretend call for RET  did run
                    this.actn_Flag_bookableServicesCallRetDidRun(true); // we fake it
                }
            }
        }, // eo function onClick_CloseModal()


        /******************************************************************* 'ServiceCalls - Booking'
        * ServiceCalls: 'Booking'
        *******************************************************************/
        /*******************************************************************
        * Call::'/booking/showfares'
        *
        * Desc:
        * Note: I only take 'fareskeycode' for Call 'lockFares' here.
        * Note: Call: Module::'Booking'.
        *
        */
        call_showFares: function call_showFares() {

            var me = this,
                hdrs = '';

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_showFares');
            // >>> 1. Builds Object ----------------------------------------
            var requestParamObject = {
                idOutwardprice: this.getBookingPriceIdSelectedOutward,
                idReturnprice: this.getBookingUsersSearchData.rTrip === true ? this.getBookingPriceIdSelectedReturn : null,
                noAdultPax: this.getBookingUsersSearchData.noADT,
                noChildPax: this.getBookingUsersSearchData.noCHD,
                noInfants: this.getBookingUsersSearchData.noINF
            };

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put('/booking/showfares/', requestParamObject).then(function (response) {
                // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.call_lockFares(response.data.faresKey); // Call 'lockfares' immediately thereafter
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eof call_showFares()


        /*******************************************************************
        * Call::'/booking/lockfares/{lockCode}', (GET)
        * Call::'/booking/lockfares/{lockCode}/includeservices', (GET)
        *
        * Desc:
        * Note: Call Seats right after?
        * Note: Call: Module::'Booking'.
        *
        * @param {Object} faresKey (The 'showFares' result)
        * @return
        */
        call_lockFares: function call_lockFares(faresKey) {

            var me = this,
                hdrs = '',
                options = {};

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_lockFares');
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Send Ajax Request ---------------------------------------
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get('/booking/lockfares/' + faresKey + '/includeservices').then(function (response) {
                // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.actn_setBookingLockfaresResults(response.data); // rem res

                        // >>> Got 'Seat' Service?
                        if (response.data.outwardFlight.offersSeatService === true) {
                            me.actn_setBookingSrvcsSeatExistOnOut(true); // rem
                        }

                        if (response.data.inboundFlight !== null) {
                            if (response.data.inboundFlight.offersSeatService === true) {
                                me.actn_setBookingSrvcsSeatExistOnRet(true); // rem
                            }
                        }

                        if (response.data.outwardFlight.offersSeatService === true || response.data.inboundFlight !== null && response.data.inboundFlight.offersSeatService === true) {
                            me.prepare_call_getSeatReservationLockingCode();
                        } else {
                            me.$vp_um();

                            me.$router.push({ path: '/passengers/' + me.modulo });

                            setTimeout(function () {
                                me.$scrollTo('#scrollPointTop', 200, options);
                            }, 300);
                        }
                        break;
                    default:
                        // 'ERROR'
                        // me.$toc('I am in Header Error');
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eof call_lockFares()


        /******************************************************************* 'ServiceCalls - Services'
        * ServiceCalls: 'Services'
        *******************************************************************/
        /*******************************************************************
        * Call::'/registration/bookingoptions'
        *
        * Desc:
        * Note: New: Axios Call is here managed in VUEX.
        *
        */
        call_registrationBookingoptions: function call_registrationBookingoptions() {

            var me = this,
                outwardId = this.getBookingFlightIdSelectedOutward,
                returnId = this.getBookingFlightIdSelectedReturn,
                flightIds = [],
                hdrs = '';

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_registrationBookingoptions');
            // >>> 1. Builds Object ----------------------------------------
            if (outwardId !== null && outwardId !== undefined && outwardId !== '') {
                flightIds.push(String(outwardId));
            }
            if (returnId !== null && returnId !== undefined && returnId !== '') {
                flightIds.push(String(returnId));
            }

            var requestParamObject = {
                "bookingOptionsRQ": {
                    "idFlights": flightIds
                }
            };

            this.actn_call_registrationBookingoptions(requestParamObject); // Call
        }, // eo function call_registrationBookingoptions()


        /*******************************************************************
        * Call::'/service/bookableservices/{idFlight}/{tktClass}'
        *
        * Desc:
        * Note: Call Seats right after?
        * Note: Call: Module::'Services'.
        * Note: New: Axios Call is here managed in VUEX.
        *
        * @param {string} type ('outward','return')
        */
        call_bookableServices: function call_bookableServices(type) {

            var me = this,
                outwardId = this.getBookingFlightIdSelectedOutward,
                returnId = this.getBookingFlightIdSelectedReturn,
                id = '';

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> call_bookableServices');
            // >>> 1. Builds Object ----------------------------------------
            if (type === 'outward') {
                id = outwardId;
            }
            if (type === 'return') {
                id = returnId;
            }

            this.actn_call_bookableServices({ id: id, type: type }); // Call
        }, // eo function call_bookableServices()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * flightSelected()
        *
        * Desc: Flight selected! Call ACTION(s)!
        * Note: Param 'flight' has ..  'flight', 'type', 'modulo'.
        * Note: Watches 'modulo'!
        *
        * @param {Object} flight (selected Flight)
        * @return {string}
        */
        flightSelected: function flightSelected(flight) {

            var me = this;

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> flightSelected');
            this.actn_setBookingUpdateCart(flight);
        }, // eof flightSelected()


        /******************************************************************* 'Listeners - eventBus'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onEmit_ReadyToPushPassengers()
        *
        * Desc: Handle 'Push Passengers' after all pre Calls are done.
        * Note:
        *
        */
        onEmit_ReadyToPushPassengers: function onEmit_ReadyToPushPassengers() {

            var me = this,
                options = {};

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> onEmit_ReadyToPushPassengers');
            // >>> Scroll Options ------------------------------------------
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            me.$router.push({ path: '/passengers/' + me.modulo });
            setTimeout(function () {
                me.$scrollTo('#scrollPointTop', 200, options);
            }, 300);
        }, // eo function onEmit_ReadyToPushPassengers()


        /*******************************************************************
        * onEmit_NeedToRerender()
        *
        * Desc: Resets Flightsearch Result Tabs.
        * Note: Sets it back to first (outward) Tab.
        * Note: Fired in: 'FlighSearchTab':'onChange_FlightsSearchForm'
        *
        */
        onEmit_NeedToRerender: function onEmit_NeedToRerender() {

            var me = this;

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> onEmit_NeedToRerender');
            this.isActive = 'outwardsearchresults'; // reset
        }, // eo function onEmit_ReadyToPushPassengers()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * prepare_call_getSeatReservationLockingCode()
        *
        * Desc: (Prepare) Get Locking Code ('OUT', 'RET')
        * Note:
        *
        * @param
        * @return
        */
        prepare_call_getSeatReservationLockingCode: function prepare_call_getSeatReservationLockingCode() {

            var me = this,
                owf_id = this.getBookingFlightIdSelectedOutward,
                rtf_id = this.getBookingFlightIdSelectedReturn,
                aggrsrvc_exist_out = this.getBookingSrvcsSeatExistOnOut,
                aggrsrvc_exist_ret = this.getBookingSrvcsSeatExistOnRet;

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> prepare_call_getSeatReservationLockingCode');
            if (owf_id !== '' && aggrsrvc_exist_out === true) {
                // Got Outward Flight? .. Get LockingCode ..
                // this.call_getSeatReservationLockingCode('out', owf_id);
                this.actn_call_getSeatReservationLockingCode({ type: 'out', id: owf_id });
            }
            if (owf_id !== null && aggrsrvc_exist_out === false) {
                me.$toasted.global.sdr_app_error({
                    message: me.errornoseatsrvcsonoutward[me.getCurrentLocale]
                });
            }

            if (rtf_id !== '' && aggrsrvc_exist_ret === true) {
                // Got Return Flight? .. Get LockingCode ..
                // this.call_getSeatReservationLockingCode('ret', rtf_id);
                this.actn_call_getSeatReservationLockingCode({ type: 'ret', id: rtf_id });
            }
            if (rtf_id !== null && aggrsrvc_exist_ret === false) {
                me.$toasted.global.sdr_app_error({
                    message: me.errornoseatsrvcsonreturn[me.getCurrentLocale]
                });
            }
        }, // eof prepare_call_getSeatReservationLockingCode()


        /*******************************************************************
        * whichFlightDirection()
        *
        * Desc:
        *
        * @param {string} apt (Airports)
        * @return {string}
        */
        whichFlightDirection: function whichFlightDirection(apt) {

            var me = this;

            me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> whichFlightDirection');
            if (apt === this.getBookingDepArprtCode) {
                return this.outwardflight[this.getCurrentLocale];
            } else {
                return this.returnflight[this.getCurrentLocale];
            }
        }, // eof whichFlightDirection()


        /*******************************************************************
        * filterOutwardOnly()
        *
        * Desc:
        *
        * @param {Object} flights (All Search Results Object)
        * @return {string}
        */
        filterOutwardOnly: function filterOutwardOnly(flights) {

            var me = this;

            // me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> filterOutwardOnly');
            return flights.filter(function (flight) {
                return flight.depArprt.i === me.getBookingDepArprtCode;
            });
        }, // eof filterOutwardOnly()


        /*******************************************************************
        * filterReturnOnly()
        *
        * Desc:
        *
        * @param {Object} flights (All Search Results Object)
        * @return {string}
        */
        filterReturnOnly: function filterReturnOnly(flights) {

            var me = this;

            // me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> filterReturnOnly');
            return flights.filter(function (flight) {
                return flight.depArprt.i !== me.getBookingDepArprtCode;
            });
        } // eof filterReturnOnly()

    }) // eof methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['active_item', 'module'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            bc_firstitem: {
                en: 'Flightsearch',
                de: 'Flugsuche'
            },
            srvcs_firstitem: {
                en: 'Your Flight(s)',
                de: 'Ihr Flug/Flüge'
            },
            srvcsbookingno_firstitem: {
                en: 'Your Booking',
                de: 'Ihre Buchung'
            },
            bc_seconditem: {
                en: 'Passenger(s)',
                de: 'Passagier(e)'
            },
            bc_thirditem: {
                en: 'Payment',
                de: 'Zahlung'
            },
            bc_fourthitem: {
                en: 'Overview',
                de: 'Übersicht'
            },
            bc_fifthitem: {
                en: 'Confirmation',
                de: 'Bestätigung'
            },
            step: {
                en: 'Step',
                de: 'Schritt'
            },
            // >>> ------------------------------------
            rebooking_firstitem: {
                en: 'Your Booking(s)',
                de: 'Ihre Buchung(en)'
            },
            rebooking_thirditem: {
                en: 'New Flight(s)',
                de: 'Neuer Flug/Flüge'
            },
            rebooking_fourthitem: {
                en: 'Payment',
                de: 'Zahlung'
            },
            rebooking_fifthitem: {
                en: 'Overview',
                de: 'Übersicht'
            },
            rebooking_sixthitem: {
                en: 'Confirmation',
                de: 'Bestätigung'
                // currentLocale: 'de',
            } };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_areWeInServicesBookingNoMode'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firstrow_FirstRowBooking_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firstrow_FirstRowServices_vue__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__secondrow_SecondRowBooking_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__secondrow_SecondRowServices_vue__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TaxesAndFees_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flight', 'flightdirection', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-shared-fsr-flight-firstrow-booking': __WEBPACK_IMPORTED_MODULE_0__firstrow_FirstRowBooking_vue__["a" /* default */], // fsr=>flight search results
        'sdr-shared-fsr-flight-firstrow-services': __WEBPACK_IMPORTED_MODULE_1__firstrow_FirstRowServices_vue__["a" /* default */],
        'sdr-shared-fsr-flight-secondrow-booking': __WEBPACK_IMPORTED_MODULE_2__secondrow_SecondRowBooking_vue__["a" /* default */],
        'sdr-shared-fsr-flight-secondrow-services': __WEBPACK_IMPORTED_MODULE_3__secondrow_SecondRowServices_vue__["a" /* default */],

        'sdr-shared-fsr-flight-taxesandfees': __WEBPACK_IMPORTED_MODULE_4__TaxesAndFees_vue__["a" /* default */]

    } // eo components
    /* <<< ****************************************************************/

});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flight', 'flightdirection', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            outwardflight: {
                en: 'Outward Flight',
                de: 'Hinflug'
            },
            returnflight: {
                en: 'Return Flight',
                de: 'Rückflug'
            },
            // ----------------------------------------
            out: {
                en: 'SOLD OUT',
                de: 'AUSV.'
            },
            // ----------------------------------------
            to: {
                en: 'to',
                de: 'nach'
            },
            // ----------------------------------------
            amenities_services: {
                en: 'Additional services can be reserved on this flight: Seats',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Sitzplätze'
            },
            amenities_meal: {
                en: 'Additional services can be reserved on this flight.: Meals',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Essen'
            },
            amenities_lugagge: {
                en: 'Additional services can be reserved on this flight.: Additional Luggage',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Zusätzliches Gepäck'
            },
            // ----------------------------------------
            seetaxes: {
                en: 'See Taxes & Fees',
                de: 'Steuern & Gebühren ansehen'
            },
            // ----------------------------------------
            avgpers: {
                en: 'AVG/PERSON',
                de: 'PRO PERSON'
            }
        };
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingFlightIdSelectedOutward', 'getBookingFlightIdSelectedReturn', 'getBookingDepArprtCode'])), // eo computed
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([]), {

        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * whichFlightDirection()
        *
        * Desc:
        *
        * @param {string} apt (Airports)
        * @return {string}
        */
        whichFlightDirection: function whichFlightDirection(apt) {

            var me = this;

            me.$toc('>>> shared/flightsearch/componenets/firstrow/FirstRowBooking.vue >>> whichFlightDirection');
            if (apt === this.getBookingDepArprtCode) {
                return this.outwardflight[this.getCurrentLocale];
            } else {
                return this.returnflight[this.getCurrentLocale];
            }
        } // eof whichFlightDirection()

    }) // eo methods
    /* <<< ****************************************************************/

});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flight', 'flightdirection', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            outwardflight: {
                en: 'Outward Flight',
                de: 'Hinflug'
            },
            returnflight: {
                en: 'Return Flight',
                de: 'Rückflug'
            },
            // ----------------------------------------
            soldoutsrvcs: {
                en: 'Your Flight!',
                de: 'Ihr Flug!'
            },
            out: {
                en: 'SOLD OUT',
                de: 'AUSV.'
            },
            // ----------------------------------------
            to: {
                en: 'to',
                de: 'nach'
            },
            // ----------------------------------------
            amenities_services: {
                en: 'Additional services can be reserved on this flight: Seats',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Sitzplätze'
            },
            amenities_meal: {
                en: 'Additional services can be reserved on this flight.: Meals',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Essen'
            },
            amenities_lugagge: {
                en: 'Additional services can be reserved on this flight.: Additional Luggage',
                de: 'Auf diesem Flug sind Zusatzleistungen reservierbar: Zusätzliches Gepäck'
            },
            // ----------------------------------------
            isthisyourflight: {
                en: 'Your Flight?',
                de: 'Ihr Flug?'
            },
            thisismyflight: {
                en: 'Yes, my Flight',
                de: 'Ja, mein Flug'
            },
            thisis: {
                en: 'Is this',
                de: 'Ist das'
            }
        };
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingFlightIdSelectedOutward', 'getBookingFlightIdSelectedReturn', 'getBookingDepArprtCode'])), // eo computed
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([]), {

        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * whichFlightDirection()
        *
        * Desc:
        *
        * @param {string} apt (Airports)
        * @return {string}
        */
        whichFlightDirection: function whichFlightDirection(apt) {

            var me = this;

            me.$toc('>>> shared/flightsearch/componenets/firstrow/FirstRowServices.vue >>> whichFlightDirection');
            if (apt === this.getBookingDepArprtCode) {
                return this.outwardflight[this.getCurrentLocale];
            } else {
                return this.returnflight[this.getCurrentLocale];
            }
        } // eof whichFlightDirection()

    }) // eo methods
    /* <<< ****************************************************************/

});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flight', 'flightdirection', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            uhr: {
                en: " o'clock",
                de: ' Uhr'
            },
            selectflight: {
                en: 'SELECT FLIGHT',
                de: 'FLUG WÄHLEN'
            },
            // ----------------------------------------
            out: {
                en: 'SOLD OUT',
                de: 'AUSV.'
            },
            // ----------------------------------------
            selectbookedflight: {
                en: 'MY NEW FLIGHT',
                de: 'MEIN NEUER FLUG'
            },
            // ----------------------------------------
            takeoff: {
                en: 'Take off',
                de: 'Abflug'
            },
            landing: {
                en: 'Landing',
                de: 'Ankunft'
            },
            totaltime: {
                en: 'total time',
                de: 'Dauer'
            },
            to: {
                en: 'to',
                de: 'nach'
            }
        };
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingFlightIdSelectedOutward', 'getBookingFlightIdSelectedReturn'])), // eo computed
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Filters */
    filters: {

        /*******************************************************************
        * durationFlight()
        *
        * Desc: Calculates "Travel Time".
        *
        * @param {int} a (duration in seconds)
        * @return {string}
        */
        durationFlight: function durationFlight(a) {

            var hours = Math.floor(a / 3600),
                minutes = Math.floor(a / 60) - hours * 60,
                hours_txt = 'S',
                // H
            minutes_txt = ' h'; // M


            if (minutes === 0) {
                return hours + ':00' + minutes_txt;
            } else if (minutes.toString().length === 1) {
                return hours + ':0' + minutes + '' + minutes_txt;
            } else {
                return hours + ':' + minutes + '' + minutes_txt;
            }
        } // eof durationFlight()

    }, // eof filters{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_setBookingUpdateCart']), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * flightSelected()
        *
        * Desc: Flight selected! Call ACTION(s)!
        * Note: Param 'flight' has: 'flight', 'type', 'modulo'.
        * Note: Watches 'modulo'!
        *
        * @param {Object} flight (selected Flight)
        * @return {string}
        */
        flightSelected: function flightSelected(flight) {

            var me = this;

            me.$toc('>>> shared/flightsearch/components/secondrow/SecondRowBooking.vue >>> flightSelected');
            this.actn_setBookingUpdateCart(flight);
        } // eof flightSelected()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flight', 'flightdirection', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            uhr: {
                en: " o'clock",
                de: ' Uhr'
            },
            // ----------------------------------------
            soldoutsrvcs: {
                en: 'Your Flight!',
                de: 'Ihr Flug!'
            },
            taxesandfees: {
                en: 'Taxes and Fees',
                de: 'Steuern und Gebühren'
            },
            out: {
                en: 'SOLD OUT',
                de: 'AUSV.'
            },
            // ----------------------------------------
            selectbookedflight: {
                en: 'MY FLIGHT',
                de: 'MEIN FLUG'
            },
            // ----------------------------------------
            takeoff: {
                en: 'Take off',
                de: 'Abflug'
            },
            landing: {
                en: 'Landing',
                de: 'Ankunft'
            },
            totaltime: {
                en: 'total time',
                de: 'Dauer'
            },
            to: {
                en: 'to',
                de: 'nach'
            }
        };
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingFlightIdSelectedOutward', 'getBookingFlightIdSelectedReturn'])), // eo computed
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Filters */
    filters: {

        /*******************************************************************
        * durationFlight()
        *
        * Desc: Calculates "Travel Time".
        *
        * @param {int} a (duration in seconds)
        * @return {string}
        */
        durationFlight: function durationFlight(a) {

            var hours = Math.floor(a / 3600),
                minutes = Math.floor(a / 60) - hours * 60,
                hours_txt = 'S',
                // H
            minutes_txt = ' h'; // M


            if (minutes === 0) {
                return hours + ':00' + minutes_txt;
            } else if (minutes.toString().length === 1) {
                return hours + ':0' + minutes + '' + minutes_txt;
            } else {
                return hours + ':' + minutes + '' + minutes_txt;
            }
        } // eof durationFlight()

    }, // eof filters{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_setBookingUpdateCart']), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * flightSelected()
        *
        * Desc: Flight selected! Call ACTION(s)!
        * Note: Param 'flight' has: 'flight', 'type', 'modulo'.
        * Note: Watches 'modulo'!
        *
        * @param {Object} flight (selected Flight)
        * @return {string}
        */
        flightSelected: function flightSelected(flight) {

            var me = this;

            me.$toc('>>> shared/flightsearch/components/secondrow/SecondRowServices.vue >>> flightSelected');
            this.actn_setBookingUpdateCart(flight);
        } // eof flightSelected()

    }) // eo methods
    /* <<< ****************************************************************/

});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flight', 'flightdirection', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            // ----------------------------------------
            taxesandfees: {
                en: 'Taxes and Fees',
                de: 'Steuern und Gebühren'
            },
            airfare: {
                en: 'Airfare',
                de: 'Flugpreis'
            },
            airporttaxes: {
                en: 'Airport taxes',
                de: 'Flughafengebühren'
            },
            aviationtax: {
                en: 'Aviation tax',
                de: 'Luftverkehrssteuer'
            },
            kerosenesurcharge: {
                en: 'Kerosene surcharge',
                de: 'Kerosinzuschlag'
            },
            securitycharges: {
                en: 'Security charges',
                de: 'Sicherheitsgebühren'
            },
            servicecharges: {
                en: 'Service charges',
                de: 'Servicegebühren'
            }
        };
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eo computed
    /* <<< ****************************************************************/

});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            modifysearch: {
                en: 'Modify Search',
                de: 'Suche verändern'
            },
            departuredate: {
                en: 'Pick a new Date Departure',
                de: 'Neues Abflugdatum'
            },
            pickdeparturedate: {
                en: 'Date Departure',
                de: 'Neues Abflugdatum'
            },
            returndate: {
                en: 'Pick a new Date Return',
                de: 'Neues Rückflugdatum'
            },
            pickreturndate: {
                en: 'Pick a new Date Return',
                de: 'Neues Rückflugdatum'
            },
            searchagain: {
                en: 'search again',
                de: 'Suche verändern'
            },
            // currentLocale: 'de',
            // >>> --------------------------
            date_from: null,
            date_to: null,
            options: {
                en: {
                    format: 'DD.MM.YYYY',
                    i18n: {
                        previousMonth: 'Previous Month',
                        nextMonth: 'Next Month',
                        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                        weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
                    }
                },
                de: {
                    format: 'DD.MM.YYYY',
                    i18n: {
                        previousMonth: 'Vorheriger Monat',
                        nextMonth: 'Nächster Monat',
                        months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                        weekdays: ['Sonntag', ' Montag', ' Dienstag', ' Mittwoch', ' Donnerstag', ' Freitag', ' Samstag'],
                        weekdaysShort: ['SO', 'MO', 'DI', 'MI', 'DO', 'FR', 'SA']
                    }
                }
                // format: 'DD.MM.YYYY',
                // minDate: moment().toDate(),
                // maxDate: moment().add(7, 'days').toDate()
            },
            // >>> --------------------------
            keyToReRender: 0
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingUsersSearchData'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::updated
    *
    * Desc:
    * Note:
    *
    */
    updated: function updated() {

        this.$nextTick(function () {
            if (this.keyToReRender !== 0) {
                // console.log('rerendered!!! ');
            }
        });
    }, // eof updated()

    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note:
    *
    */
    mounted: function mounted() {

        this.date_from = this.getBookingUsersSearchData.depAfter;
        this.date_to = this.getBookingUsersSearchData.retAfter;

        this.keyToReRender += 1;
    }, // eof mounted()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_FlagSharedShowFlightSearchResults', 'actn_setBookingFlightSearchResults'] // set: SearchResults
    ), {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/booking/listflights'
        *
        * Desc: Getting Flights ('listflights').
        * Note:
        *
        */
        call_listFlights: function call_listFlights(params) {

            var me = this,
                hdrs = '',
                options = {};

            me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> call_listFlights');
            // this.onChange_FlightsSearchForm(); // reset
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/booking/listflights/', params).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.actn_setBookingFlightSearchResults(response.data.listFlightsRS.flts);
                        me.actn_FlagSharedShowFlightSearchResults(true); // Show 'Section'
                        setTimeout(function () {
                            me.$scrollTo('#contentElement', 200, options);
                        }, 300);
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eof call_listFlights()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: ModifySearchBox Submit.
        * Note:
        *
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                depAfter = '',
                myDepPickerDate = void 0,
                theActualTime = void 0,
                isToday = void 0,
                date_from = void 0,
                date_to = void 0;

            me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> onSubmit');
            me.actn_FlagSharedShowFlightSearchResults(false); // Show 'Section'

            // >>> 1. Check for Today&depAfter-Time ------------------------
            date_from = submitEvent.target.elements.date_from.value.split('.');
            myDepPickerDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DD');

            theActualTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HH:mm:ss');
            isToday = __WEBPACK_IMPORTED_MODULE_2_moment___default()(String(myDepPickerDate)).isSame(__WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'));
            if (isToday) {
                depAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT') + theActualTime;
            }
            if (!isToday) {
                depAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT00:00:ss+0000');
            }

            // >>> 2. Builds Object ----------------------------------------
            var requestParamObject = this.getBookingUsersSearchData;
            requestParamObject.depAfter = depAfter;

            // >>> 3. Oneway || Roundtrip ? --------------------------------
            if (this.getBookingUsersSearchData.rTrip === true) {
                date_to = submitEvent.target.elements.date_to.value.split('.');
                requestParamObject.retAfter = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DDTHH:mm:ss+0000');
                requestParamObject.rTrip = true;
            }

            //this.actn_setBookingUsersSearchData(requestParamObject);  // remember in state
            this.call_listFlights(requestParamObject);
        },
        // eof onSubmit()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * forceRerender()
        *
        * Desc: Simply change the Components :key to force rerendering.
        * Note:
        *
        */
        forceRerender: function forceRerender() {

            var me = this;

            me.$toc('>>> booking/flightsearch/ModifySearchBox.vue >>> forceRerender');
            this.keyToReRender += 1;
        }
    }) // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            uhr: {
                en: " o'clock",
                de: ' Uhr'
            },
            taxesandfees: {
                en: 'Taxes and Fees',
                de: 'Steuern und Gebühren'
            },
            airfare: {
                en: 'Airfare',
                de: 'Flugpreis'
            },
            airporttaxes: {
                en: 'Airport taxes',
                de: 'Flughafengebühren'
            },
            aviationtax: {
                en: 'Aviation tax',
                de: 'Luftverkehrssteuer'
            },
            kerosenesurcharge: {
                en: 'Kerosene surcharge',
                de: 'Kerosinzuschlag'
            },
            securitycharges: {
                en: 'Security charges',
                de: 'Sicherheitsgebühren'
            },
            servicecharges: {
                en: 'Service charges',
                de: 'Servicegebühren'
            },
            takeoff: {
                en: 'Take off',
                de: 'Abflug'
            },
            landing: {
                en: 'Landing',
                de: 'Ankunft'
            },
            bookingdetails: {
                en: 'Booking Details',
                de: 'Ihre Buchung'
            },
            bookflightnow: {
                en: 'book flight now',
                de: 'Flug buchen'
            },
            seetaxes: {
                en: 'See Taxes & Fees',
                de: 'Steuern & Gebühren ansehen'
            },
            totaloutwardprice: {
                en: 'Total Outward',
                de: 'Gesamt Hinflug'
            },
            totalreturnprice: {
                en: 'Total Return',
                de: 'Gesamt Rückflug'
            },
            tincludedtaxes: {
                en: 'incl. Taxes, Fees & Surcharges',
                de: 'inkl. Steuern, Gebühren & Zuschlägen'
            },
            adult: {
                en: 'Adult',
                de: 'Erwachsener'
            },
            child: {
                en: 'Child',
                de: 'Kind'
            },
            infant: {
                en: 'Infant',
                de: 'Kleinkind'
            },
            flightprice: {
                en: 'Flightprice',
                de: 'Flugpreis'
            },
            flightpricesrvcs: {
                en: 'Flight already booked',
                de: 'Flug schon gebucht'
            },
            wannedelete: {
                en: 'Delete Service?',
                de: 'Service löschen?'
            },
            wannedeleteseat: {
                en: 'Delete Seat?',
                de: 'Sitz löschen?'
            },
            deletesrvcs: {
                en: 'Delete Service/Seat',
                de: 'Service/Sitz löschen'
            },
            alerttext: {
                en: 'Are you sure you want to delete the service/seat?',
                de: 'Wollen Sie den Service/Sitz wirklich löschen?'
            },
            alertno: {
                en: 'No',
                de: 'Nein'
            },
            alertyes: {
                en: 'Yes',
                de: 'Ja'
            },
            seat: {
                en: 'Seat',
                de: 'Sitz'
            }
            // currentLocale: 'de',
        };
    }, // eo data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingCart', 'getBookingDepArprtCode', // Users Search Data, Part 1
    'getBookingDesArprtCode', 'getBookingDepArprtName', 'getBookingDesArprtName', 'getBookingDepArprtCodeReturnToOther', 'getBookingDepArprtNameReturnToOther', 'getBookingDesArprtCodeReturnToOther', 'getBookingDesArprtNameReturnToOther', 'getBookingUsersSearchData_OjArprtCode', 'getBookingUsersSearchData', // Users Search Data, Part 2
    'getBookingCartOutwardTotal', // Summed up Outward ALL
    'getBookingCartReturnTotal', // Summed up Return ALL
    'getFlagBookingOutwardFlightSelected', // CONTROL FLAG
    'getFlagBookingReturnFlightSelected', // CONTROL FLAG
    'getBookingCartSeatsCellId', // get cellid (in comment field)
    'getBookingSeatReservationLockingCodeResults'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Filters */
    filters: {

        /*******************************************************************
        * dateFlightCart()
        *
        * Desc:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        dateFlightCart: function dateFlightCart(date) {

            return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date, __WEBPACK_IMPORTED_MODULE_2_moment___default.a.ISO_8601).format('DD.MM.YYYY'); // de:
            // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019
        }, // dateFlightCart()

        /*******************************************************************
        * durationFlightCart()
        *
        * Desc: Calculates "Travel Time".
        *
        * @param {int} a (duration in seconds)
        * @return {string}
        */
        durationFlightCart: function durationFlightCart(a) {

            var hours = Math.floor(a / 3600),
                minutes = Math.floor(a / 60) - hours * 60,
                hours_txt = 'S',
                // H
            minutes_txt = ' h'; // M


            if (minutes === 0) {
                return hours + ':00' + minutes_txt;
            } else if (minutes.toString().length === 1) {
                return hours + ':0' + minutes + '' + minutes_txt;
            } else {
                return hours + ':' + minutes + '' + minutes_txt;
            }
        }, // eof durationFlightCart()

        /*******************************************************************
        * truncate()
        *
        * Desc:
        *
        * @param
        * @return {string}
        */
        truncate: function truncate(text, length, clamp) {

            var clamp = clamp || '...';
            var node = document.createElement('div');
            node.innerHTML = text;
            var content = node.textContent;

            return content.length > length ? content.slice(0, length) + clamp : content;
        } // eof truncate()


    }, // eof filters{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_setBookingUpdateCartViaDeleteSrvcs', 'actn_setBookingUpdateCartViaDeleteSeat', 'actn_setServicesUpdateValidateObjectViaDeleteSrvcs', 'actn_setServicesUpdateValidateObjectViaDeleteSeat']), {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (DELETE)
        *
        * Desc: UNLock Seat via Lockingcode + Seatno.
        * Note:
        *
        * @param {string} cellId
        * @param {int} id_pax
        * @param {string} type ('out', 'ret')
        * @param {string} seatno
        * @param {bool} lockAfterwards (Should i lock afterwards?)
        */
        call_unlockSeat: function call_unlockSeat(cellId, id_pax, type, seatno, lockAfterwards) {

            var me = this,
                lockingCodes = {},
                lockingcode = '',
                hdrs = '';

            me.$toc('>>> shared/cart/Cart.vue >>> call_unlockSeat');
            lockingCodes = this.getBookingSeatReservationLockingCodeResults;
            if (type === 'outward') {
                lockingcode = lockingCodes.outward.response.seatReservationLockingCode;
            }
            if (type === 'return') {
                lockingcode = lockingCodes.return.response.seatReservationLockingCode;
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/seatplan/lock_code/' + lockingcode + '/' + seatno, null).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        // Delete in Cart ...&& ValidateObject
                        me.actn_setBookingUpdateCartViaDeleteSeat({ id_pax: id_pax, type: type }); // Cart / ValidateObject => 'Booking' && Cart => 'Services'
                        // if (this.modulo === 'services') {
                        me.actn_setServicesUpdateValidateObjectViaDeleteSeat({ id_pax: id_pax, type: type }); // ValidateObject => 'Services'
                        // }
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo function call_unlockSeat()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onClick_DeleteSrvcs()
        *
        * Desc: Delete Service.
        * Note: { id_pax: pax.id_pax, srvcs: srvcs, type: 'outward' }
        * Note: I want the 'collapse' to finsih before delete from state!
        *
        * @param {Object} srvcs (selected Srvcs)
        * @return {string}
        */
        onClick_DeleteSrvcs: function onClick_DeleteSrvcs(srvcs) {
            var _this = this;

            var me = this,
                elem = '';

            me.$toc('>>> shared/cart/Cart.vue >>> onClick_DeleteSrvcs');
            this.$modal.show('dialog', {
                title: me.wannedelete[me.getCurrentLocale],
                text: me.alerttext[me.getCurrentLocale],
                buttons: [{
                    title: me.alertno[me.getCurrentLocale]
                }, {
                    title: me.alertyes[me.getCurrentLocale],
                    default: true,
                    handler: function handler() {

                        me.$modal.hide('dialog');

                        if (srvcs.type === 'outward') {
                            elem = 'pax-delete-service-outward-' + srvcs.id_pax + '-' + srvcs.srvcs.id;
                            _this.$refs[elem][0].click();
                        }
                        if (srvcs.type === 'return') {
                            elem = 'pax-delete-service-return-' + srvcs.id_pax + '-' + srvcs.srvcs.id;
                            _this.$refs[elem][0].click();
                        }

                        // >>> Del from Cart ------------
                        setTimeout(function () {
                            me.actn_setBookingUpdateCartViaDeleteSrvcs(srvcs); // Cart / ValidateObject => 'Booking' && Cart => 'Services'
                            // if (this.modulo === 'services') {
                            me.actn_setServicesUpdateValidateObjectViaDeleteSrvcs(srvcs); // ValidateObject => 'Services'
                            // }
                        }, 650);
                    }
                }]
            });
        }, // eo function onClick_DeleteSrvcs()


        /*******************************************************************
        * onClick_DeleteSeat()
        *
        * Desc: Delete Seat.
        * Note: e.g.: { id_pax: pax.id_pax, type: 'outward', seat: pax.return_seat }
        * Note: I want the 'collapse' to finsih before delete from state!
        *
        * @param {Object} seat (selected Seat)
        * @return {string}
        */
        onClick_DeleteSeat: function onClick_DeleteSeat(seat) {
            var _this2 = this;

            var me = this,
                elem = '';

            me.$toc('>>> shared/cart/Cart.vue >>> onClick_DeleteSeat');
            this.$modal.show('dialog', {
                title: me.wannedelete[me.getCurrentLocale],
                text: me.alerttext[me.getCurrentLocale],
                buttons: [{
                    title: me.alertno[me.getCurrentLocale]
                }, {
                    title: me.alertyes[me.getCurrentLocale],
                    default: true,
                    handler: function handler() {
                        me.$modal.hide('dialog');
                        if (seat.type === 'outward') {
                            elem = 'pax-delete-seat-outward-' + seat.id_pax + '-' + seat.seat.seatno;
                            _this2.$refs[elem][0].click();
                        }
                        if (seat.type === 'return') {
                            elem = 'pax-delete-seat-return-' + seat.id_pax + '-' + seat.seat.seatno;
                            _this2.$refs[elem][0].click();
                        }

                        // >>> Step 2 ---
                        me.onClick_DeleteSeat_2(seat);
                    }
                }]
            });
        }, // eo function onClick_DeleteSeat()


        /*******************************************************************
        * onClick_DeleteSeat_2()
        *
        * Desc: Delete Seat 2.
        * Note:
        *
        * @param {Object} seat (selected Seat)
        * @return {string}
        */
        onClick_DeleteSeat_2: function onClick_DeleteSeat_2(seat) {

            var me = this,
                id_pax = seat.id_pax,
                type = seat.type,
                cellId = this.getBookingCartSeatsCellId({ id_pax: id_pax, type: type }); // getting it from 'comment'


            me.$toc('>>> shared/cart/Cart.vue >>> onClick_DeleteSeat');
            // >>> Unlock -------------------
            me.call_unlockSeat(cellId, id_pax, type, seat.seat.seatno, false);
        }, // eo function onClick_DeleteSeat()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * trnslPaxTypes()
        *
        * Desc:
        *
        * @param
        * @return {Array}
        */
        trnslPaxTypes: function trnslPaxTypes(type) {

            var me = this,
                trnsltdType = '';

            me.$toc('>>> shared/cart/Cart.vue >>> trnslPaxTypes');
            switch (type) {
                case 'ADT':
                    trnsltdType = me.adult[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdType = me.child[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdType = me.infant[me.getCurrentLocale];
                    break;
                default:
                    trnsltdType = '';
            }

            return trnsltdType;
        } // eo function trnslPaxTypes()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BookingnoFlightDetails_vue__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // Sidebar (right)






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-bookingno-flight-details': __WEBPACK_IMPORTED_MODULE_0__BookingnoFlightDetails_vue__["a" /* default */],
        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_1__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            headline_step1: {
                en: 'Step 1: Here you can see your booking data.',
                de: 'Schritt 1: Hier sehen Sie Ihre Buchungsdaten.'
            },
            proceed: {
                en: 'Proceed to Book seats and services',
                de: 'Weiter zu Sitzplätze und Services buchen'
            },
            resultsshown: {
                en: 'Passenger(s) found',
                de: 'Passagier(e) gefunden'
            },
            // ----------------------------------------
            tab_flightdetails: {
                en: 'Your original booking',
                de: 'Ihre ursprüngliche Buchung'
            }
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_FlagServicesShowBookingnoSearchResults', // Control Flag
    'get_ServicesBookingnoSearchResults', // Bookingno Search Results
    'get_ServicesBookingnoPassengersCount', // Passengers Count
    'get_ServicesBookingnoPassengersCountAll', //
    'get_ServicesBookingnoHasOutwardFlight', // has outward flight
    'get_ServicesBookingnoHasReturnFlight', // has return flight
    'get_areWeInServicesBookingNoMode'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note: Catch Event 'readytopushpassengers' ('All Calls done ...').
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> created');
        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$on('readytopushpassengers', this.onEmit_ReadyToPushPassengers);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> beforeDestroy');
        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$off('readytopushpassengers', this.onEmit_ReadyToPushPassengers);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actn_call_registrationBookingoptions', // Call: get 'bookingoptions'
    'actn_call_bookableServices', // Call: get 'bookable services'
    'actn_Flag_bookableServicesCallRetDidRun', 'actn_setBookingUsersSearchData', // prepare/simulate pax data
    'actn_setBookingUpdateCart', // prepare/simulate update cart
    'actn_setBookingAirports', 'actn_FlagServicesBookingnoLoginIsReadyForLogin', 'actn_setBookingFlightIdSelectedOutward', 'actn_setBookingFlightIdSelectedReturn']), {

        /******************************************************************* 'ServiceCalls - Bookingno'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * call_NextCalls()
        *
        * Desc:
        * Note: 1.  Prepare/Simulate Passengers (See: FlightSearchTab => onSubmit).
        * NOte: 1b. Update Cart and more
        * Note: 2.  Do/Run the Call Chain ..
        * Note:
        * TODO: Is here more to set up in state for the 'Passenger' Step?
        * TODO: See: FlighSearchTab.vue >>> onSubmit
        *
        */
        call_nextCalls: function call_nextCalls() {

            var me = this,
                outwardFlight = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                returnFlight = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                params = {},
                flight = {};

            me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> call_nextCalls');
            // >>> 1. Prepare/Simulate -------------------------------------
            params = {
                depArprtCode: outwardFlight !== undefined && outwardFlight !== null ? outwardFlight.departureAirportInfo.iataCode : null,
                desArprtCode: outwardFlight !== undefined ? outwardFlight.destinationAirportInfo.iataCode : null,
                noADT: this.get_ServicesBookingnoPassengersCount('ADT'),
                noCHD: this.get_ServicesBookingnoPassengersCount('CHD'),
                noINF: this.get_ServicesBookingnoPassengersCount('INF'),
                ojArprtCode: '',
                ojType: '',
                depAfter: '',
                rTrip: returnFlight !== undefined ? true : false,
                limit: 5
            };
            this.actn_setBookingUsersSearchData(params); // set/simulate/remember in state


            // >>> 1b. Prepare/Simulate ------------------------------------
            if (outwardFlight !== undefined && outwardFlight !== null) {
                // out
                flight = {
                    flight: this.build_FlightObject('outward'),
                    modulo: this.modulo,
                    type: 'outward'
                };
                this.actn_setBookingUpdateCart(flight);

                this.actn_setBookingAirports({
                    depArprtCode: outwardFlight.departureAirportInfo.iataCode,
                    depArprtName: outwardFlight.departureAirportInfo.location,
                    desArprtCode: outwardFlight.destinationAirportInfo.iataCode,
                    desArprtName: outwardFlight.destinationAirportInfo.location
                });

                this.actn_setBookingFlightIdSelectedOutward(outwardFlight.id);
            }

            if (returnFlight !== undefined && returnFlight !== null) {
                // ret
                flight = {
                    flight: this.build_FlightObject('return'),
                    modulo: this.modulo,
                    type: 'return'
                };
                this.actn_setBookingUpdateCart(flight);

                // this.actn_setBookingAirports({
                //     depArprtCode: returnFlight.departureAirportInfo.iataCode,
                //     depArprtName: returnFlight.departureAirportInfo.location,
                //     desArprtCode: returnFlight.destinationAirportInfo.iataCode,
                //     desArprtName: returnFlight.destinationAirportInfo.location,
                // });

                this.actn_setBookingFlightIdSelectedReturn(returnFlight.id);
            }

            // >>> 2. Do/Run -----------------------------------------------
            this.call_registrationBookingoptions(); // Call 1: 'get bookingoptions'
            this.call_bookableServices('outward'); // Call 2: 'get bookableservices' - outward
            if (returnFlight !== undefined) {
                this.call_bookableServices('return'); // Call 2: 'get bookableservices' - return
            } else {
                this.actn_Flag_bookableServicesCallRetDidRun(true); // we fake it
            }
        }, // eo function call_nextCalls()


        /*******************************************************************
        * Call::'/registration/bookingoptions'
        *
        * Desc:
        * Note: New: Axios Call is here managed in VUEX.
        *
        */
        call_registrationBookingoptions: function call_registrationBookingoptions() {

            var me = this,
                outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                flightIds = [],
                params = {};

            me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> call_registrationBookingoptions');
            if (outwardId !== undefined) {
                outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight.id;
            }
            if (returnId !== undefined && returnId !== null) {
                returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight.id;
            }

            // >>> 1. Builds Object ----------------------------------------
            if (outwardId !== null && outwardId !== undefined && outwardId !== '') {
                flightIds.push(String(outwardId));
            }
            if (returnId !== null && returnId !== undefined && returnId !== '') {
                flightIds.push(String(returnId));
            }

            params = {
                "bookingOptionsRQ": {
                    "idFlights": flightIds
                }
            };

            this.actn_call_registrationBookingoptions(params); // Call
        }, // eo function call_registrationBookingoptions()


        /*******************************************************************
        * Call::'/service/bookableservices/{idFlight}/{tktClass}'
        *
        * Desc:
        * Note: New: Axios Call is here managed in VUEX.
        *
        * @param {string} type ('outward','return')
        */
        call_bookableServices: function call_bookableServices(type) {

            var me = this,
                outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                id = '';

            me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> call_bookableServices');
            // >>> 1. Builds Object -------------------
            if (outwardId !== undefined && type === 'outward') {
                outwardId = this.get_ServicesBookingnoSearchResults[0].outwardFlight.id;
                id = outwardId;

                this.actn_call_bookableServices({ id: id, type: type }); // Call
            }
            if (returnId !== undefined && returnId !== null && type === 'return') {
                returnId = this.get_ServicesBookingnoSearchResults[0].returnFlight.id;
                id = returnId;

                this.actn_call_bookableServices({ id: id, type: type }); // Call
            }
        }, // eo function call_bookableServices()


        /******************************************************************* 'Listeners - eventBus'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onEmit_ReadyToPushPassengers()
        *
        * Desc: Handle 'Push Passengers' after all pre Calls are done.
        * Note:
        *
        */
        onEmit_ReadyToPushPassengers: function onEmit_ReadyToPushPassengers() {

            var me = this,
                options = {};

            me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> onEmit_ReadyToPushPassengers');
            // >>> Scroll Options ------------------------------------------
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Pushing/Scrolliing --------------------------------------
            this.actn_FlagServicesBookingnoLoginIsReadyForLogin(false); // reset


            me.$router.push({ path: '/passengers/' + me.modulo });
            setTimeout(function () {
                me.$scrollTo('#scrollPointTop', 200, options);
            }, 300);
        }, // eo function onEmit_ReadyToPushPassengers()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * build_FlightObject()
        *
        * Desc: Build/Rebuilds Fligths Object for Cart.
        * Note: Reason: Totally different FlightObject from Backend.
        * Note: In 'outwardFlight'=>OverView Call &&
        * Note: Flightobject in 'getFlights'.
        *
        * @param {string} type ('outward','return')
        */
        build_FlightObject: function build_FlightObject(type) {

            var me = this,
                outwardFlight = this.get_ServicesBookingnoSearchResults[0].outwardFlight,
                returnFlight = this.get_ServicesBookingnoSearchResults[0].returnFlight,
                flightObject = {};

            me.$toc('>>> services/pagecontent/BookingnoOverview.vue >>> build_FlightObject');
            // >>> ------------------------------------
            if (type === 'outward') {
                if (outwardFlight !== undefined) {
                    flightObject = {
                        "depDT": outwardFlight.departureDateTimeLocal, // "2020-02-26T11:30:00+0100",
                        "desDT": outwardFlight.destinationDateTimeLocal, // "2020-02-26T15:55:00+0000",
                        "dur": outwardFlight.dur

                    };
                }
            }

            // >>> ------------------------------------
            if (type === 'return') {
                if (returnFlight !== undefined && returnFlight !== null) {
                    flightObject = {
                        "depDT": returnFlight.departureDateTimeLocal, // "2020-02-26T11:30:00+0100",
                        "desDT": returnFlight.destinationDateTimeLocal, // "2020-02-26T15:55:00+0000",
                        "dur": returnFlight.dur
                    };
                }
            }

            return flightObject;
        } // eo function build_FlightObject()

    }) // eo methods
    /* <<< ****************************************************************/

});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flightdirection'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {}, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            tab_header_flightdetailsoutwardservices: {
                en: 'Your booking details for the outbound flight',
                de: 'Ihre Buchungsdetails zum Hinflug'
            },
            tab_header_flightdetailsreturnservices: {
                en: 'Your booking details for the inbound flight',
                de: 'Ihre Buchungsdetails zum Rückflug'
            },
            // >>> --------------------------
            airline: {
                en: 'Organizer',
                de: 'Veranstalter'
            },
            flighttype: {
                en: 'Flight Type',
                de: 'Tarif'
            },
            from: {
                en: 'From',
                de: 'Von'
            },
            to: {
                en: 'to',
                de: 'nach'
            },
            outwardflight: {
                en: 'Outward',
                de: 'Hinflug'
            },
            returnflight: {
                en: 'Return',
                de: 'Rückflug'
            },
            takeoff: {
                en: 'Take off',
                de: 'Abflug'
            },
            landing: {
                en: 'Landing',
                de: 'Ankunft'
            },
            born: {
                en: 'Born',
                de: 'Geb. am'
            },
            // >>> --------------------------
            mr: {
                en: 'Mr',
                de: 'Herr'
            },
            mrs: {
                en: 'Mrs',
                de: 'Frau'
            },
            chd: {
                en: 'Child',
                de: 'Kind'
            },
            inf: {
                en: 'Infant',
                de: 'Kleinkind'
            },
            // >>> --------------------------
            flightpriceservices: {
                en: 'Flight already booked',
                de: 'Flug schon gebucht'
            },
            seat: {
                en: 'Seat',
                de: 'Sitz'
            }
            // currentLocale: 'de',
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'get_ServicesBookingnoSearchResults', 'get_ServicesBookingnoSearchResultsPassengersSorted', 'get_ServicesBookingnoDepArprtNameOutuward', 'get_ServicesBookingnoDesArprtNameOutward', 'get_ServicesBookingnoDepArprtNameReturn', 'get_ServicesBookingnoDesArprtNameReturn'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Filters */
    filters: {

        /*******************************************************************
        * dateFlightCart()
        *
        * Desc:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        dateFlightCart: function dateFlightCart(date) {

            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601).format('DD.MM.YYYY'); // de:
            // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019
        }, // eo function dateFlightCart()


        /*******************************************************************
        * durationFlightCart()
        *
        * Desc: Calculates "Travel Time".
        *
        * @param {int} a (duration in seconds)
        * @return {string}
        */
        durationFlightCart: function durationFlightCart(a) {

            var hours = Math.floor(a / 3600),
                minutes = Math.floor(a / 60) - hours * 60,
                hours_txt = 'S',
                // H
            minutes_txt = ' h'; // M


            if (minutes === 0) {
                return hours + ':00' + minutes_txt;
            } else if (minutes.toString().length === 1) {
                return hours + ':0' + minutes + '' + minutes_txt;
            } else {
                return hours + ':' + minutes + '' + minutes_txt;
            }
        } // eo function durationFlightCart()

    }, // eo filters{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * trnslPaxTypes()
        *
        * Desc:
        *
        * @param
        * @return {Array}
        */
        trnslPaxTypes: function trnslPaxTypes(type) {

            var me = this,
                trnsltdType = '';

            me.$toc('>>> services/pagecontent/BookingnoFlightDetails.vue >>> trnslPaxTypes');
            switch (type) {
                case 'ADT':
                    trnsltdType = me.adult[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdType = me.child[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdType = me.infant[me.getCurrentLocale];
                    break;
                default:
                    trnsltdType = '';
            }

            return trnsltdType;
        }, // eo function trnslPaxTypes()


        /*******************************************************************
        * trnslPaxSalutations()
        *
        * Desc:
        *
        * @param
        * @return {Array}
        */
        trnslPaxSalutations: function trnslPaxSalutations(type) {

            var me = this,
                trnsltdSalutation = '';

            me.$toc('>>> services/pagecontent/BookingnoFlightDetails.vue >>> trnslPaxSalutations');
            switch (type) {
                case 'MR':
                    trnsltdSalutation = me.mr[me.getCurrentLocale];
                    break;
                case 'MRS':
                    trnsltdSalutation = me.mrs[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdSalutation = me.chd[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdSalutation = me.inf[me.getCurrentLocale];
                    break;
                default:
                    trnsltdSalutation = '';
            }

            return trnsltdSalutation;
        }, // eo function trnslPaxSalutations()


        /*******************************************************************
        * getSeatData()
        *
        * Desc:
        *
        * @param
        * @return
        */
        getSeatData: function getSeatData(paxServices) {

            var me = this,
                seatData = [];

            me.$toc('>>> services/pagecontent/BookingnoFlightDetails.vue >>> getSeatData');
            seatData = paxServices.filter(function (x) {
                return x.code == 'SEAT';
            });

            return seatData;
        } // eo function getSeatData()

    } // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            needhelp: {
                en: 'Do you need any help or support?',
                de: 'Benötigen Sie Hilfe oder Unterstützung?'
            },
            sideboxhelptext: {
                en: 'We will be happy to help you. Our Contact:',
                de: 'Wir helfen Ihnen gern weiter. Unser Kontakt:'
            },
            forbeirut: {
                en: 'For Beirut Flights:',
                de: 'Für Beirut Flüge:'
                // currentLocale: 'de',
            } };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeatTab_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68018bf4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeatTab_vue__ = __webpack_require__(307);
function injectStyle (ssrContext) {
  __webpack_require__(305)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68018bf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeatTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68018bf4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeatTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** /  /* Data */
    data: function data() {
        var _ref;

        return _ref = {
            searchboxheadlineflightseat: {
                en: 'Seats',
                de: 'Sitzplätze'
            },
            searchboxheadlineflights2: {
                en: 'Discover the world with SUNDAIR!',
                de: 'Entdecke die Welt mit SUNDAIR!'
            },
            seatstitle: {
                en: 'Reserve your desired seat!',
                de: 'Reservieren Sie sich Ihren Wunschsitzplatz!'
            },
            seatstitle2: {
                en: 'The following seating categories are available:',
                de: 'Folgende Sitzplatzkategorien stehen zur Wahl:'
            },
            seatsbutton: {
                en: 'Directly to seat booking',
                de: 'Direkt zur Sitzplatz Buchung'
            },

            furtherservices_seat_comfortseat: {
                en: 'Seats in the 1st row with plenty of legroom',
                de: 'Sitzplätze in der 1. Reihe mit viel Beinfreiheit'
            }
        }, _defineProperty(_ref, 'furtherservices_seat_comfortseat', {
            en: 'SEATS IN THE 1ST ROW',
            de: 'SITZPLÄTZE IN DER 1. REIHE'
        }), _defineProperty(_ref, 'furtherservices_seat_bestseat', {
            en: 'Seats in the 2nd - 7th row',
            de: 'Sitzplätze in der 2.-7. Reihe'
        }), _defineProperty(_ref, 'furtherservices_seat_exitseat', {
            en: 'SEATS DIRECTLY AT THE EMERGENCY EXIT',
            de: 'SITZPLÄTZE AM NOTAUSGANG'
        }), _defineProperty(_ref, 'moreinfo', {
            en: 'MORE INFO',
            de: 'MEHR INFOS'
        }), _ref;
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuggageTab_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499302f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuggageTab_vue__ = __webpack_require__(310);
function injectStyle (ssrContext) {
  __webpack_require__(308)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-499302f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuggageTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_499302f6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuggageTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** /  /* Data */
    data: function data() {
        var _ref;

        return _ref = {
            searchboxheadlineflightluggage: {
                en: 'Luggage',
                de: 'Gepäck'
            },
            searchboxheadlineflights2: {
                en: 'Discover the world with SUNDAIR!',
                de: 'Entdecke die Welt mit SUNDAIR!'
            },
            // >>> --------------------------
            luggagetitle: {
                en: 'Take extra luggage with you!',
                de: 'Nehmen Sie zusätzliches Gepäck mit!'
            },
            luggagetext1: {
                en: 'Your free luggage allowance includes <b>one (1) Cabin baggage and one (1) checked baggage free of charge per person.</b>',
                de: 'Ihr Reisegepäck umfasst <b>ein kostenloses Handgepäck und ein kostenloses aufzugebendes Gepäck pro Person</b>.'
            },
            luggagetext3: {
                en: "You need more luggage? <a href='/services'>Book additional baggage here.</a>",
                de: 'Sie benötigen weiteres Gepäck? <a href="/services">Buchen Sie zusätzliches Gepäck hier.</a>'
            },
            weareon: {
                en: 'Customer Service Department',
                de: 'Abt. Kundenservice'
            },
            // >>> --------------------------
            seatsbutton: {
                en: 'Directly to service booking',
                de: 'Direkt zur Service Buchung'
            },
            // >>> --------------------------
            furtherservices_seat_comfortseat: {
                en: 'Seats in the 1st row with plenty of legroom',
                de: 'Sitzplätze in der 1. Reihe mit viel Beinfreiheit'
            }
        }, _defineProperty(_ref, 'furtherservices_seat_comfortseat', {
            en: 'Seats in the 1st row with plenty of legroom',
            de: 'Sitzplätze in der 1. Reihe mit viel Beinfreiheit'
        }), _defineProperty(_ref, 'furtherservices_seat_bestseat', {
            en: 'Seats in the 2nd - 7th row',
            de: 'Sitzplätze in der 2.-7. Reihe'
        }), _defineProperty(_ref, 'furtherservices_seat_exitseat', {
            en: 'Seats in the 12th and 14th row directly at the exit',
            de: 'Sitzplätze in der 12. Und 14. Reihe direkt am Ausgang'
        }), _defineProperty(_ref, 'moreinfo', {
            en: 'MORE INFO',
            de: 'MEHR INFOS'
        }), _defineProperty(_ref, 'weight', {
            en: 'Weight',
            de: 'Gewicht'
        }), _defineProperty(_ref, 'dimensions', {
            en: 'Dimensions',
            de: 'Abmessungen'
        }), _defineProperty(_ref, 'handluggage', {
            en: 'CABIN BAGGAGE',
            de: 'HANDGEPÄCK'
        }), _defineProperty(_ref, 'abandonableluggage', {
            en: 'CHECKED BAGGAGE',
            de: 'AUFZUGEBENDES GEPÄCK'
        }), _defineProperty(_ref, 'piece', {
            en: 'piece',
            de: 'Stück'
            // currentLocale: 'de',
        }), _ref;
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpTab_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6003babd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpTab_vue__ = __webpack_require__(313);
function injectStyle (ssrContext) {
  __webpack_require__(311)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6003babd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6003babd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            searchboxheadlineflighthelp: {
                en: 'Help & Contact',
                de: 'Hilfe & Kontakt'
            },
            searchboxheadlineflights2: {
                en: 'Discover the world with SUNDAIR!',
                de: 'Entdecke die Welt mit SUNDAIR!'
            },
            weareon: {
                en: 'Customer Service Department',
                de: 'Abt. Kundenservice'
            },
            sendusemail: {
                en: 'Send us email on',
                de: 'Senden Sie uns eine E-Mail an'
            },
            meetusat: {
                en: 'Meet us at',
                de: 'Treffen Sie uns unter'
            },
            hellotext1: {
                en: 'Dear passenger,',
                de: 'Sehr geehrter Fluggast,'
            },
            hellotext2: {
                en: 'we will be glad to help you. We are at your disposal on Mo - Fr from 09 a.m. - 6 p.m.<br />Simply get in touch with us.<br /><br /><h5>Your SUNDAIR</h5>',
                de: 'gerne helfen wir Ihnen weiter. Wir stehen Ihnen Mo - Fr von  09 - 18 Uhr zur Verfügung.<br />Nehmen Sie doch einfach Kontakt zu uns auf.<br /><br /><h5>Ihre SUNDAIR</h5>'
            }
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            title_informations: {
                en: 'Information',
                de: 'Informationen'
            },
            title_customerservice: {
                en: 'Customer Service',
                de: 'Kundenservice'
            },
            title_agency: {
                en: 'Agency Login',
                de: 'Agentur Login'
            },
            agencylogin: {
                en: 'Agency Login',
                de: 'Agentur Login'
            },
            agencylogout: {
                en: 'Agency Logout',
                de: 'Agentur Logout'
            },
            listpoint_infos_luggage: {
                en: 'Luggage',
                de: 'Gepäck'
            },
            listpoint_infos_dangerous_goods: {
                en: 'Dangerous Goods',
                de: 'Gefährliche Güter'
            },
            listpoint_infos_prohibited_items: {
                en: 'Prohibited Items',
                de: 'Verbotene Gegenstände'
            },
            listpoint_infos_additional_services: {
                en: 'Additional Services',
                de: 'Zusatzleistungen'
            },
            listpoint_infos_serviceonboard: {
                en: 'Service on board',
                de: 'Service an Board'
            },
            listpoint_infos_seat_reservation: {
                en: 'Seat Reservation',
                de: 'Sitzplatzreservierung'
            },
            listpoint_infos_fare_conditions: {
                en: 'Fare Conditions',
                de: 'Tarifbestimmungen'
            },
            listpoint_infos_complaints: {
                en: 'Complaints',
                de: 'Reklamationen'
            },
            listpoint_infos_group_booking: {
                en: 'Group Booking',
                de: 'Gruppenbuchung'
            },
            listpoint_faq: {
                en: 'FAQ',
                de: 'FAQ'
            },
            // >>> -------------------------- Modal
            webcomponenttype: '', // ABB/FAQ aso.
            sections: [] // data
        };
    }, // eo funtion data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedAgencyLoggedIn'] // is Agency logged in?
    )), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note: Check for Agency here.
    *
    */
    mounted: function mounted() {

        var me = this,
            localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username'));

        // >>> Agency in localStorage? --------------
        if (localStorageAgencyUser !== null) {
            this.actn_FlagSharedAgencyLoggedIn(true);
        }
    }, // eo function mounted()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['actn_FlagSharedAgencyLoggedIn']), {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/site/getwebcomponent/'
        *
        * Desc:
        * Note:
        *
        * @param {string} comptype (kind of Component)
        * @param
        * @return
        */
        call_getwebcomponent: function call_getwebcomponent(comptype) {

            var me = this,
                hdrs = '';

            me.$toc('>>> shared/footer/FirstRow.vue >>> call_getwebcomponent');
            // >>> 1. Builds Object ----------------------------------------
            var requestParamObject = {
                name: comptype
            };

            // >>> #267, Translation ---------------------------------------
            if (comptype === 'FAQ') {
                this.webcomponenttype = this.listpoint_faq[this.getCurrentLocale];
            } else {
                this.webcomponenttype = comptype; // remember
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/site/getwebcomponent/', requestParamObject).then(function (response) {
                // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.$modal.show('size-modal-first', { data: response.data });
                        me.$vp_um();
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo funtion call_getwebcomponent()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onClick_AgencyLogout()
        *
        * Desc:
        * Note:
        *
        * @param
        * @return
        */
        onClick_AgencyLogout: function onClick_AgencyLogout() {

            var me = this;

            me.$toc('>>> shared/footer/FirstRow.vue >>> onClick_AgencyLogout');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agency_username');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agency_password');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agency_object');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agencyAuthorizationHeader');

            this.actn_FlagSharedAgencyLoggedIn(false);
            me.$toasted.global.sdr_app_info({
                message: 'Agency was logged out.'
            });

            // reload page
            setTimeout(function () {
                location.reload();
            }, 1000);
        }, // eo function onClick_AgencyLogout()


        /******************************************************************* 'Utilities - Common'
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * getPathName()
        *
        * Desc:
        * Note:
        *
        * @param {string} pathname ()
        * @param
        * @return
        */
        getPathName: function getPathName(pathname) {

            var me = this,
                currentUrl = window.location.pathname,
                currentUrl = currentUrl.slice(1, -1);

            // me.$toc('>>> shared/footer/LanguageList.vue >>> getPathName');
            if (pathname === currentUrl) {
                return true;
            } else {
                return false;
            }
        }, // eo function getPathName()


        /*******************************************************************
        * Modals:
        *******************************************************************/
        /*******************************************************************
        * Modal - Events - beforeOpen
        *
        * Desc:
        * Note: Catches 'data' Object from $modal.show.
        *
        */
        beforeOpen: function beforeOpen(event) {

            this.sections = event.params.data.sections;
        }
    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gql_query_builder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gql_query_builder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gql_query_builder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






 // Graphql



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            listpoint_agb: {
                en: 'General Terms',
                de: 'AGB'
            },
            listpoint_abb: {
                en: 'Terms and Conditions',
                de: 'ABB'
            },
            listpoint_impressum: {
                en: 'Imprint',
                de: 'Impressum'
            },
            listpoint_sec: {
                en: 'Data Protection & Privacy',
                de: 'Datenschutz'
            },
            infosprivacypolicy: {
                en: 'Data Protection & Privacy',
                de: 'Datenschutz'
            },
            title_legalnotices: {
                en: 'Legal Notices',
                de: 'Rechtliche Hinweise'
            },
            title_career: {
                en: 'Career',
                de: 'Karriere'
            },
            careertext: {
                en: 'Learn more about open positions at SUNDAIR. Become a part of our team as well.',
                de: 'Mehr über offene Positionen bei SUNDAIR erfahren. Werden Sie auch ein Teil unseres Teams.'
            },
            title_press: {
                en: 'Press',
                de: 'Presse'
            },
            listpoint_faq: {
                en: 'Faq',
                de: 'Faq'
            },
            // currentLocale: 'de',
            // >>> -------------------------- Modal
            webcomponenttype: '', // ABB/FAQ aso.
            sections: [] // data
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_PressreleasesHeadlines_Filtered'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Filters */
    filters: {

        /*******************************************************************
        * nicedate()
        *
        * Desc:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        nicedate: function nicedate(date) {

            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, __WEBPACK_IMPORTED_MODULE_3_moment___default.a.ISO_8601).format('DD.MM.YYYY'); // de:
        }, // eo function nicedate()


        /*******************************************************************
        * truncate()
        *
        * Desc:
        *
        * @param {string}
        * @return {string}
        */
        truncate: function truncate(str) {

            var n = 35;

            return str.length > n ? str.substr(0, n - 1) + '...' : str;
        } // eo function truncate()

    }, // eo filters{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc: Load 'Pressreleases' Headlines.
    * Note:
    *
    */
    created: function created() {

        var me = this,
            params = Object(__WEBPACK_IMPORTED_MODULE_2_gql_query_builder__["query"])({
            operation: 'pressreleases',
            fields: ['_id', 'publishDate', 'headline', 'active']
        });

        me.$toc('>>> shared/footer/SecondRow.vue >>> created');
        // >>> ---------------------------------------- Call
        me.actn_call_getPressreleasesHeadlines(params);
    }, // eo function created()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['actn_call_getPressreleasesHeadlines']), {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/site/getwebcomponent/'
        *
        * Desc:
        * Note:
        *
        * @param {string} comptype (kind of Component)
        * @param
        * @return
        */
        call_getwebcomponent: function call_getwebcomponent(comptype) {

            var me = this,
                hdrs = '';

            me.$toc('>>> shared/footer/SecondRow.vue >>> call_getwebcomponent');
            // >>> 1. Builds Object ----------------------------------------
            var requestParamObject = {
                name: comptype
            };

            // >>> #267, Translation ---------------------------------------
            if (comptype === 'ABB') {
                this.webcomponenttype = this.listpoint_abb[this.getCurrentLocale];
            } else if (comptype === 'AGB') {
                this.webcomponenttype = this.listpoint_agb[this.getCurrentLocale];
            } else if (comptype === 'IMPRINT') {
                this.webcomponenttype = this.listpoint_impressum[this.getCurrentLocale];
            } else if (comptype === 'PCPE') {
                this.webcomponenttype = this.listpoint_sec[this.getCurrentLocale];
            } else if (comptype === 'FAQ') {
                this.webcomponenttype = this.listpoint_faq[this.getCurrentLocale];
            } else {
                this.webcomponenttype = comptype; // remember
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/site/getwebcomponent/', requestParamObject).then(function (response) {
                // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.$modal.show('size-modal', { data: response.data });
                        me.$vp_um();
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eof call_getwebcomponent()


        /******************************************************************* 'Utilities - Common'
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * getPathName()
        *
        * Desc:
        * Note:
        *
        * @param {string} pathname ()
        * @param
        * @return
        */
        getPathName: function getPathName(pathname) {

            var me = this,
                currentUrl = window.location.pathname,
                currentUrl = currentUrl.slice(1, -1);

            // me.$toc('>>> shared/footer/LanguageList.vue >>> getPathName');
            if (pathname === currentUrl) {
                return true;
            } else {
                return false;
            }
        }, // eof getPathName()


        /*******************************************************************
        * Modals:
        *******************************************************************/
        /*******************************************************************
        * Modal - Events - beforeOpen
        *
        * Desc:
        * Note: Catches 'data' Object from $modal.show.
        *
        */
        beforeOpen: function beforeOpen(event) {

            this.sections = event.params.data.sections;
        },
        // eof beforeOpen()

        /*******************************************************************
        * Modal - Events - beforeClose
        *
        * Desc:
        * Note:
        *
        */
        beforeClose: function beforeClose() {

            this.sections = [];
        }
    }) // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            aboutsundair: {
                en: 'About KAYOFLY',
                de: 'Über KAYOFLY'
            },
            aboutsundairtext: {
                en: 'Welcome to <strong>Kayofly</strong>! We are a travel agency in the heart of Berlin and specialized in Tunisia.<br />Would you like to travel to Tunisia, get to know the country or just experience a dream vacation? Or are you a Tunisian yourself and would like to return to your home country?<br />Kayofly is in any case your right contact for your wishes around Tunisia. You have another desired destination? Kayofly also looks for you worldwide the cheapest flights, the most beautiful hotels and the best service around your trip.',
                de: 'Herzlich willkommen bei <strong>Kayofly</strong>! Wir sind ein Reisebüro mitten im Herzen von Berlin und spezialisiert auf Tunesien.<br />Möchten Sie gerne eine Reise nach Tunesien unternehmen, das Land kennenlernen oder einfach nur einen Traumurlaub erleben? Oder sind Sie selber Tunesier und würden gerne wieder in Ihre Heimat?<br />Kayofly ist in jedem Fall Ihr richtiger Ansprechpartner für Ihre Wünsche rund um Tunesien. Sie haben ein anderes Wunschziel? Kayofly sucht Ihnen auch weltweit die günstigsten Flüge, die schönsten Hotels und den besten Service rund um Ihre Reise.'
            },
            webshop: {
                en: 'Webshop',
                de: 'Webshop'
            },
            webshoplogin: {
                en: 'To the Webshop',
                de: 'Zum Webshop'
            }
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            language: {
                en: 'Language',
                de: 'Sprache'
            },
            agencylogin: {
                en: 'Agency Login',
                de: 'Agentur Login'
            },
            agencylogout: {
                en: 'Agency Logout',
                de: 'Agentur Logout'
            },
            userlogin: {
                en: 'Your Sundair Account',
                de: 'Ihr Sundair Konto'
            },
            userlogout: {
                en: 'Log out',
                de: 'Abmelden'
            },
            alertno: {
                en: 'No',
                de: 'Nein'
            },
            alertyes: {
                en: 'Yes',
                de: 'Ja'
            },
            dialogtitle: {
                en: 'Change Language?',
                de: 'Sprache ändern?'
            },
            dialogtext: {
                en: 'You want to change the language?',
                de: 'Sie wollen die Sprache ändern?'
            },
            dialogtitlelogout: {
                en: 'Log out?',
                de: 'Abmelden?'
            },
            dialogtextlogout: {
                en: 'You want to log out from your SUNDAIR Account?',
                de: 'Sie wollen sich von Ihrem SUNDAIR Konto abmelden?'
            },
            // >>> ------------------------------------
            user_email: null, // email in header of user
            // >>> ------------------------------------
            lang: 'de'
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedAgencyLoggedIn', 'get_Flag_Auth_UserLoggedIn', // is a User logged in?
    'get_authorizationUserdata' // get user date from ls
    ])), // eo  computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> shared/header/LanguageList.vue >>> created');
        __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$on('call_travelcenter_updateProfile_updatePasswordSuccess', this.onEmit_UpdatePasswordSuccess);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note: Check for Sundair User here.
    *
    */
    mounted: function mounted() {

        var me = this;

        me.$toc('>>> shared/header/LanguageList.vue >>> mounted');
        // >>> User in localStorage? ------------------
        if (this.get_authorizationUserdata !== null) {
            this.user_email = this.get_authorizationUserdata.email; // make visible
            this.actn_set_Flag_Auth_UserLoggedIn(true);
        }
    }, // eo function mounted()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> shared/header/LanguageList.vue >>> beforeDestroy');
        __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$off('call_travelcenter_updateProfile_updatePasswordSuccess', this.onEmit_UpdatePasswordSuccess);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_setCurrentLocale', 'actn_auth_logout', 'actn_set_Flag_Auth_UserLoggedIn']), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onClick_UserLogout()
        *
        * Desc:
        * Note: Step 1 of 2.
        *
        */
        onClick_UserLogout: function onClick_UserLogout() {

            var me = this;

            me.$toc('>>> shared/header/LanguageList.vue >>> onClick_UserLogout');
            this.wannaLogOutDialog();
        }, // eo function onClick_UserLogout()


        /*******************************************************************
        * onEmit_UpdatePasswordSuccess()
        *
        * Desc: React with Logout on Password Change.
        * Note:
        *
        */
        onEmit_UpdatePasswordSuccess: function onEmit_UpdatePasswordSuccess() {

            var me = this;

            me.$toc('>>> shared/header/LanguageList.vue >>> onClick_UserLogout');
            me.$modal.hide('dialoglogout');
            me.actn_auth_logout();
        }, // eo function onEmit_UpdatePasswordSuccess()


        /******************************************************************* 'Utilities - Common'
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * wannaLogOutDialog()
        *
        * Desc:
        * Note: Step 2 of 2.
        *
        */
        wannaLogOutDialog: function wannaLogOutDialog() {

            var me = this;

            me.$toc('>>> shared/header/LanguageList.vue >>> wannaLogOutDialog');
            this.$modal.show('dialog', {
                title: me.dialogtitlelogout[me.getCurrentLocale],
                text: me.dialogtextlogout[me.getCurrentLocale],
                buttons: [{
                    title: me.alertno[me.getCurrentLocale]
                }, {
                    title: me.alertyes[me.getCurrentLocale],
                    default: true,
                    handler: function handler() {
                        me.onEmit_UpdatePasswordSuccess(); // logout and hide
                    }
                }]
            });
        }, // eo function wannaLogOutDialog()

        /*******************************************************************
        * changeLanguage()
        *
        * Desc:
        * Note:
        *
        * @param {string} language ()
        */
        changeLanguage: function changeLanguage(language) {
            var _this = this;

            var me = this;

            me.$toc('>>> shared/header/LanguageList.vue >>> changeLanguage');
            this.$modal.show('dialog', {
                title: me.dialogtitle[me.getCurrentLocale],
                text: me.dialogtext[me.getCurrentLocale],
                buttons: [{
                    title: me.alertno[me.getCurrentLocale]
                }, {
                    title: me.alertyes[me.getCurrentLocale],
                    default: true,
                    handler: function handler() {
                        me.$modal.hide('dialog');
                        me.lang = language;
                        _this.$ls.set('lang', language); // localStorage

                        me.actn_setCurrentLocale(language);

                        setTimeout(function () {
                            me.$enableChaser(); // #800
                        }, 700);
                    }
                }]
            });
        } // eo function changeLanguage()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            // >>> ----------------
            language: {
                en: 'Language',
                de: 'Sprache'
            },
            // >>> ----------------
            agencylogin: {
                en: 'Agency Login',
                de: 'Agentur Login'
            },
            agencylogout: {
                en: 'Agency Logout',
                de: 'Agentur Logout'
            },
            // >>> ----------------
            booking: {
                en: 'Flight Booking',
                de: 'Flugbuchung'
            },
            services: {
                en: 'Seats and Services',
                de: 'Sitzplätze und Services'
            },
            rebooking: {
                en: 'Rebooking',
                de: 'Umbuchung'
            },
            mybookings: {
                en: 'My Bookings',
                de: 'Meine Buchungen'
            },
            flightplan: {
                en: 'Flight plan',
                de: 'Flugplan'
            },
            pressreleases: {
                en: 'Press Releases',
                de: 'Presse'
            },
            career: {
                en: 'Career',
                de: 'Karriere'
            },
            agency: {
                en: 'Agency',
                de: 'Agentur'
            },
            travelcenter: {
                en: 'My Travelcenter',
                de: 'Meine Reisezentrale'
            },
            flightstatus: {
                en: 'Flightstatus',
                de: 'Flugstatus'
            },
            webshop: {
                en: 'Webshop',
                de: 'Webshop'
            },
            // >>> ----------------
            dialogtitle: {
                en: 'Change Language?',
                de: 'Sprache ändern?'
            },
            dialogtext: {
                en: 'You want to change the language?',
                de: 'Sie wollen die Sprache ändern?'
            },
            alertno: {
                en: 'No',
                de: 'Nein'
            },
            alertyes: {
                en: 'Yes',
                de: 'Ja'
            },
            // >>> ------------------------------------
            currentUrl: '',
            lang: 'de'
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedAgencyLoggedIn'] // is Agency logged in?
    )), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note: Check for Agency here. If so ... show some Green.
    *
    */
    mounted: function mounted() {

        var me = this,
            localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username')),
            // catch
        localStorageAgencyPass = JSON.parse(localStorage.getItem('sdr__agency_password')); // catch


        // >>> Agency in localStorage? --------------
        if (localStorageAgencyUser !== null) {
            this.actn_FlagSharedAgencyLoggedIn(true);
        }
    }, // eo function mounted()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['actn_setCurrentLocale', 'actn_FlagSharedAgencyLoggedIn'] //
    ), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onClick_AgencyLogout()
        *
        * Desc:
        * Note:
        *
        * @param
        * @return
        */
        onClick_AgencyLogout: function onClick_AgencyLogout() {

            var me = this;

            me.$toc('>>> shared/header/NavbarMain.vue >>> onClick_AgencyLogout');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agency_username');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agency_password');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agency_object');
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].ls.remove('agencyAuthorizationHeader');

            this.actn_FlagSharedAgencyLoggedIn(false);
            me.$toasted.global.sdr_app_info({
                message: 'Agency was logged out.'
            });
        }, // eo funtion onClick_AgencyLogout()


        /******************************************************************* 'Utilities - Common'
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * changeLanguage()
        *
        * Desc:
        * Note:
        *
        * @param {string} language ()
        * @param
        * @return
        */
        changeLanguage: function changeLanguage(language) {
            var _this = this;

            var me = this;

            me.$toc('>>> shared/header/NavbarMain.vue >>> changeLanguage');
            this.$modal.show('dialog', {
                title: me.dialogtitle[me.getCurrentLocale],
                text: me.dialogtext[me.getCurrentLocale],
                buttons: [{
                    title: me.alertno[me.getCurrentLocale]
                }, {
                    title: me.alertyes[me.getCurrentLocale],
                    default: true,
                    handler: function handler() {
                        me.$modal.hide('dialog');
                        me.lang = language;
                        _this.$ls.set('lang', language); // localStorage

                        me.actn_setCurrentLocale(language);
                    }
                }]
            });
        }, // eo function changeLanguage()


        /*******************************************************************
        * getPathName()
        *
        * Desc:
        * Note:
        *
        * @param {string} pathname ()
        * @param
        * @return
        */
        getPathName: function getPathName(pathname) {

            var me = this,
                currentUrl = window.location.pathname,
                currentUrl = currentUrl.slice(1, -1);

            // me.$toc('>>> shared/header/LanguageList.vue >>> getPathName');
            if (pathname === currentUrl) {
                return true;
            } else {
                return false;
            }
        } // eo function getPathName()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_md5__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            language: {
                en: 'Language',
                de: 'Sprache'
            },
            // >>> ------------------------------------
            agency_login: '',
            agency_password: '',
            // >>> ------------------------------------
            lang: 'de'
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_Flag_Auth_UserLoggedIn'] // is user logged in?
    )), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_setCurrentLocale', 'actn_call_GetAgency'] // call:
    ), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc:
        * Note: Encrypt here (md5).
        *
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this;

            me.$toc('>>> shared/header/AgencyLogin.vue >>> onSubmit');
            // >>> Guard ------------------------------
            if (this.get_Flag_Auth_UserLoggedIn === true) {
                me.$toasted.global.sdr_app_error({
                    message: 'Login not possible. User is logged in.'
                });
                return;
            }

            // >>> Login ------------------------------
            if (this.agency_login !== '' && this.agency_password !== '') {
                this.actn_call_GetAgency({ username: this.agency_login, password: __WEBPACK_IMPORTED_MODULE_1_js_md5___default()(this.agency_password) });
            }
        } // eo function onSubmit()

    }) // eo methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            language: {
                en: 'Language',
                de: 'Sprache'
            },
            // >>> ------------------------------------
            hello: {
                en: 'Hello, welcome back to your Account',
                de: 'Hallo, willkommen zurück in Ihrem Account'
            },
            hello2: {
                en: 'Hello, create your new account',
                de: 'Hallo, erstellen Sie Ihren neuen Account'
            },
            hello3: {
                en: 'Hello, you have forgotten your password?',
                de: 'Hallo, Sie haben Ihr Passwort vergessen?'
            },
            sundairtravelcenter: {
                en: 'Sundair Travelcenter',
                de: 'Sundair Reisezentrale'
            },
            email: {
                en: 'EMail',
                de: 'E-Mail Adresse'
            },
            password: {
                en: 'Password',
                de: 'Passwort'
            },
            forgotpassword: {
                en: 'Forgot password?',
                de: 'Passwort vergessen?'
            },
            stillnoaccount: {
                en: "Don't have a Sundair account?",
                de: 'Sie haben noch kein Sundair Konto?'
            },
            signin: {
                en: "Sign in",
                de: 'Anmelden'
            },
            signup: {
                en: "Sign up",
                de: 'Registrieren'
            },
            resetpassword: {
                en: "Reset Password",
                de: 'Passwort zurücksetzen'
            },
            havealreadyanaccount: {
                en: "Already have a Sundair account?",
                de: 'Sie haben bereits ein Sundair Konto?'
            },
            putinemailadress: {
                en: "Enter your email address and we will send you a new password.",
                de: 'Geben Sie Ihre E-Mail Adresse ein und wir senden Ihnen ein neues Passwort.'
            },
            note: {
                en: "Note",
                de: 'Hinweis'
            },
            passwordwasreseted: {
                en: "Password has been reset. Check your e-mails.",
                de: 'Passwort wurde zurück gesetzt. Schauen Sie in Ihre E-Mails.'
            },
            emailwassent: {
                en: "An email has been sent to your email address.",
                de: 'Eine E-Mail wurde an Ihre E-Mail-Adresse gesendet.'
            },
            // >>> ------------------------------------
            errmsg_passwordorusernamemissing: {
                en: "Please fill in completely.",
                de: 'Bitte vollständig ausfüllen.'
            },
            // >>> ------------------------------------
            user_login_user: '',
            user_login_password: '',
            // >>> ------------------------------------
            user_signup_email: null,
            user_signup_password: null,
            // >>> ------------------------------------
            user_resetpassword_email: null,
            // >>> ------------------------------------
            lang: 'de'
        };
    }, // eo funtion data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedAgencyLoggedIn'] // is Agency logged in?'
    )), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> shared/header/SundairLogin.vue >>> created');
        __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$on('call_auth_passwordReset_success', this.onEmit_PasswordResetSuccess);
        __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$on('call_auth_userCreate_success', this.onEmit_CreateUserSuccess);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> shared/header/SundairLogin.vue >>> beforeDestroy');
        __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$off('call_auth_passwordReset_success', this.onEmit_PasswordResetSuccess);
        __WEBPACK_IMPORTED_MODULE_1__main__["eventBus"].$off('call_auth_userCreate_success', this.onEmit_CreateUserSuccess);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_setCurrentLocale', 'actn_call_auth_login', // call:
    'actn_call_auth_create', // call: signup
    'actn_call_auth_passwordReset'] // call:
    ), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit_Login()
        *
        * Desc: Login.
        * Note:
        *
        */
        onSubmit_Login: function onSubmit_Login(submitEvent) {

            var me = this;

            me.$toc('>>> shared/header/SundairLogin.vue >>> onSubmit_Login');
            // >>> Guard ------------------------------
            if (this.getFlagSharedAgencyLoggedIn === true) {
                me.$toasted.global.sdr_app_error({
                    message: 'Login not possible. Agency is logged in.'
                });
                return;
            }

            if (this.user_login_user !== '' && this.user_login_password !== '') {
                this.actn_call_auth_login({ email: this.user_login_user, password: this.user_login_password });
            } else {
                me.$toasted.global.sdr_app_error({ // #762
                    message: me.errmsg_passwordorusernamemissing[me.getCurrentLocale]
                });
            }
        }, // eof onSubmit_Login()


        /*******************************************************************
        * onSubmit_Signup()
        *
        * Desc: Sign up.
        * Note:
        *
        */
        onSubmit_Signup: function onSubmit_Signup() {

            var me = this;

            me.$toc('>>> shared/header/SundairLogin.vue >>> onSubmit_Signup');
            if (this.user_signup_email !== null && this.user_signup_password !== null) {
                this.actn_call_auth_create({ email: this.user_signup_email, password: this.user_signup_password });
            } else {
                me.$toasted.global.sdr_app_error({ // #762
                    message: me.errmsg_passwordorusernamemissing[me.getCurrentLocale]
                });
            }
        }, // eo function onSubmit_Signup()


        /*******************************************************************
        * onSubmit_ResetPassword()
        *
        * Desc: Reset Password.
        * Note:
        *
        */
        onSubmit_ResetPassword: function onSubmit_ResetPassword() {

            var me = this;

            me.$toc('>>> shared/header/SundairLogin.vue >>> onSubmit_ResetPassword');
            if (this.user_resetpassword_email !== null) {
                this.actn_call_auth_passwordReset({ email: this.user_resetpassword_email });
            }
        }, // eo function onSubmit_ResetPassword()


        /*******************************************************************
        * onEmit_PasswordResetSuccess()
        *
        * Desc:
        * Note:
        *
        */
        onEmit_PasswordResetSuccess: function onEmit_PasswordResetSuccess() {

            var me = this;

            me.$toc('>>> shared/header/SundairLogin.vue >>> onEmit_PasswordResetSuccess');
            me.$toasted.global.sdr_app_info({
                message: this.passwordwasreseted[this.getCurrentLocale]
            });

            tjq("#soap-popupbox")[0].style = 'display: none;'; // close little modal
        }, // eo function onEmit_PasswordResetSuccess()


        /*******************************************************************
        * onEmit_PasswordResetSuccess()
        *
        * Desc:
        * Note:
        *
        */
        onEmit_CreateUserSuccess: function onEmit_CreateUserSuccess() {

            var me = this;

            me.$toc('>>> shared/header/SundairLogin.vue >>> onEmit_CreateUserSuccess');
            me.$toasted.global.sdr_app_info({
                message: this.emailwassent[this.getCurrentLocale]
            });

            tjq("#soap-popupbox")[0].style = 'display: none;'; // close little modal
        } // eo function onEmit_CreateUserSuccess()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            booking: {
                en: 'Flight Booking',
                de: 'Flugbuchung'
            },
            services: {
                en: 'Seats and Services',
                de: 'Sitzplätze und Services'
            },
            rebooking: {
                en: 'Rebooking',
                de: 'Umbuchung'
            },
            mybookings: {
                en: 'My Bookings',
                de: 'Meine Buchungen'
            },
            flightplan: {
                en: 'Flight plan',
                de: 'Flugplan'
            },
            pressreleases: {
                en: 'Press releases',
                de: 'Pressemitteilungen'
            },
            career: {
                en: 'Career',
                de: 'Karriere'
            },
            agency: {
                en: 'Agency',
                de: 'Agentur'
            },
            travelcenter: {
                en: 'My Travelcenter',
                de: 'Meine Reisezentrale'
            },
            flightstatus: {
                en: 'Flightstatus',
                de: 'Flugstatus'
            },
            checkout: {
                en: 'Checkout',
                de: 'Checkout'
            },
            webshop: {
                en: 'Sundair Webshop',
                de: 'Sundair Webshop'
            },
            infos_luggage: {
                en: 'Lugagge',
                de: 'Gepäck'
            },
            infos_dangerous_goods: {
                en: 'Dangerous Goods',
                de: 'Gefährliche Güter'
            },
            infos_prohibited_items: {
                en: 'Prohibited Items',
                de: 'Verbotene Gegenstände'
            },
            infos_additional_services: {
                en: 'Additional Services',
                de: 'Zusatzleistungen'
            },
            infos_serviceonboard: {
                en: 'Service on board',
                de: 'Service an Board'
            },
            infos_seat_reservation: {
                en: 'Seat Reservation',
                de: 'Sitzplatzreservierung'
            },
            infos_fare_conditions: {
                en: 'Fare Conditions',
                de: 'Tarifbestimmungen'
            },
            infos_complaints: {
                en: 'Complaints',
                de: 'Reklamationen'
            },
            infos_group_booking: {
                en: 'Group Booking',
                de: 'Gruppenbuchung'
            },
            infos_covid19: {
                en: 'Covid19',
                de: 'Covid19'
            },
            infos_important_infos: {
                en: 'Important Informations',
                de: 'Wichtige Informationen'
            },
            infos_infoalert: {
                en: 'Info Alert',
                de: 'Informationsmeldung'
            },
            infos_info3g: {
                en: 'Info 3G Verification',
                de: 'Info 3G Nachweis'
            },
            // >>> ------------------------------------
            currentUrl: ''
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /******************************************************************* 'Utilities - Common'
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * getPathName()
        *
        * Desc:
        * Note:
        *
        * @param {string} pathname ()
        * @param
        * @return
        */
        getPathName: function getPathName(pathname) {

            var me = this,
                currentUrl = window.location.pathname,
                currentUrl = currentUrl.slice(1, -1);

            // me.$toc('>>> shared/header/LanguageList.vue >>> getPathName');
            if (pathname === currentUrl) {
                return true;
            } else {
                return false;
            }
        } // eof getPathName()

    } // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_flightsearch_FlightSearchTabs_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_flightsearch_FlightSearchResults_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__booking_pagecontent_KeyDestinations_vue__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__booking_pagecontent_FurtherServices_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__booking_pagecontent_PromoBoxSundairApp_vue__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // Entire Tabs Construct (shared)
 // Content

 // Sidebar (right)

 // Content
 // Content




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-shared-flightsearch-tabs': __WEBPACK_IMPORTED_MODULE_1__shared_flightsearch_FlightSearchTabs_vue__["a" /* default */],
        'sdr-shared-flightsearchresults': __WEBPACK_IMPORTED_MODULE_2__shared_flightsearch_FlightSearchResults_vue__["a" /* default */],

        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_3__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-keydestinations': __WEBPACK_IMPORTED_MODULE_4__booking_pagecontent_KeyDestinations_vue__["a" /* default */],
        'sdr-furtherserives': __WEBPACK_IMPORTED_MODULE_5__booking_pagecontent_FurtherServices_vue__["a" /* default */],
        'sdr-promobox-sundair-app': __WEBPACK_IMPORTED_MODULE_6__booking_pagecontent_PromoBoxSundairApp_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            alertmessage2: {
                en: 'Online check-in: Online check-in is not available at the moment. Please check in as usual at the counter.',
                de: 'Online Check-in: Ein Online Check-in steht im Moment nicht zur Verfügung. Bitte checken Sie wie gewohnt am Schalter ein.'
            },
            alertmessage3: {
                en: 'Currently, due to technical problems, payment by credit card is not possible. Bookings and payments by direct debit are still possible until 7 days before departure.',
                de: 'Aktuell ist aufgrund technischer Probleme keine Zahlung per Kreditkarte möglich. Buchungen und Zahlungen per Lastschrift sind weiterhin bis 7 Tage vor Abflug möglich.'
            },
            // >>> ---------------------------------------------------------
            modal_headline: {
                en: 'Attention: Strike in Bremen',
                de: 'Achtung: Streik in Bremen'
            },
            modal_content: {
                en: 'Dear passenger,<br /><br />due to the strike on 17.2.2023 your flight from/ to Bremen to/ from Fuerteventura will now operate from / to Lübeck at the following flight times:<br /><br />Local times<br />17.02.2023 SR3352 Lübeck from 8: 40 - Fuerteventura from 13: 05<br />17.02.2023 SR3353 Fuerteventura from 13: 55 - Lübeck to 19: 50<br /><br />A transfer to/from Lübeck will not be organized by Sundair, please travel on your own to/from Lübeck.',
                de: 'Sehr geehrter Passagier, <br /><br />aufgrund des Streiks am 17.2.2023 wird Ihr Flug ab/an Bremen nach/von Fuerteventura nunmehr ab/an Lübeck zu folgenden Flugzeiten operieren:<br /><br />Ortszeiten<br />17.02.2023 SR3352 Lübeck ab 8: 40 - Fuerteventura ab 13: 05<br />17.02.2023 SR3353 Fuerteventura ab 13: 55 - Lübeck an 19: 50<br /><br />Ein Transfer nach/von Lübeck wird durch Sundair nicht organisiert, bitte reisen Sie selbstständig an bzw. ab.'
            },
            closemodal: {
                en: 'Close',
                de: 'Schliessen'
            },
            // >>> ---------------------------------------------------------
            CONF_MOURNING: __WEBPACK_IMPORTED_MODULE_0__config_js__["c" /* CONF_MOURNING */]
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['getCurrentLocale'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note:
    * Note:
    *
    */
    mounted: function mounted() {

        var me = this;

        me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> mounted');
    }, // eo function mounted()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {} // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_flightsearch_FlightSearchTab_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_forms_BookingnoTab_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_forms_PackageToursTab_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_forms_SeatTab_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_forms_LuggageTab_vue__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_forms_RebookingTab_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_forms_HelpTab_vue__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Tab::'FlightSearch' (shared)
 // Tab::'Bookingno' (Services)
 // Tab::'PackageTours' (Booking)
 // Tab::'Seat' (Services)
 // Tab::'Luggage' (Booking)
 // Tab::'Rebooking' (Rebooking)
 // Tab::'Help' (Shared)



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-shared-flightsearch-tab': __WEBPACK_IMPORTED_MODULE_0__shared_flightsearch_FlightSearchTab_vue__["a" /* default */],
        'sdr-shared-packagetours-tab': __WEBPACK_IMPORTED_MODULE_2__shared_forms_PackageToursTab_vue__["a" /* default */],
        'sdr-shared-bookingno-tab': __WEBPACK_IMPORTED_MODULE_1__shared_forms_BookingnoTab_vue__["a" /* default */],
        'sdr-shared-seat-tab': __WEBPACK_IMPORTED_MODULE_3__shared_forms_SeatTab_vue__["a" /* default */],
        'sdr-shared-luggage-tab': __WEBPACK_IMPORTED_MODULE_4__shared_forms_LuggageTab_vue__["a" /* default */],
        'sdr-shared-rebooking-tab': __WEBPACK_IMPORTED_MODULE_5__shared_forms_RebookingTab_vue__["a" /* default */],
        'sdr-shared-help-tab': __WEBPACK_IMPORTED_MODULE_6__shared_forms_HelpTab_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            searchboxflights: {
                en: 'Flights',
                de: 'Flüge'
            },
            searchboxpackagetours: {
                en: 'Package tour',
                de: 'Pauschalreise'
            },

            searchboxflights_services: {
                en: 'Find your Flight',
                de: 'Ihren Flug finden'
            },
            searchboxbookingno_services: {
                en: 'Find your booking',
                de: 'Ihre Buchung finden'
            },
            searchboxseat: {
                en: 'Seats',
                de: 'Sitzplätze'
            },
            searchboxluggage: {
                en: 'Luggage',
                de: 'Gepäck'
            },
            searchboxrebooking: {
                en: 'Rebooking Flights',
                de: 'Flüge umbuchen'
            },
            searchboxhelp: {
                en: 'Help & Contact',
                de: 'Hilfe & Kontakt'
            }
            // currentLocale: 'de',
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eo computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var letterspaces = __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["helpers"].regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i); /* Validator */
var numericspaces = __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["helpers"].regex('numericspaces', /^[0-9+/\s]+$/i); /* Validator */
var lettersandnumbers = __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["helpers"].regex('lettersandnumbers', /^[A-Za-z0-9]+$/i); /* Validator */







/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            searchboxheadlineflighthelp: {
                en: 'Find Booking and add services',
                de: 'Buchung finden und Services hinzubuchen'
            },
            searchboxheadlineflights2: {
                en: 'Discover the world with SUNDAIR!',
                de: 'Entdecke die Welt mit SUNDAIR!'
            },

            hellotext1: {
                en: 'Create your own journey',
                de: 'Gestalten Sie Ihre Reise selbst'
            },
            hellotext2: {
                en: 'Here you can easily and conveniently add services for your already booked flight with your tour operator. To do so, please enter your booking number and the surname you gave when you made your booking.',
                de: 'Hier können Sie für Ihren bereits gebuchten Flug bei Ihrem Reiseveranstalter bequem und einfach Services hinzufügen. Dafür geben Sie bitte Ihre Buchungsnummer und Ihren Nachnamen, den Sie in der Buchung angegeben haben ein.'
            },
            hellotext3: {
                en: 'You will find your booking number in your booking confirmation from your tour operator.',
                de: 'Ihre Buchungsnummer finden Sie in Ihrer Buchungsbestätigung von Ihrem Reiseveranstalter.'
            },
            hellotext4: {
                en: 'We offer the following services:<br /><br /><ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;"><li>View your flights</li><li>Seat Reservation</li><li>Additional baggage (excess, special and sports baggage)</li><li>Premium Meals</li><li>Further services</li>',
                de: 'Wir bieten Ihnen folgende Services:<br /><br /><ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;"><li>Ihre Flüge einsehen</li><li>Sitzplatzreservierung</li><li>Zusätzliches Gepäck (Über-, Sonder- und Sportgepäck)</li><li>Premium Mahlzeiten</li><li>Weitere Serviceleistungen</li>'
            },
            checkboxtext: {
                en: 'I hereby confirm that I am authorised to manage this booking on behalf of other passengers or if I am the only passenger',
                de: 'Hiermit bestätige ich, dass ich berechtigt bin, diese Buchung im Namen anderer Passagiere zu verwalten oder wenn ich der einzige Passagier bin.'
            },
            // ----------------------------------
            when: {
                en: 'Your booking data',
                de: 'Ihre Buchungsdaten'
            },
            form_bookingno: {
                en: 'Your bookingno',
                de: 'Ihre Buchungsnummer'
            },
            form_surname: {
                en: 'Your surname',
                de: 'Ihr Familienname'
            },
            // ----------------------------------
            getbookinno: {
                en: 'FIND YOUR JOURNEY',
                de: 'IHRE REISE FINDEN'
            },
            // >>> --------------------------
            checkedBoxes: [],
            // >>> --------------------------
            input_bookingno: '', // 8C007307...., 2772630
            input_surname: '', // WIEMANN
            // >>> --------------------------
            errmsg_required: {
                en: 'This Field must not be empty.',
                de: 'Dieses Feld darf nicht leer sein.'
            },
            // >>> --------------------------
            errmsg_letterspaces: {
                en: 'Letters, "-" and spaces are allowed.',
                de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.'
            },
            errmsg_lettersandnumbers: {
                en: 'Letters and Numberss are allowed.',
                de: 'Erlaubt sind Buchstaben und Zahlen.'
            },
            // >>> --------------------------
            errmsg_min_bookingno: {
                en: 'Allowed length: 6-12 characters.',
                de: 'Erlaubte Länge: 6-12 Zeichen.'
            },
            errmsg_max_bookingno: {
                en: 'Allowed length: 6-12 characters.',
                de: 'Erlaubte Länge: 6-12 Zeichen.'
            },
            errmsg_min_surname: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            errmsg_max_surname: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            }
            // currentLocale: 'de',
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Validations */
    validations: {

        // >>> bookingno --------------------
        input_bookingno: {
            required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(12),
            lettersandnumbers: lettersandnumbers
        },
        input_surname: {
            required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(30),
            letterspaces: letterspaces
        }

    }, // eo validations{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getFlagServicesBookingnoLoginIsReadyForLogin', 'get_ServicesUsersSearchDataBookingno'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Watch */
    watch: {

        checkedBoxes: function checkedBoxes() {

            if (this.checkedBoxes.length === 1) {
                this.actn_FlagServicesBookingnoLoginIsReadyForLogin(true);
            } else {
                this.actn_FlagServicesBookingnoLoginIsReadyForLogin(false);
            }
        } // eo function checkedBoxes()

    }, // eo watch{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note: Catch Event 'readytopushpassengers' ('All Calls done ...').
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> shared/forms/BookingnoTab.vue >>> created');
        me.actn_set_stateReset('services');
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$on('readytoshoworiginalbooking', this.onEmit_ReadyToShowOriginalBooking);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note: Coming back from Payment? Then fill out again.
    * Note:
    *
    */
    mounted: function mounted() {

        if (this.get_ServicesUsersSearchDataBookingno !== null) {
            this.input_bookingno = this.get_ServicesUsersSearchDataBookingno.bookingCode;
            this.input_surname = this.get_ServicesUsersSearchDataBookingno.lastName;

            window.scrollTo(0, 0);
        }
    }, // eo function mounted()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> shared/forms/BookingnoTab.vue >>> beforeDestroy');
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$off('readytoshoworiginalbooking', this.onEmit_ReadyToShowOriginalBooking);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['actn_set_stateReset', // set:
    'actn_set_areWeInServicesBookingNoMode', // set:
    'actn_call_listOriginalBooking', // Call: 'get original booking'
    'actn_FlagSharedShowFlightSearchResults', // Control Flag
    'actn_FlagServicesShowBookingnoSearchResults', // Control Flag
    'actn_FlagServicesBookingnoLoginIsReadyForLogin', // Control Flag
    'actn_setServicesUsersSearchDataBookingno', // remember in state
    'actn_setServicesBookingnoSearchResults'] // remember in state
    ), {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/registration/overview/'
        *
        * Desc: Getting original Booking Data via Bookingno.
        * Note:
        * Note: Set 'Are we in 'Services Bookingno' Mode?
        * Note: New: Axios Call is here managed in VUEX.
        *
        */
        call_listOriginalBooking: function call_listOriginalBooking(params) {

            var me = this;

            me.$toc('>>> shared/forms/BookingnoTab.vue >>> call_listOriginalBooking');
            this.actn_set_stateReset('services'); // state reset
            this.actn_set_areWeInServicesBookingNoMode(true); // from here on ... 'we are in services bookinno mode'

            this.actn_call_listOriginalBooking(params); // Call
        }, // eo function call_listOriginalBooking()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: 'Overview Form' gets (not really) submitted.
        * Note:
        *
        * @param {Object} submitEvent (Event)
        * @return
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                myBookingnoParams = {};

            me.$toc('>>> shared/forms/BookingnoTab.vue >>> onSubmit');
            myBookingnoParams.bookingCode = this.input_bookingno.toUpperCase();
            myBookingnoParams.lastName = this.input_surname.toUpperCase();

            me.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
            me.actn_FlagServicesShowBookingnoSearchResults(false); // Hide 'Section'

            this.actn_setServicesUsersSearchDataBookingno(myBookingnoParams); // remember in state

            this.call_listOriginalBooking(myBookingnoParams);
        }, // eo function onSubmit()


        /******************************************************************* 'Listeners - eventBus'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onEmit_ReadyToShowOriginalBooking()
        *
        * Desc: Handle
        * Note:
        *
        */
        onEmit_ReadyToShowOriginalBooking: function onEmit_ReadyToShowOriginalBooking() {

            var me = this,
                options = {};

            me.$toc('>>> shared/forms/BookingnoTab.vue >>> onEmit_ReadyToShowOriginalBooking');
            // >>> Scroll Options ------------------------------------------
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Showing/Scrolling ---------------------------------------
            me.actn_FlagServicesShowBookingnoSearchResults(true); // Show 'Section'
            setTimeout(function () {
                me.$scrollTo('#contentElementBookingno', 200, options);
            }, 300);
        }, // eo function onEmit_ReadyToShowOriginalBooking()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * checkValidity()
        *
        * Desc:
        * Note:
        *
        * @param
        * @return {Array}
        */
        checkValidity: function checkValidity() {

            var me = this,
                formIsValid = false;

            me.$toc('>>> shared/forms/BookingnoTab.vue >>> checkValidity');
            if (this.input_bookingno !== '') {
                if (!me.$v.input_bookingno.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            } else {
                formIsValid = false;
            }

            if (formIsValid === true) {
                if (this.input_surname !== '') {
                    if (!me.$v.input_surname.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                } else {
                    formIsValid = false;
                }
            }

            // Last Check: Checkbox -------------------
            if (formIsValid === true) {
                if (this.getFlagServicesBookingnoLoginIsReadyForLogin === true) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }

            return formIsValid;
        } // eo function checkValidity()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            searchboxheadlineflighthelp: {
                en: 'Package tour',
                de: 'Pauschalreise'
            },
            searchboxheadlineflights2: {
                en: 'in cooperation with schauinsland-reisen',
                de: 'in Kooperation mit schauinsland-reisen'
            },
            infotexttitle: {
                de: 'Pauschalreisen suchen und buchen? Kein Problem!',
                en: 'Search and book package tours? No problem!'
            },
            infotext: {
                de: 'Nach der Auswahl Ihres gewünschten Zielgebietes werden Sie zu unserem Partner schauinsland-reisen weitergeleitet und können dort Ihre Wunschreise buchen.',
                en: 'After selecting your desired destination, you will be redirected to our Partner schauinsland-reisen where you can book your desired trip.'
            },

            // ----------------------------------
            where: {
                en: 'Where',
                de: 'Wohin'
            },
            yourplaceofdeparture: {
                en: 'YOUR DEPARTURE',
                de: 'IHR ABFLUGSORT'
            },
            yourplaceofdestination: {
                en: 'YOUR DESTINATION',
                de: 'IHR ZIELORT'
            },
            departureairport: {
                en: 'Please choose your departure airport',
                de: 'Wählen Sie Ihren Startflughafen'
            },
            destinationairport: {
                en: 'Please choose your destination airport',
                de: 'Wählen Sie Ihren Zielflughafen'
            },
            // ----------------------------------
            when: {
                en: 'When',
                de: 'Wann'
            },
            departuredate: {
                en: 'Earliest date of departure',
                de: 'Frühste Hinreise'
            },
            returndate: {
                en: 'Latest date of return',
                de: 'Späteste Rückreise'
            },
            traveltimefrom: {
                en: 'Travel time from',
                de: 'Reisedauer ab'
            },
            traveltimeto: {
                en: 'Travel time to',
                de: 'Reisedauer bis'
            },
            // ----------------------------------
            who: {
                en: 'Who',
                de: 'Wer'
            },
            adult: {
                en: 'Adults',
                de: 'Erwachsene'
            },
            adultyears: {
                en: '(From 12+ Years)',
                de: '(Ab 12+ Jahre)'
            },
            child: {
                en: 'Children',
                de: 'Kinder'
            },
            childyears: {
                en: '(2 to 12 Years)',
                de: '(2 bis 12 Jahre)'
            },
            infant: {
                en: 'Infants',
                de: 'Kleinkinder'
            },
            infantyears: {
                en: '(Up to 2 Years)',
                de: '(Bis 2 Jahre)'
            },
            // ----------------------------------
            findflights: {
                en: 'FIND PACKAGE TOUR',
                de: 'PAUSCHALREISE FINDEN'
            },
            // >>> --------------------------
            nodestinationfound: {
                en: 'We cannot offer package tours for this route.',
                de: 'Für diese Strecke können wir Ihnen keine Pauschalreisen anbieten.'
            },
            // currentLocale: 'de',
            // >>> ---------------------------------------------------------
            // >>> ---------------------------------------------------------
            airportsOriginsTours: [],
            airportsDestinationsTours: [],
            departuresLoadedTours: false,
            destinationsLoadedTours: false, // Des Aiports loaded?

            desArprtCodeTours: '', // model, new select Field
            depArprtCodeTours: '', // model, new sselect Field

            outwardonly: false, // ReturnFlight too?
            today: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(2, 'days').format('DD.MM.YYYY'),
            tommorow: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(62, 'days').format('DD.MM.YYYY'),

            listOfPaxes: { 0: '0', 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8' },
            noADT: 1
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> shared/forms/PackageToursTab.vue >>> created');
        this.call_listAirportsOrigines();
    }, // eo function created()

    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc: Initialize Select Fields.
    * Note:
    *
    */
    mounted: function mounted() {

        var me = this;

        me.$toc('>>> shared/forms/PackageToursTab.vue >>> mounted');
        me.$selectInits('booking', this.getCurrentLocale);
    }, // eo function mounted()

    /***********************************************************************
    * Lifecyclehook::updated
    *
    * Desc:
    * Note:
    *
    */
    updated: function updated() {

        var me = this;

        me.$toc('>>> shared/forms/PackageToursTab.vue >>> updated');
        me.$selectInits('booking', this.getCurrentLocale);
    }, // eo function updated()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/booking/origines'
        * Call::'/registration/destinations/ZRH'
        *
        * Desc: Getting Airports - Origines ('listAirports').
        * Note:
        *
        */
        call_listAirportsOrigines: function call_listAirportsOrigines() {

            var me = this,
                hdrs = '',
                url = '/booking/origines/';

            me.$toc('>>> shared/forms/PackageToursTab.vue >>> call_listAirportsOrigines');
            // >>> Send Ajax Request ---------------------------------------
            // me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
                // 'OK'
                // me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.airportsOriginsTours = response.data.originesRS.dep;
                        me.airportsOriginsTours.sort(function (a, b) {
                            return a.l > b.l ? 1 : b.l > a.l ? -1 : 0;
                        });
                        me.departuresLoadedTours = true;
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                // me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo funtion call_listAirportsOrigines()


        /*******************************************************************
        * Call::'/booking/destinations/ZRH'
        * Call::'/registration/destinations/ZRH'
        *
        * Desc: Getting Airports - Destinations ('listAirports').
        * Note:
        *
        */
        call_listAirportsDestinations: function call_listAirportsDestinations(event) {

            var me = this,
                hdrs = '',
                url = '/booking/destinations/';

            me.$toc('>>> shared/forms/PackageToursTab.vue >>> call_listAirportsOrigines');
            this.desArprtCodeTours = ''; // reset model
            // this.onChange_FlightsSearchForm(); // reset

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url + event.i).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.airportsDestinationsTours = response.data.destinationsRS.des;
                        me.airportsDestinationsTours.sort(function (a, b) {
                            return a.l > b.l ? 1 : b.l > a.l ? -1 : 0;
                        });
                        me.destinationsLoadedTours = true;
                        break;
                    default:
                        // 'ERROR'
                        // me.$toc('I am in Header Error');
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo funtion call_listAirportsDestinations()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: SearchForm gets submitted.
        * Note: https://www.schauinsland-reisen.de/search?destination=PMI&
        * Note: date=14082020|21082020&duration=5|7&
        * NOte: travellers=01011988|01011988|13092014&departure=KSF&airline=SR';
        *
        */
        onSubmit: function onSubmit(submitEvent) {
            var _this = this;

            var me = this,
                listOfDestinations = [{ key: 'PMI', des: 'mallorca' }, { key: 'FUE', des: 'fuerteventura' }, { key: 'LPA', des: 'gran_canaria' }, { key: 'TFS', des: 'teneriffa' }, { key: 'CFU', des: 'korfu' }, { key: 'HER', des: 'kreta' }, { key: 'KGS', des: 'kos' }, { key: 'RHO', des: 'rhodos' }, { key: 'BOJ', des: 'burgas' }, { key: 'VAR', des: 'bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar' }, { key: 'AYT', des: 'antalya_belek' }, { key: 'HRG', des: 'hurghada' }, { key: 'BEY', des: 'beirut' }, { key: 'BWK', des: 'kroatien_insel_brac' }, { key: 'DJE', des: 'tunesien_insel_djerba' }, { key: 'ACE', des: 'lanzarote' }, { key: 'LCA', des: 'zypern' }],
                url = '',
                destination = null,
                // PMI
            dateFrom = null,
                // 14082020|21082020
            dateTo = null,
                // 14082020|21082020
            tmp1 = null,
                tmp2 = null,
                start = null,
                end = null,
                duration = null,
                // 5 (days)
            traveltimeFrom = this.$refs.traveltimeFrom.value,
                traveltimeTo = this.$refs.traveltimeTo.value,
                travellers = '',
                // 01011988|01011988|13092014
            noADT = this.$refs.noADT_Tours.value,
                // this.noADT,
            noCHD = this.$refs.noCHD_Tours.value,
                // this.noCHD,
            noINF = this.$refs.noINF_Tours.value,
                // this.noINF,
            birthDateADT = null,
                birthDateCHD = null,
                birthDateINF = null,
                departure = null,
                // KSF
            baseUrl = 'https://www.schauinsland-reisen.de/search?';

            me.$toc('>>> shared/forms/PackageToursTab.vue >>> onSubmit');
            departure = this.depArprtCodeTours.i;

            destination = listOfDestinations.find(function (item) {
                return item.key === _this.desArprtCodeTours.i;
            });
            if (destination === undefined) {
                me.$toasted.global.sdr_app_error({
                    message: this.nodestinationfound[this.getCurrentLocale]
                });
                return;
            }

            destination = destination.des;

            // >>> -------------------------------------------------------- // 'date'
            dateFrom = submitEvent.target.elements.date_from.value.split('.').join("");
            dateTo = submitEvent.target.elements.date_to.value.split('.').join("");

            // >>> -------------------------------------------------------- // 'duration'
            tmp1 = submitEvent.target.elements.date_from.value.split('.');
            tmp2 = submitEvent.target.elements.date_to.value.split('.');
            start = tmp1[2] + '' + tmp1[1] + '' + tmp1[0]; // new: date format change @slr
            end = tmp2[2] + '' + tmp2[1] + '' + tmp2[0]; // new: date format change @slr
            // duration = moment.duration(end.diff(start)).asDays();
            duration = this.$refs.traveltimeFrom.value + '|' + this.$refs.traveltimeTo.value;

            // >>> -------------------------------------------------------- // 'travellers'
            birthDateADT = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateFrom, 'DD.MM.YYYY').subtract(20, 'years').format('DD.MM.YYYY').split('.').join("");
            for (var i = 0; i < noADT; i++) {
                travellers += birthDateADT + '|';
            }
            if (noCHD === 0) {
                travellers = travellers.substring(0, travellers.length - 1); // del last char
            }

            birthDateCHD = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateFrom, 'DD.MM.YYYY').subtract(5, 'years').format('DD.MM.YYYY').split('.').join("");
            for (var i = 0; i < noCHD; i++) {
                travellers += birthDateCHD + '|';
            }
            if (noINF === 0) {
                travellers = travellers.substring(0, travellers.length - 1); // del last char
            }

            birthDateINF = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateFrom, 'DD.MM.YYYY').subtract(1, 'years').format('DD.MM.YYYY').split('.').join("");
            for (var i = 0; i < noINF; i++) {
                travellers += birthDateINF + '|';
            }
            travellers = travellers.substring(0, travellers.length - 1); // del last char


            // >>> -------------------------------------------------------- // concenate
            url += 'destination=' + destination + '&';
            url += 'date=' + start + '-' + end + '&'; // OK
            url += 'duration=' + duration + '&'; // OK
            url += 'travellers=' + travellers + '&'; // OK
            url += 'departure=' + departure + '&';
            url += 'airline=SR'; // OK

            window.open(baseUrl + url, "_blank");
        } // eof onSubmit()

    } // eo  methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var letterspaces = __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["helpers"].regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i); /* Validator */
var numericspaces = __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["helpers"].regex('numericspaces', /^[0-9+/\s]+$/i); /* Validator */
var lettersandnumbers = __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["helpers"].regex('lettersandnumbers', /^[A-Za-z0-9]+$/i); /* Validator */







/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            searchboxheadlinerebooking: {
                en: 'Find booking and rebook flights',
                de: 'Buchung finden und Flüge umbuchen'
            },
            searchboxheadlineflights2: {
                en: 'Discover the world with SUNDAIR!',
                de: 'Entdecke die Welt mit SUNDAIR!'
            },
            hellotext1: {
                en: 'Rebook your flights',
                de: 'Buchen Sie Ihre Flüge um'
            },
            hellotext2: {
                en: 'Here you can rebook your already booked flight comfortably and easily until 24 hours before departure. Please enter your booking number and your date of birth.',
                de: 'Hier können Sie Ihren bereits gebuchten Flug bequem und einfach bis 24 Stunden vor Abflug umbuchen. Bitte geben Sie dafür Ihre Buchungsnummer und Ihr Geburtsdatum ein.'
            },
            hellotext3: {
                en: 'Note: A rebooking is only possible if you have booked the flights directly with SUNDAIR. If you have booked with us but through a tour operator, please contact your tour operator.',
                de: '<b>Hinweis</b>: Eine Umbuchung ist nur möglich, wenn Sie die Flüge direkt bei SUNDAIR gebucht haben. Sollten Sie mit uns fliegen, aber über einen Reiseveranstalter gebucht haben, wenden Sie sich bitte an Ihren Reiseveranstalter.'
            },
            checkboxtext: {
                en: 'I hereby confirm that I am authorised to manage this booking on behalf of other passengers or if I am the only passenger',
                de: 'Hiermit bestätige ich, dass ich berechtigt bin, diese Buchung im Namen anderer Passagiere zu verwalten oder wenn ich der einzige Passagier bin.'
            },
            // ----------------------------------
            when: {
                en: 'Your booking data',
                de: 'Ihre Buchungsdaten'
            },
            form_bookingno: {
                en: 'Your bookingcode',
                de: 'Ihr Buchungscode'
            },
            form_birthdate: {
                en: 'Your birthdate',
                de: 'Ihr Geburtsdatum'
            },
            // ----------------------------------
            getbookinno: {
                en: 'REBOOK YOUR FLIGHTS',
                de: 'IHRE FLÜGE UMBUCHEN'
            },
            // >>> --------------------------
            checkedBoxes: [],
            // >>> --------------------------
            // input_bookingno: 'JTGQJG23',
            // input_birthdate: moment('01.01.2000', "DD.MM.YYYY").format('DD.MM.YYYY'),
            input_bookingno: '',
            input_birthdate: '',
            // >>> --------------------------
            errmsg_required: {
                en: 'This Field must not be empty.',
                de: 'Dieses Feld darf nicht leer sein.'
            },
            // >>> --------------------------
            errmsg_letterspaces: {
                en: 'Letters, "-" and spaces are allowed.',
                de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.'
            },
            errmsg_lettersandnumbers: {
                en: 'Letters and Numberss are allowed.',
                de: 'Erlaubt sind Buchstaben und Zahlen.'
            },
            // >>> --------------------------
            errmsg_min_bookingno: {
                en: 'Allowed length: 6-12 characters.',
                de: 'Erlaubte Länge: 6-12 Zeichen.'
            },
            errmsg_max_bookingno: {
                en: 'Allowed length: 6-12 characters.',
                de: 'Erlaubte Länge: 6-12 Zeichen.'
            },
            errmsg_min_birthdate: {
                en: 'Allowed length: 10 characters.',
                de: 'Erlaubte Länge: 10 Zeichen.'
            },
            errmsg_max_birthdate: {
                en: 'Allowed length: 10 characters.',
                de: 'Erlaubte Länge: 10 Zeichen.'
            }
            // >>> --------------------------
            // currentLocale: 'de',
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Validations */
    validations: {

        input_bookingno: {
            required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(12),
            lettersandnumbers: lettersandnumbers
        },
        input_birthdate: {
            required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(10),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(10)
        }

    }, // eo validations{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_FlagRebookingBookingnoLoginIsReadyForLogin'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Watch */
    watch: {

        checkedBoxes: function checkedBoxes() {

            if (this.checkedBoxes.length === 1) {
                this.actn_FlagRebookingBookingnoLoginIsReadyForLogin(true);
            } else {
                this.actn_FlagRebookingBookingnoLoginIsReadyForLogin(false);
            }
        } // eo function checkedBoxes()

    }, // eo watch{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note: Catch Event 'readytoshowbookingforrebooking'.
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> shared/forms/BookingnoTab.vue >>> created');
        me.actn_set_stateReset('rebooking');
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$on('readytoshowbookingforrebooking', this.onEmit_ReadyToShowBookingForRebooking);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> shared/forms/BookingnoTab.vue >>> beforeDestroy');
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$off('readytoshowbookingforrebooking', this.onEmit_ReadyToShowBookingForRebooking);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['actn_FlagRebookingBookingnoLoginIsReadyForLogin', // Control Flag
    'actn_set_stateReset', 'actn_FlagSharedShowFlightSearchResults', // Control Flag (Hide 'Section')
    'actn_FlagRebookingShowBookingnoSearchResults', // Control Flag (Hide 'Section')
    'actn_setRebookingUsersSearchDataBookingno', // remember in state
    'actn_call_rebookingGetBooking'] // Call:
    ), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: 'Bookingno Rebooking Form' gets (not really) submitted.
        * Note:
        *
        * @param {Object} submitEvent (Event)
        * @return
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                input_birthdate = submitEvent.target.elements.input_birthdate.value.split('.'),
                myBookingnoParams = {};

            me.$toc('>>> shared/forms/BookingnoTab.vue >>> onSubmit');
            myBookingnoParams.bookingCode = this.input_bookingno.toUpperCase();
            myBookingnoParams.paxBirthDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(input_birthdate[2] + '-' + input_birthdate[1] + '-' + input_birthdate[0]).format('YYYY-MM-DDT00:00:ss+0000'); // this.input_birthdate.toUpperCase(); // 1994-01-01T12:20:00
            myBookingnoParams.email = null;
            myBookingnoParams.idCarrier = null;
            myBookingnoParams.idInvoice = null;
            myBookingnoParams.justIdInvoice = false;
            myBookingnoParams.lastName = null;
            myBookingnoParams.modify = false;
            myBookingnoParams.operatorBooking = null;

            me.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
            me.actn_FlagRebookingShowBookingnoSearchResults(false); // Hide 'Section'
            this.actn_setRebookingUsersSearchDataBookingno(myBookingnoParams); // remember in state

            this.actn_call_rebookingGetBooking(myBookingnoParams);
        }, // eo function onSubmit()


        /******************************************************************* 'Listeners - eventBus'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onEmit_ReadyToShowBookingForRebooking()
        *
        * Desc:
        * Note:
        *
        */
        onEmit_ReadyToShowBookingForRebooking: function onEmit_ReadyToShowBookingForRebooking() {

            var me = this,
                options = {};

            me.$toc('>>> shared/forms/BookingnoTab.vue >>> onEmit_ReadyToShowOriginalBooking');
            // >>> Scroll Options ------------------------------------------
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Showing/Scrolliing --------------------------------------
            me.actn_FlagRebookingShowBookingnoSearchResults(true); // Show 'Section'
            setTimeout(function () {
                me.$scrollTo('#contentElementRebookingBookingno', 200, options);
            }, 300);
        }, // eo function onEmit_ReadyToShowBookingForRebooking()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * checkValidity()
        *
        * Desc:
        * Note:
        *
        * @param
        * @return {Array}
        */
        checkValidity: function checkValidity() {

            var me = this,
                formIsValid = false;

            me.$toc('>>> shared/forms/BookingnoTab.vue >>> checkValidity');
            // Last Check: Inputs ---------------------
            if (this.input_bookingno !== '') {
                if (!me.$v.input_bookingno.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            } else {
                formIsValid = false;
            }

            if (formIsValid === true) {
                if (this.input_birthdate !== '') {
                    if (!me.$v.input_birthdate.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                } else {
                    formIsValid = false;
                }
            }

            // Last Check: Checkbox -------------------
            if (formIsValid === true) {
                if (this.get_FlagRebookingBookingnoLoginIsReadyForLogin === true) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }

            return formIsValid;
        } // eo function checkValidity()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_charts_KeyDestinationsBarChart_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-shared-keydestinations-bar-charts': __WEBPACK_IMPORTED_MODULE_0__shared_charts_KeyDestinationsBarChart_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            noADT: { "k": 1, "v": "1" },
            noCHD: { "k": 0, "v": "0" },
            noINF: { "k": 0, "v": "0" },
            // >>> --------------------------

            adult: {
                en: 'Adult (from 12+)',
                de: 'Erw. (ab 12+)'
            },
            child: {
                en: 'Child (2-12)',
                de: 'Kind (2-12)'
            },
            infant: {
                en: 'Infant (up to 2)',
                de: 'Baby (bis 2)'
            },
            // >>> --------------------------
            rememberClickedMonth: null,
            // >>> --------------------------
            headlinecontent: {
                en: 'Our most beautiful destinations - Search for best prices',
                de: 'Unsere schönsten Reiseziele - Suche nach besten Preisen'
            },
            headlinecontent_flightplan: {
                en: 'Discover our best destinations - Directly on the map',
                de: 'Entdecken Sie unsere besten Reiseziele - Direkt auf der Karte'
            },
            // >>> --------------------------
            fromDes: {
                en: 'from (Airport)',
                de: 'von (Flughafen)'
            },
            destination: {
                en: 'to (Country)',
                de: 'nach (Land)'
            },
            mydate: {
                en: 'Time period',
                de: 'Zeitraum'
            },
            next6months: {
                en: 'Next 6 Months',
                de: 'Nächsten 6 Monate'
            },
            from: {
                en: 'already from',
                de: 'schon ab'
            },
            click: {
                en: 'click',
                de: 'klick'
            },
            from2: {
                en: 'Best Price',
                de: 'Bester Preis'
            },
            flights: {
                en: 'Flights',
                de: 'Flüge'
            },
            packagetours: {
                en: 'Holidays',
                de: 'Pauschalsuche'
            },
            offers: {
                en: 'Destination',
                de: 'Reiseziel'
            },
            offers2: {
                en: 'schauinsland-reisen',
                de: 'schauinsland-reisen'
            },
            nooffers: {
                en: 'No Offer',
                de: 'Kein Angebot'
            },
            here: {
                en: 'Here',
                de: 'Hier'
            },
            reset: {
                en: 'Reset Pricesearch',
                de: 'Reset Preissuche'
            },
            clicktoseebestprices: {
                en: 'Click here for best prices!',
                de: 'Klicke hier für Beste Preise!'
            },
            // >>> --------------------------
            spain: {
                en: 'Spain',
                de: 'Spanien'
            },
            greece: {
                en: 'Greece',
                de: 'Griechenland'
            },
            bulgary: {
                en: 'Bulgary',
                de: 'Bulgarien'
            },
            turkey: {
                en: 'Turkey',
                de: 'Türkei'
            },
            hungary: {
                en: 'Hungary',
                de: 'Ungarn'
            },
            egypt: {
                en: 'Egypt',
                de: 'Ägypten'
            },
            nextmonths: {
                en: 'Your Destination',
                de: 'Ihr Reiseziel'
            },
            // >>> --------------------------
            destinationwasclicked: {
                en: 'Selected!',
                de: 'Gewählt!'
            },
            departureairport: {
                en: 'Please choose your departure airport',
                de: 'Wählen Sie Ihren Startflughafen'
            },
            // >>> --------------------------
            findflights: {
                en: 'FIND BEST PRICE AND FLIGHTS IN MONTH',
                de: 'FINDE BESTEN PREIS UND FLÜGE IM MONAT'
            },
            // >>> --------------------------
            bestprice: {
                en: 'Best Price of the Month: ',
                de: 'Bester Preis des Monat: '
            },
            // >>> --------------------------
            bestprices6months: {
                en: 'Our best Prices in the next 6 Month (Click)',
                de: 'Unsere besten Preise der nächsten 6 Monate (Klick)'
            },
            // >>> --------------------------
            tomanypeople: {
                en: 'Please use our group booking form for flight bookings of 11 or more passengers or contact customer service.',
                de: 'Bitte nutzen Sie bei einer Flugbuchung ab 11 Passagiere unser Gruppenbuchungsformular oder wenden Sie sich an den Kundenservice.'
            },
            // >>> --------------------------
            airportsOriginsKeyDes: [],
            airportsDestinationsKeyDes: [],
            departuresKeyDesLoaded: false,
            destinationsKeyDesLoaded: false, // Des Aiports loaded?
            depArprtCodeKeyDes: '', // model, new select Field
            // >>> --------------------------
            choosenStartAirport: '',
            // >>> --------------------------
            fakeCounter: 0,
            // >>> -------------------------- Props for BarChart Component
            prevChartData: [],
            barchartsOptions: {
                responsive: true,
                maintainAspectRatio: false,
                onClick: this.onClick_BarChart,
                tooltips: {
                    displayColors: false,
                    titleFontSize: 15,
                    bodyFontSize: 14,
                    backgroundColor: '#ec008b',
                    callbacks: {
                        label: function label(tooltipItem, data) {
                            var me = this,
                                k,
                                p;

                            k = (Math.round(tooltipItem.yLabel * 100) / 100).toString();
                            k += k.indexOf('.') == -1 ? '.00' : '00';
                            p = k.indexOf('.');

                            return 'Best Price of Month: ' + k.substring(0, p) + '.' + k.substring(p + 1, p + 3) + '€';
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            fontSize: 14,
                            fontColor: '#ec008b',
                            callback: function callback(value, index, values) {
                                return value + '€';
                            }
                        }
                    }],
                    xAxes: [{
                        ticks: {
                            fontSize: 14,
                            fontColor: '#ec008b'
                        },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                legend: {
                    labels: {
                        fontSize: 16,
                        fontColor: '#ec008b'
                    },
                    onClick: function onClick(e) {
                        e.stopPropagation();
                    }
                }
            },
            // >>> --------------------------
            componentKey: 0
            // >>> --------------------------
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedShowFlightSearchResults', 'getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel', 'getOffers', 'getOffersSelectedDestination', 'getBookingDeparturesKeyDes', // call: results
    'getListOfPaxes', 'getBookingOffersListFlightsMonthlyOffers', // call: results
    'getBookingOffersFlightIdViaMonth', // get: Offers FlightId via clicked Months
    'getBookingOffersChoosenFlightByUser'] // get: Get chosen Floight by User
    )), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> created');
        if (this.modulo === 'booking') {
            me.actn_call_Offers();
        }
    }, // eo function created()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['actn_call_Offers', // call:
    'actn_call_DeparturesKeyDes', // call:
    'actn_call_ListFlightsMonthlyOffers', // call:
    'actn_call_ListFlightsAfterUserSelectedBestPrice', // call:
    'actn_setBookingOffersSelectedDestination', // set: user selected destination
    'actn_setBookingOffersListFlightsMonthlyOffers', 'actn_setBookingOffersChoosenFlightByUser', 'actn_FlagSharedShowFlightSearchResults', 'actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel', 'actn_FlagServicesShowBookingnoSearchResults', 'actn_setBookingAirports', 'actn_setBookingUsersSearchData', 'actn_set_areWeInServicesBookingNoMode']), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onClick_Destination()
        *
        * Desc: KeyDestination was selected/clicked.
        * Note: 'Get Dep Airports' for clicked KeyDes Call here.
        * Note: Reset Dep Aiprt here.
        *
        * @param {String} des (e.g.: 'FUE')
        */
        onClick_Destination: function onClick_Destination(des) {

            var me = this,
                destinationObject = {};

            me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_Destination');
            this.depArprtCodeKeyDes = ''; // reset model
            this.actn_setBookingOffersListFlightsMonthlyOffers([]); // reset
            this.actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel(true);
            this.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
            this.choosenStartAirport = '';
            this.noADT = { "k": 1, "v": "1" };
            this.noCHD = { "k": 0, "v": "0" };
            this.noINF = { "k": 0, "v": "0" };

            if (this.modulo !== 'flightplan') {
                destinationObject = me.getOffers.find(function (offer) {
                    return offer.destinationOfferAptCode === des;
                });
                if (destinationObject !== undefined) {
                    destinationObject = destinationObject;

                    this.actn_setBookingOffersSelectedDestination(destinationObject);
                    this.actn_call_DeparturesKeyDes(destinationObject);
                }
            }
        }, // eo function onClick_Destination()


        /*******************************************************************
        * onSelect_DepartureAirportKeyDes()
        *
        * Desc: KeyDestinations Departure Airport was selected.
        * Note: 'Get 6 Months Offer' KeyDes Combination Call here.
        *
        */
        onSelect_DepartureAirportKeyDes: function onSelect_DepartureAirportKeyDes() {

            var me = this,
                requestParamObject = {};

            me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onSelect_DepartureAirportKeyDes');
            if (this.depArprtCodeKeyDes !== '') {
                // >>> 1. Reset --------------------------------------------
                this.actn_setBookingOffersChoosenFlightByUser(null); // reset

                // >>> 1a. To many Pax -------------------------------------
                if (+this.noADT.k + +this.noCHD.k + +this.noINF.k > 10) {
                    me.$toasted.global.sdr_app_error({
                        message: this.tomanypeople[this.getCurrentLocale]
                    });
                    return;
                }

                // >>> 2. Builds Object ------------------------------------
                requestParamObject = {
                    depArprtCode: this.depArprtCodeKeyDes.i, // submitEvent.target.elements.depArprtCode.value,
                    desArprtCode: this.getOffersSelectedDestination.destinationOfferAptCode, // submitEvent.target.elements.desArprtCode.value,
                    noADT: this.noADT.k,
                    noCHD: this.noCHD.k,
                    noINF: this.noINF.k,
                    ojArprtCode: '', // not clear
                    ojType: '', // not clear
                    depAfter: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DDTHH:mm:ss+0000'),
                    // depBefore: moment().add(5, 'months').format('YYYY-MM-DDTHH:mm:ss+0000'),
                    retAfter: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(5, 'months').format('YYYY-MM-DDTHH:mm:ss+0000'),
                    rTrip: true,
                    limit: 6,
                    monhtlyOffer: true
                };
                this.choosenStartAirport = this.depArprtCodeKeyDes.l;

                this.actn_call_ListFlightsMonthlyOffers(requestParamObject);
            }
        }, // eo function onSelect_DepartureAirportKeyDes


        /*******************************************************************
        * onClick_Reset_KeyDestinations()
        *
        * Desc: Reset KeyDestinations Stuff.
        * Note:
        *
        */
        onClick_Reset_KeyDestinations: function onClick_Reset_KeyDestinations() {

            var me = this,
                requestParamObject = {};

            me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_Reset_KeyDestinations');
            this.depArprtCodeKeyDes = ''; // reset model
            this.actn_setBookingOffersSelectedDestination({});
            this.actn_setBookingOffersChoosenFlightByUser(null);
            this.actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel(false);
            this.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
        }, // eo function onClick_Reset_KeyDestinations()


        /*******************************************************************
        * onClick_BarChart()
        *
        * Desc: Find Right Flight (via clicked Month).
        * Note:
        *
        * @param {Object} ev
        * @param {Object} data
        */
        onClick_BarChart: function onClick_BarChart(ev, data) {

            var me = this,
                clickedMonth = null;

            me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_BarChart');
            if (data[0] !== undefined) {
                if (data[0]._model !== undefined) {
                    this.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
                    clickedMonth = data[0]._model.label; // catch label
                    this.rememberClickedMonth = clickedMonth; // save locally
                    this.getBookingOffersFlightIdViaMonth(clickedMonth); // find flight
                }
            }
        }, // eo function onClick_Reset_KeyDestinations()


        /*******************************************************************
        * onClick_Submit_FindFlightsViaOffers()
        *
        * Desc:
        * Note:
        *
        */
        onClick_Submit_FindFlightsViaOffers: function onClick_Submit_FindFlightsViaOffers() {

            var me = this,
                requestParamObject = {};

            me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> onClick_Submit_FindFlightsViaOffers');
            // >>> 1. Builds Object ----------------------------------------
            requestParamObject = {
                depArprtCode: this.getBookingOffersChoosenFlightByUser.depArprt.i,
                desArprtCode: this.getBookingOffersChoosenFlightByUser.desArprt.i,
                noADT: this.noADT.k,
                noCHD: this.noCHD.k,
                noINF: this.noINF.k,
                ojArprtCode: '',
                ojType: '',
                depAfter: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.getBookingOffersChoosenFlightByUser.depDT).subtract(0, 'days').format('YYYY-MM-DDT00:00:00+0000'),
                retAfter: __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.getBookingOffersChoosenFlightByUser.depDT).add(3, 'days').format('YYYY-MM-DDT23:59:59+0000'),
                rTrip: true,
                limit: 6
            };

            // >>> 2. State Stuff ------------------------------------------
            this.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
            this.actn_FlagServicesShowBookingnoSearchResults(false); // Hide 'Section'
            this.actn_setBookingAirports({ // remember in state
                depArprtCode: requestParamObject.depArprtCode,
                depArprtName: this.getBookingOffersChoosenFlightByUser.depArprt.l,
                desArprtCode: requestParamObject.desArprtCode,
                desArprtName: this.getBookingOffersChoosenFlightByUser.desArprt.l
            });
            this.actn_setBookingUsersSearchData(requestParamObject); // remember in state
            this.actn_set_areWeInServicesBookingNoMode(false); // we are NOT in bookingno mode

            // >>> 3. Call -------------------------------------------------
            this.actn_call_ListFlightsAfterUserSelectedBestPrice(requestParamObject);

            __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$emit('needtorerender');
        }, // eo function onClick_Submit_FindFlightsViaOffers()


        /******************************************************************* 'Offers Utilities'
        * Offers Utilities:
        *******************************************************************/
        /*******************************************************************
        * get_LowestPriceForKeyDes()
        *
        * Desc: Return Price of given DKeyestination.
        * Note:
        *
        * @param {String} des (e.g.: 'FUE')
        */
        get_LowestPriceForKeyDes: function get_LowestPriceForKeyDes(des) {

            var me = this,
                lowest = 0;

            // me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> get_LowestPriceForKeyDes');
            if (me.getOffers.length > 0) {
                lowest = me.getOffers.find(function (offer) {
                    return offer.destinationOfferAptCode === des;
                });
                if (lowest !== undefined) {
                    lowest = lowest.price;
                } else {
                    lowest = 0;
                }
            }

            return lowest;
        }, // eo function get_LowestPriceForKeyDes()


        /*******************************************************************
        * get_barchartsChartdata()
        *
        * Desc: Build up Charts Objects.
        * Note:
        *
        */
        get_barchartsChartdata: function get_barchartsChartdata() {

            var me = this,
                depAfterMonthIndex = __WEBPACK_IMPORTED_MODULE_2_moment___default()().month(),
                // find right index
            retAfterMonthIndex = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(5, 'months').month(),
                months_en = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April', 'May', 'June'],
                months_de = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember', 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni'],
                labels = [],
                // labels to send
            data = this.getBookingOffersListFlightsMonthlyOffers,
                // price data to send
            barchartsChartdata = {
                labels: '', // gets filled up later
                datasets: [{
                    label: this.bestprices6months[me.getCurrentLocale],
                    borderColor: "#fff",
                    borderWidth: "2",
                    hoverBorderColor: "#666",
                    backgroundColor: ["rgba(2, 62, 138, 0.7)", "rgba(0, 119, 182, 0.7)", "rgba(0, 150, 199, 0.7)", "rgba(0, 180, 216, 0.7)", "rgba(72, 202, 228, 0.7)", "rgba(144, 224, 239, 0.7)"],
                    hoverBackgroundColor: ["#023e8a", "#0077b6", "#0096c7", "#00b4d8", "#48cae4", "#90e0ef"],

                    // barPercentage: 0.5,
                    // barThickness: 6,
                    // maxBarThickness: 8,
                    // minBarLength    : 2,
                    data: ''
                }]
            };

            me.$toc('>>> booking/pagecontent/KeyDestinations.vue >>> get_barchartsChartdata');
            // >>> ---------------------------------------------------------// right labels
            if (me.getCurrentLocale === 'de') {
                labels = months_de.slice(depAfterMonthIndex, depAfterMonthIndex + 6);
            } else {
                labels = months_en.slice(depAfterMonthIndex, depAfterMonthIndex + 6);
            }
            barchartsChartdata.labels = labels; // add labels

            barchartsChartdata.datasets[0].data = data; // add prices
            // <<< ---------------------------------------------------------


            // >>> --------------------------------------------------------- Rerender Component (using FakeCounter)
            if (JSON.stringify(this.prevChartData) !== JSON.stringify(data)) {
                this.fakeCounter = this.fakeCounter + 1;
            }
            this.prevChartData = data; // remember it
            // <<< ---------------------------------------------------------


            return barchartsChartdata;
        }, // eo function get_barchartsChartdata()


        /*******************************************************************
        * getListOfPaxes()
        *
        * Desc:
        * Note:
        *
        */
        getListOfPaxes: function getListOfPaxes() {

            return this.listOfPaxes;
        }, // eo function getListOfPaxes()


        /*******************************************************************
        * getButtonName()
        *
        * Desc:
        * Note:
        *
        */
        getButtonName: function getButtonName() {

            return this.findflights[this.getCurrentLocale] + ': ' + this.rememberClickedMonth;
        } // eo function getButtonName()

    }) // eo  methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(417);



/* harmony default export */ __webpack_exports__["a"] = ({
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
    props: ['chartdata', 'options'],

    /* >>> *************************************************************** / /* Data */
    data: function data() {
        return {
            // chartdata: {
            //     labels: ['September', 'Oktober', 'November', 'Dezember', 'January', 'February', ],
            //     datasets: [
            //         {
            //             label: 'Flightprices',
            //             backgroundColor: '#f87979',
            //             data: [72, 82, 62, 62]
            //         },
            //     ]
            // },
            // options: {
            //     responsive: true,
            //     maintainAspectRatio: false
            // }
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note:
    *
    */
    mounted: function mounted() {

        var me = this;

        me.$toc('>>> shared/charts/KeyDestinationsBarChart.vue >>> mounted');
        this.renderChart(this.chartdata, this.options);
    }, // eo function mounted()

    /***********************************************************************
    * Lifecyclehook::beforeUpdate
    *
    * Desc:
    * Note:
    *
    */
    beforeUpdate: function beforeUpdate() {

        var me = this;

        me.$toc('>>> shared/charts/KeyDestinationsBarChart.vue >>> beforeUpdate');
    }, // eo function beforeUpdate()

    /***********************************************************************
    * Lifecyclehook::updated
    *
    * Desc:
    * Note:
    *
    */
    updated: function updated() {

        var me = this;

        me.$toc('>>> shared/charts/KeyDestinationsBarChart.vue >>> updated');
    } // eo function updated()

});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {}, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            contentheadline: {
                en: 'Travel extras to enrich your trip',
                de: 'Reise Extras zur Bereicherung Ihrer Reise'
            },
            // >>> ------------------------------------
            // >>> ------------------------------------
            furtherservices_seat: {
                en: 'Reserve your seat of choice',
                de: 'Reservieren Sie sich Ihren Wunschsitzplatz'
            },
            furtherservices_seat_headline: {
                en: 'The following seating categories are available:',
                de: 'Folgende Sitzplatzkategorien stehen zur Wahl:'
            },
            furtherservices_seat_text1: {
                en: 'You can choose whether you want to sit at the window and enjoy the view or sit in the corridor with more freedom of movement. Decide for yourself and book your new favourite place',
                de: 'Sie können wählen, ob Sie am Fenster sitzen und die Aussicht genießen wollen oder am Gang mit mehr Bewegungsfreiheit sitzen möchten. Entscheiden Sie selbst und buchen Ihren neuen Lieblingsplatz'
            },
            furtherservices_seat_here: {
                en: 'here',
                de: 'hier'
            },
            furtherservices_seat_text2: {
                en: 'Attention: We recommend that you make your reservation up to 48 hours before departure!',
                de: 'Achtung: Wir empfehlen Ihnen eine rechtzeitige Reservierung<br /> bis 48 Stunden vor Abflug!'
            },
            furtherservices_seat_text3: {
                en: 'Further information can be found',
                de: 'Nähere Informationen finden Sie'
            },
            furtherservices_seat_comfortseat: {
                en: 'SEATS IN THE 1ST ROW',
                de: 'SITZPLÄTZE IN DER 1. REIHE'
            },
            furtherservices_seat_bestseat: {
                en: 'Seats in the 2nd - 7th row',
                de: 'Sitzplätze in der 2.-7. Reihe'
            },
            furtherservices_seat_exitseat: {
                en: 'SEATS DIRECTLY AT THE EMERGENCY EXIT',
                de: 'SITZPLÄTZE AM NOTAUSGANG'
            },

            // >>> ------------------------------------
            // >>> ------------------------------------
            furtherservices_luggage: {
                en: 'Take extra luggage with you',
                de: 'Nehmen Sie zusätzliches Gepäck mit'
            },
            luggage_text1: {
                en: 'Checked baggage allowance up to <b>max. 20kg</b>.',
                de: 'Aufzugebenes Freigepäckstück bis <b>max. 20kg</b>.'
            },
            luggage_text2: {
                en: 'Baggage allowance for small children up to 2 years such as pushchairs, buggies or child car seats can be carried in the hold without registration within the free baggage allowance up to 20kg.',
                de: 'Gepäckstücke für Kleinkinder bis 2 Jahre wie  Kinderwagen, Buggys oder Autokindersitze können ohne Anmeldung innerhalb der Freigepäckmenge  bis max. 20 kg im Laderaum befördert werden.'
            },

            luggage_text3: {
                en: 'One (1) Hand luggage up to max. 6kg with permissible dimensions up to 55cm x 40cm x 20cm.',
                de: 'Ein (1) Handgepäck bis max. 6 kg mit den zulässigen Abmessungen bis 55cm x 40cm x 20cm.'
            },
            luggage_text3b: {
                en: 'Please note the following information on the EU hand baggage regulations for liquids and our liability regulations under Information Baggage',
                de: 'Bitte beachten Sie folgende Hinweise zu den EU-Handgepäckregelungen für Flüssigkeiten und unseren Haftungsbestimmungen unter Informationen-Gepäck'
            },
            luggage_text4: {
                en: 'Over-, sports- or special baggage can be booked up to 48 hours before departure',
                de: 'Über-, Sport- oder Sondergepäck können bis spätestens 48 Stunden vor Abflug hier gebucht werden'
            },
            luggage_text5: {
                en: 'The price list can be found',
                de: 'Eine Entgelt-Übersicht hierzu finden Sie'
            },
            luggage_textlistheader: {
                en: 'The following items can also be taken with you by prior arrangement and confirmation:',
                de: 'Nach vorheriger Anmeldung und Bestätigung können außerdem folgende Gegenstände mitgenommen werden:'
            },
            luggage_li1: {
                en: 'up to two mobility devices',
                de: 'bis zu zwei Mobillitätshilfen'
            },
            luggage_li2: {
                en: 'a pair of assistants and/or splints, other prostheses',
                de: 'ein Paar Gehilfen und/ oder Schienen, sonstige Prothesen'
            },
            luggage_li3: {
                en: 'a guide dog',
                de: 'einen Blindenhund'
            },
            luggage_textcontact: {
                en: 'Please contact our customer service on <b>+49 30 53676791</b> for more information.',
                de: 'Bitte kontaktieren Sie hierzu unseren Kundenservice unter <span style="font-size:15.9996px; color: #D6254D;">+49 30 53676791</span>.'
            },
            // >>> ------------------------------------
            // >>> ------------------------------------
            furtherservices_sportequipment: {
                en: 'Travel with your sports equipment',
                de: 'Verreisen Sie mit Ihrem Sportequipment'
            },
            sportequipment_text1: {
                en: 'We can transport the following equipment for you our aircraft:',
                de: 'Folgendes Sportgepäck können wir für Sie in unseren Flugzeugen befördern:'
            },
            sportequipment_li1: {
                en: 'Bicycle up to 20kg',
                de: 'Fahrrad bis 20kg'
            },
            sportequipment_li2: {
                en: 'Golf baggage up to 20kg',
                de: 'Golfgepäck bis 20kg'
            },
            sportequipment_li3: {
                en: 'Diving baggage up to 30kg',
                de: 'Tauchgepäck bis 30kg'
            },
            sportequipment_li4: {
                en: 'Surfboard up to 30kg',
                de: 'Surfboard bis 30kg'
            },
            sportequipment_li5: {
                en: 'Waveboard up to 30kg',
                de: 'Waveboard bis 30kg'
            },
            sportequipment_li6: {
                en: 'Kayak up to 30kg',
                de: 'Kajak bis 30kg'
            },
            sportequipment_li7: {
                en: 'Kiteboard up to 30kg',
                de: 'Kiteboard bis 30kg'
            },
            sportequipment_li8: {
                en: 'Hangglider up to 30kg',
                de: 'Hangglider bis 30kg'
            },
            sportequipment_li9: {
                en: 'Canoe up to 30kg',
                de: 'Kanu bis 30kg'
            },
            sportequipment_li10: {
                en: 'Paraglider up to 30kg',
                de: 'Paraglider bis 30kg'
            },
            sportequipment_text3: {
                en: 'Without reservation at check-in, higher fees may apply. Detailed information and the price list can be found',
                de: 'Ohne vorherige Reservierung fallen bei Abgabe am Check-in höhere Gebühren an. Detaillierte Informationen und die Entgelte finden Sie'
            },
            sportequipment_text4: {
                en: 'Please reserve sports equipment',
                de: 'Reservieren Sie Ihr Sport- und Sondergepäck noch heute online'
            },
            // >>> ------------------------------------
            // >>> ------------------------------------
            furtherservices_meal: {
                en: 'Simply order your meal before',
                de: 'Bestellen Sie doch einfach Ihr Essen vor'
            },
            meal_text1: {
                en: 'On your flight we offer you a selection of food, snacks and drinks for sale.',
                de: 'Gerne bieten wir Ihnen eine Auswahl an Speisen, Snacks und Getränke gegen Gebühr auf Ihrem Flug an.'
            },
            meal_text2: {
                en: 'Further information can be found in our on-board bistro and sales journal (PDF document)',
                de: 'Nähere Informationen finden Sie in unserem Bord-Bistro- und Bordverkauf-Journal (PDF-Dokument)'
            },
            meal_text3: {
                en: 'Special foods such as vegetarian-meals, gluten-free meals and diabetics-menus can be booked at least 48 hours prior to departure under SERVICE',
                de: 'Spezialessen, wie vegetarisches Essen, glutenfreies Essen und Diabetiker-Essen können Sie bis spätestens 48 Stunden vor Abflug unter Service buchen'
            },
            // >>> ------------------------------------
            // >>> ------------------------------------
            furtherservices_furtherservices: {
                en: 'Further services for you',
                de: 'Weitere Services für Sie'
            },
            furtherservices_text1: {
                en: 'In addition, we offer the following services:',
                de: 'Zusätzlich bieten wir Ihnen folgende Leistungen an:'
            },
            furtherservices_li1: {
                en: 'Unaccompanied child <b>100,00€</b> for online registration',
                de: 'Unbegleitetes Kind <b>100,00€</b> bei Online-Anmeldung'
            },
            furtherservices_li2: {
                en: 'Animals in the cabin up to <b>6kg incl. box max. 42x31x20cm 60,00€</b> for online registration',
                de: 'Tiere in der Kabine bis <b>6kg inkl. Box max. 42x31x20cm 60,00€</b> bei Online-Anmeldung'
            },
            furtherservices_li3: {
                en: 'Animals in the cargo compartment up to <b>20kg incl. box 80,00€</b> for online registration',
                de: 'Tiere im Frachtraum bis <b>20kg inkl. Box 80,00€</b> bei Online-Anmeldung'
            },
            furtherservices_li4: {
                en: 'Animals in the hold <b>ab 21kg incl. box 100,00€</b> for online registration',
                de: 'Tiere im Frachtraum <b>ab 21kg inkl. Box 100,00€</b> bei Online-Anmeldung'
            },
            furtherservices_text2: {
                en: 'Book your additional services now under Service',
                de: 'Buchen Sie jetzt Ihre Zusatzleistungen unter Service'
            },
            furtherservices_text3: {
                en: 'Further information and prices can be found',
                de: 'Nähere Informationen und Preise finden Sie'
            }
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedShowFlightSearchResults'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** /  /* Data */
    data: function data() {

        return {
            // ----------------------------------
            title: {
                en: 'Take Sundair With You Wherever You Go!',
                de: 'Nehmen Sie Sundair mit, wohin Sie auch gehen!'
            },
            info: {
                en: 'This makes travelling fun.<br />Quickly and easily book your next flight with a swipe of your finger.<br />Finding your next destination with your smartphone.<br /><br />Up to 12 dream destinations with your Sundair.',
                de: 'So macht das Reisen Spaß.<br />Schnell und einfach mit einem Fingerwisch Ihren nächsten Flug buchen.<br />Ganz bequem mit Ihrem Smartphone Ihr nächstes Reiseziel finden.<br /><br />Auf zu 12 Traumzielen mit Ihrer Sundair.'
            },
            rateus: {
                en: 'Rate us',
                de: 'Bewerte uns'
            },
            soon: {
                en: "We'll be there very soon. Patience.",
                de: 'Wir kommen sehr bald. Geduld.'
            }
            // currentLocale: 'de',
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getFlagSharedShowFlightSearchResults'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {} // eo  methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booking_passengers_Passenger_vue__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_cart_Cart_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'], // via: router/push
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-passenger': __WEBPACK_IMPORTED_MODULE_1__booking_passengers_Passenger_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-shared-cart': __WEBPACK_IMPORTED_MODULE_3__shared_cart_Cart_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            pleaseselectservicesheadline: {
                en: 'Step 2: Please provide passenger details and select services.',
                de: 'Schritt 2: Bitte Passagierdaten eingeben und Services auswählen.'
            },
            pleaseselectservicesheadlineinbookinno: {
                en: 'Step 2: Please select your additional services.',
                de: 'Schritt 2: Bitte Ihre zusätzlichen Services auswählen.'
            },
            needhelp: {
                en: 'Do you need any help?',
                de: 'Brauchen Sie Hilfe?'
            },
            sideboxhelptext: {
                en: 'We will be happy to help you. Our team consultants are at your disposal around the clock.',
                de: 'Wir helfen Ihnen gerne weiter. Unsere Teamberater stehen Ihnen rund um die Uhr zur Verfügung.'
            },
            proceed: {
                en: 'PROCEED TO PAYMENT INFORMATION',
                de: 'WEITER ZU ZAHLUNGSDETAILS'
            },
            pleasselectaservice: {
                en: 'Please select at least one service!',
                de: 'Bitte wählen Sie mindestens einen Service aus!'
            },
            // currentLocale: 'de',
            // >>> --------------------------
            validateParams: {} //
        };
    }, // eo data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_areWeInServicesBookingNoMode', 'getBookingCart', 'getBookingFlightIdSelectedOutward', 'getBookingFlightIdSelectedReturn', 'getBookingLockfaresResults', 'getFlagBookingPassengersAreReadyForValidation', 'getBookingUsersSearchData', 'getBookingLockfaresResults', 'getBookingCartOutwardTotal', 'getBookingCartReturnTotal', 'getBookingCartCountServices', // #340
    // >>> --------------------------
    'get_ServicesBookingnoSearchResults', 'getServicesValidatePassengersObject']), {

        /*******************************************************************
        * validateParamsData
        *
        * Desc: 'Validate Passengers Object' for Call of same Name.
        * Note:
        *
        */
        validateParamsData: {
            get: function get() {
                return this.validateParams;
            },
            set: function set(value) {
                this.validateParams = value;
            }
        } // eof validateParamsData{}

    }), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['actn_setBookingValidatePassengersObject', // set: 'Calls Object to send'
    'actn_setBookingUpdateCartWithPaxCredentials', // set: Update Cart with Pax Credentials
    // >>> --------------------------
    'actn_setServicesValidatePassengersObject', // (same for 'Services')
    'actn_setServicesValidatePassengersObjectClone'] // (same for 'Services', Clone)
    ), {

        /******************************************************************* 'ServiceCalls - Booking'
        * ServiceCalls: 'Booking'
        *******************************************************************/
        /*******************************************************************
        * Call::'/booking/validatepassengers/', HTTP Method PUT
        *
        * Desc:
        * Note: This Call Response is a special Case:
        * Note: It may contain errors!
        * Note: Errors gets translated here!
        *
        */
        call_validatePassengers: function call_validatePassengers(params) {

            var me = this,
                hdrs = '',
                options = {},
                trsnltd = '';

            me.$toc('>>> booking/passengers/Passengers.vue >>> call_validatePassengers');
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('/booking/validatepassengers/', params).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        if (response.data.validated === false) {
                            // ERROR
                            trsnltd = me.$trnsl_error_message(response.data.errors[0]);
                            me.$toasted.global.sdr_app_error({
                                message: trsnltd
                            });
                        } else {
                            me.$vp_um();

                            me.$router.push({ path: '/payment/' + me.modulo });

                            setTimeout(function () {
                                me.$scrollTo('#scrollPointTop', 200, options);
                            }, 300);
                        }
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo function call_validatePassengers()


        /******************************************************************* 'ServiceCalls - Services'
        * ServiceCalls: 'Services'
        *******************************************************************/
        /*******************************************************************
        * Call::'/registration/validate', HTTP Method PUT
        *
        * Desc:
        * Note: This Call Response is a special Case:
        * Note: It may contain errors!
        * Note: Errors gets translated here!
        *
        * @param {Object} params
        */
        call_validateInRegistration: function call_validateInRegistration(params) {

            var me = this,
                hdrs = '',
                options = {},
                trsnltd = '';

            me.$toc('>>> booking/passengers/Passengers.vue >>> call_validateInRegistration');
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put('/registration/validate/', params).then(function (response) {
                // 'OK'
                me.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        if (response.data.validated === false) {
                            // ERROR
                            trsnltd = me.$trnsl_error_message(response.data.errors[0]);
                            me.$toasted.global.sdr_app_error({
                                message: trsnltd
                            });
                        } else {
                            me.$vp_um();

                            me.$router.push({ path: '/payment/' + me.modulo });

                            setTimeout(function () {
                                me.$scrollTo('#scrollPointTop', 200, options);
                            }, 300);
                        }
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eof call_validateInRegistration()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: 'Passengers Form' gets submitted.
        * Note: I build an Object for Update Cart only here!
        * Note: Build some 'ValidatePassengersObject' Clone here.
        *
        * @param {Object} submitEvent (Event)
        * @return {Array} infantServices
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                myValidateParams = {},
                myUpdateCartWithCredentialsParams = {},
                // for Update Cart only
            pax = {},
                day = null,
                month = null,
                year = null,
                counter = 1,
                countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                countADTCHD = countADT + countCHD,
                countADTCHDINF = countADTCHD + countINF;

            me.$toc('>>> booking/passengers/Passengers.vue >>> onSubmit');
            myValidateParams.bookingKeyCode = this.getBookingLockfaresResults.keycode;
            myValidateParams.passengers = [];
            myUpdateCartWithCredentialsParams.passengers = [];

            // >>> Catch every Pax Data (ADT) ------------------------------
            for (var i = 1; i <= countADT; i++) {
                pax.salutation = submitEvent.target.elements['inputPax_salutation_' + i].value;
                pax.firstName = submitEvent.target.elements['inputPax_firstName_' + i].value;
                pax.middleName = '';
                pax.lastName = submitEvent.target.elements['inputPax_lastName_' + i].value;
                pax.gender = submitEvent.target.elements['inputPax_salutation_' + i].value == 'MR' ? 'M' : 'F';
                day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;
                pax.birthdate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000');

                // >>> ----------------------
                pax.infantServices = this.buildValidateParams_InfantSrvcs(submitEvent, i); // i === id_pax
                pax.services = this.buildValidateParams_Srvcs(i); // i === id_pax
                pax.seatServices = this.buildValidateParams_Seats(i); // i === id_pax
                // <<< ----------------------

                myValidateParams.passengers.push(pax); // add ADT

                // >>> ---------------------- Special
                pax.id_pax = counter;
                myUpdateCartWithCredentialsParams.passengers.push(pax); // add ADT
                // <<< ----------------------

                pax = {}; // reset
                counter = counter + 1;
            }

            // >>> Catch every Pax Data (CHD) ------------------------------
            for (var i = countADT + 1; i <= countADTCHD; i++) {
                pax.salutation = 'CHD';
                pax.firstName = submitEvent.target.elements['inputPax_firstName_' + i].value;
                pax.middleName = '';
                pax.lastName = submitEvent.target.elements['inputPax_lastName_' + i].value;
                pax.gender = submitEvent.target.elements['inputPax_gender_' + i].value;
                day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;
                pax.birthdate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000');

                // >>> ----------------------
                pax.infantServices = []; // no
                pax.services = this.buildValidateParams_Srvcs(i); // i === id_pax
                pax.seatServices = this.buildValidateParams_Seats(i); // i === id_pax
                // <<< ----------------------

                myValidateParams.passengers.push(pax); // add CHD

                // >>> ---------------------- Special
                pax.id_pax = counter;
                myUpdateCartWithCredentialsParams.passengers.push(pax); // add CHD
                // <<< ----------------------

                pax = {}; // reset
                counter = counter + 1;
            }

            // >>> Catch every Pax Data (INF) - ONLY FOR CART!!! -----------
            if (this.modulo === 'booking') {
                for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {
                    pax.salutation = 'CHD';
                    pax.firstName = submitEvent.target.elements['inputPax_firstName_' + i].value;
                    pax.middleName = '';
                    pax.lastName = submitEvent.target.elements['inputPax_lastName_' + i].value;
                    pax.gender = submitEvent.target.elements['inputPax_gender_' + i].value;
                    day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                    month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                    year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;
                    pax.birthdate = __WEBPACK_IMPORTED_MODULE_6_moment___default()(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000');

                    // >>> ----------------------
                    pax.infantServices = []; // no
                    pax.services = [];
                    pax.seatServices = []; // later
                    // <<< ----------------------

                    // >>> ---------------------- Special
                    pax.id_pax = counter;
                    myUpdateCartWithCredentialsParams.passengers.push(pax); // add CHD
                    // <<< ----------------------

                    pax = {}; // reset
                    counter = counter + 1;
                }
            }

            // >>> Step 4: Add/Set/Call ------------------------------------
            this.actn_setBookingValidatePassengersObject(myValidateParams); // Save...
            this.actn_setBookingUpdateCartWithPaxCredentials(myUpdateCartWithCredentialsParams); // Save... fo Update Cart only


            // >>> The right next Call -------------------------------------
            if (this.modulo === 'booking') {
                this.call_validatePassengers(myValidateParams); // Next...
            }

            if (this.modulo === 'services') {
                if (this.getBookingUsersSearchData.rTrip === true) {
                    // Roundtrip
                    if (this.getBookingCartCountServices === 0) {
                        // some srvc in cart?, Old: this.getBookingCartOutwardTotal === 0 && this.getBookingCartReturnTotal === 0
                        me.$toasted.global.sdr_app_error({
                            message: this.pleasselectaservice[this.getCurrentLocale]
                        });
                        return;
                    }
                }
                if (this.getBookingUsersSearchData.rTrip === false) {
                    // Oneway
                    if (this.getBookingCartCountServices === 0) {
                        // some srvc in cart?, Old: this.getBookingCartOutwardTotal === 0
                        me.$toasted.global.sdr_app_error({
                            message: this.pleasselectaservice[this.getCurrentLocale]
                        });
                        return;
                    }
                }

                delete myValidateParams.bookingKeyCode; // not in 'services'


                // >>> ----------------------                               // clone for bookinno
                if (this.get_areWeInServicesBookingNoMode === true) {
                    var _deepClone = JSON.parse(JSON.stringify(myValidateParams));
                    this.actn_setServicesValidatePassengersObjectClone(_deepClone);
                }
                // <<< ----------------------

                var deepClone = JSON.parse(JSON.stringify(myValidateParams));
                me.actn_setServicesValidatePassengersObject(deepClone); // Save... (with id)

                for (var i = 0; i < myValidateParams.passengers.length; i++) {
                    // not in 'services'
                    delete myValidateParams.passengers[i].id_pax;
                }

                this.call_validateInRegistration(myValidateParams); // Next...
            }
        }, // eo function onSubmit()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * buildValidateParams_Srvcs()
        *
        * Desc: Build 'services' Array for 'validatePassengers' Params.
        * Note:
        * Note: NEW (03.2020), Add older Bookingno Srvcs too here!
        * Note: Pay Attention: SEAT does not belong into services[] !
        *
        * @param {Int} id_pax ()
        * @return {Array} services
        */
        buildValidateParams_Srvcs: function buildValidateParams_Srvcs(id_pax) {
            var _this = this;

            var me = this,
                services = [];

            me.$toc('>>> booking/passengers/Passengers.vue >>> buildValidateParams_Srvcs');
            // >>> Searching 'Cart' --------- a)
            for (var i = 0; i < this.getBookingCart.length; i++) {
                if (parseFloat(id_pax, 10) === parseFloat(this.getBookingCart[i].id_pax, 10)) {
                    for (var a = 0; a < this.getBookingCart[i].outward_srvcs.length; a++) {
                        services.push({
                            code: this.getBookingCart[i].outward_srvcs[a].code,
                            comment: this.getBookingCart[i].outward_srvcs[a].userInputSrvcsDetails_Comment,
                            idFlight: this.getBookingFlightIdSelectedOutward,
                            quantity: parseFloat(this.getBookingCart[i].outward_srvcs[a].userInputSrvcsDetails_Count, 10) + parseFloat(this.get_ServicesFromOriginalBooking(id_pax, this.getBookingFlightIdSelectedOutward, this.getBookingCart[i].outward_srvcs[a].code), 10)
                        });
                    }

                    for (var b = 0; b < this.getBookingCart[i].return_srvcs.length; b++) {
                        services.push({
                            code: this.getBookingCart[i].return_srvcs[b].code,
                            comment: this.getBookingCart[i].return_srvcs[b].userInputSrvcsDetails_Comment,
                            idFlight: this.getBookingFlightIdSelectedReturn,
                            quantity: parseFloat(this.getBookingCart[i].return_srvcs[b].userInputSrvcsDetails_Count, 10) + parseFloat(this.get_ServicesFromOriginalBooking(id_pax, this.getBookingFlightIdSelectedReturn, this.getBookingCart[i].return_srvcs[b].code), 10)
                        });
                    }
                }
            }

            // >>> Mode: Bookinno ----------- b)
            if (this.get_areWeInServicesBookingNoMode === true) {
                this.get_ServicesBookingnoSearchResults[0].passengers.forEach(function (pax, i) {
                    if (parseFloat(id_pax, 10) === parseFloat(_this.getBookingCart[i].id_pax, 10)) {
                        pax.outboundServices.forEach(function (srvcs, i) {
                            if (srvcs.code !== 'SEAT') {
                                services.push({
                                    code: srvcs.code,
                                    comment: '',
                                    idFlight: _this.getBookingFlightIdSelectedOutward,
                                    quantity: srvcs.quantity
                                });
                            }
                        });

                        pax.inboundServices.forEach(function (srvcs, i) {
                            if (srvcs.code !== 'SEAT') {
                                services.push({
                                    code: srvcs.code,
                                    comment: '',
                                    idFlight: _this.getBookingFlightIdSelectedReturn,
                                    quantity: srvcs.quantity
                                });
                            }
                        });
                    }
                });
            }

            return services;
        }, // eo function buildValidateParams_Srvcs()

        /*******************************************************************
        * buildValidateParams_Seats()
        *
        * Desc: Build 'seats' Array for 'validatePassengers' Params.
        * Note:
        *
        * @param {Int} id_pax ()
        * @return {Array} seats
        */
        buildValidateParams_Seats: function buildValidateParams_Seats(id_pax) {

            var me = this,
                services = [];

            me.$toc('>>> booking/passengers/Passengers.vue >>> buildValidateParams_Seats');
            // >>> Searching 'Cart' --------- a)
            for (var i = 0; i < this.getBookingCart.length; i++) {
                if (parseFloat(id_pax, 10) === parseFloat(this.getBookingCart[i].id_pax, 10)) {

                    if (this.getBookingCart[i].outward_seat.price !== undefined) {
                        services.push({
                            code: this.getBookingCart[i].outward_seat.code,
                            comment: this.getBookingCart[i].outward_seat.comment,
                            idFlight: this.getBookingCart[i].outward_seat.id_flight,
                            quantity: this.getBookingCart[i].outward_seat.quantity,
                            tktClass: this.getBookingCart[i].outward_seat.tktClass,
                            infantOnLap: this.getBookingCart[i].outward_seat.infantOnLap,
                            lockingCode: this.getBookingCart[i].outward_seat.lockingcode,
                            seatName: this.getBookingCart[i].outward_seat.seatno
                        });
                    }

                    if (this.getBookingCart[i].return_seat.price !== undefined) {
                        services.push({
                            code: this.getBookingCart[i].return_seat.code,
                            comment: this.getBookingCart[i].return_seat.comment,
                            idFlight: this.getBookingCart[i].return_seat.id_flight,
                            quantity: this.getBookingCart[i].return_seat.quantity,
                            tktClass: this.getBookingCart[i].return_seat.tktClass,
                            infantOnLap: this.getBookingCart[i].return_seat.infantOnLap,
                            lockingCode: this.getBookingCart[i].return_seat.lockingcode,
                            seatName: this.getBookingCart[i].return_seat.seatno
                        });
                    }
                }
            }

            return services;
        }, // eo function buildValidateParams_Seats()

        /*******************************************************************
        * buildValidateParams_InfantSrvcs()
        *
        * Desc: Build 'infantServices' Array for 'validatePassengers' Params.
        * Note:
        *
        * @param {Object} submitEvent (Event)
        * @param {Int} id_pax ()
        * @return {Array} infantServices
        */
        buildValidateParams_InfantSrvcs: function buildValidateParams_InfantSrvcs(submitEvent, id_pax) {

            var me = this,
                infantServices = [],
                pax = {},
                day = null,
                month = null,
                year = null,
                countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                countADTCHD = countADT + countCHD,
                countADTCHDINF = countADTCHD + countINF;

            me.$toc('>>> booking/passengers/Passengers.vue >>> buildValidateParams_InfantSrvcs');
            if (this.modulo === 'booking') {
                // >>> -----------------------------------------------------
                if (countINF === 0) {
                    infantServices = [];
                }

                // >>> -----------------------------------------------------
                if (countINF !== 0) {
                    // >>> Step 1: Catch every Pax Data (INF) ------------------
                    for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {

                        // >>> Arrange adults to a baby ------------------------
                        if (i === parseFloat(id_pax) + parseFloat(countADTCHD)) {

                            // >>> Infant Srvcs on OUT -----
                            if (this.getBookingFlightIdSelectedOutward !== null) {
                                day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                                month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                                year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;

                                infantServices.push({
                                    birthdate: __WEBPACK_IMPORTED_MODULE_6_moment___default()(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000'),
                                    firstName: submitEvent.target.elements['inputPax_firstName_' + i].value,
                                    gender: submitEvent.target.elements['inputPax_gender_' + i].value,
                                    lastName: submitEvent.target.elements['inputPax_lastName_' + i].value,
                                    middleName: '',
                                    tktClass: 'Y',
                                    quantity: 1,
                                    idFlight: this.getBookingFlightIdSelectedOutward
                                });
                            }

                            // >>> Infant Srvcs on RET -----
                            if (this.getBookingFlightIdSelectedReturn !== null) {
                                day = submitEvent.target.elements['inputPax_BirthdateDay_' + i].value;
                                month = submitEvent.target.elements['inputPax_BirthdateMonth_' + i].value;
                                year = submitEvent.target.elements['inputPax_BirthdateYear_' + i].value;

                                infantServices.push({
                                    birthdate: __WEBPACK_IMPORTED_MODULE_6_moment___default()(year + '-' + month + '-' + day, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00:ss+0000'),
                                    firstName: submitEvent.target.elements['inputPax_firstName_' + i].value,
                                    gender: submitEvent.target.elements['inputPax_gender_' + i].value,
                                    lastName: submitEvent.target.elements['inputPax_lastName_' + i].value,
                                    middleName: '',
                                    tktClass: 'Y',
                                    quantity: 1,
                                    idFlight: this.getBookingFlightIdSelectedReturn
                                });
                            }
                        }
                    }
                }
            }

            return infantServices;
        }, // eo function buildValidateParams_InfantSrvcs()


        /*******************************************************************
        * get_ServicesFromOriginalBooking()
        *
        * Desc:
        * Note: Special for Mode:Bookingno. Add Services only Quantity.
        * Note: Return Quantity AND Delete index from Array.
        *
        * @param {Number} id_pax
        * @param {Number} idFlight
        * @param {String} code
        * @return {Number} 'Some Count for some Service'
        */
        get_ServicesFromOriginalBooking: function get_ServicesFromOriginalBooking(id_pax, idFlight, code) {
            var _this2 = this;

            var me = this,
                quantity = 0;

            me.$toc('>>> booking/passengers/Passengers.vue >>> get_ServicesFromOriginalBooking');
            if (this.get_areWeInServicesBookingNoMode === true) {
                this.get_ServicesBookingnoSearchResults[0].passengers.forEach(function (pax, i) {
                    if (parseFloat(pax.id_pax_own, 10) === parseFloat(id_pax, 10)) {
                        pax.outboundServices.forEach(function (srvcs, i) {
                            if (srvcs.code !== 'SEAT') {
                                if (idFlight === _this2.getBookingFlightIdSelectedOutward) {
                                    if (srvcs.code === code) {
                                        quantity = srvcs.quantity;
                                        pax.outboundServices.splice(i, 1);
                                    }
                                }
                            }
                        });

                        pax.inboundServices.forEach(function (srvcs, i) {
                            if (srvcs.code !== 'SEAT') {
                                if (idFlight === _this2.getBookingFlightIdSelectedReturn) {
                                    if (srvcs.code === code) {
                                        quantity = srvcs.quantity;
                                        pax.inboundServices.splice(i, 1);
                                    }
                                }
                            }
                        });
                    }
                });
            }

            return quantity;
        } // eo function get_ServicesFromOriginalBooking()

    }) // eo methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__booking_passengers_services_Services_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booking_passengers_services_SeatDetails_vue__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'], // via: router/push
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-services-list': __WEBPACK_IMPORTED_MODULE_0__booking_passengers_services_Services_vue__["a" /* default */],
        'sdr-seatdetails': __WEBPACK_IMPORTED_MODULE_1__booking_passengers_services_SeatDetails_vue__["a" /* default */]

    }, // eo components
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            seatComponentKeyOutward: 0,
            seatComponentKeyReturn: 0,
            // ------------------------------------------------------------
            starsaremandatory: {
                en: 'Fields marked with * are required.',
                de: 'Mit * gekennzeichnete Felder sind Pflichtfelder.'
            },
            form_pax: {
                en: 'Passenger',
                de: 'Passagier'
            },
            form_adult: {
                en: 'Adult',
                de: 'Erwachsener'
            },
            form_child: {
                en: 'Child',
                de: 'Kind'
            },
            form_infant: {
                en: 'Infant',
                de: 'Kleinkind'
            },
            form_salutation: {
                en: 'Salutation',
                de: 'Anrede'
            },
            form_gender: {
                en: 'Gender',
                de: 'Geschlecht'
            },
            form_firstname: {
                en: 'First name',
                de: 'Vorname'
            },
            form_lastname: {
                en: 'Last name',
                de: 'Nachname'
            },
            form_birthdate: {
                en: 'Date of Birth',
                de: 'Geburtsdatum'
            },
            form_srvcs_headline: {
                en: 'Here you can book services for Passenger',
                de: 'Hier Services buchen für Passagier'
            },
            form_enteryourdata: {
                en: 'Enter data here',
                de: 'Hier Daten eingeben'
            },
            form_addservices: {
                en: 'Add Services here',
                de: 'Hier Services hinzubuchen'
            },
            form_mr: {
                en: 'Mr.',
                de: 'Herr'
            },
            form_mrs: {
                en: 'Mrs.',
                de: 'Frau'
            },
            form_male: {
                en: 'Male',
                de: 'Männlich'
            },
            form_female: {
                en: 'Female',
                de: 'Weiblich'
            },
            january: {
                en: 'January',
                de: 'Januar'
            },
            february: {
                en: 'February',
                de: 'Februar'
            },
            march: {
                en: 'March',
                de: 'März'
            },
            april: {
                en: 'April',
                de: 'April'
            },
            may: {
                en: 'May',
                de: 'Mai'
            },
            june: {
                en: 'June',
                de: 'Juni'
            },
            july: {
                en: 'July',
                de: 'Juli'
            },
            august: {
                en: 'August',
                de: 'August'
            },
            september: {
                en: 'September',
                de: 'September'
            },
            october: {
                en: 'October',
                de: 'Oktober'
            },
            november: {
                en: 'November',
                de: 'November'
            },
            december: {
                en: 'December',
                de: 'Dezember'
            },
            travelswithinfant: {
                en: 'travels with infant',
                de: 'reist mit kleinkind'
            },
            btn_addservices: {
                en: 'ADD SERVICE',
                de: 'HINZUFÜGEN'
            },
            btn_chooseservices: {
                en: 'CHOOSE SERVICE',
                de: 'AUSWÄHLEN'
            },
            startingat: {
                en: 'starting at',
                de: 'ab'
            },
            longseattext: {
                en: 'Would you like a window seat or more comfort? Select your seats online in advance with our easy-to-use seat map. When booking on Sundair.com, you can select and change your seat up to 48 hours before departure.',
                de: 'Möchten Sie einen Fensterplatz oder mehr Komfort? Wählen Sie Ihre Plätze online im Voraus mit unserer einfach zu bedienenden Sitzkarte aus. Bei der Buchung auf Sundair.com können Sie bis 48 Stunden vor Abflug Ihren Sitzplatz wählen und wechseln.'
            },
            longflextariftext: {
                en: 'Would you like a window seat or more comfort? Select your seats online in advance with our easy-to-use seat map. When booking on Sundair.com, you can select and change your seat up to 48 hours before departure.',
                de: 'Möchten Sie einen Fensterplatz oder mehr Komfort? Wählen Sie Ihre Plätze online im Voraus mit unserer einfach zu bedienenden Sitzkarte aus. Bei der Buchung auf Sundair.com können Sie bis 48 Stunden vor Abflug Ihren Sitzplatz wählen und wechseln.'
            },

            seattext: {
                en: 'Sit next to your friends and family. Or choose a seat directly at the window. Reserve your desired seat!',
                de: 'Setzen Sie sich neben Ihre Freunde und Familie. Oder wählen Sie einen Platz direkt am Fenster. Reservieren Sie sich Ihren Wunschsitzplatz!'
            },
            flextariftext: {
                en: "No matter how much you pay for your trip, you can cancel it within 28 days - without giving any reason.",
                de: 'Unabhängig von der Höhe des Reisepreises, können Sie bis zu 28 Tage von Ihrer Reise zurücktreten - ohne Angabe von Gründen.'
            },
            seatwithbabytext: {
                en: '(Note: For passengers travelling with a baby (without their own seat).)',
                de: '(Hinweis: Für Fluggäste, welche mit einem Baby (ohne eigenem Sitzplatz) reisen.)'
            },
            seatwithoutbabytext: {
                en: '(Note: For passengers travelling without a baby.)',
                de: '(Hinweis: Für Fluggäste, welche ohne Baby reisen.)'
            },
            seatpreselection: {
                en: 'Seat pre-selection',
                de: 'Sitzplatz Vorauswahl'
            },
            flextarifpreselection: {
                en: 'Flex option',
                de: 'Flex Option'
            },

            headline_chooseyourseat: {
                en: 'Choose your seat',
                de: 'Wählen Sie sich Ihren Sitzplatz aus'
            },
            headline_chooseyourflextarif: {
                en: 'New! Choose our Flex Option',
                de: 'Ganz Neu! Wählen Sie unseren Flex Option'
            },
            headline_chooseyourservices: {
                en: 'Select your additional services',
                de: 'Wählen Sie sich Ihre zusätzlichen Services aus'
            },
            // >>> --------------------------
            modal_headline_seatmaps: {
                en: 'Seating plans for Outward and Return Flights',
                de: 'Sitzpläne für Hin- und Rückflug'
            },
            modal_tabheadline_seatforout: {
                en: 'seat for the outward flight',
                de: 'Sitz für den Hinflug'
            },
            modal_tabheadline_seatforret: {
                en: 'seat for the return flight',
                de: 'Sitz für den Rückflug'
            },
            // >>> --------------------------
            wanneaddoutward: {
                en: 'Reserve seat outbound flight?',
                de: 'Sitz Hinflug reservieren?'
            },
            wanneaddreturn: {
                en: 'Reserve seat return flight?',
                de: 'Sitz Rückflug reservieren?'
            },
            reservetext: {
                en: 'You want to reserve the following seat',
                de: 'Sie wollen folgenden Sitz reservieren: '
            },
            alreadyincart: {
                en: 'This service is already in your shopping cart.',
                de: 'Dieser Service ist bereits in Ihrem Warenkorb.'
            },
            alertno: {
                en: 'No',
                de: 'Nein'
            },
            alertyes: {
                en: 'Yes',
                de: 'Ja'
            },
            alerticonfirm: {
                en: 'I confirm',
                de: 'Ich bestätige'
            },
            alertirefuse: {
                en: 'I refuse',
                de: 'Ich lehne ab'
            },
            confirmplease: {
                en: 'Bitte bestätigen',
                de: 'Bitte bestätigen'
            },
            added: {
                en: 'Added to Cart',
                de: 'Hinzugefügt'
            },
            close: {
                en: 'Close the seat map',
                de: 'Sitzplan schliessen'
            },
            // >>> --------------------------
            bluebox_outward: {
                en: 'Services outward flight:',
                de: 'Services Hinflug:'
            },
            bluebox_return: {
                en: 'Services return flight:',
                de: 'Services Rückflug:'
            },
            none: {
                en: 'None yet.',
                de: 'Noch keine.'
            },
            yourearlierservices: {
                en: 'Your services from a previous booking:',
                de: 'Ihre Services aus einer früheren Buchung:'
            },
            // >>> --------------------------
            // >>> --------------------------
            errmsg_required: {
                en: 'This Field must not be empty.',
                de: 'Dieses Feld darf nicht leer sein.'
            },
            // ------------------------------
            proceed: {
                en: 'PROCEED TO PAYMENT INFORMATION',
                de: 'WEITER ZU ZAHLUNGSDETAILS'
            },
            // currentLocale: 'de',
            // >>> -------------------------- 'Form / Model / Vuelidate'
            inputPax_firstName_1: '',

            // >>> -------------------------- Data for Seats Modal
            seatmapdata: {}
        };
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Validations */
    validations: {

        // >>> firstname --------------------
        inputPax_firstName_1: {
            required: __WEBPACK_IMPORTED_MODULE_2_vuelidate_lib_validators__["required"]
        }

    }, // eo validations
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_areWeInServicesBookingNoMode',
    // >>> --------------------------
    'getBookingPassengers', 'getBookingUsersSearchData', 'getBookingSrvcsSeatExistOnOut', 'getBookingSrvcsSeatExistOnRet', 'getBookingSrvcsInsuranceExist', 'getBookingSrvcsInsuranceObject', 'getBookingCartIsSrvcAlreadyInCart', 'getBookingDoesAnySrvcsExistAtAll', // we have any srvcs on flight?
    'getBookingDoesAnySrvcsExistAtAllWOSeats', // Srvcs wo. Seats
    'getBookingCartIsSeatAlreadyReserved', 'getBookingCartHasPaxAlreadyReservedASeat', 'getBookingCartHasPaxAlreadyReservedAnInsurance', // FLEX OPTION
    'getBookingSeatReservationLockingCodeResults', 'getBookingFlightIdSelectedOutward', 'getBookingFlightIdSelectedReturn', 'getBookingSeatPrice', 'getBookingSeatRemark', // get: seattype has remark?
    // >>> --------------------------
    'getServicesDoesAnySrvcsExistAtAll', // we have any srvcs on flight? (same for 'Services')
    'getServicesDoesAnySrvcsExistAtAllWOSeats', // Srvcs wo. Seats (same for 'Services')
    'get_ServicesBookingnoSearchResults', 'get_ServicesBookingnoServicesPerPax', 'get_ServicesBookingnoHasReturnFlight'])), // eo computed
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note: Catch Event 'readytoforcererender' ('setLock done').
    * Note: Catch Event 'lockafterwards' ('some new lock after unlock').
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> booking/passengers/Passenger.vue >>> created');
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$on('readytoforcererender', this.onEmit_ReadyToForceRerender);
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$on('lockafterwards', this.onEmit_LockAfterWards);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc: Initialize Select Fields.
    * Note:
    *
    */
    mounted: function mounted() {

        var me = this;

        me.$toc('>>> booking/passengers/Passenger.vue >>> mounted');
        me.$selectInits(this.modulo);
    }, // eof mounted()
    /* <<< ****************************************************************/

    /***********************************************************************
    * Lifecyclehook::updated
    *
    * Desc: Add Listeners to Seatmap after rerendering.
    * Note:
    *
    */
    updated: function updated() {

        // console.log('Passenger Lifecyclehook :updated()');
        this.$nextTick(function () {
            if (this.seatComponentKeyOutward !== 0 || this.seatComponentKeyReturn !== 0) {
                // console.log('rerendered!!! addddd listeners noooowwwwwww?');
                this.addListeners_Seatmap(); // remove before?
            }
        });
    }, // eof updated()
    /* <<< ****************************************************************/

    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> booking/passengers/Passenger.vue >>> beforeDestroy');
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$off('readytoforcererender', this.onEmit_ReadyToForceRerender);
        __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$off('lockafterwards', this.onEmit_LockAfterWards);
    }, // eo function beforeDestroy()
    /* >>> *************************************************************** /  /* LifeCycles */

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actn_setBookingUpdateCartWithSeat', // add: Seat to Cart
    'actn_setBookingUpdateCartViaDeleteSeat', // delete: Seat from Cart
    'actn_call_lockSeat', // call:
    'actn_call_unlockSeat', // call:
    'actn_setBookingUpdateCartWithSrvcs']), {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (PUT)
        *
        * Desc: Lock Seat via Lockingcode + Seatno. (Attention: Method:PUT)
        * Note: va[0]->'seatName',va[1]->'code',va[2]->'availlabs',
        * Note: va[3]->'type',va[4]->'id_pax',va[5]->'gp_Kop'
        * Note:
        * Note: New: Axios Call is here managed in VUEX.
        * TODO: is 'infantOnLap' wrong?
        *
        * @param {string} cellId
        * @return
        */
        call_lockSeat: function call_lockSeat(cellId) {

            var me = this,
                va = cellId.split("_"),
                seatno = va[0],
                seatCode = va[1],
                type = va[3],
                id_pax = va[4],
                infantOnLap = va[4] === 'AdultWithInfant' ? true : false,
                // wrong ???
            owf_id = this.getBookingFlightIdSelectedOutward,
                rtf_id = this.getBookingFlightIdSelectedReturn,
                price = this.getBookingSeatPrice({ seatCode: seatCode, type: type }),
                lockingCodes = {},
                lockingcode = '',
                newCart_Item = {},
                payload = {};

            me.$toc('>>> booking/passengers/Passenger.vue >>> call_lockSeat');
            // >>> -------------------------------- Locking Codes
            lockingCodes = this.getBookingSeatReservationLockingCodeResults;
            if (type === 'outward') {
                lockingcode = lockingCodes.outward.response.seatReservationLockingCode;
            }
            if (type === 'return') {
                lockingcode = lockingCodes.return.response.seatReservationLockingCode;
            }

            // >>> -------------------------------- New Cart Item
            newCart_Item = {
                id_pax: id_pax,
                code: "SEAT",
                comment: cellId,
                id_flight: type === 'outward' ? parseInt(owf_id, 10) : parseInt(rtf_id, 10),
                infantOnLap: infantOnLap,
                lockingcode: lockingcode,
                quantity: 1,
                seatno: seatno,
                tktClass: 'Y',
                type: type,
                price: price
            };

            // >>> -------------------------------- Send Ajax Request
            payload = {
                newCart_Item: newCart_Item
            };
            this.actn_call_lockSeat(newCart_Item);
        }, // eof call_lockSeat()

        /*******************************************************************
        * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (DELETE)
        *
        * Desc: UNLock Seat via Lockingcode + Seatno.
        * Note: New: Axios Call is here managed in VUEX.
        *
        * @param {string} cellId
        * @param {int} id_pax
        * @param {string} type ('out', 'ret')
        * @param {string} seatno
        * @param {bool} lockAfterwards (Should i lock afterwards?)
        */
        call_unlockSeat: function call_unlockSeat(cellId, id_pax, type, seatno, lockAfterwards) {

            var me = this,
                lockingCodes = {},
                lockingcode = '',
                hdrs = '',
                payload = {};

            me.$toc('>>> booking/passengers/Passenger.vue >>> call_unlockSeat');
            // >>> -------------------------------- Locking Codes
            lockingCodes = this.getBookingSeatReservationLockingCodeResults;
            if (type === 'outward') {
                lockingcode = lockingCodes.outward.response.seatReservationLockingCode;
            }
            if (type === 'return') {
                lockingcode = lockingCodes.return.response.seatReservationLockingCode;
            }

            // >>> -------------------------------- Send Ajax Request
            payload = {
                lockAfterwards: lockAfterwards,
                id_pax: id_pax,
                type: type,
                lockingcode: lockingcode,
                seatno: seatno,
                cellId: cellId
            };
            this.actn_call_unlockSeat(payload);
        }, // eof call_unlockSeat()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onClick_SrvcSeat()
        *
        * Desc: Click on Button "Add Seat".
        * Note:
        *
        * @param
        * @return
        */
        onClick_SrvcSeat: function onClick_SrvcSeat(pax) {

            var me = this,
                data = {};

            me.$toc('>>> booking/passengers/Passenger.vue >>> onClick_SrvcSeat');
            data.pax = pax; // Add Pax ... more?

            // >>> Render Modal -------------------------------------------
            me.$modal.show('seatmap-modal', { data: data });
        }, // eof onClick_SrvcSeat()


        /*******************************************************************
        * onClick_SrvcInsurance()
        *
        * Desc: Click on Button "Add Seat".
        * Note: Get real Insurance Object here. Build Object for Cart.
        *
        * @param
        * @return
        */
        onClick_SrvcInsurance: function onClick_SrvcInsurance(pax) {

            var me = this,
                srvcs = {},
                insuranceSrvcsObject = this.getBookingSrvcsInsuranceObject,
                insuranceObjectForCart = {
                acceptComment: insuranceSrvcsObject.acceptComment,
                code: insuranceSrvcsObject.code,
                description: insuranceSrvcsObject.description,
                id: insuranceSrvcsObject.id,
                maxBookablePax: insuranceSrvcsObject.maxBookablePax,
                price: insuranceSrvcsObject.price,
                remark: insuranceSrvcsObject.remark,
                srvc_exist_out: true,
                srvc_exist_ret: false,
                userInputSrvcsDetails_Count: 1,
                userInputSrvcsDetails_ToggleOut: true,
                userInputSrvcsDetails_ToggleRet: false,
                userInputSrvcsDetails_Comment: ''
            };

            me.$toc('>>> booking/passengers/Passenger.vue >>> onClick_SrvcInsurance');
            srvcs = { id_pax: pax.pax.id_pax, srvcs: insuranceObjectForCart };

            // >>> Add to Cart --------------
            if (!this.getBookingCartIsSrvcAlreadyInCart(srvcs)) {
                // Already in Cart?
                this.actn_setBookingUpdateCartWithSrvcs(srvcs);
            } else {
                me.$toasted.global.sdr_app_error({
                    message: this.alreadyincart[this.getCurrentLocale]
                });
            }
        }, // eof onClick_SrvcInsurance()


        /*******************************************************************
        * Event Listener:click
        *
        * Desc: Click Seat 1.
        * Note:
        *
        * @param {String} value (Clicked Seat)
        * @param {String} direction ('outward', 'return')
        */
        onItemtap_SeatCell: function onItemtap_SeatCell(value, direction) {

            var me = this,
                seat = value.target.dataset.target.split('_');

            me.$toc('>>> booking/passengers/Passenger.vue >>> onItemtap_SeatCell');
            this.$modal.show('dialog', {
                name: 'dialog',
                title: direction === 'outward' ? me.wanneaddoutward[me.getCurrentLocale] : me.wanneaddreturn[me.getCurrentLocale],
                text: me.reservetext[me.getCurrentLocale] + '<b>' + seat[0] + ' (' + seat[1] + ')</b><br /><br />',
                buttons: [{
                    title: me.alertno[me.getCurrentLocale]
                }, {
                    title: me.alertyes[me.getCurrentLocale],
                    default: true,
                    handler: function handler() {
                        me.$modal.hide('dialog');
                        me.onItemtap_SeatCell_2(value);
                    }
                }]
            });
        }, // eof onItemtap_SeatCell()

        /*******************************************************************
        * Event Listener:click
        *
        * Desc: Click Seat 2.
        * Note:
        *
        * @param {String} value (Clicked Seat)
        * @param {String} direction ('outward', 'return')
        */
        onItemtap_SeatCell_2: function onItemtap_SeatCell_2(value) {

            var me = this,
                va = [],
                type = '',
                id_pax = '',
                kop = '',
                clickAllowed = '',
                // Is available?
            remark = null,
                element = null,
                cellId = value.target.dataset.target;

            me.$toc('>>> booking/passengers/Passenger.vue >>> onItemtap_SeatCell_2');
            // >>> A 'cellId' at all? --------------------------------------
            if (cellId !== 'no' && cellId !== '') {

                va = cellId.split("_"); // va[0]->'seatName',va[1]->'code',va[2]->'availlabs',va[3]->'type',va[4]->'id_pax',va[5]->'gp_Kop'
                type = va[3]; // 'outward', 'return'

                // >>> Reserved already? -----------------------------------
                if (me.getBookingCartIsSeatAlreadyReserved({ seatName: va[0], type: type }) === '') {

                    id_pax = va[4];
                    type = va[3];
                    kop = va[5];
                    clickAllowed = va[2][0];

                    // >>> Available at all? -------------------------------
                    if (clickAllowed !== 0) {
                        switch (kop) {
                            case "AdultWithoutInfant":
                                clickAllowed = va[2][3];
                                break;
                            case "AdultWithInfant":
                                clickAllowed = va[2][2];
                                break;
                            case "Child":
                                clickAllowed = va[2][1];
                                break;
                            case "Nobody":
                                clickAllowed = 0;
                                break;
                            default:
                                break;
                        }
                    }

                    // >>> Allowed for Kop? Then Check for Remark! ---------
                    if (clickAllowed === '1') {
                        remark = this.getBookingSeatRemark({ seatCode: va[1], type: type });
                        remark = remark.replace(/(?:\r\n|\r|\n)/g, '<br>');
                        if (remark) {
                            // 'Remark':Yes ...
                            this.$modal.show('dialog', {
                                title: me.confirmplease[me.getCurrentLocale],
                                text: remark,
                                buttons: [{
                                    title: me.alertirefuse[me.getCurrentLocale]
                                }, {
                                    title: me.alerticonfirm[me.getCurrentLocale],
                                    default: true,
                                    handler: function handler() {
                                        me.$modal.hide('dialog');
                                        element = document.getElementById(cellId);
                                        element.classList.add("seatmapLoading"); // Note: element.classList.remove("seatmapLoading")
                                        me.onTap_BtnSeatMsgBox_Yes(id_pax, type, cellId);
                                    }
                                }]
                            });
                        }

                        if (!remark) {
                            // 'Remark':No ...
                            element = document.getElementById(cellId);
                            element.classList.add("seatmapLoading"); // Note: element.classList.remove("seatmapLoading")
                            me.onTap_BtnSeatMsgBox_Yes(id_pax, type, cellId);
                        }
                    }
                }
                // <<< Reserved already? -----------------------------------
            }
            // <<< A 'cellId' at all? --------------------------------------
        }, // eof onItemtap_SeatCell_2()


        /*******************************************************************
        * onTap_BtnSeatMsgBox_Yes
        *
        * Desc:
        * Note: Method Name is misleading. Only for reasons of equality.
        *
        * @param {string} id_pax
        * @param {string} type ('out', 'ret')
        * @param {String} cellId (Infos about Cell)
        */
        onTap_BtnSeatMsgBox_Yes: function onTap_BtnSeatMsgBox_Yes(id_pax, type, cellId) {

            var me = this,
                paxrsrvdAlready = '';

            me.$toc('>>> booking/passengers/Passenger.vue >>> onTap_BtnSeatMsgBox_Yes');
            paxrsrvdAlready = me.getBookingCartHasPaxAlreadyReservedASeat({ id_pax: id_pax, type: type }); // Returns 'seatno'
            if (paxrsrvdAlready !== '') {
                me.call_unlockSeat(cellId, id_pax, type, paxrsrvdAlready, true);
            } else {
                me.call_lockSeat(cellId);
            }
        }, // eof onTap_BtnSeatMsgBox_Yes()


        /*******************************************************************
        * onClick_CloseModal()
        *
        * Desc:
        * Note: Method Name is misleading. Only for reasons of equality.
        *
        */
        onClick_CloseModal: function onClick_CloseModal() {

            var me = this;

            me.$toc('>>> booking/passengers/Passenger.vue >>> onClick_CloseModal');
            me.$modal.hide('seatmap-modal');
        }, // eo function onClick_CloseModal()


        /******************************************************************* 'Listeners - eventBus'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onEmit_ReadyToForceRerender()
        *
        * Desc: Handle 'Ready to forece Rerender' after lockSeat Call.
        * Note:
        *
        */
        onEmit_ReadyToForceRerender: function onEmit_ReadyToForceRerender(type) {

            var me = this;

            me.$toc('>>> booking/passengers/Passenger.vue >>> onEmit_ReadyToForceRerender');
            me.forceRerender(type.type);
        }, // eo function onEmit_ReadyToForceRerender()

        /*******************************************************************
        * onEmit_ReadyToForceRerender()
        *
        * Desc: Handle 'lockAfterwards' from 'actn_call_unlockSeat' Call.
        * Note:
        *
        */
        onEmit_LockAfterWards: function onEmit_LockAfterWards(cellId) {

            var me = this;

            me.$toc('>>> booking/passengers/Passenger.vue >>> onEmit_LockAfterWards');
            this.call_lockSeat(cellId);
        }, // eo function onEmit_LockAfterWards()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * forceRerender()
        *
        * Desc: Simply change the Components :key to force rerendering.
        * Note: Triggered via eventBus.
        *
        */
        forceRerender: function forceRerender(direction) {

            var me = this;

            me.$toc('>>> booking/passengers/Passenger.vue >>> forceRerender');
            if (direction === 'outward') {
                this.seatComponentKeyOutward += 1;
            }

            if (direction === 'return') {
                this.seatComponentKeyReturn += 1;
            }
        }, // eo function forceRerender()


        /*******************************************************************
        * addListeners_Seatmap()
        *
        * Desc: Add Click Listeners to Seatmap(s).
        * Note:
        */
        addListeners_Seatmap: function addListeners_Seatmap() {

            var me = this,
                outButts = [],
                retButts = [];

            me.$toc('>>> booking/passengers/Passenger.vue >>> addListeners_Seatmap');
            outButts = document.getElementsByClassName("confirmation-callback-cells-outward");
            for (var i = 0; i < outButts.length; i++) {
                outButts[i].addEventListener("click", function (e) {
                    e.preventDefault(); // The 'Link'
                    me.onItemtap_SeatCell(e, 'outward');
                });
            }

            retButts = document.getElementsByClassName("confirmation-callback-cells-return");
            for (var i = 0; i < retButts.length; i++) {
                retButts[i].addEventListener("click", function (e) {
                    e.preventDefault(); // The 'Link'
                    me.onItemtap_SeatCell(e, 'return');
                });
            }
        }, // eo function addListeners_Seatmap()

        /*******************************************************************
        * removeListeners_Seatmap()
        *
        * Desc: Remove Click Listeners from Seatmap(s).
        * Note:
        *
        */
        removeListeners_Seatmap: function removeListeners_Seatmap() {

            var me = this,
                outButts = [],
                retButts = [];

            me.$toc('>>> booking/passengers/Passenger.vue >>> removeListeners_Seatmap');
            outButts = document.getElementsByClassName("confirmation-callback-cells-outward");
            for (var i = 0; i < outButts.length; i++) {
                outButts[i].removeEventListener("click", {});
            }

            retButts = document.getElementsByClassName("confirmation-callback-cells-return");
            for (var i = 0; i < retButts.length; i++) {
                retButts[i].removeEventListener("click", {});
            }
        }, // eof removeListeners_Seatmap()


        /*******************************************************************
        * buildSalutations()
        *
        * Desc: Build Array of 'Salutations' (trnsltd).
        *
        * @param
        * @return {Array}
        */
        buildSalutations: function buildSalutations() {

            var me = this,
                salutations = [];

            me.$toc('>>> booking/passengers/Passenger.vue >>> buildSalutations');
            salutations.push({ text: me.form_mr[me.getCurrentLocale], value: 'MR' }, { text: me.form_mrs[me.getCurrentLocale], value: 'MRS' });

            return salutations;
        }, // eof buildSalutations()

        /*******************************************************************
        * buildGenders()
        *
        * Desc: Build Array of 'Genders' (trnsltd).
        *
        * @param
        * @return {Array}
        */
        buildGenders: function buildGenders() {

            var me = this,
                genders = [];

            me.$toc('>>> booking/passengers/Passenger.vue >>> buildGenders');
            genders.push({ text: me.form_male[me.getCurrentLocale], value: 'm' }, { text: me.form_female[me.getCurrentLocale], value: 'f' });

            return genders;
        }, // eof buildGenders()

        /*******************************************************************
        * buildMonths()
        *
        * Desc: Build Array of 'Months' (trnsltd).
        *
        * @param
        * @return {Array}
        */
        buildMonths: function buildMonths() {

            var me = this,
                months = [];

            me.$toc('>>> booking/passengers/Passenger.vue >>> buildMonths');
            months.push({ text: me.january[me.getCurrentLocale], value: 1 }, { text: me.february[me.getCurrentLocale], value: 2 }, { text: me.march[me.getCurrentLocale], value: 3 }, { text: me.april[me.getCurrentLocale], value: 4 }, { text: me.may[me.getCurrentLocale], value: 5 }, { text: me.june[me.getCurrentLocale], value: 6 }, { text: me.july[me.getCurrentLocale], value: 7 }, { text: me.august[me.getCurrentLocale], value: 8 }, { text: me.september[me.getCurrentLocale], value: 9 }, { text: me.october[me.getCurrentLocale], value: 10 }, { text: me.november[me.getCurrentLocale], value: 11 }, { text: me.december[me.getCurrentLocale], value: 12 });

            return months;
        }, // eof buildMonths()

        /*******************************************************************
        * buildYears()
        *
        * Desc: Build Array of 'Years'.
        * Note: Pays Attention to ADT, CHD, INF Types.
        *
        * @param {String} type ('ADT, 'CHD', 'INF')
        * @return {Array}
        */
        buildYears: function buildYears(type) {

            var me = this,
                maxChildAge = 12,
                // ToDo: Should be a global Prop
            maxInfantAge = 2,
                // ToDo: Should be a global Prop
            startYearAdult = __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(maxChildAge, 'years').format('YYYY'),
                // moment().subtract(maxChildAge, 'years').add(1, 'years').format('YYYY'),
            startYearChild = __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(maxInfantAge, 'years').format('YYYY'),
                endYearChild = __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(maxChildAge, 'years').format('YYYY'),
                startYearInf = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY'),
                endYearInf = __WEBPACK_IMPORTED_MODULE_5_moment___default()().subtract(maxInfantAge, 'years').format('YYYY'),
                iyear = 0,
                years = [];

            me.$toc('>>> booking/passengers/Passenger.vue >>> buildYears');
            if (type === 'ADT') {
                for (iyear = startYearAdult; iyear >= 1905; iyear -= 1) {
                    years.push({ text: String(iyear), value: iyear });
                }
            }

            if (type === 'CHD') {
                for (iyear = startYearChild; iyear >= endYearChild; iyear -= 1) {
                    years.push({ text: String(iyear), value: iyear });
                }
            }

            if (type === 'INF') {
                for (iyear = startYearInf; iyear >= endYearInf; iyear -= 1) {
                    years.push({ text: String(iyear), value: iyear });
                }
            }

            return years;
        }, // eof buildYears()


        /*******************************************************************
        * travelsWithInfantNumber()
        *
        * Desc:
        * Note:
        *
        * @param {Int} id_pax
        * @return {Int} travelsWithInfantNumber
        */
        travelsWithInfantNumber: function travelsWithInfantNumber(id_pax) {

            var me = this,
                travelsWithInfantNumber = '',
                countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                countADTCHD = countADT + countCHD,
                countADTCHDINF = countADTCHD + countINF;

            // me.$toc('>>> booking/passengers/Passenger.vue >>> travelsWithInfantNumber');
            // >>> ---------------------------------------------------------
            if (countINF === 0) {
                travelsWithInfantNumber = '';
            }

            // >>> ---------------------------------------------------------
            if (countINF !== 0) {
                // >>> Step 1: Catch every Pax Data (INF) ------------------
                for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {
                    // >>> Arrange adults to a baby ------------------------
                    if (i === parseFloat(id_pax) + parseFloat(countADTCHD)) {
                        // console.log('my adt is : ' + id_pax);
                        // console.log('its inf is : ' + i);
                        travelsWithInfantNumber = i;
                    }
                }
            }

            return travelsWithInfantNumber;
        }, // eof travelsWithInfant()


        /*******************************************************************
        * Modals:
        *******************************************************************/
        /*******************************************************************
        * Modal - Events - beforeOpen
        *
        * Desc:
        * Note: Catches 'data' Object from $modal.show.
        *
        */
        beforeOpen: function beforeOpen(event) {

            this.seatmapdata = event.params.data;
        }, // eo function beforeOpen()

        /*******************************************************************
        * Modal - Events - beforeClose
        *
        * Desc:
        * Note:
        *
        */
        beforeClose: function beforeClose(e) {

            this.seatmapdata = {};
        }, // eo function beforeClose()

        /*******************************************************************
        * Modal - Events - opened
        *
        * Desc:
        * Note: Add Listeners to SeatMaps single Seats.
        *
        */
        opened: function opened(e) {

            var me = this;

            this.addListeners_Seatmap();
        }, // eo function opened()

        /*******************************************************************
        * Modal - Events - closed
        *
        * Desc:
        * Note: Remove all Listener from SeatMaps single Seats.
        *
        */
        closed: function closed(e) {

            var me = this;

            this.removeListeners_Seatmap();
        } // eo function closed()

    }) // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__booking_passengers_services_ServiceDetails_vue__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['id_pax', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-service-details': __WEBPACK_IMPORTED_MODULE_0__booking_passengers_services_ServiceDetails_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {
        var _ref;

        return _ref = {
            cat_service: {
                en: 'Service',
                de: 'Service'
            },
            cat_meals: {
                en: 'Meals',
                de: 'Essen'
            },
            cat_pets: {
                en: 'Pets',
                de: 'Tiere'
            }
        }, _defineProperty(_ref, 'cat_pets', {
            en: 'Pets',
            de: 'Tiere'
        }), _defineProperty(_ref, 'cat_sportbag', {
            en: 'Sportequip.',
            de: 'Sportequip.'
        }), _defineProperty(_ref, 'cat_baggage', {
            en: 'Baggage',
            de: 'Gepäck'
        }), _defineProperty(_ref, 'cat_medical', {
            en: 'Medical',
            de: 'Medizinisch'
        }), _defineProperty(_ref, 'category', {
            en: 'Your Services in Category',
            de: 'Ihre Services in Kategorie'
        }), _defineProperty(_ref, 'chooseyourservices', {
            en: 'Select your services',
            de: 'Wählen Sie ihre Services aus'
        }), _ref;
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getBookingSrvcsMealExists', 'getBookingSrvcsServiceExists', 'getBookingSrvcsPetsExists', 'getBookingSrvcsSportbagExists', 'getBookingSrvcsBaggageExists', 'getBookingSrvcsMedicalExists',
    // >>> --------------------------
    'getBookingPassengersSrvcsService', 'getBookingPassengersSrvcsMeals', 'getBookingPassengersSrvcsPets', 'getBookingPassengersSrvcsSportbag', 'getBookingPassengersSrvcsBaggage', 'getBookingPassengersSrvcsMedical',
    // >>> --------------------------
    'getServicesSrvcsMealExists', // (same for 'Services')
    'getServicesSrvcsServiceExists', // (same for 'Services')
    'getServicesSrvcsPetsExists', // (same for 'Services')
    'getServicesSrvcsSportbagExists', // (same for 'Services')
    'getServicesSrvcsBaggageExists', // (same for 'Services')
    'getServicesSrvcsMedicalExists', // (same for 'Services')
    // >>> --------------------------
    'getServicesPassengersSrvcsOfType'] // (same for 'Services') (universal)
    )), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * getActiveTabBooking()
        *
        * Desc: Which Tab is active? (Booking)
        * Note:
        *
        */
        getActiveTabBooking: function getActiveTabBooking(srvcscat) {

            var me = this,
                doesMealExist = this.getBookingSrvcsMealExists,
                doesServiceExist = this.getBookingSrvcsServiceExists,
                doesPetsExist = this.getBookingSrvcsPetsExists,
                doesSportbagExist = this.getBookingSrvcsSportbagExists,
                doesBaggageExist = this.getBookingSrvcsBaggageExists,
                shouldBeActiveTab = false;

            me.$toc('>>> booking/passengers/services/Services.vue >>> getActiveTabBooking');
            if (srvcscat === 'MEAL' && doesMealExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'SERVICE' && doesServiceExist && !doesMealExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'PETS' && doesPetsExist && !doesMealExist && !doesServiceExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'SPORTBAG' && doesSportbagExist && !doesMealExist && !doesServiceExist && !doesPetsExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'BAGGAGE' && doesBaggageExist && !doesMealExist && !doesServiceExist && !doesPetsExist && !doesSportbagExist) {
                shouldBeActiveTab = true;
            }

            return shouldBeActiveTab;
        },
        // eof getActiveTabBooking()

        /*******************************************************************
        * getActiveTab()
        *
        * Desc: Which Tab is active? (Services)
        * Note:
        *
        */
        getActiveTab: function getActiveTab(srvcscat) {

            var me = this,
                doesMealExist = this.getServicesSrvcsMealExists,
                doesServiceExist = this.getServicesSrvcsServiceExists,
                doesPetsExist = this.getServicesSrvcsPetsExists,
                doesSportbagExist = this.getServicesSrvcsSportbagExists,
                doesBaggageExist = this.getServicesSrvcsBaggageExists,
                shouldBeActiveTab = false;

            // me.$toc('>>> booking/passengers/services/Services.vue >>> getActiveTab');
            if (srvcscat === 'MEAL' && doesMealExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'SERVICE' && doesServiceExist && !doesMealExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'PETS' && doesPetsExist && !doesMealExist && !doesServiceExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'SPORTBAG' && doesSportbagExist && !doesMealExist && !doesServiceExist && !doesPetsExist) {
                shouldBeActiveTab = true;
            }
            if (srvcscat === 'BAGGAGE' && doesBaggageExist && !doesMealExist && !doesServiceExist && !doesPetsExist && !doesSportbagExist) {
                shouldBeActiveTab = true;
            }

            return shouldBeActiveTab;
        }
    } // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_fields_PlusMinusField_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'plusminsfield': __WEBPACK_IMPORTED_MODULE_0__shared_fields_PlusMinusField_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Props */
    props: ['id_pax', 'srvcs', 'soap_icon', 'srvcs_image', 'srvcs_type', 'modulo'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            perleg: {
                en: 'Leg',
                de: 'Strecke'
            },
            remark: {
                en: 'Remark',
                de: 'Bemerkung'
            },
            btn_addservices: {
                en: 'ADD SERVICE',
                de: 'HINZUFÜGEN'
            },
            count: {
                en: 'Number',
                de: 'Anzahl'
            },
            servicebookingfor: {
                en: 'Service booking for',
                de: 'Service buchen für'
            },
            outward: {
                en: 'Out',
                de: 'Hin'
            },
            returnflight: {
                en: 'Ret',
                de: 'Rück'
            },
            no: {
                en: 'No',
                de: 'Nein'
            },
            alreadyincart: {
                en: 'This service is already in your shopping cart.',
                de: 'Dieser Service ist bereits in Ihrem Warenkorb.'
            },
            added: {
                en: 'Added to Cart',
                de: 'Hinzugefügt'
            },
            reviews: {
                en: 'Reviews',
                de: 'Reviews'
            },
            comment: {
                en: 'Your Comment',
                de: 'Ihr Kommentar'
            },
            commentfieldisemptytext: {
                en: 'The comment field is a mandatory field:',
                de: 'Das Kommentarfeld ist ein Pflichtfeld:'
            },
            furtherservices_seat_here: {
                en: 'here',
                de: 'hier'
            },
            meal_text2: {
                en: 'Further information can be found in our on-board bistro and sales journal (PDF document)',
                de: 'Nähere Informationen finden Sie in unserem Bord-Bistro- und Bordverkauf-Journal (PDF-Dokument)'
            },
            // >>> --------------------------
            commentFieldIsEmpty: false
            // currentLocale: 'de',

        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getBookingLockfaresResults',
    // >>> --------------------------
    'getBookingCartIsSrvcAlreadyInCart',
    // >>> --------------------------
    'getServicesBookableServicesOutward', 'getServicesBookableServicesReturn'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['actn_setBookingUpdateCartWithSrvcs']), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * srvcsSelected()
        *
        * Desc: Service selected! Call ACTION!
        * Note: Check before Add! 'Passenger has already this Srvcs!'
        *
        *
        * @param {Object} srvcs (selected Srvcs)
        * @return {string}
        */
        srvcsSelected: function srvcsSelected(srvcs) {

            var me = this;

            me.$toc('>>> booking/passengers/services/ServiceDetails.vue >>> srvcsSelected');
            // >>> Attach to Object ---------
            srvcs.srvcs.userInputSrvcsDetails_Count = this.$refs.userInputSrvcsDetails_Count.newValue;
            srvcs.srvcs.userInputSrvcsDetails_ToggleOut = this.$refs.userInputSrvcsDetails_ToggleOut.toggled;
            srvcs.srvcs.userInputSrvcsDetails_ToggleRet = this.$refs.userInputSrvcsDetails_ToggleRet.toggled;

            // >>> #338, CommentField is mandatory
            if (this.$refs.inputService_comment !== undefined) {
                if (this.$refs.inputService_comment.value === '') {
                    this.commentFieldIsEmpty = true;
                } else {
                    this.commentFieldIsEmpty = false;
                    srvcs.srvcs.userInputSrvcsDetails_Comment = this.$refs.inputService_comment.value; // catch/save
                }
            }

            // >>> Add to Cart --------------
            if (!this.getBookingCartIsSrvcAlreadyInCart(srvcs)) {
                // Already in Cart?
                if (!this.commentFieldIsEmpty) {
                    this.actn_setBookingUpdateCartWithSrvcs(srvcs);
                }
            } else {
                me.$toasted.global.sdr_app_error({
                    message: this.alreadyincart[this.getCurrentLocale]
                });
            }
        }, // eof srvcsSelected()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * getDoesSrvcsExistOnOutOrRet()
        *
        * Desc: Check if a Srvcs exist on Flight Direction.
        * Note:
        *
        * @param {String} direction ('out', 'ret')
        * @param {String} code (Srvcs Code)
        * @return {Boolean}
        */
        getDoesSrvcsExistOnOutOrRet: function getDoesSrvcsExistOnOutOrRet(direction, code) {

            var me = this,
                srvcsExist = false;

            // me.$toc('>>> booking/passengers/services/ServiceDetails.vue >>> getDoesSrvcsExistOnOutOrRet');
            if (this.modulo === 'booking') {
                if (direction === 'out') {
                    var result = this.getBookingLockfaresResults.outwardFlight.services.find(function (srvcs) {
                        return String(srvcs.code) === String(code);
                    });
                    if (result !== undefined) {
                        srvcsExist = true;
                    } else {
                        srvcsExist = false;
                    }
                }

                if (direction === 'ret') {
                    if (this.getBookingLockfaresResults.inboundFlight !== null) {
                        var _result = this.getBookingLockfaresResults.inboundFlight.services.find(function (srvcs) {
                            return String(srvcs.code) === String(code);
                        });
                        if (_result !== undefined) {
                            srvcsExist = true;
                        } else {
                            srvcsExist = false;
                        }
                    } else {
                        srvcsExist = false;
                    }
                }
            }

            if (this.modulo === 'services') {
                if (direction === 'out') {
                    var _result2 = this.getServicesBookableServicesOutward.bookableServicesRS.services.find(function (srvcs) {
                        return String(srvcs.code) === String(code);
                    });
                    if (_result2 !== undefined) {
                        srvcsExist = true;
                    } else {
                        srvcsExist = false;
                    }
                }

                if (direction === 'ret') {
                    if (this.getServicesBookableServicesReturn !== null) {
                        var _result3 = this.getServicesBookableServicesReturn.bookableServicesRS.services.find(function (srvcs) {
                            return String(srvcs.code) === String(code);
                        });
                        if (_result3 !== undefined) {
                            srvcsExist = true;
                        } else {
                            srvcsExist = false;
                        }
                    }
                }
            }

            return srvcsExist;
        } // eof getDoesSrvcsExistOnOutOrRet()

    }) // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	/* >>> *************************************************************** / /* Props */
	props: {

		value: {
			default: 0,
			type: Number
		},
		min: {
			default: 1,
			type: Number
		},
		max: {
			default: undefined,
			type: Number
		}

	}, // eof props{}
	/* <<< ****************************************************************/

	/* >>> *************************************************************** / /* Data */
	data: function data() {

		return {
			newValue: 0
		};
	},
	// eof data()
	/* <<< ****************************************************************/

	/* >>> *************************************************************** / /* Watch */
	watch: {

		value: {
			handler: function handler(newVal, oldVal) {
				this.newValue = newVal;
			}
		}

	}, // eof watch{}
	/* <<< ****************************************************************/

	/* >>> *************************************************************** /  /* LifeCycles */
	/***********************************************************************
 * Lifecyclehook::created
 *
 * Desc:
 * Note:
 *
 */
	created: function created() {

		this.newValue = this.value;
	}, // eof created()
	/* <<< ****************************************************************/

	/* >>> *************************************************************** / /* Methods */
	methods: {
		getNotificationClass: function getNotificationClass(notification) {

			return 'alert alert-' + notification.type;
		},


		mpplus: function mpplus() {

			if (this.max === undefined || this.newValue < this.max) {
				this.newValue = this.newValue + 1;
				this.$emit('input', this.newValue);
			}
		},

		mpminus: function mpminus() {

			if (this.newValue > this.min) {
				this.newValue = this.newValue - 1;
				this.$emit('input', this.newValue);
			}
		}

	} // eof methods{}
	/* <<< ****************************************************************/
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flightdirection', 'pax'],
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            smlegend: {
                en: 'Seating plan Legend',
                de: 'Sitzplan Legende'
            },
            smseattypes: {
                en: 'Seat Types:',
                de: 'Sitztypen:'
            },
            smreserved: {
                en: 'Reserved',
                de: 'Reserviert'
            },
            smseattypesexplanations: {
                en: 'Make your choice.',
                de: 'Treffen Sie Ihre Wahl.'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'getBookingSeatReservationLockingCodeResults', 'getBookingSeatPlanOutwardResults', 'getBookingSeatPlanReturnResults', 'getBookingCartIsSeatAlreadyReserved', 'getBookingSeatFreeColor', 'getBookingUsersSearchData'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /*******************************************************************
        * Utilities: Build Seatmap(s)
        *******************************************************************/
        /*******************************************************************
        * bldTpl_Stmp_Cmpl()
        *
        * Desc: Build Seatmap Complete.
        * Note:
        *
        * @param {String} flightdirection
        * @param {Object} pax
        * @return {String}
        */
        bldTpl_Stmp_Cmpl: function bldTpl_Stmp_Cmpl(flightdirection, pax) {

            var me = this,
                s = '';

            me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTpl_Stmp_Cmpl');
            s += me.bldTplSs_Stmp_Legend(flightdirection);
            s += me.bldTplSs_Stmp(flightdirection, pax);

            return s;
        }, // eof bldTpl_Stmp_Cmpl()

        /*******************************************************************
        * bldTplSs_Stmp()
        *
        * Desc: Build Subset of Seatmap.
        * Note: Cockpit Pic (Width?) ->
        * Note: (seats_per_row + 2) x 14 (pix - Seatwidth)
        * Note: + (seats_per_row + 3) x 2 (pixel Spacer between Seats)
        * Note: + Rahmen 6 px
        * Note:
        *
        * @param {String}
        * @param {String}
        * @return {String}
        */
        bldTplSs_Stmp: function bldTplSs_Stmp(flightdirection, pax) {

            var me = this,
                s = '',
                cellStore = '',
                cellRows = [],
                seats_per_row = 0,
                cockpitType = '',
                seatDetail = '',
                cell_callback_class = null;

            me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTplSs_Stmp');
            // >>> The right 'Source' to use -------------------------------
            if (flightdirection === 'outward') {
                cellStore = this.getBookingSeatPlanOutwardResults;
                cell_callback_class = 'confirmation-callback-cells-outward';
            }
            if (flightdirection === 'return') {
                cellStore = this.getBookingSeatPlanReturnResults;
                cell_callback_class = 'confirmation-callback-cells-return';
            }
            // <<< The right 'Source' to use -------------------------------


            // >>> Build Cockpit -------------------------------------------
            seats_per_row = parseInt(cellStore.getSeatPlanResponse.cellRows[2].seatCells.length, 10);
            cockpitType = seats_per_row * 25 + 6 + (seats_per_row * 2 + 2);
            s += me.bldTplSs_Stmp_Cockpit(cockpitType);
            // <<<s Build Cockpit ------------------------------------------


            // >>> 'Row per Row & Cell per Cell' ---------------------------
            s += '<div align="center" style="padding-top: 0px;">';
            s += '   <table class="seatmap" border="0">';
            s += '   <tbody>';

            // >>> ---------------------------------------------------------
            // >>> Row per Row, from Left to Right -------------------------
            cellRows = cellStore.getSeatPlanResponse.cellRows;
            for (var i = 0; i < cellRows.length; i++) {
                s += '<tr>';

                // >>> -----------------------------------------------------
                // >>> Left Row Desc-Row ----------------------------------- /* Left to Right: 1 */
                s += '<td bgcolor="#FFFFFF" class="seatmap_header">';
                if (cellRows[i].hasSeats) {
                    for (var x = 1; cellRows[i].seatCells.length; x++) {
                        // Not cool! Try to find out ROW Desc
                        if (cellRows[i].seatCells[x].seatName !== undefined) {
                            s += cellRows[i].seatCells[x].seatName.length === 2 ? cellRows[i].seatCells[x].seatName.substring(0, 1) : cellRows[i].seatCells[x].seatName.substring(0, 2);
                            break;
                        }
                    }
                } else {
                    s += ' &nbsp;';
                }
                s += '</td>';
                // <<< Left Row Desc-Row -----------------------------------
                // <<< -----------------------------------------------------


                // >>> -----------------------------------------------------
                // >>> Left Space-Row --------------------------------------  /* Left to Right: 2 */
                s += '<td bgcolor="#FFFFFF" width="3" style="width: 3px;">';
                s += '  &nbsp;';
                s += '</td>';
                // <<< Left Space-Row --------------------------------------
                // <<< -----------------------------------------------------


                // >>> -----------------------------------------------------
                // >>> Left Wing/Row --------------------------------------- /* Left to Right: 3 */
                s += '<td style="background-color: #FFFFFF;">';
                if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row || cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                    if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row) {
                        s += '<img src="/res/images/services/seats/wing_left-start.png">';
                    }
                    if (cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                        s += '  <img src="/res/images/services/seats/wing_left-start.png">';
                    }
                } else {
                    s += '&nbsp;';
                }
                s += '</td>';
                // <<< Left Wing/Row ---------------------------------------
                // <<< -----------------------------------------------------


                // >>> ----------------------------------------------------- /* Left to Right: 4 */
                // >>> Left FrameBorder ------------------------------------
                if (cellRows[i].row === -1) {
                    s += '<td rowspan="' + parseInt(cellRows.length, 10) + '" bgcolor="#cccccc" width="3" height="3" style="width:3px;min-width:3px;height:3px;min-height:3px;">';
                    s += '   <img src="/res/images/services/seats/op.gif" width="3" height="3" style="height: 3px; width: 3px;">';
                    s += '</td>';
                }
                // <<< Left FrameBorder ------------------------------------
                // <<< -----------------------------------------------------


                // >>> -----------------------------------------------------
                // >>> Cell per Cell, from Left to Right -------------------
                for (var x = 0; x < cellRows[i].seatCells.length; x++) {

                    seatDetail = me.whatSeatDetails(cellRows[i].seatCells[x], flightdirection, pax);

                    // s += '<td bgcolor="' + seatDetail.cellColor + '" id="' + seatDetail.cellId + '" class="' + seatDetail.tdClass + '">' + seatDetail.tdContent +'</td>'; // {c1} IS OK
                    if (seatDetail.tdClass === 'realseat' || seatDetail.tdClass === 'seatblocked') {
                        s += '<td bgcolor="' + seatDetail.cellColor + '" id="' + seatDetail.cellId + '" class="' + seatDetail.tdClass + '"><a href="#" class="btn ' + cell_callback_class + '" data-target="' + seatDetail.cellId + '" style="padding: 0px 0px;">' + seatDetail.tdContent + '</a></td>'; // {c1}
                    } else {
                        s += '<td bgcolor="' + seatDetail.cellColor + '" id="' + seatDetail.cellId + '" class="' + seatDetail.tdClass + '">' + seatDetail.tdContent + '</td>'; // {c1}
                    }
                }
                // <<< Cell per Cell, from Left to Right -------------------
                // <<< -----------------------------------------------------


                // >>> -----------------------------------------------------
                // >>> Right FrameBorder -----------------------------------
                if (cellRows[i].row === -1) {
                    s += '<td rowspan="' + parseInt(cellRows.length, 10) + '" bgcolor="#cccccc" width="3" height="3" style="width:3px;min-width:3px;height:3px;min-height:3px;">';
                    s += '   <img src="/res/images/services/seats/op.gif" width="3" height="3" style="height: 3px; width: 3px;">';
                    s += '</td>';
                }
                // <<< Right FrameBorder -----------------------------------
                // <<< -----------------------------------------------------


                // >>> -----------------------------------------------------
                // >>> Right Wing/Row --------------------------------------
                s += '<td style="background-color: #FFFFFF;">';
                if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row || cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                    if (cellStore.getSeatPlanResponse.aircraftInfo.wingStartRow === cellRows[i].row) {
                        s += '<img src="/res/images/services/seats/wing_right-start.png">';
                    }
                    if (cellStore.getSeatPlanResponse.aircraftInfo.wingEndRow === cellRows[i].row) {
                        s += '<img src="/res/images/services/seats/wing_right-start.png">';
                    }
                } else {
                    s += '&nbsp;';
                }
                s += '</td>';
                // <<< Right Wing/Row --------------------------------------
                // <<< -----------------------------------------------------

                s += '  </tr>';
            }
            // <<< Row per Row, from Left to Right -------------------------
            // <<< ---------------------------------------------------------


            // >>> FrameBorder Bottom --------------------------------------
            s += '  <tr>';
            s += '      <td bgcolor="#FFFFFF" width="3" style="line-height: 3px; height: 3px;">'; // >>> Row Desc/Row, one Cell
            s += '           &nbsp;';
            s += '       </td>';

            s += '      <td bgcolor="#FFFFFF" width="3" style="line-height: 3px; height: 3px;">'; // >>> Space/Row, one Cell
            s += '           &nbsp;';
            s += '       </td>';

            s += '       <td bgcolor="#FFFFFF" height="3" style="line-height: 3px; height: 3px;">'; // >>> Left Wing/Row, one Cell
            s += '           &nbsp;';
            s += '       </td>';

            s += '       <td colspan="' + parseInt(cellStore.getSeatPlanResponse.cellRows[2].seatCells.length + 2, 10) + '" bgcolor="#CCCCCC" height="3" style="line-height: 3px; height: 3px;">'; /* +2 bec. Frame */
            s += '           <img src="/res/images/services/seats/op.gif" style="height: 3px; width: 3px;">';
            s += '       </td>';

            s += '       <td bgcolor="#FFFFFF" height="3" style="line-height: 3px; height: 3px;">'; // >>> Right Wing/Row, one Cell
            s += '           &nbsp;';
            s += '       </td>';
            s += '  </tr>';
            // >>> FrameBorder Bottom --------------------------------------


            s += '  </tbody>';
            s += '  </table>';
            s += '</div>';
            // <<< 'Row per Row & Cell per Cell' ---------------------------


            return s;
        }, // eof bldTplSs_Stmp()


        /**************************************************************************
        * bldTplSs_Stmp_Legend()
        *
        * Desc: Builds and Returns Seatmaps Legend.
        * Note:
        *
        * @param {String} flightdirection ('outward', 'return')
        * @return {String}
        */
        bldTplSs_Stmp_Legend: function bldTplSs_Stmp_Legend(flightdirection) {

            var me = this,
                s = '',
                storeSeatplan = '',
                seatTypes = [];

            me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTplSs_Stmp_Legend');
            // >>> The right 'Source' to use -------------------------------
            if (flightdirection === 'outward') {
                storeSeatplan = this.getBookingSeatPlanOutwardResults;
            }
            if (flightdirection === 'return') {
                storeSeatplan = this.getBookingSeatPlanReturnResults;
            }
            // <<< The right 'Source' to use -------------------------------


            s += '<div class="travel-story-container box" style="padding: 0px; margin-bottom: 0px;">';
            s += '  <div class="travel-story-content">';
            s += '      <div class="description" style="padding: 0px;">';

            s += '          <div class="panel style1" style="margin-bottom: 0px; border: 0px; box-shadow: none; -webkit-box-shadow: none;">';
            s += '              <h4 class="skin-color panel-title"><span class="index"><i class="soap-icon-bottom"></i></span>';
            s += '                  <a href="#tgg1_' + flightdirection + '" data-toggle="collapse">' + me.smlegend[me.getCurrentLocale] + ':</a>';
            s += '              </h4>';
            s += '              <div class="panel-collapse collapse in" id="tgg1_' + flightdirection + '">';
            s += '                  <div class="panel-content">';

            // s += '<br /><p>' + me.smseattypesexplanations[me.getCurrentLocale] + '</p>';
            s += '<br /><div class="my-trip">';
            s += '  <h5>' + me.smseattypes[me.getCurrentLocale] + '</h5>';
            s += '  <ul>';
            // >>> Build Legend --------------------------------------------
            seatTypes = storeSeatplan.getSeatPlanResponse.seatTypes;
            for (var i = 0; i < seatTypes.length; i++) {
                s += '<li>';
                s += '  <center><a class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #' + seatTypes[i].colorFree + ';">';
                s += '      <br />' + seatTypes[i].description + ' ' + seatTypes[i].price + '&euro;';
                s += '  </a></center>';
                s += '</li>';
            }
            s += '<li>';
            s += '  <center><a class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #' + seatTypes[0].colorReserved + ';"><br />';
            s += me.smreserved[me.getCurrentLocale];
            s += '  </a></center>';
            s += '</li>';
            // <<< Build Legend --------------------------------------------
            s += '  </ul>';
            s += '</div>';

            s += '                  </div>'; // end: panel-content
            s += '              </div>'; // end: panel-collapse collapse
            s += '          </div>'; // end: panel


            s += '        </div>'; // end: class="description
            s += '    </div>'; // end: class="travel-story-content
            s += '</div>'; // end: class="travel-story-container


            return s;
        }, // eof bldTplSs_Stmp_Legend()

        /*******************************************************************
        * bldTplSs_Stmp_Cockpit()
        *
        * Desc: Builds 'Cockpit' Pic at the Top.
        * Note: Different sizes per different Seats per Row.
        *
        * @param {String} cp (Cockpit: )
        * @return {String}
        */
        bldTplSs_Stmp_Cockpit: function bldTplSs_Stmp_Cockpit(cp) {

            var me = this,
                s = '',
                padding = 0;

            me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> bldTplSs_Stmp_Cockpit');
            // 6    SeatsPerRow = 170 (A41 - TXl-SXB)
            // 8    SeatsPerRow = 224 (VIM - VAR-MUC)
            // 9    SeatsPerRow = 136 (A41 - TXl-BSL)
            // 11   SeatsPerRow = 305 (A41 - TXL-CHICAGO)

            if (cp === 170) {
                padding = 54;
            }
            if (cp === 224) {
                padding = 54;
            }
            if (cp === 251) {
                padding = 54;
            }
            if (cp === 305) {
                padding = 54;
            }
            if (cp === 359) {
                padding = 54;
            }

            if (cp === 170 || cp === 224 || cp === 251 || cp === 305 || cp === 359) {
                s += '<div align="center" style="padding-top: 10px;">';
                s += '  <table border="0">';
                s += '  <tr>';
                s += '      <td align="center">';
                s += '          <img src="/res/images/services/seats/cockpit_' + cp + '.png" align="top" style="padding-left:' + padding + 'px;">';
                s += '      </td>';
                s += '  </tr>';
                s += '  </table>';
                s += '</div>';
            }

            return s;
        }, // eof bldTplSs_Stmp_Cockpit()


        /*******************************************************************
        * whatSeatDetails()
        *
        * Desc:
        * Note: Known Seat/Cell - Types, 'SEAT', 'BLANK', 'LAVATORY'.
        *
        * @param {object} values (Exact Cell Infos)
        * @param {object} type (FlightDirection)
        * @param {object} pax (Pax)
        *
        * @return {object} type (Flight Direction)
        */
        whatSeatDetails: function whatSeatDetails(values, type, pax) {

            var me = this,
                tmp_available = '',
                tmp_availableForChild = '',
                tmp_availableWithInfant = '',
                tmp_availableWithoutInfant = '',
                x = [],
                z = [],
                cellStore = '',
                seatDetail = {};

            // me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> whatSeatDetails');
            // >>> The right Source to use ---------------------------------
            if (type === 'outward') {
                cellStore = this.getBookingSeatPlanOutwardResults;
            }
            if (type === 'return') {
                cellStore = this.getBookingSeatPlanReturnResults;
            }
            // <<< The right Source to use ---------------------------------


            // >>> Decide --------------------------------------------------
            switch (values.type) {
                case "BLANK":
                    seatDetail.cellId = 'no';
                    seatDetail.cellColor = 'FFFFFF';
                    seatDetail.tdContent = '<img src="/res/images/services/seats/op.gif">';
                    seatDetail.tdClass = '';
                    break;
                case "LAVATORY":
                    seatDetail.cellId = 'no';
                    seatDetail.cellColor = 'FFFFFF';
                    seatDetail.tdContent = '<img src="/res/images/services/seats/wc.png">';
                    seatDetail.tdClass = '';
                    break;
                case "EXIT":
                    seatDetail.cellId = 'no';
                    seatDetail.cellColor = 'FFFFFF';
                    if (values.orientation === 'LEFT_FLANK') {
                        seatDetail.tdContent = '<img src="/res/images/services/seats/exit-left.png">';
                    } else {
                        seatDetail.tdContent = '<img src="/res/images/services/seats/exit-right.png">';
                    }
                    seatDetail.tdClass = '';
                    break;
                case "EMERGENCY_EXIT":
                    seatDetail.cellId = 'no';
                    seatDetail.cellColor = 'FFFFFF';
                    if (values.orientation === 'LEFT_FLANK') {
                        seatDetail.tdContent = '<img src="/res/images/services/seats/emexit-left.png">';
                    } else {
                        seatDetail.tdContent = '<img src="/res/images/services/seats/emexit-right.png">';
                    }
                    seatDetail.tdClass = '';
                    break;
                case "HEADER":
                    seatDetail.cellId = 'no';
                    seatDetail.cellColor = 'FFFFFF';
                    seatDetail.tdContent = values.description;
                    seatDetail.tdClass = 'seatmap_header';
                    break;
                case "S":
                    // CellType::SEAT
                    x = me.stR_Str_Seatplan_For_SeatColor(values.seatInfo, values.seatName, type, pax.pax.kop, pax.pax.id_pax);

                    tmp_available = values.seatInfo.available === true ? 1 : 0; // trick only: true === 1
                    tmp_availableForChild = values.seatInfo.availableForChild === true ? 1 : 0;
                    tmp_availableWithInfant = values.seatInfo.availableWithInfant === true ? 1 : 0;
                    tmp_availableWithoutInfant = values.seatInfo.availableWithoutInfant === true ? 1 : 0;

                    if (x[0] === true) {
                        // Reserved in Cart already
                        seatDetail.cellId = String(values.seatName + '_' + values.seatInfo.code + '_' + tmp_available + tmp_availableForChild + tmp_availableWithInfant + tmp_availableWithoutInfant + '_' + type + '_' + pax.pax.id_pax + '_' + pax.pax.kop);
                        seatDetail.cellColor = x[2]; //A41M.app.gp_SEATCLR_BLANK;
                        seatDetail.tdContent = x[1];
                        seatDetail.tdClass = '';
                    }

                    if (x[0] !== true) {
                        // NOT Reserved in Cart already
                        seatDetail.cellId = String(values.seatName + '_' + values.seatInfo.code + '_' + tmp_available + tmp_availableForChild + tmp_availableWithInfant + tmp_availableWithoutInfant + '_' + type + '_' + pax.pax.id_pax + '_' + pax.pax.kop);
                        seatDetail.cellColor = x[1];

                        if (x[1] === 'ED1C24') {
                            // color reserved -> No Seat Png!
                            seatDetail.tdClass = 'realseat taken';
                        } else {
                            seatDetail.tdClass = 'realseat';
                        }

                        if (x[2] === 'B') {
                            // Blocked
                            //seatDetail.tdContent  = '<img src="/res/img/seats/blocked.png" style="width:14px; height:14px;">';
                            seatDetail.tdClass = 'seatblocked';
                            seatDetail.tdContent = '&nbsp;&nbsp;&nbsp;&nbsp;';
                        } else {
                            seatDetail.tdContent = '&nbsp;&nbsp;&nbsp;&nbsp;';
                        }
                    }
                    break;
                default:
                    break;
            }

            return seatDetail;
        }, // eof whatSeatDetails()


        /*******************************************************************
        * Store Actions: Seats
        *******************************************************************/
        /*******************************************************************
        * Render 'SeatplanOut' & 'SeatplanRet'.
        *
        * Desc: Returns Seats Color (and Icon).
        * Note:
        *
        * @param {String} seatInfo ('seatInfo', to Identify Color&Avaibil.)
        * @param {String} seatName ('seatName', to recheck in Cart)
        * @param {String} type ('outward', 'return')
        * @param {String} kop (Kind of Persona)
        * @param {String} id_pax ()
        *
        * @return {String} seatColor
        */
        stR_Str_Seatplan_For_SeatColor: function stR_Str_Seatplan_For_SeatColor(seatInfo, seatName, type, kop, id_pax) {

            var me = this,
                storeSeatplan = '',
                reservedAlreadyBy = '',
                colorFree = '',
                paxInfo = '',
                seatColor = [],
                seatCode = seatInfo.code,
                // s5->code
            seatAvailable = seatInfo.available,
                // s1->available
            seatAvailableForChild = seatInfo.availableForChild,
                // s2->availableForChild
            seatAvailableWithInfant = seatInfo.availableWithInfant,
                // s3->availableWithInfant
            seatAvailableWithoutInfant = seatInfo.availableWithoutInfant,
                // s4->availableWithoutInfant
            seatBlocked = seatInfo.block,
                // New: 21012015
            seatTypes = [];

            // me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> stR_Str_Seatplan_For_SeatColor');
            // >>> The right Source to use ---------------------------------
            if (type === 'outward') {
                storeSeatplan = this.getBookingSeatPlanOutwardResults;
            }
            if (type === 'return') {
                storeSeatplan = this.getBookingSeatPlanReturnResults;
            }
            // <<< The right Source to use ---------------------------------


            // >>> Already reserved? ---------------------------------------
            reservedAlreadyBy = this.getBookingCartIsSeatAlreadyReserved({ seatName: seatName, type: type }); // gets pax
            // <<< Already reserved? ---------------------------------------


            // >>> Seat is: RESERVED ALREADY -------------------------------  /* means: already taken (in cart) */
            if (reservedAlreadyBy !== '') {

                colorFree = this.getBookingSeatFreeColor({ seatCode: seatCode, type: type });

                // >>> Check for right 'reserved Icon' ---------------------
                if (reservedAlreadyBy.type === 'CHD') {
                    if (reservedAlreadyBy.paxCredentials.gender === 'F') {
                        seatColor.push(true, '<img src="/res/images/services/seats/ic_girl.png">', colorFree);
                    } else {
                        seatColor.push(true, '<img src="/res/images/services/seats/ic_boy.png">', colorFree);
                    }
                }

                if (reservedAlreadyBy.type !== 'CHD') {
                    if (reservedAlreadyBy.paxCredentials.gender === 'F') {
                        if (this.travelsWithInfantNumber(id_pax) !== '') {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_woman_baby.png">', colorFree);
                        } else {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_woman.png">', colorFree);
                        }
                    }

                    if (reservedAlreadyBy.paxCredentials.gender === 'M') {
                        if (this.travelsWithInfantNumber(id_pax) !== '') {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_man_baby.png">', colorFree);
                        } else {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_man.png">', colorFree);
                        }
                    }

                    if (reservedAlreadyBy.paxCredentials.gender === undefined) {
                        if (this.travelsWithInfantNumber(reservedAlreadyBy.id_pax) !== '') {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_man_baby.png">', colorFree);
                        } else {
                            seatColor.push(true, '<img src="/res/images/services/seats/ic_man.png">', colorFree);
                        }
                    }
                }
                // <<< Check for right 'reserved Icon' ---------------------
            }
            // <<< Seat is: RESERVED ALREADY -------------------------------


            // >>> Seat is: NOT RESERVED ALREADY ---------------------------  /* means: not yet occupied (in cart) */
            if (reservedAlreadyBy === '') {

                // >>> Seat is NOT yet reserved .. Find Color .. -----------
                seatTypes = storeSeatplan.getSeatPlanResponse.seatTypes;
                for (var i = 0; i < seatTypes.length; i++) {

                    if (seatTypes[i].code === seatCode) {
                        // Right SeatType?
                        if (seatAvailable === true) {
                            switch (kop) {// A41M.app.gp_KOP
                                case "AdultWithoutInfant":
                                    if (seatAvailableWithoutInfant === true) {
                                        seatColor.push(false, seatTypes[i].colorFree);
                                    } else {
                                        seatColor.push(false, seatTypes[i].colorReserved);
                                    }
                                    break;
                                case "AdultWithInfant":
                                    if (seatAvailableWithInfant === true) {
                                        seatColor.push(false, seatTypes[i].colorFree);
                                    } else {
                                        seatColor.push(false, seatTypes[i].colorReserved);
                                    }
                                    break;
                                case "Child":
                                    if (seatAvailableForChild === true) {
                                        seatColor.push(false, seatTypes[i].colorFree);
                                    } else {
                                        seatColor.push(false, seatTypes[i].colorReserved);
                                    }
                                    break;
                                case "Nobody":
                                    // Only to See some Change
                                    seatColor.push(false, seatTypes[i].colorReserved);
                                    break;
                                default:
                                    break;
                            }

                            // >>> Hack for : #2470 ------------------------
                            if (seatBlocked) {
                                seatColor[2] = 'B'; // Set a 'B'
                            }
                            // <<< Hack for : #2470 ------------------------
                        }

                        if (seatAvailable === false) {
                            seatColor.push(false, seatTypes[i].colorReserved);
                        }
                    }
                }
                // <<< Seat is NOT yet reserved .. Find Color .. -----------
            }
            // <<< Seat is: NOT RESERVED ALREADY ---------------------------


            return seatColor;
        }, // eof stR_Str_Seatplan_For_SeatColor()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * travelsWithInfantNumber()
        *
        * Desc:
        * Note:
        *
        * @param {Int} id_pax
        * @return {Int} travelsWithInfantNumber
        */
        travelsWithInfantNumber: function travelsWithInfantNumber(id_pax) {

            var me = this,
                travelsWithInfantNumber = '',
                countADT = parseFloat(this.getBookingUsersSearchData.noADT),
                countCHD = parseFloat(this.getBookingUsersSearchData.noCHD),
                countINF = parseFloat(this.getBookingUsersSearchData.noINF),
                countADTCHD = countADT + countCHD,
                countADTCHDINF = countADTCHD + countINF;

            me.$toc('>>> booking/passengers/services/SeatDetails.vue >>> travelsWithInfantNumber');
            // >>> ---------------------------------------------------------
            if (countINF === 0) {
                travelsWithInfantNumber = '';
            }

            // >>> ---------------------------------------------------------
            if (countINF !== 0) {
                // >>> Step 1: Catch every Pax Data (INF) ------------------
                for (var i = countADTCHD + 1; i <= countADTCHDINF; i++) {
                    // >>> Arrange adults to a baby ------------------------
                    if (i === parseFloat(id_pax) + parseFloat(countADTCHD)) {
                        travelsWithInfantNumber = i;
                    }
                }
            }

            return travelsWithInfantNumber;
        } // eof travelsWithInfant()

    } // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_cart_Cart_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var letterspaces = __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["helpers"].regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i); /* Validator */
var numericspaces = __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["helpers"].regex('numericspaces', /^[0-9+/\s]+$/i); /* Validator */
var ibanletters = __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["helpers"].regex('ibanletters', /^DE\d+$/i); /* Validator, 'DE' only */





/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'], // via: router/push
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-shared-cart': __WEBPACK_IMPORTED_MODULE_2__shared_cart_Cart_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            starsaremandatory: {
                en: 'Fields marked with * are required.',
                de: 'Mit * gekennzeichnete Felder sind Pflichtfelder.'
            },
            pleaseselectpayment: {
                en: 'Step 3: Please enter your payment details.',
                de: 'Schritt 3: Bitte geben Sie Ihre Zahldaten an.'
            },
            // >>> --------------------------
            yourpersonaldata: {
                en: 'Your personal information',
                de: 'Ihre persönlichen Daten'
            },
            selectpaymentinfo: {
                en: 'Please choose payment method',
                de: 'Bitte wählen Sie Ihre Zahlart'
            },
            // >>> --------------------------
            yourcardinfo: {
                en: 'Your Card Informations',
                de: 'Ihre Kreditkarten Informationen'
            },
            yourdebitinfo: {
                en: 'Your Debit Informations',
                de: 'Ihre Lastschrift Informationen'
            },
            yourcashinfo: {
                en: 'Your Payment Informations',
                de: 'Ihre Zahlungsinformationen'
            },
            cashnote: {
                en: 'Attention: Agency pays by invoice.',
                de: 'Achtung: Agentur macht Rechnungskauf.'
            },
            // >>> --------------------------
            form_mr: {
                en: 'Mr.',
                de: 'Herr'
            },
            form_mrs: {
                en: 'Mrs.',
                de: 'Frau'
            },
            // >>> --------------------------
            form_companyname: {
                en: 'Company name',
                de: 'Firmenname'
            },
            form_salutation: {
                en: 'Salutation',
                de: 'Anrede'
            },
            form_firstname: {
                en: 'First name',
                de: 'Vorname'
            },
            form_lastname: {
                en: 'Last name',
                de: 'Nachname'
            },
            form_address: {
                en: 'Address',
                de: 'Adresse'
            },
            form_plz: {
                en: 'Zip code',
                de: 'PLZ'
            },
            form_residence: {
                en: 'City',
                de: 'Wohnort'
            },
            form_country: {
                en: 'Country',
                de: 'Land'
            },
            form_mobile: {
                en: 'Mobile phone',
                de: 'Handynummer'
            },
            form_phone: {
                en: 'Phone/Mobile number',
                de: 'Telefon-/Handynummer'
            },
            form_email: {
                en: 'E-Mail',
                de: 'E-Mail'
            },
            form_promo_1: {
                en: 'I want to receive',
                de: 'Ich möchte in Zukunft '
            },
            form_promo_2: {
                en: 'promotional offers in the future.',
                de: 'Werbeangebote erhalten.'
            },
            // >>> --------------------------
            form_cc_type: {
                en: 'Credit Card Type',
                de: 'Kreditkartentyp'
            },
            form_cc_holder: {
                en: 'Card Holder Name',
                de: 'Karteninhaber'
            },
            form_cc_number: {
                en: 'Card Number',
                de: 'Kartennummer'
            },
            form_cc_cvc: {
                en: 'Card identification number',
                de: 'CVC Code'
            },
            form_cc_expirationdate: {
                en: 'Expiration Date',
                de: 'Gültig bis'
            },
            // >>> --------------------------
            form_dd_accountholder: {
                en: 'Account holder',
                de: 'Kontoinhaber'
            },
            form_dd_iban: {
                en: 'IBAN',
                de: 'IBAN'
            },
            form_dd_bic: {
                en: 'BIC',
                de: 'BIC'
            },
            // >>> --------------------------
            paymentmethod_pleaseselect: {
                en: 'Please select',
                de: 'Bitte auswählen'
            },
            paymentmethod_cc: {
                en: 'Creditcard',
                de: 'Kreditkarte'
            },
            paymentmethod_dd: {
                en: 'Direct Debit',
                de: 'Lastschrift'
            },
            paymentmethod_cs: {
                en: 'Invoice Payment',
                de: 'Kauf auf Rechnung'
            },
            // >>> --------------------------
            creditcardnote: {
                en: 'Credit card payments will appear on your bank statement as Air41 GmbH, Taunusstrasse 1,14193 Berlin.',
                de: 'Kreditkartenzahlungen werden auf Ihrem Kontoauszug als Air41 GmbH, Taunusstraße 1,14193 Berlin, ausgewiesen.'
            },
            creditcardnote2: {
                en: 'Important note: Please make sure that your credit card is activated for 3D Secure payment.',
                de: 'Wichtiger Hinweis: Bitte stellen Sie sicher, dass ihre Kreditkarte für die 3D Secure Zahlung freigeschaltet ist.'
            },
            debitnote: {
                en: 'Important note: Payment by direct debit is only possible with a German account.',
                de: 'Wichtiger Hinweis: Die Zahlung per Lastschrift ist nur mit einem deutschen Konto möglich.'
            },
            // >>> --------------------------
            january: {
                en: 'January',
                de: 'Januar'
            },
            february: {
                en: 'February',
                de: 'Februar'
            },
            march: {
                en: 'March',
                de: 'März'
            },
            april: {
                en: 'April',
                de: 'April'
            },
            may: {
                en: 'May',
                de: 'Mai'
            },
            june: {
                en: 'June',
                de: 'Juni'
            },
            july: {
                en: 'July',
                de: 'Juli'
            },
            august: {
                en: 'August',
                de: 'August'
            },
            september: {
                en: 'September',
                de: 'September'
            },
            october: {
                en: 'October',
                de: 'Oktober'
            },
            november: {
                en: 'November',
                de: 'November'
            },
            december: {
                en: 'December',
                de: 'Dezember'
            },
            // >>> --------------------------
            // >>> --------------------------
            errmsg_required: {
                en: 'This Field must not be empty.',
                de: 'Dieses Feld darf nicht leer sein.'
            },
            errmsg_required_2: {
                en: 'Please choose your payment method.',
                de: 'Bitte wählen Sie Ihre Zahlart.'
            },
            // >>> --------------------------
            errmsg_letterspaces: {
                en: 'Letters, "-" and spaces are allowed.',
                de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.'
            },
            // >>> --------------------------
            errmsg_numericspaces: {
                en: 'Numbers, "+/" and spaces are allowed.',
                de: 'Erlaubt sind Zahlen, “+/“ und Leerzeichen.'
            },
            // >>> --------------------------
            errmsg_numeric: {
                en: 'Only numbers are allowed.',
                de: 'Es sind nur Zahlen erlaubt.'
            },
            errmsg_alphanum: {
                en: 'Only numbers and letters are allowed.',
                de: 'Erlaubt sind nur Zahlen und Buchstaben.'
            },
            // >>> --------------------------
            errmsg_min_firstname: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            errmsg_max_firstname: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_lastname: {
                en: 'Allowed length: 2-60 characters.',
                de: 'Erlaubte Länge: 2-60 Zeichen.'
            },
            errmsg_max_lastname: {
                en: 'Allowed length: 2-60 characters.',
                de: 'Erlaubte Länge: 2-60 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_plz: {
                en: 'Allowed length: 4-8 characters.',
                de: 'Erlaubte Länge: 4-8 Zeichen.'
            },
            errmsg_max_plz: {
                en: 'Allowed length: 4-8 characters.',
                de: 'Erlaubte Länge: 4-8 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_residence: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            errmsg_max_residence: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_phone: {
                en: 'Allowed length: 5-18 characters.',
                de: 'Erlaubte Länge: 5-18 Zeichen.'
            },
            errmsg_max_phone: {
                en: 'Allowed length: 5-18 characters.',
                de: 'Erlaubte Länge: 5-18 Zeichen.'
            },
            // >>> --------------------------
            errmsg_email: {
                en: 'Please provide valid e-mail.',
                de: 'Bitte geben Sie eine gültige E-Mail an.'
            },
            // >>> --------------------------
            errmsg_min_company: {
                en: 'Allowed length: 2-90 characters.',
                de: 'Erlaubte Länge: 2-90 Zeichen.'
            },
            errmsg_max_company: {
                en: 'Allowed length: 2-90 characters.',
                de: 'Erlaubte Länge: 2-90 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_iban: {
                en: 'Allowed length: 22 characters.',
                de: 'Erlaubte Länge: 22 Zeichen.'
            },
            errmsg_max_iban: {
                en: 'Allowed length: 22 characters.',
                de: 'Erlaubte Länge: 22 Zeichen.'
            },
            errmsg_countrycode_iban: {
                en: 'Only IBAN starting with DE are allowed.',
                de: 'Erlaubt sind nur IBAN beginnend mit DE.'
            },
            // >>> --------------------------
            errmsg_min_bic: {
                en: 'Allowed length: 8-11 characters.',
                de: 'Erlaubte Länge: 8-11 Zeichen.'
            },
            errmsg_max_bic: {
                en: 'Allowed length: 8-11 characters.',
                de: 'Erlaubte Länge: 8-11 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_ccnumber: {
                en: 'Allowed length: 12-16 characters.',
                de: 'Erlaubte Länge: 12-16 Zeichen.'
            },
            errmsg_max_ccnumber: {
                en: 'Allowed length: 12-16 characters.',
                de: 'Erlaubte Länge: 12-16 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_cccvc: {
                en: 'Allowed length: 3-4 characters.',
                de: 'Erlaubte Länge: 3-4 Zeichen.'
            },
            errmsg_max_cccvc: {
                en: 'Allowed length: 3-4 characters.',
                de: 'Erlaubte Länge: 3-4 Zeichen.'
            },
            // >>> --------------------------
            // >>> --------------------------
            proceed: {
                en: 'PROCEED TO YOUR BOOKING OVERVIEW',
                de: 'WEITER ZU IHRER BUCHUNGSÜBERSICHT'
            },
            // currentLocale: 'de',
            // >>> --------------------------
            showCreditcard: false,
            showCreditcardFake: false,
            showDebit: false,
            showCash: false,
            paymentParams: {}, //

            // >>> -------------------------- 'Form / Model / Vuelidate'
            inputPax_firstName_payment: '',
            inputPax_lastName_payment: '',
            inputPax_address_payment: '',
            inputPax_plz_payment: '',
            inputPax_residence_payment: '',
            inputPax_phone_payment: '',
            inputPax_mobile_payment: '', // not required
            inputPax_company_payment: '', // not required
            inputPax_email_payment: '',
            inputPax_salutation_payment: 'MR',
            inputPax_country_payment: 70,

            inputPay_payment: '',

            inputPayment_cc_holder: '',
            inputPayment_cc_number: '',
            inputPayment_cc_cvc: '',

            inputPayment_dd_accountholder: '',
            inputPayment_dd_iban: '',
            inputPayment_dd_bic: '',
            // >>> --------------------------
            isItAnOOPayment: false
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Validations */
    validations: {

        // >>> firstname --------------------
        inputPax_firstName_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(30),
            letterspaces: letterspaces
        },

        // >>> lastname ---------------------
        inputPax_lastName_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(60),
            letterspaces: letterspaces
        },

        // >>> address ----------------------
        inputPax_address_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(60)
        },

        // >>> plz --------------------------
        inputPax_plz_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            numeric: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["numeric"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(4),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(8)
        },

        // >>> city -------------------------
        inputPax_residence_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(30),
            letterspaces: letterspaces
        },

        // >>> phone ------------------------
        inputPax_phone_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(5),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(18),
            numericspaces: numericspaces
        },

        // >>> email ------------------------
        inputPax_email_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"]
        },

        // >>> mobile ----------------------- not required
        inputPax_mobile_payment: {
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(5),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(18),
            numericspaces: numericspaces
        },

        // >>> company ---------------------- not required
        inputPax_company_payment: {
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(90)
        },

        // >>> paymentchooser ---------------
        inputPay_payment: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },

        // >>> cc holder -------------------
        inputPayment_cc_holder: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(90),
            letterspaces: letterspaces
        },

        // >>> cc number -------------------
        inputPayment_cc_number: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(15),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(19)
        },

        // >>> cc cbc -----------------------
        inputPayment_cc_cvc: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            numeric: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["numeric"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(3),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(4)
        },

        // >>> dd holder -------------------
        inputPayment_dd_accountholder: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(90),
            letterspaces: letterspaces
        },

        // >>> dd iban ---------------------
        inputPayment_dd_iban: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            alphaNum: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["alphaNum"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(22),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(22),
            ibanletters: ibanletters
        },

        // >>> dd bic ---------------------
        inputPayment_dd_bic: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            alphaNum: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["alphaNum"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(8),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(11)
        }

    }, // eo validations{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getFlagBookingPaymentIsReadyForOverview', 'getBookingLockfaresResults', 'getBookingValidatePassengersObject',
    // >>> --------------------------
    'getServicesBookingOptions', // (same for 'Services')
    'getServicesValidatePassengersObject', // (same for 'Services')
    'getServicesValidatePassengersObjectClone', // (same for 'Services' Clone)
    // >>> --------------------------
    'getBookingUsersSearchData', 'getBookingCartOutwardTotal', 'getBookingCartReturnTotal', 'getBookingCartCountServices', // #340
    'get_areWeInServicesBookingNoMode', 'get_ServicesUsersSearchDataBookingno', 'get_ServicesBookingnoSearchResults', 'getBookingFlightIdSelectedOutward', 'getBookingFlightIdSelectedReturn',
    // >>> --------------------------
    'getFlagSharedAgencyLoggedIn', // Agency is logged in?
    'getSharedAgencyLoginResultsAgencyObject', 'get_Flag_Auth_UserLoggedIn', // Agency is logged in?
    'get_authorizationUserdata']), {

        /*******************************************************************
        * paymentParamsData
        *
        * Desc: 'Validate Passengers Object' for Call of same Name.
        * Note:
        *
        */
        paymentParamsData: {
            get: function get() {
                return this.paymentParams;
            },
            set: function set(value) {
                this.paymentParams = value;
            }
        } // eof paymentParamsData{}

    }), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note: Special Prefill here too.
    *
    */
    created: function created() {

        var me = this,
            agencyObject = null;

        me.$toc('>>> booking/payment/Payment.vue >>> mounted');
        // >>> -------------------------- User logged in? Prefill!
        if (this.get_authorizationUserdata !== null) {
            this.inputPax_salutation_payment = this.get_authorizationUserdata.salutation !== null ? this.get_authorizationUserdata.salutation : 'MR'; // Special case
            this.inputPax_country_payment = this.get_authorizationUserdata.idCountry !== null ? this.get_authorizationUserdata.idCountry : 70; // Special case
        }

        if (this.getFlagSharedAgencyLoggedIn === true) {
            agencyObject = JSON.parse(this.getSharedAgencyLoginResultsAgencyObject);
            this.inputPax_country_payment = agencyObject.countryCode !== null ? this.findCountryId(agencyObject.countryCode) : 70; // Special case
        }
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc: Initialize Select Fields.
    * Note: Check here if Agency is logged in.
    * Note: Prefill Agency here. Prefill User here.
    *
    */
    mounted: function mounted() {

        var me = this,
            agencyObject = null;

        me.$toc('>>> booking/payment/Payment.vue >>> mounted');
        me.$selectInits(this.modulo);

        // >>> -------------------------- OOPayment ?
        if (this.modulo === 'services') {
            if (this.getBookingUsersSearchData.rTrip === true) {
                // Roundtrip
                if (this.getBookingCartOutwardTotal === 0 && this.getBookingCartReturnTotal === 0 && this.getBookingCartCountServices > 0) {
                    this.isItAnOOPayment = true;
                }
            }
            if (this.getBookingUsersSearchData.rTrip === false) {
                // Oneway
                if (this.getBookingCartOutwardTotal === 0 && this.getBookingCartCountServices > 0) {
                    this.isItAnOOPayment = true;
                }
            }
        }

        // >>> -------------------------- Agency logged in? Prefill!
        if (this.getFlagSharedAgencyLoggedIn === true) {
            agencyObject = JSON.parse(this.getSharedAgencyLoginResultsAgencyObject);

            this.inputPax_firstName_payment = agencyObject.firstName;
            this.inputPax_lastName_payment = agencyObject.lastName;
            this.inputPax_address_payment = agencyObject.address;
            this.inputPax_plz_payment = agencyObject.plz;
            this.inputPax_residence_payment = agencyObject.city;
            this.inputPax_phone_payment = agencyObject.phone;
            this.inputPax_email_payment = agencyObject.email;
            this.inputPax_company_payment = agencyObject.companyName;

            this.checkValidity();
        }

        // >>> -------------------------- User logged in? Prefill!
        if (this.get_Flag_Auth_UserLoggedIn === true) {
            // agencyObject = JSON.parse(this.get_authorizationUserdata);

            this.inputPax_firstName_payment = this.get_authorizationUserdata.firstName;
            this.inputPax_lastName_payment = this.get_authorizationUserdata.lastName;
            this.inputPax_address_payment = this.get_authorizationUserdata.address;
            this.inputPax_plz_payment = this.get_authorizationUserdata.zipCode;
            this.inputPax_residence_payment = this.get_authorizationUserdata.city;
            this.inputPax_phone_payment = this.get_authorizationUserdata.phone;
            // this.inputPax_mobile_payment        = this.get_authorizationUserdata.mobile;
            this.inputPax_email_payment = this.get_authorizationUserdata.email;
            this.inputPax_company_payment = this.get_authorizationUserdata.companyName;

            this.checkValidity();
        }
    }, // eo function mounted()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(['actn_FlagBookingPaymentIsReadyForOverview', 'actn_setBookingProcessBookingObject',
    // >>> --------------------------
    'actn_setServicesProcessBookingObject'] // (same for 'Services')
    ), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: 'Payment Form' gets submitted.
        * Note: Send 'bookingCode' in 'BookingNoMode'.
        * Note:
        *
        * @param {Object} submitEvent (Event)
        * @return
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                options = {},
                myPaymentParams = {};

            me.$toc('>>> booking/payment/Payment.vue >>> onSubmit');
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            myPaymentParams.bookingKeyCode = this.getBookingLockfaresResults.keycode;
            myPaymentParams.isReservation = false, myPaymentParams.voucherCodes = [];

            // >>> -------------------------- 'customer'
            myPaymentParams.customer = {
                address: submitEvent.target.elements['inputPax_address_payment'].value,
                city: submitEvent.target.elements['inputPax_residence_payment'].value,
                companyName: submitEvent.target.elements['inputPax_company_payment'].value,
                countryCode: this.findCountryIataCode(submitEvent.target.elements['inputPax_country_payment'].value),
                email: submitEvent.target.elements['inputPax_email_payment'].value,
                firstName: submitEvent.target.elements['inputPax_firstName_payment'].value,
                lastName: submitEvent.target.elements['inputPax_lastName_payment'].value,
                // mobile: submitEvent.target.elements['inputPax_mobile_payment'].value,
                phone: submitEvent.target.elements['inputPax_phone_payment'].value,
                salutation: submitEvent.target.elements['inputPax_salutation_payment'].value,
                zipCode: submitEvent.target.elements['inputPax_plz_payment'].value
            };

            // >>> -------------------------- 'payment'
            myPaymentParams.payment = {};
            if (this.showCreditcard) {
                myPaymentParams.payment.ccPayment = {
                    cc_brand: submitEvent.target.elements['inputPayment_cc_type'].value,
                    cc_cvc: submitEvent.target.elements['inputPayment_cc_cvc'].value,
                    cc_expiry_month: submitEvent.target.elements['inputPayment_cc_expirationmonth'].value,
                    cc_expiry_year: submitEvent.target.elements['inputPayment_cc_expirationyear'].value,
                    cc_holder: submitEvent.target.elements['inputPayment_cc_holder'].value,
                    cc_number: submitEvent.target.elements['inputPayment_cc_number'].value
                };
                myPaymentParams.payment.refererIP = "129.12.12.12";
                myPaymentParams.payment.type = "CC";
            }
            if (this.showDebit) {
                myPaymentParams.payment.ddPayment = {
                    bankaccount_holder: submitEvent.target.elements['inputPayment_dd_accountholder'].value,
                    bankaccount_no: submitEvent.target.elements['inputPayment_dd_iban'].value,
                    bankaccount_bankno: submitEvent.target.elements['inputPayment_dd_bic'].value
                };
                myPaymentParams.payment.refererIP = "129.12.12.12";
                myPaymentParams.payment.type = "DD";
            }
            if (this.showCash) {
                // myPaymentParams.payment.csPayment = true;

                myPaymentParams.payment.refererIP = "129.12.12.12";
                myPaymentParams.payment.type = "CS";
            }
            if (this.isItAnOOPayment) {
                myPaymentParams.payment.refererIP = "129.12.12.12";
                myPaymentParams.payment.type = "OO";
            }

            // >>> --------------------------
            if (this.modulo === 'booking') {
                // >>> -------------------------- 'passengers'
                myPaymentParams.passengers = this.getBookingValidatePassengersObject.passengers; // catch (validated) pax & srvcs

                // >>> -------------------------- Next Step..
                this.actn_setBookingProcessBookingObject(myPaymentParams); // Save...
            }

            // >>> --------------------------
            if (this.modulo === 'services' && this.get_areWeInServicesBookingNoMode === false) {
                // >>> -------------------------- 'passengers'
                var deepClone = JSON.parse(JSON.stringify(this.getServicesValidatePassengersObject.passengers));
                myPaymentParams.passengers = deepClone; // catch (validated) pax & srvcs

                // >>> -------------------------- Next Step..
                delete myPaymentParams.bookingKeyCode; // not in 'services'
                delete myPaymentParams.isReservation; // not in 'services'
                delete myPaymentParams.voucherCodes; // not in 'services'
                myPaymentParams.operatorBooking = null;

                for (var i = 0; i < myPaymentParams.passengers.length; i++) {
                    // not in 'services'
                    delete myPaymentParams.passengers[i].id_pax;
                }

                this.actn_setServicesProcessBookingObject(myPaymentParams); // Save...
            }

            // >>> --------------------------
            if (this.modulo === 'services' && this.get_areWeInServicesBookingNoMode === true) {
                // >>> -------------------------- 'passengers'
                myPaymentParams.passengers = this.getServicesValidatePassengersObjectClone.passengers; // catch (validated) pax & srvcs (clone)

                // >>> -------------------------- Next Step..
                delete myPaymentParams.bookingKeyCode; // not in 'services'
                delete myPaymentParams.isReservation; // not in 'services'
                delete myPaymentParams.voucherCodes; // not in 'services'
                myPaymentParams.operatorBooking = null;

                // >>> Special: Mode: Bookinno --------
                myPaymentParams = this.buildProcessBookingObjectForBookinnoSeatsOnly(myPaymentParams);
                // <<< Special: Mode: Bookinno --------

                this.actn_setServicesProcessBookingObject(myPaymentParams); // Save...
            }

            // >>> -------------------------- Last Step..
            me.$vp_m(); // Fake ...

            setTimeout(function () {
                me.$vp_um();
                me.$router.push({ path: '/overview/' + me.modulo });
            }, 1000);

            setTimeout(function () {
                me.$scrollTo('#scrollPointTop', 200, options);
            }, 1500);
        }, // eo function onSubmit()


        /*******************************************************************
        * onChangePaymentMethod()
        *
        * Desc:
        * Note: CC, DD ONLY!
        *
        * @param {Object} event
        * @return
        */
        onChangePaymentMethod: function onChangePaymentMethod(event) {

            var me = this;

            me.$toc('>>> booking/payment/Payment.vue >>> onChangePaymentMethod');
            if (event.target.value === 'cc') {
                this.showCreditcard = true;
                this.showDebit = false;
                this.showCash = false;

                this.actn_FlagBookingPaymentIsReadyForOverview(true);
            }

            if (event.target.value === 'dd') {
                this.showDebit = true;
                this.showCreditcard = false;
                this.showCash = false;

                this.actn_FlagBookingPaymentIsReadyForOverview(true);
            }

            if (event.target.value === 'cs') {
                // Cash Agency
                this.showDebit = false;
                this.showCreditcard = false;
                this.showCash = true;

                this.actn_FlagBookingPaymentIsReadyForOverview(true);
            }

            // >>> ---------------------------------------------------------
            if (event.target.value === '') {
                this.showDebit = false;
                this.showCreditcard = false;

                this.actn_FlagBookingPaymentIsReadyForOverview(false);
            }
        }, // eo function onChangePaymentMethod()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * buildSalutations()
        *
        * Desc: Build Array of 'Salutations' (trnsltd).
        *
        * @param
        * @return {Array}
        */
        buildSalutations: function buildSalutations() {

            var me = this,
                salutations = [];

            me.$toc('>>> booking/payment/Payment.vue >>> buildSalutations');
            salutations.push({ text: me.form_mr[me.getCurrentLocale], value: 'MR' }, { text: me.form_mrs[me.getCurrentLocale], value: 'MRS' });

            return salutations;
        }, // eo function buildSalutations()


        /*******************************************************************
        * buildCountries()
        *
        * Desc: Build Array of 'Countries'.
        *
        * @param
        * @return {Array}
        */
        buildCountries: function buildCountries() {

            var me = this,
                countries = [];

            me.$toc('>>> booking/payment/Payment.vue >>> buildCountries');
            countries.push({ id: 13, iataCode: 'AT', country: 'Austria' }, { id: 65, iataCode: 'FR', country: 'France' }, { id: 70, iataCode: 'DE', country: 'Germany' }, { id: 74, iataCode: 'GR', country: 'Greece' }, { id: 20, iataCode: 'BE', country: 'Belgium' }, { id: 89, iataCode: 'IT', country: 'Italy' }, { id: 238, iataCode: 'GB', country: 'England' }, { id: 171, iataCode: 'SY', country: 'Syria' }, { id: 239, iataCode: 'US', country: 'United States' }, { id: 235, iataCode: 'TR', country: 'Turkey' }, { id: 56, iataCode: 'EG', country: 'Egypt' }, { id: 100, iataCode: 'LB', country: 'Lebanon' }, { id: 103, iataCode: 'LY', country: 'Libya' }, { id: 179, iataCode: 'TS', country: 'Tunisia' }, { id: 113, iataCode: 'MT', country: 'Malta' }, { id: 141, iataCode: 'PL', country: 'Poland' }, { id: 150, iataCode: 'RU', country: 'Russia' }, { id: 126, iataCode: 'NL', country: 'Netherlands' }, { id: 132, iataCode: 'NO', country: 'Norway' }, { id: 52, iataCode: 'DK', country: 'Denmark' }, { id: 170, iataCode: 'SE', country: 'Sweden' }, { id: 162, iataCode: 'ES', country: 'Spain' }, { id: 232, iataCode: 'CH', country: 'Switzerland' }, { id: 64, iataCode: 'FI', country: 'Finland' }, { id: 142, iataCode: 'PT', country: 'Portugal' }, { id: 30, iataCode: 'BG', country: 'Bulgaria' }, { id: 35, iataCode: 'CA', country: 'Canada' }, { id: 200, iataCode: 'LU', country: 'Luxembourg' });

            return countries;
        }, // eo function buildCountries()


        /*******************************************************************
        * findCountryIataCode()
        *
        * Desc: Find iataCode in Countries Array.
        *
        * @param
        * @return {Array}
        */
        findCountryIataCode: function findCountryIataCode(id) {

            var me = this,
                result = null,
                countries = [];

            me.$toc('>>> booking/payment/Payment.vue >>> findCountryIataCode');
            countries.push({ id: 13, iataCode: 'AT', country: 'Austria' }, { id: 65, iataCode: 'FR', country: 'France' }, { id: 70, iataCode: 'DE', country: 'Germany' }, { id: 74, iataCode: 'GR', country: 'Greece' }, { id: 20, iataCode: 'BE', country: 'Belgium' }, { id: 89, iataCode: 'IT', country: 'Italy' }, { id: 238, iataCode: 'GB', country: 'England' }, { id: 171, iataCode: 'SY', country: 'Syria' }, { id: 239, iataCode: 'US', country: 'United States' }, { id: 235, iataCode: 'TR', country: 'Turkey' }, { id: 56, iataCode: 'EG', country: 'Egypt' }, { id: 100, iataCode: 'LB', country: 'Lebanon' }, { id: 103, iataCode: 'LY', country: 'Libya' }, { id: 179, iataCode: 'TS', country: 'Tunisia' }, { id: 113, iataCode: 'MT', country: 'Malta' }, { id: 141, iataCode: 'PL', country: 'Poland' }, { id: 150, iataCode: 'RU', country: 'Russia' }, { id: 126, iataCode: 'NL', country: 'Netherlands' }, { id: 132, iataCode: 'NO', country: 'Norway' }, { id: 52, iataCode: 'DK', country: 'Denmark' }, { id: 170, iataCode: 'SE', country: 'Sweden' }, { id: 162, iataCode: 'ES', country: 'Spain' }, { id: 232, iataCode: 'CH', country: 'Switzerland' }, { id: 64, iataCode: 'FI', country: 'Finland' }, { id: 142, iataCode: 'PT', country: 'Portugal' }, { id: 30, iataCode: 'BG', country: 'Bulgaria' }, { id: 35, iataCode: 'CA', country: 'Canada' }, { id: 200, iataCode: 'LU', country: 'Luxembourg' });

            result = countries.find(function (country) {
                return +country.id === +id;
            });
            return result.iataCode;
        }, // eo function findCountryIataCode()


        /*******************************************************************
        * findCountryId()
        *
        * Desc: Find iCountry in Countries Array via iataCode.
        *
        * @param
        * @return {Array}
        */
        findCountryId: function findCountryId(iataCode) {

            var me = this,
                result = null,
                countries = [];

            me.$toc('>>> booking/payment/Payment.vue >>> findCountryId');
            countries.push({ id: 13, iataCode: 'AT', country: 'Austria' }, { id: 65, iataCode: 'FR', country: 'France' }, { id: 70, iataCode: 'DE', country: 'Germany' }, { id: 74, iataCode: 'GR', country: 'Greece' }, { id: 20, iataCode: 'BE', country: 'Belgium' }, { id: 89, iataCode: 'IT', country: 'Italy' }, { id: 238, iataCode: 'GB', country: 'England' }, { id: 171, iataCode: 'SY', country: 'Syria' }, { id: 239, iataCode: 'US', country: 'United States' }, { id: 235, iataCode: 'TR', country: 'Turkey' }, { id: 56, iataCode: 'EG', country: 'Egypt' }, { id: 100, iataCode: 'LB', country: 'Lebanon' }, { id: 103, iataCode: 'LY', country: 'Libya' }, { id: 179, iataCode: 'TS', country: 'Tunisia' }, { id: 113, iataCode: 'MT', country: 'Malta' }, { id: 141, iataCode: 'PL', country: 'Poland' }, { id: 150, iataCode: 'RU', country: 'Russia' }, { id: 126, iataCode: 'NL', country: 'Netherlands' }, { id: 132, iataCode: 'NO', country: 'Norway' }, { id: 52, iataCode: 'DK', country: 'Denmark' }, { id: 170, iataCode: 'SE', country: 'Sweden' }, { id: 162, iataCode: 'ES', country: 'Spain' }, { id: 232, iataCode: 'CH', country: 'Switzerland' }, { id: 64, iataCode: 'FI', country: 'Finland' }, { id: 142, iataCode: 'PT', country: 'Portugal' }, { id: 30, iataCode: 'BG', country: 'Bulgaria' }, { id: 35, iataCode: 'CA', country: 'Canada' }, { id: 200, iataCode: 'LU', country: 'Luxembourg' });

            result = countries.find(function (country) {
                return String(country.iataCode) === String(iataCode);
            });
            return result.id;
        }, // eo function findCountryId()


        /*******************************************************************
        * buildCreditcards()
        *
        * Desc: Build Array of 'Creditcard' Types.
        *
        * @param
        * @return {Array}
        */
        buildCreditcards: function buildCreditcards() {

            var me = this,
                cards = [];

            me.$toc('>>> booking/payment/Payment.vue >>> buildCreditcards');
            cards.push({ id: 'VISA', card: 'VISA' }, { id: 'MASTER', card: 'MASTER' }
            // { id: 'AMEX',	card: 'AMEX'	}
            );

            return cards;
        }, // eo function buildCreditcards()


        /*******************************************************************
        * buildMonths()
        *
        * Desc: Build Array of 'Months' (trnsltd).
        *
        * @param
        * @return {Array}
        */
        buildMonths: function buildMonths() {

            var me = this,
                months = [];

            me.$toc('>>> booking/payment/Payment.vue >>> buildMonths');
            months.push({ text: me.january[me.getCurrentLocale], value: 1 }, { text: me.february[me.getCurrentLocale], value: 2 }, { text: me.march[me.getCurrentLocale], value: 3 }, { text: me.april[me.getCurrentLocale], value: 4 }, { text: me.may[me.getCurrentLocale], value: 5 }, { text: me.june[me.getCurrentLocale], value: 6 }, { text: me.july[me.getCurrentLocale], value: 7 }, { text: me.august[me.getCurrentLocale], value: 8 }, { text: me.september[me.getCurrentLocale], value: 9 }, { text: me.october[me.getCurrentLocale], value: 10 }, { text: me.november[me.getCurrentLocale], value: 11 }, { text: me.december[me.getCurrentLocale], value: 12 });

            return months;
        }, // eo function buildMonths()


        /*******************************************************************
        * buildYears()
        *
        * Desc: Build Array of 'Years'.
        * Note: +6Year in the Future. -2Years in the Past.
        *
        * @param
        * @return {Array}
        */
        buildYears: function buildYears(type) {

            var me = this,
                startYear = __WEBPACK_IMPORTED_MODULE_5_moment___default()().add(6, 'years').format('YYYY'),

            // endYear = moment().subtract(2, 'years').format('YYYY'),
            endYear = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY'),
                iyear = 0,
                years = [];

            me.$toc('>>> booking/payment/Payment.vue >>> buildYears');
            for (iyear = startYear; iyear >= endYear; iyear -= 1) {
                years.push({ text: String(iyear), value: iyear });
            }

            return years;
        }, // eo function buildYears()


        /*******************************************************************
        * buildProcessBookingObjectForBookinnoSeatsOnly()
        *
        * Desc:
        * Note: Special for Mode:Bookingno. Add Seats only.
        *
        * @param {Object} myPaymentParams
        * @return {Array}
        */
        buildProcessBookingObjectForBookinnoSeatsOnly: function buildProcessBookingObjectForBookinnoSeatsOnly(myPaymentParams) {
            var _this = this;

            var me = this,
                services = [],
                idsFlights = [];

            me.$toc('>>> booking/payment/Payment.vue >>> buildProcessBookingObjectForBookinnoSeatsOnly');
            myPaymentParams.passengers.forEach(function (pax, i) {
                if (pax.seatServices.length === 0) {
                    var _pax$seatServices;

                    // No new Seat
                    services = _this.get_SeatFromOriginalBooking(pax.id_pax, idsFlights);
                    (_pax$seatServices = pax.seatServices).push.apply(_pax$seatServices, _toConsumableArray(services));
                }

                if (pax.seatServices.length !== 0) {
                    var _pax$seatServices2;

                    // At least one new Seat
                    pax.seatServices.forEach(function (seat, i) {
                        idsFlights.push(seat.idFlight);
                    });
                    services = _this.get_SeatFromOriginalBooking(pax.id_pax, idsFlights);
                    (_pax$seatServices2 = pax.seatServices).push.apply(_pax$seatServices2, _toConsumableArray(services));
                }

                idsFlights = []; // reset
            });

            // >>> --------------------------
            myPaymentParams.bookingCodeForModify = this.get_ServicesBookingnoSearchResults[0].bookingCode; // coming from 'Overview'
            myPaymentParams.operatorBooking = this.get_ServicesUsersSearchDataBookingno.bookingCode; // coming from 'Login'


            return myPaymentParams;
        }, // eo function buildProcessBookingObjectForBookinnoSeatsOnly()


        /*******************************************************************
        * get_SeatFromOriginalBooking()
        *
        * Desc:
        * Note: Special for Mode:Bookingno. Add Seats only.
        * Note
        *
        * @param {Number} id_pax
        * @param {Array} idsFlights
        * @return {Object}
        */
        get_SeatFromOriginalBooking: function get_SeatFromOriginalBooking(id_pax, idsFlights) {
            var _this2 = this;

            var me = this,
                services = [];

            me.$toc('>>> booking/payment/Payment.vue >>> get_SeatFromOriginalBooking');
            this.get_ServicesBookingnoSearchResults[0].passengers.forEach(function (pax, i) {
                if (parseFloat(pax.id_pax_own, 10) === parseFloat(id_pax, 10)) {
                    pax.outboundServices.forEach(function (srvcs, i) {
                        if (srvcs.code === 'SEAT') {
                            if (!idsFlights.includes(_this2.getBookingFlightIdSelectedOutward)) {
                                services.push({
                                    code: srvcs.code,
                                    comment: '',
                                    idFlight: _this2.getBookingFlightIdSelectedOutward,
                                    quantity: srvcs.quantity,
                                    tktClass: 'Y',
                                    infantOnLap: '',
                                    lockingCode: '',
                                    seatName: srvcs.seatName.seatName
                                });
                            }
                        }
                    });

                    pax.inboundServices.forEach(function (srvcs, i) {
                        if (srvcs.code === 'SEAT') {
                            if (!idsFlights.includes(_this2.getBookingFlightIdSelectedReturn)) {
                                services.push({
                                    code: srvcs.code,
                                    comment: '',
                                    idFlight: _this2.getBookingFlightIdSelectedReturn,
                                    quantity: srvcs.quantity,
                                    tktClass: 'Y',
                                    infantOnLap: '',
                                    lockingCode: '',
                                    seatName: srvcs.seatName.seatName
                                });
                            }
                        }
                    });
                }
            });

            return services;
        }, // eo function get_SeatFromOriginalBooking()


        /*******************************************************************
        * buildPayments()
        *
        * Desc: Build Array of allowed 'Payment Methods' (trnsltd).
        * Note: CC, DD ONLY! NEW: CS => AGENCY CASH
        *
        * @param
        * @return {Array}
        */
        buildPayments: function buildPayments() {

            var me = this,
                paymentMethods = [];

            me.$toc('>>> booking/payment/Payment.vue >>> buildPayments');
            if (this.modulo === 'booking') {
                if (this.getBookingLockfaresResults.ccPaymentAllowed === true) {
                    paymentMethods.push({ text: me.paymentmethod_cc[me.getCurrentLocale], value: 'cc' });
                }
                if (this.getBookingLockfaresResults.ddPaymentAllowed === true) {
                    paymentMethods.push({ text: me.paymentmethod_dd[me.getCurrentLocale], value: 'dd' });
                }
                // Agency Cash
                if (this.getBookingLockfaresResults.csPaymentAllowed === true) {
                    paymentMethods.push({ text: me.paymentmethod_cs[me.getCurrentLocale], value: 'cs' });
                }
            }

            if (this.modulo === 'services') {
                if (this.getServicesBookingOptions.bookingOptions.CCpaymentAllowed === true) {
                    paymentMethods.push({ text: me.paymentmethod_cc[me.getCurrentLocale], value: 'cc' });
                }
                if (this.getServicesBookingOptions.bookingOptions.DDpaymentAllowed === true) {
                    paymentMethods.push({ text: me.paymentmethod_dd[me.getCurrentLocale], value: 'dd' });
                }
                // Agency Cash
                if (this.getServicesBookingOptions.bookingOptions.CSpaymentAllowed === true) {
                    paymentMethods.push({ text: me.paymentmethod_cs[me.getCurrentLocale], value: 'cs' });
                }
            }

            return paymentMethods;
        }, // eo function buildPayments()


        /*******************************************************************
        * checkValidity()
        *
        * Desc: Build Array of allowed 'Payment Methods' (trnsltd).
        * Note: Pays Attenion to: 'if agency is logged in => prefill'
        * Note: CC, DD ONLY!
        * Note: NEW .. special for 'User logged in'
        *
        * @param
        * @return {Array}
        */
        checkValidity: function checkValidity() {

            var me = this,
                formIsValid = false;

            me.$toc('>>> booking/payment/Payment.vue >>> checkValidity');
            // >>> CC/DD/OO ------------------------------------------------
            if (this.getFlagSharedAgencyLoggedIn) {
                if (this.showCreditcard === true || this.showDebit === true || this.showCash === true || this.isItAnOOPayment === true) {
                    if (!me.$v.inputPax_company_payment.$error) {
                        // not required
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }

                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in'
                        if ((me.$v.inputPax_firstName_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_firstName_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_lastName_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_lastName_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_address_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_address_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_plz_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_plz_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_residence_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_residence_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    // if (formIsValid) {
                    //     if (!me.$v.inputPax_mobile_payment.$error) {
                    //         formIsValid = true;
                    //     } else {
                    //         formIsValid = false;
                    //     }
                    // }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_phone_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_phone_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_email_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_email_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                }
            }

            if (this.get_Flag_Auth_UserLoggedIn) {
                if (this.showCreditcard === true || this.showDebit === true || this.showCash === true || this.isItAnOOPayment === true) {
                    if (!me.$v.inputPax_company_payment.$error) {
                        // not required
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }

                    if (formIsValid) {
                        // gets prefilled in 'User logged in'
                        if (!me.$v.inputPax_firstName_payment.$error && !me.$v.inputPax_firstName_payment.$invalid) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'User logged in
                        if (!me.$v.inputPax_lastName_payment.$error && !me.$v.inputPax_lastName_payment.$invalid) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'User logged in
                        if (!me.$v.inputPax_address_payment.$error && !me.$v.inputPax_address_payment.$invalid) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'User logged in
                        if (!me.$v.inputPax_plz_payment.$error && !me.$v.inputPax_plz_payment.$invalid) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'User logged in
                        if (!me.$v.inputPax_residence_payment.$error && !me.$v.inputPax_residence_payment.$invalid) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    // if (formIsValid) {
                    //     if (!me.$v.inputPax_mobile_payment.$error) {
                    //         formIsValid = true;
                    //     } else {
                    //         formIsValid = false;
                    //     }
                    // }
                    if (formIsValid) {
                        // gets prefilled in 'User logged in
                        if (!me.$v.inputPax_phone_payment.$error && !me.$v.inputPax_phone_payment.$invalid) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'User logged in
                        if (!me.$v.inputPax_email_payment.$error && !me.$v.inputPax_email_payment.$invalid) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                }
            }

            if (!this.getFlagSharedAgencyLoggedIn && !this.get_Flag_Auth_UserLoggedIn) {
                if (this.showCreditcard === true || this.showDebit === true || this.showCash === true || this.isItAnOOPayment === true) {
                    if (!me.$v.inputPax_company_payment.$error) {
                        // not required
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }

                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in'
                        if ((me.$v.inputPax_firstName_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_firstName_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_lastName_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_lastName_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_address_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_address_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_plz_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_plz_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_residence_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_residence_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    // if (formIsValid) {
                    //     if (!me.$v.inputPax_mobile_payment.$error) {
                    //         formIsValid = true;
                    //     } else {
                    //         formIsValid = false;
                    //     }
                    // }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_phone_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_phone_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                    if (formIsValid) {
                        // gets prefilled in 'Agency logged in
                        if ((me.$v.inputPax_email_payment.$dirty || this.getFlagSharedAgencyLoggedIn) && !me.$v.inputPax_email_payment.$error) {
                            formIsValid = true;
                        } else {
                            formIsValid = false;
                        }
                    }
                }
            }

            // >>> CC ------------------------------------------------------
            if (this.showCreditcard === true) {
                if (formIsValid) {
                    //     if (me.$v.inputPayment_cc_holder.$dirty && !me.$v.inputPayment_cc_holder.$error) {
                    //         formIsValid = true;
                    //     } else {
                    //         formIsValid = false;
                    //     }
                    // }
                    // if (formIsValid) {
                    //     if (me.$v.inputPayment_cc_number.$dirty && !me.$v.inputPayment_cc_number.$error) {
                    //         formIsValid = true;
                    //     } else {
                    //         formIsValid = false;
                    //     }
                    // }
                    // if (formIsValid) {
                    //     if (me.$v.inputPayment_cc_cvc.$dirty && !me.$v.inputPayment_cc_cvc.$error) {
                    //         formIsValid = true;
                    //     } else {
                    //         formIsValid = false;
                    //     }
                    formIsValid = true;
                }
            }

            // >>> DD ------------------------------------------------------
            if (this.showDebit === true) {
                if (formIsValid) {
                    if (me.$v.inputPayment_dd_accountholder.$dirty && !me.$v.inputPayment_dd_accountholder.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputPayment_dd_iban.$dirty && !me.$v.inputPayment_dd_iban.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
                if (formIsValid) {
                    if (me.$v.inputPayment_dd_bic.$dirty && !me.$v.inputPayment_dd_bic.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
            }

            // >>> CA ------------------------------------------------------ Cash: Agency
            if (this.showCash === true) {
                if (formIsValid) {
                    formIsValid = true;
                }
            }

            // >>> Trap ----------------------------------------------------
            if (!this.isItAnOOPayment) {
                if (this.showCreditcard === false && this.showDebit === false && this.showCash === false) {
                    formIsValid = false;
                }
            }

            return formIsValid;
        } // eo function checkValidity()

    }) // eo methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__booking_overview_FlightDetails_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_cart_Cart_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'], // via: router/push
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-flight-details': __WEBPACK_IMPORTED_MODULE_1__booking_overview_FlightDetails_vue__["a" /* default */],
        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_2__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_3__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-shared-cart': __WEBPACK_IMPORTED_MODULE_4__shared_cart_Cart_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {
        var _ref;

        return _ref = {
            close: {
                en: 'Close credit card window',
                de: 'Schliesse Kreditkarten Fenster'
            },
            listpoint_agb: {
                en: 'General Terms',
                de: 'AGB'
            },
            listpoint_abb: {
                en: 'Terms and Conditions',
                de: 'ABB'
            },
            listpoint_pcp: {
                en: 'Dangerous goods',
                de: 'Gefährliche Gegenstände'
            },
            listpoint_impressum: {
                en: 'Imprint',
                de: 'Impressum'
            },
            listpoint_sec: {
                en: 'Data Protection & Privacy',
                de: 'Datenschutz'
            },
            pleaseselectoverview: {
                en: 'Step 4: Please check again your details.',
                de: 'Schritt 4: Bitte überprüfen Sie noch einmal Ihre Angaben.'
            },
            // >>> --------------------------
            outwardflight: {
                en: 'Outward',
                de: 'Hinflug'
            },
            returnflight: {
                en: 'Return',
                de: 'Rückflug'
            },
            tab_flightdetails: {
                en: 'Your booking overview',
                de: 'Ihre Buchungsübersicht'
            },
            tab_inflightfeatures: {
                en: 'Inflight Features',
                de: 'Funktionen an Bord'
            },
            tab_baggage: {
                en: 'Baggage',
                de: 'Gepäck'
            },
            tab_farerules: {
                en: 'Fare Rules',
                de: 'Tarifbestimmungen'
            },
            from: {
                en: 'From',
                de: 'Von'
            },
            to: {
                en: 'to',
                de: 'nach'
            },
            tab_header_flightdetails: {
                en: 'Your flight and booking details for the outbound flight',
                de: 'Ihre Flug- und Buchungsdetails zum Hinflug'
            },
            tab_header_flightdetailsreturn: {
                en: 'Your flight and booking details for the inbound flight',
                de: 'Ihre Flug- und Buchungsdetails zum Rückflug'
            },
            tab_header_inflightfeatures: {
                en: 'For your well-being on board',
                de: 'Für Ihr Wohlbefinden an Bord'
            },
            tab_header_farerulesforyourflight: {
                en: 'Fare Rules for your Flight',
                de: 'Tarifregeln für Ihren Flug'
            },
            // >>> --------------------------
            adult: {
                en: 'Adult',
                de: 'Erwachsener'
            },
            child: {
                en: 'Child',
                de: 'Kind'
            },
            infant: {
                en: 'Infant',
                de: 'Kleinkind'
            },
            // >>> --------------------------
            takeoff: {
                en: 'Take off',
                de: 'Abflug'
            },
            landing: {
                en: 'Landing',
                de: 'Ankunft'
            },
            // >>> --------------------------
            airline: {
                en: 'Airline',
                de: 'Airline'
            },
            flighttype: {
                en: 'Flight Type',
                de: 'Tarif'
            },
            cancellation: {
                en: 'Cancellation',
                de: 'Stornierung'
            },
            flightchange: {
                en: 'Flight Change',
                de: 'Umbuchung'
            },
            seatsandbaggage: {
                en: 'Seats & Baggage',
                de: 'Sitze & Gepäck'
            },
            extracharge: {
                en: 'Extra Charge',
                de: 'Aufpreis'
            },
            avgpers: {
                en: 'AVG/PAX',
                de: 'PRO PAX'
            },
            // >>> --------------------------
            mr: {
                en: 'Mr',
                de: 'Herr'
            },
            mrs: {
                en: 'Mrs',
                de: 'Frau'
            },
            chd: {
                en: 'Child',
                de: 'Kind'
            },
            inf: {
                en: 'Infant',
                de: 'Kleinkind'
            },
            // >>> --------------------------
            born: {
                en: 'Born',
                de: 'Geb. am'
            },
            // >>> --------------------------
            form_confirmabb_1: {
                en: 'By continuing, you agree to the Terms and Conditions.',
                de: 'Ich habe die ABB gelesen und erkläre mich damit einverstanden.'
            },
            form_confirmagb_1: {
                en: 'I confirm that I am 18 years or older and I have read and agree to the General Terms.',
                de: 'Ich bestätige, dass ich 18 Jahre oder älter bin und ich habe die AGB gelesen und erkläre mich damit einverstanden.'
            },
            form_confirmdangerous_1: {
                en: 'I have read the information on the carriage of dangerous goods and agree to it.',
                de: 'Ich habe die Informationen zur Beförderung gefährlicher Gegenstände gelesen und erkläre mich damit einverstanden.'
            },
            form_confirmprivacy_1: {
                en: 'I have read the privacy policy and agree to it.',
                de: 'Ich habe die Datenschutzerklärung gelesen und erkläre mich damit einverstanden.'
            },
            form_confirmadditional_1: {
                en: 'I have noted the charges for additional services and agree to it.',
                de: 'Ich habe die Entgelte für Zusatzleistungen zur Kenntnis genommen und erkläre mich damit einverstanden.'
            },
            pleaseclickallcheckboxes: {
                en: 'Please confirm all Checkboxes.',
                de: 'Bitte bestätigen sie alle Checkboxen.'
            },
            // >>> --------------------------
            travelerinformation: {
                en: 'Traveler Information',
                de: 'Reisende Infos'
            },
            payment: {
                en: 'Your Payment details',
                de: 'Ihre Zahlungsdetails'
            },
            paymentmethod: {
                en: 'Your Payment method',
                de: 'Ihre Zahlungsmethode'
            },
            forsecurity: {
                en: 'For security reasons we do not write out your complete payment data here.',
                de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.'
            },
            paymentismadeby: {
                en: 'Payment is made by ',
                de: 'Die Zahlung erfolgt durch '
            },
            creditcard: {
                en: 'Creditcard',
                de: 'Kreditkarte'
            },
            debit: {
                en: 'Direct Debit',
                de: 'Überweisung'
            },
            cashpayment: {
                en: 'Invoice Payment',
                de: 'Kauf auf Rechnung'
            },
            payment_firstname: {
                en: 'FIRST NAME',
                de: 'Vorname'
            },
            payment_lastname: {
                en: 'LAST NAME',
                de: 'Nachname'
            },
            payment_email: {
                en: 'EMAIL ADDRESS',
                de: 'E-Mail'
            },
            payment_phone: {
                en: 'Phone',
                de: 'Telefon'
            },
            payment_address: {
                en: 'STREET ADDRESS AND NUMBER',
                de: 'Adresse'
            },
            payment_zipcode: {
                en: 'ZIP CODE',
                de: 'PLZ'
            },
            payment_city: {
                en: 'TOWN / CITY',
                de: 'Wohnort'
            },
            payment_countrycode: {
                en: 'COUNTRY',
                de: 'Land'
            },
            // >>> --------------------------
            pleaseconfirm: {
                en: 'Please confirm',
                de: 'Bitte bestätigen Sie'
            },
            flightprice: {
                en: 'Flight price',
                de: 'Flugpreis'
            },
            tincludedtaxes: {
                en: 'incl. Taxes, Fees & Surcharges',
                de: 'inkl. Steuern, Gebühren & Zuschlägen'
            },
            total: {
                en: 'Total',
                de: 'Gesamt'
            },
            totaloutwardprice: {
                en: 'Total Outward',
                de: 'Gesamt Hinflug'
            },
            totalreturnprice: {
                en: 'Total Return',
                de: 'Gesamt Rückflug'
            },
            // >>> --------------------------
            inflightfeatures_wifi: {
                en: 'WI_FI',
                de: 'WI_FI'
            },
            inflightfeatures_entertainment: {
                en: 'Entertainment',
                de: 'Entertainment'
            },
            inflightfeatures_television: {
                en: 'Television',
                de: 'Fernsehen'
            }
        }, _defineProperty(_ref, 'inflightfeatures_television', {
            en: 'Television',
            de: 'Fernsehen'
        }), _defineProperty(_ref, 'inflightfeatures_airconditioning', {
            en: 'Air conditioning',
            de: 'Klimatisierung'
        }), _defineProperty(_ref, 'inflightfeatures_drink', {
            en: 'Drink',
            de: 'Getränke'
        }), _defineProperty(_ref, 'inflightfeatures_drink', {
            en: 'Drink',
            de: 'Getränke'
        }), _defineProperty(_ref, 'inflightfeatures_games', {
            en: 'Games',
            de: 'Spiele'
        }), _defineProperty(_ref, 'inflightfeatures_coffee', {
            en: 'coffee',
            de: 'Kaffee'
        }), _defineProperty(_ref, 'inflightfeatures_wines', {
            en: 'Wines',
            de: 'Weine'
        }), _defineProperty(_ref, 'inflightfeatures_shopping', {
            en: 'Shopping',
            de: 'Shopping'
        }), _defineProperty(_ref, 'inflightfeatures_food', {
            en: 'Food',
            de: 'Essen'
        }), _defineProperty(_ref, 'inflightfeatures_comfort', {
            en: 'Comfort',
            de: 'Komfort'
        }), _defineProperty(_ref, 'inflightfeatures_magazines', {
            en: 'Magazines',
            de: 'Zeitschriften'
        }), _defineProperty(_ref, 'agencycommision', {
            en: 'Your agency commision is: ',
            de: 'Ihre Agentur-Provision ist: '
        }), _defineProperty(_ref, 'inthissection', {
            en: "In this section you'll find information on baggage allowances, special equipment and sports items as well as restricted items. We've also included some tips to make your trip more enjoyable.",
            de: 'In diesem Abschnitt finden Sie Informationen über Freigepäck, Sonderausstattungen und Sportartikel sowie eingeschränkte Gegenstände. Wir haben auch einige Tipps beigefügt, um Ihre Reise noch angenehmer zu gestalten.'
        }), _defineProperty(_ref, 'proceed', {
            en: 'BOOK WITH OBLIGATION TO PAY',
            de: 'ZAHLUNGSPFLICHTIG BUCHEN'
        }), _defineProperty(_ref, 'threedsecurecancelled', {
            en: '3D Secure Proceedure canceled.',
            de: '3D Secure Vorgang abgebrochen.'
        }), _defineProperty(_ref, 'modattitle', {
            en: 'Your credit card details',
            de: 'Ihre Kreditkarten Daten'
        }), _defineProperty(_ref, 'webcomponenttype', ''), _defineProperty(_ref, 'sections', []), _defineProperty(_ref, 'checkedBoxes', []), _defineProperty(_ref, 'bankaccount_holder', null), _defineProperty(_ref, 'bankaccount_no', null), _defineProperty(_ref, 'bankaccount_bankno', null), _ref;
    }, // eo data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getFlagBookingOverviewIsReadyForProcess', 'getBookingProcessBookingObject', 'getBookingFlightIdSelectedReturn', // got RET Flight?
    'getBookingCart', // Pax per Pax
    'getBookingCartOutwardTotal', // Summed up Outward ALL
    'getBookingCartReturnTotal', // Summed up Return ALL
    // >>> --------------------------
    'getServicesProcessBookingObject', // object fpr process booking
    'getFlagSharedAgencyLoggedIn', // Agency
    'getSharedAgencyLoginResultsAmountAndValue', // Agency (Parts)
    // >>> --------------------------
    'getBookingWireCardEnrollPaymentResults', 'getServicesValidatePassengersObject'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Watch */
    watch: {

        checkedBoxes: function checkedBoxes() {

            if (this.checkedBoxes.length === 3) {
                this.actn_FlagBookingOverviewIsReadyForProcess(true);
            } else {
                this.actn_FlagBookingOverviewIsReadyForProcess(false);
            }
        } // eof checkedBoxes()

    }, // eo watch{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note: Catch Event 'readytoshowbookingsconfirmation' ('Call(s) done ...').
    * Note: Catch Event 'messsage' from iFrame here too.
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> booking/overview/Overview.vue >>> created');
        __WEBPACK_IMPORTED_MODULE_7__main__["eventBus"].$on('readytoshowbookingsconfirmation', this.onEmit_ReadyToShowConfirmation);
        __WEBPACK_IMPORTED_MODULE_7__main__["eventBus"].$on('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);
        __WEBPACK_IMPORTED_MODULE_7__main__["eventBus"].$on('readytodostepafterprebook', this.onEmit_ReadyToDoStepAfterPrebook);
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> booking/overview/Overview.vue >>> beforeDestroy');
        __WEBPACK_IMPORTED_MODULE_7__main__["eventBus"].$off('readytoshowbookingsconfirmation', this.onEmit_ReadyToShowConfirmation);
        __WEBPACK_IMPORTED_MODULE_7__main__["eventBus"].$off('readytoshowwirecardmodal', this.onEmit_ReadyToShowWireCardModal);
        __WEBPACK_IMPORTED_MODULE_7__main__["eventBus"].$off('readytodostepafterprebook', this.onEmit_ReadyToDoStepAfterPrebook);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(['actn_FlagBookingOverviewIsReadyForProcess', 'actn_setServicesProcessBookingResults', 'actn_call_processBooking', 'actn_call_registrationNewSpecials',
    // >>> --------------------------
    'actn_call_wireCardEnrollPayment', // new: wirecard enrollment
    'actn_call_preBooking']), {

        /******************************************************************* 'ServiceCalls - Shared'
        * ServiceCalls: 'Shared'
        *******************************************************************/
        /*******************************************************************
        * Call::'/site/getwebcomponent/'
        *
        * Desc:
        * Note:
        * ToDo: Get it into Booking Shared Store.
        *
        * @param {string} comptype (kind of Component)
        * @param
        */
        call_getwebcomponent: function call_getwebcomponent(comptype) {

            var me = this,
                hdrs = '';

            me.$toc('>>> booking/overview/Overview.vue >>> call_getwebcomponent');
            // >>> 1. Builds Object ----------------------------------------
            var requestParamObject = {
                name: comptype
            };

            // >>> #267, Translation ---------------------------------------
            if (comptype === 'ABB') {
                this.webcomponenttype = this.listpoint_abb[this.getCurrentLocale];
            } else if (comptype === 'AGB') {
                this.webcomponenttype = this.listpoint_agb[this.getCurrentLocale];
            } else if (comptype === 'PCP') {
                this.webcomponenttype = this.listpoint_pcp[this.getCurrentLocale];
            } else if (comptype === 'PCPE') {
                this.webcomponenttype = this.listpoint_sec[this.getCurrentLocale];
            } else {
                this.webcomponenttype = comptype; // remember
            }

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put('/site/getwebcomponent/', requestParamObject).then(function (response) {
                // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.$modal.show('size-modal2', { data: response.data });

                        me.$vp_um();
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        }, // eo function call_getwebcomponent()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: 'Overview Form' gets (not really) submitted.
        * Desc: Decides how to go on from here. Enrollment or Process.
        * Note: CreditCard - YES   => 'wirecard enroll payment'. (@first)
        * Note: CreditCard - NO    => 'normal process payment'.
        *
        * @param {Object} submitEvent (Event)
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                myParams = null,
                myProcessObject = {
                ticketBookingRQObject: null,
                newSpecialsRQObject: null,
                rebookingRQObject: null,
                callName: null
            };

            me.$toc('>>> booking/overview/Overview.vue >>> onSubmit');
            // >>> 'Booking' ------------------------------------
            if (this.modulo === 'booking') {
                // >>> Call(s) - Enrollment or Process? ---------
                if (this.getBookingProcessBookingObject.payment.ccPayment !== undefined) {
                    // creditcard yes    => enrollment
                    // this.actn_call_wireCardEnrollPayment(this.createObjectForEnrollment()); // older

                    myProcessObject.ticketBookingRQObject = this.createObjectForProcessNotCreditCard();
                    myProcessObject.callName = 'TICKET_BOOKING'; // 'TICKET_BOOKING', 'BLANKO', 'REBOOKING'
                    this.actn_call_preBooking(myProcessObject);
                }

                if (this.getBookingProcessBookingObject.payment.ccPayment === undefined) {
                    // creditcard no     => process
                    myParams = this.createObjectForProcessNotCreditCard();
                    this.actn_call_processBooking(myParams);
                }
            }

            // >>> 'Services' -----------------------------------
            if (this.modulo === 'services') {
                // >>> Call(s) - Enrollment or Process? ---------
                if (this.getServicesProcessBookingObject.payment.ccPayment !== undefined) {
                    // creditcard yes    => enrollment
                    // this.actn_call_wireCardEnrollPayment(this.createObjectForEnrollment()); // older
                    myProcessObject.newSpecialsRQObject = this.createObjectForProcessNotCreditCard();
                    myProcessObject.callName = 'BLANKO'; // 'TICKET_BOOKING', 'BLANKO', 'REBOOKING'

                    this.actn_call_preBooking(myProcessObject);
                }

                if (this.getServicesProcessBookingObject.payment.ccPayment === undefined) {
                    // creditcard no     => process
                    myParams = this.createObjectForProcessNotCreditCard();
                    this.actn_call_registrationNewSpecials(myParams);
                }
            }
        }, // eo function onSubmit()


        /******************************************************************* 'Listeners - eventBus'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onEmit_ReadyToShowConfirmation()
        *
        * Desc: Handle 'processBooking': Reaction (push 'Confirmation').
        * Note: Handle 'registrationNewSpecials': Reaction (push 'Confirmation').
        *
        */
        onEmit_ReadyToShowConfirmation: function onEmit_ReadyToShowConfirmation() {

            var me = this,
                options = {};

            me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToShowConfirmation');
            // >>> Scroll Options ------------------------------------------
            options = {
                container: 'body',
                easing: 'linear',
                offset: -60,
                force: true,
                cancelable: true,
                onStart: function onStart(element) {
                    // scrolling started
                },
                onDone: function onDone(element) {
                    // scrolling is done
                },
                onCancel: function onCancel() {
                    // scrolling has been interrupted
                },
                x: false,
                y: true
            };

            setTimeout(function () {
                me.$vp_um();
                me.$vp_um();
                me.$router.push({ path: '/confirmation/' + me.modulo });
            }, 500);

            setTimeout(function () {
                me.$scrollTo('#scrollPointTop', 200, options);
            }, 600);
        }, // eo function onEmit_ReadyToShowConfirmation()


        /*******************************************************************
        * onEmit_ReadyToShowWireCardModal()
        *
        * Desc:
        * Note:
        *
        */
        onEmit_ReadyToDoStepAfterPrebook: function onEmit_ReadyToDoStepAfterPrebook(data) {

            var me = this,
                myProcessObject = null;

            me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToDoStepAfterPrebook');
            // >>> ----------------------------------------
            if (this.modulo === 'booking') {
                myProcessObject = this.createObjectForEnrollment();
                myProcessObject.transactionId = data.transactionId;
                this.actn_call_wireCardEnrollPayment(myProcessObject);
            }

            // >>> ----------------------------------------
            if (this.modulo === 'services') {
                // this.actn_call_registrationNewSpecials(this.createObjectForProcessCreditCard(event));
                myProcessObject = this.createObjectForEnrollment();
                myProcessObject.transactionId = data.transactionId;
                this.actn_call_wireCardEnrollPayment(myProcessObject);
            }
        }, // eo function onEmit_ReadyToDoStepAfterPrebook()


        /*******************************************************************
        * onEmit_ReadyToShowWireCardModal()
        *
        * Desc:
        * Note: No real Modal anymore.
        *
        */
        onEmit_ReadyToShowWireCardModal: function onEmit_ReadyToShowWireCardModal() {

            var me = this,
                myProcessObject = null;

            me.$toc('>>> booking/overview/Overview.vue >>> onEmit_ReadyToShowWireCardModal');
            // >>> ----------------------------------------
            if (this.modulo === 'booking') {
                // myProcessObject = this.createObjectForEnrollment();
                // myProcessObject.tranactionId = data.transactionId;
                // this.actn_call_wireCardEnrollPayment(myProcessObject); // older
                // console.log('now do process booking ....')
                // myProcessObject = this.createObjectForProcessNotCreditCard();
                // myProcessObject.payment.ccPayment.transactionId = this.getBookingWireCardEnrollPaymentResults.transactionID;
                // console.log(this.createObjectForProcessNotCreditCard())
                // console.log(this.getBookingWireCardEnrollPaymentResults)
                // this.actn_call_processBooking(myProcessObject);

                setTimeout(function () {
                    window.location.replace(this.getBookingWireCardEnrollPaymentResults.redirectUrl);
                }.bind(this), 500);
            }

            // >>> ----------------------------------------
            if (this.modulo === 'services') {
                setTimeout(function () {
                    window.location.replace(this.getBookingWireCardEnrollPaymentResults.redirectUrl);
                }.bind(this), 500);
            }
        }, // eo function onEmit_ReadyToShowWireCardModal()


        /*******************************************************************
        * onEmit_MessageFromIFrameWasPosted()
        *
        * Desc: Handler for Event:postMessage (from iFrame).
        * Note:
        * Note:
        *
        * @param {Object} event (Event)
        */
        onEmit_MessageFromIFrameWasPostedOLD: function onEmit_MessageFromIFrameWasPostedOLD(event) {

            var me = this;

            me.$toc('>>> booking/overview/Overview.vue >>> onEmit_MessageFromIFrameWasPosted');
            me.$modal.hide('wirecard-modal', {});

            if (this.modulo === 'booking') {
                if (event.data.status === 'OK' && event.origin === __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* CONF_3DSECURE_ORIGIN */]) {
                    this.actn_call_processBooking(this.createObjectForProcessCreditCard(event));
                }
                if (event.data.status === 'KO' && event.origin === __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* CONF_3DSECURE_ORIGIN */]) {
                    if (event.data.statusReason !== null && event.data.statusReason.length > 0) {
                        me.$toasted.global.sdr_app_error({
                            message: event.data.statusReason[0].description
                        });
                    }
                    if (event.data.statusReason === null || event.data.statusReason.length === 0) {
                        me.$toasted.global.sdr_app_error({
                            message: this.threedsecurecancelled[this.getCurrentLocale]
                        });
                    }
                }
            }

            if (this.modulo === 'services') {
                if (event.data.status === 'OK' && event.origin === __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* CONF_3DSECURE_ORIGIN */]) {
                    this.actn_call_registrationNewSpecials(this.createObjectForProcessCreditCard(event));
                }
                if (event.data.status === 'KO' && event.origin === __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* CONF_3DSECURE_ORIGIN */]) {
                    if (event.data.statusReason !== null && event.data.statusReason.length > 0) {
                        me.$toasted.global.sdr_app_error({
                            message: event.data.statusReason[0].description
                        });
                    }
                    if (event.data.statusReason === null || event.data.statusReason.length === 0) {
                        me.$toasted.global.sdr_app_error({
                            message: this.threedsecurecancelled[this.getCurrentLocale]
                        });
                    }
                }
            }
        }, // eo function onEmit_MessageFromIFrameWasPosted()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * createObjectForEnrollment()
        *
        * Desc: Build Payload Object for Enrollment Call.
        * Note: Both: 'Booking', 'Services'.
        *
        * @return {Object}
        */
        createObjectForEnrollment: function createObjectForEnrollment() {

            var me = this,
                myOverviewParams = {};

            me.$toc('>>> booking/overview/Overview.vue >>> createObjectForEnrollment');
            // >>> 'Booking' ------------------------------------
            if (this.modulo === 'booking') {
                myOverviewParams = _extends({}, this.getBookingProcessBookingObject);

                delete myOverviewParams.bookingKeyCode;
                delete myOverviewParams.isReservation;
                delete myOverviewParams.passengers;
                delete myOverviewParams.voucherCodes;

                myOverviewParams.amount = parseFloat(this.getBookingCartOutwardTotal, 10) + parseFloat(this.getBookingCartReturnTotal, 10);
                myOverviewParams.comment = null;
                myOverviewParams.currency = 'EUR';

                myOverviewParams.payment.ccPayment.idProfiledPaymentData = null;
                myOverviewParams.payment.ccPayment.refererIp = '129.12.12.12';
                myOverviewParams.payment.comments = null;
                myOverviewParams.payment.currencyCode = null;
                myOverviewParams.payment.ddPayment = null;
                myOverviewParams.payment.ndPayment = null;
                myOverviewParams.payment.refererIP = '129.12.12.12';

                if (myOverviewParams.payment.ccPayment.cc_brand === 'MASTER') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'mastercard';
                }
                if (myOverviewParams.payment.ccPayment.cc_brand === 'VISA') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'visa';
                }
                if (myOverviewParams.payment.ccPayment.cc_brand === 'AMEX') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'amex';
                }
            }

            // >>> 'Services' -----------------------------------
            if (this.modulo === 'services') {
                myOverviewParams = _extends({}, this.getServicesProcessBookingObject);

                // >>> Edit Object ------------------------------
                for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                    delete myOverviewParams.passengers[i].id_pax;
                }

                delete myOverviewParams.bookingKeyCode;
                delete myOverviewParams.isReservation;
                delete myOverviewParams.passengers;
                delete myOverviewParams.voucherCodes;

                myOverviewParams.amount = parseFloat(this.getBookingCartOutwardTotal, 10) + parseFloat(this.getBookingCartReturnTotal, 10);
                myOverviewParams.comment = null;
                myOverviewParams.currency = 'EUR';

                myOverviewParams.payment.ccPayment.idProfiledPaymentData = null;
                myOverviewParams.payment.ccPayment.refererIp = '129.12.12.12';
                myOverviewParams.payment.comments = null;
                myOverviewParams.payment.currencyCode = null;
                myOverviewParams.payment.ddPayment = null;
                myOverviewParams.payment.ndPayment = null;
                myOverviewParams.payment.refererIP = '129.12.12.12';

                if (myOverviewParams.payment.ccPayment.cc_brand === 'MASTER') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'mastercard';
                }
                if (myOverviewParams.payment.ccPayment.cc_brand === 'VISA') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'visa';
                }
                if (myOverviewParams.payment.ccPayment.cc_brand === 'AMEX') {
                    myOverviewParams.payment.ccPayment.cc_brand = 'amex';
                }
            }

            return myOverviewParams;
        }, // eo function createObjectForEnrollment()


        /*******************************************************************
        * createObjectForProcessNotCreditCard()
        *
        * Desc: Build Payload Object for Process Call. NOT CC!
        * Note: Both: 'Booking', 'Services'.
        *
        * @return {Object}
        */
        createObjectForProcessNotCreditCard: function createObjectForProcessNotCreditCard() {

            var me = this,
                myOverviewParams = {};

            me.$toc('>>> booking/overview/Overview.vue >>> createObjectForProcessNotCreditCard');
            // >>> 'Booking' ------------------------------------
            if (this.modulo === 'booking') {
                myOverviewParams = _extends({}, this.getBookingProcessBookingObject);
            }

            // >>> 'Services' -----------------------------------
            if (this.modulo === 'services') {
                myOverviewParams = _extends({}, this.getServicesProcessBookingObject);

                var deepClone = JSON.parse(JSON.stringify(this.getServicesValidatePassengersObject.passengers)); // again catch from validate object Bec. it can still get deleted in cart here
                myOverviewParams.passengers = deepClone; // catch (validated) pax & srvcs


                // >>> Edit Object ------------------------------
                for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                    delete myOverviewParams.passengers[i].id_pax;
                }
            }

            return myOverviewParams;
        }, // eo function createObjectForProcessNotCreditCard()


        /*******************************************************************
        * createObjectForProcessCreditCard()
        *
        * Desc: Build Payload Object for Process Call. CC ONLY!
        * Note: Both: 'Booking', 'Services'.
        *
        * @param {Object} event (Event)
        * @return {Object}
        */
        createObjectForProcessCreditCard: function createObjectForProcessCreditCard(event) {

            var me = this,
                myOverviewParams = {};

            me.$toc('>>> booking/overview/Overview.vue >>> createObjectForProcessCreditCard');
            // >>> 'Booking' ------------------------------------
            if (this.modulo === 'booking') {
                myOverviewParams = _extends({}, this.getBookingProcessBookingObject);

                delete myOverviewParams.payment.ccPayment.cc_brand;
                delete myOverviewParams.payment.ccPayment.cc_cvc;
                delete myOverviewParams.payment.ccPayment.cc_expiry_month;
                delete myOverviewParams.payment.ccPayment.cc_expiry_year;
                delete myOverviewParams.payment.ccPayment.cc_holder;
                delete myOverviewParams.payment.ccPayment.cc_number;
                delete myOverviewParams.payment.ccPayment.idProfiledPaymentData;
                delete myOverviewParams.payment.ccPayment.refererIp;

                myOverviewParams.payment.ccPayment.transactionId = event.data.transactionId;
            }

            // >>> 'Services' -----------------------------------
            if (this.modulo === 'services') {
                myOverviewParams = _extends({}, this.getServicesProcessBookingObject);

                // >>> Edit Object ------------------------------
                for (var i = 0; i < myOverviewParams.passengers.length; i++) {
                    delete myOverviewParams.passengers[i].id_pax;
                }

                delete myOverviewParams.payment.ccPayment.cc_brand;
                delete myOverviewParams.payment.ccPayment.cc_cvc;
                delete myOverviewParams.payment.ccPayment.cc_expiry_month;
                delete myOverviewParams.payment.ccPayment.cc_expiry_year;
                delete myOverviewParams.payment.ccPayment.cc_holder;
                delete myOverviewParams.payment.ccPayment.cc_number;
                delete myOverviewParams.payment.ccPayment.idProfiledPaymentData;
                delete myOverviewParams.payment.ccPayment.refererIp;

                myOverviewParams.payment.ccPayment.transactionId = event.data.transactionId;
            }

            return myOverviewParams;
        }, // eo function createObjectForProcessCreditCard()


        /*******************************************************************
        * Modals:
        *******************************************************************/
        /*******************************************************************
        * Modal - Events - beforeOpen
        *
        * Desc:
        * Note: Catches 'data' Object from $modal.show.
        *
        */
        beforeOpen: function beforeOpen(event) {

            this.sections = event.params.data.sections;
        }, // eo function beforeOpen()


        /*******************************************************************
        * Modal - Events - beforeClose
        *
        * Desc: Empty Sections again.
        * Note:
        *
        */
        beforeClose: function beforeClose() {

            this.sections = [];
        } // eo function beforeClose()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightDetails_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e5720f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightDetails_vue__ = __webpack_require__(466);
function injectStyle (ssrContext) {
  __webpack_require__(464)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62e5720f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62e5720f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['flightdirection', 'modulo'], // via: router/push
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {}, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            // >>> --------------------------
            uhr: {
                en: " o'clock",
                de: ' Uhr'
            },
            outwardflight: {
                en: 'Outward',
                de: 'Hinflug'
            },
            returnflight: {
                en: 'Return',
                de: 'Rückfliug'
            },
            tab_flightdetails: {
                en: 'Flight Details',
                de: 'Flug Details'
            },
            tab_inflightfeatures: {
                en: 'Inflight Features',
                de: 'Funktionen an Bord'
            },
            tab_baggage: {
                en: 'Baggage',
                de: 'Gepäck'
            },
            tab_farerules: {
                en: 'Fare Rules',
                de: 'Tarifbestimmungen'
            },
            from: {
                en: 'From',
                de: 'Von'
            },
            to: {
                en: 'to',
                de: 'nach'
            },
            tab_header_flightdetailsoutward: {
                en: 'Your flight and booking details for the outbound flight',
                de: 'Ihre Flug- und Buchungsdetails zum Hinflug'
            },
            tab_header_flightdetailsreturn: {
                en: 'Your flight and booking details for the inbound flight',
                de: 'Ihre Flug- und Buchungsdetails zum Rückflug'
            },
            tab_header_flightdetailsoutwardservices: {
                en: 'Your booking details for the outbound flight',
                de: 'Ihre Buchungsdetails zum Hinflug'
            },
            tab_header_flightdetailsreturnservices: {
                en: 'Your booking details for the inbound flight',
                de: 'Ihre Buchungsdetails zum Rückflug'
            },
            tab_header_inflightfeatures: {
                en: 'For your well-being on board',
                de: 'Für Ihr Wohlbefinden an Bord'
            },
            tab_header_farerulesforyourflight: {
                en: 'Fare Rules for your Flight',
                de: 'Tarifregeln für Ihren Flug'
            },
            // >>> --------------------------
            adult: {
                en: 'Adult',
                de: 'Erwachsener'
            },
            child: {
                en: 'Child',
                de: 'Kind'
            },
            infant: {
                en: 'Infant',
                de: 'Kleinkind'
            },
            // >>> --------------------------
            takeoff: {
                en: 'Take off',
                de: 'Abflug'
            },
            landing: {
                en: 'Landing',
                de: 'Ankunft'
            },
            // >>> --------------------------
            airline: {
                en: 'Airline',
                de: 'Airline'
            },
            flighttype: {
                en: 'Flight Type',
                de: 'Tarif'
            },
            cancellation: {
                en: 'Name Change',
                de: 'Namen ändern'
            },
            flightchange: {
                en: 'Flight Change',
                de: 'Umbuchung'
            },
            seatsandbaggage: {
                en: 'Seats & Baggage',
                de: 'Sitze & Gepäck'
            },
            extracharge: {
                en: 'Extra Charge',
                de: 'Aufpreis'
            },
            avgpers: {
                en: 'AVG/PAX',
                de: 'PRO PAX'
            },
            // >>> --------------------------
            mr: {
                en: 'Mr',
                de: 'Herr'
            },
            mrs: {
                en: 'Mrs',
                de: 'Frau'
            },
            chd: {
                en: 'Child',
                de: 'Kind'
            },
            inf: {
                en: 'Infant',
                de: 'Kleinkind'
            },
            // >>> --------------------------
            born: {
                en: 'Born',
                de: 'Geb. am'
            },
            // >>> --------------------------
            travelerinformation: {
                en: 'Traveler Information',
                de: 'Reisende Infos'
            },
            payment: {
                en: 'Your Payment details',
                de: 'Ihre Zahlungsdetails'
            },
            paymentmethod: {
                en: 'Your Payment method',
                de: 'Ihre Zahlungsmethode'
            },
            forsecurity: {
                en: 'For security reasons we do not write out your complete payment data here.',
                de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.'
            },
            paymentismadeby: {
                en: 'Payment is made by ',
                de: 'Die Zahlung erfolgt durch '
            },
            creditcard: {
                en: 'Creditcard',
                de: 'Kreditkarte'
            },
            debit: {
                en: 'Direct Debit',
                de: 'Überweisung'
            },
            payment_firstname: {
                en: 'FIRST NAME',
                de: 'Vorname'
            },
            payment_lastname: {
                en: 'LAST NAME',
                de: 'Nachname'
            },
            payment_email: {
                en: 'E-MAIL ADDRESS',
                de: 'E-Mail'
            },
            payment_phone: {
                en: 'Phone',
                de: 'Telefon'
            },
            payment_address: {
                en: 'STREET ADDRESS AND NUMBER',
                de: 'Adresse'
            },
            payment_zipcode: {
                en: 'ZIP CODE',
                de: 'PLZ'
            },
            payment_city: {
                en: 'TOWN / CITY',
                de: 'Wohnort'
            },
            payment_countrycode: {
                en: 'COUNTRY',
                de: 'Land'
            },
            // >>> --------------------------
            pleaseconfirm: {
                en: 'Please confirm',
                de: 'Bitte bestätigen Sie'
            },
            flightprice: {
                en: 'Flight price',
                de: 'Flugpreis'
            },
            flightpriceservices: {
                en: 'Flight already booked',
                de: 'Flug schon gebucht'
            },
            tincludedtaxes: {
                en: 'incl. Taxes, Fees & Surcharges',
                de: 'inkl. Steuern, Gebühren & Zuschlägen'
            },
            total: {
                en: 'Total',
                de: 'Gesamt'
            },
            totaloutwardprice: {
                en: 'Total Outward',
                de: 'Gesamt Hinflug'
            },
            totalreturnprice: {
                en: 'Total Return',
                de: 'Gesamt Rückflug'
            },
            seat: {
                en: 'Seat',
                de: 'Sitz'
            }
            // currentLocale: 'de',
        };
    }, // eo funtion  data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getFlagBookingOverviewIsReadyForProcess',
    // 'getBookingProcessBookingObject',
    'getBookingFlightIdSelectedReturn', // got RET Flight?
    'getBookingDepArprtName', 'getBookingDesArprtName', 'getBookingDepArprtNameReturnToOther', 'getBookingDesArprtNameReturnToOther', 'getBookingUsersSearchData_OjArprtCode', 'getBookingCart', // Pax per Pax
    'getBookingLockfaresResults', 'getBookingCartOutwardTotal', // Summed up Outward ALL
    'getBookingCartReturnTotal'] // Summed up Return ALL
    )), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Filters */
    filters: {

        /*******************************************************************
        * dateFlightCart()
        *
        * Desc:
        *
        * @param {string} date (Date to reformat)
        * @return {string}
        */
        dateFlightCart: function dateFlightCart(date) {

            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601).format('DD.MM.YYYY'); // de:
            // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019
        }, // eo function dateFlightCart()


        /*******************************************************************
        * durationFlightCart()
        *
        * Desc: Calculates "Travel Time".
        *
        * @param {int} a (duration in seconds)
        * @return {string}
        */
        durationFlightCart: function durationFlightCart(a) {

            var hours = Math.floor(a / 3600),
                minutes = Math.floor(a / 60) - hours * 60,
                hours_txt = 'S',
                // H
            minutes_txt = ' h'; // M


            if (minutes === 0) {
                return hours + ':00' + minutes_txt;
            } else if (minutes.toString().length === 1) {
                return hours + ':0' + minutes + '' + minutes_txt;
            } else {
                return hours + ':' + minutes + '' + minutes_txt;
            }
        } // eo function durationFlightCart()

    }, // eo filters{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * trnslPaxTypes()
        *
        * Desc:
        *
        * @param
        * @return {Array}
        */
        trnslPaxTypes: function trnslPaxTypes(type) {

            var me = this,
                trnsltdType = '';

            me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxTypes');
            switch (type) {
                case 'ADT':
                    trnsltdType = me.adult[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdType = me.child[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdType = me.infant[me.getCurrentLocale];
                    break;
                default:
                    trnsltdType = '';
            }

            return trnsltdType;
        }, // eo function trnslPaxTypes()


        /*******************************************************************
        * trnslPaxSalutations()
        *
        * Desc:
        *
        * @param
        * @return {Array}
        */
        trnslPaxSalutations: function trnslPaxSalutations(type) {

            var me = this,
                trnsltdSalutation = '';

            me.$toc('>>> booking/overview/FlightDetails.vue >>> trnslPaxSalutations');
            switch (type) {
                case 'MR':
                    trnsltdSalutation = me.mr[me.getCurrentLocale];
                    break;
                case 'MRS':
                    trnsltdSalutation = me.mrs[me.getCurrentLocale];
                    break;
                case 'CHD':
                    trnsltdSalutation = me.chd[me.getCurrentLocale];
                    break;
                case 'INF':
                    trnsltdSalutation = me.inf[me.getCurrentLocale];
                    break;
                default:
                    trnsltdSalutation = '';
            }

            return trnsltdSalutation;
        } // eo function trnslPaxSalutations()

    } // eo methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__booking_overview_FlightDetails_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_sidebar_BookingNoGoBackBox_vue__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_cart_Cart_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Props */
    props: ['modulo'], // via: router/push
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-flight-details': __WEBPACK_IMPORTED_MODULE_0__booking_overview_FlightDetails_vue__["a" /* default */],
        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_1__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-bookingnogoback-box': __WEBPACK_IMPORTED_MODULE_3__shared_sidebar_BookingNoGoBackBox_vue__["a" /* default */], // only for Bookingno Mode
        'sdr-shared-cart': __WEBPACK_IMPORTED_MODULE_4__shared_cart_Cart_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {
        var _ref;

        return _ref = {
            pleaseselectconfirmation: {
                en: 'Your booking code is',
                de: 'Ihr Buchungscode lautet'
            },
            pleaseselectconfirmation2: {
                en: 'Your Invoice-Id is:',
                de: 'Ihre Rechnungsnummer ist:'
            },
            needhelp: {
                en: 'Do you need any help?',
                de: 'Brauchen Sie Hilfe?'
            },
            sideboxhelptext: {
                en: 'We will be happy to help you. Our team consultants are at your disposal around the clock.',
                de: 'Wir helfen Ihnen gerne weiter. Unsere Teamberater stehen Ihnen rund um die Uhr zur Verfügung.'
            },
            bookingconfirmation: {
                en: 'Step 5: We confirm your booking!',
                de: 'Schritt 5: Hiermit bestätigen wir Ihre Buchung!'
            },
            travelerinformation: {
                en: 'Traveler Information',
                de: 'Reisende Infos'
            },
            payment: {
                en: 'Payment',
                de: 'Zahlungsdetails'
            },
            viewbookingdetails: {
                en: 'View Booking Details',
                de: 'Ihre Buchungsdetails'
            },
            thankyou: {
                en: 'Thank You. Your booking order is confirmed now.',
                de: 'Vielen Dank. Ihre Buchungsanfrage ist hiermit bestätigt.'
            },
            emailhassent: {
                en: 'A confirmation e-mail has been sent to your provided e-mail address.',
                de: 'An Ihre angegebene E-Mail-Adresse wurde eine Bestätigungs-E-Mail gesendet.'
            },
            printdetails: {
                en: 'Print Details',
                de: 'Ausdrucken'
            }
        }, _defineProperty(_ref, 'payment', {
            en: 'Your Payment details',
            de: 'Ihre Zahlungsdetails'
        }), _defineProperty(_ref, 'paymentmethod', {
            en: 'Your Payment method',
            de: 'Ihre Zahlungsmethode'
        }), _defineProperty(_ref, 'forsecurity', {
            en: 'For security reasons we do not write out your complete payment data here.',
            de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.'
        }), _defineProperty(_ref, 'paymentismadeby', {
            en: 'Payment is made by ',
            de: 'Die Zahlung erfolgt durch '
        }), _defineProperty(_ref, 'creditcard', {
            en: 'Creditcard',
            de: 'Kreditkarte'
        }), _defineProperty(_ref, 'debit', {
            en: 'Direct Debit',
            de: 'Überweisung'
        }), _defineProperty(_ref, 'cashpayment', {
            en: 'Invoice Payment',
            de: 'Kauf auf Rechnung'
        }), _defineProperty(_ref, 'payment_firstname', {
            en: 'FIRST NAME',
            de: 'Vorname'
        }), _defineProperty(_ref, 'payment_lastname', {
            en: 'LAST NAME',
            de: 'Nachname'
        }), _defineProperty(_ref, 'payment_email', {
            en: 'E-MAIL ADDRESS',
            de: 'E-Mail'
        }), _defineProperty(_ref, 'payment_phone', {
            en: 'Your Payment details',
            de: 'Ihre Zahlungsdetails'
        }), _defineProperty(_ref, 'payment_address', {
            en: 'STREET ADDRESS AND NUMBER',
            de: 'Adresse'
        }), _defineProperty(_ref, 'payment_zipcode', {
            en: 'ZIP CODE',
            de: 'PLZ'
        }), _defineProperty(_ref, 'payment_city', {
            en: 'TOWN / CITY',
            de: 'Wohnort'
        }), _defineProperty(_ref, 'payment_countrycode', {
            en: 'COUNTRY',
            de: 'Land'
        }), _defineProperty(_ref, 'tab_flightdetails', {
            en: 'Flight/Service Details',
            de: 'Flug/Service Details'
        }), _defineProperty(_ref, 'flightpriceservices', {
            en: 'Flight already booked',
            de: 'Flug schon gebucht'
        }), _defineProperty(_ref, 'tincludedtaxes', {
            en: 'incl. Taxes, Fees & Surcharges',
            de: 'inkl. Steuern, Gebühren & Zuschlägen'
        }), _defineProperty(_ref, 'seat', {
            en: 'Seat',
            de: 'Sitz'
        }), _defineProperty(_ref, 'alertsuccessful', {
            en: 'Successful!',
            de: 'Erfolgreich!'
        }), _defineProperty(_ref, 'alertyourbooking', {
            en: 'Your booking has been made.',
            de: 'Ihre Buchung ist erfolgt.'
        }), _ref;
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getBookingProcessBookingObject', 'getBookingProcessBookingResults', 'getBookingFlightIdSelectedReturn', // got RET Flight?
    'getBookingCartOutwardTotal', // Summed up Outward ALL
    'getBookingCartReturnTotal', // Summed up Return ALL
    // >>> --------------------------
    'getServicesProcessBookingObject', 'getServicesProcessBookingResults',
    // >>> --------------------------
    'get_areWeInServicesBookingNoMode'])), // eo computed
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note:
    *
    */
    mounted: function mounted() {

        this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");
    } // eo mounted
    /* <<< ****************************************************************/

});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            needhelp: {
                en: 'Do you want to see your booking again?',
                de: 'Wollen Sie Ihre Buchung noch einmal sehen?'
            },
            sideboxhelptext1: {
                en: 'Back to the start page.',
                de: 'Zurück zur Startseite.'
            },
            sideboxhelptext2: {
                en: 'Call up your booking number again.',
                de: 'Rufen Sie Ihre Buchungsnummer noch einmal auf.'
            },
            goback: {
                en: 'Back to the booking',
                de: 'Zurück zur Buchung'
            }

            // currentLocale: 'de',
        };
    }, // eo data
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])), // eo computed
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(['actn_FlagSharedShowFlightSearchResults', 'actn_FlagServicesShowBookingnoSearchResults']), {

        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onClick_GoBack()
        *
        * Desc:
        * Note:
        *
        */
        onClick_GoBack: function onClick_GoBack() {

            var me = this;

            me.$toc('>>> components/shared/sidebar/BookingNoGoBackBox.vue >>> onClick_GoBack');
            me.actn_FlagSharedShowFlightSearchResults(false); // Hide 'Section'
            me.actn_FlagServicesShowBookingnoSearchResults(false); // Hide 'Section'

            me.$router.go(-4);
        } // eof onClick_GoBack()

    }) // eo methods
    /* <<< ****************************************************************/

});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Information on baggage transport',
                de: 'Informationen zur Gepäckbeförderung'
            },
            // >>> ------------------------
            luggage_h4: {
                en: 'Information about Baggage Transportation',
                de: 'Informationen zur Gepäckbeförderung'
            },
            luggage_h5: {
                en: 'Baggage',
                de: 'Reisegepäck'
            },
            luggage_p_1: {
                en: 'Baggage comprises carry-on baggage and checked baggage.',
                de: 'Ihr Reisegepäck umfasst Handgepäck und aufzugebendes Gepäck.'
            },
            // >>> ------------------------
            luggage_h5_2: {
                en: 'Checked Baggage',
                de: 'Aufzugebendes Gepäck'
            },
            luggage_p_2: {
                en: 'The free baggage allowance for adults and minors with maximum age of 12 Years includes one piece of checked baggage up to 20 kg.<br />The free baggage allowance for minors up to 2 years includes one piece checked baggage up to 20 kg.<br /> Infant equipment (e.g. buggy or pram or cot or child car seat) is included in the free luggage allowance. A registration is not necessary.<br />Excess baggage, sport or (any kind) of special baggage can be booked online under <a href="https://www.sundair.com/services">Services</a> <b>no later than 48h prior departure</b>.<strong><br /><br />On all Beirut flights following exemptions apply:</strong><br />- 10 kg for each infant (until age 2) Additionally one (1) stroller or one (1) buggy or one (1) children’s car seat is free of charge. No pre-registration is needed.<br /><br />Book your additional baggage online until 48 hours before departure under Services.',
                de: 'Das Freigepäck für Erwachsene und Kinder bis 12 Jahre umfasst ein aufzugebendes Gepäckstück bis maximal 20 kg.<br />Das Freigepäck für Kleinkinder bis 2 Jahre umfasst ein aufzugebendes Gepäckstück bis maximal 20 kg.<br />Kinderwagen, Buggys, Babybetten oder Autokindersitze werden innerhalb der Freigepäcksmenge für Kleinkinder (20kg) im Laderaum befördert. Eine Anmeldung ist dafür nicht notwendig.<br /><br /><strong>Auf allen Beirut – Flügen gelten folgende Ausnahmen:</strong><br />- 10 kg für ein Gepäckstück je Kleinkind (bis zum vollendeten 2. Lebensjahr)<br /><br />Zusätzlich wird ein (1) Kinderwagen oder ein (1) Buggy oder ein (1) Autokindersitz kostenfrei befördert.<br />Eine Anmeldung ist dafür nicht notwendig.<br /><br />Buchen Sie Ihr Über-, Sport- oder Sondergepäck <b>bis spätestens 48 Stunden vor Abflug</b> online unter <a href="https://www.sundair.com/services">Services.</a>'
            },
            // >>> ------------------------
            luggage_h5_3: {
                en: 'Carry-On Baggage ',
                de: 'Handgepäck'
            },
            luggage_p_3: {
                en: 'On SUNDAIR flights only one piece of hand luggage up to <b>6kg</b> is allowed in the cabin. It shall not exceed the dimensions <b>55cm x 40cm x 20cm </b>.',
                de: 'Auf jedem Flug dürfen Sie ein Handgepäckstück mit maximal <b>6kg</b> mit in die Kabine nehmen. Es darf die Abmessungen <b>55cm x 40cm x 20cm</b> nicht überschreiten.'
            },
            luggage_p_4: {
                en: 'Please observe the EU-regulations for hand luggage concerning liquids:',
                de: 'Bitte beachten Sie die <b>EU-Handgepäckregelungen</b> für Flüssigkeiten:'
            },
            luggage_li_1: {
                en: 'Single container including liquids should not exceed 100ml ',
                de: 'Einzelne Flüssigkeitsbehältnisse dürfen nicht mehr als 100ml fassen'
            },
            luggage_li_2: {
                en: 'A maximum of 10 containers is allowed in your hand luggage ',
                de: 'Sie dürfen maximal 10 Behältnisse im Handgepäck transportieren'
            },
            luggage_li_3: {
                en: 'Liquids must be transported in a transparent, resealable plastic bag that holds no more than 1 liter',
                de: 'Die Flüssigkeiten müssen in einem durchsichtigen, wiederverschließbaren Plastikbeutel transportiert werden, der maximal 1l fasst'
            },
            luggage_p_5: {
                en: 'Please take your liquids out of hand luggage and show them separately during the security control.',
                de: 'Bitte nehmen Sie Ihre Flüssigkeiten an der Sicherheitskontrolle aus dem Handgepäck und legen Sie diese separat vor.'
            },
            // >>> ------------------------
            luggage_p_6: {
                en: 'In addition, the following items can be carried after prior notification, if the passenger is dependent on it:',
                de: 'Außerdem können nach vorheriger Anmeldung folgende Gegenstände mitgenommen werden, wenn der Passagier darauf angewiesen ist:'
            },
            luggage_li_4: {
                en: 'One Wheelchair (to be collected at the gate)',
                de: 'ein Rollstuhl (am Gate abzugeben)'
            },
            luggage_li_5: {
                en: 'One rollator and/or orthopedic crutches, or other prosthetic devices',
                de: 'ein Paar Gehhilfen und/oder Schienen, sonstige Prothesen'
            },
            luggage_li_6: {
                en: 'A guide dog (Dog trained to lead the blind/deaf)',
                de: 'ein Blindenhund'
            },
            // >>> ------------------------
            luggage_p_7: {
                en: 'Please stow valuables (e.g. money, camera, laptop, keys), medicines, perishables or fragile objects in your hand luggage.',
                de: 'Bitte verstauen Sie Ihre Wertgegenstände (z.B. Bargeld, Kamera, Laptop, Hausschlüssel), Medikamente, verderbliche oder zerbrechliche Gegenstände im Handgepäck.'
            },
            luggage_p_8: {
                en: 'Please observe the information about <a href="/infos-dangerous-goods/#/dangerous-goods" id="linkToDangerousGoods">"Dangerous Goods"</a>.',
                de: 'Bitte beachten Sie unsere Informationen <a href="/infos-dangerous-goods/#/dangerous-goods" id="linkToDangerousGoods">"Gefährliche Güter"</a>.'
            },
            // >>> ------------------------
            luggage_h5_4: {
                en: 'Our liability regulations',
                de: 'Unsere Haftungsbestimmungen'
            },
            luggage_p_9: {
                en: 'Each passenger on SUNDAIR flights is responsible for its own baggage. Make sure that the luggage and the items contained therein comply with the General Conditions of Carriage.',
                de: 'Als Fluggast sind Sie für Ihr Gepäck verantwortlich. Stellen Sie sicher, dass Ihr Gepäckstück sowie die darin enthaltenen Gegenstände unseren Beförderungsbedingungen entsprechen. <br />Achten Sie zudem darauf, den Gepäckinhalt so zu verstauen, dass dieser keinen Schaden nimmt.'
            },
            luggage_p_10: {
                en: 'Please note that SUNDAIR can not be held liable for the following damages:',
                de: 'Bitte beachten Sie, dass SUNDAIR für folgende Schäden grundsätzlich nicht haftet:'
            },
            luggage_li_7: {
                en: 'Usual signs of wear and tear on your luggage, like dents or scratches',
                de: 'übliche Gebrauchsspuren am Reisegepäck, wie Kratzer, Dellen oder Verschmutzungen'
            },
            luggage_li_8: {
                en: 'Damage on incorrect packed luggage',
                de: 'Schäden an unsachgemäß gepackten Gepäckstücken'
            },
            luggage_li_9: {
                en: 'Damage caused by mandatory security checks',
                de: 'Schäden, die entstanden sind, weil Art oder Inhalt des Gepäcks zu Sicherheitskontrollen geführt hat'
            },
            luggage_li_10: {
                en: 'Valuables',
                de: 'Wertgegenstände'
            },
            luggage_li_11: {
                en: 'Fragile objects',
                de: 'zerbrechliche Gegenstände'
            },
            luggage_li_12: {
                en: 'Perishables',
                de: 'verderbliche Güter'
            },
            luggage_li_13: {
                en: 'Left behind hand luggage',
                de: 'liegengelassenes Handgepäck'
            },
            luggage_p_11: {
                en: 'The General Terms and Conditions of Carriage apply.',
                de: 'Es gelten unsere Allgemeinen Geschäfts- und Beförderungsbedingungen.'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    /* >>> *************************************************************** / /* Data */
    data: function data() {
        return {
            aboutsundair: {
                en: 'About SUNDAIR',
                de: 'Über SUNDAIR'
            },
            aboutsundairtext: {
                en: 'is an airline founded in 2016 with headquarter in Stralsund and an operational office not far from the main city airport Berlin-Brandenburg.<br />SUNDAIR operates holiday flights to the most beautiful destinations in the Mediterranean, the Red Sea and the Canary Islands. The departures are from Berlin- Brandenburg, Kassel and Dresden Bremen and Lübeck. In addition to the holiday flights, the airline operates special and charter services and scheduled flights to the Lebanese capital, Beirut. The fleet of SUNDAIR consists of nine aircraft. These are five A320 and four A319 aircraft.',
                de: 'ist eine 2016 gegründete Fluggesellschaft mit Hauptsitz in Stralsund und operativem Standort unweit des Hauptstadtflughafens Berlin-Brandenburg.<br />SUNDAIR bedient im Ferienflugverkehr die schönsten Ziele im Mittelmeerraum, am Roten Meer und auf den Kanarischen Inseln. Die Abflüge finden von den Stationen Berlin- Brandenburg, Kassel und Dresden, Bremen und Lübeck statt. Zusätzlich zu den Ferienflügen operiert die Airline im Sonder- und Charterverkehr und bedient Linienflüge in die libanesische Hauptstadt, Beirut. Für die SUNDAIR sind insgesamt neun Flugzeuge im Einsatz. Dabei handelt es sich um fünf Maschinen vom Typ A320 und vier vom Typ A319.'
            }
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            promotext1: {
                en: 'Welcome to your SUNDAIR',
                de: 'Willkommen bei Ihrer SUNDAIR'
            },
            promotext2: {
                en: 'Where are you going on your next trip?',
                de: 'Wohin geht Ihre nächste Reise?'
            },
            booknowwithus: {
                en: 'Book now with us',
                de: 'Buchen Sie jetzt bei uns'
            }
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gql_query_builder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gql_query_builder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gql_query_builder__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)





 // Graphql


/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            // >>> --------------------------
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_CovidText_DE', 'get_CovidText_EN'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc: Load 'Covid' Text.
    * Note:
    *
    */
    created: function created() {

        var me = this,
            params_DE = null,
            params_EN = null;

        me.$toc('>>> views/cms/covid/Home.vue >>> created');
        // >>> ---------------------------------------- Call 'de'
        params_DE = Object(__WEBPACK_IMPORTED_MODULE_4_gql_query_builder__["query"])({
            operation: 'covid',
            variables: {
                lang: {
                    value: 'de',
                    type: 'Lang'
                }
            },
            fields: ['_id', 'headline', 'content']
        });

        me.actn_call_getCovidText({ payload: params_DE, lang: 'de' });

        // >>> ---------------------------------------- Call 'en'
        params_EN = Object(__WEBPACK_IMPORTED_MODULE_4_gql_query_builder__["query"])({
            operation: 'covid',
            variables: {
                lang: {
                    value: 'en',
                    type: 'Lang'
                }
            },
            fields: ['_id', 'headline', 'content']
        });

        me.actn_call_getCovidText({ payload: params_EN, lang: 'en' });
    }, // eo function created()

    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actn_call_getCovidText']))
    /* <<< ************************************************************** */

});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Information on the transport of dangerous goods',
                de: 'Informationen zur Beförderung gefährlicher Gegenstände'
            },
            // >>> --------------------------
            goods_h4: {
                en: 'Information about travelling with dangerous goods',
                de: 'Informationen zur Beförderung gefährlicher Gegenstände'
            },
            goods_h5_1: {
                en: 'Dangerous goods',
                de: 'Gefährliche Gegenstände'
            },
            goods_p_1: {
                en: 'In aviation some usual items from the normal everyday life could be so dangerous, that it isn’t allowed taken them neither on aircraft nor within travelling baggage.',
                de: 'Im Luftverkehr können viele Gegenstände aus dem normalen Alltag zu einer derartigen Gefahr werden, dass sie an Bord eines Flugzeuges weder im Handgepäck noch im Reisegepäck zugelassen sind.'
            },
            goods_p_2: {
                en: 'The transport of dangerous goods is subject to the strictest regulations.',
                de: 'Der Transport von gefährlichen Gegenständen unterliegt strengsten Vorschriften.'
            },
            // >>> --------------------------
            goods_h5_2: {
                en: 'According to ICAO/ IATA regulations, dangerous goods within baggage is strictly forbidden',
                de: 'Gefährliche Gegenstände sind gemäß ICAO / IATA-Vorschriften im Gepäck verboten'
            },
            goods_h5_21: {
                en: 'Dangerous goods may be:',
                de: 'Als gefährliche Güter gelten:'
            },
            goods_li_1: {
                en: 'Smartphones type Samsung Galaxy Note 7. These smartphones must turn off and it isn’t allowed load them during flight',
                de: 'Smartphones des Typs Samsung Galaxy Note 7. Diese Smartphones müssen an Bord komplett ausgeschaltet sein und dürfen nicht aufgeladen werden.'
            },
            goods_li_2: {
                en: 'Briefcases with integrate alert and also integrate Lithium-batteries or pyrotechnic material',
                de: 'Aktenkoffer mit eingebauter Alarmanlage und integrierten Lithium-Batterien oder pyrotechnischem Material'
            },
            goods_li_3: {
                en: 'Explosives, Fireworks, Torches, light- or smoke signals',
                de: 'Explosivstoffe, Feuerwerkskörper, Fackeln, Leucht- oder Rauchsignale'
            },
            goods_li_4: {
                en: 'Containers with gases (flammable or non flammable, frozen, liquidized or toxic), for example protection spray, Stove, filled pressure bottles, lighter gas, soda patrons',
                de: 'Behälter mit Gasen (entflammbar oder nicht entflammbar, tiefgefroren, verflüssigt oder giftig), beispielsweise Reizgase, Selbstverteidigungsspray, Campinggas, gefüllte Druckflaschen, Feuerzeuggas, Soda-Patronen'
            },
            goods_li_5: {
                en: 'Containers with flammable liquids, e.g. lighter- or wash petrol, colors, varnish, adhesives, dilution fluids, detergents, heating fluids',
                de: 'Behälter mit entflammbaren Flüssigkeiten, z. B. Feuerzeug- oder Waschbenzin, Farben, Lacke, Klebstoffe, Verdünnungsflüssigkeiten, Reinigungsmittel, Heizflüssigkeiten'
            },
            goods_li_6: {
                en: 'Flammable and highly flammable substances, e.g. matches',
                de: 'Entflammbare und leicht entzündliche Stoffe, z. B. Streichhölzer'
            },
            goods_li_7: {
                en: 'E-cigarettes (must only carried within hand luggage or on body from traveler on every flight)',
                de: 'E-Zigaretten (Diese dürfen auf allen Flügen ausschließlich im Handgepäck oder am Körper des Reisenden mitgeführt werden.)'
            },
            goods_li_8: {
                en: 'Substances which become flammable gases if they get in touch with water',
                de: 'Substanzen, die bei Kontakt mit Wasser entflammbare Gase entwickeln'
            },
            goods_li_9: {
                en: 'Oxidizing substances, e.g. bleaching powder, superoxide',
                de: 'Oxidierende Stoffe, z. B. Bleichpulver, Superoxid'
            },
            goods_li_10: {
                en: 'Toxic and infectious substances, e.g. quicksilver, bacteria- and virus culture',
                de: 'Giftige (toxische) und ansteckende Stoffe, z. B. Quecksilber, Bakterien- und Viruskulturen'
            },
            goods_li_11: {
                en: 'Radioactive substances and articles',
                de: 'Radioaktive Stoffe und Gegenstände'
            },
            goods_li_12: {
                en: 'Corrosive substances, e.g. acid, alkali/base, spillable batteries',
                de: 'Ätzende Stoffe, z. B. Säuren, Laugen/Basen, Nassbatterien'
            },
            goods_li_13: {
                en: 'High magnetic material',
                de: 'Stark magnetische Materialien'
            },
            goods_li_14: {
                en: 'Gas-operated devices and tools which already contained the smallest quantity of gasoline (e.g. test purposes)',
                de: 'Benzinbetriebene Geräte und Werkzeuge, die bereits kleinste Mengen Benzin enthalten haben (z.B. für Testzwecke)'
            },
            goods_li_15: {
                en: 'Electro shock weapons, e.g. Taser',
                de: 'Elektroschockwaffen, z.B. Elektro-Schocker (Taser)'
            },
            goods_li_16: {
                en: 'Lithium battery or accumulator (It is allowed to carried maximum 2 single Lithium batteries or rechargeable batteries up to 160 Wh as spare cells for electronical consumer goods (e.g. laptops, mobile phones, watches or cameras). The Airline‘s prior consent must be obtained if separate batteries or rechargeable batteries with an individual rating of between 100 Wh and 160 Wh are to be carried on board.',
                de: 'Lithium-Batterien oder Akkumulatoren (Es dürfen höchstens zwei einzelne Lithium-Batterien oder Akkumulatoren mit einer Wattstundenleistung bis 160Wh als Ersatzzellen für elektronische Gebrauchsgüter (z.B in Laptops, Mobiltelefonen, Uhren, Kameras) befördert werden. Die Beförderung von einzelnen Batterien oder Akkumulatoren mit einer Wattstundenleistung von 100Wh bis 160 Wh bedarf der vorherigen Zustimmung der Fluggesellschaft.)'
            },
            // >>> --------------------------
            goods_h5_3: {
                en: 'The transport of means of transport which are lithium-batterie operated is strictly forbidden',
                de: 'Die Beförderung Lithium-batteriebetriebener Fortbewegungsmittel ist verboten'
            },
            goods_p_3: {
                en: 'The transport of electronical means of transport, which are operated with lithium batteries, isn’t allowed in checked baggage as well as carry on baggage on aircraft. This regulation is applicable irrespective from capacity from the batterie.<br />To these types of means of transport belongs e.g.:',
                de: 'Die Beförderung von elektronischen Fortbewegungsmitteln, die mit Lithium-Batterien betrieben werden, ist sowohl in aufgegebenem Gepäck, als auch im Handgepäck an Bord von Flugzeugen untersagt. Diese Regelung gilt unabhängig von der Leistung der Batterie.<br />Zu dieser Art der Fortbewegungsmittel gehören u.a.:'
            },
            goods_li_17: {
                en: 'Hoverboards',
                de: 'Hoverboards'
            },
            goods_li_18: {
                en: 'Segways',
                de: 'Segways'
            },
            goods_li_19: {
                en: 'Airwheels and Solowheels',
                de: 'Airwheels und Solowheels'
            },
            goods_li_20: {
                en: 'Baggage scooter',
                de: 'Gepäckscooter'
            },
            goods_li_21: {
                en: 'E-bikes with lithium batterie',
                de: 'Elektrofahrräder mit Lithium-Batterien'
            },
            goods_p_4: {
                en: 'Wheelchairs or other mobility aids, which are powered through lithium batteries, are non effected from it’s prohibition but it’s notifiable.',
                de: 'Rollstühle oder andere Mobilitätshilfen, die durch Lithium Batterien angetrieben werden, sind von diesem Verbot nicht betroffen, jedoch anmeldepflichtig.'
            },
            goods_p_5: {
                en: 'More information in regard of transportation of dangerous goods are subject to ICAO Dangerous Goods Regulations which can be found on website of LuftfahrtBundesamt.',
                de: 'Ausführliche Informationen zur Gefahrgutbeförderung sind den internationalen Gefahrgutvorschriften der ICAO zu entnehmen, welche über die Internetseiten des Luftfahrt-Bundesamtes eingesehen werden können.'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Prohibited Items',
                de: 'Verbotene Gegenstände'
            },
            // >>> ------------------------
            prohibited_h4_1: {
                en: 'Hold baggage (acc. to EU Regulation 2015/1998 Annex 5B)',
                de: 'Aufgegebenes Gepäck (gem. EU VO 2015/1998 Anlage 5B)'
            },
            prohibited_h5_1: {
                en: 'List of prohibited articles',
                de: 'Liste der verbotenen Gegenstände'
            },
            prohibited_h4_2: {
                en: 'Carry on baggage (acc. to EU Regulation 2015/1998 Annex 4C)',
                de: 'Handgepäck (gem. EU VO 2015/1998 Anlage 4C))'
            },
            prohibited_h5_2: {
                en: 'List of prohibited articles',
                de: 'Liste der verbotenen Gegenstände'
            },
            // >>> ------------------------
            prohibited_p_1: {
                en: 'Passengers are not permitted to carry the following articles in their hold baggage: explosives and incendiary substances and devices — explosives and incendiary substances and devices capable of being used to cause serious injury or to pose a threat to the safety of aircraft, including: ',
                de: 'Die nachfolgend aufgeführten Gegenstände dürfen von Fluggästen nicht im aufgegebenen Gepäck mitgeführt werden.'
            },
            prohibited_li_1: {
                en: 'Ammunition,',
                de: 'Munition,'
            },
            prohibited_li_2: {
                en: 'blasting caps,',
                de: 'Sprengkapseln'
            },
            prohibited_li_3: {
                en: 'detonators and fuses,',
                de: 'Detonatoren und Zünder,'
            },
            prohibited_li_4: {
                en: 'mines, grenades and other explosive military stores,',
                de: 'Minen, Granaten oder andere militärische Sprengkörper,'
            },
            prohibited_li_5: {
                en: 'fireworks and other pyrotechnics,',
                de: 'Feuerwerkskörper und andere pyrotechnische Erzeugnisse,'
            },
            prohibited_li_6: {
                en: 'smoke-generating canisters and smoke-generating cartridges,',
                de: 'Rauchkanister und Rauchpatronen,'
            },
            prohibited_li_7: {
                en: 'dynamite, gunpowder and plastic explosives',
                de: 'Dynamit, Schießpulver und Plastiksprengstoffe'
            },
            // >>> ------------------------
            prohibited_p_2: {
                en: 'Without prejudice to applicable safety rules, passengers are not permitted to carry the following articles into security restricted areas or on board an aircraft: ',
                de: 'Unbeschadet der geltenden Sicherheitsvorschriften dürfen folgende Gegenstände von Fluggästen nicht in Sicherheitsbereiche oder an Bord eines Luftfahrzeugs mitgenommen werden:'
            },
            prohibited_p_3: {
                en: 'a) <i>guns, firearms or any other devices that discharge projectiles</i> — devices capable, or appearing capable, of being used to cause serious injury by discharging a projectile, including: ',
                de: 'a) <i>Gewehre, Feuerwaffen und sonstige Geräte, die zum Abschießen von Projektilen bestimmt sind</i> - Geräte, die in der Lage sind oder zu sein scheinen, durch Abschießen eines Projektils schwere Verletzungen herbeizuführen, einschließlich:'
            },
            prohibited_li_8: {
                en: 'firearms of all types, such as pistols, revolvers, rifles, shotguns, ',
                de: 'Feuerwaffen aller Art, wie Pistolen, Revolver, Gewehre, Flinten,'
            },
            prohibited_li_9: {
                en: 'toy guns, replicas and imitation firearms capable of being mistaken for real weapons,',
                de: 'Spielzeugwaffen, Nachbildungen und Imitationen von Feuerwaffen, die mit echten Waffen verwechselt werden können,'
            },
            prohibited_li_10: {
                en: 'component parts of firearms, excluding telescopic sights, ',
                de: 'Teile von Feuerwaffen, ausgenommen Zielfernrohre,'
            },
            prohibited_li_11: {
                en: 'compressed air and CO2 guns, such as pistols, pellet guns, rifles and ball bearing guns,',
                de: 'Luftdruck- und CO2-Waffen, wie Luft-, Feder- und Pelletpistolen und -gewehre oder sogenannte „Ball Bearing Guns“ (BB Guns),'
            },
            prohibited_li_12: {
                en: 'signal flare pistols and starter pistols, ',
                de: 'Signalpistolen und Startpistolen,'
            },
            prohibited_li_13: {
                en: 'bows, cross bows and arrows,',
                de: 'Bogen, Armbrüste und Pfeile,'
            },
            prohibited_li_14: {
                en: 'harpoon guns and spear guns, ',
                de: 'Abschussgeräte für Harpunen und Speere,'
            },
            prohibited_li_15: {
                en: 'slingshots and catapults',
                de: 'Schleudern und Katapulte'
            },
            // >>> ------------------------
            prohibited_p_4: {
                en: 'b) <i>stunning devices</i> — devices designed specifically to stun or immobilize, including: ',
                de: 'b) <i>Betäubungsgeräte</i> - Geräte, die speziell dazu bestimmt sind, eine Betäubung oder Bewegungsunfähigkeit zu bewirken, einschließlich:'
            },
            prohibited_li_16: {
                en: 'devices for shocking, such as stun guns, tasers and stun batons,',
                de: 'Gegenstände zur Schockbetäubung, wie Betäubungsgewehre, Taser und Betäubungsstäbe,'
            },
            prohibited_li_17: {
                en: 'animal stunners and animal killers, ',
                de: 'Apparate zur Viehbetäubung und Viehtötung,'
            },
            prohibited_li_18: {
                en: 'disabling and incapacitating chemicals, gases and sprays, such as mace, pepper sprays, capsicum sprays, tear gas, acid sprays and animal repellent sprays',
                de: 'Handlungsunfähig machende und die Handlungsfähigkeit herabsetzende Chemikalien, Gase und Sprays, wie Reizgas, Pfeffersprays, Capsicum-Sprays, Tränengas, Säuresprays und Tierabwehrsprays'
            },
            // >>> ------------------------
            prohibited_p_5: {
                en: 'c)  <i>objects with a sharp point or sharp edge</i> — objects with a sharp point or sharp edge capable of being used to cause serious injury, including:',
                de: 'c) <i>spitze oder scharfe Gegenstände</i> - spitze oder scharfe Gegenstände, mit denen schwere Verletzungen herbeigeführt werden können, einschließlich:'
            },
            prohibited_li_19: {
                en: 'items designed for chopping, such as axes, hatchets and cleavers,',
                de: 'Hackwerkzeuge, wie Äxte, Beile und Hackmesser,'
            },
            prohibited_li_20: {
                en: 'ice axes and ice picks,',
                de: 'Eisäxte und Eispickel,'
            },
            prohibited_li_21: {
                en: 'razor blades,',
                de: 'Rasierklingen,'
            },
            prohibited_li_22: {
                en: 'box cutters,',
                de: 'Teppichmesser,'
            },
            prohibited_li_23: {
                en: 'knives with blades of more than 6 cm,',
                de: 'Messer mit einer Klingenlänge über 6 cm,'
            },
            prohibited_li_24: {
                en: 'scissors with blades of more than 6 cm as measured from the fulcrum, ',
                de: 'Scheren mit einer Klingenlänge über 6 cm ab dem Scharnier gemessen,'
            },
            prohibited_li_25: {
                en: 'martial arts equipment with a sharp point or sharp edge,',
                de: 'Kampfsportgeräte mit einer Spitze oder scharfen Kante,'
            },
            prohibited_li_26: {
                en: 'swords and sabres',
                de: 'Schwerter und Säbel'
            },
            // >>> ------------------------
            prohibited_p_6: {
                en: "d) <i>workmen's tools</i> — tools capable of being used either to cause serious injury or to threaten the safety of aircraft, including: ",
                de: 'd) <i>Werkzeuge</i> - Werkzeuge, mit denen schwere Verletzungen herbeigeführt werden können oder die Sicherheit des Luftfahrzeugs gefährdet werden kann, einschließlich:'
            },
            prohibited_li_27: {
                en: 'crowbars,',
                de: 'Brecheisen,'
            },
            prohibited_li_28: {
                en: 'drills and drill bits, including cordless portable power drills, ',
                de: 'Bohrmaschinen und Bohrer, einschließlich tragbare Akkubohrmaschinen,'
            },
            prohibited_li_29: {
                en: 'tools with a blade or a shaft of more than 6 cm capable of use as a weapon, such as screwdrivers and chisels, ',
                de: 'Werkzeuge mit einer Klinge oder einem Schaft von über 6 cm Länge, die als Waffe verwendet werden können, wie Schraubendreher und Meißel,'
            },
            prohibited_li_30: {
                en: 'saws, including cordless portable power saws,',
                de: 'Sägen, einschließlich tragbare Akkusägen,'
            },
            prohibited_li_31: {
                en: 'blowtorches,',
                de: 'Lötlampen,'
            },
            prohibited_li_32: {
                en: 'bolt guns and nail guns',
                de: 'Bolzenschussgeräte und Druckluftnagler'
            },
            // >>> ------------------------
            prohibited_p_7: {
                en: 'e) <i>blunt instruments</i> — objects capable of being used to cause serious injury when used to hit, including: ',
                de: 'e) <i>stumpfe Gegenstände</i> - Gegenstände, mit denen, wenn sie als Schlagwaffe eingesetzt werden, schwere Verletzungen herbeigeführt werden können, einschließlich:'
            },
            prohibited_li_33: {
                en: 'baseball and softball bats,',
                de: 'Baseball- und Softballschläger,'
            },
            prohibited_li_34: {
                en: 'clubs and batons, such as billy clubs, blackjacks and night sticks,',
                de: 'Knüppel und Schlagstöcke, wie Totschläger,'
            },
            prohibited_li_35: {
                en: 'martial arts equipment',
                de: 'Kampfsportgeräte'
            },
            // >>> ------------------------
            prohibited_p_8: {
                en: 'f) <i>explosives and incendiary substances and devices</i> — explosives and incendiary substances and devices capable, or appearing capable, of being used to cause serious injury or to pose a threat to the safety of aircraft, including: ',
                de: 'f) <i>Spreng- und Brandstoffe sowie Spreng- und Brandsätze</i> - Spreng- und Brandstoffe sowie Spreng- und Brandsätze, die in der Lage sind oder zu sein scheinen, schwere Verletzungen herbeizuführen oder die Sicherheit des Luftfahrzeugs zu gefährden, einschließlich:'
            },
            prohibited_li_36: {
                en: 'ammunition',
                de: 'Munition,'
            },
            prohibited_li_37: {
                en: 'blasting caps,',
                de: 'Sprengkapseln,'
            },
            prohibited_li_38: {
                en: 'detonators and fuses,',
                de: 'Detonatoren und Zünder,'
            },
            prohibited_li_39: {
                en: 'replica or imitation explosive devices,',
                de: 'Nachbildungen oder Imitationen von Sprengkörpern,'
            },
            prohibited_li_40: {
                en: 'mines, grenades and other explosive military stores,',
                de: 'Minen, Granaten oder andere militärische Sprengkörper,'
            },
            prohibited_li_41: {
                en: 'fireworks and other pyrotechnics,',
                de: 'Feuerwerkskörper und andere pyrotechnische Erzeugnisse,'
            },
            prohibited_li_42: {
                en: 'smoke-generating canisters and smoke-generating cartridges,',
                de: 'Rauchkanister und Rauchpatronen,'
            },
            prohibited_li_43: {
                en: 'dynamite, gunpowder and plastic explosives',
                de: 'Dynamit, Schießpulver und Plastiksprengstoffe'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Charges for additional services',
                de: 'Entgelte für Zusatzleistungen'
            },
            // >>> ------------------------
            add_h4_1: {
                en: 'Charges for additional services<br />Valid for all flights effective from 02.11.2020 (subject to changes)',
                de: 'Entgelte für Zusatzleistungen<br />Gültig für alle Flüge ab 02.11.2020 (Vorbehaltlich Änderungen)'
            },
            // >>> ------------------------
            add_th_1: {
                en: 'Information',
                de: 'Hinweise'
            },
            add_th_2: {
                en: 'Charges for additional services<br />- online reservation',
                de: 'Entgelt bei Online-Reservierung'
            },
            add_th_3: {
                en: 'Charges for additional services<br />- check-in counter',
                de: 'Entgelt am Check-in'
            },
            add_th_4: {
                en: 'Baggage',
                de: 'Gepäck'
            },
            add_th_5: {
                en: 'Charges per flight',
                de: 'Gebühren je Strecke'
            },
            add_th_6: {
                en: 'Charges per flight',
                de: 'Gebühren je Strecke'
            },
            // >>> ------------------------
            add_row_1_1: {
                en: 'Excess Baggage',
                de: 'Übergepäck'
            },
            add_row_1_2: {
                en: 'Registration > 5 kg recommended. Excess baggage charges are not refundable.',
                de: 'Anmeldung ab 5 kg empfohlen. Gebühren für Übergepäck sind nicht erstattungsfähig.'
            },
            add_row_1_3: {
                en: '10 EUR per kg',
                de: '10 EUR je kg'
            },
            add_row_1_4: {
                en: '15 EUR per kg',
                de: '15 EUR je kg'
            },
            // >>> ------------------------
            add_row_2_1: {
                en: 'Bicycle',
                de: 'Fahrrad'
            },
            add_row_2_2: {
                en: 'Registration required; up to one (1) piece of luggage;<br /> maximum 20 kg; any weight exceeded be charged as excess baggage.<br /><br /><b>ATTENTION:</b> bicycles with electric drive (Li-batteries / rechargeable batteries) are not allowed to be transported as sport and special luggage.<br /> Sports luggage must be opened at check-in.<br /> Fees for sports and special baggage are non-refundabled.',
                de: 'anmeldepflichtig; maximal ein (1) Gepäckstück;<br /> maximal 20 kg; ab 21. kg Übergepäckrate.<br /><br /><b>ACHTUNG:</b> Fahrräder mit Elektroantrieb (Li-Batterien/Akkus) dürfen nicht als Sport- und Sondergepäck transportiert werden.<br /> Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.'
            },
            add_row_2_3: {
                en: '65 EUR',
                de: '65 EUR'
            },
            add_row_2_4: {
                en: '120 EUR',
                de: '120 EUR'
            },
            // >>> ------------------------
            add_row_3_1: {
                en: 'Golf equipment',
                de: 'Golfgepäck'
            },
            add_row_3_2: {
                en: 'Registration required; up to one (1) piece of luggage;<br />  maximum 20 kg; any weight exceeded be charged as excess baggage;<br />  must be packed separately;<br /> ; may <u> only</u> include golf equipment.<br /><br /><b>ATTENTION:</b> Golf trolleys with electric drive (Li-batteries / rechargeable batteries) are not allowed to be transported as sport or special luggage.<br /> Sports luggage must be opened at check-in.<br />Fees for sports and special baggage are non-refundable.',
                de: 'anmeldepflichtig; maximal ein (1) Gepäckstück;<br /> maximal 20 kg; ab 21. kg Übergepäckrate; muss separat gepackt sein;<br />  darf <u>ausschließlich</u> Golf-Equipment beinhalten.<br /><br /><b>ACHTUNG:</b> Golftrolleys mit Elektroantrieb (Li-Batterien/Akkus) dürfen nicht als Sport-oder Sondergepäck transportiert werden. <br />Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig. '
            },
            add_row_3_3: {
                en: '65 EUR',
                de: '65 EUR'
            },
            add_row_3_4: {
                en: '120 EUR',
                de: '120 EUR'
            },
            // >>> ------------------------
            add_row_4_1: {
                en: 'Diving equipment',
                de: 'Tauchgepäck'
            },
            add_row_4_2: {
                en: 'Registration required, up to one (1) piece of luggage;<br />  maximum 30 kg; any weight exceeded be charged as excess baggage; must be packed separately; may only include diving equipment.<br /> Sports luggage must be opened at check-in. Fees for sports and special baggage are non-refundable.<br /><br /><b>ATTENTION:</b> Diving lamps are dangerous goods; therefore a separate registration isrequired.',
                de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 30 kg; ab 31. kg Übergepäckrate; muss separat gepackt sein; darf <u>ausschließlich</u> Tauch-Equipment beinhalten.<br />Sportgepäck muss am Check-in geöffnet werden. Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.<br /><br /><b>ACHTUNG:</b> Tauchlampen sind Gefahrgut; aufgrund dessen ist eine separate Anmeldung erforderlich.'
            },
            add_row_4_3: {
                en: '65 EUR',
                de: '65 EUR'
            },
            add_row_4_4: {
                en: '120 EUR',
                de: '120 EUR'
            },
            // >>> ------------------------
            add_row_5_1: {
                en: 'Diving equipment',
                de: 'Tauchgepäck'
            },
            add_row_5_2: {
                en: 'Registration required, up to one (1) piece of luggage;<br /> maximum 20 kg; any weight exceeded be charged as excess baggage; must be packed separately; may only include diving equipment.<br /> Sports luggage must be opened at check-in. Fees for sports and special baggage are non-refundable.<br /><br /><b>ATTENTION:</b> Diving lamps are dangerous goods; therefore a separate registration isrequired.',
                de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 20 kg; ab 21. kg Übergepäckrate; muss separat gepackt sein; darf <u>ausschließlich</u> Tauch-Equipment beinhalten.<br />Sportgepäck muss am Check-in geöffnet werden. Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.<br /><br /><b>ACHTUNG:</b> Tauchlampen sind Gefahrgut; aufgrund dessen ist eine separate Anmeldung erforderlich.'
            },
            add_row_5_3: {
                en: '40 EUR',
                de: '40 EUR'
            },
            add_row_5_4: {
                en: '100 EUR',
                de: '100 EUR'
            },
            // >>> ------------------------
            add_row_6_1: {
                en: 'Surf/Wave/Kiteboard',
                de: 'Surf/Wave/Kiteboard'
            },
            add_row_6_2: {
                en: 'Registration required, up to one (1) piece of luggage; maximum 30 kg;<br />any weight exceeded be charged as excess baggage;<br />Sports luggage must be opened at check-in.<br />Fees for sports and special baggage are non-refundable.',
                de: 'anmeldepflichtig maximal ein (1) Gepäckstück; maximal 30 kg;<br />ab 31. kg Übergepäckrate;<br />Sportgepäck muss am Check-in geöffnet werden.<br />Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.'
            },
            add_row_6_3: {
                en: '70 EUR',
                de: '70 EUR'
            },
            add_row_6_4: {
                en: '150 EUR',
                de: '150 EUR'
            },
            // >>> ------------------------
            add_row_7_1: {
                en: 'Canoe, Kayak',
                de: 'Kanu/Kajak'
            },
            add_row_7_2: {
                en: 'Registration required, up to one (1) piece of luggage;<br /> maximum 30 kg;<br /> any weight exceeded be charged as excess baggage.<br /> Sports luggage must be opened at check-in.<br /> Fees for sports and special baggage are non-refundable.',
                de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 30 kg; ab 31. kg Übergepäckrate <br /> Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.'
            },
            add_row_7_3: {
                en: '70 EUR',
                de: '70 EUR'
            },
            add_row_7_4: {
                en: '150 EUR',
                de: '150 EUR'
            },
            // >>> ------------------------
            add_row_8_1: {
                en: 'Hangglider/Paraglider',
                de: 'Hang/Paraglider'
            },
            add_row_8_2: {
                en: 'Registration required, up to one (1) piece of luggage;<br />  maximum 30 kg;<br />  any weight exceeded be charged as excess baggage.<br />Sports luggage must be opened at checkin.<br />Fees for sports and special baggage are non-refundable.',
                de: 'anmeldepflichtig maximal ein (1) Gepäckstück;<br /> maximal 30 kg; ab 31. kg Übergepäckrate <br /> Sportgepäck muss am Check-in geöffnet werden.<br/> Gebühren für Sport- und Sondergepäck sind nicht erstattungsfähig.'
            },
            add_row_8_3: {
                en: '70 EUR',
                de: '70 EUR'
            },
            add_row_8_4: {
                en: '150 EUR',
                de: '150 EUR'
            },
            // >>> ------------------------
            add_row_9_1: {
                en: 'Pet in cabin',
                de: 'Tier in Kabine'
            },
            add_row_9_2: {
                en: 'Registration required; up to 6 kg incl. box maximum dimensions 42x31x20 cm;<br />only one (1) animal per passenger<br />Please specify animal species and dimensions of the box!<br /> Fees for animal transport are non-refundable.',
                de: 'anmeldepflichtig; bis maximal 6 kg inkl. Box maximal 42x31x20 cm;<br />je Fluggast nur ein (1) Tier <br />Bitte Tierart und Abmessungen der Box angeben! <br />Gebühren für Tierbeförderung sind nicht erstattungsfähig.'
            },
            add_row_9_3: {
                en: '60 EUR',
                de: '60 EUR'
            },
            add_row_9_4: {
                en: '100 EUR',
                de: '100 EUR'
            },
            // >>> ------------------------
            add_row_10_1: {
                en: 'Pet in cargo hold',
                de: 'Tier im Frachtraum'
            },
            add_row_10_2: {
                en: 'Registration required; from 7 kg incl. box<br />Please specify animal species and dimensions of the box!<br />Fees for animal transport are non-refundable.',
                de: 'anmeldepflichtig; ab 7 kg inkl. Box <br />Bitte Tierart und Abmessungen der Box angeben! <br />Gebühren für Tierbeförderung sind nicht erstattungsfähig.'
            },
            add_row_10_3: {
                en: '80 EUR (up to 20 kg incl. Box)<br />100 EUR (from 21 kg incl. Box)',
                de: '80 EUR (bis 20 kg inkl. Box)<br />100 EUR (ab 21. Kg inkl. Box)'
            },
            add_row_10_4: {
                en: '130 EUR (up to 20 kg incl. Box)<br />150 EUR (from 21 kg incl. Box)',
                de: '130 EUR (bis 20 kg inkl. Box)<br />150 EUR (ab 21. kg inkl. Box)'
            },
            // >>> ------------------------
            add_row_11_1: {
                en: 'Unaccompanied minor',
                de: 'Unbegleitetes Kind'
            },
            add_row_11_2: {
                en: 'Registration required; at the age of 5-11 years<br /> Please fill in the form "unaccompanied minor", sign and carry it in triplicate.<br /> Charges for unaccompanied children are non-refundable.',
                de: 'anmeldepflichtig; im Alter von 5-11 Jahren<br /> Bitte Formular „Unbegleites Kind“ ausfüllen, unterzeichnen und in 3-facher Ausfertigung mitführen.<br />Gebühren für unbegleitete Kinder sind nicht erstattungsfähig.'
            },
            add_row_11_3: {
                en: '100 EUR',
                de: '100 EUR'
            },
            add_row_11_4: {
                en: '100 EUR',
                de: '100 EUR'
            },
            // >>> ------------------------
            add_row_12_1: {
                en: 'Seat reservations',
                de: 'Sitzplatzreservierungen'
            },
            // >>> ------------------------
            add_row_13_1: {
                en: 'Standard seats',
                de: 'Standard seats'
            },
            add_row_13_2: {
                en: 'Fees for seat reservations are non-refundable.',
                de: 'Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.'
            },
            add_row_13_3: {
                en: '15 EUR per person',
                de: '15 EUR pP'
            },
            add_row_13_4: {
                en: 'only online',
                de: 'Nur online'
            },
            // >>> ------------------------
            add_row_14_1: {
                en: 'Comfort seats',
                de: 'Comfort seats'
            },
            add_row_14_2: {
                en: 'Seats in the 1st row<br />Not for the following group of passengers:<br />- infants (not older than 2 years),<br />- expectant mothers,<br />- Persons with limited mobility due to their body size, illness or age<br />- Persons travelling with pets in cabin<br /><br />Fees for seat reservations are non-refundable.',
                de: 'Sitzplätze in der 1. Reihe<br /><b><u>Nicht</u></b> für folgenden Personenkreis :<br />- Kleinkinder (bis einschließlich 2 Jahre),<br />- werdende Mütter,<br />- Personen, die Tiere in der Kabine mitführen,<br />- Personen, die eingeschränkt mobil sind.<br />- Personen, die durch ihre Körpermaße, Krankheit oder aus Altersgründen eingeschränkt beweglich sind<br /><br />Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.'
            },
            add_row_14_3: {
                en: '30 EUR per person',
                de: '30 EUR pP'
            },
            add_row_14_4: {
                en: '40 EUR per person',
                de: '40 EUR pP'
            },
            // >>> ------------------------
            add_row_15_1: {
                en: 'Best seats',
                de: 'Best seats'
            },
            add_row_15_2: {
                en: 'Seats from row 2 to row 7<br />Benefits:<br />- In the front of the cabin<br />- Faster embarking and disembarking<br />- Quickly board service<br />- Short distance to the lavatories<br /><br />Fees for seat reservations are non-refundable.',
                de: 'Sitzplätze in der 2.-7. Reihe<br />Vorteile:<br />- Vorne in der Kabine<br />- Schnelleres Ein- und Aussteigen<br />- Schnellerer Bordservice<br />- Kurze Wege zu den Toiletten<br /><br />Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.'
            },
            add_row_15_3: {
                en: '20 EUR per person',
                de: '20 EUR pP'
            },
            add_row_15_4: {
                en: '30 EUR per person',
                de: '30 EUR pP'
            },
            // >>> ------------------------
            add_row_16_1: {
                en: 'Exit seats',
                de: 'Exit seats'
            },
            add_row_16_2: {
                en: 'Seats directly at the emergency exit<br /><u>Not</u> for the following group of people:<br />- Children and infants,<br />- expectant mothers,<br />- Persons carrying pets in the cabin<br />- Persons with reduced mobility,<br />- People who are limited in mobility due their body size, illness or age<br />- Persons who do not understand and speak either German or English<br /><br />Fees for seat reservations are non-refundable.',
                de: 'Sitzplätze direkt am Notausgang<br /><b><u>Nicht</u></b> für folgenden Personenkreis: <br />- Kinder und Kleinkinder,<br />- werdende Mütter,<br />- Personen, die Tiere in der Kabine mitführen,<br />- Personen, die eingeschränkt mobil sind,<br />- Personen, die durch ihre Körpermaße, Krankheit oder aus Altersgründen eingeschränkt beweglich sind, <br />- Personen, die weder die deutsche noch die englische Sprache verstehen und sprechen<br /><br />Gebühren für Sitzplatzreservierungen sind nicht erstattungsfähig.'
            },
            add_row_16_3: {
                en: '30 EUR per person',
                de: '30 EUR pP'
            },
            add_row_16_4: {
                en: '40 EUR per person',
                de: '40 EUR pP'
            },
            // >>> ------------------------
            add_row_17_1: {
                en: '<b>Special meals</b>',
                de: '<b>Spezialessen</b>'
            },
            // >>> ------------------------
            add_row_18_1: {
                en: 'Vegetarian meal',
                de: 'Vegetarisches Essen'
            },
            add_row_18_2: {
                en: 'vegetarian; without dairy products<br />Fees for special meals are non-refundable.',
                de: 'vegetarisch; ohne Milchprodukte<br />Gebühren für Spezialessen sind nicht erstattungsfähig.'
            },
            add_row_18_3: {
                en: '15 EUR',
                de: '15 EUR je Essen'
            },
            add_row_18_4: {
                en: 'only online',
                de: 'Nur online'
            },
            // >>> ------------------------
            add_row_19_1: {
                en: 'Gluten-free meal',
                de: 'Glutenfreies Essen'
            },
            add_row_19_2: {
                en: 'Fees for special meals are non-refundable.',
                de: 'Gebühren für Spezialessen sind nicht erstattungsfähig.'
            },
            add_row_19_3: {
                en: '15 EUR',
                de: '15 EUR je Essen'
            },
            add_row_19_4: {
                en: 'only online',
                de: 'Nur online'
            },
            // >>> ------------------------
            add_row_20_1: {
                en: 'Diabetic meal',
                de: 'Diabetiker Essen'
            },
            add_row_20_2: {
                en: 'Fees for special meals are non-refundable.',
                de: 'Gebühren für Spezialessen sind nicht erstattungsfähig.'
            },
            add_row_20_3: {
                en: '15 EUR',
                de: '15 EUR je Essen'
            },
            add_row_20_4: {
                en: 'only online',
                de: 'Nur online'
            },
            // >>> ------------------------
            add_row_21_1: {
                en: '<b>Service fees for flight booking</b>',
                de: '<b>Entgelte für Serviceleistungen bei Flugbuchungen</b>'
            },
            // >>> ------------------------
            add_row_22_1: {
                en: 'Service surcharge for a callcenter booking or rebooking fee (flight date change) ',
                de: 'Servicezuschlag, der bei einer Callcenter-Buchung oder Umbuchung (Flugdatum) anfällt'
            },
            add_row_22_2: {
                en: 'Service fees for flight bookings are non-refundable',
                de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.'
            },
            add_row_22_3: {
                en: '25 EUR per booking',
                de: '25 EUR je Buchung'
            },
            // >>> ------------------------
            add_row_23_1: {
                en: 'Rebooking fee per person if the date of flight changes within the valid timetable period up to 24 hours before departure',
                de: 'Umbuchungsgebühr pro Person bei Änderung des Flugdatums innerhalb der gültigen Flugplanperiode bis 24 Stunden vor Abflug'
            },
            add_row_23_2: {
                en: 'Service fees for flight bookings are non-refundable',
                de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.'
            },
            add_row_23_3: {
                en: '35 EUR per person plus price difference to the current fare',
                de: '35 EUR pP zzgl. Differenz zum aktuellen Flugpreis'
            },
            // >>> ------------------------
            add_row_24_1: {
                en: 'Name change per person per booking up to 48 hours before departure (without change of flight date and / or route)',
                de: 'Namensänderung pro Person pro Buchung bis 48 Stunden vor Abflug(ohne Änderung Flugdatum und/oder Flugstrecke)'
            },
            add_row_24_2: {
                en: 'Service fees for flight bookings are non-refundable',
                de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.'
            },
            add_row_24_3: {
                en: '130 EUR per person per booking',
                de: '130 EUR pP je Buchung'
            },
            // >>> ------------------------
            add_row_25_1: {
                en: 'Cancellation',
                de: 'Stornierung'
            },
            add_row_25_2: {
                en: 'Service fees for flight bookings are non-refundable',
                de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.'
            },
            add_row_25_3: {
                en: 'Depending on the tariff regulations',
                de: 'je nach Tarifbestimmungen'
            },
            // >>> ------------------------
            add_row_26_1: {
                en: 'Processing fee for cancellations and refund of taxes & fees at non-refundable fares',
                de: 'Bearbeitungsgebühr für Stornierungen und Rückerstattung der Steuern & Gebühren, bei nicht erstattungsfähigen Tarifen'
            },
            add_row_26_2: {
                en: 'Service fees for flight bookings are non-refundable',
                de: 'Gebühren für Serviceleistungen bei Flugbuchungen sind nicht erstattungsfähig.'
            },
            add_row_26_3: {
                en: '25 EUR per booking',
                de: '25 EUR je Vorgang'
            },
            // >>> ------------------------
            add_row_27_1: {
                en: '<b>Service fees for seat and special reservations</b>',
                de: '<b>Entgelte für Serviceleistungen bei Sitzplatz- und Sonderreservierungen</b>'
            },
            // >>> ------------------------
            add_row_28_1: {
                en: 'Service surcharge that accrued from a call center booking or rebooking',
                de: 'Servicezuschlag, der bei einer CallcenterBuchung oder Umbuchung (Flugdatum) anfällt'
            },
            add_row_28_2: {
                en: 'Fees for seat and special reservations services are non-refundable',
                de: 'Gebühren für Serviceleistungen bei Sitzplatz- und Sonderreservierungen sind nicht erstattungsfähig.'
            },
            add_row_28_3: {
                en: '10 EUR per booking',
                de: '10 EUR je Buchung'
            },
            // >>> ------------------------
            // >>> ------------------------
            // >>> ------------------------
            add_p_1: {
                en: 'Sports equipment not listed here (such as tennis rackets, hockey sticks, etc.) will be carried as part of the free baggage allowance. In addition, an excess baggage fee must be paid.',
                de: 'Hier nicht aufgeführtes Sportgepäck (wie Tennisschläger, Hockeyschläger, etc.) wird im Rahmen des Freigepäcks befördert. Darüber hinausgehend ist eine Übergepäckgebühr zu entrichten.'
            },
            add_p_2: {
                en: 'Registration for additional services can be made up to 48 hours before departure at <a href="/services">Services</a>.',
                de: 'Anmeldungen für Zusatzleistungen können bis 48 Stunden vor Abflug unter <a href="/services">Services</a> vorgenommen werden.'
            },
            add_p_3: {
                en: 'The fees for additional services are payable upon registration and are non-refundable. Rebookings are not permitted.',
                de: 'Die Entgelte für Zusatzleistungen sind bei der Anmeldung zu entrichten und sind nicht erstattungsfähig. Umbuchungen sind nicht gestattet.'
            },
            add_p_31: {
                en: 'For a smooth check-in please have your reservation confirmation printed out or in electronic form ready at the check-in counter.',
                de: 'Für einen reibungslosen Check-in ist Ihre Reservierungsbestätigung ausgedruckt oder in elektronischer Form am Abfertigungsschalter bereitzuhalten.'
            },
            add_p_4: {
                en: 'Passengers who do <u>not</u> make a previous registration can bring their excess baggage, sports and special luggage to the check-in. The decision on the carriage is subject to the capacity of the cargo compartment. In this case the fees are payable at the check-in and they will be higher due to the increased work load (as when registering online).',
                de: 'Fluggäste, die <u>keine</u> Anmeldung vornehmen, können ihr Über-, Sport- und Sondergepäck zum Check-in mitbringen. Dort wird dann über die Beförderung gemäß Laderaumkapazität entschieden. Die Entgelte sind dann beim Check-in zu entrichten und fallen aufgrund des erhöhten Aufwandes dann höher (als bei Online-Reservierung) aus.'
            },
            // >>> ------------------------
            add_footer_1: {
                en: 'Our service team will be pleased to assist you and is available for any further questions:<br />Phone: +49 (0) 30 53 676 791<br />E-mail: <a href="mailto:kundenservice@sundair.com">Kundenservice@Sundair.com</a>',
                de: 'Unser Serviceteam berät Sie gern und steht für weitere Fragen gern zur Verfügung:<br />Tel. +49 (0)30 53 676 791<br />E-Mail: <a href="mailto:kundenservice@sundair.com">Kundenservice@Sundair.com</a>'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Service and catering',
                de: 'Service und Verpflegung'
            },
            // >>> --------------------------
            servicesonboard_h4_1: {
                en: 'Our service on board',
                de: 'Unser Service an Bord'
            },
            servicesonboard_p_1: {
                en: 'On your flight we offer you a selection of food, snacks and drinks for sale.<br />Special foods such as vegetarian-meals, gluten-free meals and diabetics-menus can be booked at least 48 hours prior to departure under <a href="/services">Service</a>.',
                de: 'Auf Ihrem Flug bieten wir Ihnen eine Auswahl an Speisen, Snacks und Getränken gegen Gebühr an.<br />Spezialessen wie z.B. Vegetarisches Essen, Glutenfreies Essen und Diabetiker-Essen können Sie bis spätestens 48 Stunden vor Abflug online unter <a href="/services">Service</a> reservieren.'
            },
            furtherservices_seat_here: {
                en: 'here',
                de: 'hier'
            },
            meal_text2: {
                en: 'Further information can be found in our on-board bistro and sales journal (PDF document)',
                de: 'Nähere Informationen finden Sie in unserem Bord-Bistro- und Bordverkauf-Journal (PDF-Dokument)'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Notes on seat reservation',
                de: 'Hinweise zur Sitzplatzreservierung'
            },
            // >>> --------------------------
            seat_h4_1: {
                en: 'Seat reservation',
                de: 'Sitzplatzreservierung'
            },
            seat_p_1: {
                en: 'We recommend a timely seat reservation no later than 7 days prior departure. A seat reservation can be made after an only-flight booking or by booking of a holiday package on the SUNDAIR website under <a href="/services">Service</a>.',
                de: 'Wir empfehlen eine rechtzeitige Sitzplatzreservierung bis spätestens 7 Tage vor Abflug. Die Sitzplatzreservierung kann auch nach Ihrer Flugbuchung oder Ihrer Buchung der Pauschalreise unter <a href="/services">Service</a> vorgenommen werden.'
            },
            seat_p_2: {
                en: 'Seat reservations are valid from last German airport to the first foreign country airport and vice versa.',
                de: 'Ihre Sitzplatzreservierung ist gültig vom letzten deutschen Flughafen bis zum ersten Auslandsflughafen und umgekehrt.'
            },
            seat_p_3: {
                en: 'In case of any aircraft type change, unfortunately seat reservations can’t be considered.',
                de: 'Bei einem Flugzeugmuster-Wechsel kann Ihre Sitzplatzreservierung leider nicht berücksichtigt werden.'
            },
            // >>> --------------------------
            seat_h5_1: {
                en: 'Emergency exit seats',
                de: 'Sitzplätze am Notausgang'
            },
            seat_p_4: {
                en: 'Emergency exit seats are subject to special security regulations. SUNDAIR is entitled to refuse any exit seat reservations for following group of people:',
                de: 'Sitzplätze am Notausgang unterliegen besonderen Sicherheitsbestimmungen. SUNDAIR ist daher berechtigt, eine Buchung dieser Sitzplatzkategorie an folgende Personenkreise abzulehnen:'
            },
            seat_li_1: {
                en: 'Infants and minors (up to 17 years)',
                de: 'Kleinkinder und Kinder (bis einschließlich 17 Jahre)'
            },
            seat_li_1_1: {
                en: 'Infants (up to 2 years)',
                de: 'Kleinkinder (bis einschließlich 2 Jahre)'
            },
            seat_li_2: {
                en: 'Pregnant women',
                de: 'Schwangere'
            },
            seat_li_3: {
                en: 'Passengers with reduced mobility',
                de: 'Personen, die eingeschränkt mobil sind'
            },
            seat_li_4: {
                en: 'Passengers which are limited in mobility due to their body size, illness or age',
                de: 'Personen, die durch ihre Körpermaße, Krankheit oder aus Altersgründen eingeschränkt beweglich sind'
            },
            seat_li_5: {
                en: 'Passengers travelling with pets in the cabin',
                de: 'Personen, die Tiere in der Kabine mitführen'
            },
            seat_p_5: {
                en: 'With the reservation of an emergency exit seat, the passenger agrees that the afore mentioned criteria don’t apply to them and the people he booked for. Additionally, the passenger has to be ready for helping flight personal in case of any emergency situation. This requires that the passenger is able to follow the instructions from flight personal in German or in English language.',
                de: 'Mit der Reservierung eines Sitzplatzes am Notausgang sichert der Fluggast zu, dass die oben genannten Kriterien für ihn und die von ihm gebuchten Personen nicht zutreffen. Darüber hinaus muss der Fluggast bereit sein, dem Bordpersonal im Notfall behilflich zu sein. Dies setzt voraus, dass der Fluggast den Anweisungen des Bordpersonals in deutscher oder englischer Sprache Folge leisten kann.'
            },
            seat_p_6: {
                en: 'Other than described SUNDAIR is entitled to allocate another seat to the affected person without the possibility to claim any refunding of booking fees. In the event of no seat allocation under consideration of any possibilities, SUNDAIR is entitled to refuse the transportation.',
                de: 'Sollte dies nicht der Fall sein, ist SUNDAIR berechtigt, der betreffenden Person einen anderen Sitzplatz zuzuweisen, ohne dass ein Anspruch auf Rückerstattung der Reservierungskosten besteht. Sollte eine anderweitige Zuweisung eines Sitzplatzes unter Ausschöpfung aller Möglichkeiten nicht möglich sein, hat SUNDAIR das Recht, die Beförderung insgesamt zu verweigern.'
            },
            // >>> --------------------------
            seat_h5_2: {
                en: 'Seating in Row 1',
                de: 'Sitze in Reihe 1'
            },
            seat_p_7: {
                en: 'Seats in Row 1 are subject to special security regulations. SUNDAIR is entitled to refuse such seat category to following group of people:',
                de: 'Sitzplätze in Reihe 1 unterliegen besonderen Sicherheitsbestimmungen. SUNDAIR ist daher berechtigt, eine Buchung dieser Sitzplatzkategorie an folgende Personenkreise abzulehnen:'
            },
            seat_p_8: {
                en: 'With the reservation of a seat in row 1, the passenger agrees that the afore mentioned criteria don’t apply to them and the people he booked for.',
                de: 'Mit der Reservierung eines Sitzplatzes in Reihe 1 sichert der Fluggast zu, dass die obengenannten Kriterien für ihn und die von ihm gebuchten Personen nicht zutreffen.'
            },
            seat_p_9: {
                en: 'Other than described SUNDAIR is entitled to allocate another seat to the affected person without the possibility to claim any refunding of booking fees. In the event of no seat allocation under consideration of any possibilities, SUNDAIR is entitled to refuse the transportation.',
                de: 'Sollte dies nicht der Fall sein, ist SUNDAIR berechtigt, der betreffenden Person einen anderen Sitzplatz zuzuweisen, ohne dass ein Anspruch auf Rückerstattung der Reservierungskosten besteht. Sollte eine anderweitige Zuweisung eines Sitzplatzes unter Ausschöpfung aller Möglichkeiten nicht möglich sein, hat SUNDAIR das Recht, die Beförderung insgesamt zu verweigern.'
            },
            seat_p_10: {
                en: 'Our service team is pleased to assist you for any further questions:',
                de: 'Unser Serviceteam berät Sie gern und steht für weitere Fragen zur Verfügung:'
            },
            phone: {
                en: 'Phone',
                de: 'Tel.'
            },
            email: {
                en: 'E-mail',
                de: 'E-Mail'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Tariff regulations',
                de: 'Tarifbestimmungen'
            },
            // >>> ------------------------
            fare_h4_1: {
                en: 'Your Eco Sund Fare conditions',
                de: 'Ihre Eco Sund Tarifbestimmungen'
            },
            fare_h4_2: {
                en: 'Rebooking',
                de: 'Umbuchung'
            },
            fare_h4_3: {
                en: 'Name change',
                de: 'Namensänderung'
            },
            fare_h4_4: {
                en: 'Cancellation',
                de: 'Stornierung'
            },
            fare_p_1: {
                en: "For infants under the age of two (2) travelling on their parents' laps, a fixed service fee will be charged for each leg of the journey, amounting to 29 € (50 € on Lebanon flights).<br /><br />Infants under the age of 2 can’t claim a separate seat.<br /><br />If the infant will complete the second year of life before the return flight, a booking as a full paying child(2 - 11 years) with right to a seat is mandatory for safety reasons.<br /><br />For safety reasons, only one(1) infant per adult on board is allowed.",
                de: 'Kleinkinder unter 2 Jahren, die auf dem Schoß der Eltern reisen, zahlen pro Teilstrecke lediglich eine Servicepauschale von 29 € (50 € auf Libanon-Flügen).<br /><br />Kleinkinder unter 2 Jahren haben keinen Anspruch auf einen Sitzplatz.<br /><br />Aus Sicherheitsgründen ist nur ein(1) Kleinkind pro Erwachsenen an Bord gestattet.<br /><br />Sollte das Kleinkind vor dem Rückflug oder zum Rückreisetermin das 2. Lebensjahr vollenden, so ist aus Sicherheitsgründen eine Buchung als vollzahlendes Kind(2 – 11 Jahre) mit Sitzplatz zwingend erforderlich.'
            },
            fare_p_2: {
                en: 'Changes to the date of flight are chargeable and subject to seat availability within the current timetable period up to 24 hours prior to the scheduled departure. In case of a rebooking to a higher fare the difference is payable.',
                de: 'Die Reisedaten (Flugdatum) können bei freien Sitzplatzkapazitäten in der gültigen Flugplanperiode bis 24 Stunden vor Abflug gegen Gebühr und ggf. Zahlung der Tarifdifferenz geändert werden.'
            },
            fare_p_3: {
                en: 'A name change (without change of date and / or flight route) is possible up to 48 hours prior departure. A fee is payable.',
                de: 'Eine Namensänderung (ohne Änderung Flugdatum und/oder Flugstrecke) ist bis 48 Stunden vor Abflug gegen Gebühr möglich.'
            },
            fare_p_4: {
                en: 'In case of cancellation or non-appearance the ticket price is not refundable.',
                de: 'Bei Stornierung bzw. Nichtantritt ist eine Erstattung des Flugpreises nicht möglich.'
            }
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)



var letterspaces = __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["helpers"].regex('letterspaces', /^[a-z-öÖüÜäÄ\s]+$/i); /* Validator */
var numericspaces = __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["helpers"].regex('numericspaces', /^[0-9+/\s]+$/i); /* Validator */






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            bannerline1: {
                en: 'Group Booking?',
                de: 'Gruppenbuchung?'
            },
            now: {
                en: 'With pleasure!',
                de: 'Sehr gern!'
            },
            bannerline2: {
                en: 'Make your request.',
                de: 'Stellen Sie Ihre Anfrage.'
            },
            // >>> ------------------------
            titleinfo: {
                en: 'Group Booking',
                de: 'Gruppenbuchung'
            },
            wasssentsuccesful: {
                en: 'Successfully sent!',
                de: 'Erfolgreich gesendet!'
            },
            welcome: {
                en: 'Welcome to the SUNDAIR Group Department',
                de: 'Herzlich Willkommen bei der SUNDAIR Gruppenabteilung'
            },
            welcometext1: {
                en: 'Dear passenger,<br /><br />thank you very much for your interest in booking your group on one of our flights.<br /><br />Groups should have a minimum size of 10 persons.<br />Please fill out the form below. We will get in touch with you as soon as possible.<br /><br />We look forward to welcoming you on board soon.',
                de: 'Sehr geehrter Fluggast,<br /><br />vielen Dank für Ihr Interesse, Ihre Gruppe auf einem unserer Flüge buchen zu wollen.<br /><br />Gruppen sollten eine Mindestgröße von 10 Personen haben.<br />Bitte füllen Sie das nachfolgende Formular aus. Wir werden uns umgehend mit Ihnen in Verbindung setzen.<br /><br />Wir freuen uns, Sie bald bei uns an Bord begrüßen zu dürfen.'
            },
            welcometext2: {
                en: 'Here we have summarized all group conditions for you:<br />Download conditions: <a href="https://www.sundair.com/downloads/Groupconditions.pdf" target="_blank" style="font-size:15.9996px; color: #D6254D;">here</a>',
                de: 'Hier haben wir alle Gruppenkonditionen für Sie zusammengefasst:<br />Konditionen herunterladen: <a href="https://www.sundair.com/downloads/Gruppenkonditionen.pdf" target="_blank" style="font-size:15.9996px; color: #D6254D;">hier</a>'
            },

            // >>> ------------------------
            groupbooking: {
                en: 'Group Booking',
                de: 'Gruppenbuchung'
            },
            request: {
                en: 'Make a non-binding request',
                de: 'Stellen Sie eine unverbindliche Anfrage'
            },
            // >>> ------------------------
            // >>> ------------------------
            outwardandreturnflight: {
                en: 'Round Trip',
                de: 'Hin- und Rückflug'
            },
            outwardonlyflight: {
                en: 'One Way Only',
                de: 'nur Hinflug'
            },
            label_departureairport: {
                en: 'Departure airport',
                de: 'Abflughafen'
            },
            placeholder_departureairport: {
                en: 'Please enter your departure airport',
                de: 'Bitte Ihren Abflughafen eingeben'
            },
            label_destinationairport: {
                en: 'Destination Airport',
                de: 'Zielflugafen'
            },
            placeholder_destinationairport: {
                en: 'Please enter your destination airport',
                de: 'Bitte Ihren Zielflughafen eingeben'
            },
            label_departuredate: {
                en: 'Departure Date',
                de: 'Abflugdatum'
            },
            placeholder_departuredate: {
                en: 'Please enter your departure date',
                de: 'Bitte Ihr Abflugdatum eingeben'
            },
            label_destinationdate: {
                en: 'Destination Date',
                de: 'Rückflugdatum'
            },
            placeholder_destinationdate: {
                en: 'Please enter your destination date',
                de: 'Bitte Ihr Rückflugdatum eingeben'
            },
            label_adultschilds: {
                en: 'Adults & Childs',
                de: 'Erwachsene & Kinder'
            },
            label_infants: {
                en: 'Number of babies',
                de: 'Anzahl Babies'
            },
            // >>> ------------------------
            // >>> ------------------------
            groupdetails: {
                en: 'Information on the group',
                de: 'Angaben zur Gruppe'
            },
            label_groupname: {
                en: 'Group name (e.g. company, club)',
                de: 'Gruppenname (z.B. Unternehmen, Club)'
            },
            placeholder_groupname: {
                en: 'Please enter your group name',
                de: 'Bitte Ihre Gruppeninfo eingeben'
            },
            label_street: {
                en: 'Street',
                de: 'Strasse'
            },
            placeholder_street: {
                en: 'Please enter your street',
                de: 'Bitte Ihre Strasse eingeben'
            },
            label_streetno: {
                en: 'Street number',
                de: 'Nr.'
            },
            placeholder_streetno: {
                en: 'Please enter your street number',
                de: 'Bitte Ihre Hausnummer eingeben'
            },
            label_zip: {
                en: 'ZIP Code',
                de: 'PLZ'
            },
            placeholder_zip: {
                en: 'Please enter your zip code',
                de: 'Bitte Ihre PLZ eingeben'
            },
            label_place: {
                en: 'Place',
                de: 'Ort'
            },
            placeholder_place: {
                en: 'Please enter your place',
                de: 'Bitte Ihren Ort eingeben'
            },
            label_country: {
                en: 'Country',
                de: 'Land'
            },
            placeholder_country: {
                en: 'Please enter your country',
                de: 'Bitte Ihr Land eingeben'
            },
            // >>> ------------------------
            // >>> ------------------------
            contactfor: {
                en: 'Contact for',
                de: 'Ansprechpartner'
            },
            label_salutation: {
                en: 'Salutation',
                de: 'Anrede'
            },
            placeholder_salutation: {
                en: 'Please enter your salutation',
                de: 'Bitte Ihre Anrede eingeben'
            },
            label_firstname: {
                en: 'First name',
                de: 'Vorname'
            },
            placeholder_firstname: {
                en: 'Please enter your first name',
                de: 'Bitte Ihren Vornamen eingeben'
            },
            label_lastname: {
                en: 'Last name',
                de: 'Nachname'
            },
            placeholder_lastname: {
                en: 'Please enter your last name',
                de: 'Bitte Ihren Nachnamen eingeben'
            },
            label_phone: {
                en: 'Phone',
                de: 'Telefon'
            },
            placeholder_phone: {
                en: 'Please enter your phone number',
                de: 'Bitte Ihre Telefonnummer eingeben'
            },
            label_mobile: {
                en: 'Mobile',
                de: 'Mobile'
            },
            placeholder_mobile: {
                en: 'Please enter your mobile number',
                de: 'Bitte Ihre Handynummer eingeben'
            },
            label_fax: {
                en: 'Fax',
                de: 'Fax'
            },
            placeholder_fax: {
                en: 'Please enter your fax number',
                de: 'Bitte Ihre Faxnummer eingeben'
            },
            label_email: {
                en: 'E-mail',
                de: 'E-Mail'
            },
            placeholder_email: {
                en: 'Please enter your e-mail',
                de: 'Bitte Ihre E-Mail Adresse eingeben'
            },
            label_emailrepeat: {
                en: 'E-mail (again)',
                de: 'E-Mail (wiederh.)'
            },
            placeholder_emailrepeat: {
                en: 'Please enter your e-mail',
                de: 'Bitte Ihre E-Mail Adresse eingeben'
            },
            label_remark: {
                en: 'Remark',
                de: 'Bemerkung'
            },
            placeholder_remark: {
                en: 'Remarks to SUNDAIR',
                de: 'Bemerkungen an Sundair'
            },
            send_request: {
                en: 'SEND REQUEST',
                de: 'ANFRAGE SENDEN'
            },
            // >>> --------------------------
            // >>> --------------------------
            errmsg_required: {
                en: 'This Field must not be empty.',
                de: 'Dieses Feld darf nicht leer sein.'
            },
            // >>> --------------------------
            errmsg_letterspaces: {
                en: 'Letters, "-" and spaces are allowed.',
                de: 'Erlaubt sind Buchstaben, “-“ und Leerzeichen.'
            },
            // >>> --------------------------
            errmsg_numericspaces: {
                en: 'Numbers, "+/" and spaces are allowed.',
                de: 'Erlaubt sind Zahlen, “+/“ und Leerzeichen.'
            },
            // >>> --------------------------
            errmsg_numeric: {
                en: 'Only numbers are allowed.',
                de: 'Es sind nur Zahlen erlaubt.'
            },
            errmsg_alphanum: {
                en: 'Only numbers and letters are allowed.',
                de: 'Erlaubt sind nur Zahlen und Buchstaben.'
            },
            // >>> --------------------------
            errmsg_min_firstname: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            errmsg_max_firstname: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_lastname: {
                en: 'Allowed length: 2-60 characters.',
                de: 'Erlaubte Länge: 2-60 Zeichen.'
            },
            errmsg_max_lastname: {
                en: 'Allowed length: 2-60 characters.',
                de: 'Erlaubte Länge: 2-60 Zeichen.'
            },
            // >>> --------------------------
            errmsg_email: {
                en: 'Please provide valid E-mail.',
                de: 'Bitte geben Sie eine gültige E-Mail an.'
            },
            // >>> --------------------------
            errmsg_min_plz: {
                en: 'Allowed length: 4-8 characters.',
                de: 'Erlaubte Länge: 4-8 Zeichen.'
            },
            errmsg_max_plz: {
                en: 'Allowed length: 4-8 characters.',
                de: 'Erlaubte Länge: 4-8 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_residence: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            errmsg_max_residence: {
                en: 'Allowed length: 2-30 characters.',
                de: 'Erlaubte Länge: 2-30 Zeichen.'
            },
            // >>> --------------------------
            errmsg_min_phone: {
                en: 'Allowed length: 5-18 characters.',
                de: 'Erlaubte Länge: 5-18 Zeichen.'
            },
            errmsg_max_phone: {
                en: 'Allowed length: 5-18 characters.',
                de: 'Erlaubte Länge: 5-18 Zeichen.'
            },
            // >>> -------------------------- 'Form / Model / Vuelidate'
            inputGroupbooking_departureairport: '', // new:
            inputGroupbooking_destinationairport: '',
            inputGroupbooking_departuredate: '',
            inputGroupbooking_destinationdate: '',
            inputGroupbooking_adultschildscount: '',
            inputGroupbooking_infantscount: '',

            inputGroupbooking_groupname: '',
            inputGroupbooking_street: '', // ok
            inputGroupbooking_streetno: '', // ok
            inputGroupbooking_zip: '', // ok
            inputGroupbooking_place: '', // ok
            inputGroupbooking_country: '',

            inputGroupbooking_salutation: '',
            inputGroupbooking_firstname: '', // ok
            inputGroupbooking_lastname: '', // ok
            inputGroupbooking_phone: '', // ok
            inputGroupbooking_mobile: '',
            inputGroupbooking_fax: '',
            inputGroupbooking_email: '', // ok
            inputGroupbooking_emailrepeat: '', // ok
            // >>> --------------------------------------------------------- SearchForm
            outwardonly: false, // ReturnFlight too?
            sentSuccessful: false
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Validations */
    validations: {

        // >>> departureairport -------------
        inputGroupbooking_departureairport: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },
        // >>> destinationairport -----------
        inputGroupbooking_destinationairport: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },
        // >>> departuredate ----------------
        inputGroupbooking_departuredate: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },
        // >>> destinationdate --------------
        inputGroupbooking_destinationdate: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },
        // >>> infantscount -----------------
        inputGroupbooking_infantscount: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },

        // >>> street -----------------------
        inputGroupbooking_street: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },
        // >>> streetno -----------------------
        inputGroupbooking_streetno: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"]
        },
        // >>> zip --------------------------
        inputGroupbooking_zip: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            numeric: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["numeric"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(4),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(8)
        },
        // >>> place ------------------------
        inputGroupbooking_place: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(30),
            letterspaces: letterspaces
        },

        // >>> firstname --------------------
        inputGroupbooking_firstname: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(30),
            letterspaces: letterspaces
        },
        // >>> lastname ---------------------
        inputGroupbooking_lastname: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(2),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(60),
            letterspaces: letterspaces
        },
        // >>> phone ------------------------
        inputGroupbooking_phone: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            minLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["minLength"])(5),
            maxLength: Object(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["maxLength"])(18),
            numericspaces: numericspaces
        },
        // >>> email ------------------------
        inputGroupbooking_email: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"]
        },
        // >>> emailrepeal ------------------
        inputGroupbooking_emailrepeat: {
            required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"],
            email: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["email"]
        }

    }, // eof validations{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getCurrentLocale'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/humanresources/gruppenform' (PUT)
        *
        * Desc:  Saving 'Groups'.
        * Note:
        *
        * @param {Object} requestParamObject (Params to send)
        * @return
        */
        call_saveGroup: function call_saveGroup(requestParamObject) {

            var me = this,
                hdrs = '';

            me.$toc('>>> /infos/group-booking/Home.vue >>> call_saveGroup');
            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put('/humanresources/gruppenform/', requestParamObject).then(function (response) {
                // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.$vp_um();
                        me.sentSuccessful = true;
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        },
        // eof call_saveGroup()


        /******************************************************************* 'Listeners - Common'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onSubmit()
        *
        * Desc: Form gets submitted. Catch up Data.
        * Note:
        *
        * @param {Object} submitEvent (Event)
        * @return
        */
        onSubmit: function onSubmit(submitEvent) {

            var me = this,
                my_arrTimeLocal = null,
                my_city = null,
                my_comment = null,
                my_companyName = null,
                my_country = null,
                my_depTimeLocal = null,
                my_departure = null,
                my_destination = null,
                my_email = null,
                my_email2 = null,
                my_fax = null,
                my_mobile = null,
                my_name = null,
                my_noADL = null,
                my_noCHD = null,
                my_noHours = null,
                my_noINF = null,
                my_phone = null,
                my_salutation = null,
                my_street = null,
                my_streetNo = null,
                my_surname = null,
                my_zip = null,
                requestParamObject = {};

            me.$toc('>>> /infos/group-booking/Home.vue >>> onSubmit');
            // >>> Build Object --------------------------------------------
            requestParamObject = {
                "arrTimeLocal": submitEvent.target.elements['inputGroupbooking_destinationdate'].value,
                "city": submitEvent.target.elements['inputGroupbooking_place'].value,
                "comment": submitEvent.target.elements['inputGroupbooking_remark'].value,
                "companyName": submitEvent.target.elements['inputGroupbooking_groupname'].value,
                "country": submitEvent.target.elements['inputGroupbooking_country'].value,
                "depTimeLocal": submitEvent.target.elements['inputGroupbooking_departuredate'].value,
                "departure": submitEvent.target.elements['inputGroupbooking_departureairport'].value,
                "destination": submitEvent.target.elements['inputGroupbooking_destinationairport'].value,
                "email": submitEvent.target.elements['inputGroupbooking_email'].value,
                "email2": submitEvent.target.elements['inputGroupbooking_emailrepeat'].value,
                "fax": submitEvent.target.elements['inputGroupbooking_fax'].value,
                "mobile": submitEvent.target.elements['inputGroupbooking_mobile'].value,
                "name": submitEvent.target.elements['inputGroupbooking_firstname'].value,
                "noADL": submitEvent.target.elements['inputGroupbooking_adultschildscount'].value !== '' ? Number(submitEvent.target.elements['inputGroupbooking_adultschildscount'].value) : null,
                "noCHD": my_noCHD,
                "noHours": my_noHours,
                "noINF": submitEvent.target.elements['inputGroupbooking_infantscount'].value !== '' ? Number(submitEvent.target.elements['inputGroupbooking_infantscount'].value) : null,
                "phone": submitEvent.target.elements['inputGroupbooking_phone'].value,
                "salutation": submitEvent.target.elements['inputGroupbooking_salutation'].value,
                "street": submitEvent.target.elements['inputGroupbooking_street'].value,
                "streetNo": submitEvent.target.elements['inputGroupbooking_streetno'].value,
                "surname": submitEvent.target.elements['inputGroupbooking_lastname'].value,
                "zip": submitEvent.target.elements['inputGroupbooking_zip'].value
            };

            if (requestParamObject !== '') {
                this.call_saveGroup(requestParamObject);
            }
        },
        // eof onSubmit()


        /*******************************************************************
        * Utilities:
        *******************************************************************/
        /*******************************************************************
        * vldt_Form_Groups()
        *
        * Desc:
        * Note: If valid ... then Call ...
        *
        * @param
        * @return {Boolean}
        */
        vldt_Form_Groups: function vldt_Form_Groups() {

            var me = this,
                formIsValid = true;

            me.$toc('>>> /infos/group-booking/Home.vue >>> vldt_Form_Groups');
            if (formIsValid) {
                // departureairport
                if (me.$v.inputGroupbooking_departureairport.$dirty && !me.$v.inputGroupbooking_departureairport.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // destinationairport
                if (me.$v.inputGroupbooking_destinationairport.$dirty && !me.$v.inputGroupbooking_destinationairport.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // departuredate
                if (me.$v.inputGroupbooking_departuredate.$dirty && !me.$v.inputGroupbooking_departuredate.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (!this.outwardonly) {
                if (formIsValid) {
                    // destinationdate
                    if (me.$v.inputGroupbooking_destinationdate.$dirty && !me.$v.inputGroupbooking_destinationdate.$error) {
                        formIsValid = true;
                    } else {
                        formIsValid = false;
                    }
                }
            }
            if (formIsValid) {
                // infantscount
                if (me.$v.inputGroupbooking_infantscount.$dirty && !me.$v.inputGroupbooking_infantscount.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }

            if (formIsValid) {
                // street
                if (me.$v.inputGroupbooking_street.$dirty && !me.$v.inputGroupbooking_street.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // street
                if (me.$v.inputGroupbooking_streetno.$dirty && !me.$v.inputGroupbooking_streetno.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // street
                if (me.$v.inputGroupbooking_zip.$dirty && !me.$v.inputGroupbooking_zip.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // street
                if (me.$v.inputGroupbooking_place.$dirty && !me.$v.inputGroupbooking_place.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }

            if (formIsValid) {
                // firstname
                if (me.$v.inputGroupbooking_firstname.$dirty && !me.$v.inputGroupbooking_firstname.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // lastname
                if (me.$v.inputGroupbooking_lastname.$dirty && !me.$v.inputGroupbooking_lastname.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // phone
                if (me.$v.inputGroupbooking_phone.$dirty && !me.$v.inputGroupbooking_phone.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // email
                if (me.$v.inputGroupbooking_email.$dirty && !me.$v.inputGroupbooking_email.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }
            if (formIsValid) {
                // emailrepeat
                if (me.$v.inputGroupbooking_emailrepeat.$dirty && !me.$v.inputGroupbooking_emailrepeat.$error) {
                    formIsValid = true;
                } else {
                    formIsValid = false;
                }
            }

            return formIsValid;
        }, // eof vldt_Form_Groups()


        /*******************************************************************
        * range()
        *
        * Desc: Builds Array for 'adultschildscount' Loop.
        * Note:
        *
        * @param min
        * @param max
        * @return {Array}
        */
        range: function range(min, max) {

            var array = [],
                j = 0;

            for (var i = min; i <= max; i++) {
                array[j] = i;
                j++;
            }

            return array;
        } // eof range()

    } // eof methods()
    /* <<< ****************************************************************/

});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gql_query_builder__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gql_query_builder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gql_query_builder__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)





 // Graphql


/* harmony default export */ __webpack_exports__["a"] = ({

  /* >>> *************************************************************** / /* Components */
  components: {

    'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
    'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
    'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

  }, // eof components{}
  /* <<< ****************************************************************/

  /* >>> *************************************************************** / /* Data */
  data: function data() {

    return {
      // >>> --------------------------
      // getCurrentLocale: 'de',
    };
  }, // eof data()
  /* <<< ****************************************************************/

  /* >>> *************************************************************** / /* Computed */
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale', 'get_InfoalertText_DE', 'get_InfoalertText_EN'])), // eof computed{}
  /* <<< ****************************************************************/

  /* >>> *************************************************************** /  /* LifeCycles */
  /***********************************************************************
  * Lifecyclehook::created
  *
  * Desc: Load 'Covid' Text.
  * Note:
  *
  */
  created: function created() {

    var me = this,
        params_DE = null,
        params_EN = null;

    me.$toc('>>> views/cms/infoalert/Home.vue >>> created');
    // >>> ---------------------------------------- Call 'de'
    params_DE = Object(__WEBPACK_IMPORTED_MODULE_4_gql_query_builder__["query"])({
      operation: 'infoalert',
      variables: {
        lang: {
          value: 'de',
          type: 'Lang'
        }
      },
      fields: ['_id', 'headline', 'content']
    });
    me.actn_call_getInfoalertText({ payload: params_DE, lang: 'de' });

    // >>> ---------------------------------------- Call 'en'
    params_EN = Object(__WEBPACK_IMPORTED_MODULE_4_gql_query_builder__["query"])({
      operation: 'infoalert',
      variables: {
        lang: {
          value: 'en',
          type: 'Lang'
        }
      },
      fields: ['_id', 'headline', 'content']
    });
    me.actn_call_getInfoalertText({ payload: params_EN, lang: 'en' });
  }, // eo function created()

  /* <<< ****************************************************************/

  /* >>> *************************************************************** / /* Methods */
  methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['actn_call_getInfoalertText']))
  /* <<< ************************************************************** */

});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // Sidebar (right)
 // Sidebar (right)




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_2__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_3__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Data Protection & Privacy',
                de: 'Datenschutz'
            },
            sections: [] // data
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getCurrentLocale'])), // eof computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc:
    * Note:
    *
    */
    mounted: function mounted() {

        this.call_getwebcomponent('PCPE');
    }, // eo function mounted()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: {

        /******************************************************************* 'ServiceCalls - Common'
        * ServiceCalls:
        *******************************************************************/
        /*******************************************************************
        * Call::'/site/getwebcomponent/'
        *
        * Desc:
        * Note:
        *
        * @param {string} comptype (kind of Component)
        * @param
        * @return
        */
        call_getwebcomponent: function call_getwebcomponent(comptype) {

            var me = this,
                hdrs = '';

            me.$toc('>>> shared/footer/SecondRow.vue >>> call_getwebcomponent');
            // >>> 1. Builds Object ----------------------------------------
            var requestParamObject = {
                name: comptype
            };

            // >>> Send Ajax Request ---------------------------------------
            me.$vp_m();
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/site/getwebcomponent/', requestParamObject).then(function (response) {
                // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK':
                        // 'OK'
                        me.sections = response.data.sections;
                        me.$vp_um();
                        break;
                    default:
                        // 'ERROR'
                        me.$toasted.global.sdr_app_error({
                            message: response.headers["air41-error"]
                        });
                        break;
                };
            }).catch(function (error) {
                // 'ERROR'
                me.$vp_um();
                me.$toasted.global.sdr_app_error({
                    message: 'Service unavailable'
                });
            });
        } // eo function call_getwebcomponent()

    } // eo methods{}
    /* <<< ****************************************************************/
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // Sidebar (right)
 // Sidebar (right)




/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-aboutsundair-box': __WEBPACK_IMPORTED_MODULE_0__shared_sidebar_AboutSundairBox_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */],
        'sdr-promobox': __WEBPACK_IMPORTED_MODULE_2__booking_pagecontent_PromoBox_vue__["a" /* default */]

    }, // eof components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            titleinfo: {
                en: 'Important Informations',
                de: 'Wichtige Informationen'
            },
            // >>> --------------------------
            info_h4_1: {
                en: 'Proof of vaccination, immunity or a negative COVID-19 test are mandatory on all SUNDAIR flights:',
                de: '3G Nachweis auf SUNDAIR Flügen erforderlich:'
            },
            info_10: {
                en: 'Dear passengers,<br /><br />A proof of vaccination or immunity or a negative COVID19 test is required on all departing flights from Germany.<br /><br /><strong>Following proofs must be provided at departure:</strong><br />-Proof of vaccination: Valid is a printed or digital proof of a vaccination series completed more than 14 days ago of a vaccine approved in the EU.<br />-Proof of immunity: The proof of recovery (printed or digital)  must be a PCR/LAMP/TMA test proof that is at least 28 days and maximum six months old.<br />-Test certificates: Antigen, PCR, LAMP and TMA tests conducted at certified COVID19 testing sites are valid. PCR, LAMP, TMA  and Antigen tests may be carried out at the earliest 24 hours before arrival in Germany. <br /><br />This rule applies to passengers six years of age and older.<br /><br /><br />Thank you for your understanding and cooperation.<br />Your SUNDAIR-Team',
                de: 'Liebe Fluggäste,<br /><br />ab sofort gilt auf allen Flügen ab Deutschland die Nachweispflicht von Impf- oder Immunitätsausweisen oder von negativen COVID19 -Tests.<br /><br /><strong>Folgende Nachweise bei Abflug müssen erbracht werden:</strong><br /><br />-Impfnachweis: Gültig ist ein ausgedruckter  oder digitaler Nachweis einer vor mehr als 14 Tagen abgeschlossenen Impfserie eines in der EU zugelassenen Impfstoffs.<br />-Immunitätsnachweis: Der Genesungsnachweis (ausgedruckt oder digital) muss ein PCR-/LAMP-/TMA-Testnachweis sein, der mindestens 28 Tage und maximal sechs Monate alt ist.<br />-Testnachweis: Gültig sind Antigen-, PCR-, LAMP- und TMA-Tests, die an zertifizierten COVID-19-Teststellen durchgeführt wurden. PCR-, LAMP-, TMA sowie Antigen-Tests dürfen frühestens 24 Stunden vor Ankunft vorgenommen werden.<br /><br />Diese Regelung gilt für Fluggäste ab sechs Jahren.<br /><br /><br />Vielen Dank für Ihre Unterstützung und für das entgegengebrachte Vertrauen.<br />Ihr SUNDAIR-Team'
            }
            // >>> --------------------------
            // getCurrentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getCurrentLocale'])) // eof computed{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {}, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {};
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::mounted
    *
    * Desc: Make 'Get Bookings' Call.
    * Note: Send 'authorizationHeader' here.
    *
    */
    mounted: function mounted() {}, // eo function mounted()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([])) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {
        var _ref;

        return _ref = {
            bookingconfirmation: {
                en: 'Step 5: We confirm your booking!',
                de: 'Schritt 5: Hiermit bestätigen wir Ihre Buchung!'
            },
            thankyou: {
                en: 'Thank You. Your booking order is confirmed now.',
                de: 'Vielen Dank. Ihre Buchungsanfrage ist hiermit bestätigt.'
            },
            pleaseselectconfirmation: {
                en: 'Your booking code is',
                de: 'Ihr Buchungscode lautet'
            },
            pleaseselectconfirmation2: {
                en: 'Your Invoice-Id is:',
                de: 'Ihre Rechnungsnummer ist:'
            },
            emailhassent: {
                en: 'A confirmation e-mail has been sent to your provided e-mail address.',
                de: 'An Ihre angegebene E-Mail-Adresse wurde eine Bestätigungs-E-Mail gesendet.'
            },
            paymentmethod: {
                en: 'Your Payment method',
                de: 'Ihre Zahlungsmethode'
            },
            forsecurity: {
                en: 'For security reasons we do not write out your complete payment data here.',
                de: 'Aus Sicherheitsgründen schreiben wir hier Ihre kompletten Zahlungsdaten nicht aus.'
            },
            creditcard: {
                en: 'Creditcard',
                de: 'Kreditkarte'
            },
            tincludedtaxes: {
                en: 'incl. Taxes, Fees & Surcharges',
                de: 'inkl. Steuern, Gebühren & Zuschlägen'
            },
            yourinvoicetotal: {
                en: 'Invoice Total:',
                de: 'Rechnungssumme:'
            },
            // >>> --------------------------

            pleaseselectoverview: {
                en: 'Step 5: Something has gone wrong!',
                de: 'Schritt 5: Etwas ist schief gelaufen!'
            },
            aborttitle: {
                en: 'Something has gone wrong.',
                de: 'Etwas ist schief gelaufen.'
            },
            explanation: {
                en: 'Dear customer, we are sorry. Something went wrong.',
                de: 'Sehr geehrter Kunde, es tut uns leid. Etwas ist schief gelaufen.'
            },
            explanationsub: {
                en: 'You can see the next steps below.',
                de: 'Die weitere Schritte sehen Sie unten.'
            },
            solution: {
                en: 'What can i do?',
                de: 'Was kann ich tun?'
            },
            goback: {
                en: 'BACK TO THE HOMEPAGE',
                de: 'ZURÜCK ZUR HOMEPAGE'
            },
            goback2: {
                en: 'Back to: ',
                de: 'Zurück zur: '
            }
        }, _defineProperty(_ref, 'paymentmethod', {
            en: 'Your Payment method: Credit card',
            de: 'Ihre Zahlungsmethode: Kreditkarte'
        }), _defineProperty(_ref, 'solutiontext', {
            en: 'We are sorry, your booking could not be made. Please try again later. <br /><br />Should your credit card still be charged, the amount will be refunded to you immediately.<br /><br />If you still have a problem or need further help, please contact our customer service..',
            de: 'Es tut uns leid, Ihre Buchung konnte nicht durchgeführt werden. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.<br /><br />Sollte Ihre Kreditkarte trotzdem belastet worden sein, wird Ihnen der Betrag umgehend zurückerstattet.<br /><br />Wenn weiterhin ein Problem bestehlt oder Sie weitere Hilfe benötigen, wenden Sie sich gerne an unseren Kundenservice.'
        }), _defineProperty(_ref, 'alertsuccessful', {
            en: 'Successful!',
            de: 'Erfolgreich!'
        }), _defineProperty(_ref, 'alertyourbooking', {
            en: 'Your booking has been made.',
            de: 'Ihre Buchung ist erfolgt.'
        }), _defineProperty(_ref, 'show_BookingConfirmation', false), _defineProperty(_ref, 'show_BlankoConfirmation', false), _defineProperty(_ref, 'show_RebookingConfirmation', false), _defineProperty(_ref, 'show_Error_Container', false), _ref;
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getCurrentLocale',
    // >>> --------------------------
    'getBookingProcessBookingObject', 'getBookingProcessBookingResults', 'getServicesProcessBookingResults', 'get_RebookingProcessRebookingResults'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> components/checkout/success/Success.vue >>> created');
        if (this.$router.currentRoute.params.modulo !== undefined) {
            this.actn_call_checkTransactionId(this.$router.currentRoute.params.modulo);
            // >>> ----------------------------------------
            __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$on('readytoprocessbooking', this.onEmit_ReadyToDoPrcocessBooking);
            __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$on('readytoshowbookingsconfirmationoncheckout', this.onEmit_ReadyToShow_Booking_Confirmation);
            __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$on('errorinconfirmation', this.onEmit_ErrorInConfirmation);
        }
    }, // eo function created()


    /***********************************************************************
    * Lifecyclehook::beforeDestroy
    *
    * Desc: Destroy Listener.
    * Note:
    *
    */
    beforeDestroy: function beforeDestroy() {

        var me = this;

        me.$toc('>>> components/checkout/success/Success.vue >>> beforeDestroy');
        // >>> ----------------------------------------
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$off('readytoprocessbooking', this.onEmit_ReadyToDoPrcocessBooking);
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$off('readytoshowbookingsconfirmationoncheckout', this.onEmit_ReadyToShow_Booking_Confirmation);
        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$off('errorinconfirmation', this.onEmit_ErrorInConfirmation);
    }, // eo function beforeDestroy()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['actn_call_checkTransactionId', 'actn_call_processBooking', 'actn_call_registrationNewSpecials', 'actn_call_processRebooking']), {

        /******************************************************************* 'Listeners - eventbus'
        * Listeners:
        *******************************************************************/
        /*******************************************************************
        * onEmit_ReadyToDoPrcocessBooking()
        *
        * Desc:
        * Note:
        *
        */
        onEmit_ReadyToDoPrcocessBooking: function onEmit_ReadyToDoPrcocessBooking(data) {

            var me = this,
                myObjectToSend = {};

            me.$toc('>>> components/checkout/success/Success.vue >>> onEmit_ReadyToDoPrcocessBooking');
            switch (data.callName) {
                case 'TICKET_BOOKING':
                    myObjectToSend = data.ticketBookingRQObject;
                    this.actn_call_processBooking(myObjectToSend);
                    break;
                case 'BLANKO':
                    myObjectToSend = data.newSpecialsRQObject;
                    this.actn_call_registrationNewSpecials(myObjectToSend);
                    break;
                case 'REBOOKING':
                    myObjectToSend = data.rebookingRQObject;
                    this.actn_call_processRebooking(myObjectToSend);
                    break;
                default:
                    break;
            }
        }, // eo function onEmit_ReadyToDoPrcocessBooking()


        /*******************************************************************
        * onEmit_ReadyToShow_Booking_Confirmation()
        *
        * Desc: ProcessBooking or Colleagues was done.
        * Note:
        *
        */
        onEmit_ReadyToShow_Booking_Confirmation: function onEmit_ReadyToShow_Booking_Confirmation(data) {

            var me = this,
                callName = null;

            me.$toc('>>> components/checkout/success/Success.vue >>> onEmit_ReadyToShow_Booking_Confirmation');
            // >>> --------------------------
            if (data.totalBooking !== undefined) {
                callName = 'TICKET_BOOKING';
            }
            if (data.newSpecialsResponse !== undefined) {
                callName = 'BLANKO';
            }
            if (data.rebookingPrice !== undefined) {
                callName = 'REBOOKING';
            }

            // >>> --------------------------
            switch (callName) {
                case 'TICKET_BOOKING':
                    this.show_BookingConfirmation = true;
                    this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");
                    break;
                case 'BLANKO':
                    this.show_BlankoConfirmation = true;
                    this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");
                    break;
                case 'REBOOKING':
                    this.show_RebookingConfirmation = true;
                    this.$swal(this.alertsuccessful[this.getCurrentLocale], this.alertyourbooking[this.getCurrentLocale], "success");
                    break;
                default:
                    break;
            }
        }, // eo function onEmit_ReadyToShow_Booking_Confirmation()


        /*******************************************************************
        * onEmit_ErrorInConfirmation()
        *
        * Desc:
        * Note:
        *
        */
        onEmit_ErrorInConfirmation: function onEmit_ErrorInConfirmation(data) {

            var me = this;

            me.$toc('>>> components/checkout/success/Success.vue >>> onEmit_ErrorInConfirmation');
            this.show_Error_Container = true;
        } // eo function onEmit_ErrorInConfirmation()

    }) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

    /* >>> *************************************************************** / /* Components */
    components: {

        'sdr-breadcrumbs': __WEBPACK_IMPORTED_MODULE_0__shared_breadcrumbs_Breadcrumbs_vue__["a" /* default */],
        'sdr-contact-box': __WEBPACK_IMPORTED_MODULE_1__shared_sidebar_ContactBox_vue__["a" /* default */]

    }, // eo components{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Data */
    data: function data() {

        return {
            pleaseselectoverview: {
                en: 'Step 5: Something has gone wrong!',
                de: 'Schritt 5: Etwas ist schief gelaufen!'
            },
            aborttitle: {
                en: 'Something has gone wrong.',
                de: 'Etwas ist schief gelaufen.'
            },
            explanation: {
                en: 'Dear customer, we are sorry. Something went wrong.',
                de: 'Sehr geehrter Kunde, es tut uns leid. Etwas ist schief gelaufen.'
            },
            explanationsub: {
                en: 'You can see the next steps below.',
                de: 'Die weitere Schritte sehen Sie unten.'
            },
            solution: {
                en: 'What can i do?',
                de: 'Was kann ich tun?'
            },
            goback: {
                en: 'BACK TO THE HOMEPAGE',
                de: 'ZURÜCK ZUR HOMEPAGE'
            },
            goback2: {
                en: 'Back to: ',
                de: 'Zurück zur: '
            },
            paymentmethod: {
                en: 'Your Payment method: Credit card',
                de: 'Ihre Zahlungsmethode: Kreditkarte'
            },
            solutiontext: {
                en: 'At the moment we cannot process your booking. Please check your payment information and try again. If the problem persists, please contact your bank. <br /><br />If you need further help or support, please feel free to contact our customer service department.',
                de: 'Im Moment können wir Ihre Buchung nicht bearbeiten. Bitte überprüfen Sie Ihre Zahlungsinformationen und versuchen Sie es noch einmal. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an Ihre Bank.<br /><br />Wenn Sie weitere Hilfe oder Unterstützung benötigen, wenden Sie sich gerne an unseren Kundenservice.'
            }
        };
    }, // eo function data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getCurrentLocale'])), // eo computed{}
    /* <<< ****************************************************************/

    /* >>> *************************************************************** /  /* LifeCycles */
    /***********************************************************************
    * Lifecyclehook::created
    *
    * Desc:
    * Note:
    *
    */
    created: function created() {

        var me = this;

        me.$toc('>>> components/checkout/abort/Abort.vue >>> created');
        if (this.$router.currentRoute.params.modulo !== undefined) {
            this.actn_call_releaseBooking(this.$router.currentRoute.params.modulo);
        }
    }, // eo function created()


    /* >>> *************************************************************** / /* Methods */
    methods: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['actn_call_releaseBooking'])) // eo methods{}
    /* <<< ****************************************************************/

});

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(223);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13), __webpack_require__(20)))

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.0.2
  * (c) 2018 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
      ? 'router-link-active'
      : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
      ? 'router-link-exact-active'
      : globalExactActiveClass;
    var activeClass = this.activeClass == null
      ? activeClassFallback
      : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
      ? exactActiveClassFallback
      : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
}

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  window.history.replaceState({ key: getStateKey() }, '', window.location.href.replace(window.location.origin, ''));
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(router, to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : decodeURI(href.slice(index + 1))
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */



var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.2';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(15);
/*
* SundAir2019Plugin.js
*
* Description: This is our plugin object. It can be exported to be used anywhere.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/


var SundAir2019Plugin = {
	install: function install(Vue, options) {

		/***********************************************************************
        *
        * Desc:
        * Note:
        */
		// We call Vue.mixin() here to inject functionality into all components.
		// Vue.mixin({
		//     // Anything added to a mixin will be injected into all components.
		//     // In this case, the mounted() method runs when the component is added to the DOM.
		//     mounted() {
		//         console.log('Mounted!');
		//     },
		// });
		Vue.loader = '';
		// Vue.myAddedMethod = function() {
		//     return Vue.myAddedProperty;
		// };


		/***********************************************************************
        *
        * Desc:
        * Note:
        *
        */
		// Add $surname instance property directly to Vue components
		// Vue.prototype.$surname = 'Broeker';
		// Vue.prototype.$myAddedMethod = function() {
		//     return Vue.prototype.$surname;
		// };


		/***********************************************************************
        * Global: make_basic_auth()
        *
        * Desc: Build 'Authorization' Key for API Calls.
        * Note:
        *
        */
		Vue.prototype.$make_basic_auth = function () {

			var me = this,
			    Base64 = {},
			    token,
			    hash,
			    user = 'booking_website',
			    password = 'D1sq3ccfwests!';

			Base64 = {
				// private property
				keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',

				// public method for encoding
				encode: function encode(input) {
					var output = '',
					    chr1,
					    chr2,
					    chr3,
					    enc1,
					    enc2,
					    enc3,
					    enc4,
					    i = 0;

					input = Base64.utf8_encode(input);

					while (i < input.length) {
						chr1 = input.charCodeAt(i++);
						chr2 = input.charCodeAt(i++);
						chr3 = input.charCodeAt(i++);

						enc1 = chr1 >> 2;
						enc2 = (chr1 & 3) << 4 | chr2 >> 4;
						enc3 = (chr2 & 15) << 2 | chr3 >> 6;
						enc4 = chr3 & 63;

						if (isNaN(chr2)) {
							enc3 = enc4 = 64;
						} else if (isNaN(chr3)) {
							enc4 = 64;
						}

						output = output + this.keyStr.charAt(enc1) + this.keyStr.charAt(enc2) + this.keyStr.charAt(enc3) + this.keyStr.charAt(enc4);
					}

					return output;
				},
				// private method for UTF-8 encoding
				utf8_encode: function utf8_encode(string) {
					var utftext = '',
					    n,
					    c;

					string = string.replace(/\r\n/g, '\n');

					for (n = 0; n < string.length; n++) {
						c = string.charCodeAt(n);

						if (c < 128) {
							utftext += String.fromCharCode(c);
						} else if (c > 127 && c < 2048) {
							utftext += String.fromCharCode(c >> 6 | 192);
							utftext += String.fromCharCode(c & 63 | 128);
						} else {
							utftext += String.fromCharCode(c >> 12 | 224);
							utftext += String.fromCharCode(c >> 6 & 63 | 128);
							utftext += String.fromCharCode(c & 63 | 128);
						}
					}

					return utftext;
				}
			};

			token = user + ':' + password;
			hash = Base64.encode(token);

			return 'Basic ' + hash;
		}; // eo function make_basic_auth()


		/***********************************************************************
        * Global: header_language()
        *
        * Desc: Right Header Language to send.
        * Note:
        *
        */
		Vue.prototype.$header_language = function () {

			var lang = 'DE',
			    localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')); // catch


			// Language in localStrage?
			if (localStorageLanguage !== null) {
				lang = localStorageLanguage.value.toUpperCase();
			}

			return lang;
		}; // eo function header_language()


		/***********************************************************************
        * Global: selectInits()
        *
        * Desc: Initializes Select Fields.
        * Note:
        *
        */
		Vue.prototype.$selectInits = function (modulo, currentLocale) {

			if (modulo === 'booking') {
				tjq('.selector select').each(function () {
					var obj = tjq(this);
					if (obj.parent().children('.custom-select').length < 1) {
						obj.after("<span class='custom-select'>" + obj.children('option:selected').html() + '</span>');

						if (obj.hasClass('white-bg')) {
							obj.next('span.custom-select').addClass('white-bg');
						}
						if (obj.hasClass('full-width')) {
							//obj.removeClass("full-width");
							//obj.css("width", obj.parent().width() + "px");
							//obj.next("span.custom-select").css("width", obj.parent().width() + "px");
							obj.next('span.custom-select').addClass('full-width');
						}
					}
				});
				tjq('body').on('change', '.selector select', function () {
					if (tjq(this).next('span.custom-select').length > 0) {
						tjq(this).next('span.custom-select').text(tjq(this).find('option:selected').text());
					}
				});
				tjq('body').on('keydown', '.selector select', function () {
					if (tjq(this).next('span.custom-select').length > 0) {
						tjq(this).next('span.custom-select').text(tjq(this).find('option:selected').text());
					}
				});
			}

			if (modulo === 'services') {
				tjq('.selector select').each(function () {
					var obj = tjq(this);
					if (obj.parent().children('.custom-select-services').length < 1) {
						obj.after("<span class='custom-select-services'>" + obj.children('option:selected').html() + '</span>');

						if (obj.hasClass('white-bg')) {
							obj.next('span.custom-select-services').addClass('white-bg');
						}
						if (obj.hasClass('full-width')) {
							//obj.removeClass("full-width");
							//obj.css("width", obj.parent().width() + "px");
							//obj.next("span.custom-select").css("width", obj.parent().width() + "px");
							obj.next('span.custom-select-services').addClass('full-width');
						}
					}
				});
				tjq('body').on('change', '.selector select', function () {
					if (tjq(this).next('span.custom-select-services').length > 0) {
						tjq(this).next('span.custom-select-services').text(tjq(this).find('option:selected').text());
					}
				});
				tjq('body').on('keydown', '.selector select', function () {
					if (tjq(this).next('span.custom-select-services').length > 0) {
						tjq(this).next('span.custom-select-services').text(tjq(this).find('option:selected').text());
					}
				});
			}

			if (modulo === 'rebooking') {
				tjq('.selector select').each(function () {
					var obj = tjq(this);
					if (obj.parent().children('.custom-select-rebooking').length < 1) {
						obj.after("<span class='custom-select-rebooking'>" + obj.children('option:selected').html() + '</span>');

						if (obj.hasClass('white-bg')) {
							obj.next('span.custom-select-rebooking').addClass('white-bg');
						}
						if (obj.hasClass('full-width')) {
							//obj.removeClass("full-width");
							//obj.css("width", obj.parent().width() + "px");
							//obj.next("span.custom-select").css("width", obj.parent().width() + "px");
							obj.next('span.custom-select-rebooking').addClass('full-width');
						}
					}
				});
				tjq('body').on('change', '.selector select', function () {
					if (tjq(this).next('span.custom-select-rebooking').length > 0) {
						tjq(this).next('span.custom-select-rebooking').text(tjq(this).find('option:selected').text());
					}
				});
				tjq('body').on('keydown', '.selector select', function () {
					if (tjq(this).next('span.custom-select-rebooking').length > 0) {
						tjq(this).next('span.custom-select-rebooking').text(tjq(this).find('option:selected').text());
					}
				});
			}

			// change UI of file input
			tjq('.fileinput input[type=file]').each(function () {
				var obj = tjq(this);
				if (obj.parent().children('.custom-fileinput').length < 1) {
					obj.after('<input type="text" class="custom-fileinput" />');
					if (typeof obj.data('placeholder') != 'undefined') {
						obj.next('.custom-fileinput').attr('placeholder', obj.data('placeholder'));
					}
					if (typeof obj.prop('class') != 'undefined') {
						obj.next('.custom-fileinput').addClass(obj.prop('class'));
					}
					obj.parent().css('line-height', obj.outerHeight() + 'px');
				}
			});

			tjq('.fileinput input[type=file]').on('change', function () {
				var fileName = this.value;
				var slashIndex = fileName.lastIndexOf('\\');
				if (slashIndex == -1) {
					slashIndex = fileName.lastIndexOf('/');
				}
				if (slashIndex != -1) {
					fileName = fileName.substring(slashIndex + 1);
				}
				tjq(this).next('.custom-fileinput').val(fileName);
			});
			// checkbox
			tjq(".checkbox input[type='checkbox'], .radio input[type='radio']").each(function () {
				if (tjq(this).is(':checked')) {
					tjq(this).closest('.checkbox').addClass('checked');
					tjq(this).closest('.radio').addClass('checked');
				}
			});
			tjq(".checkbox input[type='checkbox']").bind('change', function () {
				if (tjq(this).is(':checked')) {
					tjq(this).closest('.checkbox').addClass('checked');
				} else {
					tjq(this).closest('.checkbox').removeClass('checked');
				}
			});
			//radio
			tjq(".radio input[type='radio']").bind('change', function (event, ui) {
				if (tjq(this).is(':checked')) {
					var name = tjq(this).prop('name');
					if (typeof name != 'undefined') {
						tjq(".radio input[name='" + name + "']").closest('.radio').removeClass('checked');
					}
					tjq(this).closest('.radio').addClass('checked');
				}
			});

			// datepicker
			tjq('.datepicker-wrap input').each(function () {
				var minDate = tjq(this).data('min-date'),
				    regional = '',
				    dayNamesMin = [],
				    monthNames = [];

				if (typeof minDate == 'undefined') {
					minDate = 0;
				}
				if (currentLocale === 'de') {
					regional = 'de';
					dayNamesMin = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
					monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
				}
				if (currentLocale === 'en') {
					regional = '';
					dayNamesMin = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
					monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
				}

				tjq(this).datepicker({
					firstDay: 1, // starting on 'Monday'
					regional: regional, // Leave ot empty for 'en'
					showOn: 'button',
					buttonImage: '../res/images/icon/blank.png',
					buttonText: '',
					buttonImageOnly: true,
					changeYear: false,
					/*showOtherMonths: true,*/
					minDate: minDate,
					dateFormat: 'dd.mm.yy',
					dayNamesMin: dayNamesMin,
					monthNames: monthNames,
					beforeShow: function beforeShow(input, inst) {
						var themeClass = tjq(input).parent().attr('class').replace('datepicker-wrap', '');
						tjq('#ui-datepicker-div').attr('class', '');
						tjq('#ui-datepicker-div').addClass('ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all');
						tjq('#ui-datepicker-div').addClass(themeClass);
					},
					onClose: function onClose(selectedDate) {
						if (tjq(this).attr('name') == 'date_from') {
							if (tjq(this).closest('form').find('input[name="date_to"]').length > 0) {
								tjq(this).closest('form').find('input[name="date_to"]').datepicker('option', 'minDate', selectedDate);
							}
						}
						if (tjq(this).attr('name') == 'date_to') {
							if (tjq(this).closest('form').find('input[name="date_from"]').length > 0) {
								tjq(this).closest('form').find('input[name="date_from"]').datepicker('option', 'maxDate', selectedDate);
							}
						}
					}
				});
			});
		}; // eo funtion selectInits()


		/***********************************************************************
  * Global: enableChaser()
  *
  * Desc:
  * Note:
  *
  */
		Vue.prototype.$enableChaser = function () {

			if (enableChaser == 1 && tjq('#content').length > 0 && tjq('#main-menu ul.menu').length > 0) {
				var forchBottom;
				var chaser = tjq('#main-menu ul.menu').clone().hide().appendTo(document.body).wrap("<div class='chaser hidden-mobile'><div class='container'></div></div>");
				tjq('<h1 class="logo navbar-brand"><a title="Sundair" href="/index.php"><img alt="" src="../res/images/logo.png"></a></h1>').insertBefore('.chaser .menu');
				var forch = tjq('#content').first();
				forchBottom = forch.offset().top + 2;
				tjq(window).on('scroll', function () {
					var top = tjq(document).scrollTop();
					if (tjq('.chaser').is(':hidden') && top > forchBottom) {
						tjq('.chaser').slideDown(300);
						//chaser.fadeIn(300, shown);
					} else if (tjq('.chaser').is(':visible') && top < forchBottom) {
						tjq('.chaser').slideUp(200);
						//chaser.fadeOut(200, hidden);
					}
				});
				tjq(window).on('resize', function () {
					var top = tjq(document).scrollTop();
					if (tjq('.chaser').is(':hidden') && top > forchBottom) {
						tjq('.chaser').slideDown(300);
					} else if (tjq('.chaser').is(':visible') && top < forchBottom) {
						tjq('.chaser').slideUp(200);
					}
				});

				tjq('.chaser').css('visibility', 'hidden');
				chaser.show();
				fixPositionMegaMenu('.chaser');
				tjq('.chaser .megamenu-menu').removeClass('light');
				//chaser.hide();
				tjq('.chaser').hide();
				tjq('.chaser').css('visibility', 'visible');
			}
		}; // eo funtion enableChaser()


		/*******************************************************************************
  * isObjectEmpty()
  *
  * Desc: Checks if an object has the form {} (is empty)
  * Note:
  *
  * @param {Object} obj (obj to check)
  *
  */
		Vue.prototype.$isObjectEmpty = function (obj) {

			if (obj !== null) {
				return Object.keys(obj).length === 0 && obj.constructor === Object;
			} else {
				return true;
			}
		}; // eo function isObjectEmpty()


		/***********************************************************************
        * Global: vp_m()
        *
        * Desc: Mask Viewport.
        * Note: Loader Config here.
        *
        */
		Vue.prototype.$vp_m = function () {

			Vue.loader = this.$loading.show({
				// container: this.$refs.loadingContainer, // ?
				canCancel: false, // default false
				color: '#ec008b',
				loader: 'spinner',
				width: 64,
				height: 64,
				backgroundColor: '#ffffff',
				opacity: 0.5
			});
		}; // eo function vp_m()


		/***********************************************************************
        * Global: vp_m()
        *
        * Desc: Unmask Viewport.
        * Note:
        *
        */
		Vue.prototype.$vp_um = function () {

			Vue.loader.hide();
		}; // eo function vp_um()


		/***********************************************************************
        * Global: trnsl_error_message()
        *
        * Desc:
        * Note: Very incomplete!!!
        *
        * @param {String} m (Message to log)
        */
		Vue.prototype.$trnsl_error_message = function (m) {

			var me = this,
			    nsa = '',
			    // new string a
			nsb = '',
			    // new string b
			splittedMessage = [],
			    trsnltd = [],
			    currentLocale = 'de',
			    localStorageLanguage = JSON.parse(localStorage.getItem('sdr__lang')),
			    // catch
			errors = [{ key: '20111', de: 'Ungültige Erwachsenenzahl. Geburtstag überprüfen.', en: 'Invalid number of Adults. Please check Birthdate.' }, // 'validatePassenger'
			{ key: '50055', de: 'Pax Vorname ist verpflichtend.', en: 'Pax firstname is mandatory.' }, // 'validatePassenger'
			{ key: '50056', de: 'Pax Nachname ist verpflichtend.', en: 'Pax lastname is mandatory.' }, // 'validatePassenger'
			{ key: '50015', de: 'Ihre gewünschten Services sind auf dem Flug nicht mehr vorhanden. Bitte kontaktieren Sie unseren Kundenservice.', en: 'The services you have chosen are not available anymore on the flights. Please contact our customer service.' }, // 'validatePassenger'
			{ key: '1003', de: 'Agentur kann nicht angemeldet werden.', en: 'Agency cannot be registered.' }, // 'getAgency'
			{ key: '120102', de: 'Keine Serviceverfügbarkeit auf dem Flug für Umbuchungen.', en: 'No service availability on flight for rebooking.' }, // 'rebooking, missing services'
			{ key: '30001', de: 'Leider konnten wir Ihren Buchungscode nicht finden.', en: 'Unfortunately we could not find your Bookingcode.' }, // 'rebooking, no not found'
			{ key: '105018', de: 'Diese Profil scheint nicht zu existieren. Falsch eingegeben?', en: 'This profile does not seem to exist. Entered incorrectly?' }, // 'auth, no such profile'
			{ key: '105120', de: 'Ungültige E-mail und/oder Passwort. Falsch eingegeben?', en: 'Invalid email and/or password. Entered incorrectly?' }, // 'auth, no such profile'
			{ key: '105016', de: 'E-mail Adresse bereits in Benutzung.', en: 'Email already in use.' }, // 'auth, email already in use'
			{ key: '50002', de: 'Es ist ein Fehler aufgetreten, bitte starten Sie den Buchungsprozess erneut.', en: 'An error has occurred, please restart the booking process.' }, // #46
			{ key: '50000', de: 'Leider ist keine Sitzplatzbuchung möglich, wenden Sie sich bitte an den Kundenservice.', en: 'We are sorry, but it is not possible to book a seat, please contact customer service.' }, // #54
			{ key: '50003', de: 'Es ist ein Fehler aufgetreten, bitte starten Sie den Buchungsprozess erneut.', en: 'An error has occurred, please restart the booking process.' }];

			// Language in localStrage?
			if (localStorageLanguage !== null) {
				currentLocale = localStorageLanguage.value;
			}

			nsa = m.substring(1); // del 1st
			nsb = nsa.substr(0, nsa.length - 1); // del last
			splittedMessage = nsb.split(']['); // split
			trsnltd = errors.find(function (item) {
				return item.key === splittedMessage[0];
			}); // find


			return trsnltd[currentLocale];
		}; // eo function trnsl_error_message()


		/***********************************************************************
        * Global: toc()
        *
        * Desc: Application Infos while Debugging.
        * Note: Now via config.js.in anderes Wunschziel? Kayofly su
        *
        * @param {String} m (Message to log)
        */
		Vue.prototype.$toc = function (m) {

			var rm = 'PROD'; // CONF_ENVIRONMENT?!


			if (rm === 'DEV') {
				console.log(m);
			}
		}; // eo function toc()
	} // eo function install()

};

/* harmony default export */ __webpack_exports__["a"] = (SundAir2019Plugin);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);
var bind = __webpack_require__(24);
var Axios = __webpack_require__(228);
var defaults = __webpack_require__(21);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(28);
axios.CancelToken = __webpack_require__(242);
axios.isCancel = __webpack_require__(27);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(243);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 227 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(21);
var utils = __webpack_require__(10);
var InterceptorManager = __webpack_require__(237);
var dispatchRequest = __webpack_require__(238);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(26);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);
var transformData = __webpack_require__(239);
var isCancel = __webpack_require__(27);
var defaults = __webpack_require__(21);
var isAbsoluteURL = __webpack_require__(240);
var combineURLs = __webpack_require__(241);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(10);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(28);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/dist/",e(e.s=6)}([function(t,e,n){"use strict";function r(){d=!1}function i(t){if(!t)return void(f!==m&&(f=m,r()));if(t!==f){if(t.length!==m.length)throw new Error("Custom alphabet for shortid must be "+m.length+" unique characters. You submitted "+t.length+" characters: "+t);var e=t.split("").filter(function(t,e,n){return e!==n.lastIndexOf(t)});if(e.length)throw new Error("Custom alphabet for shortid must be "+m.length+" unique characters. These characters were not unique: "+e.join(", "));f=t,r()}}function o(t){return i(t),f}function a(t){h.seed(t),p!==t&&(r(),p=t)}function s(){f||i(m);for(var t,e=f.split(""),n=[],r=h.nextValue();e.length>0;)r=h.nextValue(),t=Math.floor(r*e.length),n.push(e.splice(t,1)[0]);return n.join("")}function c(){return d||(d=s())}function u(t){return c()[t]}function l(){return f||m}var f,p,d,h=n(19),m="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";t.exports={get:l,characters:o,seed:a,lookup:u,shuffled:c}},function(t,e,n){"use strict";var r=n(5),i=n.n(r);e.a={animateIn:function(t){i()({targets:t,translateY:"-35px",opacity:1,duration:300,easing:"easeOutCubic"})},animateOut:function(t,e){i()({targets:t,opacity:0,marginTop:"-40px",duration:300,easing:"easeOutExpo",complete:e})},animateOutBottom:function(t,e){i()({targets:t,opacity:0,marginBottom:"-40px",duration:300,easing:"easeOutExpo",complete:e})},animateReset:function(t){i()({targets:t,left:0,opacity:1,duration:300,easing:"easeOutExpo"})},animatePanning:function(t,e,n){i()({targets:t,duration:10,easing:"easeOutQuad",left:e,opacity:n})},animatePanEnd:function(t,e){i()({targets:t,opacity:0,duration:300,easing:"easeOutExpo",complete:e})},clearAnimation:function(t){var e=i.a.timeline();t.forEach(function(t){e.add({targets:t.el,opacity:0,right:"-40px",duration:300,offset:"-=150",easing:"easeOutExpo",complete:function(){t.remove()}})})}}},function(t,e,n){"use strict";t.exports=n(16)},function(t,e,n){"use strict";n.d(e,"a",function(){return s});var r=n(8),i=n(1),o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=n(2);n(11).polyfill();var s=function t(e){var n=this;return this.id=a.generate(),this.options=e,this.cached_options={},this.global={},this.groups=[],this.toasts=[],u(this),this.group=function(e){e||(e={}),e.globalToasts||(e.globalToasts={}),Object.assign(e.globalToasts,n.global);var r=new t(e);return n.groups.push(r),r},this.register=function(t,e,r){return r=r||{},l(n,t,e,r)},this.show=function(t,e){return c(n,t,e)},this.success=function(t,e){return e=e||{},e.type="success",c(n,t,e)},this.info=function(t,e){return e=e||{},e.type="info",c(n,t,e)},this.error=function(t,e){return e=e||{},e.type="error",c(n,t,e)},this.remove=function(t){n.toasts=n.toasts.filter(function(e){return e.el.hash!==t.hash}),t.parentNode&&t.parentNode.removeChild(t)},this.clear=function(t){return i.a.clearAnimation(n.toasts,function(){t&&t()}),n.toasts=[],!0},this},c=function(t,e,i){i=i||{};var a=null;if("object"!==(void 0===i?"undefined":o(i)))return console.error("Options should be a type of object. given : "+i),null;t.options.singleton&&t.toasts.length>0&&(t.cached_options=i,t.toasts[t.toasts.length-1].goAway(0));var s=Object.assign({},t.options);return Object.assign(s,i),a=n.i(r.a)(t,e,s),t.toasts.push(a),a},u=function(t){var e=t.options.globalToasts,n=function(e,n){return"string"==typeof n&&t[n]?t[n].apply(t,[e,{}]):c(t,e,n)};e&&(t.global={},Object.keys(e).forEach(function(r){t.global[r]=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return e[r].apply(null,[t,n])}}))},l=function(t,e,n,r){t.options.globalToasts||(t.options.globalToasts={}),t.options.globalToasts[e]=function(t,e){var i=null;return"string"==typeof n&&(i=n),"function"==typeof n&&(i=n(t)),e(i,r)},u(t)}},function(t,e,n){n(22);var r=n(21)(null,null,null,null);t.exports=r.exports},function(t,e,n){(function(n){var r,i,o,a={scope:{}};a.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(t,e,n){if(n.get||n.set)throw new TypeError("ES3 does not support getters and setters.");t!=Array.prototype&&t!=Object.prototype&&(t[e]=n.value)},a.getGlobal=function(t){return"undefined"!=typeof window&&window===t?t:void 0!==n&&null!=n?n:t},a.global=a.getGlobal(this),a.SYMBOL_PREFIX="jscomp_symbol_",a.initSymbol=function(){a.initSymbol=function(){},a.global.Symbol||(a.global.Symbol=a.Symbol)},a.symbolCounter_=0,a.Symbol=function(t){return a.SYMBOL_PREFIX+(t||"")+a.symbolCounter_++},a.initSymbolIterator=function(){a.initSymbol();var t=a.global.Symbol.iterator;t||(t=a.global.Symbol.iterator=a.global.Symbol("iterator")),"function"!=typeof Array.prototype[t]&&a.defineProperty(Array.prototype,t,{configurable:!0,writable:!0,value:function(){return a.arrayIterator(this)}}),a.initSymbolIterator=function(){}},a.arrayIterator=function(t){var e=0;return a.iteratorPrototype(function(){return e<t.length?{done:!1,value:t[e++]}:{done:!0}})},a.iteratorPrototype=function(t){return a.initSymbolIterator(),t={next:t},t[a.global.Symbol.iterator]=function(){return this},t},a.array=a.array||{},a.iteratorFromArray=function(t,e){a.initSymbolIterator(),t instanceof String&&(t+="");var n=0,r={next:function(){if(n<t.length){var i=n++;return{value:e(i,t[i]),done:!1}}return r.next=function(){return{done:!0,value:void 0}},r.next()}};return r[Symbol.iterator]=function(){return r},r},a.polyfill=function(t,e,n,r){if(e){for(n=a.global,t=t.split("."),r=0;r<t.length-1;r++){var i=t[r];i in n||(n[i]={}),n=n[i]}t=t[t.length-1],r=n[t],e=e(r),e!=r&&null!=e&&a.defineProperty(n,t,{configurable:!0,writable:!0,value:e})}},a.polyfill("Array.prototype.keys",function(t){return t||function(){return a.iteratorFromArray(this,function(t){return t})}},"es6-impl","es3");var s=this;!function(n,a){i=[],r=a,void 0!==(o="function"==typeof r?r.apply(e,i):r)&&(t.exports=o)}(0,function(){function t(t){if(!R.col(t))try{return document.querySelectorAll(t)}catch(t){}}function e(t,e){for(var n=t.length,r=2<=arguments.length?arguments[1]:void 0,i=[],o=0;o<n;o++)if(o in t){var a=t[o];e.call(r,a,o,t)&&i.push(a)}return i}function n(t){return t.reduce(function(t,e){return t.concat(R.arr(e)?n(e):e)},[])}function r(e){return R.arr(e)?e:(R.str(e)&&(e=t(e)||e),e instanceof NodeList||e instanceof HTMLCollection?[].slice.call(e):[e])}function i(t,e){return t.some(function(t){return t===e})}function o(t){var e,n={};for(e in t)n[e]=t[e];return n}function a(t,e){var n,r=o(t);for(n in t)r[n]=e.hasOwnProperty(n)?e[n]:t[n];return r}function c(t,e){var n,r=o(t);for(n in e)r[n]=R.und(t[n])?e[n]:t[n];return r}function u(t){t=t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(t,e,n,r){return e+e+n+n+r+r});var e=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);t=parseInt(e[1],16);var n=parseInt(e[2],16),e=parseInt(e[3],16);return"rgba("+t+","+n+","+e+",1)"}function l(t){function e(t,e,n){return 0>n&&(n+=1),1<n&&--n,n<1/6?t+6*(e-t)*n:.5>n?e:n<2/3?t+(e-t)*(2/3-n)*6:t}var n=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t)||/hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t);t=parseInt(n[1])/360;var r=parseInt(n[2])/100,i=parseInt(n[3])/100,n=n[4]||1;if(0==r)i=r=t=i;else{var o=.5>i?i*(1+r):i+r-i*r,a=2*i-o,i=e(a,o,t+1/3),r=e(a,o,t);t=e(a,o,t-1/3)}return"rgba("+255*i+","+255*r+","+255*t+","+n+")"}function f(t){if(t=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t))return t[2]}function p(t){return-1<t.indexOf("translate")||"perspective"===t?"px":-1<t.indexOf("rotate")||-1<t.indexOf("skew")?"deg":void 0}function d(t,e){return R.fnc(t)?t(e.target,e.id,e.total):t}function h(t,e){if(e in t.style)return getComputedStyle(t).getPropertyValue(e.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function m(t,e){return R.dom(t)&&i(D,e)?"transform":R.dom(t)&&(t.getAttribute(e)||R.svg(t)&&t[e])?"attribute":R.dom(t)&&"transform"!==e&&h(t,e)?"css":null!=t[e]?"object":void 0}function v(t,n){var r=p(n),r=-1<n.indexOf("scale")?1:0+r;if(!(t=t.style.transform))return r;for(var i=[],o=[],a=[],s=/(\w+)\((.+?)\)/g;i=s.exec(t);)o.push(i[1]),a.push(i[2]);return t=e(a,function(t,e){return o[e]===n}),t.length?t[0]:r}function g(t,e){switch(m(t,e)){case"transform":return v(t,e);case"css":return h(t,e);case"attribute":return t.getAttribute(e)}return t[e]||0}function y(t,e){var n=/^(\*=|\+=|-=)/.exec(t);if(!n)return t;var r=f(t)||0;switch(e=parseFloat(e),t=parseFloat(t.replace(n[0],"")),n[0][0]){case"+":return e+t+r;case"-":return e-t+r;case"*":return e*t+r}}function b(t,e){return Math.sqrt(Math.pow(e.x-t.x,2)+Math.pow(e.y-t.y,2))}function x(t){t=t.points;for(var e,n=0,r=0;r<t.numberOfItems;r++){var i=t.getItem(r);0<r&&(n+=b(e,i)),e=i}return n}function T(t){if(t.getTotalLength)return t.getTotalLength();switch(t.tagName.toLowerCase()){case"circle":return 2*Math.PI*t.getAttribute("r");case"rect":return 2*t.getAttribute("width")+2*t.getAttribute("height");case"line":return b({x:t.getAttribute("x1"),y:t.getAttribute("y1")},{x:t.getAttribute("x2"),y:t.getAttribute("y2")});case"polyline":return x(t);case"polygon":var e=t.points;return x(t)+b(e.getItem(e.numberOfItems-1),e.getItem(0))}}function w(t,e){function n(n){return n=void 0===n?0:n,t.el.getPointAtLength(1<=e+n?e+n:0)}var r=n(),i=n(-1),o=n(1);switch(t.property){case"x":return r.x;case"y":return r.y;case"angle":return 180*Math.atan2(o.y-i.y,o.x-i.x)/Math.PI}}function E(t,e){var n,r=/-?\d*\.?\d+/g;if(n=R.pth(t)?t.totalLength:t,R.col(n))if(R.rgb(n)){var i=/rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n);n=i?"rgba("+i[1]+",1)":n}else n=R.hex(n)?u(n):R.hsl(n)?l(n):void 0;else i=(i=f(n))?n.substr(0,n.length-i.length):n,n=e&&!/\s/g.test(n)?i+e:i;return n+="",{original:n,numbers:n.match(r)?n.match(r).map(Number):[0],strings:R.str(t)||e?n.split(r):[]}}function C(t){return t=t?n(R.arr(t)?t.map(r):r(t)):[],e(t,function(t,e,n){return n.indexOf(t)===e})}function S(t){var e=C(t);return e.map(function(t,n){return{target:t,id:n,total:e.length}})}function O(t,e){var n=o(e);if(R.arr(t)){var i=t.length;2!==i||R.obj(t[0])?R.fnc(e.duration)||(n.duration=e.duration/i):t={value:t}}return r(t).map(function(t,n){return n=n?0:e.delay,t=R.obj(t)&&!R.pth(t)?t:{value:t},R.und(t.delay)&&(t.delay=n),t}).map(function(t){return c(t,n)})}function A(t,e){var n,r={};for(n in t){var i=d(t[n],e);R.arr(i)&&(i=i.map(function(t){return d(t,e)}),1===i.length&&(i=i[0])),r[n]=i}return r.duration=parseFloat(r.duration),r.delay=parseFloat(r.delay),r}function I(t){return R.arr(t)?F.apply(this,t):z[t]}function M(t,e){var n;return t.tweens.map(function(r){r=A(r,e);var i=r.value,o=g(e.target,t.name),a=n?n.to.original:o,a=R.arr(i)?i[0]:a,s=y(R.arr(i)?i[1]:i,a),o=f(s)||f(a)||f(o);return r.from=E(a,o),r.to=E(s,o),r.start=n?n.end:t.offset,r.end=r.start+r.delay+r.duration,r.easing=I(r.easing),r.elasticity=(1e3-Math.min(Math.max(r.elasticity,1),999))/1e3,r.isPath=R.pth(i),r.isColor=R.col(r.from.original),r.isColor&&(r.round=1),n=r})}function P(t,r){return e(n(t.map(function(t){return r.map(function(e){var n=m(t.target,e.name);if(n){var r=M(e,t);e={type:n,property:e.name,animatable:t,tweens:r,duration:r[r.length-1].end,delay:r[0].delay}}else e=void 0;return e})})),function(t){return!R.und(t)})}function k(t,e,n,r){var i="delay"===t;return e.length?(i?Math.min:Math.max).apply(Math,e.map(function(e){return e[t]})):i?r.delay:n.offset+r.delay+r.duration}function L(t){var e,n=a(_,t),r=a(X,t),i=S(t.targets),o=[],s=c(n,r);for(e in t)s.hasOwnProperty(e)||"targets"===e||o.push({name:e,offset:s.offset,tweens:O(t[e],r)});return t=P(i,o),c(n,{children:[],animatables:i,animations:t,duration:k("duration",t,n,r),delay:k("delay",t,n,r)})}function j(t){function n(){return window.Promise&&new Promise(function(t){return f=t})}function r(t){return d.reversed?d.duration-t:t}function i(t){for(var n=0,r={},i=d.animations,o=i.length;n<o;){var a=i[n],s=a.animatable,c=a.tweens,u=c.length-1,l=c[u];u&&(l=e(c,function(e){return t<e.end})[0]||l);for(var c=Math.min(Math.max(t-l.start-l.delay,0),l.duration)/l.duration,f=isNaN(c)?1:l.easing(c,l.elasticity),c=l.to.strings,p=l.round,u=[],m=void 0,m=l.to.numbers.length,v=0;v<m;v++){var g=void 0,g=l.to.numbers[v],y=l.from.numbers[v],g=l.isPath?w(l.value,f*g):y+f*(g-y);p&&(l.isColor&&2<v||(g=Math.round(g*p)/p)),u.push(g)}if(l=c.length)for(m=c[0],f=0;f<l;f++)p=c[f+1],v=u[f],isNaN(v)||(m=p?m+(v+p):m+(v+" "));else m=u[0];Y[a.type](s.target,a.property,m,r,s.id),a.currentValue=m,n++}if(n=Object.keys(r).length)for(i=0;i<n;i++)N||(N=h(document.body,"transform")?"transform":"-webkit-transform"),d.animatables[i].target.style[N]=r[i].join(" ");d.currentTime=t,d.progress=t/d.duration*100}function o(t){d[t]&&d[t](d)}function a(){d.remaining&&!0!==d.remaining&&d.remaining--}function s(t){var e=d.duration,s=d.offset,h=s+d.delay,m=d.currentTime,v=d.reversed,g=r(t);if(d.children.length){var y=d.children,b=y.length;if(g>=d.currentTime)for(var x=0;x<b;x++)y[x].seek(g);else for(;b--;)y[b].seek(g)}(g>=h||!e)&&(d.began||(d.began=!0,o("begin")),o("run")),g>s&&g<e?i(g):(g<=s&&0!==m&&(i(0),v&&a()),(g>=e&&m!==e||!e)&&(i(e),v||a())),o("update"),t>=e&&(d.remaining?(u=c,"alternate"===d.direction&&(d.reversed=!d.reversed)):(d.pause(),d.completed||(d.completed=!0,o("complete"),"Promise"in window&&(f(),p=n()))),l=0)}t=void 0===t?{}:t;var c,u,l=0,f=null,p=n(),d=L(t);return d.reset=function(){var t=d.direction,e=d.loop;for(d.currentTime=0,d.progress=0,d.paused=!0,d.began=!1,d.completed=!1,d.reversed="reverse"===t,d.remaining="alternate"===t&&1===e?2:e,i(0),t=d.children.length;t--;)d.children[t].reset()},d.tick=function(t){c=t,u||(u=c),s((l+c-u)*j.speed)},d.seek=function(t){s(r(t))},d.pause=function(){var t=q.indexOf(d);-1<t&&q.splice(t,1),d.paused=!0},d.play=function(){d.paused&&(d.paused=!1,u=0,l=r(d.currentTime),q.push(d),H||V())},d.reverse=function(){d.reversed=!d.reversed,u=0,l=r(d.currentTime)},d.restart=function(){d.pause(),d.reset(),d.play()},d.finished=p,d.reset(),d.autoplay&&d.play(),d}var N,_={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},X={duration:1e3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},D="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),R={arr:function(t){return Array.isArray(t)},obj:function(t){return-1<Object.prototype.toString.call(t).indexOf("Object")},pth:function(t){return R.obj(t)&&t.hasOwnProperty("totalLength")},svg:function(t){return t instanceof SVGElement},dom:function(t){return t.nodeType||R.svg(t)},str:function(t){return"string"==typeof t},fnc:function(t){return"function"==typeof t},und:function(t){return void 0===t},hex:function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)},rgb:function(t){return/^rgb/.test(t)},hsl:function(t){return/^hsl/.test(t)},col:function(t){return R.hex(t)||R.rgb(t)||R.hsl(t)}},F=function(){function t(t,e,n){return(((1-3*n+3*e)*t+(3*n-6*e))*t+3*e)*t}return function(e,n,r,i){if(0<=e&&1>=e&&0<=r&&1>=r){var o=new Float32Array(11);if(e!==n||r!==i)for(var a=0;11>a;++a)o[a]=t(.1*a,e,r);return function(a){if(e===n&&r===i)return a;if(0===a)return 0;if(1===a)return 1;for(var s=0,c=1;10!==c&&o[c]<=a;++c)s+=.1;--c;var c=s+(a-o[c])/(o[c+1]-o[c])*.1,u=3*(1-3*r+3*e)*c*c+2*(3*r-6*e)*c+3*e;if(.001<=u){for(s=0;4>s&&0!==(u=3*(1-3*r+3*e)*c*c+2*(3*r-6*e)*c+3*e);++s)var l=t(c,e,r)-a,c=c-l/u;a=c}else if(0===u)a=c;else{var c=s,s=s+.1,f=0;do{l=c+(s-c)/2,u=t(l,e,r)-a,0<u?s=l:c=l}while(1e-7<Math.abs(u)&&10>++f);a=l}return t(a,n,i)}}}}(),z=function(){function t(t,e){return 0===t||1===t?t:-Math.pow(2,10*(t-1))*Math.sin(2*(t-1-e/(2*Math.PI)*Math.asin(1))*Math.PI/e)}var e,n="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),r={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,.335],[.6,-.28,.735,.045],t],Out:[[.25,.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(e,n){return 1-t(1-e,n)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(e,n){return.5>e?t(2*e,n)/2:1-t(-2*e+2,n)/2}]},i={linear:F(.25,.25,.75,.75)},o={};for(e in r)o.type=e,r[o.type].forEach(function(t){return function(e,r){i["ease"+t.type+n[r]]=R.fnc(e)?e:F.apply(s,e)}}(o)),o={type:o.type};return i}(),Y={css:function(t,e,n){return t.style[e]=n},attribute:function(t,e,n){return t.setAttribute(e,n)},object:function(t,e,n){return t[e]=n},transform:function(t,e,n,r,i){r[i]||(r[i]=[]),r[i].push(e+"("+n+")")}},q=[],H=0,V=function(){function t(){H=requestAnimationFrame(e)}function e(e){var n=q.length;if(n){for(var r=0;r<n;)q[r]&&q[r].tick(e),r++;t()}else cancelAnimationFrame(H),H=0}return t}();return j.version="2.2.0",j.speed=1,j.running=q,j.remove=function(t){t=C(t);for(var e=q.length;e--;)for(var n=q[e],r=n.animations,o=r.length;o--;)i(t,r[o].animatable.target)&&(r.splice(o,1),r.length||n.pause())},j.getValue=g,j.path=function(e,n){var r=R.str(e)?t(e)[0]:e,i=n||100;return function(t){return{el:r,property:t,totalLength:T(r)*(i/100)}}},j.setDashoffset=function(t){var e=T(t);return t.setAttribute("stroke-dasharray",e),e},j.bezier=F,j.easings=z,j.timeline=function(t){var e=j(t);return e.pause(),e.duration=0,e.add=function(n){return e.children.forEach(function(t){t.began=!0,t.completed=!0}),r(n).forEach(function(n){var r=c(n,a(X,t||{}));r.targets=r.targets||t.targets,n=e.duration;var i=r.offset;r.autoplay=!1,r.direction=e.direction,r.offset=R.und(i)?n:y(i,n),e.began=!0,e.completed=!0,e.seek(r.offset),r=j(r),r.began=!0,r.completed=!0,r.duration>n&&(e.duration=r.duration),e.children.push(r)}),e.seek(0),e.reset(),e.autoplay&&e.restart(),e},e},j.random=function(t,e){return Math.floor(Math.random()*(e-t+1))+t},j})}).call(e,n(25))},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(3),i=n(4),o=n.n(i),a={install:function(t,e){e||(e={});var n=new r.a(e);t.component("toasted",o.a),t.toasted=t.prototype.$toasted=n}};"undefined"!=typeof window&&window.Vue&&(window.Toasted=a),e.default=a},function(t,e,n){"use strict";n.d(e,"a",function(){return c});var r=n(1),i=this,o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},a=function(t,e,n){return setTimeout(function(){if(n.cached_options.position&&n.cached_options.position.includes("bottom"))return void r.a.animateOutBottom(t,function(){n.remove(t)});r.a.animateOut(t,function(){n.remove(t)})},e),!0},s=function(t,e){return("object"===("undefined"==typeof HTMLElement?"undefined":o(HTMLElement))?e instanceof HTMLElement:e&&"object"===(void 0===e?"undefined":o(e))&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName)?t.appendChild(e):t.innerHTML=e,i},c=function(t,e){var n=!1;return{el:t,text:function(e){return s(t,e),this},goAway:function(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:800;return n=!0,a(t,r,e)},remove:function(){e.remove(t)},disposed:function(){return n}}}},function(t,e,n){"use strict";var r=n(12),i=n.n(r),o=n(1),a=n(7),s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},c=n(2);String.prototype.includes||Object.defineProperty(String.prototype,"includes",{value:function(t,e){return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}});var u={},l=null,f=function(t){return t.className=t.className||null,t.onComplete=t.onComplete||null,t.position=t.position||"top-right",t.duration=t.duration||null,t.theme=t.theme||"toasted-primary",t.type=t.type||"default",t.containerClass=t.containerClass||null,t.fullWidth=t.fullWidth||!1,t.icon=t.icon||null,t.action=t.action||null,t.fitToScreen=t.fitToScreen||null,t.closeOnSwipe=void 0===t.closeOnSwipe||t.closeOnSwipe,t.iconPack=t.iconPack||"material",t.className&&"string"==typeof t.className&&(t.className=t.className.split(" ")),t.className||(t.className=[]),t.theme&&t.className.push(t.theme.trim()),t.type&&t.className.push(t.type),t.containerClass&&"string"==typeof t.containerClass&&(t.containerClass=t.containerClass.split(" ")),t.containerClass||(t.containerClass=[]),t.position&&t.containerClass.push(t.position.trim()),t.fullWidth&&t.containerClass.push("full-width"),t.fitToScreen&&t.containerClass.push("fit-to-screen"),u=t,t},p=function(t,e){var r=document.createElement("div");if(r.classList.add("toasted"),r.hash=c.generate(),e.className&&e.className.forEach(function(t){r.classList.add(t)}),("object"===("undefined"==typeof HTMLElement?"undefined":s(HTMLElement))?t instanceof HTMLElement:t&&"object"===(void 0===t?"undefined":s(t))&&null!==t&&1===t.nodeType&&"string"==typeof t.nodeName)?r.appendChild(t):r.innerHTML=t,d(e,r),e.closeOnSwipe){var u=new i.a(r,{prevent_default:!1});u.on("pan",function(t){var e=t.deltaX;r.classList.contains("panning")||r.classList.add("panning");var n=1-Math.abs(e/80);n<0&&(n=0),o.a.animatePanning(r,e,n)}),u.on("panend",function(t){var n=t.deltaX;Math.abs(n)>80?o.a.animatePanEnd(r,function(){"function"==typeof e.onComplete&&e.onComplete(),r.parentNode&&l.remove(r)}):(r.classList.remove("panning"),o.a.animateReset(r))})}if(Array.isArray(e.action))e.action.forEach(function(t){var e=m(t,n.i(a.a)(r,l));e&&r.appendChild(e)});else if("object"===s(e.action)){var f=m(e.action,n.i(a.a)(r,l));f&&r.appendChild(f)}return r},d=function(t,e){if(t.icon){var n=document.createElement("i");switch(t.iconPack){case"fontawesome":n.classList.add("fa");var r=t.icon.name?t.icon.name:t.icon;r.includes("fa-")?n.classList.add(r.trim()):n.classList.add("fa-"+r.trim());break;case"mdi":n.classList.add("mdi");var i=t.icon.name?t.icon.name:t.icon;i.includes("mdi-")?n.classList.add(i.trim()):n.classList.add("mdi-"+i.trim());break;case"custom-class":var o=t.icon.name?t.icon.name:t.icon;"string"==typeof o?o.split(" ").forEach(function(t){n.classList.add(t)}):Array.isArray(o)&&o.forEach(function(t){n.classList.add(t.trim())});break;case"callback":var a=t.icon&&t.icon instanceof Function?t.icon:null;a&&(n=a(n));break;default:n.classList.add("material-icons"),n.textContent=t.icon.name?t.icon.name:t.icon}t.icon.after&&n.classList.add("after"),h(t,n,e)}},h=function(t,e,n){t.icon&&(t.icon.after&&t.icon.name?n.appendChild(e):(t.icon.name,n.insertBefore(e,n.firstChild)))},m=function(t,e){if(!t)return null;var n=document.createElement("a");if(n.classList.add("action"),n.classList.add("ripple"),t.text&&(n.text=t.text),t.href&&(n.href=t.href),t.target&&(n.target=t.target),t.icon){n.classList.add("icon");var r=document.createElement("i");switch(u.iconPack){case"fontawesome":r.classList.add("fa"),t.icon.includes("fa-")?r.classList.add(t.icon.trim()):r.classList.add("fa-"+t.icon.trim());break;case"mdi":r.classList.add("mdi"),t.icon.includes("mdi-")?r.classList.add(t.icon.trim()):r.classList.add("mdi-"+t.icon.trim());break;case"custom-class":"string"==typeof t.icon?t.icon.split(" ").forEach(function(t){n.classList.add(t)}):Array.isArray(t.icon)&&t.icon.forEach(function(t){n.classList.add(t.trim())});break;default:r.classList.add("material-icons"),r.textContent=t.icon}n.appendChild(r)}return t.class&&("string"==typeof t.class?t.class.split(" ").forEach(function(t){n.classList.add(t)}):Array.isArray(t.class)&&t.class.forEach(function(t){n.classList.add(t.trim())})),t.push&&n.addEventListener("click",function(n){if(n.preventDefault(),!u.router)return void console.warn("[vue-toasted] : Vue Router instance is not attached. please check the docs");u.router.push(t.push),t.push.dontClose||e.goAway(0)}),t.onClick&&"function"==typeof t.onClick&&n.addEventListener("click",function(n){t.onClick&&(n.preventDefault(),t.onClick(n,e))}),n};e.a=function(t,e,r){l=t,r=f(r);var i=document.getElementById(l.id);null===i&&(i=document.createElement("div"),i.id=l.id,document.body.appendChild(i)),r.containerClass.unshift("toasted-container"),i.className!==r.containerClass.join(" ")&&(i.className="",r.containerClass.forEach(function(t){i.classList.add(t)}));var s=p(e,r);e&&i.appendChild(s),s.style.opacity=0,o.a.animateIn(s);var c=r.duration,u=void 0;return null!==c&&(u=setInterval(function(){null===s.parentNode&&window.clearInterval(u),s.classList.contains("panning")||(c-=20),c<=0&&(o.a.animateOut(s,function(){"function"==typeof r.onComplete&&r.onComplete(),s.parentNode&&l.remove(s)}),window.clearInterval(u))},20)),n.i(a.a)(s,l)}},function(t,e,n){e=t.exports=n(10)(),e.push([t.i,".toasted{padding:0 20px}.toasted.rounded{border-radius:24px}.toasted .primary,.toasted.toasted-primary{border-radius:2px;min-height:38px;line-height:1.1em;background-color:#353535;padding:0 20px;font-size:15px;font-weight:300;color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.toasted .primary.success,.toasted.toasted-primary.success{background:#4caf50}.toasted .primary.error,.toasted.toasted-primary.error{background:#f44336}.toasted .primary.info,.toasted.toasted-primary.info{background:#3f51b5}.toasted .primary .action,.toasted.toasted-primary .action{color:#a1c2fa}.toasted.bubble{border-radius:30px;min-height:38px;line-height:1.1em;background-color:#ff7043;padding:0 20px;font-size:15px;font-weight:300;color:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24)}.toasted.bubble.success{background:#4caf50}.toasted.bubble.error{background:#f44336}.toasted.bubble.info{background:#3f51b5}.toasted.bubble .action{color:#8e2b0c}.toasted.outline{border-radius:30px;min-height:38px;line-height:1.1em;background-color:#fff;border:1px solid #676767;padding:0 20px;font-size:15px;color:#676767;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);font-weight:700}.toasted.outline.success{color:#4caf50;border-color:#4caf50}.toasted.outline.error{color:#f44336;border-color:#f44336}.toasted.outline.info{color:#3f51b5;border-color:#3f51b5}.toasted.outline .action{color:#607d8b}.toasted-container{position:fixed;z-index:10000}.toasted-container,.toasted-container.full-width{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.toasted-container.full-width{max-width:86%;width:100%}.toasted-container.full-width.fit-to-screen{min-width:100%}.toasted-container.full-width.fit-to-screen .toasted:first-child{margin-top:0}.toasted-container.full-width.fit-to-screen.top-right{top:0;right:0}.toasted-container.full-width.fit-to-screen.top-left{top:0;left:0}.toasted-container.full-width.fit-to-screen.top-center{top:0;left:0;-webkit-transform:translateX(0);transform:translateX(0)}.toasted-container.full-width.fit-to-screen.bottom-right{right:0;bottom:0}.toasted-container.full-width.fit-to-screen.bottom-left{left:0;bottom:0}.toasted-container.full-width.fit-to-screen.bottom-center{left:0;bottom:0;-webkit-transform:translateX(0);transform:translateX(0)}.toasted-container.top-right{top:10%;right:7%}.toasted-container.top-left{top:10%;left:7%}.toasted-container.top-center{top:10%;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.toasted-container.bottom-right{right:5%;bottom:7%}.toasted-container.bottom-left{left:5%;bottom:7%}.toasted-container.bottom-center{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);bottom:7%}.toasted-container.bottom-left .toasted,.toasted-container.top-left .toasted{float:left}.toasted-container.bottom-right .toasted,.toasted-container.top-right .toasted{float:right}.toasted-container .toasted{top:35px;width:auto;clear:both;margin-top:10px;position:relative;max-width:100%;height:auto;word-break:normal;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;box-sizing:inherit}.toasted-container .toasted .fa,.toasted-container .toasted .fab,.toasted-container .toasted .far,.toasted-container .toasted .fas,.toasted-container .toasted .material-icons,.toasted-container .toasted .mdi{margin-right:.5rem;margin-left:-.4rem}.toasted-container .toasted .fa.after,.toasted-container .toasted .fab.after,.toasted-container .toasted .far.after,.toasted-container .toasted .fas.after,.toasted-container .toasted .material-icons.after,.toasted-container .toasted .mdi.after{margin-left:.5rem;margin-right:-.4rem}.toasted-container .toasted .action{text-decoration:none;font-size:.8rem;padding:8px;margin:5px -7px 5px 7px;border-radius:3px;text-transform:uppercase;letter-spacing:.03em;font-weight:600;cursor:pointer}.toasted-container .toasted .action.icon{padding:4px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.toasted-container .toasted .action.icon .fa,.toasted-container .toasted .action.icon .material-icons,.toasted-container .toasted .action.icon .mdi{margin-right:0;margin-left:4px}.toasted-container .toasted .action.icon:hover{text-decoration:none}.toasted-container .toasted .action:hover{text-decoration:underline}@media only screen and (max-width:600px){#toasted-container{min-width:100%}#toasted-container .toasted:first-child{margin-top:0}#toasted-container.top-right{top:0;right:0}#toasted-container.top-left{top:0;left:0}#toasted-container.top-center{top:0;left:0;-webkit-transform:translateX(0);transform:translateX(0)}#toasted-container.bottom-right{right:0;bottom:0}#toasted-container.bottom-left{left:0;bottom:0}#toasted-container.bottom-center{left:0;bottom:0;-webkit-transform:translateX(0);transform:translateX(0)}#toasted-container.bottom-center,#toasted-container.top-center{-ms-flex-align:stretch!important;align-items:stretch!important}#toasted-container.bottom-left .toasted,#toasted-container.bottom-right .toasted,#toasted-container.top-left .toasted,#toasted-container.top-right .toasted{float:none}#toasted-container .toasted{border-radius:0}}",""])},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(r[o]=!0)}for(i=0;i<e.length;i++){var a=e[i];"number"==typeof a[0]&&r[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(t,e,n){"use strict";function r(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),r=1;r<arguments.length;r++){var i=arguments[r];if(void 0!==i&&null!==i)for(var o=Object.keys(Object(i)),a=0,s=o.length;a<s;a++){var c=o[a],u=Object.getOwnPropertyDescriptor(i,c);void 0!==u&&u.enumerable&&(n[c]=i[c])}}return n}function i(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:r})}t.exports={assign:r,polyfill:i}},function(t,e,n){var r;!function(i,o,a,s){"use strict";function c(t,e,n){return setTimeout(d(t,n),e)}function u(t,e,n){return!!Array.isArray(t)&&(l(t,n[e],n),!0)}function l(t,e,n){var r;if(t)if(t.forEach)t.forEach(e,n);else if(t.length!==s)for(r=0;r<t.length;)e.call(n,t[r],r,t),r++;else for(r in t)t.hasOwnProperty(r)&&e.call(n,t[r],r,t)}function f(t,e,n){var r="DEPRECATED METHOD: "+e+"\n"+n+" AT \n";return function(){var e=new Error("get-stack-trace"),n=e&&e.stack?e.stack.replace(/^[^\(]+?[\n$]/gm,"").replace(/^\s+at\s+/gm,"").replace(/^Object.<anonymous>\s*\(/gm,"{anonymous}()@"):"Unknown Stack Trace",o=i.console&&(i.console.warn||i.console.log);return o&&o.call(i.console,r,n),t.apply(this,arguments)}}function p(t,e,n){var r,i=e.prototype;r=t.prototype=Object.create(i),r.constructor=t,r._super=i,n&&ht(r,n)}function d(t,e){return function(){return t.apply(e,arguments)}}function h(t,e){return typeof t==gt?t.apply(e?e[0]||s:s,e):t}function m(t,e){return t===s?e:t}function v(t,e,n){l(x(e),function(e){t.addEventListener(e,n,!1)})}function g(t,e,n){l(x(e),function(e){t.removeEventListener(e,n,!1)})}function y(t,e){for(;t;){if(t==e)return!0;t=t.parentNode}return!1}function b(t,e){return t.indexOf(e)>-1}function x(t){return t.trim().split(/\s+/g)}function T(t,e,n){if(t.indexOf&&!n)return t.indexOf(e);for(var r=0;r<t.length;){if(n&&t[r][n]==e||!n&&t[r]===e)return r;r++}return-1}function w(t){return Array.prototype.slice.call(t,0)}function E(t,e,n){for(var r=[],i=[],o=0;o<t.length;){var a=e?t[o][e]:t[o];T(i,a)<0&&r.push(t[o]),i[o]=a,o++}return n&&(r=e?r.sort(function(t,n){return t[e]>n[e]}):r.sort()),r}function C(t,e){for(var n,r,i=e[0].toUpperCase()+e.slice(1),o=0;o<mt.length;){if(n=mt[o],(r=n?n+i:e)in t)return r;o++}return s}function S(){return Et++}function O(t){var e=t.ownerDocument||t;return e.defaultView||e.parentWindow||i}function A(t,e){var n=this;this.manager=t,this.callback=e,this.element=t.element,this.target=t.options.inputTarget,this.domHandler=function(e){h(t.options.enable,[t])&&n.handler(e)},this.init()}function I(t){var e=t.options.inputClass;return new(e||(Ot?q:At?W:St?B:Y))(t,M)}function M(t,e,n){var r=n.pointers.length,i=n.changedPointers.length,o=e&Mt&&r-i==0,a=e&(kt|Lt)&&r-i==0;n.isFirst=!!o,n.isFinal=!!a,o&&(t.session={}),n.eventType=e,P(t,n),t.emit("hammer.input",n),t.recognize(n),t.session.prevInput=n}function P(t,e){var n=t.session,r=e.pointers,i=r.length;n.firstInput||(n.firstInput=j(e)),i>1&&!n.firstMultiple?n.firstMultiple=j(e):1===i&&(n.firstMultiple=!1);var o=n.firstInput,a=n.firstMultiple,s=a?a.center:o.center,c=e.center=N(r);e.timeStamp=xt(),e.deltaTime=e.timeStamp-o.timeStamp,e.angle=R(s,c),e.distance=D(s,c),k(n,e),e.offsetDirection=X(e.deltaX,e.deltaY);var u=_(e.deltaTime,e.deltaX,e.deltaY);e.overallVelocityX=u.x,e.overallVelocityY=u.y,e.overallVelocity=bt(u.x)>bt(u.y)?u.x:u.y,e.scale=a?z(a.pointers,r):1,e.rotation=a?F(a.pointers,r):0,e.maxPointers=n.prevInput?e.pointers.length>n.prevInput.maxPointers?e.pointers.length:n.prevInput.maxPointers:e.pointers.length,L(n,e);var l=t.element;y(e.srcEvent.target,l)&&(l=e.srcEvent.target),e.target=l}function k(t,e){var n=e.center,r=t.offsetDelta||{},i=t.prevDelta||{},o=t.prevInput||{};e.eventType!==Mt&&o.eventType!==kt||(i=t.prevDelta={x:o.deltaX||0,y:o.deltaY||0},r=t.offsetDelta={x:n.x,y:n.y}),e.deltaX=i.x+(n.x-r.x),e.deltaY=i.y+(n.y-r.y)}function L(t,e){var n,r,i,o,a=t.lastInterval||e,c=e.timeStamp-a.timeStamp;if(e.eventType!=Lt&&(c>It||a.velocity===s)){var u=e.deltaX-a.deltaX,l=e.deltaY-a.deltaY,f=_(c,u,l);r=f.x,i=f.y,n=bt(f.x)>bt(f.y)?f.x:f.y,o=X(u,l),t.lastInterval=e}else n=a.velocity,r=a.velocityX,i=a.velocityY,o=a.direction;e.velocity=n,e.velocityX=r,e.velocityY=i,e.direction=o}function j(t){for(var e=[],n=0;n<t.pointers.length;)e[n]={clientX:yt(t.pointers[n].clientX),clientY:yt(t.pointers[n].clientY)},n++;return{timeStamp:xt(),pointers:e,center:N(e),deltaX:t.deltaX,deltaY:t.deltaY}}function N(t){var e=t.length;if(1===e)return{x:yt(t[0].clientX),y:yt(t[0].clientY)};for(var n=0,r=0,i=0;i<e;)n+=t[i].clientX,r+=t[i].clientY,i++;return{x:yt(n/e),y:yt(r/e)}}function _(t,e,n){return{x:e/t||0,y:n/t||0}}function X(t,e){return t===e?jt:bt(t)>=bt(e)?t<0?Nt:_t:e<0?Xt:Dt}function D(t,e,n){n||(n=Yt);var r=e[n[0]]-t[n[0]],i=e[n[1]]-t[n[1]];return Math.sqrt(r*r+i*i)}function R(t,e,n){n||(n=Yt);var r=e[n[0]]-t[n[0]],i=e[n[1]]-t[n[1]];return 180*Math.atan2(i,r)/Math.PI}function F(t,e){return R(e[1],e[0],qt)+R(t[1],t[0],qt)}function z(t,e){return D(e[0],e[1],qt)/D(t[0],t[1],qt)}function Y(){this.evEl=Vt,this.evWin=Wt,this.pressed=!1,A.apply(this,arguments)}function q(){this.evEl=$t,this.evWin=Gt,A.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function H(){this.evTarget=Qt,this.evWin=Jt,this.started=!1,A.apply(this,arguments)}function V(t,e){var n=w(t.touches),r=w(t.changedTouches);return e&(kt|Lt)&&(n=E(n.concat(r),"identifier",!0)),[n,r]}function W(){this.evTarget=te,this.targetIds={},A.apply(this,arguments)}function U(t,e){var n=w(t.touches),r=this.targetIds;if(e&(Mt|Pt)&&1===n.length)return r[n[0].identifier]=!0,[n,n];var i,o,a=w(t.changedTouches),s=[],c=this.target;if(o=n.filter(function(t){return y(t.target,c)}),e===Mt)for(i=0;i<o.length;)r[o[i].identifier]=!0,i++;for(i=0;i<a.length;)r[a[i].identifier]&&s.push(a[i]),e&(kt|Lt)&&delete r[a[i].identifier],i++;return s.length?[E(o.concat(s),"identifier",!0),s]:void 0}function B(){A.apply(this,arguments);var t=d(this.handler,this);this.touch=new W(this.manager,t),this.mouse=new Y(this.manager,t),this.primaryTouch=null,this.lastTouches=[]}function $(t,e){t&Mt?(this.primaryTouch=e.changedPointers[0].identifier,G.call(this,e)):t&(kt|Lt)&&G.call(this,e)}function G(t){var e=t.changedPointers[0];if(e.identifier===this.primaryTouch){var n={x:e.clientX,y:e.clientY};this.lastTouches.push(n);var r=this.lastTouches,i=function(){var t=r.indexOf(n);t>-1&&r.splice(t,1)};setTimeout(i,ee)}}function Z(t){for(var e=t.srcEvent.clientX,n=t.srcEvent.clientY,r=0;r<this.lastTouches.length;r++){var i=this.lastTouches[r],o=Math.abs(e-i.x),a=Math.abs(n-i.y);if(o<=ne&&a<=ne)return!0}return!1}function Q(t,e){this.manager=t,this.set(e)}function J(t){if(b(t,se))return se;var e=b(t,ce),n=b(t,ue);return e&&n?se:e||n?e?ce:ue:b(t,ae)?ae:oe}function K(t){this.options=ht({},this.defaults,t||{}),this.id=S(),this.manager=null,this.options.enable=m(this.options.enable,!0),this.state=fe,this.simultaneous={},this.requireFail=[]}function tt(t){return t&ve?"cancel":t&he?"end":t&de?"move":t&pe?"start":""}function et(t){return t==Dt?"down":t==Xt?"up":t==Nt?"left":t==_t?"right":""}function nt(t,e){var n=e.manager;return n?n.get(t):t}function rt(){K.apply(this,arguments)}function it(){rt.apply(this,arguments),this.pX=null,this.pY=null}function ot(){rt.apply(this,arguments)}function at(){K.apply(this,arguments),this._timer=null,this._input=null}function st(){rt.apply(this,arguments)}function ct(){rt.apply(this,arguments)}function ut(){K.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function lt(t,e){return e=e||{},e.recognizers=m(e.recognizers,lt.defaults.preset),new ft(t,e)}function ft(t,e){this.options=ht({},lt.defaults,e||{}),this.options.inputTarget=this.options.inputTarget||t,this.handlers={},this.session={},this.recognizers=[],this.oldCssProps={},this.element=t,this.input=I(this),this.touchAction=new Q(this,this.options.touchAction),pt(this,!0),l(this.options.recognizers,function(t){var e=this.add(new t[0](t[1]));t[2]&&e.recognizeWith(t[2]),t[3]&&e.requireFailure(t[3])},this)}function pt(t,e){var n=t.element;if(n.style){var r;l(t.options.cssProps,function(i,o){r=C(n.style,o),e?(t.oldCssProps[r]=n.style[r],n.style[r]=i):n.style[r]=t.oldCssProps[r]||""}),e||(t.oldCssProps={})}}function dt(t,e){var n=o.createEvent("Event");n.initEvent(t,!0,!0),n.gesture=e,e.target.dispatchEvent(n)}var ht,mt=["","webkit","Moz","MS","ms","o"],vt=o.createElement("div"),gt="function",yt=Math.round,bt=Math.abs,xt=Date.now;ht="function"!=typeof Object.assign?function(t){if(t===s||null===t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),n=1;n<arguments.length;n++){var r=arguments[n];if(r!==s&&null!==r)for(var i in r)r.hasOwnProperty(i)&&(e[i]=r[i])}return e}:Object.assign;var Tt=f(function(t,e,n){for(var r=Object.keys(e),i=0;i<r.length;)(!n||n&&t[r[i]]===s)&&(t[r[i]]=e[r[i]]),i++;return t},"extend","Use `assign`."),wt=f(function(t,e){return Tt(t,e,!0)},"merge","Use `assign`."),Et=1,Ct=/mobile|tablet|ip(ad|hone|od)|android/i,St="ontouchstart"in i,Ot=C(i,"PointerEvent")!==s,At=St&&Ct.test(navigator.userAgent),It=25,Mt=1,Pt=2,kt=4,Lt=8,jt=1,Nt=2,_t=4,Xt=8,Dt=16,Rt=Nt|_t,Ft=Xt|Dt,zt=Rt|Ft,Yt=["x","y"],qt=["clientX","clientY"];A.prototype={handler:function(){},init:function(){this.evEl&&v(this.element,this.evEl,this.domHandler),this.evTarget&&v(this.target,this.evTarget,this.domHandler),this.evWin&&v(O(this.element),this.evWin,this.domHandler)},destroy:function(){this.evEl&&g(this.element,this.evEl,this.domHandler),this.evTarget&&g(this.target,this.evTarget,this.domHandler),this.evWin&&g(O(this.element),this.evWin,this.domHandler)}};var Ht={mousedown:Mt,mousemove:Pt,mouseup:kt},Vt="mousedown",Wt="mousemove mouseup";p(Y,A,{handler:function(t){var e=Ht[t.type];e&Mt&&0===t.button&&(this.pressed=!0),e&Pt&&1!==t.which&&(e=kt),this.pressed&&(e&kt&&(this.pressed=!1),this.callback(this.manager,e,{pointers:[t],changedPointers:[t],pointerType:"mouse",srcEvent:t}))}});var Ut={pointerdown:Mt,pointermove:Pt,pointerup:kt,pointercancel:Lt,pointerout:Lt},Bt={2:"touch",3:"pen",4:"mouse",5:"kinect"},$t="pointerdown",Gt="pointermove pointerup pointercancel";i.MSPointerEvent&&!i.PointerEvent&&($t="MSPointerDown",Gt="MSPointerMove MSPointerUp MSPointerCancel"),p(q,A,{handler:function(t){var e=this.store,n=!1,r=t.type.toLowerCase().replace("ms",""),i=Ut[r],o=Bt[t.pointerType]||t.pointerType,a="touch"==o,s=T(e,t.pointerId,"pointerId");i&Mt&&(0===t.button||a)?s<0&&(e.push(t),s=e.length-1):i&(kt|Lt)&&(n=!0),s<0||(e[s]=t,this.callback(this.manager,i,{pointers:e,changedPointers:[t],pointerType:o,srcEvent:t}),n&&e.splice(s,1))}});var Zt={touchstart:Mt,touchmove:Pt,touchend:kt,touchcancel:Lt},Qt="touchstart",Jt="touchstart touchmove touchend touchcancel";p(H,A,{handler:function(t){var e=Zt[t.type];if(e===Mt&&(this.started=!0),this.started){var n=V.call(this,t,e);e&(kt|Lt)&&n[0].length-n[1].length==0&&(this.started=!1),this.callback(this.manager,e,{pointers:n[0],changedPointers:n[1],pointerType:"touch",srcEvent:t})}}});var Kt={touchstart:Mt,touchmove:Pt,touchend:kt,touchcancel:Lt},te="touchstart touchmove touchend touchcancel";p(W,A,{handler:function(t){var e=Kt[t.type],n=U.call(this,t,e);n&&this.callback(this.manager,e,{pointers:n[0],changedPointers:n[1],pointerType:"touch",srcEvent:t})}});var ee=2500,ne=25;p(B,A,{handler:function(t,e,n){var r="touch"==n.pointerType,i="mouse"==n.pointerType;if(!(i&&n.sourceCapabilities&&n.sourceCapabilities.firesTouchEvents)){if(r)$.call(this,e,n);else if(i&&Z.call(this,n))return;this.callback(t,e,n)}},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var re=C(vt.style,"touchAction"),ie=re!==s,oe="auto",ae="manipulation",se="none",ce="pan-x",ue="pan-y",le=function(){if(!ie)return!1;var t={},e=i.CSS&&i.CSS.supports;return["auto","manipulation","pan-y","pan-x","pan-x pan-y","none"].forEach(function(n){t[n]=!e||i.CSS.supports("touch-action",n)}),t}();Q.prototype={set:function(t){"compute"==t&&(t=this.compute()),ie&&this.manager.element.style&&le[t]&&(this.manager.element.style[re]=t),this.actions=t.toLowerCase().trim()},update:function(){this.set(this.manager.options.touchAction)},compute:function(){var t=[];return l(this.manager.recognizers,function(e){h(e.options.enable,[e])&&(t=t.concat(e.getTouchAction()))}),J(t.join(" "))},preventDefaults:function(t){var e=t.srcEvent,n=t.offsetDirection;if(this.manager.session.prevented)return void e.preventDefault();var r=this.actions,i=b(r,se)&&!le[se],o=b(r,ue)&&!le[ue],a=b(r,ce)&&!le[ce];if(i){var s=1===t.pointers.length,c=t.distance<2,u=t.deltaTime<250;if(s&&c&&u)return}return a&&o?void 0:i||o&&n&Rt||a&&n&Ft?this.preventSrc(e):void 0},preventSrc:function(t){this.manager.session.prevented=!0,t.preventDefault()}};var fe=1,pe=2,de=4,he=8,me=he,ve=16;K.prototype={defaults:{},set:function(t){return ht(this.options,t),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function(t){if(u(t,"recognizeWith",this))return this;var e=this.simultaneous;return t=nt(t,this),e[t.id]||(e[t.id]=t,t.recognizeWith(this)),this},dropRecognizeWith:function(t){return u(t,"dropRecognizeWith",this)?this:(t=nt(t,this),delete this.simultaneous[t.id],this)},requireFailure:function(t){if(u(t,"requireFailure",this))return this;var e=this.requireFail;return t=nt(t,this),-1===T(e,t)&&(e.push(t),t.requireFailure(this)),this},dropRequireFailure:function(t){if(u(t,"dropRequireFailure",this))return this;t=nt(t,this);var e=T(this.requireFail,t);return e>-1&&this.requireFail.splice(e,1),this},hasRequireFailures:function(){return this.requireFail.length>0},canRecognizeWith:function(t){return!!this.simultaneous[t.id]},emit:function(t){function e(e){n.manager.emit(e,t)}var n=this,r=this.state;r<he&&e(n.options.event+tt(r)),e(n.options.event),t.additionalEvent&&e(t.additionalEvent),r>=he&&e(n.options.event+tt(r))},tryEmit:function(t){if(this.canEmit())return this.emit(t);this.state=32},canEmit:function(){for(var t=0;t<this.requireFail.length;){if(!(this.requireFail[t].state&(32|fe)))return!1;t++}return!0},recognize:function(t){var e=ht({},t);if(!h(this.options.enable,[this,e]))return this.reset(),void(this.state=32);this.state&(me|ve|32)&&(this.state=fe),this.state=this.process(e),this.state&(pe|de|he|ve)&&this.tryEmit(e)},process:function(t){},getTouchAction:function(){},reset:function(){}},p(rt,K,{defaults:{pointers:1},attrTest:function(t){var e=this.options.pointers;return 0===e||t.pointers.length===e},process:function(t){var e=this.state,n=t.eventType,r=e&(pe|de),i=this.attrTest(t);return r&&(n&Lt||!i)?e|ve:r||i?n&kt?e|he:e&pe?e|de:pe:32}}),p(it,rt,{defaults:{event:"pan",threshold:10,pointers:1,direction:zt},getTouchAction:function(){var t=this.options.direction,e=[];return t&Rt&&e.push(ue),t&Ft&&e.push(ce),e},directionTest:function(t){var e=this.options,n=!0,r=t.distance,i=t.direction,o=t.deltaX,a=t.deltaY;return i&e.direction||(e.direction&Rt?(i=0===o?jt:o<0?Nt:_t,n=o!=this.pX,r=Math.abs(t.deltaX)):(i=0===a?jt:a<0?Xt:Dt,n=a!=this.pY,r=Math.abs(t.deltaY))),t.direction=i,n&&r>e.threshold&&i&e.direction},attrTest:function(t){return rt.prototype.attrTest.call(this,t)&&(this.state&pe||!(this.state&pe)&&this.directionTest(t))},emit:function(t){this.pX=t.deltaX,this.pY=t.deltaY;var e=et(t.direction);e&&(t.additionalEvent=this.options.event+e),this._super.emit.call(this,t)}}),p(ot,rt,{defaults:{event:"pinch",threshold:0,pointers:2},getTouchAction:function(){return[se]},attrTest:function(t){return this._super.attrTest.call(this,t)&&(Math.abs(t.scale-1)>this.options.threshold||this.state&pe)},emit:function(t){if(1!==t.scale){var e=t.scale<1?"in":"out";t.additionalEvent=this.options.event+e}this._super.emit.call(this,t)}}),p(at,K,{defaults:{event:"press",pointers:1,time:251,threshold:9},getTouchAction:function(){return[oe]},process:function(t){var e=this.options,n=t.pointers.length===e.pointers,r=t.distance<e.threshold,i=t.deltaTime>e.time;if(this._input=t,!r||!n||t.eventType&(kt|Lt)&&!i)this.reset();else if(t.eventType&Mt)this.reset(),this._timer=c(function(){this.state=me,this.tryEmit()},e.time,this);else if(t.eventType&kt)return me;return 32},reset:function(){clearTimeout(this._timer)},emit:function(t){this.state===me&&(t&&t.eventType&kt?this.manager.emit(this.options.event+"up",t):(this._input.timeStamp=xt(),this.manager.emit(this.options.event,this._input)))}}),p(st,rt,{defaults:{event:"rotate",threshold:0,pointers:2},getTouchAction:function(){return[se]},attrTest:function(t){return this._super.attrTest.call(this,t)&&(Math.abs(t.rotation)>this.options.threshold||this.state&pe)}}),p(ct,rt,{defaults:{event:"swipe",threshold:10,velocity:.3,direction:Rt|Ft,pointers:1},getTouchAction:function(){return it.prototype.getTouchAction.call(this)},attrTest:function(t){var e,n=this.options.direction;return n&(Rt|Ft)?e=t.overallVelocity:n&Rt?e=t.overallVelocityX:n&Ft&&(e=t.overallVelocityY),this._super.attrTest.call(this,t)&&n&t.offsetDirection&&t.distance>this.options.threshold&&t.maxPointers==this.options.pointers&&bt(e)>this.options.velocity&&t.eventType&kt},emit:function(t){var e=et(t.offsetDirection);e&&this.manager.emit(this.options.event+e,t),this.manager.emit(this.options.event,t)}}),p(ut,K,{defaults:{event:"tap",pointers:1,taps:1,interval:300,time:250,threshold:9,posThreshold:10},getTouchAction:function(){return[ae]},process:function(t){var e=this.options,n=t.pointers.length===e.pointers,r=t.distance<e.threshold,i=t.deltaTime<e.time;if(this.reset(),t.eventType&Mt&&0===this.count)return this.failTimeout();if(r&&i&&n){if(t.eventType!=kt)return this.failTimeout();var o=!this.pTime||t.timeStamp-this.pTime<e.interval,a=!this.pCenter||D(this.pCenter,t.center)<e.posThreshold;this.pTime=t.timeStamp,this.pCenter=t.center,a&&o?this.count+=1:this.count=1,this._input=t;if(0===this.count%e.taps)return this.hasRequireFailures()?(this._timer=c(function(){this.state=me,this.tryEmit()},e.interval,this),pe):me}return 32},failTimeout:function(){return this._timer=c(function(){this.state=32},this.options.interval,this),32},reset:function(){clearTimeout(this._timer)},emit:function(){this.state==me&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),lt.VERSION="2.0.7",lt.defaults={domEvents:!1,touchAction:"compute",enable:!0,inputTarget:null,inputClass:null,preset:[[st,{enable:!1}],[ot,{enable:!1},["rotate"]],[ct,{direction:Rt}],[it,{direction:Rt},["swipe"]],[ut],[ut,{event:"doubletap",taps:2},["tap"]],[at]],cssProps:{userSelect:"none",touchSelect:"none",touchCallout:"none",contentZooming:"none",userDrag:"none",tapHighlightColor:"rgba(0,0,0,0)"}};ft.prototype={set:function(t){return ht(this.options,t),t.touchAction&&this.touchAction.update(),t.inputTarget&&(this.input.destroy(),this.input.target=t.inputTarget,this.input.init()),this},stop:function(t){this.session.stopped=t?2:1},recognize:function(t){var e=this.session;if(!e.stopped){this.touchAction.preventDefaults(t);var n,r=this.recognizers,i=e.curRecognizer;(!i||i&&i.state&me)&&(i=e.curRecognizer=null);for(var o=0;o<r.length;)n=r[o],2===e.stopped||i&&n!=i&&!n.canRecognizeWith(i)?n.reset():n.recognize(t),!i&&n.state&(pe|de|he)&&(i=e.curRecognizer=n),o++}},get:function(t){if(t instanceof K)return t;for(var e=this.recognizers,n=0;n<e.length;n++)if(e[n].options.event==t)return e[n];return null},add:function(t){if(u(t,"add",this))return this;var e=this.get(t.options.event);return e&&this.remove(e),this.recognizers.push(t),t.manager=this,this.touchAction.update(),t},remove:function(t){if(u(t,"remove",this))return this;if(t=this.get(t)){var e=this.recognizers,n=T(e,t);-1!==n&&(e.splice(n,1),this.touchAction.update())}return this},on:function(t,e){if(t!==s&&e!==s){var n=this.handlers;return l(x(t),function(t){n[t]=n[t]||[],n[t].push(e)}),this}},off:function(t,e){if(t!==s){var n=this.handlers;return l(x(t),function(t){e?n[t]&&n[t].splice(T(n[t],e),1):delete n[t]}),this}},emit:function(t,e){this.options.domEvents&&dt(t,e);var n=this.handlers[t]&&this.handlers[t].slice();if(n&&n.length){e.type=t,e.preventDefault=function(){e.srcEvent.preventDefault()};for(var r=0;r<n.length;)n[r](e),r++}},destroy:function(){this.element&&pt(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},ht(lt,{INPUT_START:Mt,INPUT_MOVE:Pt,INPUT_END:kt,INPUT_CANCEL:Lt,STATE_POSSIBLE:fe,STATE_BEGAN:pe,STATE_CHANGED:de,STATE_ENDED:he,STATE_RECOGNIZED:me,STATE_CANCELLED:ve,STATE_FAILED:32,DIRECTION_NONE:jt,DIRECTION_LEFT:Nt,DIRECTION_RIGHT:_t,DIRECTION_UP:Xt,DIRECTION_DOWN:Dt,DIRECTION_HORIZONTAL:Rt,DIRECTION_VERTICAL:Ft,DIRECTION_ALL:zt,Manager:ft,Input:A,TouchAction:Q,TouchInput:W,MouseInput:Y,PointerEventInput:q,TouchMouseInput:B,SingleTouchInput:H,Recognizer:K,AttrRecognizer:rt,Tap:ut,Pan:it,Swipe:ct,Pinch:ot,Rotate:st,Press:at,on:v,off:g,each:l,merge:wt,extend:Tt,assign:ht,inherit:p,bindFn:d,prefixed:C}),(void 0!==i?i:"undefined"!=typeof self?self:{}).Hammer=lt,(r=function(){return lt}.call(e,n,e,t))!==s&&(t.exports=r)}(window,document)},function(t,e){t.exports=function(t,e,n){for(var r=(2<<Math.log(e.length-1)/Math.LN2)-1,i=Math.ceil(1.6*r*n/e.length),o="";;)for(var a=t(i),s=0;s<i;s++){var c=a[s]&r;if(e[c]&&(o+=e[c],o.length===n))return o}}},function(t,e,n){"use strict";function r(t){var e="",n=Math.floor(.001*(Date.now()-s));return n===o?i++:(i=0,o=n),e+=a(c),e+=a(t),i>0&&(e+=a(i)),e+=a(n)}var i,o,a=n(15),s=(n(0),1459707606518),c=6;t.exports=r},function(t,e,n){"use strict";function r(t){for(var e,n=0,r="";!e;)r+=a(o,i.get(),1),e=t<Math.pow(16,n+1),n++;return r}var i=n(0),o=n(18),a=n(13);t.exports=r},function(t,e,n){"use strict";function r(e){return s.seed(e),t.exports}function i(e){return l=e,t.exports}function o(t){return void 0!==t&&s.characters(t),s.shuffled()}function a(){return c(l)}var s=n(0),c=n(14),u=n(17),l=n(20)||0;t.exports=a,t.exports.generate=a,t.exports.seed=r,t.exports.worker=i,t.exports.characters=o,t.exports.isValid=u},function(t,e,n){"use strict";function r(t){return!(!t||"string"!=typeof t||t.length<6)&&!new RegExp("[^"+i.get().replace(/[|\\{}()[\]^$+*?.-]/g,"\\$&")+"]").test(t)}var i=n(0);t.exports=r},function(t,e,n){"use strict";var r,i="object"==typeof window&&(window.crypto||window.msCrypto);r=i&&i.getRandomValues?function(t){return i.getRandomValues(new Uint8Array(t))}:function(t){for(var e=[],n=0;n<t;n++)e.push(Math.floor(256*Math.random()));return e},t.exports=r},function(t,e,n){"use strict";function r(){return(o=(9301*o+49297)%233280)/233280}function i(t){o=t}var o=1;t.exports={nextValue:r,seed:i}},function(t,e,n){"use strict";t.exports=0},function(t,e){t.exports=function(t,e,n,r){var i,o=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(i=t,o=t.default);var s="function"==typeof o?o.options:o;if(e&&(s.render=e.render,s.staticRenderFns=e.staticRenderFns),n&&(s._scopeId=n),r){var c=Object.create(s.computed||null);Object.keys(r).forEach(function(t){var e=r[t];c[t]=function(){return e}}),s.computed=c}return{esModule:i,exports:o,options:s}}},function(t,e,n){var r=n(9);"string"==typeof r&&(r=[[t.i,r,""]]),r.locals&&(t.exports=r.locals);n(23)("02af2e15",r,!0,{})},function(t,e,n){function r(t){for(var e=0;e<t.length;e++){var n=t[e],r=l[n.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](n.parts[i]);for(;i<n.parts.length;i++)r.parts.push(o(n.parts[i]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var a=[],i=0;i<n.parts.length;i++)a.push(o(n.parts[i]));l[n.id]={id:n.id,refs:1,parts:a}}}}function i(){var t=document.createElement("style");return t.type="text/css",f.appendChild(t),t}function o(t){var e,n,r=document.querySelector("style["+g+'~="'+t.id+'"]');if(r){if(h)return m;r.parentNode.removeChild(r)}if(y){var o=d++;r=p||(p=i()),e=a.bind(null,r,o,!1),n=a.bind(null,r,o,!0)}else r=i(),e=s.bind(null,r),n=function(){r.parentNode.removeChild(r)};return e(t),function(r){if(r){if(r.css===t.css&&r.media===t.media&&r.sourceMap===t.sourceMap)return;e(t=r)}else n()}}function a(t,e,n,r){var i=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=b(e,i);else{var o=document.createTextNode(i),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(o,a[e]):t.appendChild(o)}}function s(t,e){var n=e.css,r=e.media,i=e.sourceMap;if(r&&t.setAttribute("media",r),v.ssrId&&t.setAttribute(g,e.id),i&&(n+="\n/*# sourceURL="+i.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(i))))+" */"),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}var c="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!c)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var u=n(24),l={},f=c&&(document.head||document.getElementsByTagName("head")[0]),p=null,d=0,h=!1,m=function(){},v=null,g="data-vue-ssr-id",y="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());t.exports=function(t,e,n,i){h=n,v=i||{};var o=u(t,e);return r(o),function(e){for(var n=[],i=0;i<o.length;i++){var a=o[i],s=l[a.id];s.refs--,n.push(s)}e?(o=u(t,e),r(o)):o=[];for(var i=0;i<n.length;i++){var s=n[i];if(0===s.refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete l[s.id]}}}};var b=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t,e){for(var n=[],r={},i=0;i<e.length;i++){var o=e[i],a=o[0],s=o[1],c=o[2],u=o[3],l={id:t+":"+i,css:s,media:c,sourceMap:u};r[a]?r[a].parts.push(l):n.push(r[a]={id:a,parts:[l]})}return n}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n}])});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("VueLoading",[],e):"object"==typeof exports?exports.VueLoading=e():t.VueLoading=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function i(n){if(e[n])return e[n].exports;var r=e[n]={i:n,l:!1,exports:{}};return t[n].call(r.exports,r,r.exports,i),r.l=!0,r.exports}return i.m=t,i.c=e,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(t,e){if(1&e&&(t=i(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)i.d(n,r,function(e){return t[e]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=1)}([function(t,e,i){},function(t,e,i){"use strict";i.r(e);var n="undefined"!=typeof window?window.HTMLElement:Object,r={mounted:function(){document.addEventListener("focusin",this.focusIn)},methods:{focusIn:function(t){if(this.isActive&&t.target!==this.$el&&!this.$el.contains(t.target)){var e=this.container?this.container:this.isFullPage?null:this.$el.parentElement;(this.isFullPage||e&&e.contains(t.target))&&(t.preventDefault(),this.$el.focus())}}},beforeDestroy:function(){document.removeEventListener("focusin",this.focusIn)}};function a(t,e,i,n,r,a,o,s){var u,l="function"==typeof t?t.options:t;if(e&&(l.render=e,l.staticRenderFns=i,l._compiled=!0),n&&(l.functional=!0),a&&(l._scopeId="data-v-"+a),o?(u=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),r&&r.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=u):r&&(u=s?function(){r.call(this,this.$root.$options.shadowRoot)}:r),u)if(l.functional){l._injectStyles=u;var c=l.render;l.render=function(t,e){return u.call(e),c(t,e)}}else{var d=l.beforeCreate;l.beforeCreate=d?[].concat(d,u):[u]}return{exports:t,options:l}}var o=a({name:"spinner",props:{color:{type:String,default:"#000"},height:{type:Number,default:64},width:{type:Number,default:64}}},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{viewBox:"0 0 38 38",xmlns:"http://www.w3.org/2000/svg",width:this.width,height:this.height,stroke:this.color}},[e("g",{attrs:{fill:"none","fill-rule":"evenodd"}},[e("g",{attrs:{transform:"translate(1 1)","stroke-width":"2"}},[e("circle",{attrs:{"stroke-opacity":".25",cx:"18",cy:"18",r:"18"}}),this._v(" "),e("path",{attrs:{d:"M36 18c0-9.94-8.06-18-18-18"}},[e("animateTransform",{attrs:{attributeName:"transform",type:"rotate",from:"0 18 18",to:"360 18 18",dur:"0.8s",repeatCount:"indefinite"}})],1)])])])},[],!1,null,null,null);o.options.__file="spinner.vue";var s=o.exports,u=a({name:"dots",props:{color:{type:String,default:"#000"},height:{type:Number,default:240},width:{type:Number,default:60}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{viewBox:"0 0 120 30",xmlns:"http://www.w3.org/2000/svg",fill:t.color,width:t.width,height:t.height}},[i("circle",{attrs:{cx:"15",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"60",cy:"15",r:"9","fill-opacity":"0.3"}},[i("animate",{attrs:{attributeName:"r",from:"9",to:"9",begin:"0s",dur:"0.8s",values:"9;15;9",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"0.5",to:"0.5",begin:"0s",dur:"0.8s",values:".5;1;.5",calcMode:"linear",repeatCount:"indefinite"}})]),t._v(" "),i("circle",{attrs:{cx:"105",cy:"15",r:"15"}},[i("animate",{attrs:{attributeName:"r",from:"15",to:"15",begin:"0s",dur:"0.8s",values:"15;9;15",calcMode:"linear",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"fill-opacity",from:"1",to:"1",begin:"0s",dur:"0.8s",values:"1;.5;1",calcMode:"linear",repeatCount:"indefinite"}})])])},[],!1,null,null,null);u.options.__file="dots.vue";var l=u.exports,c=a({name:"bars",props:{color:{type:String,default:"#000"},height:{type:Number,default:40},width:{type:Number,default:40}}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 30 30",height:t.height,width:t.width,fill:t.color}},[i("rect",{attrs:{x:"0",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"10",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.15s",dur:"0.6s",repeatCount:"indefinite"}})]),t._v(" "),i("rect",{attrs:{x:"20",y:"13",width:"4",height:"5"}},[i("animate",{attrs:{attributeName:"height",attributeType:"XML",values:"5;21;5",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}}),t._v(" "),i("animate",{attrs:{attributeName:"y",attributeType:"XML",values:"13; 5; 13",begin:"0.3s",dur:"0.6s",repeatCount:"indefinite"}})])])},[],!1,null,null,null);c.options.__file="bars.vue";var d=c.exports,f=a({name:"vue-loading",mixins:[r],props:{active:Boolean,programmatic:Boolean,container:[Object,Function,n],isFullPage:{type:Boolean,default:!0},transition:{type:String,default:"fade"},canCancel:Boolean,onCancel:{type:Function,default:function(){}},color:String,backgroundColor:String,opacity:Number,width:Number,height:Number,loader:{type:String,default:"spinner"}},data:function(){return{isActive:this.active}},components:{Spinner:s,Dots:l,Bars:d},beforeMount:function(){this.programmatic&&(this.container?(this.isFullPage=!1,this.container.appendChild(this.$el)):document.body.appendChild(this.$el))},mounted:function(){this.programmatic&&(this.isActive=!0),document.addEventListener("keyup",this.keyPress)},methods:{cancel:function(){this.canCancel&&this.isActive&&(this.hide(),this.onCancel.apply(null,arguments))},hide:function(){var t=this;this.$emit("hide"),this.$emit("update:active",!1),this.programmatic&&(this.isActive=!1,setTimeout(function(){var e;t.$destroy(),void 0!==(e=t.$el).remove?e.remove():e.parentNode.removeChild(e)},150))},keyPress:function(t){27===t.keyCode&&this.cancel()}},watch:{active:function(t){this.isActive=t}},beforeDestroy:function(){document.removeEventListener("keyup",this.keyPress)}},function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("transition",{attrs:{name:t.transition}},[i("div",{directives:[{name:"show",rawName:"v-show",value:t.isActive,expression:"isActive"}],staticClass:"vld-overlay is-active",class:{"is-full-page":t.isFullPage},attrs:{tabindex:"0","aria-busy":t.isActive,"aria-label":"Loading"}},[i("div",{staticClass:"vld-background",style:{background:this.backgroundColor,opacity:this.opacity},on:{click:function(e){return e.preventDefault(),t.cancel(e)}}}),t._v(" "),i("div",{staticClass:"vld-icon"},[t._t("before"),t._v(" "),t._t("default",[i(t.loader,{tag:"component",attrs:{color:t.color,width:t.width,height:t.height}})]),t._v(" "),t._t("after")],2)])])},[],!1,null,null,null);f.options.__file="Component.vue";var p=f.exports,h=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return{show:function(){var n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:e,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:i,a=Object.assign({},e,n,{programmatic:!0}),o=new(t.extend(p))({el:document.createElement("div"),propsData:a}),s=Object.assign({},i,r);return Object.keys(s).map(function(t){o.$slots[t]=s[t]}),o}}};i(0);p.install=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},n=h(t,e,i);t.$loading=n,t.prototype.$loading=n};e.default=p}]).default});

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(247);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0291f990", content, true, {});

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".vld-overlay{bottom:0;left:0;position:absolute;right:0;top:0;align-items:center;display:none;justify-content:center;overflow:hidden;z-index:1}.vld-overlay.is-active{display:flex}.vld-overlay.is-full-page{z-index:999999;position:fixed}.vld-overlay .vld-background{bottom:0;left:0;position:absolute;right:0;top:0;background:#fff;opacity:.5}.vld-overlay .vld-icon,.vld-parent{position:relative}", ""]);

// exports


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export install */
/* unused harmony export VTooltip */
/* unused harmony export VClosePopover */
/* unused harmony export VPopover */
/* unused harmony export createTooltip */
/* unused harmony export destroyTooltip */
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.3
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && parent.nodeName === 'HTML') {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var SVGAnimatedString = function SVGAnimatedString() {};
if (typeof window !== 'undefined') {
	SVGAnimatedString = window.SVGAnimatedString;
}

function convertToArray(value) {
	if (typeof value === 'string') {
		value = value.split(' ');
	}
	return value;
}

/**
 * Add classes to an element.
 * This method checks to ensure that the classes don't already exist before adding them.
 * It uses el.className rather than classList in order to be IE friendly.
 * @param {object} el - The element to add the classes to.
 * @param {classes} string - List of space separated classes to be added to the element.
 */
function addClasses(el, classes) {
	var newClasses = convertToArray(classes);
	var classList = void 0;
	if (el.className instanceof SVGAnimatedString) {
		classList = convertToArray(el.className.baseVal);
	} else {
		classList = convertToArray(el.className);
	}
	newClasses.forEach(function (newClass) {
		if (classList.indexOf(newClass) === -1) {
			classList.push(newClass);
		}
	});
	if (el instanceof SVGElement) {
		el.setAttribute('class', classList.join(' '));
	} else {
		el.className = classList.join(' ');
	}
}

/**
 * Remove classes from an element.
 * It uses el.className rather than classList in order to be IE friendly.
 * @export
 * @param {any} el The element to remove the classes from.
 * @param {any} classes List of space separated classes to be removed from the element.
 */
function removeClasses(el, classes) {
	var newClasses = convertToArray(classes);
	var classList = void 0;
	if (el.className instanceof SVGAnimatedString) {
		classList = convertToArray(el.className.baseVal);
	} else {
		classList = convertToArray(el.className);
	}
	newClasses.forEach(function (newClass) {
		var index = classList.indexOf(newClass);
		if (index !== -1) {
			classList.splice(index, 1);
		}
	});
	if (el instanceof SVGElement) {
		el.setAttribute('class', classList.join(' '));
	} else {
		el.className = classList.join(' ');
	}
}

var supportsPassive = false;

if (typeof window !== 'undefined') {
	supportsPassive = false;
	try {
		var opts = Object.defineProperty({}, 'passive', {
			get: function get() {
				supportsPassive = true;
			}
		});
		window.addEventListener('test', null, opts);
	} catch (e) {}
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck$1 = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/* Forked from https://github.com/FezVrasta/popper.js/blob/master/packages/tooltip/src/index.js */

var DEFAULT_OPTIONS = {
	container: false,
	delay: 0,
	html: false,
	placement: 'top',
	title: '',
	template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	trigger: 'hover focus',
	offset: 0
};

var openTooltips = [];

var Tooltip = function () {
	/**
  * Create a new Tooltip.js instance
  * @class Tooltip
  * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
  * @param {Object} options
  * @param {String} options.placement=bottom
  *			Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
  *			left(-start, -end)`
  * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
  * @param {Number|Object} options.delay=0
  *			Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
  *			If a number is supplied, delay is applied to both hide/show.
  *			Object structure is: `{ show: 500, hide: 100 }`
  * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
  * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
  * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
  *			Base HTML to used when creating the tooltip.
  *			The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
  *			`.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
  *			The outermost wrapper element should have the `.tooltip` class.
  * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
  * @param {String} [options.trigger='hover focus']
  *			How tooltip is triggered - click, hover, focus, manual.
  *			You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
  * @param {HTMLElement} options.boundariesElement
  *			The element used as boundaries for the tooltip. For more information refer to Popper.js'
  *			[boundariesElement docs](https://popper.js.org/popper-documentation.html)
  * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
  *			[offset docs](https://popper.js.org/popper-documentation.html)
  * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
  *			[options docs](https://popper.js.org/popper-documentation.html)
  * @return {Object} instance - The generated tooltip instance
  */
	function Tooltip(reference, options) {
		classCallCheck$1(this, Tooltip);

		_initialiseProps.call(this);

		// apply user options over default ones
		options = _extends$1({}, DEFAULT_OPTIONS, options);

		reference.jquery && (reference = reference[0]);

		// cache reference and options
		this.reference = reference;
		this.options = options;

		// set initial state
		this._isOpen = false;

		this._init();
	}

	//
	// Public methods
	//

	/**
  * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
  * Tooltips with zero-length titles are never displayed.
  * @method Tooltip#show
  * @memberof Tooltip
  */


	/**
  * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
  * @method Tooltip#hide
  * @memberof Tooltip
  */


	/**
  * Hides and destroys an element’s tooltip.
  * @method Tooltip#dispose
  * @memberof Tooltip
  */


	/**
  * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
  * @method Tooltip#toggle
  * @memberof Tooltip
  */


	createClass$1(Tooltip, [{
		key: 'setClasses',
		value: function setClasses(classes) {
			this._classes = classes;
		}
	}, {
		key: 'setContent',
		value: function setContent(content) {
			this.options.title = content;
			if (this._tooltipNode) {
				this._setContent(content, this.options);
			}
		}
	}, {
		key: 'setOptions',
		value: function setOptions(options) {
			var classesUpdated = false;
			var classes = options && options.classes || directive.options.defaultClass;
			if (this._classes !== classes) {
				this.setClasses(classes);
				classesUpdated = true;
			}

			options = getOptions(options);

			var needPopperUpdate = false;
			var needRestart = false;

			if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
				needPopperUpdate = true;
			}

			if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
				needRestart = true;
			}

			for (var key in options) {
				this.options[key] = options[key];
			}

			if (this._tooltipNode) {
				if (needRestart) {
					var isOpen = this._isOpen;

					this.dispose();
					this._init();

					if (isOpen) {
						this.show();
					}
				} else if (needPopperUpdate) {
					this.popperInstance.update();
				}
			}
		}

		//
		// Private methods
		//

	}, {
		key: '_init',
		value: function _init() {
			// get events list
			var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ').filter(function (trigger) {
				return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
			}) : [];
			this._isDisposed = false;
			this._enableDocumentTouch = events.indexOf('manual') === -1;

			// set event listeners
			this._setEventListeners(this.reference, events, this.options);
		}

		/**
   * Creates a new tooltip node
   * @memberof Tooltip
   * @private
   * @param {HTMLElement} reference
   * @param {String} template
   * @param {String|HTMLElement|TitleFunction} title
   * @param {Boolean} allowHtml
   * @return {HTMLelement} tooltipNode
   */

	}, {
		key: '_create',
		value: function _create(reference, template) {
			// create tooltip element
			var tooltipGenerator = window.document.createElement('div');
			tooltipGenerator.innerHTML = template.trim();
			var tooltipNode = tooltipGenerator.childNodes[0];

			// add unique ID to our tooltip (needed for accessibility reasons)
			tooltipNode.id = 'tooltip_' + Math.random().toString(36).substr(2, 10);

			// Initially hide the tooltip
			// The attribute will be switched in a next frame so
			// CSS transitions can play
			tooltipNode.setAttribute('aria-hidden', 'true');

			if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
				tooltipNode.addEventListener('mouseenter', this.hide);
				tooltipNode.addEventListener('click', this.hide);
			}

			// return the generated tooltip node
			return tooltipNode;
		}
	}, {
		key: '_setContent',
		value: function _setContent(content, options) {
			var _this = this;

			this.asyncContent = false;
			this._applyContent(content, options).then(function () {
				_this.popperInstance.update();
			});
		}
	}, {
		key: '_applyContent',
		value: function _applyContent(title, options) {
			var _this2 = this;

			return new Promise(function (resolve, reject) {
				var allowHtml = options.html;
				var rootNode = _this2._tooltipNode;
				if (!rootNode) return;
				var titleNode = rootNode.querySelector(_this2.options.innerSelector);
				if (title.nodeType === 1) {
					// if title is a node, append it only if allowHtml is true
					if (allowHtml) {
						while (titleNode.firstChild) {
							titleNode.removeChild(titleNode.firstChild);
						}
						titleNode.appendChild(title);
					}
				} else if (typeof title === 'function') {
					// if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
					var result = title();
					if (result && typeof result.then === 'function') {
						_this2.asyncContent = true;
						options.loadingClass && addClasses(rootNode, options.loadingClass);
						if (options.loadingContent) {
							_this2._applyContent(options.loadingContent, options);
						}
						result.then(function (asyncResult) {
							options.loadingClass && removeClasses(rootNode, options.loadingClass);
							return _this2._applyContent(asyncResult, options);
						}).then(resolve).catch(reject);
					} else {
						_this2._applyContent(result, options).then(resolve).catch(reject);
					}
					return;
				} else {
					// if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
					allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
				}
				resolve();
			});
		}
	}, {
		key: '_show',
		value: function _show(reference, options) {
			if (options && typeof options.container === 'string') {
				var container = document.querySelector(options.container);
				if (!container) return;
			}

			clearTimeout(this._disposeTimer);

			options = Object.assign({}, options);
			delete options.offset;

			var updateClasses = true;
			if (this._tooltipNode) {
				addClasses(this._tooltipNode, this._classes);
				updateClasses = false;
			}

			var result = this._ensureShown(reference, options);

			if (updateClasses && this._tooltipNode) {
				addClasses(this._tooltipNode, this._classes);
			}

			addClasses(reference, ['v-tooltip-open']);

			return result;
		}
	}, {
		key: '_ensureShown',
		value: function _ensureShown(reference, options) {
			var _this3 = this;

			// don't show if it's already visible
			if (this._isOpen) {
				return this;
			}
			this._isOpen = true;

			openTooltips.push(this);

			// if the tooltipNode already exists, just show it
			if (this._tooltipNode) {
				this._tooltipNode.style.display = '';
				this._tooltipNode.setAttribute('aria-hidden', 'false');
				this.popperInstance.enableEventListeners();
				this.popperInstance.update();
				if (this.asyncContent) {
					this._setContent(options.title, options);
				}
				return this;
			}

			// get title
			var title = reference.getAttribute('title') || options.title;

			// don't show tooltip if no title is defined
			if (!title) {
				return this;
			}

			// create tooltip node
			var tooltipNode = this._create(reference, options.template);
			this._tooltipNode = tooltipNode;

			this._setContent(title, options);

			// Add `aria-describedby` to our reference element for accessibility reasons
			reference.setAttribute('aria-describedby', tooltipNode.id);

			// append tooltip to container
			var container = this._findContainer(options.container, reference);

			this._append(tooltipNode, container);

			var popperOptions = _extends$1({}, options.popperOptions, {
				placement: options.placement
			});

			popperOptions.modifiers = _extends$1({}, popperOptions.modifiers, {
				arrow: {
					element: this.options.arrowSelector
				}
			});

			if (options.boundariesElement) {
				popperOptions.modifiers.preventOverflow = {
					boundariesElement: options.boundariesElement
				};
			}

			this.popperInstance = new Popper(reference, tooltipNode, popperOptions);

			// Fix position
			requestAnimationFrame(function () {
				if (!_this3._isDisposed && _this3.popperInstance) {
					_this3.popperInstance.update();

					// Show the tooltip
					requestAnimationFrame(function () {
						if (!_this3._isDisposed) {
							_this3._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
						} else {
							_this3.dispose();
						}
					});
				} else {
					_this3.dispose();
				}
			});

			return this;
		}
	}, {
		key: '_noLongerOpen',
		value: function _noLongerOpen() {
			var index = openTooltips.indexOf(this);
			if (index !== -1) {
				openTooltips.splice(index, 1);
			}
		}
	}, {
		key: '_hide',
		value: function _hide() /* reference, options */{
			var _this4 = this;

			// don't hide if it's already hidden
			if (!this._isOpen) {
				return this;
			}

			this._isOpen = false;
			this._noLongerOpen();

			// hide tooltipNode
			this._tooltipNode.style.display = 'none';
			this._tooltipNode.setAttribute('aria-hidden', 'true');

			this.popperInstance.disableEventListeners();

			clearTimeout(this._disposeTimer);
			var disposeTime = directive.options.disposeTimeout;
			if (disposeTime !== null) {
				this._disposeTimer = setTimeout(function () {
					if (_this4._tooltipNode) {
						_this4._tooltipNode.removeEventListener('mouseenter', _this4.hide);
						_this4._tooltipNode.removeEventListener('click', _this4.hide);
						// Don't remove popper instance, just the HTML element
						_this4._tooltipNode.parentNode.removeChild(_this4._tooltipNode);
						_this4._tooltipNode = null;
					}
				}, disposeTime);
			}

			removeClasses(this.reference, ['v-tooltip-open']);

			return this;
		}
	}, {
		key: '_dispose',
		value: function _dispose() {
			var _this5 = this;

			this._isDisposed = true;

			// remove event listeners first to prevent any unexpected behaviour
			this._events.forEach(function (_ref) {
				var func = _ref.func,
				    event = _ref.event;

				_this5.reference.removeEventListener(event, func);
			});
			this._events = [];

			if (this._tooltipNode) {
				this._hide();

				this._tooltipNode.removeEventListener('mouseenter', this.hide);
				this._tooltipNode.removeEventListener('click', this.hide);

				// destroy instance
				this.popperInstance.destroy();

				// destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element
				if (!this.popperInstance.options.removeOnDestroy) {
					this._tooltipNode.parentNode.removeChild(this._tooltipNode);
					this._tooltipNode = null;
				}
			} else {
				this._noLongerOpen();
			}
			return this;
		}
	}, {
		key: '_findContainer',
		value: function _findContainer(container, reference) {
			// if container is a query, get the relative element
			if (typeof container === 'string') {
				container = window.document.querySelector(container);
			} else if (container === false) {
				// if container is `false`, set it to reference parent
				container = reference.parentNode;
			}
			return container;
		}

		/**
   * Append tooltip to container
   * @memberof Tooltip
   * @private
   * @param {HTMLElement} tooltip
   * @param {HTMLElement|String|false} container
   */

	}, {
		key: '_append',
		value: function _append(tooltipNode, container) {
			container.appendChild(tooltipNode);
		}
	}, {
		key: '_setEventListeners',
		value: function _setEventListeners(reference, events, options) {
			var _this6 = this;

			var directEvents = [];
			var oppositeEvents = [];

			events.forEach(function (event) {
				switch (event) {
					case 'hover':
						directEvents.push('mouseenter');
						oppositeEvents.push('mouseleave');
						if (_this6.options.hideOnTargetClick) oppositeEvents.push('click');
						break;
					case 'focus':
						directEvents.push('focus');
						oppositeEvents.push('blur');
						if (_this6.options.hideOnTargetClick) oppositeEvents.push('click');
						break;
					case 'click':
						directEvents.push('click');
						oppositeEvents.push('click');
						break;
				}
			});

			// schedule show tooltip
			directEvents.forEach(function (event) {
				var func = function func(evt) {
					if (_this6._isOpen === true) {
						return;
					}
					evt.usedByTooltip = true;
					_this6._scheduleShow(reference, options.delay, options, evt);
				};
				_this6._events.push({ event: event, func: func });
				reference.addEventListener(event, func);
			});

			// schedule hide tooltip
			oppositeEvents.forEach(function (event) {
				var func = function func(evt) {
					if (evt.usedByTooltip === true) {
						return;
					}
					_this6._scheduleHide(reference, options.delay, options, evt);
				};
				_this6._events.push({ event: event, func: func });
				reference.addEventListener(event, func);
			});
		}
	}, {
		key: '_onDocumentTouch',
		value: function _onDocumentTouch(event) {
			if (this._enableDocumentTouch) {
				this._scheduleHide(this.reference, this.options.delay, this.options, event);
			}
		}
	}, {
		key: '_scheduleShow',
		value: function _scheduleShow(reference, delay, options /*, evt */) {
			var _this7 = this;

			// defaults to 0
			var computedDelay = delay && delay.show || delay || 0;
			clearTimeout(this._scheduleTimer);
			this._scheduleTimer = window.setTimeout(function () {
				return _this7._show(reference, options);
			}, computedDelay);
		}
	}, {
		key: '_scheduleHide',
		value: function _scheduleHide(reference, delay, options, evt) {
			var _this8 = this;

			// defaults to 0
			var computedDelay = delay && delay.hide || delay || 0;
			clearTimeout(this._scheduleTimer);
			this._scheduleTimer = window.setTimeout(function () {
				if (_this8._isOpen === false) {
					return;
				}
				if (!document.body.contains(_this8._tooltipNode)) {
					return;
				}

				// if we are hiding because of a mouseleave, we must check that the new
				// reference isn't the tooltip, because in this case we don't want to hide it
				if (evt.type === 'mouseleave') {
					var isSet = _this8._setTooltipNodeEvent(evt, reference, delay, options);

					// if we set the new event, don't hide the tooltip yet
					// the new event will take care to hide it if necessary
					if (isSet) {
						return;
					}
				}

				_this8._hide(reference, options);
			}, computedDelay);
		}
	}]);
	return Tooltip;
}();

// Hide tooltips on touch devices


var _initialiseProps = function _initialiseProps() {
	var _this9 = this;

	this.show = function () {
		_this9._show(_this9.reference, _this9.options);
	};

	this.hide = function () {
		_this9._hide();
	};

	this.dispose = function () {
		_this9._dispose();
	};

	this.toggle = function () {
		if (_this9._isOpen) {
			return _this9.hide();
		} else {
			return _this9.show();
		}
	};

	this._events = [];

	this._setTooltipNodeEvent = function (evt, reference, delay, options) {
		var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;

		var callback = function callback(evt2) {
			var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget;

			// Remove event listener after call
			_this9._tooltipNode.removeEventListener(evt.type, callback);

			// If the new reference is not the reference element
			if (!reference.contains(relatedreference2)) {
				// Schedule to hide tooltip
				_this9._scheduleHide(reference, options.delay, options, evt2);
			}
		};

		if (_this9._tooltipNode.contains(relatedreference)) {
			// listen to mouseleave on the tooltip element to be able to hide the tooltip
			_this9._tooltipNode.addEventListener(evt.type, callback);
			return true;
		}

		return false;
	};
};

if (typeof document !== 'undefined') {
	document.addEventListener('touchstart', function (event) {
		for (var i = 0; i < openTooltips.length; i++) {
			openTooltips[i]._onDocumentTouch(event);
		}
	}, supportsPassive ? {
		passive: true,
		capture: true
	} : true);
}

/**
 * Placement function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback PlacementFunction
 * @param {HTMLElement} tooltip - tooltip DOM node.
 * @param {HTMLElement} reference - reference DOM node.
 * @return {String} placement - One of the allowed placement options.
 */

/**
 * Title function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback TitleFunction
 * @return {String} placement - The desired title.
 */

var state = {
	enabled: true
};

var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];

var defaultOptions = {
	// Default tooltip placement relative to target element
	defaultPlacement: 'top',
	// Default CSS classes applied to the tooltip element
	defaultClass: 'vue-tooltip-theme',
	// Default CSS classes applied to the target element of the tooltip
	defaultTargetClass: 'has-tooltip',
	// Is the content HTML by default?
	defaultHtml: true,
	// Default HTML template of the tooltip element
	// It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
	// Change if the classes conflict with other libraries (for example bootstrap)
	defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	// Selector used to get the arrow element in the tooltip template
	defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
	// Selector used to get the inner content element in the tooltip template
	defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
	// Delay (ms)
	defaultDelay: 0,
	// Default events that trigger the tooltip
	defaultTrigger: 'hover focus',
	// Default position offset (px)
	defaultOffset: 0,
	// Default container where the tooltip will be appended
	defaultContainer: 'body',
	defaultBoundariesElement: undefined,
	defaultPopperOptions: {},
	// Class added when content is loading
	defaultLoadingClass: 'tooltip-loading',
	// Displayed when tooltip content is loading
	defaultLoadingContent: '...',
	// Hide on mouseover tooltip
	autoHide: true,
	// Close tooltip on click on tooltip target?
	defaultHideOnTargetClick: true,
	// Auto destroy tooltip DOM nodes (ms)
	disposeTimeout: 5000,
	// Options for popover
	popover: {
		defaultPlacement: 'bottom',
		// Use the `popoverClass` prop for theming
		defaultClass: 'vue-popover-theme',
		// Base class (change if conflicts with other libraries)
		defaultBaseClass: 'tooltip popover',
		// Wrapper class (contains arrow and inner)
		defaultWrapperClass: 'wrapper',
		// Inner content class
		defaultInnerClass: 'tooltip-inner popover-inner',
		// Arrow class
		defaultArrowClass: 'tooltip-arrow popover-arrow',
		defaultDelay: 0,
		defaultTrigger: 'click',
		defaultOffset: 0,
		defaultContainer: 'body',
		defaultBoundariesElement: undefined,
		defaultPopperOptions: {},
		// Hides if clicked outside of popover
		defaultAutoHide: true,
		// Update popper on content resize
		defaultHandleResize: true
	}
};

function getOptions(options) {
	var result = {
		placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
		delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
		html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
		template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
		arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
		innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
		trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
		offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
		container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
		boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
		autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
		hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
		loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
		loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
		popperOptions: _extends$1({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
	};

	if (result.offset) {
		var typeofOffset = _typeof(result.offset);
		var offset = result.offset;

		// One value -> switch
		if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
			offset = '0, ' + offset;
		}

		if (!result.popperOptions.modifiers) {
			result.popperOptions.modifiers = {};
		}
		result.popperOptions.modifiers.offset = {
			offset: offset
		};
	}

	if (result.trigger && result.trigger.indexOf('click') !== -1) {
		result.hideOnTargetClick = false;
	}

	return result;
}

function getPlacement(value, modifiers) {
	var placement = value.placement;
	for (var i = 0; i < positions.length; i++) {
		var pos = positions[i];
		if (modifiers[pos]) {
			placement = pos;
		}
	}
	return placement;
}

function getContent(value) {
	var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (type === 'string') {
		return value;
	} else if (value && type === 'object') {
		return value.content;
	} else {
		return false;
	}
}

function createTooltip(el, value) {
	var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	var content = getContent(value);
	var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;
	var opts = _extends$1({
		title: content
	}, getOptions(_extends$1({}, value, {
		placement: getPlacement(value, modifiers)
	})));
	var tooltip = el._tooltip = new Tooltip(el, opts);
	tooltip.setClasses(classes);
	tooltip._vueEl = el;

	// Class on target
	var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
	el._tooltipTargetClasses = targetClasses;
	addClasses(el, targetClasses);

	return tooltip;
}

function destroyTooltip(el) {
	if (el._tooltip) {
		el._tooltip.dispose();
		delete el._tooltip;
		delete el._tooltipOldShow;
	}

	if (el._tooltipTargetClasses) {
		removeClasses(el, el._tooltipTargetClasses);
		delete el._tooltipTargetClasses;
	}
}

function bind(el, _ref) {
	var value = _ref.value,
	    oldValue = _ref.oldValue,
	    modifiers = _ref.modifiers;

	var content = getContent(value);
	if (!content || !state.enabled) {
		destroyTooltip(el);
	} else {
		var tooltip = void 0;
		if (el._tooltip) {
			tooltip = el._tooltip;
			// Content
			tooltip.setContent(content);
			// Options
			tooltip.setOptions(_extends$1({}, value, {
				placement: getPlacement(value, modifiers)
			}));
		} else {
			tooltip = createTooltip(el, value, modifiers);
		}

		// Manual show
		if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
			el._tooltipOldShow = value.show;
			value.show ? tooltip.show() : tooltip.hide();
		}
	}
}

var directive = {
	options: defaultOptions,
	bind: bind,
	update: bind,
	unbind: function unbind(el) {
		destroyTooltip(el);
	}
};

function addListeners(el) {
	el.addEventListener('click', onClick);
	el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
		passive: true
	} : false);
}

function removeListeners(el) {
	el.removeEventListener('click', onClick);
	el.removeEventListener('touchstart', onTouchStart);
	el.removeEventListener('touchend', onTouchEnd);
	el.removeEventListener('touchcancel', onTouchCancel);
}

function onClick(event) {
	var el = event.currentTarget;
	event.closePopover = !el.$_vclosepopover_touch;
	event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
	if (event.changedTouches.length === 1) {
		var el = event.currentTarget;
		el.$_vclosepopover_touch = true;
		var touch = event.changedTouches[0];
		el.$_vclosepopover_touchPoint = touch;
		el.addEventListener('touchend', onTouchEnd);
		el.addEventListener('touchcancel', onTouchCancel);
	}
}

function onTouchEnd(event) {
	var el = event.currentTarget;
	el.$_vclosepopover_touch = false;
	if (event.changedTouches.length === 1) {
		var touch = event.changedTouches[0];
		var firstTouch = el.$_vclosepopover_touchPoint;
		event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
		event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
	}
}

function onTouchCancel(event) {
	var el = event.currentTarget;
	el.$_vclosepopover_touch = false;
}

var vclosepopover = {
	bind: function bind(el, _ref) {
		var value = _ref.value,
		    modifiers = _ref.modifiers;

		el.$_closePopoverModifiers = modifiers;
		if (typeof value === 'undefined' || value) {
			addListeners(el);
		}
	},
	update: function update(el, _ref2) {
		var value = _ref2.value,
		    oldValue = _ref2.oldValue,
		    modifiers = _ref2.modifiers;

		el.$_closePopoverModifiers = modifiers;
		if (value !== oldValue) {
			if (typeof value === 'undefined' || value) {
				addListeners(el);
			} else {
				removeListeners(el);
			}
		}
	},
	unbind: function unbind(el) {
		removeListeners(el);
	}
};

function getInternetExplorerVersion() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return -1;
}

var isIE$1 = void 0;

function initCompat() {
	if (!initCompat.init) {
		initCompat.init = true;
		isIE$1 = getInternetExplorerVersion() !== -1;
	}
}

var ResizeObserver = { render: function render() {
		var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "resize-observer", attrs: { "tabindex": "-1" } });
	}, staticRenderFns: [], _scopeId: 'data-v-b329ee4c',
	name: 'resize-observer',

	methods: {
		notify: function notify() {
			this.$emit('notify');
		},
		addResizeHandlers: function addResizeHandlers() {
			this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.notify);
			if (this._w !== this.$el.offsetWidth || this._h !== this.$el.offsetHeight) {
				this.notify();
			}
		},
		removeResizeHandlers: function removeResizeHandlers() {
			if (this._resizeObject && this._resizeObject.onload) {
				if (!isIE$1 && this._resizeObject.contentDocument) {
					this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.notify);
				}
				delete this._resizeObject.onload;
			}
		}
	},

	mounted: function mounted() {
		var _this = this;

		initCompat();
		this.$nextTick(function () {
			_this._w = _this.$el.offsetWidth;
			_this._h = _this.$el.offsetHeight;
		});
		var object = document.createElement('object');
		this._resizeObject = object;
		object.setAttribute('style', 'display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; pointer-events: none; z-index: -1;');
		object.setAttribute('aria-hidden', 'true');
		object.setAttribute('tabindex', -1);
		object.onload = this.addResizeHandlers;
		object.type = 'text/html';
		if (isIE$1) {
			this.$el.appendChild(object);
		}
		object.data = 'about:blank';
		if (!isIE$1) {
			this.$el.appendChild(object);
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.removeResizeHandlers();
	}
};

// Install the components
function install$1(Vue) {
	Vue.component('resize-observer', ResizeObserver);
	/* -- Add more components here -- */
}

/* -- Plugin definition & Auto-install -- */
/* You shouldn't have to modify the code below */

// Plugin
var plugin$2 = {
	// eslint-disable-next-line no-undef
	version: "0.4.4",
	install: install$1
};

// Auto-install
var GlobalVue$1 = null;
if (typeof window !== 'undefined') {
	GlobalVue$1 = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue$1 = global.Vue;
}
if (GlobalVue$1) {
	GlobalVue$1.use(plugin$2);
}

function getDefault(key) {
	var value = directive.options.popover[key];
	if (typeof value === 'undefined') {
		return directive.options[key];
	}
	return value;
}

var isIOS = false;
if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
	isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var openPopovers = [];

var Element = function Element() {};
if (typeof window !== 'undefined') {
	Element = window.Element;
}

var Popover = { render: function render() {
		var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "v-popover", class: _vm.cssClass }, [_c('span', { ref: "trigger", staticClass: "trigger", staticStyle: { "display": "inline-block" }, attrs: { "aria-describedby": _vm.popoverId, "tabindex": _vm.trigger.indexOf('focus') !== -1 ? 0 : -1 } }, [_vm._t("default")], 2), _vm._v(" "), _c('div', { ref: "popover", class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass], style: {
				visibility: _vm.isOpen ? 'visible' : 'hidden'
			}, attrs: { "id": _vm.popoverId, "aria-hidden": _vm.isOpen ? 'false' : 'true' } }, [_c('div', { class: _vm.popoverWrapperClass }, [_c('div', { ref: "inner", class: _vm.popoverInnerClass, staticStyle: { "position": "relative" } }, [_c('div', [_vm._t("popover")], 2), _vm._v(" "), _vm.handleResize ? _c('ResizeObserver', { on: { "notify": _vm.$_handleResize } }) : _vm._e()], 1), _vm._v(" "), _c('div', { ref: "arrow", class: _vm.popoverArrowClass })])])]);
	}, staticRenderFns: [],
	name: 'VPopover',

	components: {
		ResizeObserver: ResizeObserver
	},

	props: {
		open: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		placement: {
			type: String,
			default: function _default() {
				return getDefault('defaultPlacement');
			}
		},
		delay: {
			type: [String, Number, Object],
			default: function _default() {
				return getDefault('defaultDelay');
			}
		},
		offset: {
			type: [String, Number],
			default: function _default() {
				return getDefault('defaultOffset');
			}
		},
		trigger: {
			type: String,
			default: function _default() {
				return getDefault('defaultTrigger');
			}
		},
		container: {
			type: [String, Object, Element, Boolean],
			default: function _default() {
				return getDefault('defaultContainer');
			}
		},
		boundariesElement: {
			type: [String, Element],
			default: function _default() {
				return getDefault('defaultBoundariesElement');
			}
		},
		popperOptions: {
			type: Object,
			default: function _default() {
				return getDefault('defaultPopperOptions');
			}
		},
		popoverClass: {
			type: [String, Array],
			default: function _default() {
				return getDefault('defaultClass');
			}
		},
		popoverBaseClass: {
			type: [String, Array],
			default: function _default() {
				return directive.options.popover.defaultBaseClass;
			}
		},
		popoverInnerClass: {
			type: [String, Array],
			default: function _default() {
				return directive.options.popover.defaultInnerClass;
			}
		},
		popoverWrapperClass: {
			type: [String, Array],
			default: function _default() {
				return directive.options.popover.defaultWrapperClass;
			}
		},
		popoverArrowClass: {
			type: [String, Array],
			default: function _default() {
				return directive.options.popover.defaultArrowClass;
			}
		},
		autoHide: {
			type: Boolean,
			default: function _default() {
				return directive.options.popover.defaultAutoHide;
			}
		},
		handleResize: {
			type: Boolean,
			default: function _default() {
				return directive.options.popover.defaultHandleResize;
			}
		},
		openGroup: {
			type: String,
			default: null
		}
	},

	data: function data() {
		return {
			isOpen: false,
			id: Math.random().toString(36).substr(2, 10)
		};
	},


	computed: {
		cssClass: function cssClass() {
			return {
				'open': this.isOpen
			};
		},
		popoverId: function popoverId() {
			return 'popover_' + this.id;
		}
	},

	watch: {
		open: function open(val) {
			if (val) {
				this.show();
			} else {
				this.hide();
			}
		},
		disabled: function disabled(val, oldVal) {
			if (val !== oldVal) {
				if (val) {
					this.hide();
				} else if (this.open) {
					this.show();
				}
			}
		},
		container: function container(val) {
			if (this.isOpen && this.popperInstance) {
				var popoverNode = this.$refs.popover;
				var reference = this.$refs.trigger;

				var container = this.$_findContainer(this.container, reference);
				if (!container) {
					console.warn('No container for popover', this);
					return;
				}

				container.appendChild(popoverNode);
				this.popperInstance.scheduleUpdate();
			}
		},
		trigger: function trigger(val) {
			this.$_removeEventListeners();
			this.$_addEventListeners();
		},
		placement: function placement(val) {
			var _this = this;

			this.$_updatePopper(function () {
				_this.popperInstance.options.placement = val;
			});
		},


		offset: '$_restartPopper',

		boundariesElement: '$_restartPopper',

		popperOptions: {
			handler: '$_restartPopper',
			deep: true
		}
	},

	created: function created() {
		this.$_isDisposed = false;
		this.$_mounted = false;
		this.$_events = [];
		this.$_preventOpen = false;
	},
	mounted: function mounted() {
		var popoverNode = this.$refs.popover;
		popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);

		this.$_init();

		if (this.open) {
			this.show();
		}
	},
	beforeDestroy: function beforeDestroy() {
		this.dispose();
	},


	methods: {
		show: function show() {
			var _this2 = this;

			var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
			    event = _ref.event,
			    _ref$skipDelay = _ref.skipDelay,
			    skipDelay = _ref$skipDelay === undefined ? false : _ref$skipDelay,
			    _ref$force = _ref.force,
			    force = _ref$force === undefined ? false : _ref$force;

			if (force || !this.disabled) {
				this.$_scheduleShow(event);
				this.$emit('show');
			}
			this.$emit('update:open', true);
			this.$_beingShowed = true;
			requestAnimationFrame(function () {
				_this2.$_beingShowed = false;
			});
		},
		hide: function hide() {
			var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
			    event = _ref2.event,
			    _ref2$skipDelay = _ref2.skipDelay;

			this.$_scheduleHide(event);

			this.$emit('hide');
			this.$emit('update:open', false);
		},
		dispose: function dispose() {
			this.$_isDisposed = true;
			this.$_removeEventListeners();
			this.hide({ skipDelay: true });
			if (this.popperInstance) {
				this.popperInstance.destroy();

				// destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element
				if (!this.popperInstance.options.removeOnDestroy) {
					var popoverNode = this.$refs.popover;
					popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
				}
			}
			this.$_mounted = false;
			this.popperInstance = null;
			this.isOpen = false;

			this.$emit('dispose');
		},
		$_init: function $_init() {
			if (this.trigger.indexOf('manual') === -1) {
				this.$_addEventListeners();
			}
		},
		$_show: function $_show() {
			var _this3 = this;

			var reference = this.$refs.trigger;
			var popoverNode = this.$refs.popover;

			clearTimeout(this.$_disposeTimer);

			// Already open
			if (this.isOpen) {
				return;
			}

			// Popper is already initialized
			if (this.popperInstance) {
				this.isOpen = true;
				this.popperInstance.enableEventListeners();
				this.popperInstance.scheduleUpdate();
			}

			if (!this.$_mounted) {
				var container = this.$_findContainer(this.container, reference);
				if (!container) {
					console.warn('No container for popover', this);
					return;
				}
				container.appendChild(popoverNode);
				this.$_mounted = true;
			}

			if (!this.popperInstance) {
				var popperOptions = _extends$1({}, this.popperOptions, {
					placement: this.placement
				});

				popperOptions.modifiers = _extends$1({}, popperOptions.modifiers, {
					arrow: _extends$1({}, popperOptions.modifiers && popperOptions.modifiers.arrow, {
						element: this.$refs.arrow
					})
				});

				if (this.offset) {
					var offset = this.$_getOffset();

					popperOptions.modifiers.offset = _extends$1({}, popperOptions.modifiers && popperOptions.modifiers.offset, {
						offset: offset
					});
				}

				if (this.boundariesElement) {
					popperOptions.modifiers.preventOverflow = _extends$1({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow, {
						boundariesElement: this.boundariesElement
					});
				}

				this.popperInstance = new Popper(reference, popoverNode, popperOptions);

				// Fix position
				requestAnimationFrame(function () {
					if (!_this3.$_isDisposed && _this3.popperInstance) {
						_this3.popperInstance.scheduleUpdate();

						// Show the tooltip
						requestAnimationFrame(function () {
							if (!_this3.$_isDisposed) {
								_this3.isOpen = true;
							} else {
								_this3.dispose();
							}
						});
					} else {
						_this3.dispose();
					}
				});
			}

			var openGroup = this.openGroup;
			if (openGroup) {
				var popover = void 0;
				for (var i = 0; i < openPopovers.length; i++) {
					popover = openPopovers[i];
					if (popover.openGroup !== openGroup) {
						popover.hide();
						popover.$emit('close-group');
					}
				}
			}

			openPopovers.push(this);

			this.$emit('apply-show');
		},
		$_hide: function $_hide() {
			var _this4 = this;

			// Already hidden
			if (!this.isOpen) {
				return;
			}

			var index = openPopovers.indexOf(this);
			if (index !== -1) {
				openPopovers.splice(index, 1);
			}

			this.isOpen = false;
			if (this.popperInstance) {
				this.popperInstance.disableEventListeners();
			}

			clearTimeout(this.$_disposeTimer);
			var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;
			if (disposeTime !== null) {
				this.$_disposeTimer = setTimeout(function () {
					var popoverNode = _this4.$refs.popover;
					if (popoverNode) {
						// Don't remove popper instance, just the HTML element
						popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
						_this4.$_mounted = false;
					}
				}, disposeTime);
			}

			this.$emit('apply-hide');
		},
		$_findContainer: function $_findContainer(container, reference) {
			// if container is a query, get the relative element
			if (typeof container === 'string') {
				container = window.document.querySelector(container);
			} else if (container === false) {
				// if container is `false`, set it to reference parent
				container = reference.parentNode;
			}
			return container;
		},
		$_getOffset: function $_getOffset() {
			var typeofOffset = _typeof(this.offset);
			var offset = this.offset;

			// One value -> switch
			if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
				offset = '0, ' + offset;
			}

			return offset;
		},
		$_addEventListeners: function $_addEventListeners() {
			var _this5 = this;

			var reference = this.$refs.trigger;
			var directEvents = [];
			var oppositeEvents = [];

			var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
				return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
			}) : [];

			events.forEach(function (event) {
				switch (event) {
					case 'hover':
						directEvents.push('mouseenter');
						oppositeEvents.push('mouseleave');
						break;
					case 'focus':
						directEvents.push('focus');
						oppositeEvents.push('blur');
						break;
					case 'click':
						directEvents.push('click');
						oppositeEvents.push('click');
						break;
				}
			});

			// schedule show tooltip
			directEvents.forEach(function (event) {
				var func = function func(event) {
					if (_this5.isOpen) {
						return;
					}
					event.usedByTooltip = true;
					!_this5.$_preventOpen && _this5.show({ event: event });
				};
				_this5.$_events.push({ event: event, func: func });
				reference.addEventListener(event, func);
			});

			// schedule hide tooltip
			oppositeEvents.forEach(function (event) {
				var func = function func(event) {
					if (event.usedByTooltip) {
						return;
					}
					_this5.hide({ event: event });
				};
				_this5.$_events.push({ event: event, func: func });
				reference.addEventListener(event, func);
			});
		},
		$_scheduleShow: function $_scheduleShow() {
			var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			clearTimeout(this.$_scheduleTimer);
			if (skipDelay) {
				this.$_show();
			} else {
				// defaults to 0
				var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
				this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
			}
		},
		$_scheduleHide: function $_scheduleHide() {
			var _this6 = this;

			var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			clearTimeout(this.$_scheduleTimer);
			if (skipDelay) {
				this.$_hide();
			} else {
				// defaults to 0
				var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
				this.$_scheduleTimer = setTimeout(function () {
					if (!_this6.isOpen) {
						return;
					}

					// if we are hiding because of a mouseleave, we must check that the new
					// reference isn't the tooltip, because in this case we don't want to hide it
					if (event && event.type === 'mouseleave') {
						var isSet = _this6.$_setTooltipNodeEvent(event);

						// if we set the new event, don't hide the tooltip yet
						// the new event will take care to hide it if necessary
						if (isSet) {
							return;
						}
					}

					_this6.$_hide();
				}, computedDelay);
			}
		},
		$_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
			var _this7 = this;

			var reference = this.$refs.trigger;
			var popoverNode = this.$refs.popover;

			var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;

			var callback = function callback(event2) {
				var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget;

				// Remove event listener after call
				popoverNode.removeEventListener(event.type, callback);

				// If the new reference is not the reference element
				if (!reference.contains(relatedreference2)) {
					// Schedule to hide tooltip
					_this7.hide({ event: event2 });
				}
			};

			if (popoverNode.contains(relatedreference)) {
				// listen to mouseleave on the tooltip element to be able to hide the tooltip
				popoverNode.addEventListener(event.type, callback);
				return true;
			}

			return false;
		},
		$_removeEventListeners: function $_removeEventListeners() {
			var reference = this.$refs.trigger;
			this.$_events.forEach(function (_ref3) {
				var func = _ref3.func,
				    event = _ref3.event;

				reference.removeEventListener(event, func);
			});
			this.$_events = [];
		},
		$_updatePopper: function $_updatePopper(cb) {
			if (this.popperInstance) {
				cb();
				if (this.isOpen) this.popperInstance.scheduleUpdate();
			}
		},
		$_restartPopper: function $_restartPopper() {
			if (this.popperInstance) {
				var isOpen = this.isOpen;
				this.dispose();
				this.$_isDisposed = false;
				this.$_init();
				if (isOpen) {
					this.show({ skipDelay: true, force: true });
				}
			}
		},
		$_handleGlobalClose: function $_handleGlobalClose(event) {
			var _this8 = this;

			var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			if (this.$_beingShowed) return;

			this.hide({ event: event });

			if (event.closePopover) {
				this.$emit('close-directive');
			} else {
				this.$emit('auto-hide');
			}

			if (touch) {
				this.$_preventOpen = true;
				setTimeout(function () {
					_this8.$_preventOpen = false;
				}, 300);
			}
		},
		$_handleResize: function $_handleResize() {
			if (this.isOpen && this.popperInstance) {
				this.popperInstance.scheduleUpdate();
				this.$emit('resize');
			}
		}
	}
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
	if (isIOS) {
		document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
			passive: true,
			capture: true
		} : true);
	} else {
		window.addEventListener('click', handleGlobalClick, true);
	}
}

function handleGlobalClick(event) {
	handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
	handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
	var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	// Delay so that close directive has time to set values
	requestAnimationFrame(function () {
		var popover = void 0;
		for (var i = 0; i < openPopovers.length; i++) {
			popover = openPopovers[i];
			if (popover.$refs.popover) {
				var contains = popover.$refs.popover.contains(event.target);
				if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
					popover.$_handleGlobalClose(event, touch);
				}
			}
		}
	});
}

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lodash_merge = createCommonjsModule(function (module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;
});

function install(Vue) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	if (install.installed) return;
	install.installed = true;

	var finalOptions = {};
	lodash_merge(finalOptions, defaultOptions, options);

	plugin.options = finalOptions;
	directive.options = finalOptions;

	Vue.directive('tooltip', directive);
	Vue.directive('close-popover', vclosepopover);
	Vue.component('v-popover', Popover);
}

var VTooltip = directive;
var VClosePopover = vclosepopover;
var VPopover = Popover;

var plugin = {
	install: install,

	get enabled() {
		return state.enabled;
	},

	set enabled(value) {
		state.enabled = value;
	}
};

// Auto-install
var GlobalVue = null;
if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}
if (GlobalVue) {
	GlobalVue.use(plugin);
}


/* harmony default export */ __webpack_exports__["a"] = (plugin);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports["vue-js-modal"]=t():e["vue-js-modal"]=t()}(window,function(){return function(n){var i={};function o(e){if(i[e])return i[e].exports;var t=i[e]={i:e,l:!1,exports:{}};return n[e].call(t.exports,t,t.exports,o),t.l=!0,t.exports}return o.m=n,o.c=i,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(t,e){if(1&e&&(t=o(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)o.d(n,i,function(e){return t[e]}.bind(null,i));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="/dist/",o(o.s=11)}([function(e,t,n){var i=n(6);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(4).default)("27d83796",i,!1,{})},function(e,t,n){var i=n(8);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(4).default)("0e783494",i,!1,{})},function(e,t,n){var i=n(10);"string"==typeof i&&(i=[[e.i,i,""]]),i.locals&&(e.exports=i.locals);(0,n(4).default)("17757f60",i,!1,{})},function(e,t){e.exports=function(n){var a=[];return a.toString=function(){return this.map(function(e){var t=function(e,t){var n=e[1]||"",i=e[3];if(!i)return n;if(t&&"function"==typeof btoa){var o=(a=i,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),r=i.sources.map(function(e){return"/*# sourceURL="+i.sourceRoot+e+" */"});return[n].concat(r).concat([o]).join("\n")}var a;return[n].join("\n")}(e,n);return e[2]?"@media "+e[2]+"{"+t+"}":t}).join("")},a.i=function(e,t){"string"==typeof e&&(e=[[null,e,""]]);for(var n={},i=0;i<this.length;i++){var o=this[i][0];"number"==typeof o&&(n[o]=!0)}for(i=0;i<e.length;i++){var r=e[i];"number"==typeof r[0]&&n[r[0]]||(t&&!r[2]?r[2]=t:t&&(r[2]="("+r[2]+") and ("+t+")"),a.push(r))}},a}},function(e,t,n){"use strict";function l(e,t){for(var n=[],i={},o=0;o<t.length;o++){var r=t[o],a=r[0],s={id:e+":"+o,css:r[1],media:r[2],sourceMap:r[3]};i[a]?i[a].parts.push(s):n.push(i[a]={id:a,parts:[s]})}return n}n.r(t),n.d(t,"default",function(){return p});var i="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var d={},o=i&&(document.head||document.getElementsByTagName("head")[0]),r=null,a=0,u=!1,s=function(){},c=null,h="data-vue-ssr-id",f="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function p(a,e,t,n){u=t,c=n||{};var s=l(a,e);return v(s),function(e){for(var t=[],n=0;n<s.length;n++){var i=s[n];(o=d[i.id]).refs--,t.push(o)}e?v(s=l(a,e)):s=[];for(n=0;n<t.length;n++){var o;if(0===(o=t[n]).refs){for(var r=0;r<o.parts.length;r++)o.parts[r]();delete d[o.id]}}}}function v(e){for(var t=0;t<e.length;t++){var n=e[t],i=d[n.id];if(i){i.refs++;for(var o=0;o<i.parts.length;o++)i.parts[o](n.parts[o]);for(;o<n.parts.length;o++)i.parts.push(g(n.parts[o]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{var r=[];for(o=0;o<n.parts.length;o++)r.push(g(n.parts[o]));d[n.id]={id:n.id,refs:1,parts:r}}}}function m(){var e=document.createElement("style");return e.type="text/css",o.appendChild(e),e}function g(t){var n,i,e=document.querySelector("style["+h+'~="'+t.id+'"]');if(e){if(u)return s;e.parentNode.removeChild(e)}if(f){var o=a++;e=r||(r=m()),n=w.bind(null,e,o,!1),i=w.bind(null,e,o,!0)}else e=m(),n=function(e,t){var n=t.css,i=t.media,o=t.sourceMap;i&&e.setAttribute("media",i);c.ssrId&&e.setAttribute(h,t.id);o&&(n+="\n/*# sourceURL="+o.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */");if(e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}.bind(null,e),i=function(){e.parentNode.removeChild(e)};return n(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;n(t=e)}else i()}}var b,y=(b=[],function(e,t){return b[e]=t,b.filter(Boolean).join("\n")});function w(e,t,n,i){var o=n?"":i.css;if(e.styleSheet)e.styleSheet.cssText=y(t,o);else{var r=document.createTextNode(o),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(r,a[t]):e.appendChild(r)}}},function(e,t,n){"use strict";var i=n(0);n.n(i).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.vue-modal-resizer {\n  display: block;\n  overflow: hidden;\n  position: absolute;\n  width: 12px;\n  height: 12px;\n  right: 0;\n  bottom: 0;\n  z-index: 9999999;\n  background: transparent;\n  cursor: se-resize;\n}\n.vue-modal-resizer::after {\n  display: block;\n  position: absolute;\n  content: '';\n  background: transparent;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 0;\n  border-bottom: 10px solid #ddd;\n  border-left: 10px solid transparent;\n}\n.vue-modal-resizer.clicked::after {\n  border-bottom: 10px solid #369be9;\n}\n",""])},function(e,t,n){"use strict";var i=n(1);n.n(i).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.v--modal-block-scroll {\n  overflow: hidden;\n  width: 100vw;\n}\n.v--modal-overlay {\n  position: fixed;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 999;\n  opacity: 1;\n}\n.v--modal-overlay.scrollable {\n  height: 100%;\n  min-height: 100vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.v--modal-overlay .v--modal-background-click {\n  width: 100%;\n  height: 100%;\n}\n.v--modal-overlay .v--modal-box {\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n.v--modal-overlay.scrollable .v--modal-box {\n  margin-bottom: 2px;\n}\n.v--modal {\n  background-color: white;\n  text-align: left;\n  border-radius: 3px;\n  box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);\n  padding: 0;\n}\n.v--modal.v--modal-fullscreen {\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  left: 0;\n  top: 0;\n}\n.v--modal-top-right {\n  display: block;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.overlay-fade-enter-active,\n.overlay-fade-leave-active {\n  transition: all 0.2s;\n}\n.overlay-fade-enter,\n.overlay-fade-leave-active {\n  opacity: 0;\n}\n.nice-modal-fade-enter-active,\n.nice-modal-fade-leave-active {\n  transition: all 0.4s;\n}\n.nice-modal-fade-enter,\n.nice-modal-fade-leave-active {\n  opacity: 0;\n  transform: translateY(-20px);\n}\n",""])},function(e,t,n){"use strict";var i=n(2);n.n(i).a},function(e,t,n){(e.exports=n(3)(!1)).push([e.i,"\n.vue-dialog div {\n  box-sizing: border-box;\n}\n.vue-dialog .dialog-flex {\n  width: 100%;\n  height: 100%;\n}\n.vue-dialog .dialog-content {\n  flex: 1 0 auto;\n  width: 100%;\n  padding: 15px;\n  font-size: 14px;\n}\n.vue-dialog .dialog-c-title {\n  font-weight: 600;\n  padding-bottom: 15px;\n}\n.vue-dialog .dialog-c-text {\n}\n.vue-dialog .vue-dialog-buttons {\n  display: flex;\n  flex: 0 1 auto;\n  width: 100%;\n  border-top: 1px solid #eee;\n}\n.vue-dialog .vue-dialog-buttons-none {\n  width: 100%;\n  padding-bottom: 15px;\n}\n.vue-dialog-button {\n  font-size: 12px !important;\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  border: 0;\n  cursor: pointer;\n  box-sizing: border-box;\n  line-height: 40px;\n  height: 40px;\n  color: inherit;\n  font: inherit;\n  outline: none;\n}\n.vue-dialog-button:hover {\n  background: rgba(0, 0, 0, 0.01);\n}\n.vue-dialog-button:active {\n  background: rgba(0, 0, 0, 0.025);\n}\n.vue-dialog-button:not(:first-of-type) {\n  border-left: 1px solid #eee;\n}\n",""])},function(e,t,n){"use strict";n.r(t);var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:t.overlayTransition}},[t.visibility.overlay?n("div",{ref:"overlay",class:t.overlayClass,attrs:{"aria-expanded":t.visibility.overlay.toString(),"data-modal":t.name}},[n("div",{staticClass:"v--modal-background-click",on:{mousedown:function(e){return e.target!==e.currentTarget?null:t.handleBackgroundClick(e)},touchstart:function(e){return e.target!==e.currentTarget?null:t.handleBackgroundClick(e)}}},[n("div",{staticClass:"v--modal-top-right"},[t._t("top-right")],2),t._v(" "),n("transition",{attrs:{name:t.transition},on:{"before-enter":t.beforeTransitionEnter,"after-enter":t.afterTransitionEnter,"after-leave":t.afterTransitionLeave}},[t.visibility.modal?n("div",{ref:"modal",class:t.modalClass,style:t.modalStyle},[t._t("default"),t._v(" "),t.resizable&&!t.isAutoHeight?n("resizer",{attrs:{"min-width":t.minWidth,"min-height":t.minHeight},on:{resize:t.handleModalResize}}):t._e()],2):t._e()])],1)]):t._e()])},o=function(){var e=this.$createElement;return(this._self._c||e)("div",{class:this.className})};o._withStripped=i._withStripped=!0;var s=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0;return function(){return(e++).toString()}}(),u=function(e,t,n){return n<e?e:t<n?t:n},r=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return function(o){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,i;t=o,i=r[n=e],n in t?Object.defineProperty(t,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[n]=i})}return o}({id:s(),timestamp:Date.now(),canceled:!1},e)},a={name:"VueJsModalResizer",props:{minHeight:{type:Number,default:0},minWidth:{type:Number,default:0}},data:function(){return{clicked:!1,size:{}}},mounted:function(){this.$el.addEventListener("mousedown",this.start,!1)},computed:{className:function(){return{"vue-modal-resizer":!0,clicked:this.clicked}}},methods:{start:function(e){this.clicked=!0,window.addEventListener("mousemove",this.mousemove,!1),window.addEventListener("mouseup",this.stop,!1),e.stopPropagation(),e.preventDefault()},stop:function(){this.clicked=!1,window.removeEventListener("mousemove",this.mousemove,!1),window.removeEventListener("mouseup",this.stop,!1),this.$emit("resize-stop",{element:this.$el.parentElement,size:this.size})},mousemove:function(e){this.resize(e)},resize:function(e){var t=this.$el.parentElement;if(t){var n=e.clientX-t.offsetLeft,i=e.clientY-t.offsetTop;n=u(this.minWidth,window.innerWidth,n),i=u(this.minHeight,window.innerHeight,i),this.size={width:n,height:i},t.style.width=n+"px",t.style.height=i+"px",this.$emit("resize",{element:t,size:this.size})}}}};n(5);function l(e,t,n,i,o,r,a,s){var l,d="function"==typeof e?e.options:e;if(t&&(d.render=t,d.staticRenderFns=n,d._compiled=!0),i&&(d.functional=!0),r&&(d._scopeId="data-v-"+r),a?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),o&&o.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(a)},d._ssrRegister=l):o&&(l=s?function(){o.call(this,this.$root.$options.shadowRoot)}:o),l)if(d.functional){d._injectStyles=l;var u=d.render;d.render=function(e,t){return l.call(t),u(e,t)}}else{var c=d.beforeCreate;d.beforeCreate=c?[].concat(c,l):[l]}return{exports:e,options:d}}var d=l(a,o,[],!1,null,null,null);d.options.__file="src/Resizer.vue";var c=d.exports;function h(e){return(h="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var f="[-+]?[0-9]*.?[0-9]+",p=[{name:"px",regexp:new RegExp("^".concat(f,"px$"))},{name:"%",regexp:new RegExp("^".concat(f,"%$"))},{name:"px",regexp:new RegExp("^".concat(f,"$"))}],v=function(e){switch(h(e)){case"number":return{type:"px",value:e};case"string":return function(e){if("auto"===e)return{type:e,value:0};for(var t=0;t<p.length;t++){var n=p[t];if(n.regexp.test(e))return{type:n.name,value:parseFloat(e)}}return{type:"",value:e}}(e);default:return{type:"",value:e}}},m=function(e){if("string"!=typeof e)return 0<=e;var t=v(e);return("%"===t.type||"px"===t.type)&&0<t.value};var g={name:"VueJsModal",props:{name:{required:!0,type:String},delay:{type:Number,default:0},resizable:{type:Boolean,default:!1},adaptive:{type:Boolean,default:!1},draggable:{type:[Boolean,String],default:!1},scrollable:{type:Boolean,default:!1},reset:{type:Boolean,default:!1},overlayTransition:{type:String,default:"overlay-fade"},transition:{type:String},clickToClose:{type:Boolean,default:!0},classes:{type:[String,Array],default:"v--modal"},minWidth:{type:Number,default:0,validator:function(e){return 0<=e}},minHeight:{type:Number,default:0,validator:function(e){return 0<=e}},maxWidth:{type:Number,default:1/0},maxHeight:{type:Number,default:1/0},width:{type:[Number,String],default:600,validator:m},height:{type:[Number,String],default:300,validator:function(e){return"auto"===e||m(e)}},pivotX:{type:Number,default:.5,validator:function(e){return 0<=e&&e<=1}},pivotY:{type:Number,default:.5,validator:function(e){return 0<=e&&e<=1}}},components:{Resizer:c},data:function(){return{visible:!1,visibility:{modal:!1,overlay:!1},shift:{left:0,top:0},modal:{width:0,widthType:"px",height:0,heightType:"px",renderedHeight:0},window:{width:0,height:0},mutationObserver:null}},created:function(){this.setInitialSize()},beforeMount:function(){var t=this;if(T.event.$on("toggle",this.handleToggleEvent),window.addEventListener("resize",this.handleWindowResize),this.handleWindowResize(),this.scrollable&&!this.isAutoHeight&&console.warn('Modal "'.concat(this.name,'" has scrollable flag set to true ')+'but height is not "auto" ('.concat(this.height,")")),this.isAutoHeight){var e=function(){if("undefined"!=typeof window)for(var e=["","WebKit","Moz","O","Ms"],t=0;t<e.length;t++){var n=e[t]+"MutationObserver";if(n in window)return window[n]}return!1}();e&&(this.mutationObserver=new e(function(e){t.updateRenderedHeight()}))}this.clickToClose&&window.addEventListener("keyup",this.handleEscapeKeyUp)},beforeDestroy:function(){T.event.$off("toggle",this.handleToggleEvent),window.removeEventListener("resize",this.handleWindowResize),this.clickToClose&&window.removeEventListener("keyup",this.handleEscapeKeyUp),this.scrollable&&document.body.classList.remove("v--modal-block-scroll")},computed:{isAutoHeight:function(){return"auto"===this.modal.heightType},position:function(){var e=this.window,t=this.shift,n=this.pivotX,i=this.pivotY,o=this.trueModalWidth,r=this.trueModalHeight,a=e.width-o,s=e.height-r,l=t.left+n*a,d=t.top+i*s;return{left:parseInt(u(0,a,l)),top:parseInt(u(0,s,d))}},trueModalWidth:function(){var e=this.window,t=this.modal,n=this.adaptive,i=this.minWidth,o=this.maxWidth,r="%"===t.widthType?e.width/100*t.width:t.width,a=Math.min(e.width,o);return n?u(i,a,r):r},trueModalHeight:function(){var e=this.window,t=this.modal,n=this.isAutoHeight,i=this.adaptive,o=this.maxHeight,r="%"===t.heightType?e.height/100*t.height:t.height;if(n)return this.modal.renderedHeight;var a=Math.min(e.height,o);return i?u(this.minHeight,a,r):r},overlayClass:function(){return{"v--modal-overlay":!0,scrollable:this.scrollable&&this.isAutoHeight}},modalClass:function(){return["v--modal-box",this.classes]},modalStyle:function(){return{top:this.position.top+"px",left:this.position.left+"px",width:this.trueModalWidth+"px",height:this.isAutoHeight?"auto":this.trueModalHeight+"px"}}},watch:{visible:function(e){var t=this;e?(this.visibility.overlay=!0,setTimeout(function(){t.visibility.modal=!0,t.$nextTick(function(){t.addDraggableListeners(),t.callAfterEvent(!0)})},this.delay)):(this.visibility.modal=!1,setTimeout(function(){t.visibility.overlay=!1,t.$nextTick(function(){t.removeDraggableListeners(),t.callAfterEvent(!1)})},this.delay))}},methods:{handleToggleEvent:function(e,t,n){if(this.name===e){var i=void 0===t?!this.visible:t;this.toggle(i,n)}},setInitialSize:function(){var e=this.modal,t=v(this.width),n=v(this.height);e.width=t.value,e.widthType=t.type,e.height=n.value,e.heightType=n.type},handleEscapeKeyUp:function(e){27===e.which&&this.visible&&this.$modal.hide(this.name)},handleWindowResize:function(){this.window.width=window.innerWidth,this.window.height=window.innerHeight},createModalEvent:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};return r(function(o){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,i;t=o,i=r[n=e],n in t?Object.defineProperty(t,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[n]=i})}return o}({name:this.name,ref:this.$refs.modal},e))},handleModalResize:function(e){this.modal.widthType="px",this.modal.width=e.size.width,this.modal.heightType="px",this.modal.height=e.size.height;var t=this.modal.size;this.$emit("resize",this.createModalEvent({size:t}))},toggle:function(e,t){var n=this.reset,i=this.scrollable,o=this.visible;if(o!==e){var r=o?"before-close":"before-open";"before-open"===r?(document.activeElement&&"BODY"!==document.activeElement.tagName&&document.activeElement.blur&&document.activeElement.blur(),n&&(this.setInitialSize(),this.shift.left=0,this.shift.top=0),i&&document.body.classList.add("v--modal-block-scroll")):i&&document.body.classList.remove("v--modal-block-scroll");var a=!1,s=this.createModalEvent({stop:function(){a=!0},state:e,params:t});this.$emit(r,s),a||(this.visible=e)}},getDraggableElement:function(){var e="string"!=typeof this.draggable?".v--modal-box":this.draggable;return e?this.$refs.overlay.querySelector(e):null},handleBackgroundClick:function(){this.clickToClose&&this.toggle(!1)},callAfterEvent:function(e){e?this.connectObserver():this.disconnectObserver();var t=e?"opened":"closed",n=this.createModalEvent({state:e});this.$emit(t,n)},addDraggableListeners:function(){var r=this;if(this.draggable){var e=this.getDraggableElement();if(e){var a=0,s=0,l=0,d=0,u=function(e){return e.touches&&0<e.touches.length?e.touches[0]:e},t=function(e){var t=e.target;if(!t||"INPUT"!==t.nodeName){var n=u(e),i=n.clientX,o=n.clientY;document.addEventListener("mousemove",c),document.addEventListener("touchmove",c),document.addEventListener("mouseup",h),document.addEventListener("touchend",h),a=i,s=o,l=r.shift.left,d=r.shift.top}},c=function(e){var t=u(e),n=t.clientX,i=t.clientY;r.shift.left=l+n-a,r.shift.top=d+i-s,e.preventDefault()},h=function e(t){document.removeEventListener("mousemove",c),document.removeEventListener("touchmove",c),document.removeEventListener("mouseup",e),document.removeEventListener("touchend",e),t.preventDefault()};e.addEventListener("mousedown",t),e.addEventListener("touchstart",t)}}},removeDraggableListeners:function(){},updateRenderedHeight:function(){this.$refs.modal&&(this.modal.renderedHeight=this.$refs.modal.getBoundingClientRect().height)},connectObserver:function(){this.mutationObserver&&this.mutationObserver.observe(this.$refs.overlay,{childList:!0,attributes:!0,subtree:!0})},disconnectObserver:function(){this.mutationObserver&&this.mutationObserver.disconnect()},beforeTransitionEnter:function(){this.connectObserver()},afterTransitionEnter:function(){},afterTransitionLeave:function(){}}},b=(n(7),l(g,i,[],!1,null,null,null));b.options.__file="src/Modal.vue";var y=b.exports,w=function(){var n=this,e=n.$createElement,i=n._self._c||e;return i("modal",{attrs:{name:"dialog",height:"auto",classes:["v--modal","vue-dialog",this.params.class],width:n.width,"pivot-y":.3,adaptive:!0,clickToClose:n.clickToClose,transition:n.transition},on:{"before-open":n.beforeOpened,"before-close":n.beforeClosed,opened:function(e){n.$emit("opened",e)},closed:function(e){n.$emit("closed",e)}}},[i("div",{staticClass:"dialog-content"},[n.params.title?i("div",{staticClass:"dialog-c-title",domProps:{innerHTML:n._s(n.params.title||"")}}):n._e(),n._v(" "),n.params.component?i(n.params.component,n._b({tag:"component"},"component",n.params.props,!1)):i("div",{staticClass:"dialog-c-text",domProps:{innerHTML:n._s(n.params.text||"")}})],1),n._v(" "),n.buttons?i("div",{staticClass:"vue-dialog-buttons"},n._l(n.buttons,function(e,t){return i("button",{key:t,class:e.class||"vue-dialog-button",style:n.buttonStyle,attrs:{type:"button"},domProps:{innerHTML:n._s(e.title)},on:{click:function(e){e.stopPropagation(),n.click(t,e)}}},[n._v("\n      "+n._s(e.title)+"\n    ")])})):i("div",{staticClass:"vue-dialog-buttons-none"})])};w._withStripped=!0;var x={name:"VueJsDialog",props:{width:{type:[Number,String],default:400},clickToClose:{type:Boolean,default:!0},transition:{type:String,default:"fade"}},data:function(){return{params:{},defaultButtons:[{title:"CLOSE"}]}},computed:{buttons:function(){return this.params.buttons||this.defaultButtons},buttonStyle:function(){return{flex:"1 1 ".concat(100/this.buttons.length,"%")}}},methods:{beforeOpened:function(e){window.addEventListener("keyup",this.onKeyUp),this.params=e.params||{},this.$emit("before-opened",e)},beforeClosed:function(e){window.removeEventListener("keyup",this.onKeyUp),this.params={},this.$emit("before-closed",e)},click:function(e,t){var n=2<arguments.length&&void 0!==arguments[2]?arguments[2]:"click",i=this.buttons[e];i&&"function"==typeof i.handler?i.handler(e,t,{source:n}):this.$modal.hide("dialog")},onKeyUp:function(e){if(13===e.which&&0<this.buttons.length){var t=1===this.buttons.length?0:this.buttons.findIndex(function(e){return e.default});-1!==t&&this.click(t,e,"keypress")}}}},_=(n(9),l(x,w,[],!1,null,null,null));_.options.__file="src/Dialog.vue";var E=_.exports,k=function(){var n=this,e=n.$createElement,i=n._self._c||e;return i("div",{attrs:{id:"modals-container"}},n._l(n.modals,function(t){return i("modal",n._g(n._b({key:t.id,on:{closed:function(e){n.remove(t.id)}}},"modal",t.modalAttrs,!1),t.modalListeners),[i(t.component,n._g(n._b({tag:"component",on:{close:function(e){n.$modal.hide(t.modalAttrs.name)}}},"component",t.componentAttrs,!1),n.$listeners))],1)}))};k._withStripped=!0;var S=l({data:function(){return{modals:[]}},created:function(){this.$root._dynamicContainer=this},methods:{add:function(e){var t=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:{},o=3<arguments.length?arguments[3]:void 0,r=s(),a=i.name||"_dynamic_modal_"+r;this.modals.push({id:r,modalAttrs:function(o){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{},t=Object.keys(r);"function"==typeof Object.getOwnPropertySymbols&&(t=t.concat(Object.getOwnPropertySymbols(r).filter(function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable}))),t.forEach(function(e){var t,n,i;t=o,i=r[n=e],n in t?Object.defineProperty(t,n,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[n]=i})}return o}({},i,{name:a}),modalListeners:o,component:e,componentAttrs:n}),this.$nextTick(function(){t.$modal.show(a)})},remove:function(e){for(var t in this.modals)if(this.modals[t].id===e)return void this.modals.splice(t,1)}}},k,[],!1,null,null,null);S.options.__file="src/ModalsContainer.vue";var C=S.exports,O={install:function(a){var s=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};this.installed||(this.installed=!0,this.event=new a,this.rootInstance=null,this.componentName=s.componentName||"Modal",a.prototype.$modal={show:function(e,t,n){var i=3<arguments.length&&void 0!==arguments[3]?arguments[3]:{};if("string"!=typeof e){var o=n&&n.root?n.root:O.rootInstance,r=function(e,t,n){if(!n._dynamicContainer&&t.injectModalsContainer){var i=document.createElement("div");document.body.appendChild(i),new e({parent:n,render:function(e){return e(C)}}).$mount(i)}return n._dynamicContainer}(a,s,o);r?r.add(e,t,n,i):console.warn("[vue-js-modal] In order to render dynamic modals, a <modals-container> component must be present on the page")}else O.event.$emit("toggle",e,!0,t)},hide:function(e,t){O.event.$emit("toggle",e,!1,t)},toggle:function(e,t){O.event.$emit("toggle",e,void 0,t)}},a.component(this.componentName,y),s.dialog&&a.component("VDialog",E),s.dynamic&&(a.component("ModalsContainer",C),a.mixin({beforeMount:function(){null===O.rootInstance&&(O.rootInstance=this.$root)}})))}};var T=t.default=O}])});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-js-toggle-button"] = factory();
	else
		root["vue-js-toggle-button"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(6),
  /* scopeId */
  "data-v-25adc6c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEFAULT_COLOR_CHECKED = '#75c791';
var DEFAULT_COLOR_UNCHECKED = '#bfcbd9';
var DEFAULT_LABEL_CHECKED = 'on';
var DEFAULT_LABEL_UNCHECKED = 'off';
var DEFAULT_SWITCH_COLOR = '#fff';
var MARGIN = 3;

var contains = function contains(object, title) {
  return (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.hasOwnProperty(title);
};

var px = function px(v) {
  return v + 'px';
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    sync: {
      type: Boolean,
      default: false
    },
    speed: {
      type: Number,
      default: 300
    },
    color: {
      type: [String, Object],
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked || value.disabled : typeof value === 'string';
      }
    },
    switchColor: {
      type: [String, Object],
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'string';
      }
    },
    cssColors: {
      type: Boolean,
      default: false
    },
    labels: {
      type: [Boolean, Object],
      default: false,
      validator: function validator(value) {
        return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value.checked || value.unchecked : typeof value === 'boolean';
      }
    },
    height: {
      type: Number,
      default: 22
    },
    width: {
      type: Number,
      default: 50
    },
    fontSize: {
      type: Number
    }
  },
  computed: {
    className: function className() {
      var toggled = this.toggled,
          disabled = this.disabled;


      return ['vue-js-switch', { toggled: toggled, disabled: disabled }];
    },
    coreStyle: function coreStyle() {
      return {
        width: px(this.width),
        height: px(this.height),
        backgroundColor: this.cssColors ? null : this.disabled ? this.colorDisabled : this.colorCurrent,
        borderRadius: px(Math.round(this.height / 2))
      };
    },
    buttonRadius: function buttonRadius() {
      return this.height - MARGIN * 2;
    },
    distance: function distance() {
      return px(this.width - this.height + MARGIN);
    },
    buttonStyle: function buttonStyle() {
      var transition = 'transform ' + this.speed + 'ms';

      var transform = this.toggled ? 'translate3d(' + this.distance + ', 3px, 0px)' : null;

      var background = this.switchColor ? this.switchColorCurrent : null;

      return {
        width: px(this.buttonRadius),
        height: px(this.buttonRadius),
        transition: transition,
        transform: transform,
        background: background
      };
    },
    labelStyle: function labelStyle() {
      return {
        lineHeight: px(this.height),
        fontSize: this.fontSize ? px(this.fontSize) : null
      };
    },
    colorChecked: function colorChecked() {
      var color = this.color;


      if ((typeof color === 'undefined' ? 'undefined' : _typeof(color)) !== 'object') {
        return color || DEFAULT_COLOR_CHECKED;
      }

      return contains(color, 'checked') ? color.checked : DEFAULT_COLOR_CHECKED;
    },
    colorUnchecked: function colorUnchecked() {
      var color = this.color;


      return contains(color, 'unchecked') ? color.unchecked : DEFAULT_COLOR_UNCHECKED;
    },
    colorDisabled: function colorDisabled() {
      var color = this.color;


      return contains(color, 'disabled') ? color.disabled : this.colorCurrent;
    },
    colorCurrent: function colorCurrent() {
      return this.toggled ? this.colorChecked : this.colorUnchecked;
    },
    labelChecked: function labelChecked() {
      var labels = this.labels;


      return contains(labels, 'checked') ? labels.checked : DEFAULT_LABEL_CHECKED;
    },
    labelUnchecked: function labelUnchecked() {
      var labels = this.labels;


      return contains(labels, 'unchecked') ? labels.unchecked : DEFAULT_LABEL_UNCHECKED;
    },
    switchColorChecked: function switchColorChecked() {
      var switchColor = this.switchColor;


      return contains(switchColor, 'checked') ? switchColor.checked : DEFAULT_SWITCH_COLOR;
    },
    switchColorUnchecked: function switchColorUnchecked() {
      var switchColor = this.switchColor;


      return contains(switchColor, 'unchecked') ? switchColor.unchecked : DEFAULT_SWITCH_COLOR;
    },
    switchColorCurrent: function switchColorCurrent() {
      var switchColor = this.switchColor;


      if ((typeof switchColor === 'undefined' ? 'undefined' : _typeof(switchColor)) !== 'object') {
        return switchColor || DEFAULT_SWITCH_COLOR;
      }

      return this.toggled ? this.switchColorChecked : this.switchColorUnchecked;
    }
  },
  watch: {
    value: function value(_value) {
      if (this.sync) {
        this.toggled = !!_value;
      }
    }
  },
  data: function data() {
    return {
      toggled: !!this.value
    };
  },

  methods: {
    toggle: function toggle(event) {
      this.toggled = !this.toggled;
      this.$emit('input', this.toggled);
      this.$emit('change', {
        value: this.toggled,
        srcEvent: event
      });
    }
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Button_vue__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ToggleButton", function() { return __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a; });


var installed = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    if (installed) {
      return;
    }

    Vue.component('ToggleButton', __WEBPACK_IMPORTED_MODULE_0__Button_vue___default.a);
    installed = true;
  }
});



/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4)();
// imports


// module
exports.push([module.i, ".vue-js-switch[data-v-25adc6c0]{display:inline-block;position:relative;overflow:hidden;vertical-align:middle;user-select:none;font-size:10px;cursor:pointer}.vue-js-switch .v-switch-input[data-v-25adc6c0]{opacity:0;position:absolute;width:1px;height:1px}.vue-js-switch .v-switch-label[data-v-25adc6c0]{position:absolute;top:0;font-weight:600;color:#fff;z-index:1}.vue-js-switch .v-switch-label.v-left[data-v-25adc6c0]{left:10px}.vue-js-switch .v-switch-label.v-right[data-v-25adc6c0]{right:10px}.vue-js-switch .v-switch-core[data-v-25adc6c0]{display:block;position:relative;box-sizing:border-box;outline:0;margin:0;transition:border-color .3s,background-color .3s;user-select:none}.vue-js-switch .v-switch-core .v-switch-button[data-v-25adc6c0]{display:block;position:absolute;overflow:hidden;top:0;left:0;transform:translate3d(3px,3px,0);border-radius:100%;background-color:#fff;z-index:2}.vue-js-switch.disabled[data-v-25adc6c0]{pointer-events:none;opacity:.6}", ""]);

// exports


/***/ }),
/* 4 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.className
  }, [_c('input', {
    staticClass: "v-switch-input",
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-switch-core",
    style: (_vm.coreStyle)
  }, [_c('div', {
    staticClass: "v-switch-button",
    style: (_vm.buttonStyle)
  })]), _vm._v(" "), (_vm.labels) ? [(_vm.toggled) ? _c('span', {
    staticClass: "v-switch-label v-left",
    style: (_vm.labelStyle)
  }, [_vm._t("checked", [
    [_vm._v(_vm._s(_vm.labelChecked))]
  ])], 2) : _c('span', {
    staticClass: "v-switch-label v-right",
    style: (_vm.labelStyle)
  }, [_vm._t("unchecked", [
    [_vm._v(_vm._s(_vm.labelUnchecked))]
  ])], 2)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(8)("2283861f", content, true);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(9)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
/******/ ]);
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * pretty-checkbox-vue v1.1.9
 * (c) 2017-2018 Hamed Ehtesham
 * Released under the MIT License.
 */
!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("pretty-checkbox-vue",[],t):"object"==typeof exports?exports["pretty-checkbox-vue"]=t():e["pretty-checkbox-vue"]=t()}("undefined"!=typeof self?self:this,function(){return function(e){var t={};function i(n){if(t[n])return t[n].exports;var s=t[n]={i:n,l:!1,exports:{}};return e[n].call(s.exports,s,s.exports,i),s.l=!0,s.exports}return i.m=e,i.c=t,i.d=function(e,t,n){i.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n})},i.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return i.d(t,"a",t),t},i.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},i.p="",i(i.s=2)}([function(e,t,i){var n=i(1)(i(3),i(4),!1,null,null,null);n.options.__file="src/PrettyInput.vue",e.exports=n.exports},function(e,t){e.exports=function(e,t,i,n,s,r){var o,u=e=e||{},a=typeof e.default;"object"!==a&&"function"!==a||(o=e,u=e.default);var l,h="function"==typeof u?u.options:u;if(t&&(h.render=t.render,h.staticRenderFns=t.staticRenderFns,h._compiled=!0),i&&(h.functional=!0),s&&(h._scopeId=s),r?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),n&&n.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},h._ssrRegister=l):n&&(l=n),l){var d=h.functional,c=d?h.render:h.beforeCreate;d?(h._injectStyles=l,h.render=function(e,t){return l.call(t),c(e,t)}):h.beforeCreate=c?[].concat(c,l):[l]}return{esModule:o,exports:u,options:h}}},function(e,t,i){var n=i(0),s=i(5),r=i(7);e.exports={install:function(e,t){e.component("p-input",n),e.component("p-check",s),e.component("p-radio",r)}}},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"pretty-input",model:{prop:"modelValue",event:"change"},props:{type:String,name:String,value:{},modelValue:{},trueValue:{},falseValue:{},checked:{},disabled:{},required:{},indeterminate:{},color:String,offColor:String,hoverColor:String,indeterminateColor:String,toggle:{},hover:{},focus:{}},data:function(){return{m_checked:void 0,default_mode:!1}},computed:{_type:function(){return this.$options.input_type?this.$options.input_type:this.type?this.type:"checkbox"},shouldBeChecked:function(){return void 0!==this.modelValue?"radio"===this._type?this.modelValue===this.value:this.modelValue instanceof Array?this.modelValue.includes(this.value):this._trueValue?this.modelValue===this.trueValue:"string"==typeof this.modelValue||!!this.modelValue:void 0===this.m_checked?this.m_checked="string"==typeof this.checked||!!this.checked:this.m_checked},_disabled:function(){return"string"==typeof this.disabled||!!this.disabled},_required:function(){return"string"==typeof this.required||!!this.required},_indeterminate:function(){return"string"==typeof this.indeterminate||!!this.indeterminate},_trueValue:function(){return"string"==typeof this.trueValue?this.trueValue:!!this.trueValue},_falseValue:function(){return"string"==typeof this.falseValue?this.falseValue:!!this.falseValue},_toggle:function(){return"string"==typeof this.toggle||!!this.toggle},_hover:function(){return"string"==typeof this.hover||!!this.hover},_focus:function(){return"string"==typeof this.focus||!!this.focus},classes:function(){return{pretty:!0,"p-default":this.default_mode,"p-round":"radio"===this._type&&this.default_mode,"p-toggle":this._toggle,"p-has-hover":this._hover,"p-has-focus":this._focus,"p-has-indeterminate":this._indeterminate}},onClasses:function(){var e={state:!0,"p-on":this._toggle};return this.color&&(e["p-"+this.color]=!0),e},offClasses:function(){var e={state:!0,"p-off":!0};return this.offColor&&(e["p-"+this.offColor]=!0),e},hoverClasses:function(){var e={state:!0,"p-is-hover":!0};return this.hoverColor&&(e["p-"+this.hoverColor]=!0),e},indeterminateClasses:function(){var e={state:!0,"p-is-indeterminate":!0};return this.indeterminateColor&&(e["p-"+this.indeterminateColor]=!0),e}},watch:{checked:function(e){this.m_checked=e},indeterminate:function(e){this.$refs.input.indeterminate=e}},mounted:function(){this.$vnode.data&&!this.$vnode.data.staticClass&&(this.default_mode=!0),this._indeterminate&&(this.$refs.input.indeterminate=!0),this.$el.setAttribute("p-"+this._type,"")},methods:{updateInput:function(e){if("radio"!==this._type){this.$emit("update:indeterminate",!1);var t=e.target.checked;if(this.m_checked=t,this.modelValue instanceof Array){var i=[].concat(function(e){if(Array.isArray(e)){for(var t=0,i=Array(e.length);t<e.length;t++)i[t]=e[t];return i}return Array.from(e)}(this.modelValue));t?i.push(this.value):i.splice(i.indexOf(this.value),1),this.$emit("change",i)}else this.$emit("change",t?!this._trueValue||this.trueValue:!!this._falseValue&&this.falseValue)}else this.$emit("change",this.value)}}}},function(e,t,i){var n=function(){var e=this.$createElement,t=this._self._c||e;return t("div",{class:this.classes},[t("input",{ref:"input",attrs:{type:this._type,name:this.name,disabled:this._disabled,required:this._required},domProps:{checked:this.shouldBeChecked,value:this.value},on:{change:this.updateInput}}),this._v(" "),t("div",{class:this.onClasses},[this._t("extra"),this._v(" "),t("label",[this._t("default")],2)],2),this._v(" "),this._toggle?t("div",{class:this.offClasses},[this._t("off-extra"),this._v(" "),this._t("off-label")],2):this._e(),this._v(" "),this._hover?t("div",{class:this.hoverClasses},[this._t("hover-extra"),this._v(" "),this._t("hover-label")],2):this._e(),this._v(" "),this._indeterminate?t("div",{class:this.indeterminateClasses},[this._t("indeterminate-extra"),this._v(" "),this._t("indeterminate-label")],2):this._e()])};n._withStripped=!0,e.exports={render:n,staticRenderFns:[]}},function(e,t,i){var n=i(1)(i(6),null,!1,null,null,null);n.options.__file="src/PrettyCheckbox.vue",e.exports=n.exports},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=i(0),s={name:"pretty-checkbox",input_type:"checkbox",model:n.model,props:n.props,data:n.data,computed:n.computed,watch:n.watch,mounted:n.mounted,methods:n.methods,render:n.render};t.default=s},function(e,t,i){var n=i(1)(i(8),null,!1,null,null,null);n.options.__file="src/PrettyRadio.vue",e.exports=n.exports},function(e,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=i(0),s={name:"pretty-radio",input_type:"radio",model:n.model,props:n.props,data:n.data,computed:n.computed,watch:n.watch,mounted:n.mounted,methods:n.methods,render:n.render};t.default=s}])});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Vuelidate = Vuelidate;
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _params.withParams;
  }
});
exports.default = exports.validationMixin = void 0;

var _vval = __webpack_require__(254);

var _params = __webpack_require__(29);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var NIL = function NIL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (_typeof(val) === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');

  for (var i = 0; i < path.length; i++) {
    if (obj && _typeof(obj) === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';

function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true,
      v: false
    }
  });
  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });
  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $anyDirty: function $anyDirty() {
    var _this3 = this;

    if (this.dirty) {
      return true;
    }

    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$anyDirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $anyError: function $anyError() {
    return this.$anyDirty && !this.$pending && this.$invalid;
  },
  $pending: function $pending() {
    var _this4 = this;

    return this.ruleKeys.some(function (key) {
      return _this4.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this4.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this5 = this;

    var vals = this.validations;
    return _objectSpread({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), buildFromKeys(this.ruleKeys, function (key) {
      return _this5.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];

    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();

        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }

        params = params.concat(childParams);
      } else {
        params.push({
          path: [],
          name: key,
          params: this.$params[key]
        });
      }
    }

    return params;
  }
};
var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);
var _cachedComponent = null;

var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};

        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });

        return refs;
      }
    },
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
        this._vval = null;
      }
    },
    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();

        if (model) {
          return model[key];
        }
      },
      hasIter: function hasIter() {
        return false;
      }
    }
  });
  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: {
      runRule: function runRule(parent) {
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;
        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;
        return {
          output: output,
          params: params
        };
      }
    },
    computed: {
      run: function run() {
        var _this6 = this;

        var parent = this.lazyParentModel();

        var isArrayDependant = Array.isArray(parent) && parent.__ob__;

        if (isArrayDependant) {
          var arrayDep = parent.__ob__.dep;
          arrayDep.depend();
          var target = arrayDep.constructor.target;

          if (!this._indirectWatcher) {
            var Watcher = target.constructor;
            this._indirectWatcher = new Watcher(this, function () {
              return _this6.runRule(parent);
            }, null, {
              lazy: true
            });
          }

          var model = this.getModel();

          if (!this._indirectWatcher.dirty && this._lastModel === model) {
            this._indirectWatcher.depend();

            return target.value;
          }

          this._lastModel = model;

          this._indirectWatcher.evaluate();

          this._indirectWatcher.depend();
        } else if (this._indirectWatcher) {
          this._indirectWatcher.teardown();

          this._indirectWatcher = null;
        }

        return this._indirectWatcher ? this._indirectWatcher.value : this.runRule(parent);
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }

        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;

        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }

        return false;
      }
    },
    destroyed: function destroyed() {
      if (this._indirectWatcher) {
        this._indirectWatcher.teardown();

        this._indirectWatcher = null;
      }
    }
  });
  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },
    methods: _objectSpread({}, validationMethods, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _objectSpread({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this7 = this;

        return this.keys.filter(function (k) {
          return !_this7.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this8 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8.refProxy(key);
            }
          };
        });
        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this8[key];
            }
          };
        });
        var iterDefs = this.hasIter() ? {
          $iter: {
            enumerable: true,
            value: Object.defineProperties({}, _objectSpread({}, keyDefs))
          }
        } : {};
        return Object.defineProperties({}, _objectSpread({}, keyDefs, iterDefs, {
          $model: {
            enumerable: true,
            get: function get() {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                return parent[_this8.prop];
              } else {
                return null;
              }
            },
            set: function set(value) {
              var parent = _this8.lazyParentModel();

              if (parent != null) {
                parent[_this8.prop] = value;

                _this8.$touch();
              }
            }
          }
        }, getterDefs, methodDefs));
      },
      children: function children() {
        var _this9 = this;

        return _toConsumableArray(this.nestedKeys.map(function (key) {
          return renderNested(_this9, key);
        })).concat(_toConsumableArray(this.ruleKeys.map(function (key) {
          return renderRule(_this9, key);
        }))).filter(Boolean);
      }
    })
  });
  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            return vm.validations[key]() || false;
          }

        };
      }
    }
  });
  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();

        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this10 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return "".concat(getPath(_this10.rootModel, _this10.getModelKey(key), trackBy));
        } : function (x) {
          return "".concat(x);
        };
      },
      getModelLazy: function getModelLazy() {
        var _this11 = this;

        return function () {
          return _this11.getModel();
        };
      },
      children: function children() {
        var _this12 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _objectSpread({}, def);

        delete validations['$trackBy'];
        var usedTracks = {};
        return this.keys.map(function (key) {
          var track = _this12.tracker(key);

          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }

          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this12.getModelLazy,
            model: model[key],
            rootModel: _this12.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      },
      hasIter: function hasIter() {
        return true;
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }

    var validations = vm.validations[key];

    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NIL,
        prop: key,
        lazyModel: NIL,
        rootModel: root
      });
    }

    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = {
    VBase: VBase,
    Validation: Validation
  };
  return _cachedComponent;
};

var _cachedVue = null;

function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;

  while (Vue.super) {
    Vue = Vue.super;
  }

  _cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;
        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NIL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;

    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }

    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;

    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();

      this._vuelidate = null;
    }
  }
};
exports.validationMixin = validationMixin;

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

var _default = Vuelidate;
exports.default = _default;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({
    data: vval.args
  });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);

  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};

  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }

  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx, idxInOld, elmToMove;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx];
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;

      if (isUndef(idxInOld)) {
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];

        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }

  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];

    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }

  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return {
    tag: tag,
    key: key,
    args: args
  };
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-swal v1.0.0
 * (c) 2018 Antério Vieira
 * Released under the MIT License.
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueSwal"] = factory();
	else
		root["VueSwal"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.swal=e():t.swal=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=8)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o="swal-button";e.CLASS_NAMES={MODAL:"swal-modal",OVERLAY:"swal-overlay",SHOW_MODAL:"swal-overlay--show-modal",MODAL_TITLE:"swal-title",MODAL_TEXT:"swal-text",ICON:"swal-icon",ICON_CUSTOM:"swal-icon--custom",CONTENT:"swal-content",FOOTER:"swal-footer",BUTTON_CONTAINER:"swal-button-container",BUTTON:o,CONFIRM_BUTTON:o+"--confirm",CANCEL_BUTTON:o+"--cancel",DANGER_BUTTON:o+"--danger",BUTTON_LOADING:o+"--loading",BUTTON_LOADER:o+"__loader"},e.default=e.CLASS_NAMES},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=function(t){var e="."+t;return document.querySelector(e)},e.stringToNode=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},e.insertAfter=function(t,e){var n=e.nextSibling;e.parentNode.insertBefore(t,n)},e.removeNode=function(t){t.parentElement.removeChild(t)},e.throwErr=function(t){throw t=t.replace(/ +(?= )/g,""),"SweetAlert: "+(t=t.trim())},e.isPlainObject=function(t){if("[object Object]"!==Object.prototype.toString.call(t))return!1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype},e.ordinalSuffixOf=function(t){var e=t%10,n=t%100;return 1===e&&11!==n?t+"st":2===e&&12!==n?t+"nd":3===e&&13!==n?t+"rd":t+"th"}},function(t,e,n){"use strict";function o(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}Object.defineProperty(e,"__esModule",{value:!0}),o(n(25));var r=n(26);e.overlayMarkup=r.default,o(n(27)),o(n(28)),o(n(29));var i=n(0),a=i.default.MODAL_TITLE,s=i.default.MODAL_TEXT,c=i.default.ICON,l=i.default.FOOTER;e.iconMarkup='\n  <div class="'+c+'"></div>',e.titleMarkup='\n  <div class="'+a+'"></div>\n',e.textMarkup='\n  <div class="'+s+'"></div>',e.footerMarkup='\n  <div class="'+l+'"></div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1);e.CONFIRM_KEY="confirm",e.CANCEL_KEY="cancel";var r={visible:!0,text:null,value:null,className:"",closeModal:!0},i=Object.assign({},r,{visible:!1,text:"Cancel",value:null}),a=Object.assign({},r,{text:"OK",value:!0});e.defaultButtonList={cancel:i,confirm:a};var s=function(t){switch(t){case e.CONFIRM_KEY:return a;case e.CANCEL_KEY:return i;default:var n=t.charAt(0).toUpperCase()+t.slice(1);return Object.assign({},r,{text:n,value:t})}},c=function(t,e){var n=s(t);return!0===e?Object.assign({},n,{visible:!0}):"string"==typeof e?Object.assign({},n,{visible:!0,text:e}):o.isPlainObject(e)?Object.assign({visible:!0},n,e):Object.assign({},n,{visible:!1})},l=function(t){for(var e={},n=0,o=Object.keys(t);n<o.length;n++){var r=o[n],a=t[r],s=c(r,a);e[r]=s}return e.cancel||(e.cancel=i),e},u=function(t){var n={};switch(t.length){case 1:n[e.CANCEL_KEY]=Object.assign({},i,{visible:!1});break;case 2:n[e.CANCEL_KEY]=c(e.CANCEL_KEY,t[0]),n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t[1]);break;default:o.throwErr("Invalid number of 'buttons' in array ("+t.length+").\n      If you want more than 2 buttons, you need to use an object!")}return n};e.getButtonListOpts=function(t){var n=e.defaultButtonList;return"string"==typeof t?n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t):Array.isArray(t)?n=u(t):o.isPlainObject(t)?n=l(t):!0===t?n=u([!0,!0]):!1===t?n=u([!1,!1]):void 0===t&&(n=e.defaultButtonList),n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=n(0),a=i.default.MODAL,s=i.default.OVERLAY,c=n(30),l=n(31),u=n(32),f=n(33);e.injectElIntoModal=function(t){var e=o.getNode(a),n=o.stringToNode(t);return e.appendChild(n),n};var d=function(t){t.className=a,t.textContent=""},p=function(t,e){d(t);var n=e.className;n&&t.classList.add(n)};e.initModalContent=function(t){var e=o.getNode(a);p(e,t),c.default(t.icon),l.initTitle(t.title),l.initText(t.text),f.default(t.content),u.default(t.buttons,t.dangerMode)};var m=function(){var t=o.getNode(s),e=o.stringToNode(r.modalMarkup);t.appendChild(e)};e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r={isOpen:!1,promise:null,actions:{},timer:null},i=Object.assign({},r);e.resetState=function(){i=Object.assign({},r)},e.setActionValue=function(t){if("string"==typeof t)return a(o.CONFIRM_KEY,t);for(var e in t)a(e,t[e])};var a=function(t,e){i.actions[t]||(i.actions[t]={}),Object.assign(i.actions[t],{value:e})};e.setActionOptionsFor=function(t,e){var n=(void 0===e?{}:e).closeModal,o=void 0===n||n;Object.assign(i.actions[t],{closeModal:o})},e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(0),a=i.default.OVERLAY,s=i.default.SHOW_MODAL,c=i.default.BUTTON,l=i.default.BUTTON_LOADING,u=n(5);e.openModal=function(){o.getNode(a).classList.add(s),u.default.isOpen=!0};var f=function(){o.getNode(a).classList.remove(s),u.default.isOpen=!1};e.onAction=function(t){void 0===t&&(t=r.CANCEL_KEY);var e=u.default.actions[t],n=e.value;if(!1===e.closeModal){var i=c+"--"+t;o.getNode(i).classList.add(l)}else f();u.default.promise.resolve(n)},e.getState=function(){var t=Object.assign({},u.default);return delete t.promise,delete t.timer,t},e.stopLoading=function(){for(var t=document.querySelectorAll("."+c),e=0;e<t.length;e++){t[e].classList.remove(l)}}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(e){t.exports=e.sweetAlert=n(9)}).call(e,n(7))},function(t,e,n){(function(e){t.exports=e.swal=n(10)}).call(e,n(7))},function(t,e,n){"undefined"!=typeof window&&n(11),n(16);var o=n(23).default;t.exports=o},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={insertAt:"top"};r.transform=void 0;n(14)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){e=t.exports=n(13)(void 0),e.push([t.i,'.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button:not([disabled]):hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel:not([disabled]):hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger:not([disabled]):hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}',""])},function(t,e){function n(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=o(r);return[n].concat(r.sources.map(function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"})).concat([i]).join("\n")}return[n].join("\n")}function o(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var o=n(e,t);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=m[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],e))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],e));m[o.id]={id:o.id,refs:1,parts:a}}}}function r(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s=i[1],c=i[2],l=i[3],u={css:s,media:c,sourceMap:l};o[a]?o[a].parts.push(u):n.push(o[a]={id:a,parts:[u]})}return n}function i(t,e){var n=v(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=w[w.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),w.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=w.indexOf(t);e>=0&&w.splice(e,1)}function s(t){var e=document.createElement("style");return t.attrs.type="text/css",l(e,t.attrs),i(t,e),e}function c(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",l(e,t.attrs),i(t,e),e}function l(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function u(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=h++;n=g||(g=s(e)),o=f.bind(null,n,l,!1),r=f.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=c(e),o=p.bind(null,n,e),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(e),o=d.bind(null,n),r=function(){a(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}function f(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=x(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function d(t,e){var n=e.css,o=e.media;if(o&&t.setAttribute("media",o),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function p(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=y(o)),r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}var m={},b=function(t){var e;return function(){return void 0===e&&(e=t.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),v=function(t){var e={};return function(n){return void 0===e[n]&&(e[n]=t.call(this,n)),e[n]}}(function(t){return document.querySelector(t)}),g=null,h=0,w=[],y=n(15);t.exports=function(t,e){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=b()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=r(t,e);return o(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var s=n[a],c=m[s.id];c.refs--,i.push(c)}if(t){o(r(t,e),e)}for(var a=0;a<i.length;a++){var c=i[a];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete m[c.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return t;var i;return i=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:o+r.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(t,e,n){var o=n(17);"undefined"==typeof window||window.Promise||(window.Promise=o),n(21),String.prototype.includes||(String.prototype.includes=function(t,e){"use strict";return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(t,e){if(null==this)throw new TypeError('"this" is null or not defined');var n=Object(this),o=n.length>>>0;if(0===o)return!1;for(var r=0|e,i=Math.max(r>=0?r:o-Math.abs(r),0);i<o;){if(function(t,e){return t===e||"number"==typeof t&&"number"==typeof e&&isNaN(t)&&isNaN(e)}(n[i],t))return!0;i++}return!1}}),"undefined"!=typeof window&&function(t){t.forEach(function(t){t.hasOwnProperty("remove")||Object.defineProperty(t,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){this.parentNode.removeChild(this)}})})}([Element.prototype,CharacterData.prototype,DocumentType.prototype])},function(t,e,n){(function(e){!function(n){function o(){}function r(t,e){return function(){t.apply(e,arguments)}}function i(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(t,this)}function a(t,e){for(;3===t._state;)t=t._value;if(0===t._state)return void t._deferreds.push(e);t._handled=!0,i._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?s:c)(e.promise,t._value);var o;try{o=n(t._value)}catch(t){return void c(e.promise,t)}s(e.promise,o)})}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof i)return t._state=3,t._value=e,void l(t);if("function"==typeof n)return void f(r(n,e),t)}t._state=1,t._value=e,l(t)}catch(e){c(t,e)}}function c(t,e){t._state=2,t._value=e,l(t)}function l(t){2===t._state&&0===t._deferreds.length&&i._immediateFn(function(){t._handled||i._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function f(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,c(e,t))})}catch(t){if(n)return;n=!0,c(e,t)}}var d=setTimeout;i.prototype.catch=function(t){return this.then(null,t)},i.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new u(t,e,n)),n},i.all=function(t){var e=Array.prototype.slice.call(t);return new i(function(t,n){function o(i,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,function(t){o(i,t)},n)}e[i]=a,0==--r&&t(e)}catch(t){n(t)}}if(0===e.length)return t([]);for(var r=e.length,i=0;i<e.length;i++)o(i,e[i])})},i.resolve=function(t){return t&&"object"==typeof t&&t.constructor===i?t:new i(function(e){e(t)})},i.reject=function(t){return new i(function(e,n){n(t)})},i.race=function(t){return new i(function(e,n){for(var o=0,r=t.length;o<r;o++)t[o].then(e,n)})},i._immediateFn="function"==typeof e&&function(t){e(t)}||function(t){d(t,0)},i._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},i._setImmediateFn=function(t){i._immediateFn=t},i._setUnhandledRejectionFn=function(t){i._unhandledRejectionFn=t},void 0!==t&&t.exports?t.exports=i:n.Promise||(n.Promise=i)}(this)}).call(e,n(18).setImmediate)},function(t,e,n){function o(t,e){this._id=t,this._clearFn=e}var r=Function.prototype.apply;e.setTimeout=function(){return new o(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new o(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(19),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function o(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var o={callback:t,args:e};return l[c]=o,s(c),c++}function r(t){delete l[t]}function i(t){var e=t.callback,o=t.args;switch(o.length){case 0:e();break;case 1:e(o[0]);break;case 2:e(o[0],o[1]);break;case 3:e(o[0],o[1],o[2]);break;default:e.apply(n,o)}}function a(t){if(u)setTimeout(a,0,t);else{var e=l[t];if(e){u=!0;try{i(e)}finally{r(t),u=!1}}}}if(!t.setImmediate){var s,c=1,l={},u=!1,f=t.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(t);d=d&&d.setTimeout?d:t,"[object process]"==={}.toString.call(t.process)?function(){s=function(t){e.nextTick(function(){a(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&a(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),s=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){a(t.data)},s=function(e){t.port2.postMessage(e)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var t=f.documentElement;s=function(e){var n=f.createElement("script");n.onreadystatechange=function(){a(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){s=function(t){setTimeout(a,0,t)}}(),d.setImmediate=o,d.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(20))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(u===setTimeout)return setTimeout(t,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(t,0);try{return u(t,0)}catch(e){try{return u.call(null,t,0)}catch(e){return u.call(this,t,0)}}}function i(t){if(f===clearTimeout)return clearTimeout(t);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function a(){b&&p&&(b=!1,p.length?m=p.concat(m):v=-1,m.length&&s())}function s(){if(!b){var t=r(a);b=!0;for(var e=m.length;e;){for(p=m,m=[];++v<e;)p&&p[v].run();v=-1,e=m.length}p=null,b=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function l(){}var u,f,d=t.exports={};!function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(t){u=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(t){f=o}}();var p,m=[],b=!1,v=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];m.push(new c(t,e)),1!==m.length||b||r(s)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";n(22).polyfill()},function(t,e,n){"use strict";function o(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),o=1;o<arguments.length;o++){var r=arguments[o];if(void 0!==r&&null!==r)for(var i=Object.keys(Object(r)),a=0,s=i.length;a<s;a++){var c=i[a],l=Object.getOwnPropertyDescriptor(r,c);void 0!==l&&l.enumerable&&(n[c]=r[c])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:o})}t.exports={assign:o,polyfill:r}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(24),r=n(6),i=n(5),a=n(36),s=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if("undefined"!=typeof window){var n=a.getOpts.apply(void 0,t);return new Promise(function(t,e){i.default.promise={resolve:t,reject:e},o.default(n),setTimeout(function(){r.openModal()})})}};s.close=r.onAction,s.getState=r.getState,s.setActionValue=i.setActionValue,s.stopLoading=r.stopLoading,s.setDefaults=a.setDefaults,e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(0),i=r.default.MODAL,a=n(4),s=n(34),c=n(35),l=n(1);e.init=function(t){o.getNode(i)||(document.body||l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"),s.default(),a.default()),a.initModalContent(t),c.default(t)},e.default=e.init},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.MODAL;e.modalMarkup='\n  <div class="'+r+'" role="dialog" aria-modal="true"></div>',e.default=e.modalMarkup},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.OVERLAY,i='<div \n    class="'+r+'"\n    tabIndex="-1">\n  </div>';e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.ICON;e.errorIconMarkup=function(){var t=r+"--error",e=t+"__line";return'\n    <div class="'+t+'__x-mark">\n      <span class="'+e+" "+e+'--left"></span>\n      <span class="'+e+" "+e+'--right"></span>\n    </div>\n  '},e.warningIconMarkup=function(){var t=r+"--warning";return'\n    <span class="'+t+'__body">\n      <span class="'+t+'__dot"></span>\n    </span>\n  '},e.successIconMarkup=function(){var t=r+"--success";return'\n    <span class="'+t+"__line "+t+'__line--long"></span>\n    <span class="'+t+"__line "+t+'__line--tip"></span>\n\n    <div class="'+t+'__ring"></div>\n    <div class="'+t+'__hide-corners"></div>\n  '}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.CONTENT;e.contentMarkup='\n  <div class="'+r+'">\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.BUTTON_CONTAINER,i=o.default.BUTTON,a=o.default.BUTTON_LOADER;e.buttonMarkup='\n  <div class="'+r+'">\n\n    <button\n      class="'+i+'"\n    ></button>\n\n    <div class="'+a+'">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(2),i=n(0),a=i.default.ICON,s=i.default.ICON_CUSTOM,c=["error","warning","success","info"],l={error:r.errorIconMarkup(),warning:r.warningIconMarkup(),success:r.successIconMarkup()},u=function(t,e){var n=a+"--"+t;e.classList.add(n);var o=l[t];o&&(e.innerHTML=o)},f=function(t,e){e.classList.add(s);var n=document.createElement("img");n.src=t,e.appendChild(n)},d=function(t){if(t){var e=o.injectElIntoModal(r.iconMarkup);c.includes(t)?u(t,e):f(t,e)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),r=n(4),i=function(t){navigator.userAgent.includes("AppleWebKit")&&(t.style.display="none",t.offsetHeight,t.style.display="")};e.initTitle=function(t){if(t){var e=r.injectElIntoModal(o.titleMarkup);e.textContent=t,i(e)}},e.initText=function(t){if(t){var e=document.createDocumentFragment();t.split("\n").forEach(function(t,n,o){e.appendChild(document.createTextNode(t)),n<o.length-1&&e.appendChild(document.createElement("br"))});var n=r.injectElIntoModal(o.textMarkup);n.appendChild(e),i(n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(4),i=n(0),a=i.default.BUTTON,s=i.default.DANGER_BUTTON,c=n(3),l=n(2),u=n(6),f=n(5),d=function(t,e,n){var r=e.text,i=e.value,d=e.className,p=e.closeModal,m=o.stringToNode(l.buttonMarkup),b=m.querySelector("."+a),v=a+"--"+t;if(b.classList.add(v),d){(Array.isArray(d)?d:d.split(" ")).filter(function(t){return t.length>0}).forEach(function(t){b.classList.add(t)})}n&&t===c.CONFIRM_KEY&&b.classList.add(s),b.textContent=r;var g={};return g[t]=i,f.setActionValue(g),f.setActionOptionsFor(t,{closeModal:p}),b.addEventListener("click",function(){return u.onAction(t)}),m},p=function(t,e){var n=r.injectElIntoModal(l.footerMarkup);for(var o in t){var i=t[o],a=d(o,i,e);i.visible&&n.appendChild(a)}0===n.children.length&&n.remove()};e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r=n(4),i=n(2),a=n(5),s=n(6),c=n(0),l=c.default.CONTENT,u=function(t){t.addEventListener("input",function(t){var e=t.target,n=e.value;a.setActionValue(n)}),t.addEventListener("keyup",function(t){if("Enter"===t.key)return s.onAction(o.CONFIRM_KEY)}),setTimeout(function(){t.focus(),a.setActionValue("")},0)},f=function(t,e,n){var o=document.createElement(e),r=l+"__"+e;o.classList.add(r);for(var i in n){var a=n[i];o[i]=a}"input"===e&&u(o),t.appendChild(o)},d=function(t){if(t){var e=r.injectElIntoModal(i.contentMarkup),n=t.element,o=t.attributes;"string"==typeof n?f(e,n,o):e.appendChild(n)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=function(){var t=o.stringToNode(r.overlayMarkup);document.body.appendChild(t)};e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),r=n(6),i=n(1),a=n(3),s=n(0),c=s.default.MODAL,l=s.default.BUTTON,u=s.default.OVERLAY,f=function(t){t.preventDefault(),v()},d=function(t){t.preventDefault(),g()},p=function(t){if(o.default.isOpen)switch(t.key){case"Escape":return r.onAction(a.CANCEL_KEY)}},m=function(t){if(o.default.isOpen)switch(t.key){case"Tab":return f(t)}},b=function(t){if(o.default.isOpen)return"Tab"===t.key&&t.shiftKey?d(t):void 0},v=function(){var t=i.getNode(l);t&&(t.tabIndex=0,t.focus())},g=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l),n=e.length-1,o=e[n];o&&o.focus()},h=function(t){t[t.length-1].addEventListener("keydown",m)},w=function(t){t[0].addEventListener("keydown",b)},y=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l);e.length&&(h(e),w(e))},x=function(t){if(i.getNode(u)===t.target)return r.onAction(a.CANCEL_KEY)},_=function(t){var e=i.getNode(u);e.removeEventListener("click",x),t&&e.addEventListener("click",x)},k=function(t){o.default.timer&&clearTimeout(o.default.timer),t&&(o.default.timer=window.setTimeout(function(){return r.onAction(a.CANCEL_KEY)},t))},O=function(t){t.closeOnEsc?document.addEventListener("keyup",p):document.removeEventListener("keyup",p),t.dangerMode?v():g(),y(),_(t.closeOnClickOutside),k(t.timer)};e.default=O},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(37),a=n(38),s={title:null,text:null,icon:null,buttons:r.defaultButtonList,content:null,className:null,closeOnClickOutside:!0,closeOnEsc:!0,dangerMode:!1,timer:null},c=Object.assign({},s);e.setDefaults=function(t){c=Object.assign({},s,t)};var l=function(t){var e=t&&t.button,n=t&&t.buttons;return void 0!==e&&void 0!==n&&o.throwErr("Cannot set both 'button' and 'buttons' options!"),void 0!==e?{confirm:e}:n},u=function(t){return o.ordinalSuffixOf(t+1)},f=function(t,e){o.throwErr(u(e)+" argument ('"+t+"') is invalid")},d=function(t,e){var n=t+1,r=e[n];o.isPlainObject(r)||void 0===r||o.throwErr("Expected "+u(n)+" argument ('"+r+"') to be a plain object")},p=function(t,e){var n=t+1,r=e[n];void 0!==r&&o.throwErr("Unexpected "+u(n)+" argument ("+r+")")},m=function(t,e,n,r){var i=typeof e,a="string"===i,s=e instanceof Element;if(a){if(0===n)return{text:e};if(1===n)return{text:e,title:r[0]};if(2===n)return d(n,r),{icon:e};f(e,n)}else{if(s&&0===n)return d(n,r),{content:e};if(o.isPlainObject(e))return p(n,r),e;f(e,n)}};e.getOpts=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n={};t.forEach(function(e,o){var r=m(0,e,o,t);Object.assign(n,r)});var o=l(n);n.buttons=r.getButtonListOpts(o),delete n.button,n.content=i.getContentOpts(n.content);var u=Object.assign({},s,c,n);return Object.keys(u).forEach(function(t){a.DEPRECATED_OPTS[t]&&a.logDeprecation(t)}),u}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r={element:"input",attributes:{placeholder:""}};e.getContentOpts=function(t){var e={};return o.isPlainObject(t)?Object.assign(e,t):t instanceof Element?{element:t}:"input"===t?r:null}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.logDeprecation=function(t){var n=e.DEPRECATED_OPTS[t],o=n.onlyRename,r=n.replacement,i=n.subOption,a=n.link,s=o?"renamed":"deprecated",c='SweetAlert warning: "'+t+'" option has been '+s+".";if(r){c+=" Please use"+(i?' "'+i+'" in ':" ")+'"'+r+'" instead.'}var l="https://sweetalert.js.org";c+=a?" More details: "+l+a:" More details: "+l+"/guides/#upgrading-from-1x",console.warn(c)},e.DEPRECATED_OPTS={type:{replacement:"icon",link:"/docs/#icon"},imageUrl:{replacement:"icon",link:"/docs/#icon"},customClass:{replacement:"className",onlyRename:!0,link:"/docs/#classname"},imageSize:{},showCancelButton:{replacement:"buttons",link:"/docs/#buttons"},showConfirmButton:{replacement:"button",link:"/docs/#button"},confirmButtonText:{replacement:"button",link:"/docs/#button"},confirmButtonColor:{},cancelButtonText:{replacement:"buttons",link:"/docs/#buttons"},closeOnConfirm:{replacement:"button",subOption:"closeModal",link:"/docs/#button"},closeOnCancel:{replacement:"buttons",subOption:"closeModal",link:"/docs/#buttons"},showLoaderOnConfirm:{replacement:"buttons"},animation:{},inputType:{replacement:"content",link:"/docs/#content"},inputValue:{replacement:"content",link:"/docs/#content"},inputPlaceholder:{replacement:"content",link:"/docs/#content"},html:{replacement:"content",link:"/docs/#content"},allowEscapeKey:{replacement:"closeOnEsc",onlyRename:!0,link:"/docs/#closeonesc"},allowClickOutside:{replacement:"closeOnClickOutside",onlyRename:!0,link:"/docs/#closeonclickoutside"}}}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0).setImmediate, __webpack_require__(0).clearImmediate))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.swal = undefined;

var _sweetalert = __webpack_require__(2);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function plugin(Vue) {
  Vue.prototype.$swal = Vue.$swal = _sweetalert2.default;
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin);
}

exports.default = plugin;

var version = '__VERSION__';
// Export all components too
exports.swal = _sweetalert2.default;
exports.version = version;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(4)))

/***/ })
/******/ ]);
});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.VueStorage = factory());
}(this, function () { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  /* eslint class-methods-use-this: off */
  var ls = {};

  var MemoryStorageInterface =
  /*#__PURE__*/
  function () {
    function MemoryStorageInterface() {
      _classCallCheck(this, MemoryStorageInterface);

      Object.defineProperty(this, 'length', {
        /**
         * Define length property
         *
         * @return {number}
         */
        get: function get() {
          return Object.keys(ls).length;
        }
      });
    }
    /**
     * Get item
     *
     * @param {string} name
     * @returns {*}
     */


    _createClass(MemoryStorageInterface, [{
      key: "getItem",
      value: function getItem(name) {
        return name in ls ? ls[name] : null;
      }
      /**
       * Set item
       *
       * @param {string} name
       * @param {*} value
       * @returns {boolean}
       */

    }, {
      key: "setItem",
      value: function setItem(name, value) {
        ls[name] = value;
        return true;
      }
      /**
       * Remove item
       *
       * @param {string} name
       * @returns {boolean}
       */

    }, {
      key: "removeItem",
      value: function removeItem(name) {
        var found = name in ls;

        if (found) {
          return delete ls[name];
        }

        return false;
      }
      /**
       * Clear storage
       *
       * @returns {boolean}
       */

    }, {
      key: "clear",
      value: function clear() {
        ls = {};
        return true;
      }
      /**
       * Get item by key
       *
       * @param {number} index
       * @returns {*}
       */

    }, {
      key: "key",
      value: function key(index) {
        var keys = Object.keys(ls);
        return typeof keys[index] !== 'undefined' ? keys[index] : null;
      }
    }]);

    return MemoryStorageInterface;
  }();

  var MemoryStorage = new MemoryStorageInterface();

  var listeners = {};
  /**
   * Event class
   */

  var WebStorageEvent =
  /*#__PURE__*/
  function () {
    function WebStorageEvent() {
      _classCallCheck(this, WebStorageEvent);
    }

    _createClass(WebStorageEvent, null, [{
      key: "on",

      /**
       * Add storage change event
       *
       * @param {string} name
       * @param {Function} callback
       */
      value: function on(name, callback) {
        if (typeof listeners[name] === 'undefined') {
          listeners[name] = [];
        }

        listeners[name].push(callback);
      }
      /**
       * Remove storage change event
       *
       * @param {string} name
       * @param {Function} callback
       */

    }, {
      key: "off",
      value: function off(name, callback) {
        if (listeners[name].length) {
          listeners[name].splice(listeners[name].indexOf(callback), 1);
        } else {
          listeners[name] = [];
        }
      }
      /**
       * Emit event
       *
       * @param {Object} event
       */

    }, {
      key: "emit",
      value: function emit(event) {
        var e = event || window.event;

        var getValue = function getValue(data) {
          try {
            return JSON.parse(data).value;
          } catch (err) {
            return data;
          }
        };

        var fire = function fire(listener) {
          var newValue = getValue(e.newValue);
          var oldValue = getValue(e.oldValue);
          listener(newValue, oldValue, e.url || e.uri);
        };

        if (typeof e === 'undefined' || typeof e.key === 'undefined') {
          return;
        }

        var all = listeners[e.key];

        if (typeof all !== 'undefined') {
          all.forEach(fire);
        }
      }
    }]);

    return WebStorageEvent;
  }();

  /**
   * Storage Bridge
   */

  var WebStorage =
  /*#__PURE__*/
  function () {
    /**
     * @param {Object} storage
     */
    function WebStorage(storage) {
      _classCallCheck(this, WebStorage);

      this.storage = storage;
      this.options = {
        namespace: '',
        events: ['storage']
      };
      Object.defineProperty(this, 'length', {
        /**
         * Define length property
         *
         * @return {number}
         */
        get: function get() {
          return this.storage.length;
        }
      });

      if (typeof window !== 'undefined') {
        for (var i in this.options.events) {
          if (window.addEventListener) {
            window.addEventListener(this.options.events[i], WebStorageEvent.emit, false);
          } else if (window.attachEvent) {
            window.attachEvent("on".concat(this.options.events[i]), WebStorageEvent.emit);
          } else {
            window["on".concat(this.options.events[i])] = WebStorageEvent.emit;
          }
        }
      }
    }
    /**
     * Set Options
     *
     * @param {Object} options
     */


    _createClass(WebStorage, [{
      key: "setOptions",
      value: function setOptions() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.options = Object.assign(this.options, options);
      }
      /**
       * Set item
       *
       * @param {string} name
       * @param {*} value
       * @param {number} expire - seconds
       */

    }, {
      key: "set",
      value: function set(name, value) {
        var expire = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var stringifyValue = JSON.stringify({
          value: value,
          expire: expire !== null ? new Date().getTime() + expire : null
        });
        this.storage.setItem(this.options.namespace + name, stringifyValue);
      }
      /**
       * Get item
       *
       * @param {string} name
       * @param {*} def - default value
       * @returns {*}
       */

    }, {
      key: "get",
      value: function get(name) {
        var def = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var item = this.storage.getItem(this.options.namespace + name);

        if (item !== null) {
          try {
            var data = JSON.parse(item);

            if (data.expire === null) {
              return data.value;
            }

            if (data.expire >= new Date().getTime()) {
              return data.value;
            }

            this.remove(name);
          } catch (err) {
            return def;
          }
        }

        return def;
      }
      /**
       * Get item by key
       *
       * @param {number} index
       * @return {*}
       */

    }, {
      key: "key",
      value: function key(index) {
        return this.storage.key(index);
      }
      /**
       * Remove item
       *
       * @param {string} name
       * @return {boolean}
       */

    }, {
      key: "remove",
      value: function remove(name) {
        return this.storage.removeItem(this.options.namespace + name);
      }
      /**
       * Clear storage
       */

    }, {
      key: "clear",
      value: function clear() {
        if (this.length === 0) {
          return;
        }

        var removedKeys = [];

        for (var i = 0; i < this.length; i++) {
          var key = this.storage.key(i);
          var regexp = new RegExp("^".concat(this.options.namespace, ".+"), 'i');

          if (regexp.test(key) === false) {
            continue;
          }

          removedKeys.push(key);
        }

        for (var _key in removedKeys) {
          this.storage.removeItem(removedKeys[_key]);
        }
      }
      /**
       * Add storage change event
       *
       * @param {string} name
       * @param {Function} callback
       */

    }, {
      key: "on",
      value: function on(name, callback) {
        WebStorageEvent.on(this.options.namespace + name, callback);
      }
      /**
       * Remove storage change event
       *
       * @param {string} name
       * @param {Function} callback
       */

    }, {
      key: "off",
      value: function off(name, callback) {
        WebStorageEvent.off(this.options.namespace + name, callback);
      }
    }]);

    return WebStorage;
  }();

  var _global = typeof window !== 'undefined' ? window : global || {};
  /**
   * @type {{install: (function(Object, Object): WebStorage)}}
   */


  var VueStorage = {
    /**
     * Install plugin
     *
     * @param {Object} Vue
     * @param {Object} options
     * @returns {WebStorage}
     */
    install: function install(Vue) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _options = Object.assign({}, options, {
        storage: options.storage || 'local',
        name: options.name || 'ls'
      });

      if (_options.storage && ['memory', 'local', 'session'].indexOf(_options.storage) === -1) {
        throw new Error("Vue-ls: Storage \"".concat(_options.storage, "\" is not supported"));
      }

      var store = null;

      switch (_options.storage) {
        // eslint-disable-line
        case 'local':
          store = 'localStorage' in _global ? _global.localStorage : null;
          break;

        case 'session':
          store = 'sessionStorage' in _global ? _global.sessionStorage : null;
          break;

        case 'memory':
          store = MemoryStorage;
          break;
      }

      if (!store) {
        store = MemoryStorage; // eslint-disable-next-line

        console.error("Vue-ls: Storage \"".concat(_options.storage, "\" is not supported your system, use memory storage"));
      }

      var ls = new WebStorage(store);
      ls.setOptions(Object.assign(ls.options, {
        namespace: ''
      }, _options || {}));
      Vue[_options.name] = ls; // eslint-disable-line

      Object.defineProperty(Vue.prototype, "$".concat(_options.name), {
        /**
         * Define $ls property
         *
         * @return {WebStorage}
         */
        get: function get() {
          return ls;
        }
      });
    }
  };
  _global.VueStorage = VueStorage;

  return VueStorage;

}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(t,e){ true?module.exports=e(__webpack_require__(0),__webpack_require__(260)):"function"==typeof define&&define.amd?define(["moment","pikaday"],e):t.vuePikaday=e(t.moment,t.Pikaday)}(this,function(moment,Pikaday){"use strict";function t(e){return(t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(e)}moment=moment&&moment.hasOwnProperty("default")?moment.default:moment,Pikaday=Pikaday&&Pikaday.hasOwnProperty("default")?Pikaday.default:Pikaday;var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};var n="object"==typeof e&&e&&e.Object===Object&&e,i="object"==typeof self&&self&&self.Object===Object&&self,o=n||i||Function("return this")(),r=o.Symbol,u=Object.prototype,s=u.hasOwnProperty,a=u.toString,f=r?r.toStringTag:void 0;var c=function(t){var e=s.call(t,f),n=t[f];try{t[f]=void 0}catch(t){}var i=a.call(t);return e?t[f]=n:delete t[f],i},l=Object.prototype.toString;var d=function(t){return l.call(t)},p="[object Null]",h="[object Undefined]",v=r?r.toStringTag:void 0;var y=function(t){return null==t?void 0===t?h:p:v&&v in Object(t)?c(t):d(t)};var m=function(t){return null!=t&&"object"==typeof t},b="[object Date]";var g=function(t){return m(t)&&y(t)==b};var O,w=function(t){return function(e){return t(e)}},j=(function(t,e){var i=e&&!e.nodeType&&e,o=i&&t&&!t.nodeType&&t,r=o&&o.exports===i&&n.process,u=function(){try{var t=o&&o.require&&o.require("util").types;return t||r&&r.binding&&r.binding("util")}catch(t){}}();t.exports=u}(O={exports:{}},O.exports),O.exports),x=j&&j.isDate,S=x?w(x):g;var k={name:"vue-pikaday",inheritAttrs:!1,props:{value:{validator:function(e){var n=[void 0,null];if(function(t){return t instanceof Event||t&&t.constructor&&"Event"===t.constructor.name}(e))return!0;if(S(e))return!0;for(var i=0;i<n.length;i++){var o=n[i];if(e===o||t(e)===o)return!0}return!1},required:!0},options:{required:!1,default:function(){return{}}},autoDefault:{type:Boolean,required:!1,default:!1}},data:function(){return{visible:!1,elAttrs:{type:"text"},defaultOptions:{format:"D MMM YYYY"},mergedOptions:{}}},computed:{elementAttributes:function(){return Object.assign({},this.$attrs,this.elAttrs)}},render:function(t){return t("input",{attrs:this.elementAttributes,on:this.$listeners,value:this.inputValue(this.value)},this.$slots.default)},beforeMount:function(){this.mergedOptions=Object.assign({},this.defaultOptions,this.options)},mounted:function(){var t=this;this.create(),this.$watch("value",function(e){S(e)||(e=null),t.visible||t.pikaday.setDate(e,!0),t.change(e)})},beforeDestroy:function(){this.destroy()},methods:{create:function(){var t=this;this.mergedOptions.field=this.$el,this.bindListener("onSelect",function(){return t.onSelect()}),this.bindListener("onOpen",function(){return t.onOpen()}),this.bindListener("onClose",function(){return t.onClose()}),this.pikaday=new Pikaday(this.mergedOptions);var e=this.value;!this.value&&this.autoDefault&&(e=moment().toDate(),this.change(e)),this.pikaday.setDate(e),!1===this.mergedOptions.bound?this.hide():this.visible?this.show():this.hide()},destroy:function(){this.pikaday.destroy()},change:function(t){this.$emit("input",t),this.$emit("input-value",this.inputValue(t))},inputValue:function(t){if(!S(t))return null;var e=moment(t);return e.isValid()?e.format(this.mergedOptions.format):null},onSelect:function(){this.change(this.pikaday.getDate())},onOpen:function(){this.visible=!0},onClose:function(){S(this.value)||(this.pikaday.setDate(null,!0),this.change(null)),this.visible=!1},show:function(){this.pikaday.show()},hide:function(){this.pikaday.hide()},bindListener:function(t,e){var n=this;if(this.mergedOptions[t]){var i=this.mergedOptions[t];this.mergedOptions[t]=function(){for(var t=arguments.length,o=new Array(t),r=0;r<t;r++)o[r]=arguments[r];i(o),e.apply(n)}}else this.mergedOptions[t]=e}}};var D=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)},$=function(){return o.Date.now()},T="[object Symbol]";var q=function(t){return"symbol"==typeof t||m(t)&&y(t)==T},A=NaN,M=/^\s+|\s+$/g,V=/^[-+]0x[0-9a-f]+$/i,P=/^0b[01]+$/i,C=/^0o[0-7]+$/i,E=parseInt;var L=function(t){if("number"==typeof t)return t;if(q(t))return A;if(D(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=D(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(M,"");var n=P.test(t);return n||C.test(t)?E(t.slice(2),n?2:8):V.test(t)?A:+t},Y="Expected a function",I=Math.max,N=Math.min;var W=function(t,e,n){var i,o,r,u,s,a,f=0,c=!1,l=!1,d=!0;if("function"!=typeof t)throw new TypeError(Y);function p(e){var n=i,r=o;return i=o=void 0,f=e,u=t.apply(r,n)}function h(t){var n=t-a;return void 0===a||n>=e||n<0||l&&t-f>=r}function v(){var t=$();if(h(t))return y(t);s=setTimeout(v,function(t){var n=e-(t-a);return l?N(n,r-(t-f)):n}(t))}function y(t){return s=void 0,d&&i?p(t):(i=o=void 0,u)}function m(){var t=$(),n=h(t);if(i=arguments,o=this,a=t,n){if(void 0===s)return function(t){return f=t,s=setTimeout(v,e),c?p(t):u}(a);if(l)return s=setTimeout(v,e),p(a)}return void 0===s&&(s=setTimeout(v,e)),u}return e=L(e)||0,D(n)&&(c=!!n.leading,r=(l="maxWait"in n)?I(L(n.maxWait)||0,e):r,d="trailing"in n?!!n.trailing:d),m.cancel=function(){void 0!==s&&clearTimeout(s),f=0,i=a=o=s=void 0},m.flush=function(){return void 0===s?u:y($())},m};function B(t,e,n){var i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;e[n]=t,i=i||e,t?i.show():i.hide()}var F={inserted:function(t,e,n){var i=n.componentInstance;i.onOpen=function(){return B(!0,n.context,e.expression,i)},i.onClose=W(function(){return B(!1,n.context,e.expression,i)},100)},update:function(t,e,n){B(e.value,n.componentInstance,e.expression)}},U={install:function(t){t.component(k.name,k),t.directive("p-visible",F)}};return"undefined"!=typeof window&&window.Vue&&window.Vue.use(U),U});
//# sourceMappingURL=vue-pikaday.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 30,
	"./af.js": 30,
	"./ar": 31,
	"./ar-dz": 32,
	"./ar-dz.js": 32,
	"./ar-kw": 33,
	"./ar-kw.js": 33,
	"./ar-ly": 34,
	"./ar-ly.js": 34,
	"./ar-ma": 35,
	"./ar-ma.js": 35,
	"./ar-sa": 36,
	"./ar-sa.js": 36,
	"./ar-tn": 37,
	"./ar-tn.js": 37,
	"./ar.js": 31,
	"./az": 38,
	"./az.js": 38,
	"./be": 39,
	"./be.js": 39,
	"./bg": 40,
	"./bg.js": 40,
	"./bm": 41,
	"./bm.js": 41,
	"./bn": 42,
	"./bn.js": 42,
	"./bo": 43,
	"./bo.js": 43,
	"./br": 44,
	"./br.js": 44,
	"./bs": 45,
	"./bs.js": 45,
	"./ca": 46,
	"./ca.js": 46,
	"./cs": 47,
	"./cs.js": 47,
	"./cv": 48,
	"./cv.js": 48,
	"./cy": 49,
	"./cy.js": 49,
	"./da": 50,
	"./da.js": 50,
	"./de": 51,
	"./de-at": 52,
	"./de-at.js": 52,
	"./de-ch": 53,
	"./de-ch.js": 53,
	"./de.js": 51,
	"./dv": 54,
	"./dv.js": 54,
	"./el": 55,
	"./el.js": 55,
	"./en-au": 56,
	"./en-au.js": 56,
	"./en-ca": 57,
	"./en-ca.js": 57,
	"./en-gb": 58,
	"./en-gb.js": 58,
	"./en-ie": 59,
	"./en-ie.js": 59,
	"./en-il": 60,
	"./en-il.js": 60,
	"./en-nz": 61,
	"./en-nz.js": 61,
	"./eo": 62,
	"./eo.js": 62,
	"./es": 63,
	"./es-do": 64,
	"./es-do.js": 64,
	"./es-us": 65,
	"./es-us.js": 65,
	"./es.js": 63,
	"./et": 66,
	"./et.js": 66,
	"./eu": 67,
	"./eu.js": 67,
	"./fa": 68,
	"./fa.js": 68,
	"./fi": 69,
	"./fi.js": 69,
	"./fo": 70,
	"./fo.js": 70,
	"./fr": 71,
	"./fr-ca": 72,
	"./fr-ca.js": 72,
	"./fr-ch": 73,
	"./fr-ch.js": 73,
	"./fr.js": 71,
	"./fy": 74,
	"./fy.js": 74,
	"./gd": 75,
	"./gd.js": 75,
	"./gl": 76,
	"./gl.js": 76,
	"./gom-latn": 77,
	"./gom-latn.js": 77,
	"./gu": 78,
	"./gu.js": 78,
	"./he": 79,
	"./he.js": 79,
	"./hi": 80,
	"./hi.js": 80,
	"./hr": 81,
	"./hr.js": 81,
	"./hu": 82,
	"./hu.js": 82,
	"./hy-am": 83,
	"./hy-am.js": 83,
	"./id": 84,
	"./id.js": 84,
	"./is": 85,
	"./is.js": 85,
	"./it": 86,
	"./it.js": 86,
	"./ja": 87,
	"./ja.js": 87,
	"./jv": 88,
	"./jv.js": 88,
	"./ka": 89,
	"./ka.js": 89,
	"./kk": 90,
	"./kk.js": 90,
	"./km": 91,
	"./km.js": 91,
	"./kn": 92,
	"./kn.js": 92,
	"./ko": 93,
	"./ko.js": 93,
	"./ku": 94,
	"./ku.js": 94,
	"./ky": 95,
	"./ky.js": 95,
	"./lb": 96,
	"./lb.js": 96,
	"./lo": 97,
	"./lo.js": 97,
	"./lt": 98,
	"./lt.js": 98,
	"./lv": 99,
	"./lv.js": 99,
	"./me": 100,
	"./me.js": 100,
	"./mi": 101,
	"./mi.js": 101,
	"./mk": 102,
	"./mk.js": 102,
	"./ml": 103,
	"./ml.js": 103,
	"./mn": 104,
	"./mn.js": 104,
	"./mr": 105,
	"./mr.js": 105,
	"./ms": 106,
	"./ms-my": 107,
	"./ms-my.js": 107,
	"./ms.js": 106,
	"./mt": 108,
	"./mt.js": 108,
	"./my": 109,
	"./my.js": 109,
	"./nb": 110,
	"./nb.js": 110,
	"./ne": 111,
	"./ne.js": 111,
	"./nl": 112,
	"./nl-be": 113,
	"./nl-be.js": 113,
	"./nl.js": 112,
	"./nn": 114,
	"./nn.js": 114,
	"./pa-in": 115,
	"./pa-in.js": 115,
	"./pl": 116,
	"./pl.js": 116,
	"./pt": 117,
	"./pt-br": 118,
	"./pt-br.js": 118,
	"./pt.js": 117,
	"./ro": 119,
	"./ro.js": 119,
	"./ru": 120,
	"./ru.js": 120,
	"./sd": 121,
	"./sd.js": 121,
	"./se": 122,
	"./se.js": 122,
	"./si": 123,
	"./si.js": 123,
	"./sk": 124,
	"./sk.js": 124,
	"./sl": 125,
	"./sl.js": 125,
	"./sq": 126,
	"./sq.js": 126,
	"./sr": 127,
	"./sr-cyrl": 128,
	"./sr-cyrl.js": 128,
	"./sr.js": 127,
	"./ss": 129,
	"./ss.js": 129,
	"./sv": 130,
	"./sv.js": 130,
	"./sw": 131,
	"./sw.js": 131,
	"./ta": 132,
	"./ta.js": 132,
	"./te": 133,
	"./te.js": 133,
	"./tet": 134,
	"./tet.js": 134,
	"./tg": 135,
	"./tg.js": 135,
	"./th": 136,
	"./th.js": 136,
	"./tl-ph": 137,
	"./tl-ph.js": 137,
	"./tlh": 138,
	"./tlh.js": 138,
	"./tr": 139,
	"./tr.js": 139,
	"./tzl": 140,
	"./tzl.js": 140,
	"./tzm": 141,
	"./tzm-latn": 142,
	"./tzm-latn.js": 142,
	"./tzm.js": 141,
	"./ug-cn": 143,
	"./ug-cn.js": 143,
	"./uk": 144,
	"./uk.js": 144,
	"./ur": 145,
	"./ur.js": 145,
	"./uz": 146,
	"./uz-latn": 147,
	"./uz-latn.js": 147,
	"./uz.js": 146,
	"./vi": 148,
	"./vi.js": 148,
	"./x-pseudo": 149,
	"./x-pseudo.js": 149,
	"./yo": 150,
	"./yo.js": 150,
	"./zh-cn": 151,
	"./zh-cn.js": 151,
	"./zh-hk": 152,
	"./zh-hk.js": 152,
	"./zh-tw": 153,
	"./zh-tw.js": 153
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/Pikaday/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = __webpack_require__(0); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // data-attribute on the input field with an aria assistance tekst (only applied when `bound` is set)
        ariaLabel: 'Use the arrow keys to pick a date',

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the toString function which gets passed a current date object and format
        // and returns a string
        toString: null,

        // used to create date object from current input string
        parse: null,

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // Week picker mode
        pickWholeWeek: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // Allows user to select days that fall in the next or previous month
        enableSelectionDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // Blur field when date is selected
        blurFieldOnSelect : true,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // events array
        events: [],

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null,

        // Enable keyboard input
        keyboardInput: true
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');

                if(!opts.enableSelectionDaysInNextAndPreviousMonths) {
                    arr.push('is-selection-disabled');
                }

            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.hasEvent) {
            arr.push('has-event');
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL, pickWholeWeek, isRowSelected)
    {
        return '<tr class="pika-row' + (pickWholeWeek ? ' pick-whole-week' : '') + (isRowSelected ? ' is-selected' : '') + '">' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.blurFieldOnSelect && opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        if (opts.field) {
                            opts.field.blur();
                        }
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (opts.parse) {
                date = opts.parse(opts.field.value, opts.format);
            } else if (hasMoment) {
                date = moment(opts.field.value, opts.format, opts.formatStrict);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);

        if (opts.keyboardInput) {
            addEvent(document, 'keydown', self._onKeyChange);
        }

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            format = format || this._o.format;
            if (!isDate(this._d)) {
                return '';
            }
            if (this._o.toString) {
              return this._o.toString(this._d, format);
            }
            if (hasMoment) {
              return moment(this._d).format(format);
            }
            return this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : null;
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate() || new Date();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }

            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', opts.ariaLabel);
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect, leftAligned, bottomAligned;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
            leftAligned = true;
            bottomAligned = true;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
                leftAligned = false;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
                bottomAligned = false;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';

            addClass(this.el, leftAligned ? 'left-aligned' : 'right-aligned');
            addClass(this.el, bottomAligned ? 'bottom-aligned' : 'top-aligned');
            removeClass(this.el, !leftAligned ? 'left-aligned' : 'right-aligned');
            removeClass(this.el, !bottomAligned ? 'bottom-aligned' : 'top-aligned');
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            var isWeekSelected = false;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false,
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        hasEvent: hasEvent,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths,
                        enableSelectionDaysInNextAndPreviousMonths: opts.enableSelectionDaysInNextAndPreviousMonths
                    };

                if (opts.pickWholeWeek && isSelected) {
                    isWeekSelected = true;
                }

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL, opts.pickWholeWeek, isWeekSelected));
                    row = [];
                    r = 0;
                    isWeekSelected = false;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                this._v = true;
                this.draw();
                removeClass(this.el, 'is-hidden');
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            var opts = this._o;

            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (opts.keyboardInput) {
                removeEvent(document, 'keydown', this._onKeyChange);
            }
            if (opts.field) {
                removeEvent(opts.field, 'change', this._onInputChange);
                if (opts.bound) {
                    removeEvent(opts.trigger, 'click', this._onInputClick);
                    removeEvent(opts.trigger, 'focus', this._onInputFocus);
                    removeEvent(opts.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;
}));


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(262);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6c5060bf", content, true, {});

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";/*!\n * Pikaday\n * Copyright © 2014 David Bushell | BSD & MIT license | http://dbushell.com/\n */.pika-single{z-index:9999;display:block;position:relative;color:#333;background:#fff;border:1px solid #ccc;border-bottom-color:#bbb;font-family:Helvetica Neue,Helvetica,Arial,sans-serif}.pika-single:after,.pika-single:before{content:\" \";display:table}.pika-single:after{clear:both}.pika-single.is-hidden{display:none}.pika-single.is-bound{position:absolute;box-shadow:0 5px 15px -5px rgba(0,0,0,.5)}.pika-lendar{float:left;width:240px;margin:8px}.pika-title{position:relative;text-align:center}.pika-label{display:inline-block;position:relative;z-index:9999;overflow:hidden;margin:0;padding:5px 3px;font-size:14px;line-height:20px;font-weight:700;background-color:#fff}.pika-title select{cursor:pointer;position:absolute;z-index:9998;margin:0;left:0;top:5px;filter:alpha(opacity=0);opacity:0}.pika-next,.pika-prev{display:block;cursor:pointer;position:relative;outline:0;border:0;padding:0;width:20px;height:30px;text-indent:20px;white-space:nowrap;overflow:hidden;background-color:transparent;background-position:50%;background-repeat:no-repeat;background-size:75% 75%;opacity:.5}.pika-next:hover,.pika-prev:hover{opacity:1}.is-rtl .pika-next,.pika-prev{float:left;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAUklEQVR42u3VMQoAIBADQf8Pgj+OD9hG2CtONJB2ymQkKe0HbwAP0xucDiQWARITIDEBEnMgMQ8S8+AqBIl6kKgHiXqQqAeJepBo/z38J/U0uAHlaBkBl9I4GwAAAABJRU5ErkJggg==)}.is-rtl .pika-prev,.pika-next{float:right;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAeCAYAAAAsEj5rAAAAU0lEQVR42u3VOwoAMAgE0dwfAnNjU26bYkBCFGwfiL9VVWoO+BJ4Gf3gtsEKKoFBNTCoCAYVwaAiGNQGMUHMkjGbgjk2mIONuXo0nC8XnCf1JXgArVIZAQh5TKYAAAAASUVORK5CYII=)}.pika-next.is-disabled,.pika-prev.is-disabled{cursor:default;opacity:.2}.is-disabled .pika-button,.is-outside-current-month .pika-button{opacity:.3;color:#999}.pika-select{display:inline-block}.pika-table{width:100%;border-collapse:collapse;border-spacing:0;border:0}.pika-table td,.pika-table th{width:14.285714285714286%;padding:0}.pika-table th{color:#999;font-size:12px;line-height:25px;font-weight:700;text-align:center}.pika-button{cursor:pointer;display:block;box-sizing:border-box;-moz-box-sizing:border-box;outline:0;border:0;margin:0;width:100%;padding:5px;color:#666;font-size:12px;line-height:15px;text-align:right;background:#f5f5f5}.is-disabled .pika-button,.is-selection-disabled{pointer-events:none;cursor:default}.pika-week{font-size:11px;color:#999}.is-today .pika-button{color:#3af;font-weight:700}.has-event .pika-button,.is-selected .pika-button{color:#fff;font-weight:700;background:#3af;box-shadow:inset 0 1px 3px #178fe5;border-radius:3px}.has-event .pika-button{background:#005da9;box-shadow:inset 0 1px 3px #0076c9}.is-disabled .pika-button,.is-inrange .pika-button{background:#d5e9f7}.is-startrange .pika-button{color:#fff;background:#6cb31d;box-shadow:none;border-radius:3px}.is-endrange .pika-button{color:#fff;background:#3af;box-shadow:none;border-radius:3px}.pika-button:hover,.pika-row.pick-whole-week:hover .pika-button{color:#fff;background:#ff8000;box-shadow:none;border-radius:3px}.pika-table abbr{border-bottom:none;cursor:help}", ""]);

// exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueSelect=e():t.VueSelect=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function n(o){if(e[o])return e[o].exports;var i=e[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(o,i,function(e){return t[e]}.bind(null,i));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=9)}([function(t,e){function n(t){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function o(e){return"function"==typeof Symbol&&"symbol"===n(Symbol.iterator)?t.exports=o=function(t){return n(t)}:t.exports=o=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":n(t)},o(e)}t.exports=o},function(t,e,n){},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e,n){var o=n(5),i=n(6),s=n(7);t.exports=function(t){return o(t)||i(t)||s()}},function(t,e,n){var o=n(2);t.exports=function(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(e){o(t,e,n[e])})}return t}},function(t,e){t.exports=function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}},function(t,e){t.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(t,e,n){"use strict";var o=n(1);n.n(o).a},function(t,e,n){"use strict";n.r(e);var o=n(3),i=n.n(o),s=n(2),r=n.n(s),a=n(0),l=n.n(a),c=n(4),u=n.n(c),h={watch:{typeAheadPointer:function(){this.maybeAdjustScroll()}},methods:{maybeAdjustScroll:function(){var t=this.pixelsToPointerTop(),e=this.pixelsToPointerBottom();return t<=this.viewport().top?this.scrollTo(t):e>=this.viewport().bottom?this.scrollTo(this.viewport().top+this.pointerHeight()):void 0},pixelsToPointerTop:function(){var t=0;if(this.$refs.dropdownMenu)for(var e=0;e<this.typeAheadPointer;e++)t+=this.$refs.dropdownMenu.children[e].offsetHeight;return t},pixelsToPointerBottom:function(){return this.pixelsToPointerTop()+this.pointerHeight()},pointerHeight:function(){var t=!!this.$refs.dropdownMenu&&this.$refs.dropdownMenu.children[this.typeAheadPointer];return t?t.offsetHeight:0},viewport:function(){return{top:this.$refs.dropdownMenu?this.$refs.dropdownMenu.scrollTop:0,bottom:this.$refs.dropdownMenu?this.$refs.dropdownMenu.offsetHeight+this.$refs.dropdownMenu.scrollTop:0}},scrollTo:function(t){return this.$refs.dropdownMenu?this.$refs.dropdownMenu.scrollTop=t:null}}},p={data:function(){return{typeAheadPointer:-1}},watch:{filteredOptions:function(){this.typeAheadPointer=0}},methods:{typeAheadUp:function(){this.typeAheadPointer>0&&(this.typeAheadPointer--,this.maybeAdjustScroll&&this.maybeAdjustScroll())},typeAheadDown:function(){this.typeAheadPointer<this.filteredOptions.length-1&&(this.typeAheadPointer++,this.maybeAdjustScroll&&this.maybeAdjustScroll())},typeAheadSelect:function(){this.filteredOptions[this.typeAheadPointer]?this.select(this.filteredOptions[this.typeAheadPointer]):this.taggable&&this.search.length&&this.select(this.search),this.clearSearchOnSelect&&(this.search="")}}},d={props:{loading:{type:Boolean,default:!1}},data:function(){return{mutableLoading:!1}},watch:{search:function(){this.$emit("search",this.search,this.toggleLoading)},loading:function(t){this.mutableLoading=t}},methods:{toggleLoading:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.mutableLoading=null==t?!this.mutableLoading:t}}};function f(t,e,n,o,i,s,r,a){var l,c="function"==typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=n,c._compiled=!0),o&&(c.functional=!0),s&&(c._scopeId="data-v-"+s),r?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},c._ssrRegister=l):i&&(l=a?function(){i.call(this,this.$root.$options.shadowRoot)}:i),l)if(c.functional){c._injectStyles=l;var u=c.render;c.render=function(t,e){return l.call(e),u(t,e)}}else{var h=c.beforeCreate;c.beforeCreate=h?[].concat(h,l):[l]}return{exports:t,options:c}}var y={Deselect:f({},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"10"}},[e("path",{attrs:{d:"M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"}})])},[],!1,null,null,null).exports,OpenIndicator:f({},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"10"}},[e("path",{attrs:{d:"M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"}})])},[],!1,null,null,null).exports},b={components:u()({},y),mixins:[h,p,d],props:{value:{},components:{type:Object,default:function(){return{}}},options:{type:Array,default:function(){return[]}},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},searchable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},placeholder:{type:String,default:""},transition:{type:String,default:"vs__fade"},clearSearchOnSelect:{type:Boolean,default:!0},closeOnSelect:{type:Boolean,default:!0},label:{type:String,default:"label"},autocomplete:{type:String,default:"off"},reduce:{type:Function,default:function(t){return t}},getOptionLabel:{type:Function,default:function(t){if("object"===l()(t)){if(!t.hasOwnProperty(this.label))return;return t[this.label]}return t}},onTab:{type:Function,default:function(){this.selectOnTab&&this.typeAheadSelect()}},taggable:{type:Boolean,default:!1},tabindex:{type:Number,default:null},pushTags:{type:Boolean,default:!1},filterable:{type:Boolean,default:!0},filterBy:{type:Function,default:function(t,e,n){return(e||"").toLowerCase().indexOf(n.toLowerCase())>-1}},filter:{type:Function,default:function(t,e){var n=this;return t.filter(function(t){var o=n.getOptionLabel(t);return"number"==typeof o&&(o=o.toString()),n.filterBy(t,o,e)})}},createOption:{type:Function,default:function(t){return"object"===l()(this.optionList[0])&&(t=r()({},this.label,t)),this.$emit("option:created",t),t}},resetOnOptionsChange:{type:Boolean,default:!1},noDrop:{type:Boolean,default:!1},inputId:{type:String},dir:{type:String,default:"auto"},selectOnTab:{type:Boolean,default:!1},searchInputQuerySelector:{type:String,default:"[type=search]"}},data:function(){return{search:"",open:!1,pushedTags:[],_value:[]}},watch:{options:function(t){!this.taggable&&this.resetOnOptionsChange&&this.clearSelection()},multiple:function(){this.clearSelection()}},created:function(){var t=this;this.mutableLoading=this.loading,this.$options.propsData.hasOwnProperty("reduce")&&this.value&&(Array.isArray(this.value)?this.$data._value=this.value.map(function(e){return t.findOptionFromReducedValue(e)}):this.$data._value=this.findOptionFromReducedValue(this.value)),this.$on("option:created",this.maybePushTag)},methods:{select:function(t){this.isOptionSelected(t)||(this.taggable&&!this.optionExists(t)&&(t=this.createOption(t)),this.multiple&&(t=this.selectedValue.concat(t)),this.updateValue(t)),this.onAfterSelect(t)},deselect:function(t){var e=this;this.updateValue(this.selectedValue.filter(function(n){return!e.optionComparator(n,t)}))},clearSelection:function(){this.updateValue(this.multiple?[]:null)},onAfterSelect:function(t){this.closeOnSelect&&(this.open=!this.open,this.searchEl.blur()),this.clearSearchOnSelect&&(this.search="")},updateValue:function(t){var e=this;this.isTrackingValues&&(this.$data._value=t),null!==t&&(t=Array.isArray(t)?t.map(function(t){return e.reduce(t)}):this.reduce(t)),this.$emit("input",t)},toggleDropdown:function(t){var e=t.target,n=[this.$el,this.searchEl,this.$refs.toggle.$el];void 0!==this.$refs.openIndicator&&n.push.apply(n,[this.$refs.openIndicator.$el].concat(i()(Array.prototype.slice.call(this.$refs.openIndicator.$el.childNodes)))),(n.indexOf(e)>-1||e.classList.contains("vs__selected"))&&(this.open?this.searchEl.blur():this.disabled||(this.open=!0,this.searchEl.focus()))},isOptionSelected:function(t){var e=this;return this.selectedValue.some(function(n){return e.optionComparator(n,t)})},optionComparator:function(t,e){if("object"!==l()(t)&&"object"!==l()(e)){if(t===e)return!0}else{if(t===this.reduce(e))return!0;if(this.getOptionLabel(t)===this.getOptionLabel(e)||this.getOptionLabel(t)===e)return!0;if(this.reduce(t)===this.reduce(e))return!0}return!1},findOptionFromReducedValue:function(t){var e=this;return this.options.find(function(n){return JSON.stringify(e.reduce(n))===JSON.stringify(t)})||t},closeSearchOptions:function(){this.open=!1,this.$emit("search:blur")},maybeDeleteValue:function(){if(!this.searchEl.value.length&&this.selectedValue&&this.clearable){var t=null;this.multiple&&(t=i()(this.selectedValue.slice(0,this.selectedValue.length-1))),this.updateValue(t)}},optionExists:function(t){var e=this;return this.optionList.some(function(n){return"object"===l()(n)&&e.getOptionLabel(n)===t||n===t})},normalizeOptionForSlot:function(t){return"object"===l()(t)?t:r()({},this.label,t)},maybePushTag:function(t){this.pushTags&&this.pushedTags.push(t)},onEscape:function(){this.search.length?this.search="":this.searchEl.blur()},onSearchBlur:function(){if(!this.mousedown||this.searching)return this.clearSearchOnBlur&&(this.search=""),void this.closeSearchOptions();this.mousedown=!1,0!==this.search.length||0!==this.options.length||this.closeSearchOptions()},onSearchFocus:function(){this.open=!0,this.$emit("search:focus")},onMousedown:function(){this.mousedown=!0},onMouseUp:function(){this.mousedown=!1},onSearchKeyDown:function(t){switch(t.keyCode){case 8:return this.maybeDeleteValue();case 9:return this.onTab()}},onSearchKeyUp:function(t){switch(t.keyCode){case 27:return this.onEscape();case 38:return t.preventDefault(),this.typeAheadUp();case 40:return t.preventDefault(),this.typeAheadDown();case 13:return t.preventDefault(),this.typeAheadSelect()}}},computed:{isTrackingValues:function(){return void 0===this.value||this.$options.propsData.hasOwnProperty("reduce")},selectedValue:function(){var t=this.value;return this.isTrackingValues&&(t=this.$data._value),t?[].concat(t):[]},optionList:function(){return this.options.concat(this.pushedTags)},searchEl:function(){return this.$scopedSlots.search?this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector):this.$refs.search},scope:function(){var t=this;return{search:{attributes:{disabled:this.disabled,placeholder:this.searchPlaceholder,tabindex:this.tabindex,readonly:!this.searchable,id:this.inputId,"aria-expanded":this.dropdownOpen,"aria-label":"Search for option",ref:"search",role:"combobox",type:"search",autocomplete:"off",value:this.search},events:{keydown:this.onSearchKeyDown,keyup:this.onSearchKeyUp,blur:this.onSearchBlur,focus:this.onSearchFocus,input:function(e){return t.search=e.target.value}}},spinner:{loading:this.mutableLoading},openIndicator:{attributes:{ref:"openIndicator",role:"presentation",class:"vs__open-indicator"}}}},childComponents:function(){return u()({},y,this.components)},stateClasses:function(){return{"vs--open":this.dropdownOpen,"vs--single":!this.multiple,"vs--searching":this.searching&&!this.noDrop,"vs--searchable":this.searchable&&!this.noDrop,"vs--unsearchable":!this.searchable,"vs--loading":this.mutableLoading,"vs--disabled":this.disabled}},clearSearchOnBlur:function(){return this.clearSearchOnSelect&&!this.multiple},searching:function(){return!!this.search},dropdownOpen:function(){return!this.noDrop&&(this.open&&!this.mutableLoading)},searchPlaceholder:function(){if(this.isValueEmpty&&this.placeholder)return this.placeholder},filteredOptions:function(){var t=[].concat(this.optionList);if(!this.filterable&&!this.taggable)return t;var e=this.search.length?this.filter(t,this.search,this):t;return this.taggable&&this.search.length&&!this.optionExists(this.search)&&e.unshift(this.search),e},isValueEmpty:function(){return 0===this.selectedValue.length},showClearButton:function(){return!this.multiple&&this.clearable&&!this.open&&!this.isValueEmpty}}},m=(n(8),f(b,function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"v-select",class:t.stateClasses,attrs:{dir:t.dir}},[n("div",{ref:"toggle",staticClass:"vs__dropdown-toggle",on:{mousedown:function(e){return e.preventDefault(),t.toggleDropdown(e)}}},[n("div",{ref:"selectedOptions",staticClass:"vs__selected-options"},[t._l(t.selectedValue,function(e){return t._t("selected-option-container",[n("span",{key:e.index,staticClass:"vs__selected"},[t._t("selected-option",[t._v("\n            "+t._s(t.getOptionLabel(e))+"\n          ")],null,t.normalizeOptionForSlot(e)),t._v(" "),t.multiple?n("button",{staticClass:"vs__deselect",attrs:{disabled:t.disabled,type:"button","aria-label":"Deselect option"},on:{click:function(n){return t.deselect(e)}}},[n(t.childComponents.Deselect,{tag:"component"})],1):t._e()],2)],{option:t.normalizeOptionForSlot(e),deselect:t.deselect,multiple:t.multiple,disabled:t.disabled})}),t._v(" "),t._t("search",[n("input",t._g(t._b({staticClass:"vs__search"},"input",t.scope.search.attributes,!1),t.scope.search.events))],null,t.scope.search)],2),t._v(" "),n("div",{staticClass:"vs__actions"},[n("button",{directives:[{name:"show",rawName:"v-show",value:t.showClearButton,expression:"showClearButton"}],staticClass:"vs__clear",attrs:{disabled:t.disabled,type:"button",title:"Clear selection"},on:{click:t.clearSelection}},[n(t.childComponents.Deselect,{tag:"component"})],1),t._v(" "),t._t("open-indicator",[t.noDrop?t._e():n(t.childComponents.OpenIndicator,t._b({tag:"component"},"component",t.scope.openIndicator.attributes,!1))],null,t.scope.openIndicator),t._v(" "),t._t("spinner",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.mutableLoading,expression:"mutableLoading"}],staticClass:"vs__spinner"},[t._v("Loading...")])],null,t.scope.spinner)],2)]),t._v(" "),n("transition",{attrs:{name:t.transition}},[t.dropdownOpen?n("ul",{ref:"dropdownMenu",staticClass:"vs__dropdown-menu",attrs:{role:"listbox"},on:{mousedown:t.onMousedown,mouseup:t.onMouseUp}},[t._l(t.filteredOptions,function(e,o){return n("li",{key:o,staticClass:"vs__dropdown-option",class:{"vs__dropdown-option--selected":t.isOptionSelected(e),"vs__dropdown-option--highlight":o===t.typeAheadPointer},attrs:{role:"option"},on:{mouseover:function(e){t.typeAheadPointer=o},mousedown:function(n){return n.preventDefault(),n.stopPropagation(),t.select(e)}}},[t._t("option",[t._v("\n          "+t._s(t.getOptionLabel(e))+"\n        ")],null,t.normalizeOptionForSlot(e))],2)}),t._v(" "),t.filteredOptions.length?t._e():n("li",{staticClass:"vs__no-options",on:{mousedown:function(t){t.stopPropagation()}}},[t._t("no-options",[t._v("Sorry, no matching options.")])],2)],2):t._e()])],1)},[],!1,null,null,null).exports),g={ajax:d,pointer:p,pointerScroll:h};n.d(e,"VueSelect",function(){return m}),n.d(e,"mixins",function(){return g});e.default=m}])});
//# sourceMappingURL=vue-select.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(265);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("575941b1", content, true, {});

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".v-select{position:relative;font-family:inherit}.v-select,.v-select *{box-sizing:border-box}@-webkit-keyframes vSelectSpinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes vSelectSpinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.vs__fade-enter-active,.vs__fade-leave-active{transition:opacity .15s cubic-bezier(1,.5,.8,1)}.vs__fade-enter,.vs__fade-leave-to{opacity:0}.vs--disabled .vs__clear,.vs--disabled .vs__dropdown-toggle,.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected{cursor:not-allowed;background-color:#f8f8f8}.v-select[dir=rtl] .vs__actions{padding:0 3px 0 6px}.v-select[dir=rtl] .vs__clear{margin-left:6px;margin-right:0}.v-select[dir=rtl] .vs__deselect{margin-left:0;margin-right:2px}.v-select[dir=rtl] .vs__dropdown-menu{text-align:right}.vs__dropdown-toggle{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:flex;padding:0 0 4px;background:none;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal}.vs__selected-options{display:flex;flex-basis:100%;flex-grow:1;flex-wrap:wrap;padding:0 2px;position:relative}.vs__actions{display:flex;align-items:center;padding:4px 6px 0 3px}.vs--searchable .vs__dropdown-toggle{cursor:text}.vs--unsearchable .vs__dropdown-toggle{cursor:pointer}.vs--open .vs__dropdown-toggle{border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.vs__open-indicator{fill:rgba(60,60,60,.5);-webkit-transform:scale(1);transform:scale(1);transition:-webkit-transform .15s cubic-bezier(1,-.115,.975,.855);transition:transform .15s cubic-bezier(1,-.115,.975,.855);transition:transform .15s cubic-bezier(1,-.115,.975,.855),-webkit-transform .15s cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855)}.vs--open .vs__open-indicator{-webkit-transform:rotate(180deg) scale(1);transform:rotate(180deg) scale(1)}.vs--loading .vs__open-indicator{opacity:0}.vs__clear{fill:rgba(60,60,60,.5);padding:0;border:0;background-color:transparent;cursor:pointer;margin-right:8px}.vs__dropdown-menu{display:block;position:absolute;top:calc(100% - 1px);left:0;z-index:1000;padding:5px 0;margin:0;width:100%;max-height:350px;min-width:160px;overflow-y:auto;box-shadow:0 3px 6px 0 rgba(0,0,0,.15);border:1px solid rgba(60,60,60,.26);border-top-style:none;border-radius:0 0 4px 4px;text-align:left;list-style:none;background:#fff}.vs__no-options{text-align:center}.vs__dropdown-option{line-height:1.42857143;display:block;padding:3px 20px;clear:both;color:#333;white-space:nowrap}.vs__dropdown-option:hover{cursor:pointer}.vs__dropdown-option--highlight{background:#5897fb;color:#fff}.vs__selected{display:flex;align-items:center;background-color:#f0f0f0;border:1px solid rgba(60,60,60,.26);border-radius:4px;color:#333;line-height:1.4;margin:4px 2px 0;padding:0 .25em}.vs__deselect{display:inline-flex;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-left:4px;padding:0;border:0;cursor:pointer;background:none;fill:rgba(60,60,60,.5);text-shadow:0 1px 0 #fff}.vs--single .vs__selected{background-color:transparent;border-color:transparent}.vs--single.vs--open .vs__selected{position:absolute;opacity:.4}.vs--single.vs--searching .vs__selected{display:none}.vs__search::-ms-clear,.vs__search::-webkit-search-cancel-button,.vs__search::-webkit-search-decoration,.vs__search::-webkit-search-results-button,.vs__search::-webkit-search-results-decoration{display:none}.vs__search,.vs__search:focus{-webkit-appearance:none;-moz-appearance:none;appearance:none;line-height:1.4;font-size:1em;border:1px solid transparent;border-left:none;outline:none;margin:4px 0 0;padding:0 7px;background:none;box-shadow:none;width:0;max-width:100%;flex-grow:1}.vs__search::-webkit-input-placeholder{color:inherit}.vs__search:-ms-input-placeholder,.vs__search::-ms-input-placeholder{color:inherit}.vs__search::placeholder{color:inherit}.vs--unsearchable .vs__search{opacity:1}.vs--unsearchable .vs__search:hover{cursor:pointer}.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search{opacity:.2}.vs__spinner{align-self:center;opacity:0;font-size:5px;text-indent:-9999em;overflow:hidden;border:.9em solid rgba(99,99,99,.1);border-left-color:rgba(60,60,60,.45);-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:vSelectSpinner 1.1s linear infinite;animation:vSelectSpinner 1.1s linear infinite;transition:opacity .1s}.vs__spinner,.vs__spinner:after{border-radius:50%;width:5em;height:5em}.vs--loading .vs__spinner{opacity:1}", ""]);

// exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(267);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("68d98741", content, true, {});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".search-box-wrapper.style1 .search-tab-content .title-container{background:#ec008b}.search-box-wrapper.style1 .search-tab-content .title-container-srvcs{background:#4a6e89}.checkbox.checked:before,.radio.checked:before{border-color:#ec008b;color:#fff;background:#ec008b;content:\"\\E8BA\"}.radiosrvcs.checked:before{border-color:#4a6e89;color:#fff;background:#4a6e89;content:\"\\E8BA\"}.icon-check-srvcs{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check-srvcs:after{content:\"\";position:absolute;top:0;right:0;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}.style-chooser .vs__dropdown-menu,.style-chooser .vs__dropdown-toggle,.style-chooser .vs__search::placeholder{background:#ec008b;color:#fff}.style-chooser .vs__clear,.style-chooser .vs__open-indicator{fill:#fff}.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected,.vs__dropdown-toggle{background-color:#ec008b}.vs__select,.vs__selected{color:#fff;font-size:14px}.vs__search,.vs__search:focus{line-height:2.7}.vs__dropdown-option{color:#fff}.vs__dropdown-option--highlight{background:#5897fb;color:#fff;font-size:14px}.style-chooser-srvcs .vs__dropdown-menu,.style-chooser-srvcs .vs__dropdown-toggle,.style-chooser-srvcs .vs__search::placeholder{background:#4a6e89;color:#fff}.style-chooser-srvcs .vs__clear,.style-chooser-srvcs .vs__open-indicator{fill:#fff}.style-chooser-srvcs .vs--disabled .vs__open-indicator,.style-chooser-srvcs.vs--disabled .vs__search,.style-chooser-srvcs .vs--disabled .vs__selected,.style-chooser-srvcs .vs__dropdown-toggle{background-color:#4a6e89}.vs--disabled .vs__open-indicator{opacity:0}.style-chooser .vs--disabled .vs__clear,.style-chooser .vs--disabled .vs__dropdown-toggle,.style-chooser .vs--disabled .vs__open-indicator,.style-chooser .vs--disabled .vs__search,.style-chooser .vs--disabled .vs__selected{background-color:#ec008b;color:#fff}.style-chooser-srvcs .vs--disabled{background-color:#4a6e89!important;color:#fff}.vs__dropdown-menu{background:#ec008b;color:#fff}.style-chooser-srvcs .vs__dropdown-menu{background:#4a6e89;color:#fff}.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected,.vs__dropdown-toggle{color:#fff}.vs--disabled .vs__clear,.vs--disabled .vs__dropdown-toggle,.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected{opacity:.8}.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected,.vs__dropdown-toggle{background-color:transparent}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.search-box-wrapper.style1 .search-tab-content .search-content{padding:18px 25px 25px;padding:18px 10px 10px}}", ""]);

// exports


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[(_vm.modulo === 'booking')?_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlineflights[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-plane-right takeoff-effect"})]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"title-container",style:({ background: '#4A6E89' })},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlineservices[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-plane-right takeoff-effect"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-content"},[(_vm.modulo === 'booking')?_c('div',{staticClass:"row choose-travel"},[_c('div',{staticClass:"col-xs-4"},[_c('label',{staticClass:"radio radio-inline"},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"1","checked":""},on:{"change":function($event){_vm.outwardonly = false; _vm.returntoother = false;}}}),_vm._v(_vm._s(_vm.outwardandreturnflight[_vm.getCurrentLocale])+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('label',{staticClass:"radio radio-inline"},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"2"},on:{"change":function($event){_vm.outwardonly = true; _vm.returntoother = false;}}}),_vm._v(_vm._s(_vm.outwardonlyflight[_vm.getCurrentLocale])+"\n                    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modulo !== 'services'),expression:"modulo !== 'services'"}],staticClass:"col-xs-4"},[_c('label',{staticClass:"radio radio-inline"},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"2"},on:{"change":function($event){_vm.outwardonly = false; _vm.returntoother = true; _vm.onChange_Radio_checkIfSomethingAlreadyChosen();}}}),_vm._v(_vm._s(_vm.returntootherflight[_vm.getCurrentLocale])+"\n                    ")])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"row choose-travel"},[_c('div',{staticClass:"col-xs-4"},[_c('label',{staticClass:"radio radio-inline radiosrvcs"},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"1","checked":""},on:{"change":function($event){_vm.outwardonly = false; _vm.returntoother = false;}}}),_vm._v(_vm._s(_vm.outwardandreturnflight[_vm.getCurrentLocale])+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('label',{staticClass:"radio radio-inline radiosrvcs"},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"2"},on:{"change":function($event){_vm.outwardonly = true; _vm.returntoother = false;}}}),_vm._v(_vm._s(_vm.outwardonlyflight[_vm.getCurrentLocale])+"\n                    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modulo === 'services'),expression:"modulo === 'services'"}],staticClass:"col-xs-4"},[_c('label',{staticClass:"radio radio-inline radiosrvcs"},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"2"},on:{"change":function($event){_vm.outwardonly = false; _vm.returntoother = true; _vm.onChange_Radio_checkIfSomethingAlreadyChosen();}}}),_vm._v(_vm._s(_vm.returntootherflight[_vm.getCurrentLocale])+"\n                    ")])])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.where[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdeparture[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"depArprtCode",staticClass:"style-chooser",attrs:{"name":"depArprtCode","clearable":false,"disabled":!_vm.departuresLoaded,"options":_vm.airportsOrigins,"label":"l","value":_vm.i,"placeholder":this.departureairport[this.getCurrentLocale]},on:{"input":_vm.call_listAirportsDestinations},model:{value:(_vm.depArprtCode),callback:function ($$v) {_vm.depArprtCode=$$v},expression:"depArprtCode"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdestination[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"desArprtCode",staticClass:"style-chooser",attrs:{"name":"desArprtCode","clearable":false,"disabled":!_vm.destinationsLoaded,"options":_vm.airportsDestinations,"label":"l","value":_vm.i,"placeholder":this.destinationairport[this.getCurrentLocale]},on:{"input":_vm.call_listAirportsReturnToOther},model:{value:(_vm.desArprtCode),callback:function ($$v) {_vm.desArprtCode=$$v},expression:"desArprtCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdeparture[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"depArprtCode",staticClass:"style-chooser-srvcs",attrs:{"name":"depArprtCode","clearable":false,"disabled":!_vm.departuresLoaded,"options":_vm.airportsOrigins,"label":"l","value":_vm.i,"placeholder":this.departureairport[this.getCurrentLocale]},on:{"input":_vm.call_listAirportsDestinations},model:{value:(_vm.depArprtCode),callback:function ($$v) {_vm.depArprtCode=$$v},expression:"depArprtCode"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdestination[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"desArprtCode",staticClass:"style-chooser-srvcs",attrs:{"name":"desArprtCode","clearable":false,"disabled":!_vm.destinationsLoaded,"options":_vm.airportsDestinations,"label":"l","value":_vm.i,"placeholder":this.destinationairport[this.getCurrentLocale]},on:{"input":_vm.call_listAirportsReturnToOther},model:{value:(_vm.desArprtCode),callback:function ($$v) {_vm.desArprtCode=$$v},expression:"desArprtCode"}})],1)]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking' && _vm.returntoother === true)?_c('div',{staticClass:"row",staticStyle:{"padding-top":"20px"}},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdeparturetoother[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"depArprtCode_returntoother",staticClass:"style-chooser",attrs:{"name":"depArprtCode_returntoother","clearable":false,"disabled":"","label":"l","value":_vm.i,"placeholder":this.departureairporttoother[this.getCurrentLocale]},model:{value:(_vm.depArprtCode_returntoother),callback:function ($$v) {_vm.depArprtCode_returntoother=$$v},expression:"depArprtCode_returntoother"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdestinationtoother[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"desArprtCode_returntoother",staticClass:"style-chooser",attrs:{"name":"desArprtCode_returntoother","clearable":false,"disabled":!_vm.returntootherLoaded,"label":"l","value":_vm.i,"placeholder":this.destinationairporttoother[this.getCurrentLocale],"options":_vm.airportsReturntoother},model:{value:(_vm.desArprtCode_returntoother),callback:function ($$v) {_vm.desArprtCode_returntoother=$$v},expression:"desArprtCode_returntoother"}})],1)]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services' && _vm.returntoother === true)?_c('div',{staticClass:"row",staticStyle:{"padding-top":"20px"}},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdeparturetoother[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"depArprtCode_returntoother",staticClass:"style-chooser-srvcs",attrs:{"name":"depArprtCode_returntoother","clearable":false,"disabled":"","label":"l","value":_vm.i,"placeholder":this.departureairporttoother[this.getCurrentLocale]},model:{value:(_vm.depArprtCode_returntoother),callback:function ($$v) {_vm.depArprtCode_returntoother=$$v},expression:"depArprtCode_returntoother"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdestinationtoother[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"desArprtCode_returntoother",staticClass:"style-chooser-srvcs",attrs:{"name":"desArprtCode_returntoother","clearable":false,"disabled":!_vm.returntootherLoaded,"label":"l","value":_vm.i,"placeholder":this.destinationairporttoother[this.getCurrentLocale],"options":_vm.airportsReturntoother},model:{value:(_vm.desArprtCode_returntoother),callback:function ($$v) {_vm.desArprtCode_returntoother=$$v},expression:"desArprtCode_returntoother"}})],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.when[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.departuredate[_vm.getCurrentLocale])+":")]),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"datepicker-wrap sundair"},[_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","name":"date_from","placeholder":"dd.mm.yy"},domProps:{"value":_vm.today}})]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"datepicker-wrap sundairsrvcs"},[_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","name":"date_from","placeholder":"dd.mm.yy"},domProps:{"value":_vm.today}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.outwardonly === false),expression:"outwardonly === false"}]},[_vm._v(_vm._s(_vm.returndate[_vm.getCurrentLocale])+":")]),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.outwardonly === false),expression:"outwardonly === false"}],staticClass:"datepicker-wrap sundair"},[_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","name":"date_to","placeholder":"dd.mm.yy"},domProps:{"value":_vm.tommorow}})]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.outwardonly === false),expression:"outwardonly === false"}],staticClass:"datepicker-wrap sundairsrvcs"},[_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","name":"date_to","placeholder":"dd.mm.yy"},domProps:{"value":_vm.tommorow}})]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.who[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.adult[_vm.getCurrentLocale])),_c('br'),_vm._v(_vm._s(_vm.adultyears[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"noADT"},_vm._l((_vm.listOfPaxes),function(value,key){return _c('option',{key:key,domProps:{"value":value}},[_vm._v(_vm._s(value))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.child[_vm.getCurrentLocale])),_c('br'),_vm._v(_vm._s(_vm.childyears[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"noCHD"},_vm._l((_vm.listOfPaxes),function(value,key){return _c('option',{key:key,domProps:{"value":value}},[_vm._v(_vm._s(value))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.infant[_vm.getCurrentLocale])),_c('br'),_vm._v(_vm._s(_vm.infantyears[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"noINF"},_vm._l((_vm.listOfPaxes),function(value,key){return _c('option',{key:key,domProps:{"value":value}},[_vm._v(_vm._s(value))])}))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.modulo === 'booking' && _vm.depArprtCode !== '' && _vm.desArprtCode !== '')?_c('button',{staticClass:"btn-medium icon-check uppercase full-width",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.findflights[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking' && (_vm.depArprtCode === '' || _vm.desArprtCode === ''))?_c('a',{staticClass:"button btn-medium uppercase full-width silver"},[_vm._v(_vm._s(_vm.findflights[_vm.getCurrentLocale])+" ")]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services' && _vm.depArprtCode !== '' && _vm.desArprtCode !== '')?_c('button',{staticClass:"btn-medium icon-check-srvcs uppercase full-width",style:({ background: '#4A6E89' }),attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.findflights[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services' && (_vm.depArprtCode === '' || _vm.desArprtCode === ''))?_c('a',{staticClass:"button btn-medium uppercase full-width silver"},[_vm._v(_vm._s(_vm.findflights[_vm.getCurrentLocale])+" ")]):_vm._e()])]),_vm._v(" "),_c('modal',{attrs:{"name":"booking-error-modal","transition":"nice-modal-fade","classes":"demo-modal-class","min-width":100,"min-height":100,"pivot-y":0.5,"adaptive":true,"scrollable":true,"reset":true,"width":"500px","height":"auto"},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"booking-error-modal-content",staticStyle:{"border":"2px solid red"}},[_c('section',{staticStyle:{"padding":"20px","min-height":"100px"},attrs:{"id":"content"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"10px"}},[_c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-notice circle"})]),_vm._v(_vm._s(_vm.modal_headline_rebooking_error[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.modal_content_rebooking_error[_vm.getCurrentLocale])}})])])])]),_vm._v(" "),_c('button',{staticClass:"btn-large full-width totalbutton sundair",staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important","margin-bottom":"0px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.onClick_CloseModal()}}},[_vm._v(" "+_vm._s(_vm.closemodal[_vm.getCurrentLocale]))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(270);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3e356d47", content, true, {});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".tab-container .tab-content .tab-pane[data-v-551dc5b0]{padding:0}.tab-container .tab-content[data-v-551dc5b0]{background:none}.tab-container .tab-content .tab-pane .row[data-v-551dc5b0]{margin-bottom:1px}.pricing-table[data-v-551dc5b0]{padding:0;padding-top:15px;padding-bottom:0;background:none}.listing-style3 [class^=soap-icon].circle.yellowchossen[data-v-551dc5b0],.listing-style3 [class^=soap-icon].circle[data-v-551dc5b0]:hover{color:#ec008b}.listing-style3 [class^=soap-icon].circle.bluechossen[data-v-551dc5b0]{color:#4a6e89}.listing-style3 [class^=soap-icon].circle.greychossen[data-v-551dc5b0]{color:#d9d9d8}.alert.alert-info[data-v-551dc5b0]{background:#64a8db}.listing-style3.flight figure span img[data-v-551dc5b0]{max-width:35px}.silver-color[data-v-551dc5b0]{color:#d9d9d8!important}.tab-container.style1 ul.tabs li.active>a[data-v-551dc5b0],.tab-container.style1 ul.tabs li:hover>a[data-v-551dc5b0]{color:#fff;background:#ec008b;position:relative}.tab-container.style1 ul.tabs.srvcs li.active_srvcs>a[data-v-551dc5b0],.tab-container.style1 ul.tabs.srvcs li:hover>a[data-v-551dc5b0]{color:#fff;background:#4a6e89;position:relative}.tab-container.style1 ul.tabs.srvcs li.active_srvcs>a[data-v-551dc5b0]:after,.tab-container.style1 ul.tabs.srvcs li:hover>a[data-v-551dc5b0]:after{position:absolute;bottom:-5px;left:50%;margin-left:-10px;border-top:5px solid #4a6e89;border-left:7px solid transparent;border-right:7px solid transparent;content:\"\"}.div_hover[data-v-551dc5b0]{margin-bottom:2px}.div_hover[data-v-551dc5b0]:hover{box-shadow:0 0 .5px .5px #c0de92}.icon-check2[data-v-551dc5b0]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check2[data-v-551dc5b0]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #ec008b}.icon-check3[data-v-551dc5b0]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check3[data-v-551dc5b0]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}.image-box .discount[data-v-551dc5b0]{line-height:70px;text-indent:-10px}.skin-color-srvcs[data-v-551dc5b0]{color:#4a6e89}.listing-style3.flight figure span img[data-v-551dc5b0]{max-width:85px}.topDistance[data-v-551dc5b0]{margin-top:25px}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-551dc5b0],h3[data-v-551dc5b0]{font-size:1.5em}h4[data-v-551dc5b0]{font-size:1.2em}.topDistance[data-v-551dc5b0]{margin-top:17px}a.button.btn-small[data-v-551dc5b0],button.btn-small[data-v-551dc5b0],input[type=button].button.btn-small[data-v-551dc5b0]{font-size:.7em}.price[data-v-551dc5b0]{font-size:1.4em}.listing-style3.flight .details .details-wrapper>*>[data-v-551dc5b0]{display:table-cell;padding:3px 3px 0}.listing-style3 [class^=soap-icon].circle[data-v-551dc5b0]{font-size:13px}.button.btn-mini[data-v-551dc5b0]{padding-left:5px;padding-right:5px}.listing-style3.flight figure span img[data-v-551dc5b0]{max-width:35px}.listing-style3.flight .details .details-wrapper .time>div[data-v-551dc5b0]{padding-left:5px}.image-box .discount[data-v-551dc5b0]{font-size:.75em}a.button.btn-large[data-v-551dc5b0],button.btn-large[data-v-551dc5b0],input[type=button].button.btn-large[data-v-551dc5b0]{font-size:1em}.listing-style3.flight.box[data-v-551dc5b0],.listing-style3.flight .box[data-v-551dc5b0]{padding:4px}}.buttonglowing[data-v-551dc5b0]{background-color:#004a7f;-webkit-border-radius:5px;border-radius:5px;border:none;color:#fff;cursor:pointer;-webkit-animation:glowing-data-v-551dc5b0 1.5s infinite;-moz-animation:glowing-data-v-551dc5b0 1.5s infinite;-o-animation:glowing-data-v-551dc5b0 1.5s infinite;animation:glowing-data-v-551dc5b0 1.5s infinite}@-webkit-keyframes glowing-data-v-551dc5b0{0%{background-color:#e11a33;-webkit-box-shadow:0 0 3px #e11a33}50%{background-color:#7c2525;-webkit-box-shadow:0 0 20px #7c2525}to{background-color:#e11a33;-webkit-box-shadow:0 0 3px #e11a33}}@-moz-keyframes glowing-data-v-551dc5b0{0%{background-color:#e11a33;-moz-box-shadow:0 0 3px #e11a33}50%{background-color:#7c2525;-moz-box-shadow:0 0 20px #7c2525}to{background-color:#e11a33;-moz-box-shadow:0 0 3px #e11a33}}@-o-keyframes glowing-data-v-551dc5b0{0%{background-color:#e11a33;box-shadow:0 0 3px #e11a33}50%{background-color:#7c2525;box-shadow:0 0 20px #7c2525}to{background-color:#e11a33;box-shadow:0 0 3px #e11a33}}@keyframes glowing-data-v-551dc5b0{0%{background-color:#e11a33;box-shadow:0 0 3px #e11a33}50%{background-color:#7c2525;box-shadow:0 0 0 #7c2525}to{background-color:#e11a33;box-shadow:0 0 3px #e11a33}}", ""]);

// exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(272);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("540532ad", content, true, {});

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "[data-v-477e7a86]{margin:0;padding:0;box-sizing:border-box}body[data-v-477e7a86],html[data-v-477e7a86]{height:100%;background-color:#333}.container[data-v-477e7a86]{display:flex;flex-direction:column;height:100%;width:100%;min-width:480px;padding:20px 15px}.breadcrumb[data-v-477e7a86]{display:flex;border-radius:6px;overflow:hidden;margin:auto;text-align:center;top:50%;width:100%;height:57px;-webkit-transform:translateY(-50%);transform:translateY(-50%);xbox-shadow:0 1px 1px #000,0 4px 14px rgba(0,0,0,.7);z-index:1;background-color:#d9d9d8;font-size:14px}.breadcrumb a[data-v-477e7a86]{position:relative;display:flex;flex-grow:1;text-decoration:none;margin:auto;height:100%;padding-left:38px;padding-right:0;color:#9f9f9e}.breadcrumb a[data-v-477e7a86]:first-child{padding-left:15.2px}.breadcrumb a[data-v-477e7a86]:last-child{padding-right:15.2px}.breadcrumb a[data-v-477e7a86]:after{content:\"\";position:absolute;display:inline-block;width:57px;height:57px;top:0;right:-28.1481481481px;background-color:#d9d9d8;border-top-right-radius:5px;-webkit-transform:scale(.707) rotate(45deg);transform:scale(.707) rotate(45deg);box-shadow:1px -1px rgba(0,0,0,.25);z-index:1}.breadcrumb a[data-v-477e7a86]:last-child:after{content:none}.breadcrumb a.active[data-v-477e7a86],.breadcrumb a.active[data-v-477e7a86]:after{background:#ec008b;color:#fff}.breadcrumb_srvcs[data-v-477e7a86]{display:flex;border-radius:6px;overflow:hidden;margin:auto;text-align:center;top:50%;width:100%;height:57px;-webkit-transform:translateY(-50%);transform:translateY(-50%);xbox-shadow:0 1px 1px #000,0 4px 14px rgba(0,0,0,.7);z-index:1;background-color:#d9d9d8;font-size:14px}.breadcrumb_srvcs a[data-v-477e7a86]{position:relative;display:flex;flex-grow:1;text-decoration:none;margin:auto;height:100%;padding-left:38px;padding-right:0;color:#9f9f9e}.breadcrumb_srvcs a[data-v-477e7a86]:first-child{padding-left:15.2px}.breadcrumb_srvcs a[data-v-477e7a86]:last-child{padding-right:15.2px}.breadcrumb_srvcs a[data-v-477e7a86]:after{content:\"\";position:absolute;display:inline-block;width:57px;height:57px;top:0;right:-28.1481481481px;background-color:#d9d9d8;border-top-right-radius:5px;-webkit-transform:scale(.707) rotate(45deg);transform:scale(.707) rotate(45deg);box-shadow:1px -1px rgba(0,0,0,.25);z-index:1}.breadcrumb_srvcs a[data-v-477e7a86]:last-child:after{content:none}.breadcrumb_srvcs a.active[data-v-477e7a86],.breadcrumb_srvcs a.active[data-v-477e7a86]:after{background:#4a6e89;color:#fff}.breadcrumb_rebooking[data-v-477e7a86]{display:flex;border-radius:6px;overflow:hidden;margin:auto;text-align:center;top:50%;width:100%;height:57px;-webkit-transform:translateY(-50%);transform:translateY(-50%);xbox-shadow:0 1px 1px #000,0 4px 14px rgba(0,0,0,.7);z-index:1;background-color:#d9d9d8;font-size:14px}.breadcrumb_rebooking a[data-v-477e7a86]{position:relative;display:flex;flex-grow:1;text-decoration:none;margin:auto;height:100%;padding-left:38px;padding-right:0;color:#9f9f9e}.breadcrumb_rebooking a[data-v-477e7a86]:first-child{padding-left:15.2px}.breadcrumb_rebooking a[data-v-477e7a86]:last-child{padding-right:15.2px}.breadcrumb_rebooking a[data-v-477e7a86]:after{content:\"\";position:absolute;display:inline-block;width:57px;height:57px;top:0;right:-28.1481481481px;background-color:#d9d9d8;border-top-right-radius:5px;-webkit-transform:scale(.707) rotate(45deg);transform:scale(.707) rotate(45deg);box-shadow:1px -1px rgba(0,0,0,.25);z-index:1}.breadcrumb_rebooking a[data-v-477e7a86]:last-child:after{content:none}.breadcrumb_rebooking a.active[data-v-477e7a86],.breadcrumb_rebooking a.active[data-v-477e7a86]:after{background:#fdb714;color:#fff}.breadcrumb__inner[data-v-477e7a86]{display:flex;flex-direction:column;margin:auto;z-index:2}.breadcrumb__title[data-v-477e7a86]{font-weight:700;font-size:12px;letter-spacing:.48px;text-transform:uppercase}.breadcrumb__desc[data-v-477e7a86]{font-weight:700;font-size:10px;letter-spacing:.48px;text-transform:uppercase}@media (max-width:1000px){.breadcrumb[data-v-477e7a86],.breadcrumb_srvcs[data-v-477e7a86]{font-size:12px}}@media (max-width:710px){.breadcrumb__desc[data-v-477e7a86]{display:none}.breadcrumb[data-v-477e7a86]{height:38px}.breadcrumb a[data-v-477e7a86]{padding-left:25.3333333333px}.breadcrumb a[data-v-477e7a86]:after{content:\"\";width:38px;height:38px;right:-19px;-webkit-transform:scale(.707) rotate(45deg);transform:scale(.707) rotate(45deg)}.breadcrumb_srvcs[data-v-477e7a86]{height:38px}.breadcrumb_srvcs a[data-v-477e7a86]{padding-left:25.3333333333px}.breadcrumb_srvcs a[data-v-477e7a86]:after{content:\"\";width:38px;height:38px;right:-19px;-webkit-transform:scale(.707) rotate(45deg);transform:scale(.707) rotate(45deg)}}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.breadcrumb__title[data-v-477e7a86]{font-size:11px}}", ""]);

// exports


/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{class:{ breadcrumb: _vm.module === 'booking',  breadcrumb_srvcs: _vm.module === 'services',  breadcrumb_rebooking: _vm.module === 'rebooking' }},[_c('a',{class:{ active: _vm.active_item === 'first' }},[(_vm.module === 'booking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.bc_firstitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 1")])]):_vm._e(),_vm._v(" "),(_vm.module === 'services' && _vm.get_areWeInServicesBookingNoMode === false)?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.srvcs_firstitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 1")])]):_vm._e(),_vm._v(" "),(_vm.module === 'services' && _vm.get_areWeInServicesBookingNoMode === true)?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.srvcsbookingno_firstitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 1")])]):_vm._e(),_vm._v(" "),(_vm.module === 'rebooking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.rebooking_firstitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 1")])]):_vm._e()]),_vm._v(" "),_c('a',{class:{ active: _vm.active_item === 'second' }},[_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.bc_seconditem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 2")])])]),_vm._v(" "),_c('a',{class:{ active: _vm.active_item === 'third' }},[(_vm.module !== 'rebooking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.bc_thirditem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 3")])]):_vm._e(),_vm._v(" "),(_vm.module === 'rebooking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.rebooking_thirditem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 3")])]):_vm._e()]),_vm._v(" "),_c('a',{class:{ active: _vm.active_item === 'fourth' }},[(_vm.module !== 'rebooking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.bc_fourthitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 4")])]):_vm._e(),_vm._v(" "),(_vm.module === 'rebooking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.rebooking_fourthitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 4")])]):_vm._e()]),_vm._v(" "),_c('a',{class:{ active: _vm.active_item === 'fifth' }},[(_vm.module !== 'rebooking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.bc_fifthitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 5")])]):_vm._e(),_vm._v(" "),(_vm.module === 'rebooking')?_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.rebooking_fifthitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 5")])]):_vm._e()]),_vm._v(" "),(_vm.module === 'rebooking')?_c('a',{class:{ active: _vm.active_item === 'sixth' }},[_c('span',{staticClass:"breadcrumb__inner"},[_c('span',{staticClass:"breadcrumb__title"},[_vm._v(_vm._s(_vm.rebooking_sixthitem[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',{staticClass:"breadcrumb__desc"},[_vm._v(_vm._s(_vm.step[_vm.getCurrentLocale])+" 6")])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flight_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f149f7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flight_vue__ = __webpack_require__(287);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Flight_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f149f7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Flight_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstRowBooking_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25714b1f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstRowBooking_vue__ = __webpack_require__(276);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstRowBooking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25714b1f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstRowBooking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"first-row"},[(_vm.flightdirection === 'outward')?_c('div',[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flight.depArprt.i)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+" "+_vm._s(_vm.flight.desArprt.i)),_c('small',[_vm._v(_vm._s(_vm.whichFlightDirection(_vm.flight.depArprt.i))+" - "+_vm._s(_vm.flight.no))])]),_vm._v(" "),_c('a',{staticClass:"button btn-mini silver",class:{ yellow: _vm.getBookingFlightIdSelectedOutward === _vm.flight.id },staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important","color":"#4f657e"}},[_vm._v("STOPS: "+_vm._s(_vm.flight.stpArprt === null ? '0' : '1'))]),_vm._v(" "),(_vm.getBookingFlightIdSelectedOutward === _vm.flight.id && (_vm.flight.prcs[0] !== undefined && _vm.flight.warn === ''))?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_services[_vm.getCurrentLocale]),expression:"amenities_services[getCurrentLocale]"}],staticClass:"soap-icon-passenger circle yellowchossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_meal[_vm.getCurrentLocale]),expression:"amenities_meal[getCurrentLocale]"}],staticClass:"soap-icon-fork circle yellowchossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_lugagge[_vm.getCurrentLocale]),expression:"amenities_lugagge[getCurrentLocale]"}],staticClass:"soap-icon-suitcase circle yellowchossen"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.getBookingFlightIdSelectedOutward !== _vm.flight.id || (_vm.flight.prcs[0] === undefined || _vm.flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY'))?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{staticClass:"soap-icon-passenger circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{staticClass:"soap-icon-fork circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{staticClass:"soap-icon-suitcase circle greychossen"}):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('div',[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flight.depArprt.i)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+" "+_vm._s(_vm.flight.desArprt.i)),_c('small',[_vm._v(_vm._s(_vm.whichFlightDirection(_vm.flight.depArprt.i))+" - "+_vm._s(_vm.flight.no))])]),_vm._v(" "),_c('a',{staticClass:"button btn-mini silver",class:{ yellow: _vm.getBookingFlightIdSelectedReturn === _vm.flight.id },staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important","color":"#4f657e"}},[_vm._v("STOPS: "+_vm._s(_vm.flight.stpArprt === null ? '0' : '1'))]),_vm._v(" "),(_vm.getBookingFlightIdSelectedReturn === _vm.flight.id && (_vm.flight.prcs[0] !== undefined && _vm.flight.warn === ''))?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_services[_vm.getCurrentLocale]),expression:"amenities_services[getCurrentLocale]"}],staticClass:"soap-icon-passenger circle yellowchossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_meal[_vm.getCurrentLocale]),expression:"amenities_meal[getCurrentLocale]"}],staticClass:"soap-icon-fork circle yellowchossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_lugagge[_vm.getCurrentLocale]),expression:"amenities_lugagge[getCurrentLocale]"}],staticClass:"soap-icon-suitcase circle yellowchossen"}):_vm._e()]):_vm._e(),_vm._v(" "),((_vm.getBookingFlightIdSelectedReturn !== _vm.flight.id) || (_vm.flight.prcs[0] === undefined || _vm.flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY'))?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{staticClass:"soap-icon-passenger circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{staticClass:"soap-icon-fork circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{staticClass:"soap-icon-suitcase circle greychossen"}):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.flight.prcs[0] !== undefined && _vm.flight.warn === '')?_c('span',{staticClass:"price"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.seetaxes[_vm.getCurrentLocale]),expression:"seetaxes[getCurrentLocale]"}],staticClass:"collapsed",attrs:{"href":'#acc' + _vm.flight.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.flight.id}},[_c('small',[_vm._v(_vm._s(_vm.avgpers[_vm.getCurrentLocale]))]),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.flight.prcs[0].amnt) + Number(_vm.flight.prcs[0].tax.tot)))+"\n        ")])]):_vm._e(),_vm._v(" "),(_vm.flight.prcs[0] === undefined || _vm.flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY')?_c('span',{staticClass:"price",staticStyle:{"color":"#D9D9D8","text-transform":"none"}},[_c('small',{staticStyle:{"color":"#D9D9D8"}},[_vm._v(_vm._s(_vm.avgpers[_vm.getCurrentLocale]))]),_c('span',{staticStyle:{"color":"rgb(142, 142, 142)"}},[_vm._v(_vm._s(_vm.out[_vm.getCurrentLocale]))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstRowServices_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f71026f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstRowServices_vue__ = __webpack_require__(278);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstRowServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f71026f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstRowServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"first-row"},[(_vm.flightdirection === 'outward')?_c('div',[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flight.depArprt.i)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+" "+_vm._s(_vm.flight.desArprt.i)),_c('small',[_vm._v(_vm._s(_vm.whichFlightDirection(_vm.flight.depArprt.i))+" - "+_vm._s(_vm.flight.no))])]),_vm._v(" "),_c('a',{staticClass:"button btn-mini silver",class:{ yellow: _vm.getBookingFlightIdSelectedOutward === _vm.flight.id },staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important"}},[_vm._v("STOPS: "+_vm._s(_vm.flight.stpArprt === null ? '0' : '1'))]),_vm._v(" "),(_vm.getBookingFlightIdSelectedOutward === _vm.flight.id)?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_services[_vm.getCurrentLocale]),expression:"amenities_services[getCurrentLocale]"}],staticClass:"soap-icon-passenger circle bluechossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_meal[_vm.getCurrentLocale]),expression:"amenities_meal[getCurrentLocale]"}],staticClass:"soap-icon-fork circle bluechossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_lugagge[_vm.getCurrentLocale]),expression:"amenities_lugagge[getCurrentLocale]"}],staticClass:"soap-icon-suitcase circle bluechossen"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.getBookingFlightIdSelectedOutward !== _vm.flight.id)?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{staticClass:"soap-icon-passenger circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{staticClass:"soap-icon-fork circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{staticClass:"soap-icon-suitcase circle greychossen"}):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('div',[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flight.depArprt.i)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+" "+_vm._s(_vm.flight.desArprt.i)),_c('small',[_vm._v(_vm._s(_vm.whichFlightDirection(_vm.flight.depArprt.i))+" - "+_vm._s(_vm.flight.no))])]),_vm._v(" "),_c('a',{staticClass:"button btn-mini silver",class:{ yellow: _vm.getBookingFlightIdSelectedReturn === _vm.flight.id },staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important"}},[_vm._v("STOPS: "+_vm._s(_vm.flight.stpArprt === null ? '0' : '1'))]),_vm._v(" "),(_vm.getBookingFlightIdSelectedReturn === _vm.flight.id)?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_services[_vm.getCurrentLocale]),expression:"amenities_services[getCurrentLocale]"}],staticClass:"soap-icon-passenger circle bluechossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_meal[_vm.getCurrentLocale]),expression:"amenities_meal[getCurrentLocale]"}],staticClass:"soap-icon-fork circle bluechossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.amenities_lugagge[_vm.getCurrentLocale]),expression:"amenities_lugagge[getCurrentLocale]"}],staticClass:"soap-icon-suitcase circle bluechossen"}):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.getBookingFlightIdSelectedReturn !== _vm.flight.id)?_c('div',{staticClass:"amenities"},[(_vm.flight.srvcSeat === true)?_c('i',{staticClass:"soap-icon-passenger circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.meal === true)?_c('i',{staticClass:"soap-icon-fork circle greychossen"}):_vm._e(),_vm._v(" "),(_vm.flight.serviceCategories.baggage === true)?_c('i',{staticClass:"soap-icon-suitcase circle greychossen"}):_vm._e()]):_vm._e()]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"price"},[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.isthisyourflight[_vm.getCurrentLocale]),expression:"isthisyourflight[getCurrentLocale]"}],staticClass:"collapsed",attrs:{"href":'#acc' + _vm.flight.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.flight.id}},[_c('small',[_vm._v(_vm._s(_vm.thisis[_vm.getCurrentLocale]))]),_vm._v(_vm._s(_vm.isthisyourflight[_vm.getCurrentLocale])+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondRowBooking_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f917590_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondRowBooking_vue__ = __webpack_require__(280);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondRowBooking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f917590_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondRowBooking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second-row"},[_c('div',{staticClass:"time"},[_c('div',{staticClass:"take-off col-sm-4"},[_c('div',{staticClass:"icon"},[(_vm.flight.prcs[0] !== undefined)?_c('i',{staticClass:"soap-icon-plane-right yellow-color"}):_vm._e(),_vm._v(" "),(_vm.flight.prcs[0] === undefined)?_c('i',{staticClass:"soap-icon-plane-right silver-color"}):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{class:{ 'skin-color': _vm.flight.prcs[0] !== undefined }},[_vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(_vm._f("moment")(_vm.flight.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale])+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"landing col-sm-4"},[_c('div',{staticClass:"icon"},[(_vm.flight.prcs[0] !== undefined)?_c('i',{staticClass:"soap-icon-plane-right yellow-color"}):_vm._e(),_vm._v(" "),(_vm.flight.prcs[0] === undefined)?_c('i',{staticClass:"soap-icon-plane-right silver-color"}):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{class:{ 'skin-color': _vm.flight.prcs[0] !== undefined }},[_vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(_vm._f("moment")(_vm.flight.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale])+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"total-time col-sm-4"},[_c('div',{staticClass:"icon"},[(_vm.flight.prcs[0] !== undefined)?_c('i',{staticClass:"soap-icon-clock yellow-color"}):_vm._e(),_vm._v(" "),(_vm.flight.prcs[0] === undefined)?_c('i',{staticClass:"soap-icon-clock silver-color"}):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{class:{ 'skin-color': _vm.flight.prcs[0] !== undefined }},[_vm._v(_vm._s(_vm.totaltime[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(_vm._f("durationFlight")(_vm.flight.dur))+"\n            ")])])]),_vm._v(" "),(_vm.flightdirection === 'outward' && _vm.flight.prcs[0] !== undefined && _vm.flight.warn === '')?_c('div',{staticClass:"action"},[(_vm.getBookingFlightIdSelectedOutward !== _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width xgreen",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.flightSelected({ flight: _vm.flight, type: 'outward', modulo: _vm.modulo })}}},[_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getBookingFlightIdSelectedOutward === _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width sundair"},[_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return' && _vm.flight.prcs[0] !== undefined && _vm.flight.warn === '')?_c('div',{staticClass:"action"},[(_vm.getBookingFlightIdSelectedReturn !== _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width xgreen",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.flightSelected({ flight: _vm.flight, type: 'return', modulo: _vm.modulo })}}},[_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getBookingFlightIdSelectedReturn === _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width sundair"},[_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.flight.prcs[0] === undefined || _vm.flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY')?_c('div',{staticClass:"action"},[_c('a',{staticClass:"button btn-small full-width silver",staticStyle:{"color":"rgba(0,0,0,.075)","background":"#F9F9F9"}},[_vm._v(_vm._s(_vm.selectflight[_vm.getCurrentLocale]))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondRowServices_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c7bc4e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondRowServices_vue__ = __webpack_require__(282);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondRowServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c7bc4e6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondRowServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"second-row"},[_c('div',{staticClass:"time"},[_c('div',{staticClass:"take-off col-sm-4"},[_c('div',{staticClass:"icon"},[(_vm.modulo === 'services')?_c('i',{staticClass:"soap-icon-plane-right yellow-color"}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.modulo === 'services')?_c('span',{staticClass:"skin-color-srvcs"},[_vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(_vm._f("moment")(_vm.flight.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale])+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"landing col-sm-4"},[_c('div',{staticClass:"icon"},[(_vm.modulo === 'services')?_c('i',{staticClass:"soap-icon-plane-right yellow-color"}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.modulo === 'services')?_c('span',{staticClass:"skin-color-srvcs"},[_vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(_vm._f("moment")(_vm.flight.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale])+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"total-time col-sm-4"},[_c('div',{staticClass:"icon"},[(_vm.modulo === 'services')?_c('i',{staticClass:"soap-icon-clock yellow-color"}):_vm._e()]),_vm._v(" "),_c('div',[(_vm.modulo === 'services')?_c('span',{staticClass:"skin-color-srvcs"},[_vm._v(_vm._s(_vm.totaltime[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("\n                "+_vm._s(_vm._f("durationFlight")(_vm.flight.dur))+"\n            ")])])]),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('div',{staticClass:"action"},[(_vm.getBookingFlightIdSelectedOutward !== _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width xgreen",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.flightSelected({ flight: _vm.flight, type: 'outward', modulo: _vm.modulo })}}},[_vm._v("\n            "+_vm._s(_vm.selectbookedflight[_vm.getCurrentLocale])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.getBookingFlightIdSelectedOutward === _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width sundairsrvcs"},[_vm._v(_vm._s(_vm.selectbookedflight[_vm.getCurrentLocale]))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('div',{staticClass:"action"},[(_vm.getBookingFlightIdSelectedReturn !== _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width xgreen",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.flightSelected({ flight: _vm.flight, type: 'return', modulo: _vm.modulo })}}},[_vm._v("\n            "+_vm._s(_vm.selectbookedflight[_vm.getCurrentLocale])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.getBookingFlightIdSelectedReturn === _vm.flight.id)?_c('a',{staticClass:"button btn-small full-width sundairsrvcs"},[_vm._v(_vm._s(_vm.selectbookedflight[_vm.getCurrentLocale]))]):_vm._e()]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxesAndFees_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b228553_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxesAndFees_vue__ = __webpack_require__(286);
function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b228553"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaxesAndFees_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b228553_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaxesAndFees_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(285);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("43f2b850", content, true, {});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".tab-container .tab-content .tab-pane[data-v-0b228553]{padding:0}.tab-container .tab-content[data-v-0b228553]{background:none}.tab-container .tab-content .tab-pane .row[data-v-0b228553]{margin-bottom:1px}.pricing-table[data-v-0b228553]{padding:0;padding-top:15px;padding-bottom:0;background:none}.tab-container.style1 ul.tabs li.active>a[data-v-0b228553],.tab-container.style1 ul.tabs li:hover>a[data-v-0b228553]{color:#fff;background:#ec008b;position:relative}.tab-container.style1 ul.tabs.srvcs li.active_rebooking>a[data-v-0b228553],.tab-container.style1 ul.tabs.srvcs li:hover>a[data-v-0b228553]{color:#fff;background:#fdb714;position:relative}.tab-container.style1 ul.tabs.srvcs li.active_rebooking>a[data-v-0b228553]:after,.tab-container.style1 ul.tabs.srvcs li:hover>a[data-v-0b228553]:after{position:absolute;bottom:-5px;left:50%;margin-left:-10px;border-top:5px solid #fdb714;border-left:7px solid transparent;border-right:7px solid transparent;content:\"\"}.icon-check3[data-v-0b228553]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check3[data-v-0b228553]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}.topDistance[data-v-0b228553]{margin-top:25px}a.button[data-v-0b228553]:hover{background:#fdb714}", ""]);

// exports


/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-container",attrs:{"id":'accordion' + _vm.flight.id}},[_c('div',{staticClass:"panel"},[_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'acc' + _vm.flight.id}},[_c('div',{staticClass:"panel-content",staticStyle:{"padding-top":"0px","padding-left":"15px"}},[_c('hr'),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.taxesandfees[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px","padding-right":"10px","margin-bottom":"0px","width":"50%"}},[_c('ul',{staticStyle:{"margin-bottom":"0px","font-size":"0.8333em"}},[_c('li',{staticClass:"skin-color uppercase"},[_vm._v(_vm._s(_vm.airfare[_vm.getCurrentLocale])+": "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.flight.prcs[0].amnt))))])]),_vm._v(" "),_c('li',{staticClass:"skin-color uppercase"},[_vm._v(_vm._s(_vm.airporttaxes[_vm.getCurrentLocale])+": "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.flight.prcs[0].tax.air)))])]),_vm._v(" "),_c('li',{staticClass:"skin-color uppercase"},[_vm._v(_vm._s(_vm.aviationtax[_vm.getCurrentLocale])+": "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.flight.prcs[0].tax.avia)))])]),_vm._v(" "),_c('li',{staticClass:"skin-color uppercase"},[_vm._v(_vm._s(_vm.kerosenesurcharge[_vm.getCurrentLocale])+": "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.flight.prcs[0].tax.fuel)))])]),_vm._v(" "),_c('li',{staticClass:"skin-color uppercase"},[_vm._v(_vm._s(_vm.securitycharges[_vm.getCurrentLocale])+": "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.flight.prcs[0].tax.sec)))])]),_vm._v(" "),_c('li',{staticClass:"skin-color uppercase"},[_vm._v(_vm._s(_vm.servicecharges[_vm.getCurrentLocale])+": "),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.flight.prcs[0].tax.srvc)))])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details col-xs-9 col-sm-10"},[_c('div',{staticClass:"details-wrapper"},[(_vm.modulo === 'booking')?_c('sdr-shared-fsr-flight-firstrow-booking',{attrs:{"flight":_vm.flight,"flightdirection":_vm.flightdirection,"modulo":_vm.modulo}}):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('sdr-shared-fsr-flight-firstrow-services',{attrs:{"flight":_vm.flight,"flightdirection":_vm.flightdirection,"modulo":_vm.modulo}}):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('sdr-shared-fsr-flight-secondrow-booking',{attrs:{"flight":_vm.flight,"flightdirection":_vm.flightdirection,"modulo":_vm.modulo}}):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('sdr-shared-fsr-flight-secondrow-services',{attrs:{"flight":_vm.flight,"flightdirection":_vm.flightdirection,"modulo":_vm.modulo}}):_vm._e()],1),_vm._v(" "),(_vm.modulo === 'booking' && _vm.flight.prcs[0] !== undefined && _vm.flight.warn === '')?_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"0px"}},[_c('sdr-shared-fsr-flight-taxesandfees',{attrs:{"flight":_vm.flight,"flightdirection":_vm.flightdirection,"modulo":_vm.modulo}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModifySearchBox_vue__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a4a1292_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModifySearchBox_vue__ = __webpack_require__(289);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModifySearchBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a4a1292_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModifySearchBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.keyToReRender,staticClass:"toggle-container filters-container"},[_c('div',{staticClass:"panel style1 arrow-right"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":"#modify-search-panel"}},[_vm._v(_vm._s(_vm.modifysearch[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"modify-search-panel"}},[_c('div',{staticClass:"panel-content"},[_c('div',{staticClass:"search-content"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.departuredate[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('vue-pikaday',{staticClass:"input-text full-width",attrs:{"name":"date_from","placeholder":_vm.pickdeparturedate[_vm.getCurrentLocale],"options":_vm.options[_vm.getCurrentLocale],"value":_vm._f("birthdate")(_vm.getBookingUsersSearchData.depAfter)},model:{value:(_vm.date_from),callback:function ($$v) {_vm.date_from=$$v},expression:"date_from"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingUsersSearchData.rTrip === true),expression:"getBookingUsersSearchData.rTrip === true"}]},[_vm._v(_vm._s(_vm.returndate[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('vue-pikaday',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingUsersSearchData.rTrip === true),expression:"getBookingUsersSearchData.rTrip === true"}],staticClass:"input-text full-width",attrs:{"name":"date_to","placeholder":_vm.pickreturndate[_vm.getCurrentLocale],"options":_vm.options[_vm.getCurrentLocale],"value":_vm._f("birthdate")(_vm.getBookingUsersSearchData.retAfter)},model:{value:(_vm.date_to),callback:function ($$v) {_vm.date_to=$$v},expression:"date_to"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-medium icon-check uppercase full-width"},[_vm._v(_vm._s(_vm.searchagain[_vm.getCurrentLocale]))])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(291);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3bdb1b6f", content, true, {});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "article[data-v-5016ec47]{margin-bottom:2px}.detailed-logo .box-title[data-v-5016ec47]{margin-top:5px;padding-bottom:5px}.booking-details .details[data-v-5016ec47]{padding-top:0}.sdr-box .box-title[data-v-5016ec47]{margin-bottom:15px}.booking-details .other-details dd[data-v-5016ec47],.booking-details .other-details dt[data-v-5016ec47]{padding:.8em 0}.sdr-box .box-title[data-v-5016ec47]{margin-bottom:5px}a.button.btn-large[data-v-5016ec47],button.btn-large[data-v-5016ec47],input[type=button].button.btn-large[data-v-5016ec47]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.paxheadline[data-v-5016ec47]{margin-bottom:4px;padding-top:4px}.fade-enter[data-v-5016ec47]{opacity:0}.fade-enter-active[data-v-5016ec47]{transition:opacity 1s}.fade-leave-active[data-v-5016ec47]{transition:opacity 1s;opacity:0}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.price[data-v-5016ec47],a.button.btn-large[data-v-5016ec47],button.btn-large[data-v-5016ec47],input[type=button].button.btn-large[data-v-5016ec47]{font-size:1.4em}h2[data-v-5016ec47]{font-size:1.5em}.sdr-box[data-v-5016ec47]{padding:10px}}", ""]);

// exports


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.getFlagBookingOutwardFlightSelected === true || _vm.getFlagBookingReturnFlightSelected === true)?_c('div',{staticClass:"booking-details sdr-box"},[_c('h4',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.bookingdetails[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.getFlagBookingOutwardFlightSelected === true)?_c('div',[_c('article',{staticClass:"flight-booking-details"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"constant-column-3 timing clearfix"},[_c('div',{staticClass:"check-in"},[_c('label',[_vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.getBookingCart[0].outward.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"duration text-center"},[_c('i',{staticClass:"soap-icon-clock"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.getBookingCart[0].outward.dur)))])]),_vm._v(" "),_c('div',{staticClass:"check-out"},[_c('label',[_vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.getBookingCart[0].outward.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))])])])])]),_vm._v(" "),_c('article',{staticClass:"detailed-logo",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"details"},[(_vm.getBookingUsersSearchData_OjArprtCode === '')?_c('center',[_c('h2',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.getBookingDepArprtCode + ' - ' + _vm.getBookingDesArprtCode)),_c('small',[_vm._v(_vm._s(_vm.getBookingDepArprtName + ' - ' + _vm.getBookingDesArprtName))])])]):_vm._e(),_vm._v(" "),(_vm.getBookingUsersSearchData_OjArprtCode !== '')?_c('center',[_c('h2',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.getBookingDepArprtCode + ' - ' + _vm.getBookingDesArprtCode)),_c('small',[_vm._v(_vm._s(_vm.getBookingDepArprtName + ' - ' + _vm.getBookingDesArprtName))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.getBookingCart),function(pax,index){return _c('div',{key:index},[_c('h4',{staticClass:"paxheadline",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.trnslPaxTypes(pax.type))+" "+_vm._s(pax.counter))]),_vm._v(" "),(_vm.modulo === 'booking')?_c('span',{staticClass:"price clearfix"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-tax-panel-outward' + pax.id}},[_c('small',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.flightprice[_vm.getCurrentLocale])+" ")]),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.seetaxes[_vm.getCurrentLocale]),expression:"seetaxes[getCurrentLocale]"}],staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.totalprice !== undefined ? pax.outward.totalprice : '0')))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('span',{staticClass:"price clearfix"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-tax-panel-outward' + pax.id}},[_c('small',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.flightpricesrvcs[_vm.getCurrentLocale])+" ")]),_c('span',{staticClass:"pull-right"},[_vm._v("-")])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'pax-tax-panel-outward' + pax.id}},[_c('dl',{staticClass:"other-details"},[_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.airfare[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.price !== undefined ? pax.outward.price :  '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.airporttaxes[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.taxes !== undefined ? pax.outward.taxes.air :  '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.aviationtax[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.taxes !== undefined ? pax.outward.taxes.avia :'0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.kerosenesurcharge[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.taxes !== undefined ? pax.outward.taxes.fuel : '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.securitycharges[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.taxes !== undefined ? pax.outward.taxes.sec :  '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.servicecharges[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.taxes !== undefined ? pax.outward.taxes.srvc :  '0')))])])]):_vm._e(),_vm._v(" "),(pax.outward_seat.seatno !== undefined)?_c('span',{staticClass:"price clearfix"},[_c('a',{ref:'pax-delete-seat-outward-' + pax.id_pax + '-' + pax.outward_seat.seatno,refInFor:true,staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-delete-seat-outward-' + pax.id_pax + '-' + pax.outward_seat.seatno}},[_c('small',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.seat[_vm.getCurrentLocale])+": "),_c('b',[_vm._v(_vm._s(_vm._f("truncate")(pax.outward_seat.seatno,17, '...')))])]),_c('i',{staticClass:"soap-icon-triangle-bottom yellow-color"}),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.wannedeleteseat[_vm.getCurrentLocale]),expression:"wannedeleteseat[getCurrentLocale]"}],staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward_seat.price !== undefined ? parseFloat(pax.outward_seat.price) : '0')))])])]):_vm._e(),_vm._v(" "),(pax.outward_seat.seatno !== undefined)?_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'pax-delete-seat-outward-' + pax.id_pax + '-' + pax.outward_seat.seatno}},[_c('a',{staticClass:"button btn-small sundair pull-right",on:{"click":function($event){$event.preventDefault();_vm.onClick_DeleteSeat({ id_pax: pax.id_pax, type: 'outward', seat: pax.outward_seat })}}},[_vm._v(_vm._s(_vm.wannedeleteseat[_vm.getCurrentLocale]))]),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_vm._l((pax.outward_srvcs),function(srvcs,index2){return _c('span',{key:index2},[(srvcs.code !== 'FLEX OPTION')?_c('span',{staticClass:"price clearfix"},[_c('a',{ref:'pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id,refInFor:true,staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id}},[_c('small',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(srvcs.description),expression:"srvcs.description"}],staticClass:"pull-left"},[_vm._v(_vm._s(_vm._f("truncate")(srvcs.description,17, '...'))+" ")]),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.wannedelete[_vm.getCurrentLocale]),expression:"wannedelete[getCurrentLocale]"}],staticClass:"pull-right"},[_c('i',{staticClass:"soap-icon-triangle-bottom yellow-color"}),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0')))])])]):_vm._e(),_vm._v(" "),(srvcs.code === 'FLEX OPTION')?_c('span',{staticClass:"price clearfix",staticStyle:{"background-color":"#BD6196"}},[_c('a',{ref:'pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id,refInFor:true,staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id}},[_c('small',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(srvcs.description),expression:"srvcs.description"}],staticClass:"pull-left",staticStyle:{"color":"#fff","padding-left":"3px"}},[_vm._v(_vm._s(_vm._f("truncate")(srvcs.description,17, '...'))+" ")]),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.wannedelete[_vm.getCurrentLocale]),expression:"wannedelete[getCurrentLocale]"}],staticClass:"pull-right",staticStyle:{"color":"#fff"}},[_c('i',{staticClass:"soap-icon-triangle-bottom yellow-color"}),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0')))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'pax-delete-service-outward-' + pax.id_pax + '-' + srvcs.id}},[_c('a',{staticClass:"button btn-small sundair pull-right",on:{"click":function($event){$event.preventDefault();_vm.onClick_DeleteSrvcs({ id_pax: pax.id_pax, srvcs: srvcs, type: 'outward' })}}},[_vm._v(_vm._s(_vm.deletesrvcs[_vm.getCurrentLocale]))]),_c('br'),_c('br')])])})],2)}),_vm._v(" "),_c('dl',{staticClass:"other-details"},[_c('dt',{staticClass:"total-price"},[_vm._v(_vm._s(_vm.totaloutwardprice[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"total-price-value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getBookingCartOutwardTotal)))])])],2)])]):_vm._e(),_vm._v(" "),(_vm.getBookingUsersSearchData.rTrip === true && _vm.getFlagBookingReturnFlightSelected === true)?_c('div',[_c('br'),_vm._v(" "),_c('article',{staticClass:"flight-booking-details"},[_c('div',{staticClass:"details"},[_c('div',{staticClass:"constant-column-3 timing clearfix"},[_c('div',{staticClass:"check-in"},[_c('label',[_vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.getBookingCart[0].return.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"duration text-center"},[_c('i',{staticClass:"soap-icon-clock"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.getBookingCart[0].return.dur)))])]),_vm._v(" "),_c('div',{staticClass:"check-out"},[_c('label',[_vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale]))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.getBookingCart[0].return.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))])])])])]),_vm._v(" "),_c('article',{staticClass:"detailed-logo",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"details"},[(_vm.getBookingUsersSearchData_OjArprtCode === '')?_c('center',[_c('h2',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.getBookingDesArprtCode + ' - ' +  _vm.getBookingDepArprtCode)),_c('small',[_vm._v(_vm._s(_vm.getBookingDesArprtName + ' - ' +  _vm.getBookingDepArprtName))])])]):_vm._e(),_vm._v(" "),(_vm.getBookingUsersSearchData_OjArprtCode !== '')?_c('center',[_c('h2',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.getBookingDepArprtCodeReturnToOther + ' - ' +  _vm.getBookingDesArprtCodeReturnToOther)),_c('small',[_vm._v(_vm._s(_vm.getBookingDepArprtNameReturnToOther + ' - ' +  _vm.getBookingDesArprtNameReturnToOther))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.getBookingCart),function(pax,index){return _c('div',{key:index},[_c('h4',{staticClass:"paxheadline",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.trnslPaxTypes(pax.type))+" "+_vm._s(pax.counter))]),_vm._v(" "),(_vm.modulo === 'booking')?_c('span',{staticClass:"price clearfix"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-tax-panel-return' + pax.id}},[_c('small',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.flightprice[_vm.getCurrentLocale])+" ")]),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.seetaxes[_vm.getCurrentLocale]),expression:"seetaxes[getCurrentLocale]"}],staticClass:"pull-right"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.totalprice !== undefined ? pax.return.totalprice : '0')))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('span',{staticClass:"price clearfix"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-tax-panel-return' + pax.id}},[_c('small',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.flightpricesrvcs[_vm.getCurrentLocale])+" ")]),_c('span',{staticClass:"pull-right"},[_vm._v("-")])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'pax-tax-panel-return' + pax.id}},[_c('dl',{staticClass:"other-details"},[_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.airfare[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.price !== undefined ? pax.return.price : '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.airporttaxes[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.taxes !== undefined ? pax.return.taxes.air : '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.aviationtax[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.taxes !== undefined ? pax.return.taxes.avia : '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.kerosenesurcharge[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.taxes !== undefined ? pax.return.taxes.fuel : '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.securitycharges[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.taxes !== undefined ? pax.return.taxes.sec :  '0')))]),_vm._v(" "),_c('dt',{staticClass:"feature"},[_vm._v(_vm._s(_vm.servicecharges[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.taxes !== undefined ? pax.return.taxes.srvc :  '0')))])])]):_vm._e(),_vm._v(" "),(pax.return_seat.seatno !== undefined)?_c('span',{staticClass:"price clearfix"},[_c('a',{ref:'pax-delete-seat-return-' + pax.id_pax + '-' + pax.return_seat.seatno,refInFor:true,staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-delete-seat-return-' + pax.id_pax + '-' + pax.return_seat.seatno}},[_c('small',{staticClass:"pull-left"},[_vm._v(_vm._s(_vm.seat[_vm.getCurrentLocale])+": "),_c('b',[_vm._v(_vm._s(_vm._f("truncate")(pax.return_seat.seatno,17, '...')))])]),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.wannedeleteseat[_vm.getCurrentLocale]),expression:"wannedeleteseat[getCurrentLocale]"}],staticClass:"pull-right"},[_c('i',{staticClass:"soap-icon-triangle-bottom yellow-color"}),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return_seat.price !== undefined ? parseFloat(pax.return_seat.price) : '0')))])])]):_vm._e(),_vm._v(" "),(pax.return_seat.seatno !== undefined)?_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'pax-delete-seat-return-' + pax.id_pax + '-' + pax.return_seat.seatno}},[_c('a',{staticClass:"button btn-small sundair pull-right",on:{"click":function($event){$event.preventDefault();_vm.onClick_DeleteSeat({ id_pax: pax.id_pax, type: 'return', seat: pax.return_seat })}}},[_vm._v(_vm._s(_vm.wannedeleteseat[_vm.getCurrentLocale]))]),_c('br'),_c('br')]):_vm._e(),_vm._v(" "),_vm._l((pax.return_srvcs),function(srvcs,index2){return _c('span',{key:index2},[_c('span',{staticClass:"price clearfix"},[_c('a',{ref:'pax-delete-service-return-' + pax.id_pax + '-' + srvcs.id,refInFor:true,staticClass:"collapsed",attrs:{"data-toggle":"collapse","href":'#pax-delete-service-return-' + pax.id_pax + '-' + srvcs.id}},[_c('small',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(srvcs.description),expression:"srvcs.description"}],staticClass:"pull-left"},[_vm._v(_vm._s(_vm._f("truncate")(srvcs.description,17, '...'))+" ")]),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.wannedelete[_vm.getCurrentLocale]),expression:"wannedelete[getCurrentLocale]"}],staticClass:"pull-right"},[_c('i',{staticClass:"soap-icon-triangle-bottom yellow-color"}),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0')))])])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'pax-delete-service-return-' + pax.id_pax + '-' + srvcs.id}},[_c('a',{staticClass:"button btn-small sundair pull-right",on:{"click":function($event){$event.preventDefault();_vm.onClick_DeleteSrvcs({ id_pax: pax.id_pax, srvcs: srvcs, type: 'return' })}}},[_vm._v(_vm._s(_vm.deletesrvcs[_vm.getCurrentLocale]))]),_c('br'),_c('br')])])})],2)}),_vm._v(" "),_c('dl',{staticClass:"other-details"},[_c('dt',{staticClass:"total-price"},[_vm._v(_vm._s(_vm.totalreturnprice[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"total-price-value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getBookingCartReturnTotal)))])])],2)])]):_vm._e(),_vm._v(" "),(_vm.getFlagBookingOutwardFlightSelected === true || _vm.getFlagBookingReturnFlightSelected === true)?_c('div',[_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-large full-width sundair",class:{ sundairsrvcs: _vm.modulo === 'services' },staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.getBookingCartOutwardTotal) + Number(_vm.getBookingCartReturnTotal)))),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.5em"}},[_vm._v(_vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),_c('v-dialog')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getFlagSharedShowFlightSearchResults)?_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"block",attrs:{"id":"contentElement"}},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"first","module":_vm.modulo}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-md-9"},[_c('div',{staticClass:"container shortcode travel-ideas"},[(_vm.modulo === 'booking')?_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"30px"}},[_vm._m(0),_vm._v(_vm._s(_vm.pleaseselectflightheadline[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"30px"}},[_vm._m(1),_vm._v(_vm._s(_vm.pleaseselectflightservicesheadline[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-container style1"},[(_vm.modulo === 'booking')?_c('ul',{staticClass:"tabs full-width"},[_c('li',{class:{ active: _vm.isActive === 'outwardsearchresults', 'icon-check2': _vm.getBookingFlightIdSelectedOutward !== null }},[_c('a',{attrs:{"href":"#outwardsearchresults","data-toggle":"tab"},on:{"click":function($event){$event.preventDefault();_vm.isActive ='outwardsearchresults'}}},[_vm._v(_vm._s(_vm.departureflightlist[_vm.getCurrentLocale]))])]),_vm._v(" "),(_vm.getBookingUsersSearchData.rTrip === true)?_c('li',{class:{ active: _vm.isActive === 'returnsearchresults', 'icon-check2': _vm.getBookingFlightIdSelectedReturn !== null}},[_c('a',{class:{ 'buttonglowing': _vm.getBookingFlightIdSelectedReturn === null && _vm.getBookingFlightIdSelectedOutward !== null },attrs:{"href":"#returnsearchresults","data-toggle":"tab"},on:{"click":function($event){$event.preventDefault();_vm.isActive ='returnsearchresults'}}},[_vm._v(_vm._s(_vm.returnflightlist[_vm.getCurrentLocale]))])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('ul',{staticClass:"tabs full-width srvcs"},[_c('li',{class:{ active_srvcs: _vm.isActive === 'outwardsearchresults', 'icon-check3': _vm.getBookingFlightIdSelectedOutward !== null }},[_c('a',{attrs:{"href":"#outwardsearchresults","data-toggle":"tab"},on:{"click":function($event){$event.preventDefault();_vm.isActive ='outwardsearchresults'}}},[_vm._v(_vm._s(_vm.departureflightlist[_vm.getCurrentLocale]))])]),_vm._v(" "),(_vm.getBookingUsersSearchData.rTrip === true)?_c('li',{class:{ active_srvcs: _vm.isActive === 'returnsearchresults', 'icon-check3': _vm.getBookingFlightIdSelectedReturn !== null }},[_c('a',{class:{ 'buttonglowing': _vm.getBookingFlightIdSelectedReturn === null && _vm.getBookingFlightIdSelectedOutward !== null },attrs:{"href":"#returnsearchresults","data-toggle":"tab"},on:{"click":function($event){$event.preventDefault();_vm.isActive ='returnsearchresults'}}},[_vm._v(_vm._s(_vm.returnflightlist[_vm.getCurrentLocale]))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"outwardsearchresults"}},[_c('div',{staticClass:"pricing-table"},[_c('div',{staticClass:"header clearfix",staticStyle:{"border-bottom":"0px"}},[_c('i',{staticClass:"soap-icon-plane-right circle takeoff-effect yellow-color"}),_vm._v(" "),(_vm.filterOutwardOnly(_vm.getBookingFlightSearchResults).length !== 0)?_c('h3',{staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.getBookingDepArprtName + ' - ' + _vm.getBookingDesArprtName))]):_vm._e(),_vm._v(" "),(_vm.filterOutwardOnly(_vm.getBookingFlightSearchResults).length === 0)?_c('h3',{staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.getBookingDepArprtName + ' - ' + _vm.getBookingDesArprtName)+" - "+_vm._s(_vm.noresultsout[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.filterOutwardOnly(_vm.getBookingFlightSearchResults)),function(flight){return _c('div',{key:flight.id,staticClass:"row image-box"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"flight-list listing-style3 flight"},[_c('article',{staticClass:"box div_hover"},[_c('figure',{staticClass:"col-xs-3 col-sm-2"},[(_vm.modulo === 'booking' && (flight.prcs[0] !== undefined && flight.warn === ''))?_c('span',[_c('img',{attrs:{"alt":"","src":"/res/images/logo-centered3.png"}})]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking' && (flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY'))?_c('span',[_c('img',{attrs:{"alt":"","src":"/res/images/logo-centered3-bw.png"}})]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('span',[_c('img',{attrs:{"alt":"","src":"/res/images/logo-centered3.png"}})]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingFlightIdSelectedOutward === flight.id),expression:"getBookingFlightIdSelectedOutward === flight.id"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.soldout[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingFlightIdSelectedOutward === flight.id),expression:"getBookingFlightIdSelectedOutward === flight.id"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.soldoutsrvcs[_vm.getCurrentLocale]))])]):_vm._e()]),_vm._v(" "),_c('sdr-shared-fsr-flight',{attrs:{"flight":flight,"flightdirection":"outward","modulo":_vm.modulo}})],1)])])])})],2),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"returnsearchresults"}},[_c('div',{staticClass:"pricing-table"},[_c('div',{staticClass:"header clearfix",staticStyle:{"border-bottom":"0px"}},[_c('i',{staticClass:"soap-icon-plane-right takeoff-effect1 circle yellow-color"}),_vm._v(" "),(_vm.filterReturnOnly(_vm.getBookingFlightSearchResults).length !== 0)?_c('h3',{staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.getBookingDesArprtName + ' - ' + _vm.getBookingDepArprtName))]):_vm._e(),_vm._v(" "),(_vm.filterReturnOnly(_vm.getBookingFlightSearchResults).length === 0)?_c('h3',{staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.getBookingDesArprtName + ' - ' + _vm.getBookingDepArprtName)+" - "+_vm._s(_vm.noresultsret[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.filterReturnOnly(_vm.getBookingFlightSearchResults)),function(flight){return _c('div',{key:flight.id,staticClass:"row image-box"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"flight-list listing-style3 flight"},[_c('article',{staticClass:"box div_hover"},[_c('figure',{staticClass:"col-xs-3 col-sm-2"},[(_vm.modulo === 'booking' && (flight.prcs[0] !== undefined && flight.warn === ''))?_c('span',[_c('img',{attrs:{"alt":"","src":"/res/images/logo-centered3.png"}})]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking' && (flight.prcs[0] === undefined || flight.warn === 'LC_WARNING_INSUFFICIENT_INF_SERVICE_AVAILABILITY'))?_c('span',[_c('img',{attrs:{"alt":"","src":"/res/images/logo-centered3-bw.png"}})]):_vm._e(),_vm._v(" "),( _vm.modulo === 'services')?_c('span',[_c('img',{attrs:{"alt":"","src":"/res/images/logo-centered3.png"}})]):_vm._e(),_vm._v(" "),( _vm.modulo === 'booking')?_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingFlightIdSelectedReturn === flight.id),expression:"getBookingFlightIdSelectedReturn === flight.id"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.soldout[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),( _vm.modulo === 'services')?_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingFlightIdSelectedReturn === flight.id),expression:"getBookingFlightIdSelectedReturn === flight.id"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.soldoutsrvcs[_vm.getCurrentLocale]))])]):_vm._e()]),_vm._v(" "),_c('sdr-shared-fsr-flight',{attrs:{"flight":flight,"flightdirection":"return","modulo":_vm.modulo}})],1)])])])})],2)])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getBookingUsersSearchData.rTrip === true && (_vm.filterOutwardOnly(_vm.getBookingFlightSearchResults).length !== 0 && _vm.filterReturnOnly(_vm.getBookingFlightSearchResults).length !== 0))?_c('div',[(_vm.getFlagBookingOutwardFlightSelected === true && _vm.getFlagBookingReturnFlightSelected === true)?_c('button',{staticClass:"btn-large icon-check uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.call_nextCallBookingOrServices(_vm.modulo)}}},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getFlagBookingOutwardFlightSelected !== true || _vm.getFlagBookingReturnFlightSelected !== true)?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale])+" ")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.getBookingUsersSearchData.rTrip === true && (_vm.filterOutwardOnly(_vm.getBookingFlightSearchResults).length === 0 || _vm.filterReturnOnly(_vm.getBookingFlightSearchResults).length === 0))?_c('div',[_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale])+" ")])]):_vm._e(),_vm._v(" "),(_vm.getBookingUsersSearchData.rTrip !== true)?_c('div',[(_vm.getFlagBookingOutwardFlightSelected === true)?_c('button',{staticClass:"btn-large icon-check uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.call_nextCallBookingOrServices(_vm.modulo)}}},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getFlagBookingOutwardFlightSelected !== true)?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale])+" ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sms-6 col-sm-4 col-md-3 topDistance"},[_c('h2',[_vm._v(" ")]),_vm._v(" "),_c('h4',{staticClass:"search-results-title",staticStyle:{"color":"#4f657e !important"}},[_c('i',{staticClass:"soap-icon-search"}),_c('b',[_vm._v(_vm._s(_vm.getBookingFlightSearchResults.length))]),_vm._v(" "+_vm._s(_vm.resultsshown[_vm.getCurrentLocale])+".")]),_vm._v(" "),(_vm.modulo === 'booking')?_c('sdr-modifysearch-box'):_vm._e(),_vm._v(" "),_c('sdr-shared-cart',{attrs:{"modulo":_vm.modulo}})],1)])])]),_vm._v(" "),_c('modal',{attrs:{"name":"booking-error-modal-sameday","transition":"nice-modal-fade","classes":"demo-modal-class","min-width":100,"min-height":100,"pivot-y":0.5,"adaptive":true,"scrollable":true,"reset":true,"width":"500px","height":"auto"},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"booking-error-modal-sameday-content",staticStyle:{"border":"2px solid red"}},[_c('section',{staticStyle:{"padding":"20px","min-height":"100px"},attrs:{"id":"content"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"10px"}},[_c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-notice circle"})]),_vm._v(_vm._s(_vm.modal_headline_rebooking_error[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.modal_content_rebooking_error[_vm.getCurrentLocale])}})])])])]),_vm._v(" "),_c('button',{staticClass:"btn-large full-width totalbutton sundair",staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important","margin-bottom":"0px"},attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();_vm.onClick_CloseModal(_vm.modulo)}}},[_vm._v(" "+_vm._s(_vm.closemodal[_vm.getCurrentLocale]))])])])],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingnoOverview_vue__ = __webpack_require__(167);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fee809_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingnoOverview_vue__ = __webpack_require__(304);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35fee809"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingnoOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fee809_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingnoOverview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(296);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("34ed0d22", content, true, {});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "#flight-details .flights[data-v-35fee809]{padding-bottom:0}#flight-details .flights .first-flight .logo[data-v-35fee809]:after{bottom:23px}.totalbutton[data-v-35fee809]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.tab-container ul.tabs li.active>a[data-v-35fee809],.tab-container ul.tabs li:hover>a[data-v-35fee809],dl.term-description dt[data-v-35fee809]{color:#9e4d84}.cruise-itinerary td[data-v-35fee809]{line-height:2.5em;border:1px solid #f5f5f5}.booking-details .other-details[data-v-35fee809]{background-color:#f5f5f5}.booking-details .other-details .total-price-value[data-v-35fee809]{font-size:1.9167em}.total-price-value-small[data-v-35fee809]{color:#98ce44;font-size:1.4em;text-align:right}.booking-details .other-details dd[data-v-35fee809],.booking-details .other-details dt[data-v-35fee809]{padding-top:.4em;padding-bottom:.4em}#flight-fare-rules .topics li.active[data-v-35fee809],.hotel-faqs .topics li.active[data-v-35fee809],.icon-box.style9>i[data-v-35fee809]{background:#9e4d84}.size-modal2-content[data-v-35fee809]{padding:10px;font-style:13px;background-color:#fff;padding-right:50px}.v--modal-overlay[data-modal=size-modal2][data-v-35fee809]{background:rgba(0,0,0,.5);z-index:555555!important}.demo-modal-class[data-v-35fee809]{border-radius:5px;background:#f7f7f7;box-shadow:5px 5px 30px 0 rgba(46,61,73,.6)}.icon-check3[data-v-35fee809]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check3[data-v-35fee809]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-35fee809]{font-size:1.5em}h2[data-v-35fee809]{font-size:1.4em}a.button.btn-large[data-v-35fee809],button.btn-large[data-v-35fee809],input[type=button].button.btn-large[data-v-35fee809]{font-size:1em}.booking-section[data-v-35fee809]{padding:20px 15px}}", ""]);

// exports


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingnoFlightDetails_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e58d50_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingnoFlightDetails_vue__ = __webpack_require__(300);
function injectStyle (ssrContext) {
  __webpack_require__(298)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33e58d50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingnoFlightDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33e58d50_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingnoFlightDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(299);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("df1f3cb4", content, true, {});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "#flight-details .flights[data-v-33e58d50]{padding-bottom:0}#flight-details .flights .first-flight .logo[data-v-33e58d50]:after{bottom:23px}.totalbutton[data-v-33e58d50]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.tab-container ul.tabs li.active>a[data-v-33e58d50],.tab-container ul.tabs li:hover>a[data-v-33e58d50],dl.term-description dt[data-v-33e58d50]{color:#9e4d84}.cruise-itinerary td[data-v-33e58d50]{line-height:2.5em;border:1px solid #f5f5f5}.booking-details .other-details[data-v-33e58d50]{background-color:#f5f5f5}.booking-details .other-details .total-price-value[data-v-33e58d50]{font-size:1.9167em}.total-price-value-small[data-v-33e58d50]{color:#98ce44;font-size:1.4em;text-align:right}.booking-details .other-details dd[data-v-33e58d50],.booking-details .other-details dt[data-v-33e58d50]{padding-top:.4em;padding-bottom:.4em}#flight-fare-rules .topics li.active[data-v-33e58d50],.hotel-faqs .topics li.active[data-v-33e58d50],.icon-box.style9>i[data-v-33e58d50]{background:#9e4d84}.cruise-itinerary td[data-v-33e58d50]{line-height:1.8em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-33e58d50]{font-size:1.5em}h2[data-v-33e58d50]{font-size:1.4em}a.button.btn-large[data-v-33e58d50],button.btn-large[data-v-33e58d50],input[type=button].button.btn-large[data-v-33e58d50]{font-size:1em}.booking-section[data-v-33e58d50]{padding:20px 15px}}", ""]);

// exports


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.flightdirection === 'outward')?_c('h2',[_vm._v(_vm._s(_vm.tab_header_flightdetailsoutwardservices[_vm.getCurrentLocale])+":")]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('h2',[_vm._v(_vm._s(_vm.tab_header_flightdetailsreturnservices[_vm.getCurrentLocale])+":")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"intro table-wrapper full-width hidden-table-sm box",staticStyle:{"border-spacing":"8px"}},[_c('div',{staticClass:"col-md-4 table-cell sdr-box"},[_c('dl',{staticClass:"term-description"},[_c('dt',[_vm._v(_vm._s(_vm.airline[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v("Schauinsland")]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.flighttype[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v("Economy")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 table-cell"},[_c('div',{staticClass:"detailed-features booking-details"},[_c('div',{staticClass:"sdr-box"},[(_vm.flightdirection === 'outward')?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.get_ServicesBookingnoDepArprtNameOutuward)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.get_ServicesBookingnoDesArprtNameOutward)),_c('small',[_vm._v(_vm._s(_vm.outwardflight[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.get_ServicesBookingnoDepArprtNameReturn)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.get_ServicesBookingnoDesArprtNameReturn)),_c('small',[_vm._v(_vm._s(_vm.returnflight[_vm.getCurrentLocale]))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"table-wrapper flights"},[_c('div',{staticClass:"table-row first-flight"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table-cell timing-detail"},[_c('div',{staticClass:"timing"},[_c('div',{staticClass:"check-in"},[_c('label',[_vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.get_ServicesBookingnoSearchResults[0].outwardFlight.departureDateTimeLocal))+", "+_vm._s(_vm._f("momentTime")(_vm.get_ServicesBookingnoSearchResults[0].outwardFlight.departureDateTimeLocal)))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.get_ServicesBookingnoSearchResults[0].returnFlight.departureDateTimeLocal))+", "+_vm._s(_vm._f("momentTime")(_vm.get_ServicesBookingnoSearchResults[0].returnFlight.departureDateTimeLocal)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"duration text-center"},[_c('i',{staticClass:"soap-icon-clock"}),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.get_ServicesBookingnoSearchResults[0].outwardFlight.dur)))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.get_ServicesBookingnoSearchResults[0].returnFlight.dur)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"check-out"},[_c('label',[_vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.get_ServicesBookingnoSearchResults[0].outwardFlight.destinationDateTimeLocal))+", "+_vm._s(_vm._f("momentTime")(_vm.get_ServicesBookingnoSearchResults[0].outwardFlight.destinationDateTimeLocal)))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.get_ServicesBookingnoSearchResults[0].returnFlight.destinationDateTimeLocal))+", "+_vm._s(_vm._f("momentTime")(_vm.get_ServicesBookingnoSearchResults[0].returnFlight.destinationDateTimeLocal)))]):_vm._e()])])])])])])])]),_vm._v(" "),_vm._l((_vm.get_ServicesBookingnoSearchResultsPassengersSorted),function(pax,index){return _c('div',{key:index,staticClass:"booking-section sdr-box",staticStyle:{"padding":"0px","padding-top":"10px"}},[_c('h4',{staticClass:"paxheadline"},[_vm._v(_vm._s(_vm.trnslPaxSalutations(pax.salutation))+" "+_vm._s(pax.firstName)+" "+_vm._s(pax.lastName))]),_vm._v(" "),_c('div',{staticClass:"table-cell cruise-itinerary"},[_c('div',{staticClass:"sdr-box",staticStyle:{"padding-top":"0px","padding-bottom":"0px","padding-left":"0px","padding-right":"0px"}},[(_vm.flightdirection === 'outward')?_c('table',[_c('tbody',[_c('tr',[_c('td',[_c('b',[_vm._v(_vm._s(_vm.flightpriceservices[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(" - ")])]),_vm._v(" "),(_vm.getSeatData(pax.outboundServices).length > 0)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.seat[_vm.getCurrentLocale])+": "),_c('b',[_vm._v(_vm._s(_vm._f("truncate")(_vm.getSeatData(pax.outboundServices)[0].seatName.seatName,17, '...')))])]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getSeatData(pax.outboundServices)[0].price !== undefined ? _vm.getSeatData(pax.outboundServices)[0].price : '0')))])]):_vm._e(),_vm._v(" "),_vm._l((pax.outboundServices.filter(function (x) { return (x.code != 'SEAT'); })),function(srvcs,index2){return _c('tr',{key:index2},[_c('td',[_vm._v(_vm._s(srvcs.label)+" ")]),_vm._v(" "),_c('td',{staticStyle:{"text-transform":"none"}},[(srvcs.quantity > 1)?_c('span',[_vm._v(_vm._s(srvcs.quantity)+"x a "+_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.quantity) : '0')))])])})],2)]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('table',[_c('tbody',[_c('tr',[_c('td',[_c('b',[_vm._v(_vm._s(_vm.flightpriceservices[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(" - ")])]),_vm._v(" "),(_vm.getSeatData(pax.inboundServices).length > 0)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.seat[_vm.getCurrentLocale])+": "),_c('b',[_vm._v(_vm._s(_vm._f("truncate")(_vm.getSeatData(pax.inboundServices)[0].seatName.seatName,17, '...')))])]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getSeatData(pax.inboundServices)[0].price !== undefined ? _vm.getSeatData(pax.inboundServices)[0].price : '0')))])]):_vm._e(),_vm._v(" "),_vm._l((pax.inboundServices.filter(function (x) { return (x.code != 'SEAT'); })),function(srvcs,index2){return _c('tr',{key:index2},[_c('td',[_vm._v(_vm._s(srvcs.label))]),_vm._v(" "),_c('td',{staticStyle:{"text-transform":"none"}},[(srvcs.quantity > 1)?_c('span',[_vm._v(_vm._s(srvcs.quantity)+"x a "+_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.quantity) : '0')))])])})],2)]):_vm._e()])])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell logo"},[_c('img',{staticStyle:{"padding-bottom":"3px"},attrs:{"src":"/res/images/sdr140x30.png","alt":"Schauinsland"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(302);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("46150d23", content, true, {});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdr-box contact-box"},[_c('h4',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.needhelp[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.sideboxhelptext[_vm.getCurrentLocale]))]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',{staticClass:"contact-details"},[_c('span',{staticClass:"contact-phone"},[_c('i',{staticClass:"soap-icon-phone"}),_vm._v(" +49 30 20673716")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"contact-email",attrs:{"href":"mailto:info@kayofly.de"}},[_vm._v("info@kayofly.de")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',{staticClass:"contact-details"},[_c('span',{staticClass:"contact-phone"},[_c('i',{staticClass:"soap-icon-phone"}),_vm._v(" +49 176 66858855")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.get_FlagServicesShowBookingnoSearchResults)?_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"block",attrs:{"id":"contentElementBookingno"}},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"first","module":_vm.modulo}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"30px"}},[_vm._m(0),_vm._v(_vm._s(_vm.headline_step1[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9"},[_c('div',{staticClass:"tab-container",attrs:{"id":"flight-features"}},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flight-details","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.tab_flightdetails[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"flight-details"}},[(_vm.get_ServicesBookingnoHasOutwardFlight)?_c('sdr-bookingno-flight-details',{attrs:{"flightdirection":"outward"}}):_vm._e(),_vm._v(" "),(_vm.get_ServicesBookingnoHasReturnFlight)?_c('div',[_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('sdr-bookingno-flight-details',{attrs:{"flightdirection":"return"}})],1):_vm._e()],1)])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-large icon-check uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.call_nextCalls()}}},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sms-6 col-sm-4 col-md-3 topDistance"},[_c('h2',[_vm._v(" ")]),_vm._v(" "),_c('h4',{staticClass:"search-results-title"},[_c('i',{staticClass:"soap-icon-search"}),_c('b',[_vm._v(_vm._s(_vm.get_ServicesBookingnoPassengersCountAll))]),_vm._v(" "+_vm._s(_vm.resultsshown[_vm.getCurrentLocale])+".")]),_vm._v(" "),_c('sdr-contact-box')],1)])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(306);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a83671ac", content, true, {});

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".md-section[data-v-68018bf4]{padding-top:0}.image-style[data-v-68018bf4]{padding:10px 0 10px 10px}.column-in-center[data-v-68018bf4]{margin-left:60px}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.column-in-center[data-v-68018bf4]{margin-left:0}}.image-box.style9 figure img[data-v-68018bf4]{width:50%}a.button[data-v-68018bf4]{background:#ec008b}", ""]);

// exports


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"action":"#l","method":"post"}},[_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlineflightseat[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-passenger"})]),_vm._v(" "),_c('div',{staticClass:"search-content"},[_c('div',{staticClass:"col-md-12",staticStyle:{"margin-bottom":"0px"},attrs:{"id":"main"}},[_c('h4',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.seatstitle[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.seatstitle2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"image-box style9 column-4"},[_c('article',{staticClass:"box"},[_c('center',[_c('figure',[_c('a',{attrs:{"href":"#","title":""}},[_c('img',{staticStyle:{"background-color":"#FF6600"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","height":"30"}})])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('a',{staticClass:"button",staticStyle:{"margin-top":"10px","margin-bottom":"20px"},attrs:{"href":"/infos-seat-reservation/#/seat-reservation","title":"","target":"_new"}},[_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v("\n                                    Comfort"),_c('br'),_vm._v("Seat"),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"5px","margin-bottom":"10px","font-size":"20px","color":"rgb(125, 185, 33)"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(30))))]),_vm._v(" "),_c('small',[_c('br'),_vm._v(_vm._s(_vm.furtherservices_seat_comfortseat[_vm.getCurrentLocale]))])])])])],1),_vm._v(" "),_c('article',{staticClass:"box"},[_c('center',[_c('figure',[_c('a',{attrs:{"href":"#","title":""}},[_c('img',{staticStyle:{"background-color":"#9900CC"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","heigth":"30"}})])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('a',{staticClass:"button",staticStyle:{"margin-top":"10px","margin-bottom":"20px"},attrs:{"href":"/infos-seat-reservation/#/seat-reservation","title":"","target":"_new"}},[_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v("\n                                    Best"),_c('br'),_vm._v("Seat"),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"5px","margin-bottom":"10px","font-size":"20px","color":"rgb(125, 185, 33)"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(20))))]),_vm._v(" "),_c('small',[_c('br'),_vm._v(_vm._s(_vm.furtherservices_seat_bestseat[_vm.getCurrentLocale]))])])])])],1),_vm._v(" "),_c('article',{staticClass:"box"},[_c('center',[_c('figure',[_c('a',{attrs:{"href":"#","title":""}},[_c('img',{staticStyle:{"background-color":"#22B14C"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","heigth":"30"}})])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('a',{staticClass:"button",staticStyle:{"margin-top":"10px","margin-bottom":"20px"},attrs:{"href":"/infos-seat-reservation/#/seat-reservation","title":"","target":"_new"}},[_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v("\n                                    Standard"),_c('br'),_vm._v("Seat"),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"5px","margin-bottom":"10px","font-size":"20px","color":"rgb(125, 185, 33)"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(15))))]),_vm._v(" "),_c('small',[_c('br')])])])])],1),_vm._v(" "),_c('article',{staticClass:"box"},[_c('center',[_c('figure',[_c('a',{attrs:{"href":"#","title":""}},[_c('img',{staticStyle:{"background-color":"#3399FF"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","heigth":"30"}})])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('a',{staticClass:"button",staticStyle:{"margin-top":"10px","margin-bottom":"20px"},attrs:{"href":"/infos-seat-reservation/#/seat-reservation","title":"","target":"_new"}},[_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v("\n                                    Exit"),_c('br'),_vm._v("Seat"),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"5px","margin-bottom":"10px","font-size":"20px","color":"rgb(125, 185, 33)"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(30))))]),_vm._v(" "),_c('small',[_c('br'),_vm._v(_vm._s(_vm.furtherservices_seat_exitseat[_vm.getCurrentLocale]))])])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade in active image-style style2",attrs:{"id":"honeymoon1"}},[_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('a',{staticClass:"button btn-medium icon-check uppercase full-width",attrs:{"href":"/services"}},[_vm._v(_vm._s(_vm.seatsbutton[_vm.getCurrentLocale]))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 column-in-center"},[_c('ul',{staticClass:"image-block clearfix"},[_c('li',{staticStyle:{"z-index":"5","left":"50px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"80px","height":"80px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-40px","left":"50%","margin-left":"-66.5px"},attrs:{"width":"133","height":"88","alt":"","src":"/res/images/services/seats/tabs_banner_5.png"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"4","left":"180px","top":"100px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"100px","height":"100px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-50px","left":"50%","margin-left":"-75px"},attrs:{"width":"150","height":"100","alt":"","src":"/res/images/services/seats/tabs_banner_4.jpg"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"3","left":"250px","top":"20px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"150px","height":"150px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-75px","left":"50%","margin-left":"-110px"},attrs:{"width":"220","height":"196","alt":"","src":"/res/images/services/seats/tabs_banner_2.png"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"2","left":"100px","top":"0"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"160px","height":"160px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-80px","left":"50%","margin-left":"-156px"},attrs:{"width":"312","height":"208","alt":"","src":"/res/images/services/seats/tabs_banner_3.png"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"1","left":"0","top":"30px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"156px","height":"156px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-78px","left":"50%","margin-left":"-117.5px"},attrs:{"width":"235","height":"156","alt":"","src":"/res/images/services/seats/tabs_banner_1.jpg"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(309);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("40d58440", content, true, {});

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".md-section[data-v-499302f6]{padding-top:0}.image-style[data-v-499302f6]{padding:10px 0 10px 10px}.column-in-center[data-v-499302f6]{margin-left:60px}.image-box.style9 figure img[data-v-499302f6]{width:50%}.icon-box.style5>i[data-v-499302f6],a.button[data-v-499302f6]{background:#ec008b}.icon-box.style5[data-v-499302f6]{background:#f5f5f5}.block[data-v-499302f6]{margin-bottom:20px}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.column-in-center[data-v-499302f6]{margin-left:0}.icon-box.style5>i[data-v-499302f6]{width:80px;line-height:80px}.icon-box.style5[data-v-499302f6]{height:80px;line-height:80px}}", ""]);

// exports


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{attrs:{"action":"#l","method":"post"}},[_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlineflightluggage[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-baggage-status"})]),_vm._v(" "),_c('div',{staticClass:"search-content"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"main"}},[_c('h4',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.luggagetitle[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggagetext1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"contact-address block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"icon-box style5"},[_c('i',{staticClass:"soap-icon-baggage-status"}),_vm._v(" "),_c('div',{staticClass:"description",staticStyle:{"padding-top":"6px"}},[_c('h5',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("\n                                        "+_vm._s(_vm.handluggage[_vm.getCurrentLocale])+" (1 "+_vm._s(_vm.piece[_vm.getCurrentLocale])+")"),_c('br'),_vm._v("\n                                        "+_vm._s(_vm.dimensions[_vm.getCurrentLocale])+": max. 55cm x 40cm x 20cm , "+_vm._s(_vm.weight[_vm.getCurrentLocale])+": max. 6kg\n                                    ")]),_vm._v(" "),_c('a',{staticClass:"button sundair",attrs:{"href":"/infos-luggage/#/luggage","title":"","target":"_new"}},[_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))])])])])])]),_vm._v(" "),_c('div',{staticClass:"contact-address block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"icon-box style5"},[_c('i',{staticClass:"soap-icon-baggage-status"}),_vm._v(" "),_c('div',{staticClass:"description",staticStyle:{"padding-top":"6px"}},[_c('h5',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("\n                                        "+_vm._s(_vm.abandonableluggage[_vm.getCurrentLocale])+" (1 "+_vm._s(_vm.piece[_vm.getCurrentLocale])+")"),_c('br'),_vm._v("\n                                        "+_vm._s(_vm.weight[_vm.getCurrentLocale])+": max. 20kg\n                                    ")]),_vm._v(" "),_c('a',{staticClass:"button sundair",attrs:{"href":"/infos-luggage/#/luggage","title":"","target":"_new"}},[_vm._v(_vm._s(_vm.moreinfo[_vm.getCurrentLocale]))])])])])])]),_vm._v(" "),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.luggagetext3[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('div',{staticClass:"tab-pane fade in active image-style style2",attrs:{"id":"honeymoon1"}},[_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('a',{staticClass:"button btn-medium icon-check uppercase full-width",attrs:{"href":"/services"}},[_vm._v(_vm._s(_vm.seatsbutton[_vm.getCurrentLocale]))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 column-in-center"},[_c('ul',{staticClass:"image-block clearfix"},[_c('li',{staticStyle:{"z-index":"5","left":"50px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"80px","height":"80px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-40px","left":"50%","margin-left":"-66.5px"},attrs:{"width":"133","height":"88","alt":"","src":"/res/images/services/seats/tabs_banner_5.png"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"4","left":"180px","top":"100px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"100px","height":"100px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-50px","left":"50%","margin-left":"-75px"},attrs:{"width":"150","height":"100","alt":"","src":"/res/images/services/seats/tabs_banner_4.jpg"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"3","left":"250px","top":"20px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"150px","height":"150px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-75px","left":"50%","margin-left":"-110px"},attrs:{"width":"220","height":"196","alt":"","src":"/res/images/services/seats/tabs_banner_2.png"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"2","left":"100px","top":"0"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"160px","height":"160px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-80px","left":"50%","margin-left":"-156px"},attrs:{"width":"312","height":"208","alt":"","src":"/res/images/services/seats/tabs_banner_3.png"}})])]),_vm._v(" "),_c('li',{staticStyle:{"z-index":"1","left":"0","top":"30px"}},[_c('a',{staticClass:"middle-block",staticStyle:{"width":"156px","height":"156px","position":"relative"},attrs:{"href":"/services"}},[_c('img',{staticClass:"middle-item",staticStyle:{"position":"absolute","top":"50%","margin-top":"-78px","left":"50%","margin-left":"-117.5px"},attrs:{"width":"235","height":"156","alt":"","src":"/res/images/services/seats/tabs_banner_1.jpg"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(312);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0cf17ee2", content, true, {});

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".icon-box.style5>i[data-v-6003babd]{background:#ec008b}.icon-box.style5[data-v-6003babd]{background:#f5f5f5}", ""]);

// exports


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"title-container"},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlineflighthelp[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-message"})]),_vm._v(" "),_c('section',{staticStyle:{"padding-top":"20px","background-color":"#fff"},attrs:{"id":"content"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"contact-address block",staticStyle:{"margin-left":"20px","margin-right":"20px"}},[_c('h4',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.hellotext1[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.hellotext2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"icon-box style5"},[_c('i',{staticClass:"soap-icon-phone"}),_vm._v(" "),_c('div',{staticClass:"description"},[_c('small',[_vm._v(_vm._s(_vm.weareon[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h5',[_vm._v("Tel. +49 (0) 30 - 53 676 791")])])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"icon-box style5"},[_c('i',{staticClass:"soap-icon-message"}),_vm._v(" "),_c('div',{staticClass:"description"},[_c('small',[_vm._v(_vm._s(_vm.sendusemail[_vm.getCurrentLocale]))]),_vm._v(" "),_vm._m(0)])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"icon-box style5"},[_c('i',{staticClass:"soap-icon-address"}),_vm._v(" "),_c('div',{staticClass:"description"},[_c('small',[_vm._v(_vm._s(_vm.meetusat[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h5',[_vm._v("SUNDAIR GmbH, Knieperdamm 79, 18435 Stralsund")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',[_c('a',{attrs:{"href":"mailto:kundenservice@sundair.com"}},[_vm._v("kundenservice@sundair.com")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstRow_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c088eecc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstRow_vue__ = __webpack_require__(317);
function injectStyle (ssrContext) {
  __webpack_require__(315)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c088eecc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirstRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c088eecc_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirstRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(316);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2b65f618", content, true, {});

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".size-modal-first-content[data-v-c088eecc]{padding:10px;font-style:13px;background-color:#fff;padding-right:50px}.v--modal-overlay[data-modal=size-modal][data-v-c088eecc]{background:rgba(0,0,0,.5);z-index:555555!important}.demo-modal-class[data-v-c088eecc]{border-radius:5px;background:#f7f7f7;box-shadow:5px 5px 30px 0 rgba(46,61,73,.6)}", ""]);

// exports


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-md-4"},[_c('h2',[_vm._v(_vm._s(_vm.title_informations[_vm.getCurrentLocale]))]),_vm._v(" "),_c('ul',{staticClass:"discover triangle hover row"},[_c('li',{staticClass:"col-xs-6",class:{ active: _vm.getPathName('infos-luggage') }},[_c('a',{attrs:{"href":"/infos-luggage/#/luggage"}},[_vm._v(_vm._s(_vm.listpoint_infos_luggage[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6",class:{ active: _vm.getPathName('infos-dangerous-goods') }},[_c('a',{attrs:{"href":"/infos-dangerous-goods/#/dangerous-goods"}},[_vm._v(_vm._s(_vm.listpoint_infos_dangerous_goods[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6",class:{ active: _vm.getPathName('infos-prohibited-items') }},[_c('a',{attrs:{"href":"/infos-prohibited-items/#/prohibited-items"}},[_vm._v(_vm._s(_vm.listpoint_infos_prohibited_items[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6",class:{ active: _vm.getPathName('infos-additional-services') }},[_c('a',{attrs:{"href":"/infos-additional-services/#/additional-services"}},[_vm._v(_vm._s(_vm.listpoint_infos_additional_services[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6",class:{ active: _vm.getPathName('infos-serviceonboard') }},[_c('a',{attrs:{"href":"/infos-serviceonboard/#/serviceonboard"}},[_vm._v(_vm._s(_vm.listpoint_infos_serviceonboard[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6",class:{ active: _vm.getPathName('infos-seat-reservation') }},[_c('a',{attrs:{"href":"/infos-seat-reservation/#/seat-reservation"}},[_vm._v(_vm._s(_vm.listpoint_infos_seat_reservation[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6",class:{ active: _vm.getPathName('infos-fare-conditions') }},[_c('a',{attrs:{"href":"/infos-fare-conditions/#/fare-conditions"}},[_vm._v(_vm._s(_vm.listpoint_infos_fare_conditions[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('FAQ')}}},[_vm._v(_vm._s(_vm.listpoint_faq[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('modal',{attrs:{"name":"size-modal-first","transition":"nice-modal-fade","classes":"demo-modal-class","min-width":200,"min-height":200,"pivot-y":0.5,"adaptive":true,"scrollable":true,"reset":true,"xwidth":"40%","height":"auto"},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"size-modal-first-content"},[_c('h2',[_vm._v(_vm._s(_vm.webcomponenttype))]),_vm._v(" "),(_vm.sections.length > 1)?_c('span',_vm._l((_vm.sections),function(section,index){return _c('div',{key:index,staticClass:"toggle-container box",staticStyle:{"margin-bottom":"0px"},attrs:{"id":"accordion1"}},[_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":'#acc1_' + index,"data-toggle":"collapse","data-parent":"#accordion1"}},[_vm._v(_vm._s(section.title))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'acc1_' + index}},[_c('div',{staticClass:"panel-content"},[_c('span',{domProps:{"innerHTML":_vm._s(section.content)}})])])])])})):_vm._e(),_vm._v(" "),(_vm.sections.length === 1)?_c('span',[_c('div',{staticClass:"panel style1"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.sections[0].content)}})])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondRow_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1738b80e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondRow_vue__ = __webpack_require__(328);
function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1738b80e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SecondRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1738b80e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SecondRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(320);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d3a68aa6", content, true, {});

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".size-modal-content[data-v-1738b80e]{padding:10px;font-style:13px;background-color:#fff;padding-right:50px}.v--modal-overlay[data-modal=size-modal][data-v-1738b80e]{background:rgba(0,0,0,.5);z-index:555555!important}.demo-modal-class[data-v-1738b80e]{border-radius:5px;background:#f7f7f7;box-shadow:5px 5px 30px 0 rgba(46,61,73,.6)}", ""]);

// exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DefaultAppSyncMutationAdapter_1 = __webpack_require__(322);
var DefaultAppSyncQueryAdapter_1 = __webpack_require__(324);
exports.default = { DefaultAppSyncQueryAdapter: DefaultAppSyncQueryAdapter_1.default, DefaultAppSyncMutationAdapter: DefaultAppSyncMutationAdapter_1.default };
//# sourceMappingURL=index.js.map

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OperationType_1 = __webpack_require__(17);
var Utils_1 = __webpack_require__(18);
var DefaultAppSyncMutationAdapter = /** @class */ (function () {
    function DefaultAppSyncMutationAdapter(options) {
        if (Array.isArray(options)) {
            this.variables = Utils_1.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields;
            this.operation = options.operation;
        }
    }
    DefaultAppSyncMutationAdapter.prototype.mutationBuilder = function () {
        return this.operationWrapperTemplate(this.variables, this.operationTemplate(this.operation));
    };
    DefaultAppSyncMutationAdapter.prototype.mutationsBuilder = function (mutations) {
        var _this = this;
        var content = mutations.map(function (opts) {
            _this.operation = opts.operation;
            _this.variables = opts.variables;
            _this.fields = opts.fields;
            return _this.operationTemplate(opts.operation);
        });
        return this.operationWrapperTemplate(Utils_1.default.resolveVariables(mutations), content.join("\n  "));
    };
    // Convert object to name and argument map. eg: (id: $id)
    DefaultAppSyncMutationAdapter.prototype.queryDataNameAndArgumentMap = function () {
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    DefaultAppSyncMutationAdapter.prototype.queryDataArgumentAndTypeMap = function (variables) {
        return Object.keys(variables).length
            ? "(".concat(Object.keys(variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1.default.queryDataType(variables[key]));
            }, ""), ")")
            : "";
    };
    // start of mutation building
    DefaultAppSyncMutationAdapter.prototype.operationWrapperTemplate = function (variables, content) {
        return {
            query: "".concat(OperationType_1.default.Mutation, " ").concat(this.operation.charAt(0).toUpperCase() + this.operation.slice(1), " ").concat(this.queryDataArgumentAndTypeMap(variables), " {\n  ").concat(content, "\n}"),
            variables: Utils_1.default.queryVariablesMap(variables),
        };
    };
    DefaultAppSyncMutationAdapter.prototype.operationTemplate = function (operation) {
        return "".concat(operation, " ").concat(this.queryDataNameAndArgumentMap(), " {\n    ").concat(this.queryFieldsMap(this.fields), "\n  }");
    };
    // Fields selection map. eg: { id, name }
    DefaultAppSyncMutationAdapter.prototype.queryFieldsMap = function (fields) {
        var _this = this;
        return Array.isArray(fields)
            ? fields
                .map(function (field) {
                return typeof field === "object"
                    ? "".concat(Object.keys(field)[0], " { ").concat(_this.queryFieldsMap(Object.values(field)[0]), " }")
                    : "".concat(field);
            })
                .join(", ")
            : "";
    };
    return DefaultAppSyncMutationAdapter;
}());
exports.default = DefaultAppSyncMutationAdapter;
//# sourceMappingURL=DefaultAppSyncMutationAdapter.js.map

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isNestedField = void 0;
function isNestedField(object) {
    return (typeof object === "object" &&
        object.hasOwnProperty("operation") &&
        object.hasOwnProperty("variables") &&
        object.hasOwnProperty("fields"));
}
exports.isNestedField = isNestedField;
//# sourceMappingURL=NestedField.js.map

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OperationType_1 = __webpack_require__(17);
var Utils_1 = __webpack_require__(18);
var DefaultAppSyncQueryAdapter = /** @class */ (function () {
    function DefaultAppSyncQueryAdapter(options) {
        this.queryDataType = function (variable) {
            var type = "String";
            var value = typeof variable === "object" ? variable.value : variable;
            if (variable.type !== undefined) {
                type = variable.type;
            }
            else {
                switch (typeof value) {
                    case "object":
                        type = "Object";
                        break;
                    case "boolean":
                        type = "Boolean";
                        break;
                    case "number":
                        type = value % 1 === 0 ? "Int" : "Float";
                        break;
                }
            }
            if (typeof variable === "object" && variable.required) {
                type += "!";
            }
            return type;
        };
        if (Array.isArray(options)) {
            this.variables = Utils_1.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields || [];
            this.operation = options.operation;
        }
    }
    // kicks off building for a single query
    DefaultAppSyncQueryAdapter.prototype.queryBuilder = function () {
        return this.operationWrapperTemplate(this.operationTemplate());
    };
    // if we have an array of options, call this
    DefaultAppSyncQueryAdapter.prototype.queriesBuilder = function (queries) {
        var _this = this;
        var content = function () {
            var tmpl = [];
            queries.forEach(function (query) {
                if (query) {
                    _this.operation = query.operation;
                    _this.fields = query.fields;
                    _this.variables = query.variables;
                    tmpl.push(_this.operationTemplate());
                }
            });
            return tmpl.join(" ");
        };
        return this.operationWrapperTemplate(content());
    };
    // Convert object to name and argument map. eg: (id: $id)
    DefaultAppSyncQueryAdapter.prototype.queryDataNameAndArgumentMap = function () {
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    // Convert object to argument and type map. eg: ($id: Int)
    DefaultAppSyncQueryAdapter.prototype.queryDataArgumentAndTypeMap = function () {
        var _this = this;
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(_this.queryDataType(_this.variables[key]));
            }, ""), ")")
            : "";
    };
    DefaultAppSyncQueryAdapter.prototype.operationWrapperTemplate = function (content) {
        return {
            query: "".concat(OperationType_1.default.Query, " ").concat(this.operation
                .charAt(0)
                .toUpperCase()).concat(this.operation.slice(1), " ").concat(this.queryDataArgumentAndTypeMap(), " { ").concat(content, " }"),
            variables: Utils_1.default.queryVariablesMap(this.variables),
        };
    };
    // query
    DefaultAppSyncQueryAdapter.prototype.operationTemplate = function () {
        return "".concat(this.operation, " ").concat(this.queryDataNameAndArgumentMap(), " { nodes { ").concat(Utils_1.default.queryFieldsMap(this.fields), " } }");
    };
    return DefaultAppSyncQueryAdapter;
}());
exports.default = DefaultAppSyncQueryAdapter;
//# sourceMappingURL=DefaultAppSyncQueryAdapter.js.map

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var OperationType_1 = __webpack_require__(17);
var Utils_1 = __webpack_require__(18);
var DefaultMutationAdapter = /** @class */ (function () {
    function DefaultMutationAdapter(options) {
        if (Array.isArray(options)) {
            this.variables = Utils_1.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields;
            this.operation = options.operation;
        }
    }
    DefaultMutationAdapter.prototype.mutationBuilder = function () {
        return this.operationWrapperTemplate(OperationType_1.default.Mutation, this.variables, this.operationTemplate(this.operation));
    };
    DefaultMutationAdapter.prototype.mutationsBuilder = function (mutations) {
        var _this = this;
        var content = mutations.map(function (opts) {
            _this.operation = opts.operation;
            _this.variables = opts.variables;
            _this.fields = opts.fields;
            return _this.operationTemplate(opts.operation);
        });
        return this.operationWrapperTemplate(OperationType_1.default.Mutation, Utils_1.default.resolveVariables(mutations), content.join("\n  "));
    };
    DefaultMutationAdapter.prototype.queryDataArgumentAndTypeMap = function (variablesUsed) {
        if (this.fields && typeof this.fields === "object") {
            variablesUsed = __assign(__assign({}, Utils_1.default.getNestedVariables(this.fields)), variablesUsed);
        }
        return variablesUsed && Object.keys(variablesUsed).length > 0
            ? "(".concat(Object.keys(variablesUsed).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1.default.queryDataType(variablesUsed[key]));
            }, ""), ")")
            : "";
    };
    // start of mutation building
    DefaultMutationAdapter.prototype.operationWrapperTemplate = function (type, variables, content) {
        return {
            query: "".concat(type, " ").concat(this.queryDataArgumentAndTypeMap(variables), " {\n  ").concat(content, "\n}"),
            variables: Utils_1.default.queryVariablesMap(variables, this.fields),
        };
    };
    DefaultMutationAdapter.prototype.operationTemplate = function (operation) {
        return "".concat(operation, " ").concat(Utils_1.default.queryDataNameAndArgumentMap(this.variables), " ").concat(this.fields && this.fields.length > 0
            ? "{\n    ".concat(Utils_1.default.queryFieldsMap(this.fields), "\n  }")
            : "");
    };
    return DefaultMutationAdapter;
}());
exports.default = DefaultMutationAdapter;
//# sourceMappingURL=DefaultMutationAdapter.js.map

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var OperationType_1 = __webpack_require__(17);
var Utils_1 = __webpack_require__(18);
var DefaultQueryAdapter = /** @class */ (function () {
    function DefaultQueryAdapter(options, configuration) {
        var _this = this;
        // Default configs
        this.config = {
            operationName: "",
        };
        if (configuration) {
            Object.entries(configuration).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                _this.config[key] = value;
            });
        }
        if (Array.isArray(options)) {
            this.variables = Utils_1.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields || [];
            this.operation = options.operation;
        }
    }
    // kicks off building for a single query
    DefaultQueryAdapter.prototype.queryBuilder = function () {
        return this.operationWrapperTemplate(this.operationTemplate(this.variables));
    };
    // if we have an array of options, call this
    DefaultQueryAdapter.prototype.queriesBuilder = function (queries) {
        var _this = this;
        var content = function () {
            var tmpl = [];
            queries.forEach(function (query) {
                if (query) {
                    _this.operation = query.operation;
                    _this.fields = query.fields;
                    tmpl.push(_this.operationTemplate(query.variables));
                }
            });
            return tmpl.join(" ");
        };
        return this.operationWrapperTemplate(content());
    };
    // Convert object to argument and type map. eg: ($id: Int)
    DefaultQueryAdapter.prototype.queryDataArgumentAndTypeMap = function () {
        var variablesUsed = this.variables;
        if (this.fields && typeof this.fields === "object") {
            variablesUsed = __assign(__assign({}, Utils_1.default.getNestedVariables(this.fields)), variablesUsed);
        }
        return variablesUsed && Object.keys(variablesUsed).length > 0
            ? "(".concat(Object.keys(variablesUsed).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1.default.queryDataType(variablesUsed[key]));
            }, ""), ")")
            : "";
    };
    DefaultQueryAdapter.prototype.operationWrapperTemplate = function (content) {
        var query = "".concat(OperationType_1.default.Query, " ").concat(this.queryDataArgumentAndTypeMap(), " { ").concat(content, " }");
        query = query.replace("query", "query".concat(this.config.operationName !== "" ? " " + this.config.operationName : ""));
        return {
            query: query,
            variables: Utils_1.default.queryVariablesMap(this.variables, this.fields),
        };
    };
    // query
    DefaultQueryAdapter.prototype.operationTemplate = function (variables) {
        return "".concat(this.operation, " ").concat(variables ? Utils_1.default.queryDataNameAndArgumentMap(variables) : "", " ").concat(this.fields && this.fields.length > 0
            ? "{ " + Utils_1.default.queryFieldsMap(this.fields) + " }"
            : "");
    };
    return DefaultQueryAdapter;
}());
exports.default = DefaultQueryAdapter;
//# sourceMappingURL=DefaultQueryAdapter.js.map

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OperationType_1 = __webpack_require__(17);
var Utils_1 = __webpack_require__(18);
var DefaultSubscriptionAdapter = /** @class */ (function () {
    function DefaultSubscriptionAdapter(options) {
        if (Array.isArray(options)) {
            this.variables = Utils_1.default.resolveVariables(options);
        }
        else {
            this.variables = options.variables;
            this.fields = options.fields;
            this.operation = options.operation;
        }
    }
    DefaultSubscriptionAdapter.prototype.subscriptionBuilder = function () {
        return this.operationWrapperTemplate(OperationType_1.default.Subscription, this.variables, this.operationTemplate(this.operation));
    };
    DefaultSubscriptionAdapter.prototype.subscriptionsBuilder = function (subscriptions) {
        var _this = this;
        var content = subscriptions.map(function (opts) {
            _this.operation = opts.operation;
            _this.variables = opts.variables;
            _this.fields = opts.fields;
            return _this.operationTemplate(opts.operation);
        });
        return this.operationWrapperTemplate(OperationType_1.default.Subscription, Utils_1.default.resolveVariables(subscriptions), content.join("\n  "));
    };
    // Convert object to name and argument map. eg: (id: $id)
    DefaultSubscriptionAdapter.prototype.queryDataNameAndArgumentMap = function () {
        return this.variables && Object.keys(this.variables).length
            ? "(".concat(Object.keys(this.variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "").concat(key, ": $").concat(key);
            }, ""), ")")
            : "";
    };
    DefaultSubscriptionAdapter.prototype.queryDataArgumentAndTypeMap = function (variables) {
        return Object.keys(variables).length
            ? "(".concat(Object.keys(variables).reduce(function (dataString, key, i) {
                return "".concat(dataString).concat(i !== 0 ? ", " : "", "$").concat(key, ": ").concat(Utils_1.default.queryDataType(variables[key]));
            }, ""), ")")
            : "";
    };
    // start of subscription building
    DefaultSubscriptionAdapter.prototype.operationWrapperTemplate = function (type, variables, content) {
        return {
            query: "".concat(type, " ").concat(this.queryDataArgumentAndTypeMap(variables), " {\n  ").concat(content, "\n}"),
            variables: Utils_1.default.queryVariablesMap(variables),
        };
    };
    DefaultSubscriptionAdapter.prototype.operationTemplate = function (operation) {
        return "".concat(operation, " ").concat(this.queryDataNameAndArgumentMap(), " {\n    ").concat(this.queryFieldsMap(this.fields), "\n  }");
    };
    // Fields selection map. eg: { id, name }
    DefaultSubscriptionAdapter.prototype.queryFieldsMap = function (fields) {
        var _this = this;
        return fields
            ? fields
                .map(function (field) {
                return typeof field === "object"
                    ? "".concat(Object.keys(field)[0], " { ").concat(_this.queryFieldsMap(Object.values(field)[0]), " }")
                    : "".concat(field);
            })
                .join(", ")
            : "";
    };
    return DefaultSubscriptionAdapter;
}());
exports.default = DefaultSubscriptionAdapter;
//# sourceMappingURL=DefaultSubscriptionAdapter.js.map

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-md-6"},[_c('h2',{staticStyle:{"font-size":"28px"}},[_vm._v(_vm._s(_vm.title_legalnotices[_vm.getCurrentLocale]))]),_vm._v(" "),_c('ul',{staticClass:"discover triangle hover row"},[_c('li',{staticClass:"col-xs-6"},[_c('a',{staticStyle:{"color":"#fefe00","font-size":"18px"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('AGB')}}},[_vm._v(_vm._s(_vm.listpoint_agb[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6"},[_c('a',{staticStyle:{"color":"#fefe00","font-size":"18px"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('ABB')}}},[_vm._v(_vm._s(_vm.listpoint_abb[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6"},[_c('a',{staticStyle:{"color":"#fefe00","font-size":"18px"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('IMPRINT')}}},[_vm._v(_vm._s(_vm.listpoint_impressum[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('li',{staticClass:"col-xs-6"},[_c('a',{staticStyle:{"color":"#fefe00","font-size":"18px"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('PCPE')}}},[_vm._v(_vm._s(_vm.infosprivacypolicy[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('modal',{attrs:{"name":"size-modal","transition":"nice-modal-fade","classes":"demo-modal-class","min-width":200,"min-height":200,"pivot-y":0.5,"adaptive":true,"scrollable":true,"reset":true,"height":"auto"},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"size-modal-content"},[_c('h2',[_vm._v(_vm._s(_vm.webcomponenttype))]),_vm._v(" "),(_vm.sections.length > 1)?_c('span',_vm._l((_vm.sections),function(section,index){return _c('div',{key:index,staticClass:"toggle-container box",staticStyle:{"margin-bottom":"0px"},attrs:{"id":"accordion1"}},[_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":'#acc1_' + index,"data-toggle":"collapse","data-parent":"#accordion1"}},[_vm._v(_vm._s(section.title))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'acc1_' + index}},[_c('div',{staticClass:"panel-content"},[_c('span',{domProps:{"innerHTML":_vm._s(section.content)}})])])])])})):_vm._e(),_vm._v(" "),(_vm.sections.length === 1)?_c('span',[_c('div',{staticClass:"panel style1"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.sections[0].content)}})])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThirdRow_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6ebc152_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThirdRow_vue__ = __webpack_require__(332);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a6ebc152"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThirdRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6ebc152_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThirdRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6c90fe14", content, true, {});

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-md-6"},[_c('h2',{staticStyle:{"font-size":"28px"}},[_vm._v(_vm._s(_vm.aboutsundair[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_c('span',{staticStyle:{"color":"#fefe00","font-size":"18px"},domProps:{"innerHTML":_vm._s(_vm.aboutsundairtext[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_c('br'),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageList_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7cf6fea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageList_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f7cf6fea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7cf6fea_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(335);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7b6bfca6", content, true, {});

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".agencyisloggedin[data-v-f7cf6fea]{background-color:#3bdd4e!important}#header .topnav ul.quick-menu>li>a[data-v-f7cf6fea]{line-height:30px;display:block;font-size:.9375em;text-transform:uppercase}", ""]);

// exports


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topnav hidden-xs",class:{ agencyisloggedin: _vm.getFlagSharedAgencyLoggedIn === true }},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"quick-menu pull-left"},[_c('li',{staticClass:"ribbon"},[_c('a',[_vm._v(_vm._s(_vm.language[_vm.getCurrentLocale])+" ("+_vm._s(_vm.getCurrentLocale)+")")]),_vm._v(" "),_c('ul',{staticClass:"menu mini"},[_c('li',{class:{ active: _vm.getCurrentLocale === 'de' }},[_c('a',{attrs:{"href":"#","title":"Deutsch"},on:{"click":function($event){$event.preventDefault();_vm.changeLanguage('de')}}},[_vm._v("Deutsch")])]),_vm._v(" "),_c('li',{class:{ active: _vm.getCurrentLocale === 'en' }},[_c('a',{attrs:{"href":"#","title":"English"},on:{"click":function($event){$event.preventDefault();_vm.changeLanguage('en')}}},[_vm._v("English")])])]),_vm._v(" "),_c('v-dialog')],1)]),_vm._v(" "),_c('v-dialoglogout')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarMain_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80cb081e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarMain_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80cb081e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80cb081e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(339);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("64e238f4", content, true, {});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".menu-color-blue ul.menu.mini[data-v-80cb081e],.menu-color-blue ul.menu.mini li.active[data-v-80cb081e],.menu-color-blue ul.menu.mini li[data-v-80cb081e]:hover,.menu-color-green ul.menu.mini[data-v-80cb081e],.menu-color-green ul.menu.mini li.active[data-v-80cb081e],.menu-color-green ul.menu.mini li[data-v-80cb081e]:hover,.menu-color-skin ul.menu.mini[data-v-80cb081e],.menu-color-skin ul.menu.mini li.active[data-v-80cb081e],.menu-color-skin ul.menu.mini li[data-v-80cb081e]:hover,.menu-color-yellow ul.menu.mini[data-v-80cb081e],.menu-color-yellow ul.menu.mini li.active[data-v-80cb081e],.menu-color-yellow ul.menu.mini li[data-v-80cb081e]:hover{background:#ec008b}#header .mobile-menu .mobile-topnav>li>a[data-v-80cb081e]{font-size:.8333em;padding:0 10px;margin:22px 10px;line-height:1em;width:auto;text-transform:uppercase}.agencyisloggedin[data-v-80cb081e]{background-color:#3bdd4e!important}a[id=_new][data-v-80cb081e]:after{font-family:FontAwesome;content:\" \\F0A2\"}", ""]);

// exports


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-header",staticStyle:{"background-color":"#0a142d !important"}},[_c('a',{staticClass:"mobile-menu-toggle",attrs:{"href":"#mobile-menu-01","data-toggle":"collapse"}},[_vm._v("\n        Mobiles Menü umschalten\n    ")]),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('nav',{attrs:{"id":"main-menu","role":"navigation"}},[_c('ul',{staticClass:"menu"},[_c('li',{staticClass:"menu-item",class:{ active: _vm.getPathName('booking') }},[_c('a',{attrs:{"href":"/booking/"}},[_vm._v(_vm._s(_vm.booking[_vm.getCurrentLocale]))])])])])]),_vm._v(" "),_c('nav',{staticClass:"mobile-menu collapse",attrs:{"id":"mobile-menu-01"}},[_c('ul',{staticClass:"menu",attrs:{"id":"mobile-primary-menu"}},[_c('li',{staticClass:"menu-item",class:{ active: _vm.getPathName('booking') }},[_c('a',{attrs:{"href":"/booking/"}},[_vm._v(_vm._s(_vm.booking[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('ul',{staticClass:"mobile-topnav container"},[_c('li',{staticClass:"ribbon language menu-color-skin"},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.language[_vm.getCurrentLocale])+" ("+_vm._s(_vm.lang)+")")]),_vm._v(" "),_c('ul',{staticClass:"menu mini"},[_c('li',{class:{ active: _vm.lang === 'de' }},[_c('a',{attrs:{"href":"#","title":"Deutsch"},on:{"click":function($event){$event.preventDefault();_vm.changeLanguage('de')}}},[_vm._v("Deutsch")])]),_vm._v(" "),_c('li',{class:{ active: _vm.lang === 'en' }},[_c('a',{attrs:{"href":"#","title":"English"},on:{"click":function($event){$event.preventDefault();_vm.changeLanguage('en')}}},[_vm._v("English")])]),_vm._v(" "),_c('v-dialog')],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"logo navbar-brand"},[_c('a',{attrs:{"href":"/index.php"}},[_c('img',{attrs:{"src":"/res/images/logo.png","alt":"Sundair"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyLogin_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ef9959e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyLogin_vue__ = __webpack_require__(346);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ef9959e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgencyLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ef9959e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgencyLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(343);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("3407c533", content, true, {});

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-md5]{@link https://github.com/emn178/js-md5}
 *
 * @namespace md5
 * @version 0.7.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_MD5_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_MD5_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD = "function" === 'function' && __webpack_require__(345);
  var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [128, 32768, 8388608, -2147483648];
  var SHIFT = [0, 8, 16, 24];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'buffer', 'arrayBuffer', 'base64'];
  var BASE64_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

  var blocks = [], buffer8;
  if (ARRAY_BUFFER) {
    var buffer = new ArrayBuffer(68);
    buffer8 = new Uint8Array(buffer);
    blocks = new Uint32Array(buffer);
  }

  if (root.JS_MD5_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  /**
   * @method hex
   * @memberof md5
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hex('The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method digest
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.digest('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method array
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.array('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method arrayBuffer
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.buffer('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method base64
   * @memberof md5
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.base64('The quick brown fox jumps over the lazy dog');
   */
  var createOutputMethod = function (outputType) {
    return function (message) {
      return new Md5(true).update(message)[outputType]();
    };
  };

  /**
   * @method create
   * @memberof md5
   * @description Create Md5 object
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.create();
   */
  /**
   * @method update
   * @memberof md5
   * @description Create and update Md5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.update('The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.create();
   * hash.update('The quick brown fox jumps over the lazy dog');
   */
  var createMethod = function () {
    var method = createOutputMethod('hex');
    if (NODE_JS) {
      method = nodeWrap(method);
    }
    method.create = function () {
      return new Md5();
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type);
    }
    return method;
  };

  var nodeWrap = function (method) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash('md5').update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw ERROR;
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash('md5').update(new Buffer(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  /**
   * Md5 class
   * @class Md5
   * @description This is internal class.
   * @see {@link md5.create}
   */
  function Md5(sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
      this.buffer8 = buffer8;
    } else {
      if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        this.buffer8 = new Uint8Array(buffer);
        this.blocks = new Uint32Array(buffer);
      } else {
        this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    }
    this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
  }

  /**
   * @method update
   * @memberof Md5
   * @instance
   * @description Update hash
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @see {@link md5.update}
   */
  Md5.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }

    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw ERROR;
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw ERROR;
          }
        }
      } else {
        throw ERROR;
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;
    var buffer8 = this.buffer8;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = blocks[16];
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        if (ARRAY_BUFFER) {
          for (i = this.start; index < length && i < 64; ++index) {
            buffer8[i++] = message[index];
          }
        } else {
          for (i = this.start; index < length && i < 64; ++index) {
            blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
          }
        }
      } else {
        if (ARRAY_BUFFER) {
          for (i = this.start; index < length && i < 64; ++index) {
            code = message.charCodeAt(index);
            if (code < 0x80) {
              buffer8[i++] = code;
            } else if (code < 0x800) {
              buffer8[i++] = 0xc0 | (code >> 6);
              buffer8[i++] = 0x80 | (code & 0x3f);
            } else if (code < 0xd800 || code >= 0xe000) {
              buffer8[i++] = 0xe0 | (code >> 12);
              buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
              buffer8[i++] = 0x80 | (code & 0x3f);
            } else {
              code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
              buffer8[i++] = 0xf0 | (code >> 18);
              buffer8[i++] = 0x80 | ((code >> 12) & 0x3f);
              buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
              buffer8[i++] = 0x80 | (code & 0x3f);
            }
          }
        } else {
          for (i = this.start; index < length && i < 64; ++index) {
            code = message.charCodeAt(index);
            if (code < 0x80) {
              blocks[i >> 2] |= code << SHIFT[i++ & 3];
            } else if (code < 0x800) {
              blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
              blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            } else {
              code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
              blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            }
          }
        }
      }
      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Md5.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[i >> 2] |= EXTRA[i & 3];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = blocks[16];
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.bytes << 3;
    blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
    this.hash();
  };

  Md5.prototype.hash = function () {
    var a, b, c, d, bc, da, blocks = this.blocks;

    if (this.first) {
      a = blocks[0] - 680876937;
      a = (a << 7 | a >>> 25) - 271733879 << 0;
      d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
      d = (d << 12 | d >>> 20) + a << 0;
      c = (-271733879 ^ (d & (a ^ -271733879))) + blocks[2] - 1126478375;
      c = (c << 17 | c >>> 15) + d << 0;
      b = (a ^ (c & (d ^ a))) + blocks[3] - 1316259209;
      b = (b << 22 | b >>> 10) + c << 0;
    } else {
      a = this.h0;
      b = this.h1;
      c = this.h2;
      d = this.h3;
      a += (d ^ (b & (c ^ d))) + blocks[0] - 680876936;
      a = (a << 7 | a >>> 25) + b << 0;
      d += (c ^ (a & (b ^ c))) + blocks[1] - 389564586;
      d = (d << 12 | d >>> 20) + a << 0;
      c += (b ^ (d & (a ^ b))) + blocks[2] + 606105819;
      c = (c << 17 | c >>> 15) + d << 0;
      b += (a ^ (c & (d ^ a))) + blocks[3] - 1044525330;
      b = (b << 22 | b >>> 10) + c << 0;
    }

    a += (d ^ (b & (c ^ d))) + blocks[4] - 176418897;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[5] + 1200080426;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[6] - 1473231341;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[7] - 45705983;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (d ^ (b & (c ^ d))) + blocks[8] + 1770035416;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[9] - 1958414417;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[10] - 42063;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[11] - 1990404162;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (d ^ (b & (c ^ d))) + blocks[12] + 1804603682;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[13] - 40341101;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[14] - 1502002290;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[15] + 1236535329;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[1] - 165796510;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[6] - 1069501632;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[11] + 643717713;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[0] - 373897302;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[5] - 701558691;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[10] + 38016083;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[15] - 660478335;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[4] - 405537848;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[9] + 568446438;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[14] - 1019803690;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[3] - 187363961;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[8] + 1163531501;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[13] - 1444681467;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[2] - 51403784;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[7] + 1735328473;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[12] - 1926607734;
    b = (b << 20 | b >>> 12) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[5] - 378558;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[8] - 2022574463;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[11] + 1839030562;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[14] - 35309556;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[1] - 1530992060;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[4] + 1272893353;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[7] - 155497632;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[10] - 1094730640;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[13] + 681279174;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[0] - 358537222;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[3] - 722521979;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[6] + 76029189;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[9] - 640364487;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[12] - 421815835;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[15] + 530742520;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[2] - 995338651;
    b = (b << 23 | b >>> 9) + c << 0;
    a += (c ^ (b | ~d)) + blocks[0] - 198630844;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[5] - 57434055;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[10] - 1051523;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[15] - 30611744;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[4] - 145523070;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[2] + 718787259;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[9] - 343485551;
    b = (b << 21 | b >>> 11) + c << 0;

    if (this.first) {
      this.h0 = a + 1732584193 << 0;
      this.h1 = b - 271733879 << 0;
      this.h2 = c - 1732584194 << 0;
      this.h3 = d + 271733878 << 0;
      this.first = false;
    } else {
      this.h0 = this.h0 + a << 0;
      this.h1 = this.h1 + b << 0;
      this.h2 = this.h2 + c << 0;
      this.h3 = this.h3 + d << 0;
    }
  };

  /**
   * @method hex
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.hex();
   */
  Md5.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;

    return HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
      HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F];
  };

  /**
   * @method toString
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.toString();
   */
  Md5.prototype.toString = Md5.prototype.hex;

  /**
   * @method digest
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.digest}
   * @example
   * hash.digest();
   */
  Md5.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
    return [
      h0 & 0xFF, (h0 >> 8) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 24) & 0xFF,
      h1 & 0xFF, (h1 >> 8) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 24) & 0xFF,
      h2 & 0xFF, (h2 >> 8) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 24) & 0xFF,
      h3 & 0xFF, (h3 >> 8) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 24) & 0xFF
    ];
  };

  /**
   * @method array
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.array}
   * @example
   * hash.array();
   */
  Md5.prototype.array = Md5.prototype.digest;

  /**
   * @method arrayBuffer
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.arrayBuffer}
   * @example
   * hash.arrayBuffer();
   */
  Md5.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(16);
    var blocks = new Uint32Array(buffer);
    blocks[0] = this.h0;
    blocks[1] = this.h1;
    blocks[2] = this.h2;
    blocks[3] = this.h3;
    return buffer;
  };

  /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.buffer}
   * @example
   * hash.buffer();
   */
  Md5.prototype.buffer = Md5.prototype.arrayBuffer;

  /**
   * @method base64
   * @memberof Md5
   * @instance
   * @description Output hash as base64 string
   * @returns {String} base64 string
   * @see {@link md5.base64}
   * @example
   * hash.base64();
   */
  Md5.prototype.base64 = function () {
    var v1, v2, v3, base64Str = '', bytes = this.array();
    for (var i = 0; i < 15;) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] +
        BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] +
        BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] +
        BASE64_ENCODE_CHAR[v3 & 63];
    }
    v1 = bytes[i];
    base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] +
      BASE64_ENCODE_CHAR[(v1 << 4) & 63] +
      '==';
    return base64Str;
  };

  var exports = createMethod();

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    /**
     * @method md5
     * @description Md5 hash function, export to global in browsers.
     * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
     * @returns {String} md5 hashes
     * @example
     * md5(''); // d41d8cd98f00b204e9800998ecf8427e
     * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
     * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
     *
     * // It also supports UTF-8 encoding
     * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
     *
     * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
     * md5([]); // d41d8cd98f00b204e9800998ecf8427e
     * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
     */
    root.md5 = exports;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20), __webpack_require__(13)))

/***/ }),
/* 345 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"travelo-login-box sdr-box",attrs:{"id":"agency-login"}},[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agency_login),expression:"agency_login"}],staticClass:"input-text full-width",attrs:{"type":"text","placeholder":"agency login"},domProps:{"value":(_vm.agency_login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.agency_login=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.agency_password),expression:"agency_password"}],staticClass:"input-text full-width",attrs:{"type":"password","placeholder":"agency password"},domProps:{"value":(_vm.agency_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.agency_password=$event.target.value}}})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"seperator"}),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seperator"},[_c('label',[_vm._v("Hello Agency")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-medium uppercase full-width"},[_c('i',{staticClass:"soap-icon-trunk-1"}),_vm._v("  Login with Agency")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Don't have an account?  "),_c('a',{staticClass:"goto-signup soap-popupbox"},[_vm._v("+49 30 53676791")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SundairLogin_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ef3330_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SundairLogin_vue__ = __webpack_require__(350);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62ef3330"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SundairLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62ef3330_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SundairLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(349);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1fa9a309", content, true, {});

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"travelo-login-box sdr-box",staticStyle:{"width":"540px"},attrs:{"id":"sundair-login"}},[_c('center',[_c('img',{attrs:{"src":"/res/images/logo.png","alt":"Sundair"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_c('center',[_vm._v(_vm._s(_vm.sundairtravelcenter[_vm.getCurrentLocale]))])],1),_vm._v(" "),_c('div',{staticClass:"seperator"},[_c('label',[_vm._v(_vm._s(_vm.hello[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit_Login($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_login_user),expression:"user_login_user"}],staticClass:"input-text full-width",attrs:{"type":"text","placeholder":_vm.email[_vm.getCurrentLocale]},domProps:{"value":(_vm.user_login_user)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_login_user=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_login_password),expression:"user_login_password"}],staticClass:"input-text full-width",attrs:{"type":"password","placeholder":_vm.password[_vm.getCurrentLocale]},domProps:{"value":(_vm.user_login_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_login_password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('a',{staticClass:"forgot-password pull-right goto-signup soap-popupbox",attrs:{"href":"#sundair-resetpassword"}},[_vm._v(_vm._s(_vm.forgotpassword[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-medium uppercase full-width"},[_c('i',{staticClass:"soap-icon-trunk-1"}),_vm._v("  "+_vm._s(_vm.signin[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"seperator"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.stillnoaccount[_vm.getCurrentLocale])),_c('a',{staticClass:"goto-signup soap-popupbox",attrs:{"href":"#sundair-signup"}},[_vm._v("   "+_vm._s(_vm.signup[_vm.getCurrentLocale])+".")])])],1),_vm._v(" "),_c('div',{staticClass:"travelo-login-box sdr-box",staticStyle:{"width":"540px"},attrs:{"id":"sundair-signup"}},[_c('center',[_c('img',{attrs:{"src":"/res/images/logo.png","alt":"Sundair"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_c('center',[_vm._v(_vm._s(_vm.sundairtravelcenter[_vm.getCurrentLocale]))])],1),_vm._v(" "),_c('div',{staticClass:"seperator"},[_c('label',[_vm._v(_vm._s(_vm.hello2[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit_Signup($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_signup_email),expression:"user_signup_email"}],staticClass:"input-text full-width",attrs:{"type":"text","placeholder":_vm.email[_vm.getCurrentLocale]},domProps:{"value":(_vm.user_signup_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_signup_email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_signup_password),expression:"user_signup_password"}],staticClass:"input-text full-width",attrs:{"type":"password","placeholder":_vm.password[_vm.getCurrentLocale]},domProps:{"value":(_vm.user_signup_password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_signup_password=$event.target.value}}})]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-medium uppercase full-width"},[_c('i',{staticClass:"soap-icon-trunk-1"}),_vm._v("  "+_vm._s(_vm.signup[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"seperator"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.havealreadyanaccount[_vm.getCurrentLocale])),_c('a',{staticClass:"goto-signup soap-popupbox",attrs:{"href":"#sundair-login"}},[_vm._v("   "+_vm._s(_vm.signin[_vm.getCurrentLocale])+".")])])],1),_vm._v(" "),_c('div',{staticClass:"travelo-login-box sdr-box",staticStyle:{"width":"540px"},attrs:{"id":"sundair-resetpassword"}},[_c('center',[_c('img',{attrs:{"src":"/res/images/logo.png","alt":"Sundair"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_c('center',[_vm._v(_vm._s(_vm.sundairtravelcenter[_vm.getCurrentLocale]))])],1),_vm._v(" "),_c('div',{staticClass:"seperator"},[_c('label',[_vm._v(_vm._s(_vm.hello3[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.note[_vm.getCurrentLocale])+": "+_vm._s(_vm.putinemailadress[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit_ResetPassword($event)}}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user_resetpassword_email),expression:"user_resetpassword_email"}],staticClass:"input-text full-width",attrs:{"type":"text","placeholder":_vm.email[_vm.getCurrentLocale]},domProps:{"value":(_vm.user_resetpassword_email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.user_resetpassword_email=$event.target.value}}})]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-medium uppercase full-width"},[_c('i',{staticClass:"soap-icon-trunk-1"}),_vm._v("  "+_vm._s(_vm.resetpassword[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"seperator"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.havealreadyanaccount[_vm.getCurrentLocale])),_c('a',{staticClass:"goto-signup soap-popupbox",attrs:{"href":"#sundair-login"}},[_vm._v("   "+_vm._s(_vm.signin[_vm.getCurrentLocale])+".")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarBreadcrumbs_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10dc5101_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarBreadcrumbs_vue__ = __webpack_require__(352);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavbarBreadcrumbs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10dc5101_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavbarBreadcrumbs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page-title pull-left"},[_c('h2',{staticClass:"entry-title",staticStyle:{"font-size":"28px"}},[(_vm.getPathName('booking'))?_c('span',[_vm._v(_vm._s(_vm.booking[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('services'))?_c('span',[_vm._v(_vm._s(_vm.services[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('rebooking'))?_c('span',[_vm._v(_vm._s(_vm.rebooking[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('mybookings'))?_c('span',[_vm._v(_vm._s(_vm.mybookings[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('flightplan'))?_c('span',[_vm._v(_vm._s(_vm.flightplan[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('pressreleases'))?_c('span',[_vm._v(_vm._s(_vm.pressreleases[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('career'))?_c('span',[_vm._v(_vm._s(_vm.career[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('agency'))?_c('span',[_vm._v(_vm._s(_vm.agency[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('travelcenter'))?_c('span',[_vm._v(_vm._s(_vm.travelcenter[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('flightstatus'))?_c('span',[_vm._v(_vm._s(_vm.flightstatus[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('checkout'))?_c('span',[_vm._v(_vm._s(_vm.checkout[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('webshop'))?_c('span',[_vm._v(_vm._s(_vm.webshop[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-luggage'))?_c('span',[_vm._v(_vm._s(_vm.infos_luggage[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-dangerous-goods'))?_c('span',[_vm._v(_vm._s(_vm.infos_dangerous_goods[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-prohibited-items'))?_c('span',[_vm._v(_vm._s(_vm.infos_prohibited_items[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-additional-services'))?_c('span',[_vm._v(_vm._s(_vm.infos_additional_services[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-serviceonboard'))?_c('span',[_vm._v(_vm._s(_vm.infos_serviceonboard[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-seat-reservation'))?_c('span',[_vm._v(_vm._s(_vm.infos_seat_reservation[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-fare-conditions'))?_c('span',[_vm._v(_vm._s(_vm.infos_fare_conditions[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-complaints'))?_c('span',[_vm._v(_vm._s(_vm.infos_complaints[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-group-booking'))?_c('span',[_vm._v(_vm._s(_vm.infos_group_booking[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-covid19'))?_c('span',[_vm._v(_vm._s(_vm.infos_covid19[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-important-infos'))?_c('span',[_vm._v(_vm._s(_vm.infos_important_infos[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-infoalert'))?_c('span',[_vm._v(_vm._s(_vm.infos_infoalert[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-info3g'))?_c('span',[_vm._v(_vm._s(_vm.infos_info3g[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"breadcrumbs pull-right"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"active"},[(_vm.getPathName('booking'))?_c('span',[_vm._v(_vm._s(_vm.booking[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('services'))?_c('span',[_vm._v(_vm._s(_vm.services[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('rebooking'))?_c('span',[_vm._v(_vm._s(_vm.rebooking[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('mybookings'))?_c('span',[_vm._v(_vm._s(_vm.mybookings[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('flightplan'))?_c('span',[_vm._v(_vm._s(_vm.flightplan[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('pressreleases'))?_c('span',[_vm._v(_vm._s(_vm.pressreleases[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('career'))?_c('span',[_vm._v(_vm._s(_vm.career[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('agency'))?_c('span',[_vm._v(_vm._s(_vm.agency[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('travelcenter'))?_c('span',[_vm._v(_vm._s(_vm.travelcenter[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('flightstatus'))?_c('span',[_vm._v(_vm._s(_vm.flightstatus[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('checkout'))?_c('span',[_vm._v(_vm._s(_vm.checkout[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('webshop'))?_c('span',[_vm._v(_vm._s(_vm.webshop[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-luggage'))?_c('span',[_vm._v(_vm._s(_vm.infos_luggage[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-dangerous-goods'))?_c('span',[_vm._v(_vm._s(_vm.infos_dangerous_goods[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-prohibited-items'))?_c('span',[_vm._v(_vm._s(_vm.infos_prohibited_items[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-additional-services'))?_c('span',[_vm._v(_vm._s(_vm.infos_additional_services[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-serviceonboard'))?_c('span',[_vm._v(_vm._s(_vm.infos_serviceonboard[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-seat-reservation'))?_c('span',[_vm._v(_vm._s(_vm.infos_seat_reservation[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-fare-conditions'))?_c('span',[_vm._v(_vm._s(_vm.infos_fare_conditions[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-complaints'))?_c('span',[_vm._v(_vm._s(_vm.infos_complaints[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-group-booking'))?_c('span',[_vm._v(_vm._s(_vm.infos_group_booking[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-covid19'))?_c('span',[_vm._v(_vm._s(_vm.infos_covid19[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-infoalert'))?_c('span',[_vm._v(_vm._s(_vm.infos_infoalert[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getPathName('infos-info3g'))?_c('span',[_vm._v(_vm._s(_vm.infos_info3g[_vm.getCurrentLocale]))]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"/index.php"}},[_vm._v("HOME")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_booking_booking__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_services_services__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_rebooking_rebooking__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_auth_auth__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_travelcenter_travelcenter__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_career_career__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_covid_covid__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_infoalert_infoalert__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_pressreleases_pressreleases__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_flightstatus_flightstatus__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getters__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mutations__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(366);
/*
 * store.js
 *
 * Description: Holds common/global Stores.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */


 // 'Booking:Store'
 // 'Services:Store'
 // 'Rebooking:Store'
 // 'Auth:Store'
 // 'Travelcenter:Store'
 // 'Career:Store'
 // 'Covid:Store'
 // 'Infoalert:Store'
 // 'Pressreleases:Store'
 // 'Flightstatus:Store'

 // global ones



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        // >>> just demo
        value: 0
    },
    getters: __WEBPACK_IMPORTED_MODULE_12__getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_13__mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_14__actions__,
    modules: {
        booking: __WEBPACK_IMPORTED_MODULE_2__modules_booking_booking__["a" /* default */],
        services: __WEBPACK_IMPORTED_MODULE_3__modules_services_services__["a" /* default */],
        rebooking: __WEBPACK_IMPORTED_MODULE_4__modules_rebooking_rebooking__["a" /* default */],
        auth: __WEBPACK_IMPORTED_MODULE_5__modules_auth_auth__["a" /* default */],
        travelcenter: __WEBPACK_IMPORTED_MODULE_6__modules_travelcenter_travelcenter__["a" /* default */],
        career: __WEBPACK_IMPORTED_MODULE_7__modules_career_career__["a" /* default */],
        covid: __WEBPACK_IMPORTED_MODULE_8__modules_covid_covid__["a" /* default */],
        infoalert: __WEBPACK_IMPORTED_MODULE_9__modules_infoalert_infoalert__["a" /* default */],
        pressreleases: __WEBPACK_IMPORTED_MODULE_10__modules_pressreleases_pressreleases__["a" /* default */],
        flightstatus: __WEBPACK_IMPORTED_MODULE_11__modules_flightstatus_flightstatus__["a" /* default */]
    }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(6);
var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/






//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> currentLocale ----------------------------------
    currentLocale: 'de',

    // >>> Flag: AgencyLogin ------------------------------
    flagSharedAgencyLoggedIn: false,
    sharedAgencyLoginResults: {},

    shared_AgencyGetBookings: [],
    shared_AgencyGetBookings_Filtered: [],
    shared_filterSearchAgencyBookingsParams: {
        "searchfor_flightdate": '',
        "searchfor_bookingcode": '',
        "searchfor_invoiceid": '',
        "searchfor_surname": ''
    },

    shared_AgencyTotalBrutto: 0,
    shared_AgencyAgencyTotalBrutto: 0,
    shared_AgencyAgencyCashLimit: 0,
    shared_AgencyBookingsParams: {},

    // >>> Flag: Show Section 'FlightSearchResults' -------
    flagSharedShowFlightSearchResults: false, // CONTROL FLAG - 'Search Results Section'

    // >>> 'Users Search Data' ----------------------------
    bookingDepArprtCode: '', // Dep Airport FLight Search, Code
    bookingDesArprtCode: '', // Des Airport FLight Search, Code
    bookingDepArprtName: '', // Dep Airport FLight Search, Name
    bookingDesArprtName: '', // Des Airport FLight Search, Name
    bookingDepArprtCode_ReturnToOther: '', // Dep Airport FLight Search, Code (Return to other)
    bookingDesArprtCode_ReturnToOther: '', // Des Airport FLight Search, Code (Return to other)
    bookingDepArprtName_ReturnToOther: '', // Dep Airport FLight Search, Name (Return to other)
    bookingDesArprtName_ReturnToOther: '', // Des Airport FLight Search, Name (Return to other)

    bookingUsersSearchData: { // Users Search Data
        depAfter: '',
        depArprtCode: '',
        desArprtCode: '',
        limit: '',
        noADT: '',
        noCHD: '',
        noINF: '',
        ojArprtCode: '',
        ojType: '',
        rTrip: '',
        retAfter: ''
    },

    // >>> 'Users FlightSearch Results' -------------------
    bookingFlightSearchResults: {}, // SearchResults
    // >>> 'Users Lockfares Results' ----------------------
    bookingLockfaresResults: {},
    // >>> 'Users Process Results' ------------------------
    bookingProcessBookingResult: {},

    // >>> Seatmap(s) Stuff -------------------------------
    bookingSeatReservationLockingCodeResults: { // saving both Directions
        outward: '',
        return: ''
    },
    bookingSeatPlanOutwardResults: {},
    bookingSeatPlanReturnResults: {},

    // >>> 'Users Cart&More' ------------------------------
    bookingCart: [],
    bookingCartOutwardTotal: 0,
    bookingCartReturnTotal: 0,

    flagBookingOutwardFlightSelected: false, // CONTROL FLAG - Selected 'Outward Flight'
    flagBookingReturnFlightSelected: false, // CONTROL FLAG - Selected 'Return Flight'
    bookingFlightIdSelectedOutward: null, // which selected OUT Flight ID
    bookingFlightIdSelectedReturn: null, // which selected RET Flight ID
    bookingPriceIdSelectedOutward: null, // which selected OUT PRCS ID
    bookingPriceIdSelectedReturn: null, // which selected RET PRCS ID

    bookingSrvcsSeatExistOnOut: false, // does Srvcs Seat exist on OUT?
    bookingSrvcsSeatExistOnRet: false, // does Srvcs Seat exist on Ret?
    bookingSrvcsMealExists: false, // does Srvcs 'MEAL' exist?
    bookingSrvcsServiceExists: false, // does Srvcs 'SERVICE' exist?
    bookingSrvcsPetsExists: false, // does Srvcs 'PETS' exist?
    bookingSrvcsSportbagExists: false, // does Srvcs 'SPORTBAG' exist?
    bookingSrvcsBaggageExists: false, // does Srvcs 'BAGGAGE' exist?
    bookingSrvcsMedicalExists: false, // does Srvcs 'MEDICAL' exist?
    bookingSrvcsInsuranceExists: false, // does Srvcs 'INSURANCE' exist?
    bookingSrvcsInsuranceObject: {}, // Insurance Object itself


    flagBookingPassengersAreReadyForValidation: true, // Passenger(s) are ready ...
    flagBookingPaymentIsReadyForOverview: false, // 'Payment' is ready ...
    flagBookingOverviewIsReadyForProcess: false, // 'Overview' is ready ...

    bookingValidatePassengersObject: {}, // Calls Object to send ..
    bookingProcessBookingObject: {}, // Calls Object to send ..


    // >>> 'Offers' ---------------------------------------
    bookingOffers: {}, // KeyDestinatiosns Offers
    bookingDeparturesKeyDes: [], // KeyDestinatiosns Departure Airports

    bookingOffersSelectedDestination: {}, // User selected Destination
    bookingOffersListFlightsMonthlyOffers: [], // Next 6 Months Prices Offers
    bookingOffersChoosenFlightByUser: null, // User choosen Flight of Offers
    flagSharedShowFlightSearchResultsAndBestPriceCaroussel: false, // CONTROL FLAG - 'Search Results Section and Best Prices'


    // >>> 'Wirecard' -------------------------------------
    bookingWireCardEnrollPaymentResults: {}

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: Current Locale
    ***************************************************************************/
    /***************************************************************************
    * getCurrentLocale()
    *
    * Desc:
    * Note:
    *
    */
    getCurrentLocale: function getCurrentLocale(state) {

        var data = JSON.parse(localStorage.getItem('sdr__lang'));

        if (data === null) {
            return state.currentLocale;
        }
        if (data.value !== null) {
            return state.currentLocale === data.value ? state.currentLocale : data.value;
        }
        // return data.value;
    }, // eof getCurrentLocale()


    /***************************************************************************
    * Getters: Flag: Agency Login
    ***************************************************************************/
    /***************************************************************************
    * getFlagSharedAgencyLoggedIn()
    *
    * Desc:
    * Note:
    *
    */
    getFlagSharedAgencyLoggedIn: function getFlagSharedAgencyLoggedIn(state) {

        return state.flagSharedAgencyLoggedIn;
    }, // eof getFlagSharedAgencyLoggedIn()


    /***************************************************************************
    * getSharedAgencyLoginResultsAmountAndValue()
    *
    * Desc: Return Agency Commison&Type. Catch from localStorage. NOT from State.
    * Note: Extract from agency-object in localStorage.
    *
    */
    getSharedAgencyLoginResultsAmountAndValue: function getSharedAgencyLoginResultsAmountAndValue(state) {
        return function (payload) {

            var ao = JSON.parse(localStorage.getItem('sdr__agency_object')),
                ao2 = JSON.parse(ao.value);

            if (payload === 'services') {
                return ao2.agency_servicecommission_amount + ' ' + ao2.agency_servicecommission_type;
            } else {
                return ao2.agency_commission_amount + ' ' + ao2.agency_commission_type;
            }
        };
    }, // eof getSharedAgencyLoginResultsAmountAndValue()


    /***************************************************************************
    * getSharedAgencyLoginResultsAgencyObject()
    *
    * Desc: Return Agency Object. Catch from localStorage. NOT from State.
    * Note: Extract from agency-object in localStorage.
    *
    */
    getSharedAgencyLoginResultsAgencyObject: function getSharedAgencyLoginResultsAgencyObject(state) {

        var ao = JSON.parse(localStorage.getItem('sdr__agency_object'));

        return ao.value;
    }, // eof getSharedAgencyLoginResultsAgencyObject()


    /***************************************************************************
    * get_agencyAuthorizationHeader()
    *
    * Desc: Return ... Catch up (Agency) Auth Header from Ls.
    * Note:
    *
    */
    get_agencyAuthorizationHeader: function get_agencyAuthorizationHeader(state) {

        var localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__agencyAuthorizationHeader'));

        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            localStorageHeader = JSON.parse(localStorageHeaderData.value);
        }

        return localStorageHeader;
    }, // eo function get_agencyAuthorizationHeader()


    /***************************************************************************
    * get_agencyUsername()
    *
    * Desc:
    * Note:
    *
    */
    get_agencyUsername: function get_agencyUsername(state) {

        var localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__agency_username'));

        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            // localStorageHeader = JSON.parse(localStorageHeaderData.value);
            localStorageHeader = localStorageHeaderData.value;
        }

        return localStorageHeader;
    }, // eo function get_agencyUsername()


    /***************************************************************************
    * get_agencyPassword()
    *
    * Desc:
    * Note:
    *
    */
    get_agencyPassword: function get_agencyPassword(state) {

        var localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__agency_password'));

        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            // localStorageHeader = JSON.parse(localStorageHeaderData.value);
            localStorageHeader = localStorageHeaderData.value;
        }

        return localStorageHeader;
    }, // eo function get_agencyPassword()


    /***************************************************************************
    * get_shared_AgencyGetBookings()
    *
    * Desc: Return Agencies 'Get Bookings'.
    * Note:
    *
    */
    get_shared_AgencyGetBookings: function get_shared_AgencyGetBookings(state) {

        return state.shared_AgencyGetBookings;
    }, // eof get_shared_AgencyGetBookings()

    /***************************************************************************
    * get_shared_AgencyGetBookings_Filtered()
    *
    * Desc: Return Agencies 'Get Bookings' BUT ... filtered.
    * Note:
    *
    */
    get_shared_AgencyGetBookings_Filtered: function get_shared_AgencyGetBookings_Filtered(state) {

        return state.shared_AgencyGetBookings_Filtered;
    }, // eof get_shared_AgencyGetBookings_Filtered()


    /***************************************************************************
    * get_shared_AgencyTotalBrutto()
    *
    * Desc: Return Agencies 'Total Brutto'
    * Note:
    *
    */
    get_shared_AgencyTotalBrutto: function get_shared_AgencyTotalBrutto(state) {

        return state.shared_AgencyTotalBrutto;
    }, // eof get_shared_AgencyTotalBrutto()


    /***************************************************************************
    * get_shared_AgencyAgencyTotalBrutto()
    *
    * Desc: Return Agencies 'Total Brutto of Agency'
    * Note:
    *
    */
    get_shared_AgencyAgencyTotalBrutto: function get_shared_AgencyAgencyTotalBrutto(state) {

        return state.shared_AgencyAgencyTotalBrutto;
    }, // eof get_shared_AgencyAgencyTotalBrutto()


    /***************************************************************************
    * get_shared_AgencyAgencyCashLimit()
    *
    * Desc: Return Agencies 'Cash Limit'
    * Note:
    *
    */
    get_shared_AgencyAgencyCashLimit: function get_shared_AgencyAgencyCashLimit(state) {

        return state.shared_AgencyAgencyCashLimit;
    }, // eof get_shared_AgencyAgencyCashLimit()


    /***************************************************************************
    * get_shared_AgencyBookingsParams()
    *
    * Desc: Return Agencies Search Params.
    * Note:
    *
    */
    get_shared_AgencyBookingsParams: function get_shared_AgencyBookingsParams(state) {

        return state.shared_AgencyBookingsParams;
    }, // eof get_shared_AgencyBookingsParams()


    /***************************************************************************
    * Getters: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * getFlagSharedShowFlightSearchResults()
    *
    * Desc: Return Flag: 'Show Flight Search Results Section'
    * Note:
    *
    */
    getFlagSharedShowFlightSearchResults: function getFlagSharedShowFlightSearchResults(state) {

        return state.flagSharedShowFlightSearchResults;
    }, // eof getFlagSharedShowFlightSearchResults()


    /***************************************************************************
    * Getters: Users Search
    ***************************************************************************/
    /***************************************************************************
    * getBookingDepArprtCode()
    *
    * Desc: Return DepArprtCode
    * Note: Users Search, Part 1
    *
    */
    getBookingDepArprtCode: function getBookingDepArprtCode(state) {

        return state.bookingDepArprtCode;
    }, // eof getBookingDepArprtCode()

    /***************************************************************************
    * getBookingDepArprtName()
    *
    * Desc: Return DepArprtName
    * Note: Users Search, Part 1
    *
    */
    getBookingDepArprtName: function getBookingDepArprtName(state) {

        return state.bookingDepArprtName;
    }, // eof getBookingDepArprtName()

    /***************************************************************************
    * getBookingDesArprtCode()
    *
    * Desc: Return DesArprtCode
    * Note: Users Search, Part 1
    *
    */
    getBookingDesArprtCode: function getBookingDesArprtCode(state) {

        return state.bookingDesArprtCode;
    }, // eof getBookingDesArprtCode()

    /***************************************************************************
    * getBookingDesArprtName()
    *
    * Desc: Return DesArprtName
    * Note: Users Search, Part 1
    *
    */
    getBookingDesArprtName: function getBookingDesArprtName(state) {

        return state.bookingDesArprtName;
    }, // eof getBookingDesArprtName()


    /***************************************************************************
    * getBookingDepArprtCodeReturnToOther()
    *
    * Desc: Return DepArprtCode_ReturnToOther;
    * Note:
    *
    */
    getBookingDepArprtCodeReturnToOther: function getBookingDepArprtCodeReturnToOther(state) {

        return state.bookingDepArprtCode_ReturnToOther;
    }, // eof getBookingDepArprtCodeReturnToOther()

    /***************************************************************************
    * getBookingDepArprtNameReturnToOther()
    *
    * Desc: Return DepArprtName_ReturnToOther;
    * Note:
    *
    */
    getBookingDepArprtNameReturnToOther: function getBookingDepArprtNameReturnToOther(state) {

        return state.bookingDepArprtName_ReturnToOther;
    }, // eof getBookingDepArprtNameReturnToOther()


    /***************************************************************************
    * getBookingDesArprtCodeReturnToOther()
    *
    * Desc: Return DesArprtCode_ReturnToOther;
    * Note:
    *
    */
    getBookingDesArprtCodeReturnToOther: function getBookingDesArprtCodeReturnToOther(state) {

        return state.bookingDesArprtCode_ReturnToOther;
    }, // eof getBookingDesArprtCodeReturnToOther()


    /***************************************************************************
    * getBookingDesArprtNameReturnToOther()
    *
    * Desc: Return DesArprtName_ReturnToOther;
    * Note:
    *
    */
    getBookingDesArprtNameReturnToOther: function getBookingDesArprtNameReturnToOther(state) {

        return state.bookingDesArprtName_ReturnToOther;
    }, // eof getBookingDesArprtNameReturnToOther()


    /***************************************************************************
    * getBookingUsersSearchData()
    *
    * Desc: Return entire Users Search Object.
    * Note: Users Search, Part 2
    *
    */
    getBookingUsersSearchData: function getBookingUsersSearchData(state) {

        return state.bookingUsersSearchData;
    }, // eof getBookingUsersSearchData()


    /***************************************************************************
    * getBookingUsersSearchData_OjArprtCode()
    *
    * Desc: Return
    * Note:
    *
    */
    getBookingUsersSearchData_OjArprtCode: function getBookingUsersSearchData_OjArprtCode(state) {

        return state.bookingUsersSearchData.ojArprtCode;
    }, // eof getBookingUsersSearchData_OjArprtCode()


    /***************************************************************************
    * Getters: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * getBookingFlightSearchResults()
    *
    * Desc: Return Results of FlightSearch (Calls Response).
    * Note:
    *
    */
    getBookingFlightSearchResults: function getBookingFlightSearchResults(state) {

        return state.bookingFlightSearchResults;
    }, // eof getBookingFlightSearchResults()


    /***************************************************************************
    * getFlagBookingOutwardFlightSelected()
    *
    * Desc: Is 'Outward Flight' selected.
    * Note:
    *
    */
    getFlagBookingOutwardFlightSelected: function getFlagBookingOutwardFlightSelected(state) {

        return state.flagBookingOutwardFlightSelected;
    }, // eof getFlagBookingOutwardFlightSelected()


    /***************************************************************************
    * getFlagBookingReturnFlightSelected()
    *
    * Desc: Is 'Return Flight' selected.
    * Note:
    *
    */
    getFlagBookingReturnFlightSelected: function getFlagBookingReturnFlightSelected(state) {

        return state.flagBookingReturnFlightSelected;
    }, // eof getFlagBookingReturnFlightSelected()


    /***************************************************************************
    * getBookingFlightIdSelectedOutward()
    *
    * Desc: Selected Outward Flight Id.
    * Note:
    *
    */
    getBookingFlightIdSelectedOutward: function getBookingFlightIdSelectedOutward(state) {

        return state.bookingFlightIdSelectedOutward;
    }, // eof getBookingFlightIdSelectedOutward()


    /***************************************************************************
    * getBookingFlightIdSelectedReturn()
    *
    * Desc: Selected Return Flight Id.
    * Note:
    *
    */
    getBookingFlightIdSelectedReturn: function getBookingFlightIdSelectedReturn(state) {

        return state.bookingFlightIdSelectedReturn;
    }, // eof getBookingFlightIdSelectedReturn()


    /***************************************************************************
    * getBookingPriceIdSelectedOutward()
    *
    * Desc: Selected Outward Price Id.
    * Note:
    *
    */
    getBookingPriceIdSelectedOutward: function getBookingPriceIdSelectedOutward(state) {

        return state.bookingPriceIdSelectedOutward;
    }, // eof getBookingPriceIdSelectedOutward()


    /***************************************************************************
    * getBookingPriceIdSelectedReturn()
    *
    * Desc: Selected Return Price Id.
    * Note:
    *
    */
    getBookingPriceIdSelectedReturn: function getBookingPriceIdSelectedReturn(state) {

        return state.bookingPriceIdSelectedReturn;
    }, // eof getBookingPriceIdSelectedReturn()


    /***************************************************************************
    * Getters: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * getBookingLockfaresResults()
    *
    * Desc: Return Results of Lockfares (Calls Response).
    * Note:
    *
    */
    getBookingLockfaresResults: function getBookingLockfaresResults(state) {

        return state.bookingLockfaresResults;
    }, // eof getBookingLockfaresResults()


    /***************************************************************************
    * getBookingPassengers()
    *
    * Desc: Returns an Array of 'PassengersTypes'.
    * Note: kop ('AdultWithoutInfant', 'AdultWithInfant', 'Child', 'Nobody')
    * Note: Getter with Paylod
    *
    */
    getBookingPassengers: function getBookingPassengers(state) {
        return function (payload) {

            var paxArray = [],
                counter = 1,
                travelsWithInfantNumber = '',
                countADT = parseFloat(state.bookingUsersSearchData.noADT),
                countCHD = parseFloat(state.bookingUsersSearchData.noCHD),
                countINF = parseFloat(state.bookingUsersSearchData.noINF),
                countADTCHD = countADT + countCHD,
                countADTCHDINF = countADTCHD + countINF;

            for (var i = 0; i < state.bookingUsersSearchData.noADT; i++) {
                // >>> ---------------------------------------------------------
                if (countINF === 0) {
                    travelsWithInfantNumber = '';
                }

                // >>> ---------------------------------------------------------
                if (countINF !== 0) {
                    // >>> Step 1: Catch every Pax Data (INF) ------------------
                    for (var x = countADTCHD + 1; x <= countADTCHDINF; x++) {
                        // >>> Arrange adults to a baby ------------------------
                        if (x === parseFloat(counter) + parseFloat(countADTCHD)) {
                            travelsWithInfantNumber = x;
                        }
                    }
                }

                paxArray.push({
                    type: 'ADT',
                    index: counter,
                    id_pax: counter,
                    kop: travelsWithInfantNumber !== '' ? 'AdultWithInfant' : 'AdultWithoutInfant'
                });
                counter = counter + 1;
                travelsWithInfantNumber = '';
            }
            for (var i = 0; i < state.bookingUsersSearchData.noCHD; i++) {
                paxArray.push({
                    type: 'CHD',
                    index: counter,
                    id_pax: counter,
                    kop: 'Child'
                });
                counter = counter + 1;
            }
            if (payload === 'booking') {
                for (var i = 0; i < state.bookingUsersSearchData.noINF; i++) {
                    paxArray.push({
                        type: 'INF',
                        index: counter,
                        id_pax: counter,
                        kop: 'Nobody'
                    });
                    counter = counter + 1;
                }
            }

            return paxArray;
        };
    }, // eof getBookingPassengers()


    /***************************************************************************
    * getBookingPassengersSrvcsService()
    *
    * Desc: Returns an Array of Srvcs 'SERVICE'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsService: function getBookingPassengersSrvcsService(state) {

        var srvcsArray = [];

        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'service') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'service') {
                    var result = srvcsArray.findIndex(function (srvcs) {
                        return srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id;
                    });
                    if (result === -1) {
                        // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {
                        // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }

        return srvcsArray;
    }, // eof getBookingPassengersSrvcsService()


    /***************************************************************************
    * getBookingPassengersSrvcsMeals()
    *
    * Desc: Returns an Array of Srvcs 'MEALS'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsMeals: function getBookingPassengersSrvcsMeals(state) {

        var srvcsArray = [];

        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'meal') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'meal') {
                    var result = srvcsArray.findIndex(function (srvcs) {
                        return srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id;
                    });
                    if (result === -1) {
                        // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {
                        // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }

        return srvcsArray;
    }, // eof getBookingPassengersSrvcsMeals()


    /***************************************************************************
    * getBookingPassengersSrvcsPets()
    *
    * Desc: Returns an Array of Srvcs 'PETS'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsPets: function getBookingPassengersSrvcsPets(state) {

        var srvcsArray = [];

        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'pets') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'pets') {
                    var result = srvcsArray.findIndex(function (srvcs) {
                        return srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id;
                    });
                    if (result === -1) {
                        // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {
                        // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }

        return srvcsArray;
    }, // eof getBookingPassengersSrvcsPets()


    /***************************************************************************
    * getBookingPassengersSrvcsSportbag()
    *
    * Desc: Returns an Array of Srvcs 'SPORTBAG'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsSportbag: function getBookingPassengersSrvcsSportbag(state) {

        var srvcsArray = [];

        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'sportbag') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'sportbag') {
                    var result = srvcsArray.findIndex(function (srvcs) {
                        return srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id;
                    });
                    if (result === -1) {
                        // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {
                        // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }

        return srvcsArray;
    }, // eof getBookingPassengersSrvcsSportbag()


    /***************************************************************************
    * getBookingPassengersSrvcsSportbag()
    *
    * Desc: Returns an Array of Srvcs 'BAGGAGE'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsBaggage: function getBookingPassengersSrvcsBaggage(state) {

        var srvcsArray = [];

        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'baggage') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'baggage') {
                    var result = srvcsArray.findIndex(function (srvcs) {
                        return srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id;
                    });
                    if (result === -1) {
                        // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {
                        // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }

        return srvcsArray;
    }, // eof getBookingPassengersSrvcsBaggage()


    /***************************************************************************
    * getBookingPassengersSrvcsMedical()
    *
    * Desc: Returns an Array of Srvcs 'MEDICAL'.
    * Note: ToDo: OPTIMIZE! (This could all be ONE Method only. With Get Param!)
    *
    */
    getBookingPassengersSrvcsMedical: function getBookingPassengersSrvcsMedical(state) {

        var srvcsArray = [];

        for (var i = 0; i < state.bookingLockfaresResults.outwardFlight.services.length; i++) {
            if (state.bookingLockfaresResults.outwardFlight.services[i].categoryCode === 'medical') {
                srvcsArray.push({
                    id: state.bookingLockfaresResults.outwardFlight.services[i].id,
                    description: state.bookingLockfaresResults.outwardFlight.services[i].description,
                    remark: state.bookingLockfaresResults.outwardFlight.services[i].remark,
                    code: state.bookingLockfaresResults.outwardFlight.services[i].code,
                    price: state.bookingLockfaresResults.outwardFlight.services[i].price,
                    maxBookablePax: state.bookingLockfaresResults.outwardFlight.services[i].maxBookablePax,
                    acceptComment: state.bookingLockfaresResults.outwardFlight.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            for (var i = 0; i < state.bookingLockfaresResults.inboundFlight.services.length; i++) {
                if (state.bookingLockfaresResults.inboundFlight.services[i].categoryCode === 'medical') {
                    var result = srvcsArray.findIndex(function (srvcs) {
                        return srvcs.id === state.bookingLockfaresResults.inboundFlight.services[i].id;
                    });
                    if (result === -1) {
                        // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.bookingLockfaresResults.inboundFlight.services[i].id,
                            description: state.bookingLockfaresResults.inboundFlight.services[i].description,
                            remark: state.bookingLockfaresResults.inboundFlight.services[i].remark,
                            code: state.bookingLockfaresResults.inboundFlight.services[i].code,
                            price: state.bookingLockfaresResults.inboundFlight.services[i].price,
                            maxBookablePax: state.bookingLockfaresResults.inboundFlight.services[i].maxBookablePax,
                            acceptComment: state.bookingLockfaresResults.inboundFlight.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {
                        // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }

        return srvcsArray;
    }, // eof getBookingPassengersSrvcsMedical()


    /***************************************************************************
    * getBookingSrvcsSeatExistOnOut()
    *
    * Desc: Return 'Srvcs SEAT exist on OUT'.
    * Note:
    *
    */
    getBookingSrvcsSeatExistOnOut: function getBookingSrvcsSeatExistOnOut(state) {

        return state.bookingSrvcsSeatExistOnOut;
    }, // eof getBookingSrvcsSeatExistOnOut()


    /***************************************************************************
    * getBookingSrvcsSeatExistOnRet()
    *
    * Desc: Return 'Srvcs SEAT exist on RET'.
    * Note:
    *
    */
    getBookingSrvcsSeatExistOnRet: function getBookingSrvcsSeatExistOnRet(state) {

        return state.bookingSrvcsSeatExistOnRet;
    }, // eof getBookingSrvcsSeatExistOnRet()


    /***************************************************************************
    * getBookingSrvcsInsuranceExist()
    *
    * Desc: 'Srvcs INSURANCE exists'.
    * Note:
    *
    */
    getBookingSrvcsInsuranceExist: function getBookingSrvcsInsuranceExist(state) {

        return state.bookingSrvcsInsuranceExists;
    }, // eof getBookingSrvcsInsuranceExist()


    /***************************************************************************
    * getBookingSrvcsInsuranceObject()
    *
    * Desc: Returns 'Srvcs INSURANCE' Object.
    * Note:
    *
    */
    getBookingSrvcsInsuranceObject: function getBookingSrvcsInsuranceObject(state) {

        return state.bookingSrvcsInsuranceObject;
    }, // eof getBookingSrvcsInsuranceObject()


    /***************************************************************************
    * getBookingSrvcsMealExists()
    *
    * Desc: Return 'Srvcs MEAL exists?'.
    * Note:
    *
    */
    getBookingSrvcsMealExists: function getBookingSrvcsMealExists(state) {

        return state.bookingSrvcsMealExists;
    }, // eof getBookingSrvcsMealExists()


    /***************************************************************************
    * getBookingSrvcsServiceExists()
    *
    * Desc: Return 'Srvcs SERVICE exists?'.
    * Note:
    *
    */
    getBookingSrvcsServiceExists: function getBookingSrvcsServiceExists(state) {

        return state.bookingSrvcsServiceExists;
    }, // eof getBookingSrvcsServiceExists()


    /***************************************************************************
    * getBookingSrvcsPetsExists()
    *
    * Desc: Return 'Srvcs PETS exists?'.
    * Note:
    *
    */
    getBookingSrvcsPetsExists: function getBookingSrvcsPetsExists(state) {

        return state.bookingSrvcsPetsExists;
    }, // eof getBookingSrvcsPetsExists()


    /***************************************************************************
    * getBookingSrvcsSportbagExists()
    *
    * Desc: Return 'Srvcs SPORTBAG exists?'.
    * Note:
    *
    */
    getBookingSrvcsSportbagExists: function getBookingSrvcsSportbagExists(state) {

        return state.bookingSrvcsSportbagExists;
    }, // eof getBookingSrvcsSportbagExists()


    /***************************************************************************
    * getBookingSrvcsBaggageExists()
    *
    * Desc: Return 'Srvcs BAGGAGE exists?'.
    * Note:
    *
    */
    getBookingSrvcsBaggageExists: function getBookingSrvcsBaggageExists(state) {

        return state.bookingSrvcsBaggageExists;
    }, // eof getBookingSrvcsBaggageExists()


    /***************************************************************************
    * getBookingSrvcsMedicalExists()
    *
    * Desc: Return 'Srvcs MEDICAL exists?'.
    * Note:
    *
    */
    getBookingSrvcsMedicalExists: function getBookingSrvcsMedicalExists(state) {

        return state.bookingSrvcsMedicalExists;
    }, // eof getBookingSrvcsMedicalExists()


    /***************************************************************************
    * getBookingDoesAnySrvcsExistAtAll()
    *
    * Desc: Return 'we have any srvcs on flight?  With Seats included!'
    * Note:
    *
    */
    getBookingDoesAnySrvcsExistAtAll: function getBookingDoesAnySrvcsExistAtAll(state) {

        var srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;

        if (state.bookingLockfaresResults.outwardFlight.services.length === 0 && state.bookingLockfaresResults.outwardFlight.seatServices.length === 0) {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            if (state.bookingLockfaresResults.inboundFlight.services.length === 0 && state.bookingLockfaresResults.inboundFlight.seatServices.length === 0) {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }

        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }

        return doesAnySrvcsExistAtAll;
    }, // eof getBookingDoesAnySrvcsExistAtAll()


    /***************************************************************************
    * getBookingDoesAnySrvcsExistAtAllWOSeats()
    *
    * Desc: Return 'we have any srvcs on flight? Without Seats!'
    * Note:
    *
    */
    getBookingDoesAnySrvcsExistAtAllWOSeats: function getBookingDoesAnySrvcsExistAtAllWOSeats(state) {

        var srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;

        if (state.bookingLockfaresResults.outwardFlight.services.length === 0) {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.bookingLockfaresResults.inboundFlight !== null) {
            if (state.bookingLockfaresResults.inboundFlight.services.length === 0) {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }

        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }

        return doesAnySrvcsExistAtAll;
    }, // eof getBookingDoesAnySrvcsExistAtAllWOSeats()


    /***************************************************************************
    * getFlagBookingPassengersAreReadyForValidation()
    *
    * Desc: Return Flag: 'Passengers are ready to get validated'
    * Note:
    *
    */
    getFlagBookingPassengersAreReadyForValidation: function getFlagBookingPassengersAreReadyForValidation(state) {

        return state.flagBookingPassengersAreReadyForValidation;
    }, // eof getFlagBookingPassengersAreReadyForValidation()


    /***************************************************************************
    * Getters: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * getFlagBookingPaymentIsReadyForOverview()
    *
    * Desc: Return Flag: 'Payment is ready to Step:Overview'
    * Note:
    *
    */
    getFlagBookingPaymentIsReadyForOverview: function getFlagBookingPaymentIsReadyForOverview(state) {

        return state.flagBookingPaymentIsReadyForOverview;
    }, // eof getFlagBookingPaymentIsReadyForOverview()


    /***************************************************************************
    * getBookingValidatePassengersObject()
    *
    * Desc: Return 'Object we sent in validatePassenger Call'.
    * Note:
    *
    */
    getBookingValidatePassengersObject: function getBookingValidatePassengersObject(state) {

        return state.bookingValidatePassengersObject;
    }, // eof getBookingValidatePassengersObject()


    /***************************************************************************
    * Getters: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * getFlagBookingOverviewIsReadyForProcess()
    *
    * Desc: Return Flag: 'Overview is ready to Step:Confirmation'
    * Note:
    *
    */
    getFlagBookingOverviewIsReadyForProcess: function getFlagBookingOverviewIsReadyForProcess(state) {

        return state.flagBookingOverviewIsReadyForProcess;
    }, // eof getFlagBookingOverviewIsReadyForProcess()


    /***************************************************************************
    * getBookingProcessBookingObject()
    *
    * Desc: Return 'Object we sent in processBooking Call'.
    * Note:
    *
    */
    getBookingProcessBookingObject: function getBookingProcessBookingObject(state) {

        return state.bookingProcessBookingObject;
    }, // eof getBookingProcessBookingObject()


    /***************************************************************************
    * getBookingProcessBookingResults()
    *
    * Desc: Return Results of ProcessBooking (Calls Response).
    * Note:
    *
    */
    getBookingProcessBookingResults: function getBookingProcessBookingResults(state) {

        return state.bookingProcessBookingResults;
    }, // eof getBookingProcessBookingResults()


    /***************************************************************************
    * Getters: 'Seats'
    ***************************************************************************/
    /*************************************************************************** 'Seats'
    * getBookingSeatReservationLockingCodeResults()
    *
    * Desc: Return Results of Seats LockingCodes Calls (both).
    * Note:
    *
    */
    getBookingSeatReservationLockingCodeResults: function getBookingSeatReservationLockingCodeResults(state) {

        return state.bookingSeatReservationLockingCodeResults;
    }, // eof getBookingSeatReservationLockingCodeResults()


    /*************************************************************************** 'Seats'
    * getBookingSeatPlanOutwardResults()
    *
    * Desc: Return Results Seatmap Data Outward.
    * Note:
    *
    */
    getBookingSeatPlanOutwardResults: function getBookingSeatPlanOutwardResults(state) {

        return state.bookingSeatPlanOutwardResults;
    }, // eof getBookingSeatPlanOutwardResults()


    /*************************************************************************** 'Seats'
    * getBookingSeatPlanReturnResults()
    *
    * Desc: Return Results Seatmap Data Return.
    * Note:
    *
    */
    getBookingSeatPlanReturnResults: function getBookingSeatPlanReturnResults(state) {

        return state.bookingSeatPlanReturnResults;
    }, // eof getBookingSeatPlanReturnResults()


    /*************************************************************************** 'Seats'
    * getBookingSeatPrice()
    *
    * Desc: Get Price of Seat(type).
    * Note: Getter with Payload!
    * Note: Payload e.g.: {seatCode: seatCode, type: type }
    *
    */
    getBookingSeatPrice: function getBookingSeatPrice(state) {
        return function (payload) {

            var seatPrice = 0;

            // >>> Searching/Adding  ----------------
            if (payload.type === 'outward') {
                state.bookingSeatPlanOutwardResults.getSeatPlanResponse.seatTypes.forEach(function (item, i) {
                    if (item.code === payload.seatCode) {
                        seatPrice = item.price;
                    }
                });
            }

            if (payload.type === 'return') {
                state.bookingSeatPlanReturnResults.getSeatPlanResponse.seatTypes.forEach(function (item, i) {
                    if (item.code === payload.seatCode) {
                        seatPrice = item.price;
                    }
                });
            }

            return seatPrice;
        };
    }, // eof getBookingSeatPrice()


    /*************************************************************************** 'Seats'
    * getBookingSeatFreeColor()
    *
    * Desc: Get SeatColor Free of Seat(type).
    * Note: Getter with Payload!
    * Note: Payload e.g.: {seatCode: seatCode, type: type }
    */
    getBookingSeatFreeColor: function getBookingSeatFreeColor(state) {
        return function (payload) {

            var seatFreeColor = '';

            // >>> Searching ------------------------
            if (payload.type === 'outward') {
                state.bookingSeatPlanOutwardResults.getSeatPlanResponse.seatTypes.forEach(function (item, i) {
                    if (item.code === payload.seatCode) {
                        seatFreeColor = item.colorFree;
                    }
                });
            }

            if (payload.type === 'return') {
                state.bookingSeatPlanReturnResults.getSeatPlanResponse.seatTypes.forEach(function (item, i) {
                    if (item.code === payload.seatCode) {
                        seatFreeColor = item.colorFree;
                    }
                });
            }

            return seatFreeColor;
        };
    }, // eof getBookingSeatFreeColor()


    /*************************************************************************** 'Seats'
    * getBookingSeatRemark()
    *
    * Desc: Get 'Remark' of Seat(type). (must be confirmed when booking)
    * Note: Getter with Payload!
    * Note: Payload e.g.: {seatCode: seatCode, type: type }
    *
    */
    getBookingSeatRemark: function getBookingSeatRemark(state) {
        return function (payload) {

            var seatsRemark = '';

            // >>> Searching ------------------------
            if (payload.type === 'outward') {
                state.bookingSeatPlanOutwardResults.getSeatPlanResponse.seatTypes.forEach(function (item, i) {
                    if (item.code === payload.seatCode) {
                        seatsRemark = item.remark !== undefined ? item.remark : '';
                    }
                });
            }

            if (payload.type === 'return') {
                state.bookingSeatPlanReturnResults.getSeatPlanResponse.seatTypes.forEach(function (item, i) {
                    if (item.code === payload.seatCode) {
                        seatsRemark = item.remark !== undefined ? item.remark : '';
                    }
                });
            }

            return seatsRemark;
        };
    }, // eof getBookingSeatFreeColor()


    /***************************************************************************
    * Getters: Cart
    ***************************************************************************/
    /***************************************************************************
    * getBookingCart()
    *
    * Desc: Return Cart.
    * Note:
    *
    */
    getBookingCart: function getBookingCart(state) {

        return state.bookingCart;
    }, // eof getBookingCart()


    /***************************************************************************
    * getBookingCartOutwardTotal()
    *
    * Desc: Return Summed up Outward ALL.
    * Note:
    *
    */
    getBookingCartOutwardTotal: function getBookingCartOutwardTotal(state) {

        return state.bookingCartOutwardTotal;
    }, // eof getBookingCartOutwardTotal()


    /***************************************************************************
    * getBookingCartReturnTotal()
    *
    * Desc: Summed up Return ALL
    * Note:
    *
    */
    getBookingCartReturnTotal: function getBookingCartReturnTotal(state) {

        return state.bookingCartReturnTotal;
    }, // eof getBookingCartReturnTotal()


    /***************************************************************************
    * getBookingCartCountServices()
    *
    * Desc: Check if we have Service in Cart?
    * Note:
    *
    */
    getBookingCartCountServices: function getBookingCartCountServices(state) {

        var cartCountServices = 0;

        // >>> Searching 'Cart' -----------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) {
                // Count SRVCS
                cartCountServices = cartCountServices + 1;
            }

            for (var x = 0; x < state.bookingCart[i].return_srvcs.length; x++) {
                cartCountServices = cartCountServices + 1;
            }

            if (state.bookingCart[i].outward_seat.seatno !== undefined) {
                // Count SEATS
                cartCountServices = cartCountServices + 1;
            }

            if (state.bookingCart[i].return_seat.seatno !== undefined) {
                cartCountServices = cartCountServices + 1;
            }
        }

        return cartCountServices;
    }, // eof getBookingCartCountServices()


    /***************************************************************************
    * getBookingCartIsSrvcAlreadyInCart()
    *
    * Desc: Check if Srvcs already exist in Cart?
    * Note: Getter with Payload!
    *
    */
    getBookingCartIsSrvcAlreadyInCart: function getBookingCartIsSrvcAlreadyInCart(state) {
        return function (payload) {

            var alreadyInCart = false;

            // >>> Searching 'Cart' -----------------
            for (var i = 0; i < state.bookingCart.length; i++) {
                if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    // >>> Srvcs already in Out?
                    for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) {
                        if (state.bookingCart[i].outward_srvcs[x].code === payload.srvcs.code) {
                            alreadyInCart = true;
                        }
                    }

                    // >>> Or Srvcs already in Ret?
                    if (alreadyInCart === false) {
                        for (var x = 0; x < state.bookingCart[i].return_srvcs.length; x++) {
                            if (state.bookingCart[i].return_srvcs[x].code === payload.srvcs.code) {
                                alreadyInCart = true;
                            }
                        }
                    }
                }
            }

            return alreadyInCart;
        };
    }, // eof getBookingCartIsSrvcAlreadyInCart()


    /*************************************************************************** 'Cart - Seats'
    * getBookingCartIsSeatAlreadyReserved()
    *
    * Desc: Check if Seat is already reserved in Cart?
    * Note: Getter with Payload!
    * Note: Returns entire Pax or empty ....
    *
    */
    getBookingCartIsSeatAlreadyReserved: function getBookingCartIsSeatAlreadyReserved(state) {
        return function (payload) {

            var alreadyReservedBy = '';

            // >>> Searching 'Cart' -----------------
            for (var i = 0; i < state.bookingCart.length; i++) {
                if (payload.type === 'outward') {
                    if (state.bookingCart[i].outward_seat.seatno === payload.seatName) {
                        alreadyReservedBy = state.bookingCart[i]; // returns entire pax
                    }
                }

                if (payload.type === 'return') {
                    if (state.bookingCart[i].return_seat.seatno === payload.seatName) {
                        alreadyReservedBy = state.bookingCart[i]; // returns entire pax
                    }
                }
            }

            return alreadyReservedBy;
        };
    }, // eof getBookingCartIsSeatAlreadyReserved()


    /***************************************************************************
    * getBookingCartHasPaxAlreadyReservedASeat()
    *
    * Desc: Check if Seat is already reserved in Cart?
    * Note: Getter with Payload!
    * Note: Returns entire Pax or empty ....
    *
    */
    getBookingCartHasPaxAlreadyReservedASeat: function getBookingCartHasPaxAlreadyReservedASeat(state) {
        return function (payload) {

            var paxHasAlreadyReserved = '';

            // >>> Searching 'Cart' -----------------
            for (var i = 0; i < state.bookingCart.length; i++) {
                if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    if (payload.type === 'outward') {
                        if (state.bookingCart[i].outward_seat.seatno !== undefined) {
                            paxHasAlreadyReserved = state.bookingCart[i].outward_seat.seatno; // returns seatno
                        }
                    }

                    if (payload.type === 'return') {
                        if (state.bookingCart[i].return_seat.seatno !== undefined) {
                            paxHasAlreadyReserved = state.bookingCart[i].return_seat.seatno; // returns seatno
                        }
                    }

                    if (payload.type === 'both') {
                        if (state.bookingCart[i].outward_seat.seatno !== undefined) {
                            paxHasAlreadyReserved = state.bookingCart[i].outward_seat.seatno; // returns seatno
                        }
                        if (paxHasAlreadyReserved === '') {
                            if (state.bookingCart[i].return_seat.seatno !== undefined) {
                                paxHasAlreadyReserved = state.bookingCart[i].return_seat.seatno; // returns seatno
                            }
                        }
                    }
                }
            }

            return paxHasAlreadyReserved;
        };
    }, // eof getBookingCartHasPaxAlreadyReservedASeat()


    /***************************************************************************
    * getBookingCartHasPaxAlreadyReservedAnInsurance()
    *
    * Desc:
    * Note:
    */
    getBookingCartHasPaxAlreadyReservedAnInsurance: function getBookingCartHasPaxAlreadyReservedAnInsurance(state) {
        return function (payload) {

            var paxHasAlreadyReserved = false;

            console.log('getBookingCartHasPaxAlreadyReservedAnInsurance');
            // >>> Searching 'Cart' -----------------
            for (var i = 0; i < state.bookingCart.length; i++) {
                if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    if (payload.type === 'outward') {
                        console.log(state.bookingCart[i]);
                        for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) {
                            if (state.bookingCart[i].outward_srvcs[x].code === 'FLEX OPTION') {
                                paxHasAlreadyReserved = true;
                            }
                        }
                    }
                }
            }

            console.log('paxHasAlreadyReserved');
            console.log(paxHasAlreadyReserved);
            return paxHasAlreadyReserved;
        };
    }, // eof getBookingCartHasPaxAlreadyReservedAnInsurance()


    /***************************************************************************
    * getBookingCartSeatsCellId()
    *
    * Desc: Return 'comment' prop from seat in demand?
    * Note: Getter with Payload!
    * Note: Returns 'comment' (cellid).
    *
    */
    getBookingCartSeatsCellId: function getBookingCartSeatsCellId(state) {
        return function (payload) {

            var cellId = '';

            // >>> Searching 'Cart' -----------------
            for (var i = 0; i < state.bookingCart.length; i++) {
                if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    if (payload.type === 'outward') {
                        if (state.bookingCart[i].outward_seat.comment !== undefined) {
                            cellId = state.bookingCart[i].outward_seat.comment; // returns comment (cellId)
                        }
                    }

                    if (payload.type === 'return') {
                        if (state.bookingCart[i].return_seat.comment !== undefined) {
                            cellId = state.bookingCart[i].return_seat.comment; // returns comment (cellId)
                        }
                    }
                }
            }

            return cellId;
        };
    }, // eof getBookingCartSeatsCellId()


    /***************************************************************************
    * Getters: Get Offers, KeyDestinations
    ***************************************************************************/
    /***************************************************************************
    * getOffers()
    *
    * Desc:
    * Note:
    *
    */
    getOffers: function getOffers(state) {

        return state.bookingOffers;
    }, // eof getOffers()


    /***************************************************************************
    * getBookingDeparturesKeyDes()
    *
    * Desc:
    * Note:
    *
    */
    getBookingDeparturesKeyDes: function getBookingDeparturesKeyDes(state) {

        if (state.bookingDeparturesKeyDes.destinationsRS !== undefined) {
            return state.bookingDeparturesKeyDes.destinationsRS.des;
        } else {
            return state.bookingDeparturesKeyDes;
        }
    }, // eof getBookingDeparturesKeyDes()


    /***************************************************************************
    * getListOfPaxes()
    *
    * Desc:
    * Note: No State Var here!!!
    *
    */
    getListOfPaxes: function getListOfPaxes(state) {

        var listOfPaxes = [{ "k": 0, "v": "0" }, { "k": 1, "v": "1" }, { "k": 2, "v": "2" }, { "k": 3, "v": "3" }, { "k": 4, "v": "4" }, { "k": 5, "v": "5" }, { "k": 6, "v": "6" }, { "k": 7, "v": "7" }, { "k": 8, "v": "8" }];

        return listOfPaxes;
    }, // eof getListOfPaxes()


    /***************************************************************************
    * getOffersSelectedDestination()
    *
    * Desc: Return 'Users selected KeyDeastination'
    * Note:
    *
    */
    getOffersSelectedDestination: function getOffersSelectedDestination(state) {

        return state.bookingOffersSelectedDestination;
    }, // eof getOffers()


    /***************************************************************************
    * getBookingOffersListFlightsMonthlyOffers()
    *
    * Desc: Returns ...
    * Note: Fill up Array here .. Push '0' at the end too.
    * Note: // 7th '0' is for right rendering. (starting always with '0').
    *
    */
    getBookingOffersListFlightsMonthlyOffers: function getBookingOffersListFlightsMonthlyOffers(state) {

        var monthToSearchFor = __WEBPACK_IMPORTED_MODULE_3_moment___default()().month(),
            prices = [0, 0, 0, 0, 0, 0];

        for (var a = 0; a < prices.length; a++) {
            state.bookingOffersListFlightsMonthlyOffers.forEach(function (flight, i) {
                if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(flight.depDT).month() === monthToSearchFor) {
                    prices[a] = parseFloat(flight.prcs[0].amnt) + parseFloat(flight.prcs[0].tax.tot);;
                }
            });
            if (monthToSearchFor === 11) {
                // End of Year? => Start with 0
                monthToSearchFor = 0;
            } else {
                monthToSearchFor = monthToSearchFor + 1;
            }
        }

        prices.push(0); // 7th is for right rendering


        return prices;
    }, // eof getBookingOffersListFlightsMonthlyOffers()


    /***************************************************************************
    * getBookingOffersFlightIdViaMonth()
    *
    * Desc: Returns .. Flight via given Month.
    * Note:
    *
    */
    getBookingOffersFlightIdViaMonth: function getBookingOffersFlightIdViaMonth(state, getters) {
        return function (payload) {

            var currentLocale = getters.getCurrentLocale,
                flightMonthIndex = null,
                foundMonthIndex = null,
                months_en = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                months_de = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

            if (currentLocale === 'en') {
                foundMonthIndex = months_en.indexOf(payload);
            } else {
                foundMonthIndex = months_de.indexOf(payload);
            }

            // >>> -----------------------------------------------------------------
            state.bookingOffersListFlightsMonthlyOffers.forEach(function (flight, i) {
                flightMonthIndex = Number(__WEBPACK_IMPORTED_MODULE_3_moment___default()(flight.depDT).month());
                if (flightMonthIndex === foundMonthIndex) {
                    state.bookingOffersChoosenFlightByUser = flight;
                }
            });
        };
    }, // eof getBookingOffersFlightIdViaMonth()


    /***************************************************************************
    * getBookingOffersChoosenFlightByUser()
    *
    * Desc: Returns .. Flight choosen by User.
    * Note:
    *
    */
    getBookingOffersChoosenFlightByUser: function getBookingOffersChoosenFlightByUser(state) {

        return state.bookingOffersChoosenFlightByUser;
    }, // eof getBookingOffersChoosenFlightByUser()


    /***************************************************************************
    * getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel()
    *
    * Desc:
    * Note:
    *
    */
    getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel: function getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel(state) {

        return state.flagSharedShowFlightSearchResultsAndBestPriceCaroussel;
    }, // eof getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel()


    /***************************************************************************
    * getBookingWireCardEnrollPaymentResults()
    *
    * Desc:
    * Note:
    *
    */
    getBookingWireCardEnrollPaymentResults: function getBookingWireCardEnrollPaymentResults(state) {

        return state.bookingWireCardEnrollPaymentResults;
    } // eof getBookingWireCardEnrollPaymentResults()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: State Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_set_stateResetBooking()
    *
    * Desc: Reset State In Context:Booking.
    * Note:
    * TODO: Reset more.
    *
    */
    mut_set_stateResetBooking: function mut_set_stateResetBooking(context, payload) {

        state.bookingUsersSearchData = { // Users Search Data
            depAfter: '',
            depArprtCode: '',
            desArprtCode: '',
            limit: '',
            noADT: '',
            noCHD: '',
            noINF: '',
            ojArprtCode: '',
            ojType: '',
            rTrip: '',
            retAfter: ''
        };

        state.bookingCart = []; // Cart

        state.flagBookingOutwardFlightSelected = false; // CONTROL FLAG - Selected 'Outward Flight'
        state.flagBookingReturnFlightSelected = false; // CONTROL FLAG - Selected 'Return Flight'
    }, // eof mut_set_stateResetBooking()


    /***************************************************************************
    * Mutations: Current Locale
    ***************************************************************************/
    /***************************************************************************
    * mut_setCurrentLocale()
    *
    * Desc: SET State/Flag
    * Note:
    *
    */
    mut_setCurrentLocale: function mut_setCurrentLocale(state, payload) {

        state.currentLocale = payload;
    }, // eof mut_setCurrentLocale()


    /***************************************************************************
    * Mutations: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagSharedShowFlightSearchResults()
    *
    * Desc: SET State/Flag 'Show Flight Search Results Section'
    * Note: CONTROL FLAG
    *
    */
    mut_FlagSharedShowFlightSearchResults: function mut_FlagSharedShowFlightSearchResults(state, payload) {

        state.flagSharedShowFlightSearchResults = payload;
    }, // eof mut_FlagSharedShowFlightSearchResults()


    /***************************************************************************
    * Mutations: Users Search
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingAirports()
    *
    * Desc: SET States Search Airports (Part 1)
    * Note: ATTENTION: USE 'bookingDepArprtCode' for OUTWARD on 'return to other'
    *
    */
    mut_setBookingAirports: function mut_setBookingAirports(state, payload) {

        state.bookingDepArprtCode = payload.depArprtCode;
        state.bookingDepArprtName = payload.depArprtName;
        state.bookingDesArprtCode = payload.desArprtCode;
        state.bookingDesArprtName = payload.desArprtName;
        // >>> 'Return to other'
        state.bookingDepArprtCode_ReturnToOther = payload.depArprtCode_returntoother ? payload.depArprtCode_returntoother : payload.depArprtCode;
        state.bookingDepArprtName_ReturnToOther = payload.depArprtName_returntoother ? payload.depArprtName_returntoother : payload.depArprtName;
        state.bookingDesArprtCode_ReturnToOther = payload.desArprtCode_returntoother ? payload.desArprtCode_returntoother : payload.desArprtCode;
        state.bookingDesArprtName_ReturnToOther = payload.desArprtName_returntoother ? payload.desArprtName_returntoother : payload.desArprtName;
    }, // eof mut_setBookingAirports()


    /***************************************************************************
    * mut_setBookingUsersSearchData()
    *
    * Desc: ACTION 'SET Users Search Data' (Part 2)
    * Note:
    *
    */
    mut_setBookingUsersSearchData: function mut_setBookingUsersSearchData(state, payload) {

        state.bookingUsersSearchData = {
            depAfter: payload.depAfter,
            depArprtCode: payload.depArprtCode,
            desArprtCode: payload.desArprtCode,
            limit: payload.limit,
            noADT: payload.noADT,
            noCHD: payload.noCHD,
            noINF: payload.noINF,
            ojArprtCode: payload.ojArprtCode,
            ojType: payload.ojType,
            rTrip: payload.rTrip,
            retAfter: payload.retAfter
        };
    }, // eof mut_setBookingUsersSearchData()


    /***************************************************************************
    * Mutations: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingFlightSearchResults()
    *
    * Desc: SET State 'Search Results' Object
    * Note:
    *
    */
    mut_setBookingFlightSearchResults: function mut_setBookingFlightSearchResults(state, payload) {

        state.bookingFlightSearchResults = payload;
    }, // eof mut_setBookingFlightSearchResults()


    /***************************************************************************
    * mut_FlagBookingOutwardFlightSelected()
    *
    * Desc: SET State 'Outward Flight selected' Object.
    * Note:
    *
    */
    mut_FlagBookingOutwardFlightSelected: function mut_FlagBookingOutwardFlightSelected(state, payload) {

        state.flagBookingOutwardFlightSelected = payload;
    }, // eof mut_FlagBookingOutwardFlightSelected()


    /***************************************************************************
    * mut_FlagBookingReturnFlightSelected()
    *
    * Desc: SET State 'Return Flight selected' Object.
    * Note:
    *
    */
    mut_FlagBookingReturnFlightSelected: function mut_FlagBookingReturnFlightSelected(state, payload) {

        state.flagBookingReturnFlightSelected = payload;
    }, // eof mut_FlagBookingReturnFlightSelected()


    /***************************************************************************
    * mut_setBookingFlightIdSelectedOutward()
    *
    * Desc: SET State 'Outward Flight Id'.
    * Note:
    *
    */
    mut_setBookingFlightIdSelectedOutward: function mut_setBookingFlightIdSelectedOutward(state, payload) {

        state.bookingFlightIdSelectedOutward = payload;
    }, // eof mut_setBookingFlightIdSelectedOutward()


    /***************************************************************************
    * mut_setBookingFlightIdSelectedReturn()
    *
    * Desc: SET State 'Return Flight Id'.
    * Note:
    *
    */
    mut_setBookingFlightIdSelectedReturn: function mut_setBookingFlightIdSelectedReturn(state, payload) {

        state.bookingFlightIdSelectedReturn = payload;
    }, // eof mut_setBookingFlightIdSelectedReturn()


    /***************************************************************************
    * Mutations: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingLockfaresResults()
    *
    * Desc: SET State 'Lockfares' Object/Results.
    * Note: SET States if singe Srvcs Cats (exits at all?),
    *
    */
    mut_setBookingLockfaresResults: function mut_setBookingLockfaresResults(state, payload) {

        // >>> Save calls response --------------
        state.bookingLockfaresResults = payload;

        // >>> State of Srvcs -------------------
        if (payload.inboundFlight !== null) {

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'meal';
            }) !== undefined || payload.inboundFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'meal';
            }) !== undefined) {
                state.bookingSrvcsMealExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'service';
            }) !== undefined || payload.inboundFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'service';
            }) !== undefined) {
                state.bookingSrvcsServiceExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'pets';
            }) !== undefined || payload.inboundFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'pets';
            }) !== undefined) {
                state.bookingSrvcsPetsExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'sportbag';
            }) !== undefined || payload.inboundFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'pets';
            }) !== undefined) {
                state.bookingSrvcsSportbagExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'baggage';
            }) !== undefined || payload.inboundFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'baggage';
            }) !== undefined) {
                state.bookingSrvcsBaggageExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'medical';
            }) !== undefined || payload.inboundFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'medical';
            }) !== undefined) {
                state.bookingSrvcsMedicalExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'insurance';
            }) !== undefined) {
                state.bookingSrvcsInsuranceExists = true;
                state.bookingSrvcsInsuranceObject = payload.outwardFlight.services.find(function (srvcs) {
                    return srvcs.categoryCode === 'insurance';
                });
            }
        } else {

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'meal';
            }) !== undefined) {
                state.bookingSrvcsMealExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'service';
            }) !== undefined) {
                state.bookingSrvcsServiceExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'pets';
            }) !== undefined) {
                state.bookingSrvcsPetsExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'sportbag';
            }) !== undefined) {
                state.bookingSrvcsSportbagExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'baggage';
            }) !== undefined) {
                state.bookingSrvcsBaggageExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'medical';
            }) !== undefined) {
                state.bookingSrvcsMedicalExists = true;
            }

            if (payload.outwardFlight.services.find(function (srvcs) {
                return srvcs.categoryCode === 'insurance';
            }) !== undefined) {
                state.bookingSrvcsInsuranceExists = true;
                state.bookingSrvcsInsuranceObject = payload.outwardFlight.services.find(function (srvcs) {
                    return srvcs.categoryCode === 'insurance';
                });
            }
        }
    }, // eof mut_setBookingLockfaresResults()


    /***************************************************************************
    * mut_setBookingSrvcsSeatExistOnOut()
    *
    * Desc: SET State 'Srvcs Seat exits on OUT' Boolean.
    * Note:
    *
    */
    mut_setBookingSrvcsSeatExistOnOut: function mut_setBookingSrvcsSeatExistOnOut(state, payload) {

        state.bookingSrvcsSeatExistOnOut = payload;
    }, // eof mut_setBookingSrvcsSeatExistOnOut()


    /***************************************************************************
    * mut_setBookingSrvcsSeatExistOnRet()
    *
    * Desc: SET State 'Srvcs Seat exits on OUT' Boolean.
    * Note:
    *
    */
    mut_setBookingSrvcsSeatExistOnRet: function mut_setBookingSrvcsSeatExistOnRet(state, payload) {

        state.bookingSrvcsSeatExistOnRet = payload;
    }, // eof mut_setBookingSrvcsSeatExistOnRet()


    /***************************************************************************
    * mut_setBookingValidatePassengersObject()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger).
    * Note: Saves the Params itself.
    *
    */
    mut_setBookingValidatePassengersObject: function mut_setBookingValidatePassengersObject(state, payload) {

        state.bookingValidatePassengersObject = payload;
    }, // eof mut_setBookingValidatePassengersObject()


    /***************************************************************************
    * Mutations: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagBookingPaymentIsReadyForOverview()
    *
    * Desc: SET State 'Payment is ready for Overview?' Boolean.
    * Note:
    *
    */
    mut_FlagBookingPaymentIsReadyForOverview: function mut_FlagBookingPaymentIsReadyForOverview(state, payload) {

        state.flagBookingPaymentIsReadyForOverview = payload;
    }, // eof mut_FlagBookingPaymentIsReadyForOverview()


    /***************************************************************************
    * mut_setBookingProcessBookingObject()
    *
    * Desc: SET State 'Calls Object to send' (processBooking).
    * Note: Saves the Params itself.
    *
    */
    mut_setBookingProcessBookingObject: function mut_setBookingProcessBookingObject(state, payload) {

        state.bookingProcessBookingObject = payload;
    }, // eof mut_setBookingProcessBookingObject()


    /***************************************************************************
    * Mutations: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagBookingOverviewIsReadyForProcess()
    *
    * Desc: SET State 'Overview is ready for Proicess?' Boolean.
    * Note:
    *
    */
    mut_FlagBookingOverviewIsReadyForProcess: function mut_FlagBookingOverviewIsReadyForProcess(state, payload) {

        state.flagBookingOverviewIsReadyForProcess = payload;
    }, // eof mut_FlagBookingOverviewIsReadyForProcess()


    /***************************************************************************
    * mut_setBookingProcessBookingResults()
    *
    * Desc: SET State 'processBooking' Object/Results.
    * Note:
    *
    */
    mut_setBookingProcessBookingResults: function mut_setBookingProcessBookingResults(state, payload) {

        // >>> Save calls response --------------
        state.bookingProcessBookingResults = payload;
    }, // eof mut_setBookingProcessBookingResults()


    /***************************************************************************
    * Mutations: Seats
    ***************************************************************************/
    /*************************************************************************** 'Seats'
    * mut_setBookingSeatReservationLockingCodeResults()
    *
    * Desc: SET State 'Seats Lockingcodes' (/seatplan/lock/).
    * Note: Saves the Codes/Params/Response itself.
    *
    */
    mut_setBookingSeatReservationLockingCodeResults: function mut_setBookingSeatReservationLockingCodeResults(state, payload) {

        if (payload.type === 'out') {
            state.bookingSeatReservationLockingCodeResults.outward = payload;
        }
        if (payload.type === 'ret') {
            state.bookingSeatReservationLockingCodeResults.return = payload;
        }
    }, // eof mut_setBookingSeatReservationLockingCodeResults()


    /*************************************************************************** 'Seats'
    * mut_setBookingSeatReservationLockingCodeResults()
    *
    * Desc: SET State 'Seatplan' (/seatplan/).
    * Note: Saves the Codes/Params/Response itself.
    *
    */
    mut_setBookingSeatplanResults: function mut_setBookingSeatplanResults(state, payload) {

        if (payload.type === 'out') {
            state.bookingSeatPlanOutwardResults = payload.response;
        }
        if (payload.type === 'ret') {
            state.bookingSeatPlanReturnResults = payload.response;
        }
    }, // eof mut_setBookingSeatplanResults()


    /***************************************************************************
    * Mutations: Cart / Prefill / Update
    ***************************************************************************/
    /***************************************************************************
    * mut_setBookingPrefillCart()
    *
    * Desc: PreFill Cart (Skeleton-Object),
    * Note: Attention: To stay reactive the 'state.bookingCart' needs
    * to have all its Parts already at the Beginning.
    *
    */
    mut_setBookingPrefillCart: function mut_setBookingPrefillCart(state, payload) {

        var pax = {},
            counter = 1;

        // >>> PreFill Cart --------------------
        state.bookingCart = []; // reset
        state.bookingCartOutwardTotal = 0;
        state.bookingCartReturnTotal = 0;

        for (var i = 0; i < payload.noADT; i++) {
            pax = {
                id: 'adt' + i,
                id_pax: counter,
                counter: i + 1,
                type: 'ADT',
                typeWritten: 'Adult',
                outward: {}, // Flight
                outward_srvcs: [],
                outward_seat: {},
                return: {}, // Flight
                return_srvcs: [],
                return_seat: {},
                paxCredentials: {}
            };
            state.bookingCart.push(pax);
            counter = counter + 1;
        }

        for (var i = 0; i < payload.noCHD; i++) {
            pax = {
                id: 'chd' + i,
                id_pax: counter,
                counter: i + 1,
                type: 'CHD',
                typeWritten: 'Child',
                outward: {}, // Flight
                outward_srvcs: [],
                outward_seat: {},
                return: {}, // Flight
                return_srvcs: [],
                return_seat: {},
                paxCredentials: {}
            };
            state.bookingCart.push(pax);
            counter = counter + 1;
        }

        for (var i = 0; i < payload.noINF; i++) {
            pax = {
                id: 'inf' + i,
                id_pax: counter,
                counter: i + 1,
                type: 'INF',
                typeWritten: 'Infant',
                outward: {}, // Flight
                outward_srvcs: [],
                outward_seat: {},
                return: {}, // Flight
                return_srvcs: [],
                return_seat: {},
                paxCredentials: {}
            };
            state.bookingCart.push(pax);
            counter = counter + 1;
        }
    }, // eof mut_setBookingPrefillCart()


    /***************************************************************************
    * mut_setBookingUpdateCart()
    *
    * Desc: Update Cart/Totals. (on 'Select Flight')
    * Note: New: Sundair, Inf wo. Tax
    * Note: Watches 'modulo'!
    *
    */
    mut_setBookingUpdateCart: function mut_setBookingUpdateCart(state, payload) {

        var price = 0,
            totalprice = 0,
            totalpriceoutward = 0,
            totalpricereturn = 0;

        // >>> Update 'Cart' --------------------------------------------------
        for (var i = 0; i < state.bookingCart.length; i++) {

            // >>> ------------------------------ 'booking
            if (payload.modulo === 'booking') {

                if (state.bookingCart[i].type === 'INF') {
                    price = payload.flight.prcs[0].amntInf;
                    totalprice = parseFloat(payload.flight.prcs[0].amntInf);
                } else if (state.bookingCart[i].type === 'CHD') {
                    price = payload.flight.prcs[0].amntRedcd;
                    totalprice = parseFloat(payload.flight.prcs[0].amntRedcd) + parseFloat(payload.flight.prcs[0].tax.tot);
                } else {
                    price = payload.flight.prcs[0].amnt;
                    totalprice = parseFloat(payload.flight.prcs[0].amnt) + parseFloat(payload.flight.prcs[0].tax.tot);
                }

                // >>> Outward Object -----------
                if (payload.type === 'outward') {
                    state.bookingCart[i].outward = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: payload.flight.prcs[0].tax // taxes only
                    };
                    totalpriceoutward = parseFloat(totalpriceoutward) + parseFloat(totalprice);
                }
                // >>> Return Object ------------
                if (payload.type === 'return') {
                    state.bookingCart[i].return = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: payload.flight.prcs[0].tax // taxes only
                    };
                    totalpricereturn = parseFloat(totalpricereturn) + parseFloat(totalprice);
                }
            }

            // >>> ------------------------------ 'services'
            if (payload.modulo === 'services') {

                if (state.bookingCart[i].type === 'INF') {
                    price = 0; // useful?
                    totalprice = 0; // useful?
                } else if (state.bookingCart[i].type === 'CHD') {
                    price = 0; // useful?
                    totalprice = 0; // useful?
                } else {
                    price = 0; // useful?
                    totalprice = 0; // useful?
                }

                // >>> Outward Object -----------
                if (payload.type === 'outward') {
                    state.bookingCart[i].outward = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: 0 // taxes only // useful?
                    };
                    totalpriceoutward = parseFloat(totalpriceoutward) + parseFloat(totalprice);
                }
                // >>> Return Object ------------
                if (payload.type === 'return') {
                    state.bookingCart[i].return = {
                        depDT: payload.flight.depDT, // take off
                        desDT: payload.flight.desDT, // landing
                        dur: payload.flight.dur, // duration
                        price: price, // price (wo taxes)
                        totalprice: totalprice, // price (wo taxes)
                        taxes: 0 // taxes only // useful?
                    };
                    totalpricereturn = parseFloat(totalpricereturn) + parseFloat(totalprice);
                }
            }
        }
        // <<< Update 'Cart' --------------------------------------------------


        // >>> Update 'Totals' ------------------------------------------------
        // >>> ---------------------------------- 'booking'
        if (payload.modulo === 'booking') {

            if (payload.type === 'outward') {
                state.flagBookingOutwardFlightSelected = true;

                state.bookingCartOutwardTotal = totalpriceoutward;
                state.bookingFlightIdSelectedOutward = payload.flight.id;
                state.bookingPriceIdSelectedOutward = payload.flight.prcs[0].id;
            }
            if (payload.type === 'return') {
                state.flagBookingReturnFlightSelected = true;

                state.bookingCartReturnTotal = totalpricereturn;
                state.bookingFlightIdSelectedReturn = payload.flight.id;
                state.bookingPriceIdSelectedReturn = payload.flight.prcs[0].id;
            }
        }

        // >>> ---------------------------------- 'services'
        if (payload.modulo === 'services') {

            if (payload.type === 'outward') {
                state.flagBookingOutwardFlightSelected = true;

                state.bookingCartOutwardTotal = 0; // useful?
                state.bookingFlightIdSelectedOutward = payload.flight.id;
                state.bookingPriceIdSelectedOutward = null; // useful?
            }
            if (payload.type === 'return') {
                state.flagBookingReturnFlightSelected = true;

                state.bookingCartReturnTotal = 0; // useful?
                state.bookingFlightIdSelectedReturn = payload.flight.id;
                state.bookingPriceIdSelectedReturn = null; // useful?
            }
        }
        // <<< Update 'Totals' ------------------------------------------------
    }, // eof mut_setBookingUpdateCart()


    /***************************************************************************
    * mut_setBookingUpdateCartWithSrvcs()
    *
    * Desc: Update Cart/Totals. (on 'Select Srvcs')
    * Note: Add Srvcs, Update Out/Ret Totals.
    * Note: Add 'FLEX OPTION' only on oubound Flight.
    *
    */
    mut_setBookingUpdateCartWithSrvcs: function mut_setBookingUpdateCartWithSrvcs(state, payload) {

        var totalpriceoutward = 0,
            totalpricereturn = 0;

        // >>> Update 'Cart' --------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                // >>> Srvcs for Out? Add to Cart!
                if (payload.srvcs.userInputSrvcsDetails_ToggleOut === true) {
                    state.bookingCart[i].outward_srvcs.push({
                        code: payload.srvcs.code,
                        description: payload.srvcs.description,
                        id: payload.srvcs.id,
                        maxBookablePax: payload.srvcs.maxBookablePax,
                        price: payload.srvcs.price,
                        remark: payload.srvcs.remark,
                        srvc_exist_out: payload.srvcs.srvc_exist_out,
                        srvc_exist_ret: payload.srvcs.srvc_exist_ret,
                        userInputSrvcsDetails_Count: payload.srvcs.userInputSrvcsDetails_Count,
                        userInputSrvcsDetails_ToggleOut: payload.srvcs.userInputSrvcsDetails_ToggleOut,
                        userInputSrvcsDetails_ToggleRet: payload.srvcs.userInputSrvcsDetails_ToggleRet,
                        userInputSrvcsDetails_Comment: payload.srvcs.userInputSrvcsDetails_Comment
                    });
                    totalpriceoutward = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                    state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) + parseFloat(totalpriceoutward);
                }

                // >>> Srvcs for Ret? Add to Cart!
                if (payload.srvcs.userInputSrvcsDetails_ToggleRet === true) {
                    if (payload.srvcs.code !== 'FLEX OPTION') {
                        // See Note:
                        state.bookingCart[i].return_srvcs.push({
                            code: payload.srvcs.code,
                            description: payload.srvcs.description,
                            id: payload.srvcs.id,
                            maxBookablePax: payload.srvcs.maxBookablePax,
                            price: payload.srvcs.price,
                            remark: payload.srvcs.remark,
                            srvc_exist_out: payload.srvcs.srvc_exist_out,
                            srvc_exist_ret: payload.srvcs.srvc_exist_ret,
                            userInputSrvcsDetails_Count: payload.srvcs.userInputSrvcsDetails_Count,
                            userInputSrvcsDetails_ToggleOut: payload.srvcs.userInputSrvcsDetails_ToggleOut,
                            userInputSrvcsDetails_ToggleRet: payload.srvcs.userInputSrvcsDetails_ToggleRet,
                            userInputSrvcsDetails_Comment: payload.srvcs.userInputSrvcsDetails_Comment
                        });
                        totalpricereturn = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                        state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) + parseFloat(totalpricereturn);
                    }
                }
            }
        }
    }, // eof mut_setBookingUpdateCartWithSrvcs()


    /***************************************************************************
    * mut_setBookingUpdateCartWithSeat()
    *
    * Desc: Update Cart/Totals. (add  'Seat')
    * Note: Add Seat, Update Out/Ret Totals.
    *
    */
    mut_setBookingUpdateCartWithSeat: function mut_setBookingUpdateCartWithSeat(state, payload) {

        var totalpriceoutward = 0,
            totalpricereturn = 0;

        // >>> Update 'Cart' --------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                // >>> Seat for Out? Add to Cart!
                if (payload.type === 'outward') {
                    state.bookingCart[i].outward_seat = payload;
                    totalpriceoutward = parseFloat(payload.price);
                    state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) + parseFloat(totalpriceoutward);
                }

                // >>> Seat for Out? Add to Cart!
                if (payload.type === 'return') {
                    state.bookingCart[i].return_seat = payload;
                    totalpricereturn = parseFloat(payload.price);
                    state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) + parseFloat(totalpricereturn);
                }
            }
        }
    }, // eof mut_setBookingUpdateCartWithSeat()


    /***************************************************************************
    * mut_setBookingUpdateCartWithPaxCredentials()
    *
    * Desc: Update Cart with Pax Credentials.
    * Note: Add Firstname & Co.
    * Note: Built in 'onSubmit' for 'validatePassenger' Call.
    *
    */
    mut_setBookingUpdateCartWithPaxCredentials: function mut_setBookingUpdateCartWithPaxCredentials(state, payload) {

        // >>> Update 'Cart' --------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            for (var a = 0; a < payload.passengers.length; a++) {
                if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.passengers[a].id_pax, 10)) {
                    state.bookingCart[i].paxCredentials = {
                        birthdate: payload.passengers[a].birthdate,
                        firstName: payload.passengers[a].firstName,
                        gender: payload.passengers[a].gender,
                        lastName: payload.passengers[a].lastName,
                        middleName: payload.passengers[a].middleName,
                        salutation: payload.passengers[a].salutation
                    };
                }
            }
        }
    }, // eof mut_setBookingUpdateCartWithPaxCredentials()


    /***************************************************************************
    * mut_setBookingUpdateCartViaDeleteSrvcs()
    *
    * Desc: Update Cart/Totals. (on 'Delete Srvcs')
    * Note: Delete 'Srvcs'. Update Out/Ret Totals.
    * Note: payload::{ id_pax: pax.id_pax, srvcs: srvcs, type: 'return' }
    * Note: Manipulate State: bookingValidatePassengersObject here too!
    *
    */
    mut_setBookingUpdateCartViaDeleteSrvcs: function mut_setBookingUpdateCartViaDeleteSrvcs(state, payload) {

        var totalpriceoutward = 0,
            totalpricereturn = 0,
            bookingValidatePassengersObject_Clone = _extends({}, state.bookingValidatePassengersObject); // copy


        // >>> A: Update 'Cart' ---------------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                if (payload.type === 'outward') {
                    for (var x = 0; x < state.bookingCart[i].outward_srvcs.length; x++) {
                        if (state.bookingCart[i].outward_srvcs[x].id === payload.srvcs.id) {
                            state.bookingCart[i].outward_srvcs.splice(x, 1);
                            totalpriceoutward = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                            state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) - parseFloat(totalpriceoutward);
                        }
                    }
                }

                if (payload.type === 'return') {
                    for (var x = 0; x < state.bookingCart[i].return_srvcs.length; x++) {
                        if (state.bookingCart[i].return_srvcs[x].id === payload.srvcs.id) {
                            state.bookingCart[i].return_srvcs.splice(x, 1);
                            totalpricereturn = parseFloat(payload.srvcs.price) * parseFloat(payload.srvcs.userInputSrvcsDetails_Count);
                            state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) - parseFloat(totalpricereturn);
                        }
                    }
                }
            }
        }

        // >>> B: 'bookingValidatePassengersObject' -------
        if (Object.keys(bookingValidatePassengersObject_Clone.length !== 0)) {
            // got Data (before validate!)?
            for (var i = 0; i < bookingValidatePassengersObject_Clone.passengers.length; i++) {
                if (parseFloat(bookingValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    for (var x = 0; x < bookingValidatePassengersObject_Clone.passengers[i].services.length; x++) {
                        if (bookingValidatePassengersObject_Clone.passengers[i].services[x].code === payload.srvcs.code) {
                            if (payload.type === 'outward') {
                                if (bookingValidatePassengersObject_Clone.passengers[i].services[x].idFlight === state.bookingFlightIdSelectedOutward) {
                                    bookingValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                }
                            }

                            if (payload.type === 'return') {
                                if (bookingValidatePassengersObject_Clone.passengers[i].services[x].idFlight === state.bookingFlightIdSelectedReturn) {
                                    bookingValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                }
                            }
                        }
                    }
                }
            }
        }

        state.bookingValidatePassengersObject = bookingValidatePassengersObject_Clone; // write back
    }, // eo function mut_setBookingUpdateCartViaDeleteSrvcs()


    /***************************************************************************
    * mut_setBookingUpdateCartViaDeleteSeat()
    *
    * Desc: Update Cart/Totals. ((on 'Delete Seat')
    * Note: Delete 'Seat'. Update Out/Ret Totals.
    * Note: payload::{ id_pax: id_pax, type: type }
    * Note: Manipulate State: bookingValidatePassengersObject here too!
    *
    */
    mut_setBookingUpdateCartViaDeleteSeat: function mut_setBookingUpdateCartViaDeleteSeat(state, payload) {

        var totalpriceoutward = 0,
            totalpricereturn = 0,
            bookingValidatePassengersObject_Clone = _extends({}, state.bookingValidatePassengersObject); // copy


        // >>> A: Update 'Cart' ---------------------------
        for (var i = 0; i < state.bookingCart.length; i++) {
            if (parseFloat(state.bookingCart[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                // >>> Seat for Out? Delete from Cart!
                if (payload.type === 'outward') {
                    totalpriceoutward = parseFloat(state.bookingCart[i].outward_seat.price);
                    state.bookingCartOutwardTotal = parseFloat(state.bookingCartOutwardTotal) - parseFloat(totalpriceoutward);
                    state.bookingCart[i].outward_seat = {}; // delete
                }

                // >>> Seat for Out? Delete from Cart!
                if (payload.type === 'return') {
                    totalpricereturn = parseFloat(state.bookingCart[i].return_seat.price);
                    state.bookingCartReturnTotal = parseFloat(state.bookingCartReturnTotal) - parseFloat(totalpricereturn);
                    state.bookingCart[i].return_seat = {}; // delete
                }
            }
        }

        // >>> B: 'bookingValidatePassengersObject' -------
        if (Object.keys(bookingValidatePassengersObject_Clone).length !== 0) {
            // got Data (before validate!)?
            for (var i = 0; i < bookingValidatePassengersObject_Clone.passengers.length; i++) {
                if (parseFloat(bookingValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.id_pax, 10)) {
                    for (var x = 0; x < bookingValidatePassengersObject_Clone.passengers[i].seatServices.length; x++) {
                        if (payload.type === 'outward') {
                            if (bookingValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === state.bookingFlightIdSelectedOutward) {
                                bookingValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                            }
                        }

                        if (payload.type === 'return') {
                            if (bookingValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === state.bookingFlightIdSelectedReturn) {
                                bookingValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                            }
                        }
                    }
                }
            }
        }

        state.bookingValidatePassengersObject = bookingValidatePassengersObject_Clone; // write back
    }, // eo function mut_setBookingUpdateCartViaDeleteSeat()


    /***************************************************************************
    * Mutations: Offers, KeyDestinations
    ***************************************************************************/
    /***************************************************************************
    * mut_setOffers()
    *
    * Desc:
    * Note:
    *
    */
    mut_setOffers: function mut_setOffers(state, payload) {

        state.bookingOffers = payload.response;
    }, // eof mut_setOffers()


    /***************************************************************************
    * mut_call_DeparturesKeyDes()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_DeparturesKeyDes: function mut_call_DeparturesKeyDes(state, payload) {

        state.bookingDeparturesKeyDes = payload.response;
    }, // eof mut_call_DeparturesKeyDes()


    /***************************************************************************
    * mut_setBookingOffersSelectedDestination()
    *
    * Desc:
    * Note:
    *
    */
    mut_setBookingOffersSelectedDestination: function mut_setBookingOffersSelectedDestination(state, payload) {

        state.bookingOffersSelectedDestination = payload;
    }, // eof mut_setBookingOffersSelectedDestination()


    /***************************************************************************
    * mut_call_ListFlightsMonthlyOffers()
    *
    * Desc: Sets / Saves Calls Response
    * Note:
    *
    */
    mut_call_ListFlightsMonthlyOffers: function mut_call_ListFlightsMonthlyOffers(state, payload) {

        state.bookingOffersListFlightsMonthlyOffers = payload;
    }, // eof mut_call_ListFlightsMonthlyOffers()


    /***************************************************************************
    * mut_setBookingOffersListFlightsMonthlyOffers()
    *
    * Desc: Sets / Saves / Reset
    * Note:
    *
    */
    mut_setBookingOffersListFlightsMonthlyOffers: function mut_setBookingOffersListFlightsMonthlyOffers(state, payload) {

        state.bookingOffersListFlightsMonthlyOffers = payload;
    }, // eof mut_setBookingOffersListFlightsMonthlyOffers()


    /***************************************************************************
    * mut_setBookingOffersChoosenFlightByUser()
    *
    * Desc: Sets / Saves / Reset
    * Note:
    *
    */
    mut_setBookingOffersChoosenFlightByUser: function mut_setBookingOffersChoosenFlightByUser(state, payload) {

        state.bookingOffersChoosenFlightByUser = payload;
    }, // eof mut_setBookingOffersChoosenFlightByUser()


    /***************************************************************************
    * mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()
    *
    * Desc: Flag
    * Note:
    *
    */
    mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel: function mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel(state, payload) {

        state.flagSharedShowFlightSearchResultsAndBestPriceCaroussel = payload;
    }, // eof mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()


    /***************************************************************************
    * Mutations: Agency login
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagSharedAgencyLoggedIn()
    *
    * Desc: Flag: Agency logged in?
    * Note:
    *
    */
    mut_FlagSharedAgencyLoggedIn: function mut_FlagSharedAgencyLoggedIn(state, payload) {

        state.flagSharedAgencyLoggedIn = payload;
    }, // eof mut_FlagSharedAgencyLoggedIn()


    /***************************************************************************
    * mut_call_GetAgency()
    *
    * Desc: Save Agency Login - Data.
    * Note:
    *
    */
    mut_call_GetAgency: function mut_call_GetAgency(state, payload) {

        state.sharedAgencyLoginResults = payload.response;
    }, // eof mut_call_GetAgency()


    /***************************************************************************
    * mut_set_AgencyBookingsParams()
    *
    * Desc: Save Agency Data Search Params.
    * Note:
    *
    */
    mut_set_AgencyBookingsParams: function mut_set_AgencyBookingsParams(state, payload) {

        state.shared_AgencyBookingsParams = payload;
    }, // eof mut_set_AgencyBookingsParams()


    /***************************************************************************
    * mut_call_GetAgencyBookings()
    *
    * Desc: Save Agency Data. Booking History. And Total Brutto.
    * Note: Copy it for Filtered.
    *
    */
    mut_call_GetAgencyBookings: function mut_call_GetAgencyBookings(state, payload) {

        state.shared_AgencyGetBookings = payload.response.bookings;
        state.shared_AgencyGetBookings.sort(function (a, b) {
            return new Date(a.addendum.bookingDate) < new Date(b.addendum.bookingDate) ? 1 : new Date(b.addendum.bookingDate) < new Date(a.addendum.bookingDate) ? -1 : 0;
        });

        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings; // copy it here

        state.shared_AgencyTotalBrutto = payload.response.totalBrutto;
        state.shared_AgencyAgencyTotalBrutto = payload.response.agencytotalBrutto;
        state.shared_AgencyAgencyCashLimit = payload.response.cashLimit;
    }, // eof mut_call_GetAgencyBookings()


    /***************************************************************************
    * mut_set_filterSearchAgencyBookingsParams()
    *
    * Desc: Set Serch/Filöter Terms. Filter right afterwards.
    * Note:
    *
    */
    mut_set_filterSearchAgencyBookingsParams: function mut_set_filterSearchAgencyBookingsParams(state, payload) {

        state.shared_filterSearchAgencyBookingsParams = payload.payload;
        payload.context.commit('mut_filterSearchAgencyBookings'); // now filter
    }, // eof mut_set_filterSearchAgencyBookingsParams()


    /***************************************************************************
    * mut_filterSearchAgencyBookings()
    *
    * Desc:
    * Note:
    * Note: shared_filterSearchAgencyBookingsParams: {
    *           "searchfor_flightdate": '',
    *           "searchfor_bookingcode": '',
    *           "searchfor_invoiceid": '',
    *           "searchfor_surname": '',
    *       }
    */
    mut_filterSearchAgencyBookings: function mut_filterSearchAgencyBookings(state, payload) {

        var filterFlightdate = function filterFlightdate(booking) {
            var applyFilter = false;

            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate !== '') {
                if (booking.outwardFlights.length > 0) {
                    booking.outwardFlights.forEach(function (flight) {
                        if (String(flight.departureDateTime.substr(0, 10)) === String(state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate.substr(0, 10))) {
                            applyFilter = true;
                        }
                    });
                }
                if (booking.inboundFlights.length > 0) {
                    booking.inboundFlights.forEach(function (flight) {
                        if (String(flight.departureDateTime.substr(0, 10)) === String(state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate.substr(0, 10))) {
                            applyFilter = true;
                        }
                    });
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_flightdate === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        var filterBookingcode = function filterBookingcode(booking) {
            var applyFilter = false;

            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_bookingcode !== '') {
                if (booking.addendum.bookingNo.match(new RegExp(state.shared_filterSearchAgencyBookingsParams.searchfor_bookingcode, 'i'))) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_bookingcode === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        var filterInvoiceid = function filterInvoiceid(booking) {
            var applyFilter = false;

            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_invoiceid !== '') {
                if (+booking.addendum.idInvoice === +state.shared_filterSearchAgencyBookingsParams.searchfor_invoiceid) {
                    applyFilter = true;
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_invoiceid === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        var filterSurname = function filterSurname(booking) {
            var applyFilter = false;

            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_surname !== '') {
                if (booking.passengers.length > 0) {
                    booking.passengers.forEach(function (passenger) {
                        if (passenger.lastName.match(new RegExp(state.shared_filterSearchAgencyBookingsParams.searchfor_surname, 'i'))) {
                            applyFilter = true;
                        }
                    });
                }
            }

            // if there is set no search term
            if (state.shared_filterSearchAgencyBookingsParams && state.shared_filterSearchAgencyBookingsParams.searchfor_surname === '') {
                applyFilter = true;
            }

            if (state.shared_filterSearchAgencyBookingsParams === null) {
                applyFilter = true;
            }

            return applyFilter;
        };

        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings.filter(function (booking) {
            return filterFlightdate(booking);
        });
        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings_Filtered.filter(function (booking) {
            return filterBookingcode(booking);
        });
        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings_Filtered.filter(function (booking) {
            return filterInvoiceid(booking);
        });
        state.shared_AgencyGetBookings_Filtered = state.shared_AgencyGetBookings_Filtered.filter(function (booking) {
            return filterSurname(booking);
        });
    }, // eof mut_filterSearchAgencyBookings()


    /***************************************************************************
    * mut_setBookingWireCardEnrollPayment()
    *
    * Desc: Save Wirecard Enroll Payment Response
    * Note:
    *
    */
    mut_setBookingWireCardEnrollPayment: function mut_setBookingWireCardEnrollPayment(state, payload) {

        state.bookingWireCardEnrollPaymentResults = payload;
    } // eof mut_setBookingWireCardEnrollPayment()


};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: Current Locale
    ***************************************************************************/
    /***************************************************************************
    * actn_setCurrentLocale()
    *
    * Desc:
    * Note:
    *
    */
    actn_setCurrentLocale: function actn_setCurrentLocale(context, payload) {

        context.commit('mut_setCurrentLocale', payload); // calling mutation
    }, // eof actn_setCurrentLocale()


    /***************************************************************************
    * Actions: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagSharedShowFlightSearchResults()
    *
    * Desc: ACTION 'Show Flight Search Results Section'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagSharedShowFlightSearchResults: function actn_FlagSharedShowFlightSearchResults(context, payload) {

        context.commit('mut_FlagSharedShowFlightSearchResults', payload); // calling mutation
    }, // eof actn_FlagSharedShowFlightSearchResults()


    /***************************************************************************
    * Actions: Users Search
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingAirports()
    *
    * Desc: ACTION 'SET Search Airports' (Part 1).
    * Note:
    *
    */
    actn_setBookingAirports: function actn_setBookingAirports(context, payload) {

        context.commit('mut_setBookingAirports', payload); // calling mutation
    }, // eof actn_setBookingAirports()


    /***************************************************************************
    * actn_setBookingUsersSearchData()
    *
    * Desc: ACTION 'SET Users Search Data' (Part 2).
    * Note: PreFill Cart here too.
    *
    */
    actn_setBookingUsersSearchData: function actn_setBookingUsersSearchData(context, payload) {

        context.commit('mut_setBookingUsersSearchData', payload); // calling mutation
        context.commit('mut_setBookingPrefillCart', payload); // calling mutation
    }, // eof actn_setBookingUsersSearchData()


    /***************************************************************************
    * Actions: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingFlightSearchResults()
    *
    * Desc: ACTION 'SET Search Results'.
    * Note: Entire Response of FlightSearch.
    *
    */
    actn_setBookingFlightSearchResults: function actn_setBookingFlightSearchResults(context, payload) {

        context.commit('mut_setBookingFlightSearchResults', payload); // calling mutation
    }, // eof actn_setBookingFlightSearchResults()


    /***************************************************************************
    * actn_FlagBookingOutwardFlightSelected()
    *
    * Desc: ACTION 'Outward Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagBookingOutwardFlightSelected: function actn_FlagBookingOutwardFlightSelected(context, payload) {

        context.commit('mut_FlagBookingOutwardFlightSelected', payload); // calling mutation
    }, // eof actn_FlagBookingOutwardFlightSelected()


    /***************************************************************************
    * actn_FlagBookingReturnFlightSelected()
    *
    * Desc: ACTION 'Return Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagBookingReturnFlightSelected: function actn_FlagBookingReturnFlightSelected(context, payload) {

        context.commit('mut_FlagBookingReturnFlightSelected', payload); // calling mutation
    }, // eof actn_FlagBookingReturnFlightSelected()


    /***************************************************************************
    * actn_setBookingFlightIdSelectedOutward()
    *
    * Desc: ACTION 'SET Selected Flight Id' Out.
    * Note:
    *
    */
    actn_setBookingFlightIdSelectedOutward: function actn_setBookingFlightIdSelectedOutward(context, payload) {

        context.commit('mut_setBookingFlightIdSelectedOutward', payload); // calling mutation
    }, // eof actn_setBookingFlightIdSelectedOutward()


    /***************************************************************************
    * actn_setBookingFlightIdSelectedReturn()
    *
    * Desc: ACTION 'SET Selected Flight Id' Ret.
    * Note:
    *
    */
    actn_setBookingFlightIdSelectedReturn: function actn_setBookingFlightIdSelectedReturn(context, payload) {

        context.commit('mut_setBookingFlightIdSelectedReturn', payload); // calling mutation
    }, // eof actn_setBookingFlightIdSelectedReturn()


    /***************************************************************************
    * Actions: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingLockfaresResults()
    *
    * Desc: ACTION 'SET Search Results'.
    * Note: Entire Response of FlightSearch.
    *
    */
    actn_setBookingLockfaresResults: function actn_setBookingLockfaresResults(context, payload) {

        context.commit('mut_setBookingLockfaresResults', payload); // calling mutation
    }, // eof actn_setBookingFlightSearchResults()


    /***************************************************************************
    * actn_setBookingSrvcsSeatExistOnOut()
    *
    * Desc: ACTION 'SET Service Exists on OUT'.
    * Note: Gets checked in lockfares Response.
    *
    */
    actn_setBookingSrvcsSeatExistOnOut: function actn_setBookingSrvcsSeatExistOnOut(context, payload) {

        context.commit('mut_setBookingSrvcsSeatExistOnOut', payload); // calling mutation
    }, // eof actn_setBookingSrvcsSeatExistOnOut()


    /***************************************************************************
    * actn_setBookingSrvcsSeatExistOnRet()
    *
    * Desc: ACTION 'SET Service Exists on RET'.
    * Note: Gets checked in lockfares Response.
    *
    */
    actn_setBookingSrvcsSeatExistOnRet: function actn_setBookingSrvcsSeatExistOnRet(context, payload) {

        context.commit('mut_setBookingSrvcsSeatExistOnRet', payload); // calling mutation
    }, // eof actn_setBookingSrvcsSeatExistOnRet()


    /***************************************************************************
    * actn_setBookingValidatePassengersObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger).
    * Note:
    *
    */
    actn_setBookingValidatePassengersObject: function actn_setBookingValidatePassengersObject(context, payload) {

        context.commit('mut_setBookingValidatePassengersObject', payload); // calling mutation
    }, // eof actn_setBookingValidatePassengersObject()


    /***************************************************************************
    * Actions: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagBookingPaymentIsReadyForOverview()
    *
    * Desc: ACTION 'SET Flag: Payment is ready for Overview'.
    * Note:
    *
    */
    actn_FlagBookingPaymentIsReadyForOverview: function actn_FlagBookingPaymentIsReadyForOverview(context, payload) {

        context.commit('mut_FlagBookingPaymentIsReadyForOverview', payload); // calling mutation
    }, // eof actn_FlagBookingPaymentIsReadyForOverview()


    /***************************************************************************
    * actn_setBookingProcessBookingObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (processBooking).
    * Note:
    *
    */
    actn_setBookingProcessBookingObject: function actn_setBookingProcessBookingObject(context, payload) {

        context.commit('mut_setBookingProcessBookingObject', payload); // calling mutation
    }, // eof actn_setBookingProcessBookingObject()


    /***************************************************************************
    * Actions: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagBookingOverviewIsReadyForProcess()
    *
    * Desc: ACTION 'SET Flag: Overview is ready for Process'.
    * Note:
    *
    */
    actn_FlagBookingOverviewIsReadyForProcess: function actn_FlagBookingOverviewIsReadyForProcess(context, payload) {

        context.commit('mut_FlagBookingOverviewIsReadyForProcess', payload); // calling mutation
    }, // eof actn_FlagBookingOverviewIsReadyForProcess()


    /*************************************************************************** 'Version 2 is Tmp only'
    * Call::'/booking/processbooking2/'
    *
    * Desc: (Call) - Process Booking.
    * Note: THIS IS USING 'processBooking2'. An enhanced Copy of Original.
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_processBooking: function actn_call_processBooking(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('/booking/processbooking2/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    // >>> ----------------------------
                    if (response.data.status !== 'KO') {
                        context.commit('mut_setBookingProcessBookingResults', response.data); // save ...
                        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('readytoshowbookingsconfirmation', response.data); // emit ... 'ready to push 'confirmation' (original)
                        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('readytoshowbookingsconfirmationoncheckout', response.data); // emit ... 'ready to push 'confirmation' (checkout)
                    }

                    // >>> ----------------------------
                    if (response.data.status === 'KO') {
                        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                            message: response.data.errors[0].errorMessage
                        });
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_processBooking()


    /***************************************************************************
    * Actions: Seats
    ***************************************************************************/
    /*************************************************************************** 'Seats'
    * actn_bookingSeatReservationLockingCodeResults()
    *
    * Desc: ACTION 'SET Lockingcodes Results'.
    * Note: Entire Response of /seatplan/lock/ call.
    *
    */
    actn_bookingSeatReservationLockingCodeResults: function actn_bookingSeatReservationLockingCodeResults(context, payload) {

        context.commit('mut_setBookingSeatReservationLockingCodeResults', payload); // calling mutation
    }, // eof actn_bookingSeatReservationLockingCodeResults()


    /*************************************************************************** 'Seats'
    * actn_bookingSeatplanResults()
    *
    * Desc: ACTION 'SET Seatplan Results'.
    * Note: Entire Response of '/seatplan/' Call.
    *
    */
    actn_bookingSeatplanResults: function actn_bookingSeatplanResults(context, payload) {

        context.commit('mut_setBookingSeatplanResults', payload); // calling mutation
    }, // eof actn_bookingSeatplanResults()


    /***************************************************************************
    * Actions: Update Cart
    ***************************************************************************/
    /***************************************************************************
    * actn_setBookingUpdateCart()
    *
    * Desc: ACTION 'Update Cart'.
    * Note:
    *
    */
    actn_setBookingUpdateCart: function actn_setBookingUpdateCart(context, payload) {

        context.commit('mut_setBookingUpdateCart', payload); // calling mutation
    }, // eof actn_setBookingUpdateCart()


    /***************************************************************************
    * actn_setBookingUpdateCartWithSrvcs()
    *
    * Desc: ACTION 'Update Cart' with Services.
    * Note:
    *
    */
    actn_setBookingUpdateCartWithSrvcs: function actn_setBookingUpdateCartWithSrvcs(context, payload) {

        context.commit('mut_setBookingUpdateCartWithSrvcs', payload); // calling mutation
    }, // eof actn_setBookingUpdateCart()


    /***************************************************************************
    * actn_setBookingUpdateCartWithSeat()
    *
    * Desc: ACTION 'Update Cart' with a Seat.
    * Note:
    *
    */
    actn_setBookingUpdateCartWithSeat: function actn_setBookingUpdateCartWithSeat(context, payload) {

        context.commit('mut_setBookingUpdateCartWithSeat', payload); // calling mutation
    }, // eof actn_setBookingUpdateCartWithSeat()


    /***************************************************************************
    * actn_setBookingUpdateCartWithPaxCredentials()
    *
    * Desc: ACTION 'Update Cart' with Pax Credentials.
    * Note:
    *
    */
    actn_setBookingUpdateCartWithPaxCredentials: function actn_setBookingUpdateCartWithPaxCredentials(context, payload) {

        context.commit('mut_setBookingUpdateCartWithPaxCredentials', payload); // calling mutation
    }, // eof actn_setBookingUpdateCartWithPaxCredentials()


    /***************************************************************************
    * actn_setBookingUpdateCartViaDeleteSrvcs()
    *
    * Desc: ACTION 'Update Cart' via DELETE a Service.
    * Note:
    *
    */
    actn_setBookingUpdateCartViaDeleteSrvcs: function actn_setBookingUpdateCartViaDeleteSrvcs(context, payload) {

        context.commit('mut_setBookingUpdateCartViaDeleteSrvcs', payload); // calling mutation
    }, // eof actn_setBookingUpdateCartViaDeleteSrvcs()


    /***************************************************************************
    * actn_setBookingUpdateCartViaDeleteSeat()
    *
    * Desc: ACTION 'Update Cart' via DELETE a Seat.
    * Note: e.g.: { id_pax: pax.id_pax, type: 'return' }
    *
    */
    actn_setBookingUpdateCartViaDeleteSeat: function actn_setBookingUpdateCartViaDeleteSeat(context, payload) {

        context.commit('mut_setBookingUpdateCartViaDeleteSeat', payload); // calling mutation
    }, // eof actn_setBookingUpdateCartViaDeleteSeat()


    /***************************************************************************
    * Actions: 'Calls', Offers, KeyDestinations
    ***************************************************************************/
    /***************************************************************************
    * Call::'/booking/offers/'
    *
    * Desc: (Call) - ´
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_Offers: function actn_call_Offers(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/booking/offers/').then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_setOffers', { response: response.data }, { root: true }); // commit into booking state
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_Offers()


    /***************************************************************************
    * Call::'booking/departures/FUE'
    *
    * Desc: (Call) - Geeting Origins Airports
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_DeparturesKeyDes: function actn_call_DeparturesKeyDes(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('booking/departures/' + payload.destinationOfferAptCode).then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_DeparturesKeyDes', { response: response.data }, { root: true }); // commit into booking state
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_DeparturesKeyDes()


    /***************************************************************************
    * Call::'/booking/listflights/'
    *
    * Desc: (Call) - Get Monthly Offers via 'listflights'
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_ListFlightsMonthlyOffers: function actn_call_ListFlightsMonthlyOffers(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('/booking/listflights/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_ListFlightsMonthlyOffers', response.data.listFlightsRS.flts); // commit into booking state
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_ListFlightsMonthlyOffers()


    /***************************************************************************
    * actn_setBookingOffersSelectedDestination()
    *
    * Desc: ACTION 'Save User selected KeyDestination.
    * Note:
    *
    */
    actn_setBookingOffersSelectedDestination: function actn_setBookingOffersSelectedDestination(context, payload) {

        context.commit('mut_setBookingOffersSelectedDestination', payload); // calling mutation
    }, // eof actn_setBookingOffersSelectedDestination()


    /***************************************************************************
    * actn_setBookingOffersListFlightsMonthlyOffers()
    *
    * Desc: ACTION
    * Note:
    *
    */
    actn_setBookingOffersListFlightsMonthlyOffers: function actn_setBookingOffersListFlightsMonthlyOffers(context, payload) {

        context.commit('mut_setBookingOffersListFlightsMonthlyOffers', payload); // calling mutation
    }, // eof actn_setBookingOffersListFlightsMonthlyOffers()


    /***************************************************************************
    * actn_setBookingOffersChoosenFlightByUser()
    *
    * Desc: ACTION
    * Note:
    *
    */
    actn_setBookingOffersChoosenFlightByUser: function actn_setBookingOffersChoosenFlightByUser(context, payload) {

        context.commit('mut_setBookingOffersChoosenFlightByUser', payload); // calling mutation
    }, // eof actn_setBookingOffersChoosenFlightByUser()


    /***************************************************************************
    * Call::'/booking/listflights/'
    *
    * Desc: (Call) - Get Monthly Offers via 'listflights'
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_ListFlightsAfterUserSelectedBestPrice: function actn_call_ListFlightsAfterUserSelectedBestPrice(context, payload) {

        var me = _this,
            hdrs = '',
            options = {
            container: 'body',
            easing: 'linear',
            offset: -60,
            force: true,
            cancelable: true,
            onStart: function onStart(element) {
                // scrolling started
            },
            onDone: function onDone(element) {
                // scrolling is done
            },
            onCancel: function onCancel() {
                // scrolling has been interrupted
            },
            x: false,
            y: true
        };

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('/booking/listflights/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_setBookingFlightSearchResults', response.data.listFlightsRS.flts);
                    context.commit('mut_FlagSharedShowFlightSearchResults', true);

                    setTimeout(function () {
                        context.commit('mut_setBookingUpdateCart', { flight: state.bookingOffersChoosenFlightByUser, type: 'outward', modulo: 'booking' });
                        __WEBPACK_IMPORTED_MODULE_1_vue_scrollto___default.a.scrollTo('#contentElement', 200, options);
                    }, 200);
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_ListFlightsAfterUserSelectedBestPrice()


    /***************************************************************************
    * actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()
    *
    * Desc: ACTION 'Show Flight Search Results Section and Best Prices'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel: function actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel(context, payload) {

        context.commit('mut_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel', payload); // calling mutation
    }, // eof actn_FlagSharedShowFlightSearchResultsAndBestPriceCaroussel()


    /***************************************************************************
    * Actions: 'Calls', Sundair/Agency Login
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagSharedAgencyLoggedIn()
    *
    * Desc: ACTION: Set Flag 'Agency is logged in?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagSharedAgencyLoggedIn: function actn_FlagSharedAgencyLoggedIn(context, payload) {

        context.commit('mut_FlagSharedAgencyLoggedIn', payload); // calling mutation
    }, // eof actn_FlagSharedAgencyLoggedIn()


    /***************************************************************************
    * Call::'/rest/info/getagency'
    *
    * Desc: (Call) -
    * Note: Add user/pass in this Call here.
    * Note: Write into LocalStorage. Remember Agency.
    *
    */
    actn_call_GetAgency: function actn_call_GetAgency(context, payload) {

        var me = _this,
            hdrs = '',
            trsnltd = '',
            agencyObject = {};

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.username = payload.username; // Add user/pass
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.password = payload.password;

        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/info/getagency').then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'

                    tjq("#soap-popupbox")[0].style = 'display: none;'; // close little modal

                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].set('agency_username', payload.username, 60 * 60 * 1000); // SuccessFul: => into localStorage, // expiry 1 hour
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].set('agency_password', payload.password, 60 * 60 * 1000);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].set('agencyAuthorizationHeader', JSON.stringify(window.btoa(payload.username + ":" + payload.password)), 60 * 60 * 1000); // #795

                    // Vue['ls'].set('agency_commission_amount', response.data.commission.amount, 60 * 60 * 1000);
                    // Vue['ls'].set('agency_commission_type', response.data.commission.type, 60 * 60 * 1000);

                    agencyObject = {
                        firstName: response.data.firstName,
                        lastName: response.data.lastName,
                        address: response.data.address,
                        plz: response.data.postalCode,
                        city: response.data.city,
                        phone: response.data.phone,
                        email: response.data.email,
                        companyName: response.data.companyName,
                        agency_commission_amount: response.data.commission.amount,
                        agency_commission_type: response.data.commission.type,
                        agency_servicecommission_amount: response.data.serviceCommission.amount,
                        agency_servicecommission_type: response.data.serviceCommission.type,
                        idCustomer: response.data.idCustomer,
                        countryCode: response.data.countryCode
                    };
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].set('agency_object', JSON.stringify(agencyObject), 60 * 60 * 1000);

                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_info({ // inform
                        message: 'Agency was logged in.'
                    });

                    context.commit('mut_call_GetAgency', { response: response.data }, { root: true }); // commit into booking state
                    context.commit('mut_FlagSharedAgencyLoggedIn', true, { root: true });

                    delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.username; // remove header again
                    delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.password;

                    // reload page
                    setTimeout(function () {
                        location.reload();
                    }, 1000);

                    break;
                default:
                    // 'ERROR'
                    trsnltd = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$trnsl_error_message(response.headers["air41-error"]);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: trsnltd
                    });

                    delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.username; // remove header again
                    delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.password;
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.username; // remove header again
            delete __WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.password;

            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_GetAgency()


    /***************************************************************************
    * Call::'/booking/getagencybookings'
    *
    * Desc: (Call) -
    * Note:
    *
    */
    actn_call_GetAgencyBookings: function actn_call_GetAgencyBookings(context, payload) {

        var me = _this,
            hdrs = '',
            trsnltd = '';

        // >>> Send Ajax Request --------------------------
        context.commit('mut_set_AgencyBookingsParams', payload);

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('/booking/getagencybookings', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_GetAgencyBookings', { response: response.data }, { root: true }); // commit into booking state
                    break;
                default:
                    // 'ERROR'
                    trsnltd = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$trnsl_error_message(response.headers["air41-error"]);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: trsnltd
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_GetAgencyBookings()


    /***************************************************************************
    * act_set_filterSearchAgencyBookingsParams()
    *
    * Desc: Save Search/Filter Params for Agency Bookings.
    * Note:
    *
    */
    act_set_filterSearchAgencyBookingsParams: function act_set_filterSearchAgencyBookingsParams(context, payload) {

        context.commit('mut_set_filterSearchAgencyBookingsParams', { payload: payload, context: context });
    }, // eo function act_set_filterSearchAgencyBookingsParams()


    /***************************************************************************
    * Actions: 'WireCare Enroll Payment Step'
    ***************************************************************************/
    /***************************************************************************
    * Call::'acm/payment/secuconnect/enroll'
    *
    * Desc: (Call) - WireCard Enroll Payment. ITS NOT WIRTECARD!!!
    * Note: Very special in Error Handling!!!
    *
    */
    actn_call_wireCardEnrollPayment: function actn_call_wireCardEnrollPayment(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('/acm/payment/secuconnect/enroll', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'

                    // >>> ----------------------------
                    if (response.data.status === 'KO') {
                        if (response.data.statusReason !== null && response.data.statusReason.length > 0) {
                            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                                message: response.data.statusReason[0].description
                            });
                        }
                        if (response.data.statusReason === null || response.data.statusReason.length === 0) {
                            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                                message: 'Please check your credt card data.'
                            });
                        }
                    }

                    // >>> ----------------------------
                    if (response.data.status !== 'KO') {
                        context.commit('mut_setBookingWireCardEnrollPayment', response.data);
                        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('readytoshowwirecardmodal');
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_wireCardEnrollPayment()


    /***************************************************************************
    * Call::'booking/prebook'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_preBooking: function actn_call_preBooking(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put('/booking/prebook', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('readytodostepafterprebook', response.data);
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_preBooking()


    /***************************************************************************
    * Call::'payment/secuconnect/checkout/'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_checkTransactionId: function actn_call_checkTransactionId(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('payment/secuconnect/checkout/' + payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    // >>> ----------------------------
                    if (response.data.status === 'OK') {
                        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('readytoprocessbooking', response.data); // emit .. 'ready to push 'confirmation'
                    }

                    // >>> ----------------------------
                    if (response.data.status === 'KO') {
                        __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                            message: response.data.errors[0].errorMessage
                        });
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_4__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_checkTransactionId()


    /***************************************************************************
    * Call::'booking/releaseccbooking/{transactionid}'
    *
    * Desc:
    * Note: This is the 'Cleanup Backend Call'
    *
    */
    actn_call_releaseBooking: function actn_call_releaseBooking(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('booking/releaseccbooking/' + payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    // if (response.data.status === 'OK') {
                    //     eventBus.$emit('readytoprocessbooking', response.data); // emit .. 'ready to push 'confirmation'
                    // }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    } // eo function actn_call_checkTransactionId()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * services.js
 *
 * Description: Holds 'Stores' Logic for Module:'Services'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> Are we in 'Services-Bookingno' Mode? -----------
    areWeInServicesBookingNoMode: false,

    // >>> 'BookingOptions Results' -----------------------
    servicesBookingOptionsResults: null,
    // >>> 'Bookable Services Results' --------------------
    servicesBookableServicesOutwardResults: null,
    servicesBookableServicesReturnResults: null,
    // >>> ------------------------------------------------
    servicesSrvcsMealExistsOnOut: false, // does Srvcs 'MEAL' exist on OUT?
    servicesSrvcsMealExistsOnRet: false, // does Srvcs 'MEAL' exist on OUT?
    servicesSrvcsServiceExistsOnOut: false, // and so on ...
    servicesSrvcsServiceExistsOnRet: false,
    servicesSrvcsPetsExistsOnOut: false,
    servicesSrvcsPetsExistsOnRet: false,
    servicesSrvcsSportbagExistsOnOut: false,
    servicesSrvcsSportbagExistsOnRet: false,
    servicesSrvcsBaggageExistsOnOut: false,
    servicesSrvcsBaggageExistsOnRet: false,
    servicesSrvcsMedicalExistsOnOut: false,
    servicesSrvcsMedicalExistsOnRet: false,

    // >>> ------------------------------------------------
    servicesValidatePassengersObject: null, // Calls Object to send ..
    servicesValidatePassengersObjectClone: null, // Calls Object to send .. Clone

    servicesProcessBookingObject: null, // Calls Object to send .. last call
    servicesProcessBookingResults: null,

    // >>> 'Bookingno' ------------------------------------
    flagServicesBookingnoLoginIsReadyForLogin: false, // 'Bookingno Login' ready?
    servicesUsersSearchDataBookingno: null,
    servicesBookingnoSearchResults: {}, // SearchResults (Bookingno)
    // >>> Flag: Show Section 'Bookingno Overview' --------
    flagServicesShowBookingnoSearchResults: false, // CONTROL FLAG - 'Search Results Section'


    // >>> Flag: Internal' --------------------------------
    bookableServicesCallOutDidRun: false, // CONTROL FLAG - Internal
    bookableServicesCallRetDidRun: false, // CONTROL FLAG - Internal
    gotSeatOnOut: false, // CONTROL FLAG - Internal
    gotSeatOnRet: false, // CONTROL FLAG - Internal
    seatplanCallCounter: 0 // Counts Seatplan Calls

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: 'Are we in 'Services Bookingno' Mode?
    ***************************************************************************/
    /***************************************************************************
    * get_areWeInServicesBookingNoMode()
    *
    * Desc: Are we in 'Services Bookingno' Mode?
    * Note:
    *
    */
    get_areWeInServicesBookingNoMode: function get_areWeInServicesBookingNoMode(state) {

        return state.areWeInServicesBookingNoMode;
    }, // eof get_areWeInServicesBookingNoMode()


    /***************************************************************************
    * Getters: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * getServicesBookingOptions()
    *
    * Desc: Return Results of Call::'/registration/bookingoptions'.
    * Note:
    *
    */
    getServicesBookingOptions: function getServicesBookingOptions(state) {

        return state.servicesBookingOptionsResults;
    }, // eof getServicesBookingOptions()

    /***************************************************************************
    * getServicesBookableServicesOutward()
    *
    * Desc: Return Results of Call::'/registration/bookableservices'.
    * Note: 'Outward Flights' Services.
     */
    getServicesBookableServicesOutward: function getServicesBookableServicesOutward(state) {

        return state.servicesBookableServicesOutwardResults;
    }, // eof getServicesBookableServicesOutward()

    /***************************************************************************
    * getServicesBookableServicesReturn()
    *
    * Desc: Return Results of Call::'/registration/bookableservices'.
    * Note: 'Return Flights' Services.
     */
    getServicesBookableServicesReturn: function getServicesBookableServicesReturn(state) {

        return state.servicesBookableServicesReturnResults;
    }, // eof getServicesBookableServicesReturn()


    /***************************************************************************
    * Getters: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * getServicesDoesAnySrvcsExistAtAll()
    *
    * Desc: Return 'We have any srvcs on Flight?  With Seats included!'
    * Note:
    *
    */
    getServicesDoesAnySrvcsExistAtAll: function getServicesDoesAnySrvcsExistAtAll(state) {

        var srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;

        if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length === 0) {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.servicesBookableServicesReturnResults !== null) {
            if (state.servicesBookableServicesReturnResults.bookableServicesRS.services.length === 0) {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }

        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }

        return doesAnySrvcsExistAtAll;
    }, // eof getServicesDoesAnySrvcsExistAtAll()

    /***************************************************************************
    * getServicesDoesAnySrvcsExistAtAllWOSeats()
    *
    * Desc: Return 'We have any srvcs on Flight? Without Seats!'
    * Note:
    *
    */
    getServicesDoesAnySrvcsExistAtAllWOSeats: function getServicesDoesAnySrvcsExistAtAllWOSeats(state) {

        var srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;

        if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length === 0) {
            srvcsExistOnOut = false;
        } else if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length === 1 && state.servicesBookableServicesOutwardResults.bookableServicesRS.services[0].code === 'SEAT') {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.servicesBookableServicesReturnResults !== null) {
            if (state.servicesBookableServicesReturnResults.bookableServicesRS.services.length === 0) {
                srvcsExistOnRet = false;
            } else if (state.servicesBookableServicesReturnResults.bookableServicesRS.services.length === 1 && state.servicesBookableServicesReturnResults.bookableServicesRS.services[0].code === 'SEAT') {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }

        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }

        return doesAnySrvcsExistAtAll;
    }, // eof getServicesDoesAnySrvcsExistAtAllWOSeats()


    /***************************************************************************
    * getServicesSrvcsMealExists()
    *
    * Desc: Return if Srvcs 'MEAL' exists?
    * Note:
    *
    */
    getServicesSrvcsMealExists: function getServicesSrvcsMealExists(state) {

        if (state.servicesSrvcsMealExistsOnOut === true || state.servicesSrvcsMealExistsOnRet === true) {
            return true;
        } else {
            return false;
        }
    }, // eof getServicesSrvcsMealExists()

    /***************************************************************************
    * getServicesSrvcsServiceExists()
    *
    * Desc: Return if Srvcs 'SERVICE' exists?
    * Note:
    *
    */
    getServicesSrvcsServiceExists: function getServicesSrvcsServiceExists(state) {

        if (state.servicesSrvcsServiceExistsOnOut === true || state.servicesSrvcsServiceExistsOnRet === true) {
            return true;
        } else {
            return false;
        }
    }, // eof getServicesSrvcsServiceExists()

    /***************************************************************************
    * getServicesSrvcsServiceExists()
    *
    * Desc: Return if Srvcs 'PETS' exists?
    * Note:
    *
    */
    getServicesSrvcsPetsExists: function getServicesSrvcsPetsExists(state) {

        if (state.servicesSrvcsPetsExistsOnOut === true || state.servicesSrvcsPetsExistsOnRet === true) {
            return true;
        } else {
            return false;
        }
    }, // eof getServicesSrvcsPetsExists()

    /***************************************************************************
    * getServicesSrvcsSportbagExists()
    *
    * Desc: Return if Srvcs 'SPORTBAG' exists?
    * Note:
    *
    */
    getServicesSrvcsSportbagExists: function getServicesSrvcsSportbagExists(state) {

        if (state.servicesSrvcsSportbagExistsOnOut === true || state.servicesSrvcsSportbagExistsOnRet === true) {
            return true;
        } else {
            return false;
        }
    }, // eof getServicesSrvcsSportbagExists()

    /***************************************************************************
    * getServicesSrvcsBaggageExists()
    *
    * Desc: Return if Srvcs 'BAGGAGE' exists?
    * Note:
    *
    */
    getServicesSrvcsBaggageExists: function getServicesSrvcsBaggageExists(state) {

        if (state.servicesSrvcsBaggageExistsOnOut === true || state.servicesSrvcsBaggageExistsOnRet === true) {
            return true;
        } else {
            return false;
        }
    }, // eof getServicesSrvcsBaggageExists()

    /***************************************************************************
    * getServicesSrvcsMedicalExists()
    *
    * Desc: Return if Srvcs 'MEDICAL' exists?
    * Note:
    *
    */
    getServicesSrvcsMedicalExists: function getServicesSrvcsMedicalExists(state) {

        if (state.servicesSrvcsMedicalExistsOnOut === true || state.servicesSrvcsMedicalExistsOnRet === true) {
            return true;
        } else {
            return false;
        }
    }, // eof getServicesSrvcsMedicalExists()


    /***************************************************************************
    * getServicesPassengersSrvcsOfType()
    *
    * Desc: Returns an Array of Srvcs of Type ...!
    * Note: Works for all Services Categories/Types.
    *
    */
    getServicesPassengersSrvcsOfType: function getServicesPassengersSrvcsOfType(state) {
        return function (payload) {

            var srvcsArray = [];

            for (var i = 0; i < state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length; i++) {
                if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].categoryCode === payload.type) {
                    srvcsArray.push({
                        id: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].id,
                        description: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].description,
                        remark: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].remark,
                        code: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].code,
                        price: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].price,
                        maxBookablePax: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].maxBookablePax,
                        acceptComment: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].acceptComment,
                        srvc_exist_out: true,
                        srvc_exist_ret: false
                    });
                }
            }

            if (state.servicesBookableServicesReturnResults !== null) {
                for (var i = 0; i < state.servicesBookableServicesReturnResults.bookableServicesRS.services.length; i++) {
                    if (state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].categoryCode === payload.type) {
                        var result = srvcsArray.findIndex(function (srvcs) {
                            return srvcs.id === state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].id;
                        });
                        if (result === -1) {
                            // We dont have this 'servicecat' yet -> simply 'insert' it.
                            srvcsArray.push({
                                id: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].id,
                                description: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].description,
                                remark: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].remark,
                                code: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].code,
                                price: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].price,
                                maxBookablePax: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].maxBookablePax,
                                acceptComment: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].acceptComment,
                                srvc_exist_out: false,
                                srvc_exist_ret: true
                            });
                        } else {
                            // We have this 'srvcs' already -> simply 'update' it.
                            srvcsArray[result].srvc_exist_ret = true;
                        }
                    }
                }
            }

            return srvcsArray;
        };
    }, // eof getServicesPassengersSrvcsOfType()


    /***************************************************************************
    * Getters: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * getServicesValidatePassengersObject()
    *
    * Desc: Return 'Object we sent in validatePassenger Call'.
    * Note:
    *
    */
    getServicesValidatePassengersObject: function getServicesValidatePassengersObject(state) {

        return state.servicesValidatePassengersObject;
    }, // eof getServicesValidatePassengersObject()

    /***************************************************************************
    * getServicesValidatePassengersObjectClone()
    *
    * Desc: Return 'Object we sent in validatePassenger Call'. Clone.
    * Note:
    *
    */
    getServicesValidatePassengersObjectClone: function getServicesValidatePassengersObjectClone(state) {

        return state.servicesValidatePassengersObjectClone;
    }, // eof getServicesValidatePassengersObjectClone()


    /***************************************************************************
    * Getters: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * getServicesProcessBookingObject()
    *
    * Desc: Return 'Object we sent in processBooking Call'.
    * Note:
    *
    */
    getServicesProcessBookingObject: function getServicesProcessBookingObject(state) {

        return state.servicesProcessBookingObject;
    }, // eof getServicesProcessBookingObject()

    /***************************************************************************
    * getServicesProcessBookingResults()
    *
    * Desc: Return Results of ProcessBooking (Calls Response).
    * Note:
    *
    */
    getServicesProcessBookingResults: function getServicesProcessBookingResults(state) {

        return state.servicesProcessBookingResults;
    }, // eof getServicesProcessBookingResults()


    /***************************************************************************
    * Getters: 'Bookingno'
    ***************************************************************************/
    /***************************************************************************
    * getFlagServicesBookingnoLoginIsReadyForLogin()
    *
    * Desc: Return Flag: 'Bookingno is ready for Login?'
    * Note:
    *
    */
    getFlagServicesBookingnoLoginIsReadyForLogin: function getFlagServicesBookingnoLoginIsReadyForLogin(state) {

        return state.flagServicesBookingnoLoginIsReadyForLogin;
    }, // eo function getFlagServicesBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * get_ServicesUsersSearchDataBookingno()
    *
    * Desc: Returns Search Data (bookingCode lastName).
    * Note:
    *
    */
    get_ServicesUsersSearchDataBookingno: function get_ServicesUsersSearchDataBookingno(state) {

        return state.servicesUsersSearchDataBookingno;
    }, // eo function get_ServicesUsersSearchDataBookingno()


    /***************************************************************************
    * get_ServicesBookingnoSearchResults()
    *
    * Desc: Return Bookingno Search Results.
    * Note:
    *
    */
    get_ServicesBookingnoSearchResults: function get_ServicesBookingnoSearchResults(state) {

        return state.servicesBookingnoSearchResults;
    }, // eo function get_ServicesBookingnoSearchResults()


    /***************************************************************************
    * get_ServicesBookingnoSearchResultsPassengersSorted()
    *
    * Desc: Return Bookingno Search Results Passengers (sorted).
    * Note:
    * Note: Build 'own' id_pax.
    *
    */
    get_ServicesBookingnoSearchResultsPassengersSorted: function get_ServicesBookingnoSearchResultsPassengersSorted(state) {

        state.servicesBookingnoSearchResults[0].passengers.forEach(function (item, i) {
            if (item.salutation === 'MR' || item.salutation === 'MRS') {
                item.order = 1;
            }
            if (item.salutation === 'CHD') {
                item.order = 2;
            }
            if (item.salutation === 'INF') {
                item.order = 3;
            }
        });

        state.servicesBookingnoSearchResults[0].passengers.sort(function (a, b) {
            return a.order - b.order;
        });

        state.servicesBookingnoSearchResults[0].passengers.forEach(function (item, i) {
            item.id_pax_own = i + 1;
        });

        return state.servicesBookingnoSearchResults[0].passengers;
    }, // eo function get_ServicesBookingnoSearchResultsPassengersSorted()


    /***************************************************************************
    * get_ServicesBookingnoPassengersCountAll()
    *
    * Desc: Return Bookingno Search Results Passengers Count.
    * Note:
    *
    */
    get_ServicesBookingnoPassengersCountAll: function get_ServicesBookingnoPassengersCountAll(state) {

        return state.servicesBookingnoSearchResults[0].passengers.length;
    }, // eo function get_ServicesBookingnoPassengersCountAll()


    /***************************************************************************
    * get_ServicesBookingnoPassengersCount()
    *
    * Desc: Return Bookingno Search Results Passengers Count.
    * Note: Getter with Payload!
    *
    */
    get_ServicesBookingnoPassengersCount: function get_ServicesBookingnoPassengersCount(state) {
        return function (payload) {

            var paxCount = 0;

            if (payload === 'ADT') {
                paxCount = state.servicesBookingnoSearchResults[0].passengers.filter(function (x) {
                    return x.salutation == 'MR' || x.salutation == 'MRS';
                }).length;
            }
            if (payload === 'CHD') {
                paxCount = state.servicesBookingnoSearchResults[0].passengers.filter(function (x) {
                    return x.salutation == 'CHD';
                }).length;
            }
            if (payload === 'INF') {
                paxCount = state.servicesBookingnoSearchResults[0].passengers.filter(function (x) {
                    return x.salutation == 'INF';
                }).length;
            }

            return paxCount;
        };
    }, // eo function get_ServicesBookingnoPassengersCount()


    /***************************************************************************
    * get_ServicesBookingnoHasOutwardFlight()
    *
    * Desc: Return .. Has Outward Flight?
    * Note:
    *
    */
    get_ServicesBookingnoHasOutwardFlight: function get_ServicesBookingnoHasOutwardFlight(state) {

        if (state.servicesBookingnoSearchResults[0].outwardFlight !== undefined && state.servicesBookingnoSearchResults[0].outwardFlight !== null) {
            return true;
        } else {
            return false;
        }
    }, // eo function get_ServicesBookingnoHasOutwardFlight()


    /***************************************************************************
    * get_ServicesBookingnoHasReturnFlight()
    *
    * Desc: Return .. Has Return Flight?
    * Note:
    *
    */
    get_ServicesBookingnoHasReturnFlight: function get_ServicesBookingnoHasReturnFlight(state) {

        if (state.servicesBookingnoSearchResults[0].returnFlight !== undefined && state.servicesBookingnoSearchResults[0].returnFlight !== null) {
            return true;
        } else {
            return false;
        }
    }, // eo function get_ServicesBookingnoHasReturnFlight()


    /***************************************************************************
    * get_ServicesBookingnoDepArprtNameOutuward()
    *
    * Desc: Return .. Apt Name, Departure, Outward
    * Note:
    *
    */
    get_ServicesBookingnoDepArprtNameOutuward: function get_ServicesBookingnoDepArprtNameOutuward(state) {

        return state.servicesBookingnoSearchResults[0].outwardFlight.departureAirportInfo.location;
    }, // eo function get_ServicesBookingnoDepArprtNameOutuward()

    /***************************************************************************
    * get_ServicesBookingnoDesArprtNameOutward()
    *
    * Desc: Return .. Apt Name, Destination, Outward
    * Note:
    *
    */
    get_ServicesBookingnoDesArprtNameOutward: function get_ServicesBookingnoDesArprtNameOutward(state) {

        return state.servicesBookingnoSearchResults[0].outwardFlight.destinationAirportInfo.location;
    }, // eo function  get_ServicesBookingnoDesArprtNameOutward()

    /***************************************************************************
    * get_ServicesBookingnoDepArprtNameReturn()
    *
    * Desc: Return .. Apt Name, Departure, Return
    * Note:
    *
    */
    get_ServicesBookingnoDepArprtNameReturn: function get_ServicesBookingnoDepArprtNameReturn(state) {

        return state.servicesBookingnoSearchResults[0].returnFlight.departureAirportInfo.location;
    }, // eo function get_ServicesBookingnoDepArprtNameReturn()

    /***************************************************************************
    * get_ServicesBookingnoDesArprtNameReturn()
    *
    * Desc: Return .. Apt Name, Destination, Return
    * Note:
    *
    */
    get_ServicesBookingnoDesArprtNameReturn: function get_ServicesBookingnoDesArprtNameReturn(state) {

        return state.servicesBookingnoSearchResults[0].returnFlight.destinationAirportInfo.location;
    }, // eo function get_ServicesBookingnoDesArprtNameOutward()


    /***************************************************************************
    * get_ServicesBookingnoServicesPerPax()
    *
    * Desc: Return already booked Services of Pax.
    * Note: Getter with Payload!
    *
    */
    get_ServicesBookingnoServicesPerPax: function get_ServicesBookingnoServicesPerPax(state) {
        return function (payload) {

            var paxSrvcsList = [];

            state.servicesBookingnoSearchResults[0].passengers.forEach(function (pax, i) {
                if (pax.id_pax_own === payload.id_pax) {
                    if (payload.type === 'outward') {
                        paxSrvcsList = pax.outboundServices;
                    }
                    if (payload.type === 'return') {
                        paxSrvcsList = pax.inboundServices;
                    }
                }
            });

            return paxSrvcsList;
        };
    }, // eo function get_ServicesBookingnoServicesPerPax()


    /***************************************************************************
    * Getters: Control Flags (Bookingno)
    ***************************************************************************/
    /***************************************************************************
    * get_FlagServicesShowBookingnoSearchResults()
    *
    * Desc: Return Flag: 'Show Bookingno Overview Section'
    * Note:
    *
    */
    get_FlagServicesShowBookingnoSearchResults: function get_FlagServicesShowBookingnoSearchResults(state) {

        return state.flagServicesShowBookingnoSearchResults;
    } // eo function get_FlagServicesShowBookingnoSearchResults()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: State Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_set_stateResetServices()
    *
    * Desc: Reset State In Context:Services.
    * Note:
    * TODO: Reset more.
    *
    */
    mut_set_stateResetServices: function mut_set_stateResetServices(context, payload) {

        state.servicesBookingOptionsResults = null;

        // >>> 'Bookable Services Results' --------------------
        state.servicesBookableServicesOutwardResults = null;
        state.servicesBookableServicesReturnResults = null;
        // >>> ------------------------------------------------
        state.servicesSrvcsMealExistsOnOut = false;
        state.servicesSrvcsMealExistsOnRet = false;
        state.servicesSrvcsServiceExistsOnOut = false;
        state.servicesSrvcsServiceExistsOnRet = false;
        state.servicesSrvcsPetsExistsOnOut = false;
        state.servicesSrvcsPetsExistsOnRet = false;
        state.servicesSrvcsSportbagExistsOnOut = false;
        state.servicesSrvcsSportbagExistsOnRet = false;
        state.servicesSrvcsBaggageExistsOnOut = false;
        state.servicesSrvcsBaggageExistsOnRet = false;
        state.servicesSrvcsMedicalExistsOnOut = false;
        state.servicesSrvcsMedicalExistsOnRet = false;
        // >>> ------------------------------------------------
        state.servicesValidatePassengersObject = null;
        state.servicesValidatePassengersObjectClone = null;

        state.servicesProcessBookingObject = null;
        state.servicesProcessBookingResults = null;

        // >>> 'Bookingno' ------------------------------------
        // state.flagServicesBookingnoLoginIsReadyForLogin =  false;
        // state.servicesUsersSearchDataBookingno =  null;
        // state.servicesBookingnoSearchResults =  {};
        // >>> Flag: Show Section 'Bookingno Overview' --------
        // state.flagServicesShowBookingnoSearchResults =  false;
    }, // eof mut_set_stateResetServices()


    /***************************************************************************
    * Mutations: 'Are we in 'Services Bookingno' Mode?
    ***************************************************************************/
    /***************************************************************************
    * mut_set_areWeInServicesBookingNoMode()
    *
    * Desc: 'Are we in 'Services Bookingno' Mode?
    * Note:
    *
    */
    mut_set_areWeInServicesBookingNoMode: function mut_set_areWeInServicesBookingNoMode(context, payload) {

        state.areWeInServicesBookingNoMode = payload;
    }, // eof mut_set_areWeInServicesBookingNoMode()


    /***************************************************************************
    * Mutations: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * mut_setServicesBookableServicesResults()
    *
    * Desc: SET State Call::'/registration/bookingoptions' Object/Results.
    * Note: Scan for different Services Categories/Types.
    * Note: I'm checking: 'meal', 'service', 'pets', 'sportbag', 'baggage', 'medical'.
    *
    */
    mut_setServicesBookableServicesResults: function mut_setServicesBookableServicesResults(state, payload) {

        if (payload.type === 'outward') {

            // >>> Save calls response ----------
            state.servicesBookableServicesOutwardResults = payload.data;

            // >>> State of Srvcs ---------------
            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'meal';
            }) !== undefined) {
                // 'meal'
                state.servicesSrvcsMealExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'service';
            }) !== undefined) {
                // 'service'
                state.servicesSrvcsServiceExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'pets';
            }) !== undefined) {
                // 'pets'
                state.servicesSrvcsPetsExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'sportbag';
            }) !== undefined) {
                // 'sportbag'
                state.servicesSrvcsSportbagExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'baggage';
            }) !== undefined) {
                // 'baggage'
                state.servicesSrvcsBaggageExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'medical';
            }) !== undefined) {
                // 'medical'
                state.servicesSrvcsMedicalExistsOnOut = true;
            }
        }

        if (payload.type === 'return') {
            state.servicesBookableServicesReturnResults = payload.data;

            // >>> State of Srvcs ---------------
            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'meal';
            }) !== undefined) {
                // 'meal'
                state.servicesSrvcsMealExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'service';
            }) !== undefined) {
                // 'service'
                state.servicesSrvcsServiceExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'pets';
            }) !== undefined) {
                // 'pets'
                state.servicesSrvcsPetsExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'sportbag';
            }) !== undefined) {
                // 'sportbag'
                state.servicesSrvcsSportbagExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'baggage';
            }) !== undefined) {
                // 'baggage'
                state.servicesSrvcsBaggageExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(function (srvcs) {
                return srvcs.categoryCode === 'medical';
            }) !== undefined) {
                // 'baggage'
                state.servicesSrvcsMedicalExistsOnRet = true;
            }
        }
    }, // eof mut_setServicesBookableServicesResults()


    /***************************************************************************
    * mut_setServicesValidatePassengersObject()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger).
    * Note: Saves the Params itself.
    *
    */
    mut_setServicesValidatePassengersObject: function mut_setServicesValidatePassengersObject(state, payload) {

        state.servicesValidatePassengersObject = payload;
    }, // eof mut_setServicesValidatePassengersObject()


    /***************************************************************************
    * mut_setServicesValidatePassengersObjectClone()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger). Clone.
    * Note: Saves the Params itself.
    *
    */
    mut_setServicesValidatePassengersObjectClone: function mut_setServicesValidatePassengersObjectClone(state, payload) {

        state.servicesValidatePassengersObjectClone = payload;
    }, // eof mut_setServicesValidatePassengersObjectClone()


    /***************************************************************************
    * mut_setServicesProcessBookingObject()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger).
    * Note: Saves the Params itself.
    *
    */
    mut_setServicesProcessBookingObject: function mut_setServicesProcessBookingObject(state, payload) {

        state.servicesProcessBookingObject = payload;
    }, // eof mut_setServicesProcessBookingObject()


    /***************************************************************************
    * mut_setServicesProcessBookingResults()
    *
    * Desc: SET State 'Calls Object RESPONSE' (process).
    * Note: Saves the Params itself.
    *
    */
    mut_setServicesProcessBookingResults: function mut_setServicesProcessBookingResults(state, payload) {

        state.servicesProcessBookingResults = payload;
    }, // eof mut_setServicesProcessBookingResults()


    /***************************************************************************
    * mut_setServicesUpdateValidateObjectViaDeleteSrvcs()
    *
    * Desc:
    * Note:
    *
    */
    mut_setServicesUpdateValidateObjectViaDeleteSrvcs: function mut_setServicesUpdateValidateObjectViaDeleteSrvcs(state, payload) {

        var servicesValidatePassengersObject_Clone = _extends({}, state.servicesValidatePassengersObject); // copy


        // >>> A: 'bookingValidatePassengersObject' -------
        if (Object.keys(servicesValidatePassengersObject_Clone.length !== 0)) {
            // got Data (before validate!)?
            if (servicesValidatePassengersObject_Clone && servicesValidatePassengersObject_Clone.passengers) {
                for (var i = 0; i < servicesValidatePassengersObject_Clone.passengers.length; i++) {
                    if (parseFloat(servicesValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.payload.id_pax, 10)) {

                        for (var x = 0; x < servicesValidatePassengersObject_Clone.passengers[i].services.length; x++) {
                            if (servicesValidatePassengersObject_Clone.passengers[i].services[x].code === payload.payload.srvcs.code) {
                                if (payload.payload.type === 'outward') {
                                    if (servicesValidatePassengersObject_Clone.passengers[i].services[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedOutward) {
                                        servicesValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                    }
                                }

                                if (payload.payload.type === 'return') {
                                    if (servicesValidatePassengersObject_Clone.passengers[i].services[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedReturn) {
                                        servicesValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        state.servicesValidatePassengersObject = servicesValidatePassengersObject_Clone;
    }, // eo function mut_setServicesUpdateValidateObjectViaDeleteSrvcs()


    /***************************************************************************
    * mut_setServicesUpdateValidateObjectViaDeleteSeat()
    *
    * Desc:
    * Note:
    *
    */
    mut_setServicesUpdateValidateObjectViaDeleteSeat: function mut_setServicesUpdateValidateObjectViaDeleteSeat(state, payload) {

        var servicesValidatePassengersObject_Clone = _extends({}, state.servicesValidatePassengersObject); // copy


        // >>> A: 'bookingValidatePassengersObject' -------
        if (Object.keys(servicesValidatePassengersObject_Clone).length !== 0) {
            // got Data (before validate!)?
            if (servicesValidatePassengersObject_Clone && servicesValidatePassengersObject_Clone.passengers) {
                for (var i = 0; i < servicesValidatePassengersObject_Clone.passengers.length; i++) {
                    if (parseFloat(servicesValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.payload.id_pax, 10)) {
                        for (var x = 0; x < servicesValidatePassengersObject_Clone.passengers[i].seatServices.length; x++) {
                            if (payload.payload.type === 'outward') {
                                if (servicesValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedOutward) {
                                    servicesValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                                }
                            }

                            if (payload.payload.type === 'return') {
                                if (servicesValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedReturn) {
                                    servicesValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                                }
                            }
                        }
                    }
                }
            }
        }

        state.servicesValidatePassengersObject = servicesValidatePassengersObject_Clone;
    }, // eo function mut_setServicesUpdateValidateObjectViaDeleteSeat()


    /***************************************************************************
    * Mutations: 'Bookingno'
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagServicesBookingnoLoginIsReadyForLogin()
    *
    * Desc: SET State 'Bookingno is ready for Login?' Boolean.
    * Note:
    *
    */
    mut_FlagServicesBookingnoLoginIsReadyForLogin: function mut_FlagServicesBookingnoLoginIsReadyForLogin(state, payload) {

        state.flagServicesBookingnoLoginIsReadyForLogin = payload;
    }, // eof mut_FlagServicesBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * mut_setServicesUsersSearchDataBookingno()
    *
    * Desc: ACTION 'SET Users Search Data Bookingno'.
    * Note:
    *
    */
    mut_setServicesUsersSearchDataBookingno: function mut_setServicesUsersSearchDataBookingno(state, payload) {

        state.servicesUsersSearchDataBookingno = payload;
    }, // eof mut_setServicesUsersSearchDataBookingno()

    /***************************************************************************
    * mut_setServicesBookingnoSearchResults()
    *
    * Desc: ACTION 'SET Bookingno Search Results '.
    * Note: Ticket:#395, 'If we have only a Return ..'.
    *
    */
    mut_setServicesBookingnoSearchResults: function mut_setServicesBookingnoSearchResults(state, payload) {

        if (payload[0].outwardFlight === undefined || payload[0].outwardFlight === null) {
            payload[0].outwardFlight = payload[0].returnFlight; // a) FlightObject twist
            delete payload[0].returnFlight;

            payload[0].passengers.forEach(function (item, i) {
                // b) Services twist
                item.outboundServices = item.inboundServices;
                item.inboundServices = [];
            });
        }

        state.servicesBookingnoSearchResults = payload;
    }, // eof mut_setServicesBookingnoSearchResults()


    /***************************************************************************
    * Mutations: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagServicesShowBookingnoSearchResults()
    *
    * Desc: SET State/Flag 'Show Bookinno Overview Section'
    * Note: CONTROL FLAG
    *
    */
    mut_FlagServicesShowBookingnoSearchResults: function mut_FlagServicesShowBookingnoSearchResults(state, payload) {

        state.flagServicesShowBookingnoSearchResults = payload;
    }, // eof mut_FlagServicesShowBookingnoSearchResults()


    /***************************************************************************
    * mut_Flag_bookableServicesCallRetDidRun()
    *
    * Desc: SET State/Flag 'bookableServicesCallRetDidRun'
    * Note: CONTROL FLAG
    *
    */
    mut_Flag_bookableServicesCallRetDidRun: function mut_Flag_bookableServicesCallRetDidRun(state, payload) {

        state.bookableServicesCallRetDidRun = payload;
    }, // eof mut_Flag_bookableServicesCallRetDidRun()


    /***************************************************************************
    * Mutations: 'Calls', (Shared: Services, Bookingno)
    ***************************************************************************/
    /***************************************************************************
    * mut_setServicesBookingOptionsResults()
    *
    * Desc:
    * Note:
    *
    */
    mut_setServicesBookingOptionsResults: function mut_setServicesBookingOptionsResults(state, payload) {

        state.servicesBookingOptionsResults = payload;
    } // eo function mut_setServicesBookingOptionsResults()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: State Reset
    ***************************************************************************/
    /***************************************************************************
    * actn_set_stateReset()
    *
    * Desc: Reset States (In Services & Booking).
    * Note:
    * Note: [WATCHHOW] we reset in Context:Booking.
    *
    */
    actn_set_stateReset: function actn_set_stateReset(context, payload) {

        if (payload === 'booking') {
            context.commit('mut_set_stateResetBooking', payload, { root: true }); // reset in booking state context
        }

        if (payload === 'services') {
            context.commit('mut_set_stateResetServices'); // reset in services state context
        }

        if (payload === 'rebooking') {
            context.commit('mut_set_stateResetRebooking', payload, { root: true }); // reset in rebooking state context
        }
    }, // eof actn_set_stateReset()


    /***************************************************************************
    * Actions: 'Are we in 'Services Bookingno' Mode?
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesBookableServicesResults()
    *
    * Desc: 'Are we in 'Services Bookingno' Mode?
    * Note:
    *
    */
    actn_set_areWeInServicesBookingNoMode: function actn_set_areWeInServicesBookingNoMode(context, payload) {

        context.commit('mut_set_areWeInServicesBookingNoMode', payload);
    }, // eof actn_set_areWeInServicesBookingNoMode()


    /***************************************************************************
    * Actions: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesBookableServicesResults()
    *
    * Desc: ACTION 'SET Search Results'.
    * Note: Entire Response of Call::'/service/bookableservices'.
    *
    */
    actn_setServicesBookableServicesResults: function actn_setServicesBookableServicesResults(context, payload) {

        context.commit('mut_setServicesBookableServicesResults', payload);
    }, // eof actn_setServicesBookableServicesResults()


    /***************************************************************************
    * actn_setServicesValidatePassengersObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger).
    * Note:
    *
    */
    actn_setServicesValidatePassengersObject: function actn_setServicesValidatePassengersObject(context, payload) {

        context.commit('mut_setServicesValidatePassengersObject', payload); // calling mutation
    }, // eof actn_setServicesValidatePassengersObject()


    /***************************************************************************
    * actn_setServicesValidatePassengersObjectClone()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger). Clone.
    * Note:
    *
    */
    actn_setServicesValidatePassengersObjectClone: function actn_setServicesValidatePassengersObjectClone(context, payload) {

        context.commit('mut_setServicesValidatePassengersObjectClone', payload); // calling mutation
    }, // eof actn_setServicesValidatePassengersObjectClone()


    /***************************************************************************
    * actn_setServicesUpdateValidateObjectViaDeleteSrvcs()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger).
    * Note:
    *
    */
    actn_setServicesUpdateValidateObjectViaDeleteSrvcs: function actn_setServicesUpdateValidateObjectViaDeleteSrvcs(context, payload) {

        context.commit('mut_setServicesUpdateValidateObjectViaDeleteSrvcs', { payload: payload, context: context }); // calling mutation
    }, // eof actn_setServicesUpdateValidateObjectViaDeleteSrvcs()


    /***************************************************************************
    * actn_setServicesUpdateValidateObjectViaDeleteSeat()
    *
    * Desc:
    * Note:
    *
    */
    actn_setServicesUpdateValidateObjectViaDeleteSeat: function actn_setServicesUpdateValidateObjectViaDeleteSeat(context, payload) {

        context.commit('mut_setServicesUpdateValidateObjectViaDeleteSeat', { payload: payload, context: context }); // calling mutation
    }, // eof actn_setServicesUpdateValidateObjectViaDeleteSeat()


    /***************************************************************************
    * Actions: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesProcessBookingObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (process).
    * Note:
    *
    */
    actn_setServicesProcessBookingObject: function actn_setServicesProcessBookingObject(context, payload) {

        context.commit('mut_setServicesProcessBookingObject', payload); // calling mutation
    }, // eof actn_setServicesProcessBookingObject()


    /*************************************************************************** 'Version 2 is Tmp only'
    * Call::'/registration/newspecials2/'
    *
    * Desc: (Call) - Process Services ('registrationNewSpecials').
    * Note: THIS IS USING 'processBooking2'. An enhanced Copy of Original.
    * Note:
    *
    */
    actn_call_registrationNewSpecials: function actn_call_registrationNewSpecials(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/registration/newspecials2/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    // >>> ----------------------------
                    if (response.data.status !== 'KO') {
                        context.commit('mut_setServicesProcessBookingResults', response.data); // save ...
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshowbookingsconfirmation'); // emit .. 'ready to push 'confirmation' (original)
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshowbookingsconfirmationoncheckout', response.data); // emit .. 'ready to push 'confirmation' (checkout)
                    }

                    // >>> ----------------------------
                    if (response.data.status === 'KO') {
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                            message: response.data.errors[0].errorMessage
                        });
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_registrationNewSpecials()


    /***************************************************************************
    * Actions: 'Bookingno'
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesUsersSearchDataBookingno()
    *
    * Desc: ACTION 'SET Users Search Data Bookingno'.
    * Note:
    *
    */
    actn_setServicesUsersSearchDataBookingno: function actn_setServicesUsersSearchDataBookingno(context, payload) {

        context.commit('mut_setServicesUsersSearchDataBookingno', payload); // calling mutation
    }, // eo function actn_setServicesUsersSearchDataBookingno()


    /***************************************************************************
    * actn_setServicesBookingnoSearchResults()
    *
    * Desc: ACTION 'SET Search Bookingno Results'.
    * Note:
    *
    */
    actn_setServicesBookingnoSearchResults: function actn_setServicesBookingnoSearchResults(context, payload) {

        context.commit('mut_setServicesBookingnoSearchResults', payload); // calling mutation
    }, // eo function actn_setServicesBookingnoSearchResults()


    /***************************************************************************
    * Actions: 'Bookingno', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagServicesBookingnoLoginIsReadyForLogin()
    *
    * Desc: ACTION 'SET Flag: Bookingno is ready for Login'.
    * Note:
    *
    */
    actn_FlagServicesBookingnoLoginIsReadyForLogin: function actn_FlagServicesBookingnoLoginIsReadyForLogin(context, payload) {

        context.commit('mut_FlagServicesBookingnoLoginIsReadyForLogin', payload); // calling mutation
    }, // eo function actn_FlagServicesBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * actn_FlagServicesShowBookingnoSearchResults()
    *
    * Desc: ACTION 'Show Bookinno Overview Section'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagServicesShowBookingnoSearchResults: function actn_FlagServicesShowBookingnoSearchResults(context, payload) {

        context.commit('mut_FlagServicesShowBookingnoSearchResults', payload); // calling mutation
    }, // eo function actn_FlagServicesShowBookingnoSearchResults()


    /***************************************************************************
    * actn_Flag_bookableServicesCallRetDidRun()
    *
    * Desc: ACTION 'SET Flag: '.
    * Note: CONTROL FLAG
    *
    */
    actn_Flag_bookableServicesCallRetDidRun: function actn_Flag_bookableServicesCallRetDidRun(context, payload) {

        context.commit('mut_Flag_bookableServicesCallRetDidRun', payload); // calling mutation
    }, // eo function actn_Flag_bookableServicesCallRetDidRun()


    /***************************************************************************
    * Actions: 'Calls', (Shared: Services, Bookingno, Flights)
    ***************************************************************************/
    /***************************************************************************
    * Call::'/registration/overview/'
    *
    * Desc: (Call) - Getting original Booking Data via Bookingno.
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_listOriginalBooking: function actn_call_listOriginalBooking(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/registration/overview/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshoworiginalbooking'); // emit .. 'ready to push 'passengers''
                    context.commit('mut_setServicesBookingnoSearchResults', response.data);
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_listOriginalBooking()


    /***************************************************************************
    * Call::'/registration/bookingoptions/'
    *
    * Desc: (Call) - 'Get Bookingoptions'.
    * Note: Shared: 'Bookingno', 'Services'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_registrationBookingoptions: function actn_call_registrationBookingoptions(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/registration/bookingoptions/', payload).then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_setServicesBookingOptionsResults', response.data);
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_registrationBookingoptions()


    /***************************************************************************
    * Call::'/service/bookableservices/{idFlight}/{tktClass}'
    *
    * Desc: (Call) - 'Get bookable Services'.
    * Note: Shared: 'Bookingno'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: NEW: Using 'eventBus' to communicate.
    * Note: [WATCHHOW] Calling Actions from Actions.
    * Note: [WATCHHOW] Setting local State.
    *
    */
    actn_call_bookableServices: function actn_call_bookableServices(context, payload) {

        var hdrs = '',
            result = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/service/bookableservices/' + payload.id + '/Y', '').then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    // >>> ---------------------------- save
                    context.commit('mut_setServicesBookableServicesResults', { data: response.data, type: payload.type });

                    // >>> ---------------------------- next 'out'
                    if (payload.type === 'outward') {
                        state.bookableServicesCallOutDidRun = true; // Internal Flag
                        result = response.data.bookableServicesRS.services.findIndex(function (srvcs) {
                            return srvcs.code === 'SEAT';
                        });

                        if (result !== -1) {
                            // >>> Got Seats ...
                            state.gotSeatOnOut = true; // Internal Flag
                            context.commit("mut_setBookingSrvcsSeatExistOnOut", true, { root: true }); // set in booking state context
                            context.dispatch("actn_call_getSeatReservationLockingCode", { type: 'out', id: payload.id });
                        }
                    }

                    // >>> ---------------------------- next 'ret'
                    if (payload.type === 'return') {
                        state.bookableServicesCallRetDidRun = true; // Internal Flag
                        result = response.data.bookableServicesRS.services.findIndex(function (srvcs) {
                            return srvcs.code === 'SEAT';
                        });

                        if (result !== -1) {
                            // >>> Got Seats ...
                            state.gotSeatOnRet = true; // Internal Flag
                            context.commit("mut_setBookingSrvcsSeatExistOnRet", true, { root: true }); // set in booking state context
                            context.dispatch("actn_call_getSeatReservationLockingCode", { type: 'ret', id: payload.id });
                        }
                    }

                    // >>> ---------------------------- all done?
                    if (state.gotSeatOnOut === false && state.gotSeatOnRet === false && state.bookableServicesCallOutDidRun === true && state.bookableServicesCallRetDidRun === true) {
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();

                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytopushpassengers'); // emit .. 'ready to push 'passengers''
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytopushpassengersnotbookingno'); // emit .. 'ready to push 'passengers''

                        state.bookableServicesCallOutDidRun = false; // reset
                        state.bookableServicesCallRetDidRun = false;
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_bookableServices()


    /***************************************************************************
    * Call::'/bookingapidev/seatplan/lock/67082/Y' (e.g.)
    *
    * Desc: (Call) - et Lockingcode for Service 'Seat'.
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_getSeatReservationLockingCode: function actn_call_getSeatReservationLockingCode(context, payload) {

        var hdrs = '',
            noSeats = 0,
            userSearchData = context.rootState.booking.bookingUsersSearchData; // from booking state


        // >>> Send Ajax Request --------------------------
        noSeats = parseFloat(userSearchData.noADT, 10) + parseFloat(userSearchData.noCHD, 10) + parseFloat(userSearchData.noINF, 10);
        state.seatplanCallCounter += 1; // Internal Counter
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/seatplan/lock/' + payload.id + '/Y/' + noSeats).then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            state.seatplanCallCounter -= 1; // Internal Counter
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_setBookingSeatReservationLockingCodeResults', { response: response.data, type: payload.type }, { root: true }); // commit into booking state
                    context.dispatch("actn_call_getSeatPlan", { code: String(response.data.seatReservationLockingCode), type: payload.type }); // next
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_getSeatReservationLockingCode()


    /***************************************************************************
    * Call::'/bookingapidev/seatplan/5792310ac5b9e90aae83d75cc1b5eb6c/'
    *
    * Desc: (Call) - Get Seatplan with Lockingcode.
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_getSeatPlan: function actn_call_getSeatPlan(context, payload) {

        var hdrs = '',
            trsnltd = '';

        // >>> Send Ajax Request --------------------------
        state.seatplanCallCounter += 1; // Internal Counter
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/seatplan/' + payload.code).then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            state.seatplanCallCounter -= 1; // Internal Counter
            if (state.seatplanCallCounter === 1 || state.seatplanCallCounter === 0) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            }
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_setBookingSeatplanResults', { response: response.data, type: payload.type }, { root: true }); // commit into booking state

                    if (state.seatplanCallCounter === 0) {
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytopushpassengers'); // emit .. 'ready to push 'passengers''
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytopushpassengersnotbookingno'); // emit .. 'ready to push 'passengers''

                        state.bookableServicesCallOutDidRun = false; // reset
                        state.bookableServicesCallRetDidRun = false;
                        state.seatplanCallCounter = 0;
                    }
                    break;
                default:
                    // 'ERROR'
                    trsnltd = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$trnsl_error_message(response.headers["air41-error"]);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: trsnltd
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_getSeatPlan()


    /***************************************************************************
    * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (PUT)
    *
    * Desc: (Call) - Lock Seat via Lockingcode + Seatno. (Attention: Method:PUT)
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_lockSeat: function actn_call_lockSeat(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/seatplan/lock_code/' + payload.lockingcode + '/' + payload.seatno, null).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_setBookingUpdateCartWithSeat', payload, { root: true }); // set in booking state context
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoforcererender', { type: payload.type }); // emit .. 'ready to push 'passengers''
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_getSeatPlan()


    /***************************************************************************
    * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (DELETE)
    *
    * Desc: (Call) - UnLock Seat via Lockingcode + Seatno.
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_unlockSeat: function actn_call_unlockSeat(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/seatplan/lock_code/' + payload.lockingcode + '/' + payload.seatno, null).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    // Delete in Cart ...
                    context.commit('mut_setBookingUpdateCartViaDeleteSeat', { id_pax: payload.id_pax, type: payload.type }, { root: true }); // set in booking state context
                    // Lock ...
                    if (payload.lockAfterwards) {
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('lockafterwards', payload.cellId); // emit .. 'ready to push 'passengers''
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    } // eo function actn_call_unlockSeat()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
/*
 * rebooking.js
 *
 * Description: Holds 'Stores' Logic for Module:'Rebooking'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> 'Bookingno for Rebooking' ----------------------
    flagRebookingBookingnoLoginIsReadyForLogin: false, // 'Bookingno Login' ready?
    flagRebookingShowBookingnoSearchResults: false, // 'Rebooking Get Booking' done

    rebookingUsersSearchDataBookingno: null, // User Input
    rebookingGetBookingResults: {}, // SearchResults (Bookingno Rebooking)

    rebookingAllPaxCheckboxClicked: [],
    rebookingIdTicketOutwards: [],
    rebookingIdTicketReturn: [],

    rebookingUsersSearchDataFlightSearch: null, // User Input for Call
    rebookingFlightSearchResults: {}, // Results (Rebooking Flights)

    rebookingFlightIdSelectedOutward: null,
    rebookingFlightIdSelectedReturn: null,
    rebookingPriceIdSelectedOutward: null,
    rebookingPriceIdSelectedReturn: null,
    flagRebookingOutwardFlightSelected: false,
    flagRebookingReturnFlightSelected: false,

    rebookingUsersSearchDataGetRebookingKey: null, // User Input for Call
    rebookingGetRebookingKeyResults: {}, // Results (GetRebookingKey)

    rebookingUsersSearchDataProcessrebooking: null, // User Input for Call
    rebookingProcessRebookingResults: {} // Results (processRebooking)

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: 'Bookingno Rebooking', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * get_FlagRebookingBookingnoLoginIsReadyForLogin()
    *
    * Desc: Return Flag: 'Bookingno Rebooking is ready for Login?'
    * Note:
    *
    */
    get_FlagRebookingBookingnoLoginIsReadyForLogin: function get_FlagRebookingBookingnoLoginIsReadyForLogin(state) {

        return state.flagRebookingBookingnoLoginIsReadyForLogin;
    }, // eo function get_FlagRebookingBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * get_FlagRebookingShowBookingnoSearchResults()
    *
    * Desc: Return Flag: 'Show Bookingno Rebooking Overview Section'
    * Note:
    *
    */
    get_FlagRebookingShowBookingnoSearchResults: function get_FlagRebookingShowBookingnoSearchResults(state) {

        return state.flagRebookingShowBookingnoSearchResults;
    }, // eo function get_FlagRebookingShowBookingnoSearchResults()


    /***************************************************************************
    * Getters: 'Bookingno Rebooking'
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataBookingno()
    *
    * Desc: Returns entire 'Users Search Data'.
    * Note:
    *
    */
    get_RebookingUsersSearchDataBookingno: function get_RebookingUsersSearchDataBookingno(state) {

        return state.rebookingUsersSearchDataBookingno;
    }, // eof get_RebookingUsersSearchDataBookingno()


    /***************************************************************************
    * get_RebookingGetBookingResults()
    *
    * Desc: Returns entire 'getbooking' Result.
    * Note:
    *
    */
    get_RebookingGetBookingResults: function get_RebookingGetBookingResults(state) {

        return state.rebookingGetBookingResults;
    }, // eof get_RebookingGetBookingResults()


    /***************************************************************************
    * get_RebookingTickets()
    *
    * Desc: Returns Pax List with its Services.
    * Note: payload: { idFlight: flight.idFlight, whichCall: 'getbooking' }
    * Note: Possible whichCall(s): 'getbooking', 'getrebookingkey'
    *
    */
    get_RebookingTickets: function get_RebookingTickets(state) {
        return function (payload) {

            var paxSrvcsList = [];

            // >>> Tickets from Call: 'getbooking' ------------
            if (payload.whichCall === 'getbooking') {
                state.rebookingGetBookingResults.tickets.forEach(function (ticket, i) {
                    if (ticket.idFlight === payload.idFlight) {
                        state.rebookingGetBookingResults.passengers.forEach(function (pax, i) {
                            if (ticket.idPax === pax.idPax) {
                                paxSrvcsList.push({
                                    pax: pax,
                                    ticket: ticket
                                });
                            }
                        });
                    }
                });
            }

            // >>> Tickets from Call: 'getrebookingkey' ------------
            if (payload.whichCall === 'getrebookingkey') {
                state.rebookingGetRebookingKeyResults.tickets.forEach(function (ticket, i) {
                    if (ticket.idFlight === payload.idFlight) {
                        state.rebookingGetRebookingKeyResults.passengers.forEach(function (pax, i) {
                            if (ticket.idPax === pax.idPax) {
                                paxSrvcsList.push({
                                    pax: pax,
                                    ticket: ticket
                                });
                            }
                        });
                    }
                });
            }

            return paxSrvcsList;
        };
    }, // eo function get_RebookingTickets()


    /***************************************************************************
    * get_GotFlightsToRebook()
    *
    * Desc: Returns
    * Note: payload: { flightdirection: flightdirection' }
    * Note:
    *
    */
    get_GotFlightsToRebook: function get_GotFlightsToRebook(state) {
        return function (payload) {

            var gotFlightsToRebook = false;

            // >>> Tickets from Call: 'getbooking' ------------
            if (payload.flightdirection === 'outward') {
                state.rebookingGetBookingResults.outwardFlights.forEach(function (flight, i) {
                    if (flight.rebookable === true) {
                        gotFlightsToRebook = true;
                    }
                });
            }

            if (payload.flightdirection === 'return') {
                state.rebookingGetBookingResults.inboundFlights.forEach(function (flight, i) {
                    if (flight.rebookable === true) {
                        gotFlightsToRebook = true;
                    }
                });
            }

            return gotFlightsToRebook;
        };
    }, // eo function get_GotFlightsToRebook()


    /***************************************************************************
    * getRebookingOriginalBookingHasOutwardFlight()
    *
    * Desc: Return if original Booking has an 'Outward Flight'?
    * Note:
    *
    */
    getRebookingOriginalBookingHasOutwardFlight: function getRebookingOriginalBookingHasOutwardFlight(state) {

        var outwardFlightInOriginalBooking = false;

        if (state.rebookingGetBookingResults.outwardFlights.length > 0) {
            outwardFlightInOriginalBooking = true;
        } else {
            outwardFlightInOriginalBooking = false;
        }

        return outwardFlightInOriginalBooking;
    }, // eof getRebookingOriginalBookingHasOutwardFlight()


    /***************************************************************************
    * getRebookingOriginalBookingHasReturnFlight()
    *
    * Desc: Return if original Booking has a 'Inbound Flight'?
    * Note:
    *
    */
    getRebookingOriginalBookingHasReturnFlight: function getRebookingOriginalBookingHasReturnFlight(state) {

        var returnFlightInOriginalBooking = false;

        if (state.rebookingGetBookingResults.inboundFlights.length > 0) {
            returnFlightInOriginalBooking = true;
        } else {
            returnFlightInOriginalBooking = false;
        }

        return returnFlightInOriginalBooking;
    }, // eof getRebookingOriginalBookingHasReturnFlight()


    /***************************************************************************
    * getRebookingOriginalBookingRebookingFee()
    *
    * Desc: Return 'rebookingFee' from original Booking.
    * Note:
    *
    */
    getRebookingOriginalBookingRebookingFee: function getRebookingOriginalBookingRebookingFee(state) {

        return Number(state.rebookingGetBookingResults.rebookingFee);
    }, // eof getRebookingOriginalBookingRebookingFee()


    /***************************************************************************
    * getRebookingOriginalBookingHasInfant()
    *
    * Desc: Return 'has Infant' from original Booking via Pax.
    * Note:
    *
    */
    getRebookingOriginalBookingHasInfant: function getRebookingOriginalBookingHasInfant(state) {
        return function (payload) {

            var hasInfant = false;

            state.rebookingGetBookingResults.tickets.forEach(function (ticket, i) {
                if (+ticket.idPax === +payload.idPax && +ticket.idFlight === +payload.idFlight) {
                    if (ticket.infantServices.length > 0) {
                        hasInfant = true;
                    }
                }
            });

            return hasInfant;
        };
    }, // eof getRebookingOriginalBookingHasInfant()


    /***************************************************************************
    * get_RebookingAllPaxCheckboxClicked()
    *
    * Desc: Return Array.
    * Note:
    *
    */
    get_RebookingAllPaxCheckboxClicked: function get_RebookingAllPaxCheckboxClicked(state) {

        return state.rebookingAllPaxCheckboxClicked;
    }, // eof get_RebookingAllPaxCheckboxClicked()


    /***************************************************************************
    * getRebookingIdTicketOutwards()
    *
    * Desc: Return Array.
    * Note:
    *
    */
    getRebookingIdTicketOutwards: function getRebookingIdTicketOutwards(state) {

        return state.rebookingIdTicketOutwards;
    }, // eof getRebookingIdTicketOutwards()


    /***************************************************************************
    * getRebookingIdTicketReturn()
    *
    * Desc: Return Array.
    * Note:
    *
    */
    getRebookingIdTicketReturn: function getRebookingIdTicketReturn(state) {

        return state.rebookingIdTicketReturn;
    }, // eof getRebookingIdTicketReturn()


    /***************************************************************************
    * getRebookingDepArprtName()
    *
    * Desc: Return DepArprtName.
    * Note:
    *
    */
    getRebookingDepArprtName: function getRebookingDepArprtName(state) {

        return state.rebookingGetBookingResults.outwardFlights[0].departureAirport.location;
    }, // eof getRebookingDepArprtName()


    /***************************************************************************
    * getRebookingDesArprtName()
    *
    * Desc: Return DesArprtName.
    * Note:
    *
    */
    getRebookingDesArprtName: function getRebookingDesArprtName(state) {

        return state.rebookingGetBookingResults.outwardFlights[0].destinationAirport.location;
    }, // eof getRebookingDesArprtName()


    /***************************************************************************
    * getRebookingDepArprtCode()
    *
    * Desc: Return DepArprtCode.
    * Note:
    *
    */
    getRebookingDepArprtCode: function getRebookingDepArprtCode(state) {

        return state.rebookingGetBookingResults.outwardFlights[0].departureAirport.iataCode;
    }, // eof getRebookingDepArprtCode()


    /***************************************************************************
    * getRebookingDesArprtCode()
    *
    * Desc: Return DesArprtCode.
    * Note:
    *
    */
    getRebookingDesArprtCode: function getRebookingDesArprtCode(state) {

        return state.rebookingGetBookingResults.outwardFlights[0].destinationAirport.iataCode;
    }, // eof getRebookingDesArprtCode()


    /***************************************************************************
    * Getters: RebookingFlightSearchResult
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataFlightSearch()
    *
    * Desc: Return
    * Note:
    *
    */
    get_RebookingUsersSearchDataFlightSearch: function get_RebookingUsersSearchDataFlightSearch(state) {

        return state.rebookingUsersSearchDataFlightSearch;
    }, // eof get_RebookingUsersSearchDataFlightSearch()


    /***************************************************************************
    * get_RebookingFlightSearchResults()
    *
    * Desc: Return
    * Note:
    *
    */
    get_RebookingFlightSearchResults: function get_RebookingFlightSearchResults(state) {

        return state.rebookingFlightSearchResults;
    }, // eof get_RebookingFlightSearchResults()


    /***************************************************************************
    * get_FlagRebookingOutwardFlightSelected()
    *
    * Desc: Is 'Outward Flight' selected.
    * Note:
    *
    */
    get_FlagRebookingOutwardFlightSelected: function get_FlagRebookingOutwardFlightSelected(state) {

        return state.flagRebookingOutwardFlightSelected;
    }, // eof get_FlagRebookingOutwardFlightSelected()


    /***************************************************************************
    * get_FlagRebookingReturnFlightSelected()
    *
    * Desc: Is 'Return Flight' selected.
    * Note:
    *
    */
    get_FlagRebookingReturnFlightSelected: function get_FlagRebookingReturnFlightSelected(state) {

        return state.flagRebookingReturnFlightSelected;
    }, // eof get_FlagRebookingReturnFlightSelected()


    /***************************************************************************
    * get_RebookingFlightIdSelectedOutward()
    *
    * Desc: Returns Selected Outward Flight Id.
    * Note:
    *
    */
    get_RebookingFlightIdSelectedOutward: function get_RebookingFlightIdSelectedOutward(state) {

        return state.rebookingFlightIdSelectedOutward;
    }, // eof get_RebookingFlightIdSelectedOutward()


    /***************************************************************************
    * get_RebookingFlightIdSelectedReturn()
    *
    * Desc: Returns Selected Return Flight Id.
    * Note:
    *
    */
    get_RebookingFlightIdSelectedReturn: function get_RebookingFlightIdSelectedReturn(state) {

        return state.rebookingFlightIdSelectedReturn;
    }, // eof get_RebookingFlightIdSelectedReturn()


    /***************************************************************************
    * get_RebookingPriceIdSelectedOutward()
    *
    * Desc: Returns Selected Outward Flight Price Id.
    * Note:
    *
    */
    get_RebookingPriceIdSelectedOutward: function get_RebookingPriceIdSelectedOutward(state) {

        return state.rebookingPriceIdSelectedOutward;
    }, // eof get_RebookingPriceIdSelectedOutward()


    /***************************************************************************
    * get_RebookingPriceIdSelectedReturn()
    *
    * Desc: Returns Selected Return Flight Price Id.
    * Note:
    *
    */
    get_RebookingPriceIdSelectedReturn: function get_RebookingPriceIdSelectedReturn(state) {

        return state.rebookingPriceIdSelectedReturn;
    }, // eof get_RebookingPriceIdSelectedReturn()


    /***************************************************************************
    * Getters: RebookingKey
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataGetRebookingKey()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingUsersSearchDataGetRebookingKey: function get_RebookingUsersSearchDataGetRebookingKey(state, payload) {

        return state.rebookingUsersSearchDataGetRebookingKey;
    }, // eof get_RebookingUsersSearchDataGetRebookingKey()


    /***************************************************************************
    * get_RebookingGetRebookingKeyResults()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingGetRebookingKeyResults: function get_RebookingGetRebookingKeyResults(state) {

        return state.rebookingGetRebookingKeyResults;
    }, // eof get_RebookingGetRebookingKeyResults()


    /***************************************************************************
    * get_RebookingGetRebookingTicketsTotal()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingGetRebookingTicketsTotal: function get_RebookingGetRebookingTicketsTotal(state) {

        var ticketsTotal = 0;

        state.rebookingGetRebookingKeyResults.tickets.forEach(function (ticket, i) {
            ticketsTotal = parseFloat(ticketsTotal, 10) + parseFloat(ticket.rebookingTotal, 10);
        });

        return ticketsTotal;
    }, // eof get_RebookingGetRebookingTicketsTotal()


    /***************************************************************************
    * Getters: processRebookiong
    ***************************************************************************/
    /***************************************************************************
    * get_RebookingUsersSearchDataGetProcessRebooking()
    *
    * Desc:
    * Note:
    *
    */
    get_RebookingUsersSearchDataGetProcessRebooking: function get_RebookingUsersSearchDataGetProcessRebooking(state, payload) {

        return state.rebookingUsersSearchDataProcessrebooking;
    }, // eof get_RebookingUsersSearchDataGetProcessRebooking()


    /***************************************************************************
    * get_RebookingProcessRebookingResults()
    *
    * Desc: Returns
    * Note:
    *
    */
    get_RebookingProcessRebookingResults: function get_RebookingProcessRebookingResults(state, payload) {

        return state.rebookingProcessRebookingResults;
    }, // eof get_RebookingProcessRebookingResults()


    /***************************************************************************
    * get_RebookingProcessRebookingResultsTotal()
    *
    * Desc: Returns Total of all summed up Tickets.
    * Note: Funny Thing is .. 'rebookingPrice' is a the 'Total' here.
    *
    */
    get_RebookingProcessRebookingResultsTotal: function get_RebookingProcessRebookingResultsTotal(state, payload) {

        var total = 0;

        total = parseFloat(state.rebookingProcessRebookingResults.rebookingPrice, 10);

        return total;
    } // eof get_RebookingProcessRebookingResultsTotal()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: State Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_set_stateResetRebooking()
    *
    * Desc: Reset State In Context:Rebooking.
    * Note:
    *
    */
    mut_set_stateResetRebooking: function mut_set_stateResetRebooking(context, payload) {

        state.flagRebookingBookingnoLoginIsReadyForLogin = false;
    }, // eof mut_set_stateResetRebooking()


    /***************************************************************************
    * Mutations: 'Bookingno Rebooking', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagRebookingBookingnoLoginIsReadyForLogin()
    *
    * Desc: SET State 'Bookingno is ready for Login?' Boolean.
    * Note:
    *
    */
    mut_FlagRebookingBookingnoLoginIsReadyForLogin: function mut_FlagRebookingBookingnoLoginIsReadyForLogin(state, payload) {

        state.flagRebookingBookingnoLoginIsReadyForLogin = payload;
    }, // eof mut_FlagRebookingBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * mut_FlagRebookingShowBookingnoSearchResults()
    *
    * Desc: SET State/Flag 'Show Bookinno Overview Section'
    * Note: CONTROL FLAG
    *
    */
    mut_FlagRebookingShowBookingnoSearchResults: function mut_FlagRebookingShowBookingnoSearchResults(state, payload) {

        state.flagRebookingShowBookingnoSearchResults = payload;
    }, // eof mut_FlagRebookingShowBookingnoSearchResults()


    /***************************************************************************
    * Mutations: 'Bookingno Rebooking'
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataBookingno()
    *
    * Desc: 'SET Users Search Data Bookingno & Birthdate'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataBookingno: function mut_setRebookingUsersSearchDataBookingno(state, payload) {

        state.rebookingUsersSearchDataBookingno = payload;
    }, // eof mut_setRebookingUsersSearchDataBookingno()


    /***************************************************************************
    * mut_setRebookingAllPaxCheckboxClicked()
    *
    * Desc: Handle (add/remove) flightIds.
    * Note:
    *
    */
    mut_setRebookingAllPaxCheckboxClicked: function mut_setRebookingAllPaxCheckboxClicked(state, payload) {

        var flightDirection = payload.split('_');

        if (!state.rebookingAllPaxCheckboxClicked.includes(flightDirection[1])) {
            state.rebookingAllPaxCheckboxClicked.push(flightDirection[1]);
        } else {
            var index = state.rebookingAllPaxCheckboxClicked.indexOf(flightDirection[1]);
            state.rebookingAllPaxCheckboxClicked.splice(index, 1);
        }
    }, // eof mut_setRebookingAllPaxCheckboxClicked()


    /***************************************************************************
    * mut_setRebookingIdTickets()
    *
    * Desc:
    * Note:
    *
    */
    mut_setRebookingIdTickets: function mut_setRebookingIdTickets(state, payload) {

        state.rebookingIdTicketOutwards = payload.idTicketOutwards;
        state.rebookingIdTicketReturn = payload.idTicketReturn;
    }, // eof mut_setRebookingIdTickets()


    /***************************************************************************
    * Mutations: 'Calls', (Bookingno Rebooking)
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingGetBookingResults()
    *
    * Desc: SET State 'getbooking' Object. Rebooking.
    * Note: Sort here: ADT => CHD
    *
    */
    mut_setRebookingGetBookingResults: function mut_setRebookingGetBookingResults(state, payload) {

        payload.tickets.forEach(function (item, i) {
            if (item.child === true) {
                item.order = 2;
            }
            if (item.child === false) {
                item.order = 1;
            }
        });

        payload.tickets.sort(function (a, b) {
            return a.order - b.order;
        });

        state.rebookingGetBookingResults = payload;
    }, // eo function mut_setRebookingGetBookingResults()


    /***************************************************************************
    * Mutations: RebookingFlightSearchResult
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataFlightSearch()
    *
    * Desc: 'SET Users Search Data for FlightSearch'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataFlightSearch: function mut_setRebookingUsersSearchDataFlightSearch(state, payload) {

        state.rebookingUsersSearchDataFlightSearch = payload;
    }, // eof mut_setRebookingFlightSearchResults()


    /***************************************************************************
    * mut_setRebookingFlightSearchResults()
    *
    * Desc: SET State 'Flight Search Results' Object. Rebooking.
    * Note:
    *
    */
    mut_setRebookingFlightSearchResults: function mut_setRebookingFlightSearchResults(state, payload) {

        state.rebookingFlightSearchResults = payload;
    }, // eof mut_setRebookingFlightSearchResults()


    /***************************************************************************
    * mut_FlagRebookingOutwardFlightSelected()
    *
    * Desc: SET State 'Outward Flight selected' Object.
    * Note:
    *
    */
    mut_FlagRebookingOutwardFlightSelected: function mut_FlagRebookingOutwardFlightSelected(state, payload) {

        state.flagRebookingOutwardFlightSelected = payload;
    }, // eof mut_FlagRebookingOutwardFlightSelected()


    /***************************************************************************
    * mut_FlagRebookingReturnFlightSelected()
    *
    * Desc: SET State 'Return Flight selected' Object.
    * Note:
    *
    */
    mut_FlagRebookingReturnFlightSelected: function mut_FlagRebookingReturnFlightSelected(state, payload) {

        state.flagRebookingReturnFlightSelected = payload;
    }, // eof mut_FlagRebookingReturnFlightSelected()


    /***************************************************************************
    * Mutations: Update Cart
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUpdateCart()
    *
    * Desc:
    * Note: Set different States here.
    *
    */
    mut_setRebookingUpdateCart: function mut_setRebookingUpdateCart(state, payload) {

        if (payload.type === 'outward') {
            state.flagRebookingOutwardFlightSelected = true;
            state.rebookingFlightIdSelectedOutward = payload.flight.id;
            state.rebookingPriceIdSelectedOutward = payload.flight.prcs[0].id;
        }
        if (payload.type === 'return') {
            state.flagRebookingReturnFlightSelected = true;
            state.rebookingFlightIdSelectedReturn = payload.flight.id;
            state.rebookingPriceIdSelectedReturn = payload.flight.prcs[0].id;
        }
    }, // eof mut_setRebookingUpdateCart


    /***************************************************************************
    * Mutations: RebookingKey
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataGetRebookingKey()
    *
    * Desc: 'SET Users Search Data for GetRebookingKey'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataGetRebookingKey: function mut_setRebookingUsersSearchDataGetRebookingKey(state, payload) {

        state.rebookingUsersSearchDataGetRebookingKey = payload;
    }, // eof mut_setRebookingUsersSearchDataGetRebookingKey()


    /***************************************************************************
    * mut_setRebookingGetRebookingKeyResults()
    *
    * Desc: SET State 'getrebookingkey' Object. Rebooking.
    * Note: Sort here: ADT => CHD
    *
    */
    mut_setRebookingGetRebookingKeyResults: function mut_setRebookingGetRebookingKeyResults(state, payload) {

        payload.tickets.forEach(function (item, i) {
            if (item.child === true) {
                item.order = 2;
            }
            if (item.child === false) {
                item.order = 1;
            }
        });

        payload.tickets.sort(function (a, b) {
            return a.order - b.order;
        });

        state.rebookingGetRebookingKeyResults = payload;
    }, // eof mut_setRebookingGetRebookingKeyResults()


    /***************************************************************************
    * Mutations: processRebookiong
    ***************************************************************************/
    /***************************************************************************
    * mut_setRebookingUsersSearchDataProcessRebooking()
    *
    * Desc: 'SET Users Search Data for Process Rebooking'.
    * Note:
    *
    */
    mut_setRebookingUsersSearchDataProcessRebooking: function mut_setRebookingUsersSearchDataProcessRebooking(state, payload) {

        state.rebookingUsersSearchDataProcessrebooking = payload;
    }, // eof mut_setRebookingUsersSearchDataProcessRebooking()


    /***************************************************************************
    * mut_setRebookingProcessRebookingResults()
    *
    * Desc: SET State 'processrebooking' Object. Rebooking.
    * Note:
    *
    */
    mut_setRebookingProcessRebookingResults: function mut_setRebookingProcessRebookingResults(state, payload) {

        state.rebookingProcessRebookingResults = payload;
    } // eof mut_setRebookingProcessRebookingResults()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: 'Bookingno Rebooking', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagRebookingBookingnoLoginIsReadyForLogin()
    *
    * Desc: ACTION 'SET Flag: Bookingno Rebooking is ready for Login'.
    * Note:
    *
    */
    actn_FlagRebookingBookingnoLoginIsReadyForLogin: function actn_FlagRebookingBookingnoLoginIsReadyForLogin(context, payload) {

        context.commit('mut_FlagRebookingBookingnoLoginIsReadyForLogin', payload); // calling mutation
    }, // eo function actn_FlagRebookingBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * actn_FlagRebookingShowBookingnoSearchResults()
    *
    * Desc: ACTION 'Show Bookinno Rebooking Overview Section'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagRebookingShowBookingnoSearchResults: function actn_FlagRebookingShowBookingnoSearchResults(context, payload) {

        context.commit('mut_FlagRebookingShowBookingnoSearchResults', payload); // calling mutation
    }, // eo function actn_FlagRebookingShowBookingnoSearchResults()


    /***************************************************************************
    * Actions: 'Bookingno Rebooking'
    ***************************************************************************/
    /***************************************************************************
    * actn_setRebookingUsersSearchDataBookingno()
    *
    * Desc: ACTION 'SET Users Search Data Bookingno & Birthdate'.
    * Note:
    *
    */
    actn_setRebookingUsersSearchDataBookingno: function actn_setRebookingUsersSearchDataBookingno(context, payload) {

        context.commit('mut_setRebookingUsersSearchDataBookingno', payload); // calling mutation
    }, // eo function actn_setRebookingUsersSearchDataBookingno()


    /***************************************************************************
    * actn_setRebookingAllPaxCheckboxClicked()
    *
    * Desc: ACTION 'SET AllPax CheckBox was licked. Save FlightId'.
    * Note:
    *
    */
    actn_setRebookingAllPaxCheckboxClicked: function actn_setRebookingAllPaxCheckboxClicked(context, payload) {

        context.commit('mut_setRebookingAllPaxCheckboxClicked', payload); // calling mutation
    }, // eo function actn_setRebookingAllPaxCheckboxClicked()


    /***************************************************************************
    * Actions: 'Calls', Bookingno Rebooking
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rebooking/getbooking'
    *
    * Desc: (Call) - 'Get Bookingoptions'.
    * Note:
    *
    */
    actn_call_rebookingGetBooking: function actn_call_rebookingGetBooking(context, payload) {

        var hdrs = '',
            trsnltd = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/rebooking/getbooking/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshowbookingforrebooking'); // emit .. 'ready to push 'passengers''
                    context.commit('mut_setRebookingGetBookingResults', response.data);
                    break;
                default:
                    // 'ERROR'
                    trsnltd = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$trnsl_error_message(response.headers["air41-error"]);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: trsnltd
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_rebookingGetBooking()


    /***************************************************************************
    * actn_setRebookingIdTickets()
    *
    * Desc: ACTION 'SET idTickets'.
    * Note:
    *
    */
    actn_setRebookingIdTickets: function actn_setRebookingIdTickets(context, payload) {

        context.commit('mut_setRebookingIdTickets', payload); // calling mutation
    }, // eo function actn_setRebookingIdTickets()


    /***************************************************************************
    * Call::'/rebooking/listflightsforrebooking'
    *
    * Desc: (Call) - 'Get Flights for Rebooking'.
    * Note:
    *
    */
    actn_call_listFlightsForRebooking: function actn_call_listFlightsForRebooking(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        context.commit('mut_setRebookingUsersSearchDataFlightSearch', payload);

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/rebooking/listflightsforrebooking/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshowrebookingflightsearchresults'); // emit .. 'ready to push 'passengers''
                    context.commit('mut_setRebookingFlightSearchResults', response.data.listFlightsRS.flts);
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_listFlightsForRebooking()


    /***************************************************************************
    * actn_FlagRebookingOutwardFlightSelected()
    *
    * Desc: ACTION 'Outward Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagRebookingOutwardFlightSelected: function actn_FlagRebookingOutwardFlightSelected(context, payload) {

        context.commit('mut_FlagRebookingOutwardFlightSelected', payload); // calling mutation
    }, // eof actn_FlagRebookingOutwardFlightSelected()


    /***************************************************************************
    * actn_FlagRebookingReturnFlightSelected()
    *
    * Desc: ACTION 'Return Flight selected?'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagRebookingReturnFlightSelected: function actn_FlagRebookingReturnFlightSelected(context, payload) {

        context.commit('mut_FlagRebookingReturnFlightSelected', payload); // calling mutation
    }, // eof actn_FlagRebookingReturnFlightSelected()


    /***************************************************************************
    * Actions: Update Cart
    ***************************************************************************/
    /***************************************************************************
    * actn_setRebookingUpdateCart()
    *
    * Desc: ACTION 'Update Cart'.
    * Note:
    *
    */
    actn_setRebookingUpdateCart: function actn_setRebookingUpdateCart(context, payload) {

        context.commit('mut_setRebookingUpdateCart', payload); // calling mutation
    }, // eof actn_setRebookingUpdateCart()


    /***************************************************************************
    * Actions: RebookingKey
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rebooking/getrebookingkey'
    *
    * Desc: (Call) - 'Get Rebookingkey'.
    * Note: Translated Error Message.
    * Note: Special Case here: Emits Event also in Case of some special Error.
    *
    */
    actn_call_getRebookingKey: function actn_call_getRebookingKey(context, payload) {

        var hdrs = '',
            nsa = '',
            nsb = '',
            splittedMessage = '',
            trsnltd = '';

        // >>> Send Ajax Request --------------------------
        context.commit('mut_setRebookingUsersSearchDataGetRebookingKey', payload); // emit ..

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/rebooking/getrebookingkey/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshowrebookingspayment'); // emit .. 'ready to push 'payment''
                    context.commit('mut_setRebookingGetRebookingKeyResults', response.data);
                    break;
                default:
                    // 'ERROR'
                    trsnltd = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$trnsl_error_message(response.headers["air41-error"]);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: trsnltd
                    });

                    // >>> Error 120102 ? ---
                    nsa = response.headers["air41-error"].substring(1); // del 1st
                    nsb = nsa.substr(0, nsa.length - 1); // del last
                    splittedMessage = nsb.split(']['); // split
                    if (splittedMessage[0] === '120102') {
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('errorrebookingnoservicesanymore'); // emit .. 'error .. no services anymore'
                    }

                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_getRebookingKey()


    /***************************************************************************
    * Actions: processrebooking
    ***************************************************************************/
    /*************************************************************************** 'Version 2 is Tmp only'
    * Call::'/rebooking/processrebooking2'
    *
    * Desc: (Call) - 'process rebooking'.
    * Note: THIS IS USING 'processBooking2'. An enhanced Copy of Original.
    *
    */
    actn_call_processRebooking: function actn_call_processRebooking(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        context.commit('mut_setRebookingUsersSearchDataProcessRebooking', payload);

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/rebooking/processrebooking2/', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    // >>> ----------------------------
                    if (response.data.status !== 'KO') {
                        context.commit('mut_setRebookingProcessRebookingResults', response.data);
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshowrebookingsconfirmation'); // emit .. 'ready to push 'confirmation' (original)
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('readytoshowbookingsconfirmationoncheckout', response.data); // emit .. 'ready to push 'confirmation' (checkout)
                    }

                    // >>> ----------------------------
                    if (response.data.status === 'KO') {
                        __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                            message: response.data.errors[0].errorMessage
                        });
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('errorinconfirmation', response.data); // emit ... 'Error'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    } // eo function actn_call_processRebooking()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Auth'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> User -------------------------------------------
    auth_userLoggedIn: false,
    auth_user: null

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: Auth Calls
    ***************************************************************************/
    /***************************************************************************
    * get_authorizationUserdata()
    *
    * Desc: Return ... Catch up User Date from Ls.
    * Note:
    *
    */
    get_authorizationUserdata: function get_authorizationUserdata(state) {

        var localStorageUser = null,
            localStorageUserData = JSON.parse(localStorage.getItem('sdr__authorizationUserdata'));

        // >>> User in localStorage? ----------------------
        if (localStorageUserData !== null) {
            localStorageUser = JSON.parse(localStorageUserData.value);
        }

        return localStorageUser;
    }, // eo function get_authorizationUserdata()


    /***************************************************************************
    * get_authorizationHeader()
    *
    * Desc: Return ... Catch up Auth Header from Ls.
    * Note:
    *
    */
    get_authorizationHeader: function get_authorizationHeader(state) {

        var localStorageHeader = null,
            localStorageHeaderData = JSON.parse(localStorage.getItem('sdr__authorizationHeader'));

        // >>> Header in localStorage? --------------------
        if (localStorageHeaderData !== null) {
            localStorageHeader = JSON.parse(localStorageHeaderData.value);
        }

        return localStorageHeader;
    }, // eo function get_authorizationUserdata()


    /***************************************************************************
    * Getters: Flags & Co
    ***************************************************************************/
    /***************************************************************************
    * get_Flag_Auth_UserLoggedIn()
    *
    * Desc: Return ... Flag 'is User logged in?'
    * Note:
    *
    */
    get_Flag_Auth_UserLoggedIn: function get_Flag_Auth_UserLoggedIn(state) {

        return state.auth_userLoggedIn;
    } // eo function get_Flag_Auth_UserLoggedIn()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: Auth Calls
    ***************************************************************************/
    /***************************************************************************
    * mut_call_auth_login()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_auth_login: function mut_call_auth_login(state, payload) {

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].set('authorizationHeader', JSON.stringify(payload.authorizationHeader), 60 * 60 * 1000);
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].set('authorizationUserdata', JSON.stringify(payload.payload), 60 * 60 * 1000);

        state.auth_userLoggedIn = true; // kind of useless here
        state.auth_userLoggedIn = payload.payload;

        // reload page
        setTimeout(function () {
            location.reload();
        }, 700);
    }, // eo function mut_call_auth_login()


    /***************************************************************************
    * Mutations: Flags & Co
    ***************************************************************************/
    /***************************************************************************
    * mut_auth_logout()
    *
    * Desc:
    * Note:
    *
    */
    mut_auth_logout: function mut_auth_logout(state, payload) {

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].remove('authorizationHeader');
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].remove('authorizationUserdata');

        state.auth_userLoggedIn = false; // kind of useless here
        state.auth_userLoggedIn = null;

        // reload page
        setTimeout(function () {
            location.reload();
        }, 700);
    }, // eo function mut_auth_logout()


    /***************************************************************************
    * mut_set_Flag_Auth_UserLoggedIn()
    *
    * Desc:
    * Note:
    *
    */
    mut_set_Flag_Auth_UserLoggedIn: function mut_set_Flag_Auth_UserLoggedIn(state, payload) {

        state.auth_userLoggedIn = payload;
    } // eo function mut_set_Flag_Auth_UserLoggedIn()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: Auth Calls
    ***************************************************************************/
    /***************************************************************************
    * Call::'/booking/profile/login';
    *
    * Desc:
    * Note:
    * Note: Translate in Vuex here ..  via context.rootGetters.
    * Note: A 401 Error gets send as 200 with Air41-Error: [105120]
    */
    actn_call_auth_login: function actn_call_auth_login(context, payload) {

        var hdrs = '',
            trsnltd = '',
            authorizationHeader = '';

        // >>> Set Auth Header ----------------------------
        if ("authorizationHeader" in payload) {
            authorizationHeader = payload.authorizationHeader;
        }
        if (!("authorizationHeader" in payload)) {
            authorizationHeader = window.btoa(payload.email + ":" + payload.password);
        }

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/booking/profile/login", {
            withCredentials: true,
            headers: {
                "Authorization": "Basic " + authorizationHeader
            } }).then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_info({
                        message: context.rootGetters.getCurrentLocale === 'de' ? 'Willkommen zurück.' : 'Welcome back.'
                    });
                    context.commit('mut_call_auth_login', { payload: response.data, authorizationHeader: authorizationHeader });
                    break;
                default:
                    // 'ERROR'
                    trsnltd = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$trnsl_error_message(response.headers["air41-error"]);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: trsnltd
                    });
                    context.commit('actn_auth_logout');
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
            context.commit('actn_auth_logout');
        });
    }, // eo function actn_call_auth_login()


    /***************************************************************************
    * Call::'/rest/booking/profile/create';
    *
    * Desc: Call: Create an user.
    * Note:
    */
    actn_call_auth_create: function actn_call_auth_create(context, payload) {

        var hdrs = '',
            trsnltd = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/booking/profile/create', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('call_auth_userCreate_success'); // works
                    break;
                default:
                    // 'ERROR'
                    trsnltd = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$trnsl_error_message(response.headers["air41-error"]);
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: trsnltd
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_auth_create()


    /***************************************************************************
    * Call::'/rest/booking/profile/forgot';
    *
    * Desc:
    * Note:
    *
    */
    actn_call_auth_passwordReset: function actn_call_auth_passwordReset(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/booking/profile/forgot', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('call_auth_passwordReset_success'); // works

                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_auth_passwordReset()


    /***************************************************************************
    * Actions: Flags & Co
    ***************************************************************************/
    /***************************************************************************
    * actn_set_Flag_Auth_UserLoggedIn()
    *
    * Desc: ACTION: Set Flag 'User is logged in?'.
    * Note: CONTROL FLAG
    *
    */
    actn_set_Flag_Auth_UserLoggedIn: function actn_set_Flag_Auth_UserLoggedIn(context, payload) {

        context.commit('mut_set_Flag_Auth_UserLoggedIn', payload);
    }, // eo function actn_set_Flag_Auth_UserLoggedIn()


    /***************************************************************************
    * actn_auth_logout()
    *
    * Desc:
    * Note:
    *
    */
    actn_auth_logout: function actn_auth_logout(context, payload) {

        context.commit('mut_auth_logout');
    } // eo function actn_auth_logout()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Travelcenter'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> ------------------------------------------------
    travelcenter_usersbookings: [],
    travelcenter_usersbookings_filtered: [],
    travelcenter_nextBooking: null,
    travelcenter_nextFlight: null,
    // >>> ------------------------------------------------
    shared_filterSearchTravelcenterBookings_Params: null, // search/filer param
    // >>> ------------------------------------------------
    shared_getCountries: []

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: Travelcenter
    ***************************************************************************/
    /***************************************************************************
    * get_Travelcenter_UsersBookings()
    *
    * Desc:
    * Note:
    *
    */
    get_Travelcenter_UsersBookings: function get_Travelcenter_UsersBookings(state) {

        return state.travelcenter_usersbookings;
    }, // eo function get_Travelcenter_UsersBookings()


    /***************************************************************************
    * get_Travelcenter_UsersBookings_Filtered()
    *
    * Desc:
    * Note:
    *
    */
    get_Travelcenter_UsersBookings_Filtered: function get_Travelcenter_UsersBookings_Filtered(state) {

        return state.travelcenter_usersbookings_filtered;
    }, // eo function get_Travelcenter_UsersBookings_Filtered()


    /***************************************************************************
    * get_Travelcenter_UsersBookings_Length()
    *
    * Desc: Return summed up Lengths if all 'Year Arrays'.
    * Note:
    *
    */
    get_Travelcenter_UsersBookings_Length: function get_Travelcenter_UsersBookings_Length(state) {

        var summedUpLength = 0;

        Object.keys(state.travelcenter_usersbookings).forEach(function (year) {
            summedUpLength += state.travelcenter_usersbookings[year].length;
        });

        return summedUpLength;
    }, // eo function get_Travelcenter_UsersBookings_Length()


    /***************************************************************************
    * get_Travelcenter_UsersBookings()
    *
    * Desc:
    * Note:
    *
    */
    get_Travelcenter_NextFlight: function get_Travelcenter_NextFlight(state) {

        return state.travelcenter_nextFlight;
    }, // eo function get_Travelcenter_NextFlight()


    /***************************************************************************
    * Getters: Travelcenter Calls, Countries (Shared)
    ***************************************************************************/
    /***************************************************************************
    * get_Shared_Countries()
    *
    * Desc:
    * Note:
    *
    */
    get_Shared_Countries: function get_Shared_Countries(state) {

        return state.shared_getCountries;
    } // eo function get_Shared_Countries()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: Travelcenter Calls
    ***************************************************************************/
    /***************************************************************************
    * mut_call_travelcenter_updateProfile()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_travelcenter_updateProfile: function mut_call_travelcenter_updateProfile(state, payload) {

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]['ls'].set('authorizationUserdata', JSON.stringify(payload.response), 60 * 60 * 1000);
    }, // eo function mut_call_travelcenter_updateProfile()


    /***************************************************************************
    * mut_call_travelcenter_getBookingsOLd()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_travelcenter_getBookingsOLd: function mut_call_travelcenter_getBookingsOLd(state, payload) {

        var nextBooking = null,
            nextFlight = null,
            getBookings_StructuredByYear = {};

        // >>> sort every flight in every booking ---------
        payload.bookings.forEach(function (booking) {
            booking.outwardFlights.sort(function (a, b) {
                return a.departureDateTime < b.departureDateTime ? 1 : -1;
            });
            booking.inboundFlights.sort(function (a, b) {
                return a.departureDateTime < b.departureDateTime ? 1 : -1;
            });
        });

        // >>> sort complete bookings ---------------------
        payload.bookings.sort(function (a, b) {
            return a.outwardFlights[0].departureDateTime < b.outwardFlights[0].departureDateTime ? 1 : -1;
        });

        // >>> find next Booking (via next flight) --------
        payload.bookings.forEach(function (booking) {
            for (var i = 0; i < booking.outwardFlights.length; i++) {
                var flight = booking.outwardFlights[i];

                if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(flight.departureDateTime).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()()) > 0) {
                    // flug findet noch statt

                    if (nextFlight === null) {
                        nextFlight = flight;
                        continue;
                    }

                    if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(nextFlight.departureDateTime).diff(flight.departureDateTime) < 0) {
                        // flight findet VOR nextFlight statt
                        nextFlight = flight;
                        nextBooking = booking;
                    } else {
                        // flight findet NACH nextFlight statt
                        // do nothing
                    }
                }
            }

            for (var _i = 0; _i < booking.inboundFlights.length; _i++) {
                var _flight = booking.inboundFlights[_i];

                if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(_flight.departureDateTime).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()()) > 0) {
                    // flug findet noch statt

                    if (nextFlight === null) {
                        nextFlight = _flight;
                        continue;
                    }

                    if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(nextFlight.departureDateTime).diff(_flight.departureDateTime) > 0) {
                        // flight findet VOR nextFlight statt
                        nextFlight = _flight;
                        nextBooking = booking;
                    } else {
                        // flight findet NACH nextFlight statt
                        // do nothing
                    }
                }
            }
        });

        // >>> destructure by year of booking -------------
        payload.bookings.forEach(function (booking) {

            var year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(booking.outwardFlights[0].departureDateTime).get("year").toString();

            if (year in getBookings_StructuredByYear) {
                getBookings_StructuredByYear[year].push(booking);
            } else {
                getBookings_StructuredByYear[year] = [];
                getBookings_StructuredByYear[year].push(booking);
            }
        });

        // >>> set ----------------------------------------
        state.travelcenter_usersbookings = getBookings_StructuredByYear; // payload;
        state.travelcenter_usersbookings_filtered = getBookings_StructuredByYear; // payload;
        state.travelcenter_nextBooking = nextBooking;
        state.travelcenter_nextFlight = nextFlight;
    }, // eo function mut_call_travelcenter_getBookingsOLd()

    /***************************************************************************
    * mut_call_travelcenter_getBookings()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_travelcenter_getBookings: function mut_call_travelcenter_getBookings(state, payload) {

        var flight = null,
            year = null,
            nextBooking = null,
            nextFlight = null,
            getBookings_StructuredByYear = {};

        // >>> buil iso date times ------------------------
        payload.forEach(function (booking) {
            booking.departureDateTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(booking.date + ' ' + booking.departureTime, 'DD.MM.YY HH:mm').format('YYYY-MM-DDTHH:mm:ss+0000');
            booking.arrivalDateTime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(booking.date + ' ' + booking.arrivalTime, 'DD.MM.YY HH:mm').format('YYYY-MM-DDTHH:mm:ss+0000');
        });

        // >>> sort complete bookings --------------------- enough?
        payload.sort(function (a, b) {
            return a.departureDateTime > b.departureDateTime ? 1 : -1;
        });

        // >>> find next Booking (via next flight) --------
        payload.forEach(function (booking) {
            flight = booking;

            if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(flight.departureDateTime, 'YYYY-MM-DDTHH:mm:ss+0000').get("year").toString() === __WEBPACK_IMPORTED_MODULE_2_moment___default()().get("year").toString()) {
                if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(flight.departureDateTime, 'YYYY-MM-DDTHH:mm:ss+0000').diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()()) > 0) {
                    // flug findet noch statt
                    if (nextFlight === null) {
                        nextFlight = flight;
                    }

                    if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(flight.departureDateTime, 'YYYY-MM-DDTHH:mm:ss+0000').diff(nextFlight.departureDateTime) < 0) {
                        // flight findet VOR nextFlight stat
                        nextFlight = flight;
                        nextBooking = booking;
                    } else {
                        // flight findet NACH nextFlight statt
                        // do nothing
                    }
                }
            }
        });

        // >>> destructure by year of booking ------------- ok
        payload.forEach(function (booking) {

            year = __WEBPACK_IMPORTED_MODULE_2_moment___default()(booking.date, 'DD.MM.YY').get("year").toString();

            if (year in getBookings_StructuredByYear) {
                getBookings_StructuredByYear[year].push(booking);
            } else {
                getBookings_StructuredByYear[year] = [];
                getBookings_StructuredByYear[year].push(booking);
            }
        });

        // >>> set ----------------------------------------
        state.travelcenter_usersbookings = getBookings_StructuredByYear; // payload;
        state.travelcenter_usersbookings_filtered = getBookings_StructuredByYear; // payload;
        state.travelcenter_nextFlight = nextFlight;
    }, // eo function mut_call_travelcenter_getBookings()


    /***************************************************************************
    * Mutations: Travelcenter, Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * mut_set_filterSearchTravelcenterBookings()
    *
    * Desc: Set Search/Filter Terms.
    * Note: Filter right afterwards.
    *
    */
    mut_set_filterSearchTravelcenterBookings: function mut_set_filterSearchTravelcenterBookings(state, payload) {

        state.shared_filterSearchTravelcenterBookings_Params = payload.payload;
        payload.context.commit('mut_filterSearchTravelcenterBookings', payload.payload); // now filter
    }, // eo function mut_set_filterSearchTravelcenterBookings()


    /***************************************************************************
    * mut_filterSearchTravelcenterBookings()
    *
    * Desc:
    * Note: Shallow, Deep Copy.
    *
    */
    mut_filterSearchTravelcenterBookings: function mut_filterSearchTravelcenterBookings(state, payload) {

        // const gl_travelcenter_getBookings = {...state.travelcenter_usersbookings}; // copy it, shallow
        var gl_travelcenter_getBookings = JSON.parse(JSON.stringify(state.travelcenter_usersbookings)); // copy it, deep


        if (gl_travelcenter_getBookings !== null) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {

                for (var _iterator = Object.entries(gl_travelcenter_getBookings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = _slicedToArray(_ref, 2);

                    var year = _ref2[0];
                    var bookingsOfAYear = _ref2[1];


                    gl_travelcenter_getBookings[year] = bookingsOfAYear.filter(function (booking) {

                        var applyFilter = false;

                        if (booking.aptFrom.match(new RegExp(payload, 'i')) || booking.aptTo.match(new RegExp(payload, 'i')) || booking.flightNo.match(new RegExp(payload, 'i'))) {
                            applyFilter = true;
                        }

                        booking.paxes.forEach(function (pax) {
                            if (pax.bookingCode.match(new RegExp(payload, 'i'))) {
                                applyFilter = true;
                            }
                        });

                        booking.services.forEach(function (service) {
                            if (service.bookingCode.match(new RegExp(payload, 'i'))) {
                                applyFilter = true;
                            }
                        });

                        return applyFilter;
                    });

                    if (gl_travelcenter_getBookings[year].length === 0) {
                        delete gl_travelcenter_getBookings[year];
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            state.travelcenter_usersbookings_filtered = gl_travelcenter_getBookings;
        }
    }, // eo function mut_filterSearchTravelcenterBookings()


    /***************************************************************************
    * Mutations: Travelcenter Calls, Countries (Shared)
    ***************************************************************************/
    /***************************************************************************
    * mut_call_shared_getCountries()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_shared_getCountries: function mut_call_shared_getCountries(state, payload) {

        payload.sort(function (a, b) {
            return a.name > b.name ? 1 : -1;
        });
        state.shared_getCountries = payload;
    } // eo function mut_call_shared_getCountries()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: Travelcenter Calls
    ***************************************************************************/
    /***************************************************************************
    * Call::'/booking/profile/update';
    *
    * Desc: Call: Update an user.
    * Note: On password update log out user.
    *
    */
    actn_call_travelcenter_updateProfile: function actn_call_travelcenter_updateProfile(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/booking/profile/update', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_travelcenter_updateProfile', { response: response.data }, { root: true });
                    __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$emit('call_travelcenter_updateProfile_success');

                    // password update case
                    if ("password" in payload) {
                        __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$emit('call_travelcenter_updateProfile_updatePasswordSuccess'); // works
                    }
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_travelcenter_updateProfile()


    /***************************************************************************
    * Call::'/booking/profile/bookings/'; (old)
    * Call::'/booking/profile/active/'; (actual)
    *
    * Desc: Call: Get Users Bookings.
    * Note: New: With 'Security' Authorization Header.
    *
    */
    actn_call_travelcenter_getBookings: function actn_call_travelcenter_getBookings(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/booking/profile/active/', { 'email': payload.user_email }, {
            headers: {
                "Authorization": "Basic " + payload.authorizationHeader
            } }).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_travelcenter_getBookings', response.data);
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_travelcenter_getBookings()


    /***************************************************************************
    * Actions: Travelcenter, Search/Filter
    ***************************************************************************/
    /***************************************************************************
    * act_set_filterSearchTravelcenterBookings()
    *
    * Desc: Save Search/Filter Params for Bookings.
    * Note:
    *
    */
    act_set_filterSearchTravelcenterBookings: function act_set_filterSearchTravelcenterBookings(context, payload) {

        context.commit('mut_set_filterSearchTravelcenterBookings', { payload: payload, context: context });
    }, // eo function act_set_filterSearchTravelcenterBookings()


    /***************************************************************************
    * Actions: Travelcenter Calls, Countries (Shared)
    ***************************************************************************/
    /***************************************************************************
    * Call::'/info/countries';
    *
    * Desc: Call: Get Countries.
    * Note:
    *
    */
    actn_call_shared_getCountries: function actn_call_shared_getCountries(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request --------------------------
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/info/countries').then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_shared_getCountries', response.data);
                    __WEBPACK_IMPORTED_MODULE_3__main__["eventBus"].$emit('call_shared_countries_success');

                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    } // eo function actn_call_shared_getCountries()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(15);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> Jobs -------------------------------------------
    jobs: []

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: 'CMS' - 'Jobs'
    ***************************************************************************/
    /***************************************************************************
    * get_Jobs()
    *
    * Desc:
    * Note:
    *
    */
    get_Jobs: function get_Jobs(state) {

        return state.jobs;
    }, // eof get_Jobs()


    /***************************************************************************
    * get_Jobs_Filtered()
    *
    * Desc: Return 'Office' filtered Jobs.
    * Note: Checks 'if Job is active'.
    *
    */
    get_Jobs_Filtered: function get_Jobs_Filtered(state) {
        return function (payload) {

            if (payload !== undefined && payload !== null) {
                return state.jobs.filter(function (x) {
                    return x.offices.includes(String(payload).toLocaleUpperCase()) === true && x.active === true;
                }).sort(function (a, b) {
                    return a.sort < b.sort ? -1 : 1;
                });
            }
        };
    } // eof get_Jobs_Filtered()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: 'CMS' - 'Jobs'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getJobs()
    *
    * Desc: Save jobs to state.
    * Note:
    *
    */
    mut_call_getJobs: function mut_call_getJobs(state, payload) {

        var jobs = [].concat(_toConsumableArray(payload.jobs));

        jobs.forEach(function (job) {
            job.offices.sort();
        });

        state.jobs = jobs;
    } // eo function mut_call_getJobs()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: 'CMS' - 'Jobs'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getJobs'
    *
    * Desc: Get List of 'Jobs'.
    * Note:
    *
    */
    actn_call_getJobs: function actn_call_getJobs(context, payload) {

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* CONF_API_BASEURL */], payload).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            context.commit('mut_call_getJobs', response.data.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();

            // >>> --------------------------
            if (error.response && error.response.data.errors) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: error.response.data.errors[0].message
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: "Service not available"
                });
            }
        });
    } // eo funtion actn_call_getJobs()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(15);
/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> 'Covid Text ------------------------------------
    covidtext_DE: [],
    covidtext_EN: []

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: 'Website' - 'Covid Text'
    ***************************************************************************/
    /***************************************************************************
    * get_CovidText_DE()
    *
    * Desc: Return 'DE' Version of Covid Text.
    * Note:
    *
    */
    get_CovidText_DE: function get_CovidText_DE(state) {

        return state.covidtext_DE;
    }, // eof get_CovidText_DE()


    /***************************************************************************
    * get_CovidText_EN()
    *
    * Desc: Return 'EN' Version of Covid Text.
    * Note:
    *
    */
    get_CovidText_EN: function get_CovidText_EN(state) {

        return state.covidtext_EN;
    } // eof get_CovidText_EN()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: 'Website' - 'Covid Text'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getCovidText()
    *
    * Desc: Save 'Covid Text' to state.
    * Note: Gettin 'lang' via payload.
    *
    */
    mut_call_getCovidText: function mut_call_getCovidText(state, payload) {

        if (payload.lang === 'de') {
            state.covidtext_DE = payload.response;
        }

        if (payload.lang === 'en') {
            state.covidtext_EN = payload.response;
        }
    } // eo function mut_call_getCovidText()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: 'Website' - 'Covid Text'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getCovidText'
    *
    * Desc: Get 'Covid Text'.
    * Note: Gettin 'lang' in payload.
    *
    */
    actn_call_getCovidText: function actn_call_getCovidText(context, payload) {

        // Vue.prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* CONF_API_BASEURL */], payload.payload).then(function (response) {
            // Vue.prototype.$vp_um();
            context.commit('mut_call_getCovidText', { response: response.data.data.covid, lang: payload.lang });
        }).catch(function (error) {
            // Vue.prototype.$vp_um();


            // >>> --------------------------
            if (error.response && error.response.data.errors) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: error.response.data.errors[0].message
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: "Service not available"
                });
            }
        });
    } // eo funtion actn_call_getCovidText()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(15);
/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> 'Infoalert Text --------------------------------
    infoalerttext_DE: [],
    infoalerttext_EN: []

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: 'Website' - 'Infoalert Text'
    ***************************************************************************/
    /***************************************************************************
    * get_InfoalertText_DE()
    *
    * Desc: Return 'DE' Version of Infoalert Text.
    * Note:
    *
    */
    get_InfoalertText_DE: function get_InfoalertText_DE(state) {

        return state.infoalerttext_DE;
    }, // eof get_InfoalertText_DE()


    /***************************************************************************
    * get_InfoalertText_EN()
    *
    * Desc: Return 'EN' Version of Infoalert Text.
    * Note:
    *
    */
    get_InfoalertText_EN: function get_InfoalertText_EN(state) {

        return state.infoalerttext_EN;
    } // eof get_InfoalertText_EN()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: 'Website' - 'Infoalert Text'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getInfoalertText()
    *
    * Desc: Save 'Infoalert Text' to state.
    * Note: Gettin 'lang' via payload.
    *
    */
    mut_call_getInfoalertText: function mut_call_getInfoalertText(state, payload) {

        if (payload.lang === 'de') {
            state.infoalerttext_DE = payload.response;
        }

        if (payload.lang === 'en') {
            state.infoalerttext_EN = payload.response;
        }
    } // eo function mut_call_getInfoalertText()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: 'Website' - 'Infoalert Text'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getInfoalertText'
    *
    * Desc: Get 'Infoalert Text'.
    * Note: Gettin 'lang' in payload.
    *
    */
    actn_call_getInfoalertText: function actn_call_getInfoalertText(context, payload) {

        // Vue.prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* CONF_API_BASEURL */], payload.payload).then(function (response) {
            // Vue.prototype.$vp_um();
            context.commit('mut_call_getInfoalertText', { response: response.data.data.infoalert, lang: payload.lang });
        }).catch(function (error) {
            // Vue.prototype.$vp_um();


            // >>> --------------------------
            if (error.response && error.response.data.errors) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: error.response.data.errors[0].message
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: "Service not available"
                });
            }
        });
    } // eo funtion actn_call_getInfoalertText()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(15);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Booking'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/





//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> 'Pressreleases' --------------------------------
    pressreleases: [],
    pressreleasesheadlines: []
};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: 'Website' - 'Pressreleases'
    ***************************************************************************/
    /***************************************************************************
    * get_Pressreleases()
    *
    * Desc: Return 'Pressreleases'.
    * Note:
    *
    */
    get_Pressreleases: function get_Pressreleases(state) {

        return state.pressreleases;
    }, // eof get_Pressreleases()


    /***************************************************************************
    * get_Pressreleases_Filtered()
    *
    * Desc: .
    * Note: Checks 'if Pressreleses is active'.
    *
    */
    get_Pressreleases_Filtered: function get_Pressreleases_Filtered(state) {

        return state.pressreleases.filter(function (x) {
            return x.active === true;
        }).sort(function (a, b) {
            return a.publishDate > b.publishDate ? -1 : 1;
        });
    }, // eof get_Pressreleases_Filtered()


    /***************************************************************************
    * get_PressreleasesHeadlines_Filtered()
    *
    * Desc: .
    * Note: Checks 'if Pressreleses is active'.
    *
    */
    get_PressreleasesHeadlines_Filtered: function get_PressreleasesHeadlines_Filtered(state) {

        return state.pressreleasesheadlines.filter(function (x) {
            return x.active === true;
        }).sort(function (a, b) {
            return a.publishDate > b.publishDate ? -1 : 1;
        });
    } // eof get_PressreleasesHeadlines_Filtered()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: 'Website' - 'Pressreleases'
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getPressreleases()
    *
    * Desc: Save 'Pressreleases' to state.
    * Note:
    *
    */
    mut_call_getPressreleases: function mut_call_getPressreleases(state, payload) {

        var pressreleases = [].concat(_toConsumableArray(payload.pressreleases));

        state.pressreleases = pressreleases;
    }, // eo function mut_call_getPressreleases()


    /***************************************************************************
    * mut_call_getPressreleasesHeadlines()
    *
    * Desc: Save 'Pressreleases' Headlines to state.
    * Note:
    *
    */
    mut_call_getPressreleasesHeadlines: function mut_call_getPressreleasesHeadlines(state, payload) {

        var pressreleases = [].concat(_toConsumableArray(payload.pressreleases));

        state.pressreleasesheadlines = pressreleases;
    } // eo function mut_call_getPressreleasesHeadlines()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: 'Website' - 'Pressreleases'
    ***************************************************************************/
    /***************************************************************************
    * Call: 'actn_call_getPressreleases'
    *
    * Desc: Get List of 'Pressreleases'.
    * Note:
    *
    */
    actn_call_getPressreleases: function actn_call_getPressreleases(context, payload) {

        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* CONF_API_BASEURL */], payload).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            context.commit('mut_call_getPressreleases', response.data.data);
        }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();

            // >>> --------------------------
            if (error.response && error.response.data.errors) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: error.response.data.errors[0].message
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: "Service not available"
                });
            }
        });
    }, // eo funtion actn_call_getPressreleases()


    /***************************************************************************
    * Call: 'actn_call_getPressreleasesHeadlines'
    *
    * Desc: Get List of 'Pressreleases' Headlines (for Footer).
    * Note:
    *
    */
    actn_call_getPressreleasesHeadlines: function actn_call_getPressreleasesHeadlines(context, payload) {

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["b" /* CONF_API_BASEURL */], payload).then(function (response) {
            context.commit('mut_call_getPressreleasesHeadlines', response.data.data);
        }).catch(function (error) {

            // >>> --------------------------
            if (error.response && error.response.data.errors) {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: error.response.data.errors[0].message
                });
            } else {
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                    message: "Service not available"
                });
            }
        });
    } // eo funtion actn_call_getPressreleasesHeadlines()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(6);
/*
* booking.js
*
* Description: Holds 'Stores' Logic for Module:'Travelcenter'.
*
* This file is part of: "http://apps.sundair.com/", "Sundair-2019"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact:  http://www.sundair.com/
* @author Learek <michael.broeker@sundair.com>
*
*/




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var state = {

    // >>> ------------------------------------------------
    flightstatus_airportsOrigins: [],
    flightstatus_airportsDestinations: [],
    flightstatus_flightTracker: [],
    flightstatus_airportInfos: []

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
var getters = {

    /***************************************************************************
    * Getters: Flightstatus
    ***************************************************************************/
    /***************************************************************************
    * get_Flightstatus_AirportOrigins()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_AirportOrigins: function get_Flightstatus_AirportOrigins(state) {

        return state.flightstatus_airportsOrigins;
    }, // eo function get_Flightstatus_AirportOrigins()


    /***************************************************************************
    * get_Flightstatus_AirportDestinations()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_AirportDestinations: function get_Flightstatus_AirportDestinations(state) {

        return state.flightstatus_airportsDestinations;
    }, // eo function get_Flightstatus_AirportDestinations()


    /***************************************************************************
    * get_Flightstatus_FlightTracker()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_FlightTracker: function get_Flightstatus_FlightTracker(state) {

        return state.flightstatus_flightTracker;
    }, // eo function get_Flightstatus_FlightTracker()


    /***************************************************************************
    * get_Flightstatus_AirportInfo()
    *
    * Desc:
    * Note:
    *
    */
    get_Flightstatus_AirportInfo: function get_Flightstatus_AirportInfo(state) {
        return function (payload) {

            var website = null;

            state.flightstatus_airportInfos.forEach(function (airport) {
                if (airport.iataCode === payload) {
                    website = airport.website;
                }
            });

            return website;
        };
    } // eo function get_Flightstatus_AirportInfo()

};

//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
var mutations = {

    /***************************************************************************
    * Mutations: Flightstatus Calls
    ***************************************************************************/
    /***************************************************************************
    * mut_call_listAirportsOrigines()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listAirportsOrigines: function mut_call_listAirportsOrigines(state, payload) {

        var airportsToFilterOut = ['HER', 'KGS', 'RHO', 'CFU'],
            tmp_flightstatus_airportsOrigins = [];

        state.flightstatus_airportsOrigins = payload.originesRS.dep;
        state.flightstatus_airportsOrigins.sort(function (a, b) {
            return a.l > b.l ? 1 : b.l > a.l ? -1 : 0;
        });

        // >>> Filter out ....
        state.flightstatus_airportsOrigins.forEach(function (apt) {
            if (airportsToFilterOut.includes(apt.i) === false) {
                tmp_flightstatus_airportsOrigins.push(apt);
            }
        });

        state.flightstatus_airportsOrigins = tmp_flightstatus_airportsOrigins;
    }, // eo function mut_call_listAirportsOrigines()


    /***************************************************************************
    * mut_call_listAirportsDestinations()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listAirportsDestinations: function mut_call_listAirportsDestinations(state, payload) {

        var airportsToFilterOut = ['HER', 'KGS', 'RHO', 'CFU'],
            tmp_flightstatus_airportsDestination = [];

        state.flightstatus_airportsDestinations = payload.destinationsRS.des;
        state.flightstatus_airportsDestinations.sort(function (a, b) {
            return a.l > b.l ? 1 : b.l > a.l ? -1 : 0;
        });

        // >>> Filter out ....
        state.flightstatus_airportsDestinations.forEach(function (apt) {
            if (airportsToFilterOut.includes(apt.i) === false) {
                tmp_flightstatus_airportsDestination.push(apt);
            }
        });

        state.flightstatus_airportsDestinations = tmp_flightstatus_airportsDestination;
    }, // eo function mut_call_listAirportsDestinations()


    /***************************************************************************
    * mut_call_listFlighttracker()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listFlighttracker: function mut_call_listFlighttracker(state, payload) {

        state.flightstatus_flightTracker = payload;
    }, // eo function mut_call_listFlighttracker()


    /***************************************************************************
    * mut_call_listAirportInfos()
    *
    * Desc:
    * Note:
    *
    */
    mut_call_listAirportInfos: function mut_call_listAirportInfos(state, payload) {

        state.flightstatus_airportInfos = payload;
    } // eo function mut_call_listAirportInfos()

};

//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
var actions = {

    /***************************************************************************
    * Actions: Flightstatus Calls
    ***************************************************************************/
    /***************************************************************************
    * Call::'/registration/origines'
    *
    * Desc: Getting Airports - Origines ('listAirports').
    * Note:
    *
    */
    actn_call_listAirportsOrigines: function actn_call_listAirportsOrigines(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request ---------------------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/registration/origines/').then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_listAirportsOrigines', response.data);
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('callairportoriginessuccess');
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function call_listAirportsOrigines()


    /***************************************************************************
    * Call::'/registration/destinations'
    *
    * Desc: Getting Airports - Destinations ('listAirports').
    * Note:
    *
    */
    actn_call_listAirportsDestinations: function actn_call_listAirportsDestinations(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request ---------------------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/registration/destinations/' + payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_listAirportsDestinations', response.data);
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('callairportdestinationssuccess');
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_listAirportsDestinations()


    /***************************************************************************
    * Call::'/acm/forms/flighttracker'
    *
    * Desc: Getting Airports - Destinations ('listAirports').
    * Note:
    *
    */
    actn_call_listFlighttracker: function actn_call_listFlighttracker(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request ---------------------------------------
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_m();
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put('/acm/forms/flighttracker', payload).then(function (response) {
            // 'OK'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_listFlighttracker', response.data);
                    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('callflighttrackersuccess');
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$vp_um();
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    }, // eo function actn_call_listFlighttracker()


    /***************************************************************************
    * Call::'/acm/airport'
    *
    * Desc:
    * Note:
    *
    */
    actn_call_listAirportInfos: function actn_call_listAirportInfos(context, payload) {

        var hdrs = '';

        // >>> Send Ajax Request ---------------------------------------
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/acm/airport').then(function (response) {
            // 'OK'
            hdrs = response.headers["air41-status"];
            switch (hdrs) {
                case 'OK':
                    // 'OK'
                    context.commit('mut_call_listAirportInfos', response.data);
                    break;
                default:
                    // 'ERROR'
                    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                        message: response.headers["air41-error"]
                    });
                    break;
            };
        }).catch(function (error) {
            // 'ERROR'
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toasted.global.sdr_app_error({
                message: 'Service unavailable: ' + error
            });
        });
    } // eo function actn_call_listAirportInfos()

};

//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "value", function() { return value; });
/*
 * getters.js
 *
 * Description: Holds global Getters (for store).
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
// demo
var value = function value(state) {
  return state.value;
};

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateValue", function() { return updateValue; });
/*
 * mutations.js
 *
 * Description: Holds global Mutations (for store).
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
// demo
var updateValue = function updateValue(state, payload) {
  state.value = payload;
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateValue", function() { return updateValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "action2", function() { return action2; });
/*
 * actions.js
 *
 * Description: Holds global Actions (for store).
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
// demo
var updateValue = function updateValue(_ref, payload) {
  var commit = _ref.commit;

  commit('updateValue', payload);
};

var action2 = function action2() {};

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/*
 * filters.js
 *
 * Description: Holds common/global Filters.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("first4Chars", function (str) {
    return str.substring(0, 4);
}); // Unused
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("last4Chars", function (str) {
    return str.substring(str.length - 4);
}); // Unused


/*******************************************************************************
* Filter:: 'moment'
*
* Desc:
* Note: 2014-09-18T04:00:00+0200
* dateIso8601.match(regexIsoDate) =
* ["2013-03-27T12:05:00+0100", "2013", "03", "27", "T", "12", "05", "00", "+", "01", "00"]

* Example:
* dateIso8601 = "2013-03-27T12:05:00+0100"
* ---> getDateFromDateIso8601
* ---> "27.03.2013"
*
* @param {string} dateIso8601 (Date in ISO8601 format)
* @param {string} format (date format that we want to the return data. Default is: "dd.mm.yyyy")
* @param {bool} withTime (With Time added?)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('moment', function (dateIso8601, format, withTime) {

    var regexIsoDate = '',
        m = '',
        day = '',
        month = '',
        year = '',
        hour = '',
        minute = '',
        result = '';

    format = 'd.m.Y'; // Fake
    withTime = true; // Fake
    regexIsoDate = /^(\d{4})-(\d{2})-(\d{2})(T)(\d{2}):(\d{2}):(\d{2})([\-+])(\d{2})(\d{2})$/;
    m = typeof dateIso8601 === 'string' && dateIso8601.match(regexIsoDate);

    if (m) {
        year = m[1];
        month = m[2];
        day = m[3];
        hour = m[5];
        minute = m[6];

        switch (format) {
            case 'd.m.Y':
                result = day + '.' + month + '.' + year;
                if (withTime) {
                    // result += ', ' + hour + ':' + minute + ' Uhr'
                    result += ', ' + hour + ':' + minute;
                }
                break;
            case 'j.m.y':
                result = parseInt(day, 10) + '.' + month + '.' + year.substr(2, 2);
                if (withTime) {
                    result += ' ' + hour + ':' + minute;
                }
                break;
            case 'H:i':
                result = hour + ':' + minute;
                break;
        }
    }

    return result;
    // return moment(date, moment.ISO_8601).format('DD.MM.YYYY, HH:mm') + ' Uhr'; // de:
    // return moment(date, moment.ISO_8601).format('MMM DD, YYYY HH:mm A'); // en: JAN 30, 2019
});

/*******************************************************************************
* Filter:: 'momentDate'
*
* Desc:
* Note: 2014-09-18T04:00:00+0200
* dateIso8601.match(regexIsoDate) =
* ["2013-03-27T12:05:00+0100", "2013", "03", "27", "T", "12", "05", "00", "+", "01", "00"]

* Example:
* dateIso8601 = "2013-03-27T12:05:00+0100"
* ---> getDateFromDateIso8601
* ---> "27.03.2013"
*
* @param {string} dateIso8601 (Date in ISO8601 format)
* @param {string} format (date format that we want to the return data. Default is: "dd.mm.yyyy")
* @param {bool} withTime (With Time added?)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('momentDate', function (dateIso8601, format, withTime) {

    var regexIsoDate = '',
        m = '',
        day = '',
        month = '',
        year = '',
        hour = '',
        minute = '',
        result = '';

    format = 'd.m.Y'; // Fake
    withTime = false; // Fake
    regexIsoDate = /^(\d{4})-(\d{2})-(\d{2})(T)(\d{2}):(\d{2}):(\d{2})([\-+])(\d{2})(\d{2})$/;
    m = typeof dateIso8601 === 'string' && dateIso8601.match(regexIsoDate);

    if (m) {
        year = m[1];
        month = m[2];
        day = m[3];
        hour = m[5];
        minute = m[6];

        switch (format) {
            case 'd.m.Y':
                result = day + '.' + month + '.' + year;
                if (withTime) {
                    result += ', ' + hour + ':' + minute + ' Uhr';
                }
                break;
            case 'j.m.y':
                result = parseInt(day, 10) + '.' + month + '.' + year.substr(2, 2);
                if (withTime) {
                    result += ' ' + hour + ':' + minute;
                }
                break;
            case 'H:i':
                result = hour + ':' + minute;
                break;
        }
    }

    return result;
    // return moment(date, moment.ISO_8601).format('DD.MM.YYYY, HH:mm') + ' Uhr'; // de:
    // return moment(date, moment.ISO_8601).format('MMM DD, YYYY HH:mm A'); // en: JAN 30, 2019
});

/*******************************************************************************
* Filter:: 'momentTime'
*
* Desc: Time only.
* Note:
*
* @param {string} dateIso8601 (Date in ISO8601 format)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('momentTime', function (dateIso8601) {

    var regexIsoDate = '',
        m = '',
        day = '',
        month = '',
        year = '',
        hour = '',
        minute = '',
        result = '';

    regexIsoDate = /^(\d{4})-(\d{2})-(\d{2})(T)(\d{2}):(\d{2}):(\d{2})([\-+])(\d{2})(\d{2})$/;
    m = typeof dateIso8601 === 'string' && dateIso8601.match(regexIsoDate);

    if (m) {
        year = m[1];
        month = m[2];
        day = m[3];
        hour = m[5];
        minute = m[6];

        // result = hour + ':' + minute + ' Uhr';
        result = hour + ':' + minute;
    }

    return result;
});

/*******************************************************************************
* Filter:: 'birthdate'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('birthdate', function (date) {

    if (date !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601).format('DD.MM.YYYY'); // de:
    } else {
        return '';
    }
    // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019
});

/*******************************************************************************
* Filter:: 'monthname'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('monthname', function (date) {

    var locale = JSON.parse(localStorage.getItem('sdr__lang'));
    if (locale) {
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(locale.value); // returns the new locale, in this case 'de'
    } else {
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('de'); // returns the new locale, in this case 'de'
    }

    if (date !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601).format('MMM, YYYY').toUpperCase(); // de:
    } else {
        return '';
    }
});

/*******************************************************************************
* Filter:: 'weekday'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('weekday', function (date) {

    var locale = JSON.parse(localStorage.getItem('sdr__lang'));
    if (locale) {
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(locale.value); // returns the new locale, in this case 'de'
    } else {
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale('de'); // returns the new locale, in this case 'de'
    }

    if (date !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601).format('ddd').toUpperCase(); // de:
    } else {
        return '';
    }
});

/*******************************************************************************
* Filter:: 'dayofmonth'
*
* Desc: Filter: Format Date.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('dayofmonth', function (date) {

    if (date !== undefined) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date, __WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601).format('DD'); // de:
    } else {
        return '';
    }
});

/*******************************************************************************
* Filter:: 'yearofbooking'
*
* Desc: Filter: Format Date. Return Year of Booking.
*
* @param {string} date (Date to reformat)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('yearofbooking', function (date) {

    return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).get("year").toString();
});

/*******************************************************************************
* Filter:: 'currency'
*
* Desc: Filter: Format Sum.
*
* @param {string} sum (Sum to reformat)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('currency', function (sum) {

    return String(sum).indexOf(".") === -1 ? sum + '.00€' : sum + '€';
});

/*******************************************************************************
* Filter:: 'rndAmntRUAFWZ'
*
* Desc: Filter: Format Value.
*
* @param {string} v (Value to reformat)
* @return {string}
*/
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter('rndAmntRUAFWZ', function (v) {

    var k, p;

    k = (Math.round(v * 100) / 100).toString();
    k += k.indexOf('.') == -1 ? '.00' : '00';
    p = k.indexOf('.');

    return k.substring(0, p) + '.' + k.substring(p + 1, p + 3) + '€';
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routesbooking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_booking_Home_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_booking_passengers_Passengers_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_booking_payment_Payment_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_booking_overview_Overview_vue__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_booking_confirmation_Confirmation_vue__ = __webpack_require__(468);
/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Booking'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
 // 'Home-Booking' ..
 // 'Paxes&Service's ..
 // 'Payment' ..
 // 'Overview' ..
 // 'Confirmation' ..


var routesbooking = [{ path: '', component: __WEBPACK_IMPORTED_MODULE_0__components_booking_Home_vue__["a" /* default */] },
// { path: '', component: FlightSearchResultsBooking }, // Step: 1
// { path: '/passengers', name: 'Passengers', component: Passengers }, // Step: 2
{ path: '/passengers/:modulo?', name: 'Passengers', component: __WEBPACK_IMPORTED_MODULE_1__components_booking_passengers_Passengers_vue__["a" /* default */], props: true }, // Step: 2
{ path: '/payment/:modulo?', name: 'Payment', component: __WEBPACK_IMPORTED_MODULE_2__components_booking_payment_Payment_vue__["a" /* default */], props: true }, // Step: 3
{ path: '/overview/:modulo?', name: 'Overview', component: __WEBPACK_IMPORTED_MODULE_3__components_booking_overview_Overview_vue__["a" /* default */], props: true }, // Step: 4
{ path: '/confirmation/:modulo?', name: 'Confirmation', component: __WEBPACK_IMPORTED_MODULE_4__components_booking_confirmation_Confirmation_vue__["a" /* default */], props: true }];

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386e9c39_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(430);
function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-386e9c39"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_386e9c39_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(371);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("8c2b9850", content, true, {});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".alert.alert-info[data-v-386e9c39]{background:#fff;color:#2d3e52;margin-left:15px;margin-right:15px;font-size:14px;font-weight:400}.alert.alert-warning[data-v-386e9c39]{background:red;color:#fff;margin-left:15px;margin-right:15px;font-size:14px;font-weight:400}.alert .close[data-v-386e9c39],.info-box .close[data-v-386e9c39]{color:#fff}", ""]);

// exports


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightSearchTabs_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fc3ffe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightSearchTabs_vue__ = __webpack_require__(408);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FlightSearchTabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65fc3ffe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FlightSearchTabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingnoTab_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06eb48c7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingnoTab_vue__ = __webpack_require__(399);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06eb48c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingnoTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06eb48c7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingnoTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(375);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("41642154", content, true, {});

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".icon-box.style5>i[data-v-06eb48c7]{background:#ec008b}.icon-box.style5[data-v-06eb48c7]{background:#f5f5f5}.alert.alert-help[data-v-06eb48c7]{background:#dcecf6;color:#406f8c}.alert .close[data-v-06eb48c7],.info-box .close[data-v-06eb48c7]{color:#406f8c}.icon-check-srvcs[data-v-06eb48c7]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check-srvcs[data-v-06eb48c7]:after{content:\"\";position:absolute;top:0;right:0;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}.errormsg[data-v-06eb48c7]{margin-bottom:3px;margin-top:3px;color:red}", ""]);

// exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production"}).BUILD === 'web' ? __webpack_require__(378).withParams : __webpack_require__(29).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(13)))

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(7);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"title-container",style:({ background: '#4A6E89' })},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlineflighthelp[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-search"})]),_vm._v(" "),_c('section',{staticStyle:{"padding-top":"20px","background-color":"#fff"},attrs:{"id":"content"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"contact-address block",staticStyle:{"margin-left":"20px","margin-right":"20px"}},[_c('h4',[_vm._v(_vm._s(_vm.hellotext1[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.hellotext2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.hellotext3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('div',{staticClass:"alert alert-help"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.hellotext4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('span',{staticClass:"close"})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.when[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.form_bookingno[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input_bookingno),expression:"input_bookingno"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.input_bookingno.$error },staticStyle:{"text-transform":"uppercase"},attrs:{"type":"text","id":"'input_bookingno","name":"input_bookingno","value":"","placeholder":"E.G.: MB4K2VUH"},domProps:{"value":(_vm.input_bookingno)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.input_bookingno=$event.target.value},function($event){_vm.$v.input_bookingno.$touch()}]}}),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_bookingno[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_bookingno[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.lettersandnumbers)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_lettersandnumbers[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.form_surname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input_surname),expression:"input_surname"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.input_surname.$error },staticStyle:{"text-transform":"uppercase"},attrs:{"type":"text","id":"'input_surname","name":"input_surname","value":"","placeholder":"E.G.: Mustermann"},domProps:{"value":(_vm.input_surname)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.input_surname=$event.target.value},function($event){_vm.$v.input_surname.$touch()}]}}),_vm._v(" "),(_vm.$v.input_surname.$dirty && !_vm.$v.input_surname.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_surname.$dirty && !_vm.$v.input_surname.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_surname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_surname.$dirty && !_vm.$v.input_surname.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_surname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_surname.$dirty && !_vm.$v.input_surname.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-check',{staticClass:"p-svg p-round p-pulse",attrs:{"color":"success","value":"ABB"},model:{value:(_vm.checkedBoxes),callback:function ($$v) {_vm.checkedBoxes=$$v},expression:"checkedBoxes"}},[_c('svg',{staticClass:"svg svg-icon",attrs:{"slot":"extra","viewBox":"0 0 20 20"},slot:"extra"},[_c('path',{staticStyle:{"stroke":"white","fill":"white"},attrs:{"d":"M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"}})])]),_vm._v(" "),_c('span',{staticClass:"skin-color",staticStyle:{"font-size":"1.0833em"}},[_vm._v(_vm._s(_vm.checkboxtext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('hr'),_vm._v(" "),((!_vm.checkValidity() && _vm.getFlagServicesBookingnoLoginIsReadyForLogin === false) || (!_vm.checkValidity() && _vm.getFlagServicesBookingnoLoginIsReadyForLogin === true))?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.getbookinno[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.checkValidity() && _vm.getFlagServicesBookingnoLoginIsReadyForLogin === true)?_c('button',{staticClass:"btn-large icon-check-srvcs uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },style:({ background: '#4A6E89' }),attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.getbookinno[_vm.getCurrentLocale]))]):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageToursTab_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b017c68_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageToursTab_vue__ = __webpack_require__(403);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b017c68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PackageToursTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b017c68_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PackageToursTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2101da06", content, true, {});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".icon-box.style5>i[data-v-2b017c68]{background:#ec008b}.icon-box.style5[data-v-2b017c68]{background:#f5f5f5}.style-chooser-tours .vs__dropdown-menu[data-v-2b017c68],.style-chooser-tours .vs__dropdown-toggle[data-v-2b017c68],.style-chooser-tours .vs__search[data-v-2b017c68]::placeholder{background:#0082c8;color:#fff}.style-chooser-tours .vs__clear[data-v-2b017c68],.style-chooser-tours .vs__open-indicator[data-v-2b017c68]{fill:#fff}.style-chooser-tours .vs--disabled .vs__open-indicator[data-v-2b017c68],.style-chooser-tours .vs--disabled .vs__search[data-v-2b017c68],.style-chooser-tours .vs--disabled .vs__selected[data-v-2b017c68],.style-chooser-tours .vs__dropdown-toggle[data-v-2b017c68]{background-color:#0082c8}.style-chooser-tours .vs--disabled[data-v-2b017c68]{background-color:#0082c8!important;color:#fff}.style-chooser-srvcs .vs__dropdown-menu[data-v-2b017c68]{background:#0082c8;color:#fff}.vs--disabled .vs__open-indicator[data-v-2b017c68],.vs--disabled .vs__search[data-v-2b017c68],.vs--disabled .vs__selected[data-v-2b017c68],.vs__dropdown-toggle[data-v-2b017c68]{color:#fff}.icon-check-srvcs[data-v-2b017c68]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check-srvcs[data-v-2b017c68]:after{content:\"\";position:absolute;top:0;right:0;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #0082c8}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.search-box-wrapper.style1 .search-tab-content .search-content[data-v-2b017c68]{padding:18px 25px 25px;padding:18px 10px 10px}}", ""]);

// exports


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"title-container",style:({ background: '#0082C8' })},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlineflighthelp[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-hotel"})]),_vm._v(" "),_c('div',{staticClass:"search-content",staticStyle:{"padding-top":"20px","background-color":"#fff"}},[_c('h4',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.infotexttitle[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.infotext[_vm.getCurrentLocale])}}),_vm._v(" "),_c('img',{staticStyle:{"float":"right"},attrs:{"src":"/res/images/slrh65.png"}}),_vm._v(" "),_c('h5',{staticClass:"title",staticStyle:{"margin-top":"50px"}},[_vm._v(_vm._s(_vm.where[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdeparture[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"depArprtCodeTours",staticClass:"style-chooser",attrs:{"name":"depArprtCodeTours","clearable":false,"disabled":!_vm.departuresLoadedTours,"options":_vm.airportsOriginsTours,"label":"l","value":_vm.i,"placeholder":this.departureairport[this.getCurrentLocale]},on:{"input":_vm.call_listAirportsDestinations},model:{value:(_vm.depArprtCodeTours),callback:function ($$v) {_vm.depArprtCodeTours=$$v},expression:"depArprtCodeTours"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.yourplaceofdestination[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"i",ref:"desArprtCodeTours",staticClass:"style-chooser",attrs:{"name":"desArprtCodeTours","clearable":false,"disabled":!_vm.destinationsLoadedTours,"options":_vm.airportsDestinationsTours,"label":"l","value":_vm.i,"placeholder":this.destinationairport[this.getCurrentLocale]},model:{value:(_vm.desArprtCodeTours),callback:function ($$v) {_vm.desArprtCodeTours=$$v},expression:"desArprtCodeTours"}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.when[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.departuredate[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"datepicker-wrap sundair"},[_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","name":"date_from","placeholder":"dd.mm.yy"},domProps:{"value":_vm.today}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.outwardonly === false),expression:"outwardonly === false"}]},[_vm._v(_vm._s(_vm.returndate[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.outwardonly === false),expression:"outwardonly === false"}],staticClass:"datepicker-wrap sundair"},[_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","name":"date_to","placeholder":"dd.mm.yy"},domProps:{"value":_vm.tommorow}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.traveltimefrom[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"traveltimeFrom"},_vm._l((28),function(value,index){return _c('option',{key:index,domProps:{"value":value,"selected":value === 7}},[_vm._v(_vm._s(value))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.traveltimeto[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"traveltimeTo"},_vm._l((28),function(value,index){return _c('option',{key:index,domProps:{"value":value,"selected":value === 14}},[_vm._v(_vm._s(value))])}))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.who[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.adult[_vm.getCurrentLocale])),_c('br'),_vm._v(_vm._s(_vm.adultyears[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"noADT_Tours"},_vm._l((_vm.listOfPaxes),function(value,key){return _c('option',{key:key,domProps:{"value":value,"selected":value === '1'}},[_vm._v(_vm._s(value))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.child[_vm.getCurrentLocale])),_c('br'),_vm._v(_vm._s(_vm.childyears[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"noCHD_Tours"},_vm._l((_vm.listOfPaxes),function(value,key){return _c('option',{key:key,domProps:{"value":value}},[_vm._v(_vm._s(value))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4 col-md-4"},[_c('label',[_vm._v(_vm._s(_vm.infant[_vm.getCurrentLocale])),_c('br'),_vm._v(_vm._s(_vm.infantyears[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{ref:"noINF_Tours"},_vm._l((_vm.listOfPaxes),function(value,key){return _c('option',{key:key,domProps:{"value":value}},[_vm._v(_vm._s(value))])}))])])]),_vm._v(" "),_c('br'),_c('br'),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn-medium icon-check-srvcs uppercase full-width",style:({ background: '#0082C8' }),attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.findflights[_vm.getCurrentLocale]))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RebookingTab_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3baac50b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RebookingTab_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3baac50b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RebookingTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3baac50b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RebookingTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4acf2844", content, true, {});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".icon-check-rebooking[data-v-3baac50b]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check-rebooking[data-v-3baac50b]:after{content:\"\";position:absolute;top:0;right:0;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #fdb714}.errormsg[data-v-3baac50b]{margin-bottom:3px;margin-top:3px;color:red}", ""]);

// exports


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"title-container",style:({ background: '#FDB714' })},[_c('h2',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.searchboxheadlinerebooking[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.searchboxheadlineflights2[_vm.getCurrentLocale]))]),_vm._v(" "),_c('i',{staticClass:"soap-icon-search"})]),_vm._v(" "),_c('section',{staticStyle:{"padding-top":"20px","background-color":"#fff"},attrs:{"id":"content"}},[_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"contact-address block",staticStyle:{"margin-left":"20px","margin-right":"20px"}},[_c('h4',[_vm._v(_vm._s(_vm.hellotext1[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.hellotext2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.hellotext3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.when[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.form_bookingno[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input_bookingno),expression:"input_bookingno"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.input_bookingno.$error },staticStyle:{"text-transform":"uppercase"},attrs:{"type":"text","id":"'input_bookingno","name":"input_bookingno","value":"","placeholder":"E.G.: MB4K2VUH"},domProps:{"value":(_vm.input_bookingno)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.input_bookingno=$event.target.value},function($event){_vm.$v.input_bookingno.$touch()}]}}),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_bookingno[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_bookingno[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_bookingno.$dirty && !_vm.$v.input_bookingno.lettersandnumbers)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_lettersandnumbers[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('label',[_vm._v(_vm._s(_vm.form_birthdate[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input_birthdate),expression:"input_birthdate"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.input_birthdate.$error },attrs:{"type":"text","id":"'input_birthdate","name":"input_birthdate","value":"","placeholder":"E.G.: 01.01.1984"},domProps:{"value":(_vm.input_birthdate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.input_birthdate=$event.target.value},function($event){_vm.$v.input_birthdate.$touch()}]}}),_vm._v(" "),(_vm.$v.input_birthdate.$dirty && !_vm.$v.input_birthdate.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_birthdate.$dirty && !_vm.$v.input_birthdate.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_birthdate[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.input_birthdate.$dirty && !_vm.$v.input_birthdate.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_birthdate[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-check',{staticClass:"p-svg p-round p-pulse",attrs:{"color":"success","value":"ABB"},model:{value:(_vm.checkedBoxes),callback:function ($$v) {_vm.checkedBoxes=$$v},expression:"checkedBoxes"}},[_c('svg',{staticClass:"svg svg-icon",attrs:{"slot":"extra","viewBox":"0 0 20 20"},slot:"extra"},[_c('path',{staticStyle:{"stroke":"white","fill":"white"},attrs:{"d":"M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"}})])]),_vm._v(" "),_c('span',{staticClass:"skin-color",staticStyle:{"font-size":"1.0833em"}},[_vm._v(_vm._s(_vm.checkboxtext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('hr'),_vm._v(" "),((!_vm.checkValidity() && _vm.get_FlagRebookingBookingnoLoginIsReadyForLogin === false) || (!_vm.checkValidity() && _vm.get_FlagRebookingBookingnoLoginIsReadyForLogin === true))?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.getbookinno[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.checkValidity() && _vm.get_FlagRebookingBookingnoLoginIsReadyForLogin === true)?_c('button',{staticClass:"btn-large icon-check-rebooking uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },style:({ background: '#FDB714' }),attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.getbookinno[_vm.getCurrentLocale]))]):_vm._e()],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box-wrapper style1"},[_c('div',{staticClass:"search-box"},[_c('ul',{staticClass:"search-tabs clearfix"},[(_vm.modulo === 'booking')?_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flights-tab","data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-plane-right takeoff-effect"}),_vm._v("\n                    "+_vm._s(_vm.searchboxflights[_vm.getCurrentLocale])+"\n                ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"visible-mobile"},[_c('ul',{staticClass:"search-tabs clearfix",attrs:{"id":"mobile-search-tabs"}},[(_vm.modulo === 'booking')?_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flights-tab"}},[_vm._v(_vm._s(_vm.searchboxflights[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('li',[_c('a',{attrs:{"href":"#packagetours-tab"}},[_vm._v(_vm._s(_vm.searchboxpackagetours[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('li',[_c('a',{attrs:{"href":"#seat-tab"}},[_vm._v(_vm._s(_vm.searchboxseat[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('li',[_c('a',{attrs:{"href":"#luggage-tab"}},[_vm._v(_vm._s(_vm.searchboxluggage[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flights-tab"}},[_vm._v(_vm._s(_vm.searchboxflights_services[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'rebooking')?_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#rebooking-tab"}},[_vm._v(_vm._s(_vm.searchboxrebooking[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#help-tab"}},[_vm._v(_vm._s(_vm.searchboxhelp[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"search-tab-content"},[(_vm.modulo === 'booking')?_c('div',{staticClass:"tab-pane fade active in",attrs:{"id":"flights-tab"}},[_c('sdr-shared-flightsearch-tab',{attrs:{"modulo":_vm.modulo}})],1):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"tab-pane fade",attrs:{"id":"packagetours-tab"}},[_c('sdr-shared-packagetours-tab')],1):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"tab-pane fade",attrs:{"id":"seat-tab"}},[_c('sdr-shared-seat-tab')],1):_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"tab-pane fade",attrs:{"id":"luggage-tab"}},[_c('sdr-shared-luggage-tab')],1):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"tab-pane fade active in",attrs:{"id":"flights-tab"}},[_c('sdr-shared-flightsearch-tab',{attrs:{"modulo":_vm.modulo}})],1):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"tab-pane fade",attrs:{"id":"bookingno-tab"}},[_c('sdr-shared-bookingno-tab')],1):_vm._e(),_vm._v(" "),(_vm.modulo === 'rebooking')?_c('div',{staticClass:"tab-pane fade active in",attrs:{"id":"rebooking-tab"}},[_c('sdr-shared-rebooking-tab')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"help-tab"}},[_c('sdr-shared-help-tab')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyDestinations_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3b265c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyDestinations_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(410)
  __webpack_require__(412)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e3b265c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyDestinations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3b265c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyDestinations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(411);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("76706a17", content, true, {});

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".image-box .discount[data-v-5e3b265c]{text-indent:4px}", ""]);

// exports


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(413);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("029fe496", content, true, {});

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".hover-effect:after{xbackground-color:#ec008b}.five-stars-container{font-size:13px;line-height:1.4em}.image-box.style9 .details{text-align:left}.floatingicon{float:left;text-align:start;margin-right:7px;margin-top:5px;width:2.2em;height:2.2em}.image-carousel.style3{margin-bottom:0}.smallSelectorDescs{font-size:12px!important;text-transform:none!important;font-weight:500!important;margin-bottom:7px!important}.buttonglowing{background-color:#004a7f;-webkit-border-radius:5px;border-radius:5px;border:none;color:#fff;cursor:pointer;-webkit-animation:glowing 1.5s infinite;-moz-animation:glowing 1.5s infinite;-o-animation:glowing 1.5s infinite;animation:glowing 1.5s infinite}@-webkit-keyframes glowing{0%{background-color:#e11a33;-webkit-box-shadow:0 0 10px #e11a33}50%{background-color:#7c2525;-webkit-box-shadow:0 0 20px #7c2525}to{background-color:#e11a33;-webkit-box-shadow:0 0 10px #e11a33}}@-moz-keyframes glowing{0%{background-color:#e11a33;-moz-box-shadow:0 0 10px #e11a33}50%{background-color:#7c2525;-moz-box-shadow:0 0 20px #7c2525}to{background-color:#e11a33;-moz-box-shadow:0 0 10px #e11a33}}@-o-keyframes glowing{0%{background-color:#e11a33;box-shadow:0 0 10px #e11a33}50%{background-color:#7c2525;box-shadow:0 0 20px #7c2525}to{background-color:#e11a33;box-shadow:0 0 10px #e11a33}}@keyframes glowing{0%{background-color:#e11a33;box-shadow:0 0 10px #e11a33}50%{background-color:#7c2525;box-shadow:0 0 0 #7c2525}to{background-color:#e11a33;box-shadow:0 0 10px #e11a33}}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1{font-size:1.5em}}", ""]);

// exports


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyDestinationsBarChart_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyDestinationsBarChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("43d25ee0", content, true, {});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VueCharts */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseCharts__ = __webpack_require__(419);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["a"]; });
/* unused harmony reexport HorizontalBar */
/* unused harmony reexport Doughnut */
/* unused harmony reexport Line */
/* unused harmony reexport Pie */
/* unused harmony reexport PolarArea */
/* unused harmony reexport Radar */
/* unused harmony reexport Bubble */
/* unused harmony reexport Scatter */
/* unused harmony reexport mixins */
/* unused harmony reexport generateChart */


var VueCharts = {
  Bar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["a" /* Bar */],
  HorizontalBar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["d" /* HorizontalBar */],
  Doughnut: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["c" /* Doughnut */],
  Line: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["e" /* Line */],
  Pie: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["f" /* Pie */],
  PolarArea: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["g" /* PolarArea */],
  Radar: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["h" /* Radar */],
  Bubble: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["b" /* Bubble */],
  Scatter: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["i" /* Scatter */],
  mixins: __WEBPACK_IMPORTED_MODULE_0__mixins_index_js__["a" /* default */],
  generateChart: __WEBPACK_IMPORTED_MODULE_1__BaseCharts__["j" /* generateChart */],
  render: function render() {
    return console.error('[vue-chartjs]: This is not a vue component. It is the whole object containing all vue components. Please import the named export or access the components over the dot notation. For more info visit https://vue-chartjs.org/#/home?id=quick-start');
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (VueCharts);


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reactiveData */
/* unused harmony export reactiveProp */
function dataHandler(newData, oldData) {
  if (oldData) {
    var chart = this.$data._chart;
    var newDatasetLabels = newData.datasets.map(function (dataset) {
      return dataset.label;
    });
    var oldDatasetLabels = oldData.datasets.map(function (dataset) {
      return dataset.label;
    });
    var oldLabels = JSON.stringify(oldDatasetLabels);
    var newLabels = JSON.stringify(newDatasetLabels);

    if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
      newData.datasets.forEach(function (dataset, i) {
        var oldDatasetKeys = Object.keys(oldData.datasets[i]);
        var newDatasetKeys = Object.keys(dataset);
        var deletionKeys = oldDatasetKeys.filter(function (key) {
          return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
        });
        deletionKeys.forEach(function (deletionKey) {
          delete chart.data.datasets[i][deletionKey];
        });

        for (var attribute in dataset) {
          if (dataset.hasOwnProperty(attribute)) {
            chart.data.datasets[i][attribute] = dataset[attribute];
          }
        }
      });

      if (newData.hasOwnProperty('labels')) {
        chart.data.labels = newData.labels;
        this.$emit('labels:update');
      }

      if (newData.hasOwnProperty('xLabels')) {
        chart.data.xLabels = newData.xLabels;
        this.$emit('xlabels:update');
      }

      if (newData.hasOwnProperty('yLabels')) {
        chart.data.yLabels = newData.yLabels;
        this.$emit('ylabels:update');
      }

      chart.update();
      this.$emit('chart:update');
    } else {
      if (chart) {
        chart.destroy();
        this.$emit('chart:destroy');
      }

      this.renderChart(this.chartData, this.options);
      this.$emit('chart:render');
    }
  } else {
    if (this.$data._chart) {
      this.$data._chart.destroy();

      this.$emit('chart:destroy');
    }

    this.renderChart(this.chartData, this.options);
    this.$emit('chart:render');
  }
}

var reactiveData = {
  data: function data() {
    return {
      chartData: null
    };
  },
  watch: {
    'chartData': dataHandler
  }
};
var reactiveProp = {
  props: {
    chartData: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  watch: {
    'chartData': dataHandler
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  reactiveData: reactiveData,
  reactiveProp: reactiveProp
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = generateChart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Bar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HorizontalBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Doughnut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Pie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PolarArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Radar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Bubble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Scatter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);

function generateChart(chartId, chartType) {
  return {
    render: function render(createElement) {
      return createElement('div', {
        style: this.styles,
        class: this.cssClasses
      }, [createElement('canvas', {
        attrs: {
          id: this.chartId,
          width: this.width,
          height: this.height
        },
        ref: 'canvas'
      })]);
    },
    props: {
      chartId: {
        default: chartId,
        type: String
      },
      width: {
        default: 400,
        type: Number
      },
      height: {
        default: 400,
        type: Number
      },
      cssClasses: {
        type: String,
        default: ''
      },
      styles: {
        type: Object
      },
      plugins: {
        type: Array,
        default: function _default() {
          return [];
        }
      }
    },
    data: function data() {
      return {
        _chart: null,
        _plugins: this.plugins
      };
    },
    methods: {
      addPlugin: function addPlugin(plugin) {
        this.$data._plugins.push(plugin);
      },
      generateLegend: function generateLegend() {
        if (this.$data._chart) {
          return this.$data._chart.generateLegend();
        }
      },
      renderChart: function renderChart(data, options) {
        if (this.$data._chart) this.$data._chart.destroy();
        this.$data._chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.$refs.canvas.getContext('2d'), {
          type: chartType,
          data: data,
          options: options,
          plugins: this.$data._plugins
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.$data._chart) {
        this.$data._chart.destroy();
      }
    }
  };
}
var Bar = generateChart('bar-chart', 'bar');
var HorizontalBar = generateChart('horizontalbar-chart', 'horizontalBar');
var Doughnut = generateChart('doughnut-chart', 'doughnut');
var Line = generateChart('line-chart', 'line');
var Pie = generateChart('pie-chart', 'pie');
var PolarArea = generateChart('polar-chart', 'polarArea');
var Radar = generateChart('radar-chart', 'radar');
var Bubble = generateChart('bubble-chart', 'bubble');
var Scatter = generateChart('scatter-chart', 'scatter');
/* unused harmony default export */ var _unused_webpack_default_export = ({
  Bar: Bar,
  HorizontalBar: HorizontalBar,
  Doughnut: Doughnut,
  Line: Line,
  Pie: Pie,
  PolarArea: PolarArea,
  Radar: Radar,
  Bubble: Bubble,
  Scatter: Scatter
});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Chart.js v2.9.3
 * https://www.chartjs.org
 * (c) 2019 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
 true ? module.exports = factory(function() { try { return __webpack_require__(0); } catch(e) { } }()) :
typeof define === 'function' && define.amd ? define(['require'], function(require) { return factory(function() { try { return require('moment'); } catch(e) { } }()); }) :
(global = global || self, global.Chart = factory(global.moment));
}(this, (function (moment) { 'use strict';

moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var colorName = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

var conversions = createCommonjsModule(function (module) {
/* MIT license */


// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)

var reverseKeywords = {};
for (var key in colorName) {
	if (colorName.hasOwnProperty(key)) {
		reverseKeywords[colorName[key]] = key;
	}
}

var convert = module.exports = {
	rgb: {channels: 3, labels: 'rgb'},
	hsl: {channels: 3, labels: 'hsl'},
	hsv: {channels: 3, labels: 'hsv'},
	hwb: {channels: 3, labels: 'hwb'},
	cmyk: {channels: 4, labels: 'cmyk'},
	xyz: {channels: 3, labels: 'xyz'},
	lab: {channels: 3, labels: 'lab'},
	lch: {channels: 3, labels: 'lch'},
	hex: {channels: 1, labels: ['hex']},
	keyword: {channels: 1, labels: ['keyword']},
	ansi16: {channels: 1, labels: ['ansi16']},
	ansi256: {channels: 1, labels: ['ansi256']},
	hcg: {channels: 3, labels: ['h', 'c', 'g']},
	apple: {channels: 3, labels: ['r16', 'g16', 'b16']},
	gray: {channels: 1, labels: ['gray']}
};

// hide .channels and .labels properties
for (var model in convert) {
	if (convert.hasOwnProperty(model)) {
		if (!('channels' in convert[model])) {
			throw new Error('missing channels property: ' + model);
		}

		if (!('labels' in convert[model])) {
			throw new Error('missing channel labels property: ' + model);
		}

		if (convert[model].labels.length !== convert[model].channels) {
			throw new Error('channel and label counts mismatch: ' + model);
		}

		var channels = convert[model].channels;
		var labels = convert[model].labels;
		delete convert[model].channels;
		delete convert[model].labels;
		Object.defineProperty(convert[model], 'channels', {value: channels});
		Object.defineProperty(convert[model], 'labels', {value: labels});
	}
}

convert.rgb.hsl = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var min = Math.min(r, g, b);
	var max = Math.max(r, g, b);
	var delta = max - min;
	var h;
	var s;
	var l;

	if (max === min) {
		h = 0;
	} else if (r === max) {
		h = (g - b) / delta;
	} else if (g === max) {
		h = 2 + (b - r) / delta;
	} else if (b === max) {
		h = 4 + (r - g) / delta;
	}

	h = Math.min(h * 60, 360);

	if (h < 0) {
		h += 360;
	}

	l = (min + max) / 2;

	if (max === min) {
		s = 0;
	} else if (l <= 0.5) {
		s = delta / (max + min);
	} else {
		s = delta / (2 - max - min);
	}

	return [h, s * 100, l * 100];
};

convert.rgb.hsv = function (rgb) {
	var rdif;
	var gdif;
	var bdif;
	var h;
	var s;

	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var v = Math.max(r, g, b);
	var diff = v - Math.min(r, g, b);
	var diffc = function (c) {
		return (v - c) / 6 / diff + 1 / 2;
	};

	if (diff === 0) {
		h = s = 0;
	} else {
		s = diff / v;
		rdif = diffc(r);
		gdif = diffc(g);
		bdif = diffc(b);

		if (r === v) {
			h = bdif - gdif;
		} else if (g === v) {
			h = (1 / 3) + rdif - bdif;
		} else if (b === v) {
			h = (2 / 3) + gdif - rdif;
		}
		if (h < 0) {
			h += 1;
		} else if (h > 1) {
			h -= 1;
		}
	}

	return [
		h * 360,
		s * 100,
		v * 100
	];
};

convert.rgb.hwb = function (rgb) {
	var r = rgb[0];
	var g = rgb[1];
	var b = rgb[2];
	var h = convert.rgb.hsl(rgb)[0];
	var w = 1 / 255 * Math.min(r, Math.min(g, b));

	b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

	return [h, w * 100, b * 100];
};

convert.rgb.cmyk = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var c;
	var m;
	var y;
	var k;

	k = Math.min(1 - r, 1 - g, 1 - b);
	c = (1 - r - k) / (1 - k) || 0;
	m = (1 - g - k) / (1 - k) || 0;
	y = (1 - b - k) / (1 - k) || 0;

	return [c * 100, m * 100, y * 100, k * 100];
};

/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */
function comparativeDistance(x, y) {
	return (
		Math.pow(x[0] - y[0], 2) +
		Math.pow(x[1] - y[1], 2) +
		Math.pow(x[2] - y[2], 2)
	);
}

convert.rgb.keyword = function (rgb) {
	var reversed = reverseKeywords[rgb];
	if (reversed) {
		return reversed;
	}

	var currentClosestDistance = Infinity;
	var currentClosestKeyword;

	for (var keyword in colorName) {
		if (colorName.hasOwnProperty(keyword)) {
			var value = colorName[keyword];

			// Compute comparative distance
			var distance = comparativeDistance(rgb, value);

			// Check if its less, if so set as closest
			if (distance < currentClosestDistance) {
				currentClosestDistance = distance;
				currentClosestKeyword = keyword;
			}
		}
	}

	return currentClosestKeyword;
};

convert.keyword.rgb = function (keyword) {
	return colorName[keyword];
};

convert.rgb.xyz = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;

	// assume sRGB
	r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

	var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

	return [x * 100, y * 100, z * 100];
};

convert.rgb.lab = function (rgb) {
	var xyz = convert.rgb.xyz(rgb);
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.hsl.rgb = function (hsl) {
	var h = hsl[0] / 360;
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var t1;
	var t2;
	var t3;
	var rgb;
	var val;

	if (s === 0) {
		val = l * 255;
		return [val, val, val];
	}

	if (l < 0.5) {
		t2 = l * (1 + s);
	} else {
		t2 = l + s - l * s;
	}

	t1 = 2 * l - t2;

	rgb = [0, 0, 0];
	for (var i = 0; i < 3; i++) {
		t3 = h + 1 / 3 * -(i - 1);
		if (t3 < 0) {
			t3++;
		}
		if (t3 > 1) {
			t3--;
		}

		if (6 * t3 < 1) {
			val = t1 + (t2 - t1) * 6 * t3;
		} else if (2 * t3 < 1) {
			val = t2;
		} else if (3 * t3 < 2) {
			val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
		} else {
			val = t1;
		}

		rgb[i] = val * 255;
	}

	return rgb;
};

convert.hsl.hsv = function (hsl) {
	var h = hsl[0];
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var smin = s;
	var lmin = Math.max(l, 0.01);
	var sv;
	var v;

	l *= 2;
	s *= (l <= 1) ? l : 2 - l;
	smin *= lmin <= 1 ? lmin : 2 - lmin;
	v = (l + s) / 2;
	sv = l === 0 ? (2 * smin) / (lmin + smin) : (2 * s) / (l + s);

	return [h, sv * 100, v * 100];
};

convert.hsv.rgb = function (hsv) {
	var h = hsv[0] / 60;
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var hi = Math.floor(h) % 6;

	var f = h - Math.floor(h);
	var p = 255 * v * (1 - s);
	var q = 255 * v * (1 - (s * f));
	var t = 255 * v * (1 - (s * (1 - f)));
	v *= 255;

	switch (hi) {
		case 0:
			return [v, t, p];
		case 1:
			return [q, v, p];
		case 2:
			return [p, v, t];
		case 3:
			return [p, q, v];
		case 4:
			return [t, p, v];
		case 5:
			return [v, p, q];
	}
};

convert.hsv.hsl = function (hsv) {
	var h = hsv[0];
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;
	var vmin = Math.max(v, 0.01);
	var lmin;
	var sl;
	var l;

	l = (2 - s) * v;
	lmin = (2 - s) * vmin;
	sl = s * vmin;
	sl /= (lmin <= 1) ? lmin : 2 - lmin;
	sl = sl || 0;
	l /= 2;

	return [h, sl * 100, l * 100];
};

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function (hwb) {
	var h = hwb[0] / 360;
	var wh = hwb[1] / 100;
	var bl = hwb[2] / 100;
	var ratio = wh + bl;
	var i;
	var v;
	var f;
	var n;

	// wh + bl cant be > 1
	if (ratio > 1) {
		wh /= ratio;
		bl /= ratio;
	}

	i = Math.floor(6 * h);
	v = 1 - bl;
	f = 6 * h - i;

	if ((i & 0x01) !== 0) {
		f = 1 - f;
	}

	n = wh + f * (v - wh); // linear interpolation

	var r;
	var g;
	var b;
	switch (i) {
		default:
		case 6:
		case 0: r = v; g = n; b = wh; break;
		case 1: r = n; g = v; b = wh; break;
		case 2: r = wh; g = v; b = n; break;
		case 3: r = wh; g = n; b = v; break;
		case 4: r = n; g = wh; b = v; break;
		case 5: r = v; g = wh; b = n; break;
	}

	return [r * 255, g * 255, b * 255];
};

convert.cmyk.rgb = function (cmyk) {
	var c = cmyk[0] / 100;
	var m = cmyk[1] / 100;
	var y = cmyk[2] / 100;
	var k = cmyk[3] / 100;
	var r;
	var g;
	var b;

	r = 1 - Math.min(1, c * (1 - k) + k);
	g = 1 - Math.min(1, m * (1 - k) + k);
	b = 1 - Math.min(1, y * (1 - k) + k);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.rgb = function (xyz) {
	var x = xyz[0] / 100;
	var y = xyz[1] / 100;
	var z = xyz[2] / 100;
	var r;
	var g;
	var b;

	r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

	// assume sRGB
	r = r > 0.0031308
		? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
		: r * 12.92;

	g = g > 0.0031308
		? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
		: g * 12.92;

	b = b > 0.0031308
		? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
		: b * 12.92;

	r = Math.min(Math.max(0, r), 1);
	g = Math.min(Math.max(0, g), 1);
	b = Math.min(Math.max(0, b), 1);

	return [r * 255, g * 255, b * 255];
};

convert.xyz.lab = function (xyz) {
	var x = xyz[0];
	var y = xyz[1];
	var z = xyz[2];
	var l;
	var a;
	var b;

	x /= 95.047;
	y /= 100;
	z /= 108.883;

	x = x > 0.008856 ? Math.pow(x, 1 / 3) : (7.787 * x) + (16 / 116);
	y = y > 0.008856 ? Math.pow(y, 1 / 3) : (7.787 * y) + (16 / 116);
	z = z > 0.008856 ? Math.pow(z, 1 / 3) : (7.787 * z) + (16 / 116);

	l = (116 * y) - 16;
	a = 500 * (x - y);
	b = 200 * (y - z);

	return [l, a, b];
};

convert.lab.xyz = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var x;
	var y;
	var z;

	y = (l + 16) / 116;
	x = a / 500 + y;
	z = y - b / 200;

	var y2 = Math.pow(y, 3);
	var x2 = Math.pow(x, 3);
	var z2 = Math.pow(z, 3);
	y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
	x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
	z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

	x *= 95.047;
	y *= 100;
	z *= 108.883;

	return [x, y, z];
};

convert.lab.lch = function (lab) {
	var l = lab[0];
	var a = lab[1];
	var b = lab[2];
	var hr;
	var h;
	var c;

	hr = Math.atan2(b, a);
	h = hr * 360 / 2 / Math.PI;

	if (h < 0) {
		h += 360;
	}

	c = Math.sqrt(a * a + b * b);

	return [l, c, h];
};

convert.lch.lab = function (lch) {
	var l = lch[0];
	var c = lch[1];
	var h = lch[2];
	var a;
	var b;
	var hr;

	hr = h / 360 * 2 * Math.PI;
	a = c * Math.cos(hr);
	b = c * Math.sin(hr);

	return [l, a, b];
};

convert.rgb.ansi16 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];
	var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

	value = Math.round(value / 50);

	if (value === 0) {
		return 30;
	}

	var ansi = 30
		+ ((Math.round(b / 255) << 2)
		| (Math.round(g / 255) << 1)
		| Math.round(r / 255));

	if (value === 2) {
		ansi += 60;
	}

	return ansi;
};

convert.hsv.ansi16 = function (args) {
	// optimization here; we already know the value and don't need to get
	// it converted for us.
	return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};

convert.rgb.ansi256 = function (args) {
	var r = args[0];
	var g = args[1];
	var b = args[2];

	// we use the extended greyscale palette here, with the exception of
	// black and white. normal palette only has 4 greyscale shades.
	if (r === g && g === b) {
		if (r < 8) {
			return 16;
		}

		if (r > 248) {
			return 231;
		}

		return Math.round(((r - 8) / 247) * 24) + 232;
	}

	var ansi = 16
		+ (36 * Math.round(r / 255 * 5))
		+ (6 * Math.round(g / 255 * 5))
		+ Math.round(b / 255 * 5);

	return ansi;
};

convert.ansi16.rgb = function (args) {
	var color = args % 10;

	// handle greyscale
	if (color === 0 || color === 7) {
		if (args > 50) {
			color += 3.5;
		}

		color = color / 10.5 * 255;

		return [color, color, color];
	}

	var mult = (~~(args > 50) + 1) * 0.5;
	var r = ((color & 1) * mult) * 255;
	var g = (((color >> 1) & 1) * mult) * 255;
	var b = (((color >> 2) & 1) * mult) * 255;

	return [r, g, b];
};

convert.ansi256.rgb = function (args) {
	// handle greyscale
	if (args >= 232) {
		var c = (args - 232) * 10 + 8;
		return [c, c, c];
	}

	args -= 16;

	var rem;
	var r = Math.floor(args / 36) / 5 * 255;
	var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
	var b = (rem % 6) / 5 * 255;

	return [r, g, b];
};

convert.rgb.hex = function (args) {
	var integer = ((Math.round(args[0]) & 0xFF) << 16)
		+ ((Math.round(args[1]) & 0xFF) << 8)
		+ (Math.round(args[2]) & 0xFF);

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.hex.rgb = function (args) {
	var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
	if (!match) {
		return [0, 0, 0];
	}

	var colorString = match[0];

	if (match[0].length === 3) {
		colorString = colorString.split('').map(function (char) {
			return char + char;
		}).join('');
	}

	var integer = parseInt(colorString, 16);
	var r = (integer >> 16) & 0xFF;
	var g = (integer >> 8) & 0xFF;
	var b = integer & 0xFF;

	return [r, g, b];
};

convert.rgb.hcg = function (rgb) {
	var r = rgb[0] / 255;
	var g = rgb[1] / 255;
	var b = rgb[2] / 255;
	var max = Math.max(Math.max(r, g), b);
	var min = Math.min(Math.min(r, g), b);
	var chroma = (max - min);
	var grayscale;
	var hue;

	if (chroma < 1) {
		grayscale = min / (1 - chroma);
	} else {
		grayscale = 0;
	}

	if (chroma <= 0) {
		hue = 0;
	} else
	if (max === r) {
		hue = ((g - b) / chroma) % 6;
	} else
	if (max === g) {
		hue = 2 + (b - r) / chroma;
	} else {
		hue = 4 + (r - g) / chroma + 4;
	}

	hue /= 6;
	hue %= 1;

	return [hue * 360, chroma * 100, grayscale * 100];
};

convert.hsl.hcg = function (hsl) {
	var s = hsl[1] / 100;
	var l = hsl[2] / 100;
	var c = 1;
	var f = 0;

	if (l < 0.5) {
		c = 2.0 * s * l;
	} else {
		c = 2.0 * s * (1.0 - l);
	}

	if (c < 1.0) {
		f = (l - 0.5 * c) / (1.0 - c);
	}

	return [hsl[0], c * 100, f * 100];
};

convert.hsv.hcg = function (hsv) {
	var s = hsv[1] / 100;
	var v = hsv[2] / 100;

	var c = s * v;
	var f = 0;

	if (c < 1.0) {
		f = (v - c) / (1 - c);
	}

	return [hsv[0], c * 100, f * 100];
};

convert.hcg.rgb = function (hcg) {
	var h = hcg[0] / 360;
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	if (c === 0.0) {
		return [g * 255, g * 255, g * 255];
	}

	var pure = [0, 0, 0];
	var hi = (h % 1) * 6;
	var v = hi % 1;
	var w = 1 - v;
	var mg = 0;

	switch (Math.floor(hi)) {
		case 0:
			pure[0] = 1; pure[1] = v; pure[2] = 0; break;
		case 1:
			pure[0] = w; pure[1] = 1; pure[2] = 0; break;
		case 2:
			pure[0] = 0; pure[1] = 1; pure[2] = v; break;
		case 3:
			pure[0] = 0; pure[1] = w; pure[2] = 1; break;
		case 4:
			pure[0] = v; pure[1] = 0; pure[2] = 1; break;
		default:
			pure[0] = 1; pure[1] = 0; pure[2] = w;
	}

	mg = (1.0 - c) * g;

	return [
		(c * pure[0] + mg) * 255,
		(c * pure[1] + mg) * 255,
		(c * pure[2] + mg) * 255
	];
};

convert.hcg.hsv = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var v = c + g * (1.0 - c);
	var f = 0;

	if (v > 0.0) {
		f = c / v;
	}

	return [hcg[0], f * 100, v * 100];
};

convert.hcg.hsl = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;

	var l = g * (1.0 - c) + 0.5 * c;
	var s = 0;

	if (l > 0.0 && l < 0.5) {
		s = c / (2 * l);
	} else
	if (l >= 0.5 && l < 1.0) {
		s = c / (2 * (1 - l));
	}

	return [hcg[0], s * 100, l * 100];
};

convert.hcg.hwb = function (hcg) {
	var c = hcg[1] / 100;
	var g = hcg[2] / 100;
	var v = c + g * (1.0 - c);
	return [hcg[0], (v - c) * 100, (1 - v) * 100];
};

convert.hwb.hcg = function (hwb) {
	var w = hwb[1] / 100;
	var b = hwb[2] / 100;
	var v = 1 - b;
	var c = v - w;
	var g = 0;

	if (c < 1) {
		g = (v - c) / (1 - c);
	}

	return [hwb[0], c * 100, g * 100];
};

convert.apple.rgb = function (apple) {
	return [(apple[0] / 65535) * 255, (apple[1] / 65535) * 255, (apple[2] / 65535) * 255];
};

convert.rgb.apple = function (rgb) {
	return [(rgb[0] / 255) * 65535, (rgb[1] / 255) * 65535, (rgb[2] / 255) * 65535];
};

convert.gray.rgb = function (args) {
	return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
};

convert.gray.hsl = convert.gray.hsv = function (args) {
	return [0, 0, args[0]];
};

convert.gray.hwb = function (gray) {
	return [0, 100, gray[0]];
};

convert.gray.cmyk = function (gray) {
	return [0, 0, 0, gray[0]];
};

convert.gray.lab = function (gray) {
	return [gray[0], 0, 0];
};

convert.gray.hex = function (gray) {
	var val = Math.round(gray[0] / 100 * 255) & 0xFF;
	var integer = (val << 16) + (val << 8) + val;

	var string = integer.toString(16).toUpperCase();
	return '000000'.substring(string.length) + string;
};

convert.rgb.gray = function (rgb) {
	var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
	return [val / 255 * 100];
};
});
var conversions_1 = conversions.rgb;
var conversions_2 = conversions.hsl;
var conversions_3 = conversions.hsv;
var conversions_4 = conversions.hwb;
var conversions_5 = conversions.cmyk;
var conversions_6 = conversions.xyz;
var conversions_7 = conversions.lab;
var conversions_8 = conversions.lch;
var conversions_9 = conversions.hex;
var conversions_10 = conversions.keyword;
var conversions_11 = conversions.ansi16;
var conversions_12 = conversions.ansi256;
var conversions_13 = conversions.hcg;
var conversions_14 = conversions.apple;
var conversions_15 = conversions.gray;

/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/

function buildGraph() {
	var graph = {};
	// https://jsperf.com/object-keys-vs-for-in-with-closure/3
	var models = Object.keys(conversions);

	for (var len = models.length, i = 0; i < len; i++) {
		graph[models[i]] = {
			// http://jsperf.com/1-vs-infinity
			// micro-opt, but this is simple.
			distance: -1,
			parent: null
		};
	}

	return graph;
}

// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
	var graph = buildGraph();
	var queue = [fromModel]; // unshift -> queue -> pop

	graph[fromModel].distance = 0;

	while (queue.length) {
		var current = queue.pop();
		var adjacents = Object.keys(conversions[current]);

		for (var len = adjacents.length, i = 0; i < len; i++) {
			var adjacent = adjacents[i];
			var node = graph[adjacent];

			if (node.distance === -1) {
				node.distance = graph[current].distance + 1;
				node.parent = current;
				queue.unshift(adjacent);
			}
		}
	}

	return graph;
}

function link(from, to) {
	return function (args) {
		return to(from(args));
	};
}

function wrapConversion(toModel, graph) {
	var path = [graph[toModel].parent, toModel];
	var fn = conversions[graph[toModel].parent][toModel];

	var cur = graph[toModel].parent;
	while (graph[cur].parent) {
		path.unshift(graph[cur].parent);
		fn = link(conversions[graph[cur].parent][cur], fn);
		cur = graph[cur].parent;
	}

	fn.conversion = path;
	return fn;
}

var route = function (fromModel) {
	var graph = deriveBFS(fromModel);
	var conversion = {};

	var models = Object.keys(graph);
	for (var len = models.length, i = 0; i < len; i++) {
		var toModel = models[i];
		var node = graph[toModel];

		if (node.parent === null) {
			// no possible conversion, or this node is the source model.
			continue;
		}

		conversion[toModel] = wrapConversion(toModel, graph);
	}

	return conversion;
};

var convert = {};

var models = Object.keys(conversions);

function wrapRaw(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		return fn(args);
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

function wrapRounded(fn) {
	var wrappedFn = function (args) {
		if (args === undefined || args === null) {
			return args;
		}

		if (arguments.length > 1) {
			args = Array.prototype.slice.call(arguments);
		}

		var result = fn(args);

		// we're assuming the result is an array here.
		// see notice in conversions.js; don't use box types
		// in conversion functions.
		if (typeof result === 'object') {
			for (var len = result.length, i = 0; i < len; i++) {
				result[i] = Math.round(result[i]);
			}
		}

		return result;
	};

	// preserve .conversion property if there is one
	if ('conversion' in fn) {
		wrappedFn.conversion = fn.conversion;
	}

	return wrappedFn;
}

models.forEach(function (fromModel) {
	convert[fromModel] = {};

	Object.defineProperty(convert[fromModel], 'channels', {value: conversions[fromModel].channels});
	Object.defineProperty(convert[fromModel], 'labels', {value: conversions[fromModel].labels});

	var routes = route(fromModel);
	var routeModels = Object.keys(routes);

	routeModels.forEach(function (toModel) {
		var fn = routes[toModel];

		convert[fromModel][toModel] = wrapRounded(fn);
		convert[fromModel][toModel].raw = wrapRaw(fn);
	});
});

var colorConvert = convert;

var colorName$1 = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/* MIT license */


var colorString = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
};

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3,4})$/i,
       hex =  /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr),
       hexAlpha = "";
   if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha + hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
         a = Math.round((parseInt(hexAlpha, 16) / 255) * 100) / 100;
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgba, a) {
   var a = (a !== undefined && rgba.length === 3) ? a : rgba[3];
   return "#" + hexDouble(rgba[0]) 
              + hexDouble(rgba[1])
              + hexDouble(rgba[2])
              + (
                 (a >= 0 && a < 1)
                 ? hexDouble(Math.round(a * 255))
                 : ""
              );
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorName$1) {
   reverseNames[colorName$1[name]] = name;
}

/* MIT license */



var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = colorString.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = colorString.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = colorString.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return colorString.hexString(this.values.rgb);
	},
	rgbString: function () {
		return colorString.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return colorString.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return colorString.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return colorString.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return colorString.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return colorString.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return colorString.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = colorConvert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

var chartjsColor = Color;

/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array (including typed arrays), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @function
	 */
	isArray: function(value) {
		if (Array.isArray && Array.isArray(value)) {
			return true;
		}
		var type = Object.prototype.toString.call(value);
		if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
			return true;
		}
		return false;
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns true if `value` is a finite number, else returns false
	 * @param {*} value  - The value to test.
	 * @returns {boolean}
	 */
	isFinite: function(value) {
		return (typeof value === 'number' || value instanceof Number) && isFinite(value);
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {object|Array} loopable - The object or array to be iterated.
	 * @param {function} fn - The function to call for each item.
	 * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see https://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @param {object} [options] - Merging options:
	 * @param {function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {object} target - The target object in which all sources are merged into.
	 * @param {object|object[]} source - Object(s) to merge into `target`.
	 * @returns {object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {object} target - The target object in which all objects are merged into.
	 * @param {object} arg1 - Object containing additional properties to merge in target.
	 * @param {object} argN - Additional objects containing properties to merge in target.
	 * @returns {object} The `target` object.
	 */
	extend: Object.assign || function(target) {
		return helpers.merge(target, [].slice.call(arguments, 1), {
			merger: function(key, dst, src) {
				dst[key] = src[key];
			}
		});
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	},

	_deprecated: function(scope, value, previous, current) {
		if (value !== undefined) {
			console.warn(scope + ': "' + previous +
				'" is deprecated. Please use "' + current + '" instead');
		}
	}
};

var helpers_core = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

var helpers_easing = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.easingEffects = effects;

var PI = Math.PI;
var RAD_PER_DEG = PI / 180;
var DOUBLE_PI = PI * 2;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;

/**
 * @namespace Chart.helpers.canvas
 */
var exports$1 = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {number} width - The rectangle's width.
	 * @param {number} height - The rectangle's height.
	 * @param {number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var r = Math.min(radius, height / 2, width / 2);
			var left = x + r;
			var top = y + r;
			var right = x + width - r;
			var bottom = y + height - r;

			ctx.moveTo(x, top);
			if (left < right && top < bottom) {
				ctx.arc(left, top, r, -PI, -HALF_PI);
				ctx.arc(right, top, r, -HALF_PI, 0);
				ctx.arc(right, bottom, r, 0, HALF_PI);
				ctx.arc(left, bottom, r, HALF_PI, PI);
			} else if (left < right) {
				ctx.moveTo(left, y);
				ctx.arc(right, top, r, -HALF_PI, HALF_PI);
				ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
			} else if (top < bottom) {
				ctx.arc(left, top, r, -PI, 0);
				ctx.arc(left, bottom, r, 0, PI);
			} else {
				ctx.arc(left, top, r, -PI, PI);
			}
			ctx.closePath();
			ctx.moveTo(x, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y, rotation) {
		var type, xOffset, yOffset, size, cornerRadius;
		var rad = (rotation || 0) * RAD_PER_DEG;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.save();
				ctx.translate(x, y);
				ctx.rotate(rad);
				ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
				ctx.restore();
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		ctx.beginPath();

		switch (style) {
		// Default includes circle
		default:
			ctx.arc(x, y, radius, 0, DOUBLE_PI);
			ctx.closePath();
			break;
		case 'triangle':
			ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			rad += TWO_THIRDS_PI;
			ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
			ctx.closePath();
			break;
		case 'rectRounded':
			// NOTE: the rounded rect implementation changed to use `arc` instead of
			// `quadraticCurveTo` since it generates better results when rect is
			// almost a circle. 0.516 (instead of 0.5) produces results with visually
			// closer proportion to the previous impl and it is inscribed in the
			// circle with `radius`. For more details, see the following PRs:
			// https://github.com/chartjs/Chart.js/issues/5597
			// https://github.com/chartjs/Chart.js/issues/5858
			cornerRadius = radius * 0.516;
			size = radius - cornerRadius;
			xOffset = Math.cos(rad + QUARTER_PI) * size;
			yOffset = Math.sin(rad + QUARTER_PI) * size;
			ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
			ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
			ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
			ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
			ctx.closePath();
			break;
		case 'rect':
			if (!rotation) {
				size = Math.SQRT1_2 * radius;
				ctx.rect(x - size, y - size, 2 * size, 2 * size);
				break;
			}
			rad += QUARTER_PI;
			/* falls through */
		case 'rectRot':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + yOffset, y - xOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			ctx.closePath();
			break;
		case 'crossRot':
			rad += QUARTER_PI;
			/* falls through */
		case 'cross':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'star':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			rad += QUARTER_PI;
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x + yOffset, y - xOffset);
			ctx.lineTo(x - yOffset, y + xOffset);
			break;
		case 'line':
			xOffset = Math.cos(rad) * radius;
			yOffset = Math.sin(rad) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			break;
		case 'dash':
			ctx.moveTo(x, y);
			ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
			break;
		}

		ctx.fill();
		ctx.stroke();
	},

	/**
	 * Returns true if the point is inside the rectangle
	 * @param {object} point - The point to test
	 * @param {object} area - The rectangle
	 * @returns {boolean}
	 * @private
	 */
	_isPointInArea: function(point, area) {
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

		return point.x > area.left - epsilon && point.x < area.right + epsilon &&
			point.y > area.top - epsilon && point.y < area.bottom + epsilon;
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		var stepped = target.steppedLine;
		if (stepped) {
			if (stepped === 'middle') {
				var midpoint = (previous.x + target.x) / 2.0;
				ctx.lineTo(midpoint, flip ? target.y : previous.y);
				ctx.lineTo(midpoint, flip ? previous.y : target.y);
			} else if ((stepped === 'after' && !flip) || (stepped !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

var helpers_canvas = exports$1;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.clear = exports$1.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers_core.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports$1.roundedRect.apply(exports$1, arguments);
};

var defaults = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers_core.merge(this[scope] || (this[scope] = {}), values);
	}
};

// TODO(v3): remove 'global' from namespace.  all default are global and
// there's inconsistency around which options are under 'global'
defaults._set('global', {
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	defaultLineHeight: 1.2,
	showLines: true
});

var core_defaults = defaults;

var valueOrDefault = helpers_core.valueOrDefault;

/**
 * Converts the given font object into a CSS font string.
 * @param {object} font - A font object.
 * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */
function toFontString(font) {
	if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
		return null;
	}

	return (font.style ? font.style + ' ' : '')
		+ (font.weight ? font.weight + ' ' : '')
		+ font.size + 'px '
		+ font.family;
}

/**
 * @alias Chart.helpers.options
 * @namespace
 */
var helpers_options = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {number|object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers_core.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Parses font options and returns the font object.
	 * @param {object} options - A object that contains font options to be parsed.
	 * @return {object} The font object.
	 * @todo Support font.* options and renamed to toFont().
	 * @private
	 */
	_parseFont: function(options) {
		var globalDefaults = core_defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var font = {
			family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
			lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
			size: size,
			style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
			weight: null,
			string: ''
		};

		font.string = toFontString(font);
		return font;
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array} inputs - An array of values, falling back to the last value.
	 * @param {object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @param {object} [info] - object to return information about resolution in
	 * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index, info) {
		var cacheable = true;
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
				cacheable = false;
			}
			if (index !== undefined && helpers_core.isArray(value)) {
				value = value[index];
				cacheable = false;
			}
			if (value !== undefined) {
				if (info && !cacheable) {
					info.cacheable = false;
				}
				return value;
			}
		}
	}
};

/**
 * @alias Chart.helpers.math
 * @namespace
 */
var exports$2 = {
	/**
	 * Returns an array of factors sorted from 1 to sqrt(value)
	 * @private
	 */
	_factorize: function(value) {
		var result = [];
		var sqrt = Math.sqrt(value);
		var i;

		for (i = 1; i < sqrt; i++) {
			if (value % i === 0) {
				result.push(i);
				result.push(value / i);
			}
		}
		if (sqrt === (sqrt | 0)) { // if value is a square number
			result.push(sqrt);
		}

		result.sort(function(a, b) {
			return a - b;
		}).pop();
		return result;
	},

	log10: Math.log10 || function(x) {
		var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
		// Check for whole powers of 10,
		// which due to floating point rounding error should be corrected.
		var powerOf10 = Math.round(exponent);
		var isPowerOf10 = x === Math.pow(10, powerOf10);

		return isPowerOf10 ? powerOf10 : exponent;
	}
};

var helpers_math = exports$2;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
 * @namespace Chart.helpers.log10
 * @deprecated since version 2.9.0
 * @todo remove at version 3
 * @private
 */
helpers_core.log10 = exports$2.log10;

var getRtlAdapter = function(rectX, width) {
	return {
		x: function(x) {
			return rectX + rectX + width - x;
		},
		setWidth: function(w) {
			width = w;
		},
		textAlign: function(align) {
			if (align === 'center') {
				return align;
			}
			return align === 'right' ? 'left' : 'right';
		},
		xPlus: function(x, value) {
			return x - value;
		},
		leftForLtr: function(x, itemWidth) {
			return x - itemWidth;
		},
	};
};

var getLtrAdapter = function() {
	return {
		x: function(x) {
			return x;
		},
		setWidth: function(w) { // eslint-disable-line no-unused-vars
		},
		textAlign: function(align) {
			return align;
		},
		xPlus: function(x, value) {
			return x + value;
		},
		leftForLtr: function(x, _itemWidth) { // eslint-disable-line no-unused-vars
			return x;
		},
	};
};

var getAdapter = function(rtl, rectX, width) {
	return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
};

var overrideTextDirection = function(ctx, direction) {
	var style, original;
	if (direction === 'ltr' || direction === 'rtl') {
		style = ctx.canvas.style;
		original = [
			style.getPropertyValue('direction'),
			style.getPropertyPriority('direction'),
		];

		style.setProperty('direction', direction, 'important');
		ctx.prevTextDirection = original;
	}
};

var restoreTextDirection = function(ctx) {
	var original = ctx.prevTextDirection;
	if (original !== undefined) {
		delete ctx.prevTextDirection;
		ctx.canvas.style.setProperty('direction', original[0], original[1]);
	}
};

var helpers_rtl = {
	getRtlAdapter: getAdapter,
	overrideTextDirection: overrideTextDirection,
	restoreTextDirection: restoreTextDirection,
};

var helpers$1 = helpers_core;
var easing = helpers_easing;
var canvas = helpers_canvas;
var options = helpers_options;
var math = helpers_math;
var rtl = helpers_rtl;
helpers$1.easing = easing;
helpers$1.canvas = canvas;
helpers$1.options = options;
helpers$1.math = math;
helpers$1.rtl = rtl;

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = chartjsColor(origin);
				if (c0.valid) {
					c1 = chartjsColor(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers$1.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers$1.extend(Element.prototype, {
	_type: undefined,

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers$1.extend({}, me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = helpers$1.extend({}, model);
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
	}
});

Element.extend = helpers$1.inherits;

var core_element = Element;

var exports$3 = core_element.extend({
	chart: null, // the animation associated chart instance
	currentStep: 0, // the current animation step
	numSteps: 60, // default number of steps
	easing: '', // the easing to use for this animation
	render: null, // render function used by the animation service

	onAnimationProgress: null, // user specified callback to fire on each step of the animation
	onAnimationComplete: null, // user specified callback to fire when the animation finishes
});

var core_animation = exports$3;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.Animation instead
 * @prop Chart.Animation#animationObject
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'animationObject', {
	get: function() {
		return this;
	}
});

/**
 * Provided for backward compatibility, use Chart.Animation#chart instead
 * @prop Chart.Animation#chartInstance
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 */
Object.defineProperty(exports$3.prototype, 'chartInstance', {
	get: function() {
		return this.chart;
	},
	set: function(value) {
		this.chart = value;
	}
});

core_defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers$1.noop,
		onComplete: helpers$1.noop
	}
});

var core_animations = {
	animations: [],
	request: null,

	/**
	 * @param {Chart} chart - The chart to animate.
	 * @param {Chart.Animation} animation - The animation that we will animate.
	 * @param {number} duration - The animation duration in ms.
	 * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
	 */
	addAnimation: function(chart, animation, duration, lazy) {
		var animations = this.animations;
		var i, ilen;

		animation.chart = chart;
		animation.startTime = Date.now();
		animation.duration = duration;

		if (!lazy) {
			chart.animating = true;
		}

		for (i = 0, ilen = animations.length; i < ilen; ++i) {
			if (animations[i].chart === chart) {
				animations[i] = animation;
				return;
			}
		}

		animations.push(animation);

		// If there are no animations queued, manually kickstart a digest, for lack of a better word
		if (animations.length === 1) {
			this.requestAnimationFrame();
		}
	},

	cancelAnimation: function(chart) {
		var index = helpers$1.findIndex(this.animations, function(animation) {
			return animation.chart === chart;
		});

		if (index !== -1) {
			this.animations.splice(index, 1);
			chart.animating = false;
		}
	},

	requestAnimationFrame: function() {
		var me = this;
		if (me.request === null) {
			// Skip animation frame requests until the active one is executed.
			// This can happen when processing mouse events, e.g. 'mousemove'
			// and 'mouseout' events will trigger multiple renders.
			me.request = helpers$1.requestAnimFrame.call(window, function() {
				me.request = null;
				me.startDigest();
			});
		}
	},

	/**
	 * @private
	 */
	startDigest: function() {
		var me = this;

		me.advance();

		// Do we have more stuff to animate?
		if (me.animations.length > 0) {
			me.requestAnimationFrame();
		}
	},

	/**
	 * @private
	 */
	advance: function() {
		var animations = this.animations;
		var animation, chart, numSteps, nextStep;
		var i = 0;

		// 1 animation per chart, so we are looping charts here
		while (i < animations.length) {
			animation = animations[i];
			chart = animation.chart;
			numSteps = animation.numSteps;

			// Make sure that currentStep starts at 1
			// https://github.com/chartjs/Chart.js/issues/6104
			nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
			animation.currentStep = Math.min(nextStep, numSteps);

			helpers$1.callback(animation.render, [chart, animation], chart);
			helpers$1.callback(animation.onAnimationProgress, [animation], chart);

			if (animation.currentStep >= numSteps) {
				helpers$1.callback(animation.onAnimationComplete, [animation], chart);
				chart.animating = false;
				animations.splice(i, 1);
			} else {
				++i;
			}
		}
	}
};

var resolve = helpers$1.options.resolve;

var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

/**
 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
 */
function listenArrayEvents(array, listener) {
	if (array._chartjs) {
		array._chartjs.listeners.push(listener);
		return;
	}

	Object.defineProperty(array, '_chartjs', {
		configurable: true,
		enumerable: false,
		value: {
			listeners: [listener]
		}
	});

	arrayEvents.forEach(function(key) {
		var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
		var base = array[key];

		Object.defineProperty(array, key, {
			configurable: true,
			enumerable: false,
			value: function() {
				var args = Array.prototype.slice.call(arguments);
				var res = base.apply(this, args);

				helpers$1.each(array._chartjs.listeners, function(object) {
					if (typeof object[method] === 'function') {
						object[method].apply(object, args);
					}
				});

				return res;
			}
		});
	});
}

/**
 * Removes the given array event listener and cleanup extra attached properties (such as
 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
 */
function unlistenArrayEvents(array, listener) {
	var stub = array._chartjs;
	if (!stub) {
		return;
	}

	var listeners = stub.listeners;
	var index = listeners.indexOf(listener);
	if (index !== -1) {
		listeners.splice(index, 1);
	}

	if (listeners.length > 0) {
		return;
	}

	arrayEvents.forEach(function(key) {
		delete array[key];
	});

	delete array._chartjs;
}

// Base class for all dataset controllers (line, bar, etc)
var DatasetController = function(chart, datasetIndex) {
	this.initialize(chart, datasetIndex);
};

helpers$1.extend(DatasetController.prototype, {

	/**
	 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
	 * @type {Chart.core.element}
	 */
	datasetElementType: null,

	/**
	 * Element type used to generate a meta data (e.g. Chart.element.Point).
	 * @type {Chart.core.element}
	 */
	dataElementType: null,

	/**
	 * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth'
	],

	/**
	 * Data element option keys to be resolved in _resolveDataElementOptions.
	 * A derived controller may override this to resolve controller-specific options.
	 * The keys defined here are for backward compatibility for legend styles.
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'pointStyle'
	],

	initialize: function(chart, datasetIndex) {
		var me = this;
		me.chart = chart;
		me.index = datasetIndex;
		me.linkScales();
		me.addElements();
		me._type = me.getMeta().type;
	},

	updateIndex: function(datasetIndex) {
		this.index = datasetIndex;
	},

	linkScales: function() {
		var me = this;
		var meta = me.getMeta();
		var chart = me.chart;
		var scales = chart.scales;
		var dataset = me.getDataset();
		var scalesOpts = chart.options.scales;

		if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
			meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
		}
		if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
			meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
		}
	},

	getDataset: function() {
		return this.chart.data.datasets[this.index];
	},

	getMeta: function() {
		return this.chart.getDatasetMeta(this.index);
	},

	getScaleForId: function(scaleID) {
		return this.chart.scales[scaleID];
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().yAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getValueScale: function() {
		return this.getScaleForId(this._getValueScaleId());
	},

	/**
	 * @private
	 */
	_getIndexScale: function() {
		return this.getScaleForId(this._getIndexScaleId());
	},

	reset: function() {
		this._update(true);
	},

	/**
	 * @private
	 */
	destroy: function() {
		if (this._data) {
			unlistenArrayEvents(this._data, this);
		}
	},

	createMetaDataset: function() {
		var me = this;
		var type = me.datasetElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index
		});
	},

	createMetaData: function(index) {
		var me = this;
		var type = me.dataElementType;
		return type && new type({
			_chart: me.chart,
			_datasetIndex: me.index,
			_index: index
		});
	},

	addElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data || [];
		var metaData = meta.data;
		var i, ilen;

		for (i = 0, ilen = data.length; i < ilen; ++i) {
			metaData[i] = metaData[i] || me.createMetaData(i);
		}

		meta.dataset = meta.dataset || me.createMetaDataset();
	},

	addElementAndReset: function(index) {
		var element = this.createMetaData(index);
		this.getMeta().data.splice(index, 0, element);
		this.updateElement(element, index, true);
	},

	buildOrUpdateElements: function() {
		var me = this;
		var dataset = me.getDataset();
		var data = dataset.data || (dataset.data = []);

		// In order to correctly handle data addition/deletion animation (an thus simulate
		// real-time charts), we need to monitor these data modifications and synchronize
		// the internal meta data accordingly.
		if (me._data !== data) {
			if (me._data) {
				// This case happens when the user replaced the data array instance.
				unlistenArrayEvents(me._data, me);
			}

			if (data && Object.isExtensible(data)) {
				listenArrayEvents(data, me);
			}
			me._data = data;
		}

		// Re-sync meta data in case the user replaced the data array or if we missed
		// any updates and so make sure that we handle number of datapoints changing.
		me.resyncElements();
	},

	/**
	 * Returns the merged user-supplied and default dataset-level options
	 * @private
	 */
	_configure: function() {
		var me = this;
		me._config = helpers$1.merge({}, [
			me.chart.options.datasets[me._type],
			me.getDataset(),
		], {
			merger: function(key, target, source) {
				if (key !== '_meta' && key !== 'data') {
					helpers$1._merger(key, target, source);
				}
			}
		});
	},

	_update: function(reset) {
		var me = this;
		me._configure();
		me._cachedDataOpts = null;
		me.update(reset);
	},

	update: helpers$1.noop,

	transition: function(easingValue) {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		for (; i < ilen; ++i) {
			elements[i].transition(easingValue);
		}

		if (meta.dataset) {
			meta.dataset.transition(easingValue);
		}
	},

	draw: function() {
		var meta = this.getMeta();
		var elements = meta.data || [];
		var ilen = elements.length;
		var i = 0;

		if (meta.dataset) {
			meta.dataset.draw();
		}

		for (; i < ilen; ++i) {
			elements[i].draw();
		}
	},

	/**
	 * Returns a set of predefined style properties that should be used to represent the dataset
	 * or the data if the index is specified
	 * @param {number} index - data index
	 * @return {IStyleInterface} style object
	 */
	getStyle: function(index) {
		var me = this;
		var meta = me.getMeta();
		var dataset = meta.dataset;
		var style;

		me._configure();
		if (dataset && index === undefined) {
			style = me._resolveDatasetElementOptions(dataset || {});
		} else {
			index = index || 0;
			style = me._resolveDataElementOptions(meta.data[index] || {}, index);
		}

		if (style.fill === false || style.fill === null) {
			style.backgroundColor = style.borderColor;
		}

		return style;
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element, hover) {
		var me = this;
		var chart = me.chart;
		var datasetOpts = me._config;
		var custom = element.custom || {};
		var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
		var elementOptions = me._datasetElementOptions;
		var values = {};
		var i, ilen, key, readKey;

		// Scriptable options
		var context = {
			chart: chart,
			dataset: me.getDataset(),
			datasetIndex: me.index,
			hover: hover
		};

		for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
			key = elementOptions[i];
			readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
			values[key] = resolve([
				custom[readKey],
				datasetOpts[readKey],
				options[readKey]
			], context);
		}

		return values;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(element, index) {
		var me = this;
		var custom = element && element.custom;
		var cached = me._cachedDataOpts;
		if (cached && !custom) {
			return cached;
		}
		var chart = me.chart;
		var datasetOpts = me._config;
		var options = chart.options.elements[me.dataElementType.prototype._type] || {};
		var elementOptions = me._dataElementOptions;
		var values = {};

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: me.getDataset(),
			datasetIndex: me.index
		};

		// `resolve` sets cacheable to `false` if any option is indexed or scripted
		var info = {cacheable: !custom};

		var keys, i, ilen, key;

		custom = custom || {};

		if (helpers$1.isArray(elementOptions)) {
			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		} else {
			keys = Object.keys(elementOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					datasetOpts[elementOptions[key]],
					datasetOpts[key],
					options[key]
				], context, index, info);
			}
		}

		if (info.cacheable) {
			me._cachedDataOpts = Object.freeze(values);
		}

		return values;
	},

	removeHoverStyle: function(element) {
		helpers$1.merge(element._model, element.$previousStyle || {});
		delete element.$previousStyle;
	},

	setHoverStyle: function(element) {
		var dataset = this.chart.data.datasets[element._datasetIndex];
		var index = element._index;
		var custom = element.custom || {};
		var model = element._model;
		var getHoverColor = helpers$1.getHoverColor;

		element.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth
		};

		model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
		model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
		model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
	},

	/**
	 * @private
	 */
	_removeDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;

		if (element) {
			this.removeHoverStyle(element);
		}
	},

	/**
	 * @private
	 */
	_setDatasetHoverStyle: function() {
		var element = this.getMeta().dataset;
		var prev = {};
		var i, ilen, key, keys, hoverOptions, model;

		if (!element) {
			return;
		}

		model = element._model;
		hoverOptions = this._resolveDatasetElementOptions(element, true);

		keys = Object.keys(hoverOptions);
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
			prev[key] = model[key];
			model[key] = hoverOptions[key];
		}

		element.$previousStyle = prev;
	},

	/**
	 * @private
	 */
	resyncElements: function() {
		var me = this;
		var meta = me.getMeta();
		var data = me.getDataset().data;
		var numMeta = meta.data.length;
		var numData = data.length;

		if (numData < numMeta) {
			meta.data.splice(numData, numMeta - numData);
		} else if (numData > numMeta) {
			me.insertElements(numMeta, numData - numMeta);
		}
	},

	/**
	 * @private
	 */
	insertElements: function(start, count) {
		for (var i = 0; i < count; ++i) {
			this.addElementAndReset(start + i);
		}
	},

	/**
	 * @private
	 */
	onDataPush: function() {
		var count = arguments.length;
		this.insertElements(this.getDataset().data.length - count, count);
	},

	/**
	 * @private
	 */
	onDataPop: function() {
		this.getMeta().data.pop();
	},

	/**
	 * @private
	 */
	onDataShift: function() {
		this.getMeta().data.shift();
	},

	/**
	 * @private
	 */
	onDataSplice: function(start, count) {
		this.getMeta().data.splice(start, count);
		this.insertElements(start, arguments.length - 2);
	},

	/**
	 * @private
	 */
	onDataUnshift: function() {
		this.insertElements(0, arguments.length);
	}
});

DatasetController.extend = helpers$1.inherits;

var core_datasetController = DatasetController;

var TAU = Math.PI * 2;

core_defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: core_defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2,
			borderAlign: 'center'
		}
	}
});

function clipArc(ctx, arc) {
	var startAngle = arc.startAngle;
	var endAngle = arc.endAngle;
	var pixelMargin = arc.pixelMargin;
	var angleMargin = pixelMargin / arc.outerRadius;
	var x = arc.x;
	var y = arc.y;

	// Draw an inner border by cliping the arc and drawing a double-width border
	// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
	ctx.beginPath();
	ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
	if (arc.innerRadius > pixelMargin) {
		angleMargin = pixelMargin / arc.innerRadius;
		ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
	} else {
		ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
	}
	ctx.closePath();
	ctx.clip();
}

function drawFullCircleBorders(ctx, vm, arc, inner) {
	var endAngle = arc.endAngle;
	var i;

	if (inner) {
		arc.endAngle = arc.startAngle + TAU;
		clipArc(ctx, arc);
		arc.endAngle = endAngle;
		if (arc.endAngle === arc.startAngle && arc.fullCircles) {
			arc.endAngle += TAU;
			arc.fullCircles--;
		}
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
	for (i = 0; i < arc.fullCircles; ++i) {
		ctx.stroke();
	}
}

function drawBorder(ctx, vm, arc) {
	var inner = vm.borderAlign === 'inner';

	if (inner) {
		ctx.lineWidth = vm.borderWidth * 2;
		ctx.lineJoin = 'round';
	} else {
		ctx.lineWidth = vm.borderWidth;
		ctx.lineJoin = 'bevel';
	}

	if (arc.fullCircles) {
		drawFullCircleBorders(ctx, vm, arc, inner);
	}

	if (inner) {
		clipArc(ctx, arc);
	}

	ctx.beginPath();
	ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
	ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
	ctx.closePath();
	ctx.stroke();
}

var element_arc = core_element.extend({
	_type: 'arc',

	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += TAU;
			}
			while (angle > endAngle) {
				angle -= TAU;
			}
			while (angle < startAngle) {
				angle += TAU;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var pixelMargin = (vm.borderAlign === 'inner') ? 0.33 : 0;
		var arc = {
			x: vm.x,
			y: vm.y,
			innerRadius: vm.innerRadius,
			outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
			pixelMargin: pixelMargin,
			startAngle: vm.startAngle,
			endAngle: vm.endAngle,
			fullCircles: Math.floor(vm.circumference / TAU)
		};
		var i;

		ctx.save();

		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;

		if (arc.fullCircles) {
			arc.endAngle = arc.startAngle + TAU;
			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			for (i = 0; i < arc.fullCircles; ++i) {
				ctx.fill();
			}
			arc.endAngle = arc.startAngle + vm.circumference % TAU;
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.fill();

		if (vm.borderWidth) {
			drawBorder(ctx, vm, arc);
		}

		ctx.restore();
	}
});

var valueOrDefault$1 = helpers$1.valueOrDefault;

var defaultColor = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: defaultColor,
			borderWidth: 3,
			borderColor: defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

var element_line = core_element.extend({
	_type: 'line',

	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalDefaults = core_defaults.global;
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var closePath = me._loop;
		var index, previous, currentVM;

		if (!points.length) {
			return;
		}

		if (me._loop) {
			for (index = 0; index < points.length; ++index) {
				previous = helpers$1.previousItem(points, index);
				// If the line has an open path, shift the point array
				if (!points[index]._view.skip && previous._view.skip) {
					points = points.slice(index).concat(points.slice(0, index));
					closePath = spanGaps;
					break;
				}
			}
			// If the line has a close path, add the first point again
			if (closePath) {
				points.push(points[0]);
			}
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();

		// First point moves to it's starting position no matter what
		currentVM = points[0]._view;
		if (!currentVM.skip) {
			ctx.moveTo(currentVM.x, currentVM.y);
			lastDrawnIndex = 0;
		}

		for (index = 1; index < points.length; ++index) {
			currentVM = points[index]._view;
			previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

			if (!currentVM.skip) {
				if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
					// There was a gap and this is the first point after the gap
					ctx.moveTo(currentVM.x, currentVM.y);
				} else {
					// Line to next point
					helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
				}
				lastDrawnIndex = index;
			}
		}

		if (closePath) {
			ctx.closePath();
		}

		ctx.stroke();
		ctx.restore();
	}
});

var valueOrDefault$2 = helpers$1.valueOrDefault;

var defaultColor$1 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor$1,
			borderColor: defaultColor$1,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius) : false;
}

var element_point = core_element.extend({
	_type: 'point',

	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var rotation = vm.rotation;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

		if (vm.skip) {
			return;
		}

		// Clipping for Points.
		if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
			helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
		}
	}
});

var defaultColor$2 = core_defaults.global.defaultColor;

core_defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaultColor$2,
			borderColor: defaultColor$2,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(vm) {
	return vm && vm.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(vm) {
	var x1, x2, y1, y2, half;

	if (isVertical(vm)) {
		half = vm.width / 2;
		x1 = vm.x - half;
		x2 = vm.x + half;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		half = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - half;
		y2 = vm.y + half;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

function swap(orig, v1, v2) {
	return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}

function parseBorderSkipped(vm) {
	var edge = vm.borderSkipped;
	var res = {};

	if (!edge) {
		return res;
	}

	if (vm.horizontal) {
		if (vm.base > vm.x) {
			edge = swap(edge, 'left', 'right');
		}
	} else if (vm.base < vm.y) {
		edge = swap(edge, 'bottom', 'top');
	}

	res[edge] = true;
	return res;
}

function parseBorderWidth(vm, maxW, maxH) {
	var value = vm.borderWidth;
	var skip = parseBorderSkipped(vm);
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = +value.top || 0;
		r = +value.right || 0;
		b = +value.bottom || 0;
		l = +value.left || 0;
	} else {
		t = r = b = l = +value || 0;
	}

	return {
		t: skip.top || (t < 0) ? 0 : t > maxH ? maxH : t,
		r: skip.right || (r < 0) ? 0 : r > maxW ? maxW : r,
		b: skip.bottom || (b < 0) ? 0 : b > maxH ? maxH : b,
		l: skip.left || (l < 0) ? 0 : l > maxW ? maxW : l
	};
}

function boundingRects(vm) {
	var bounds = getBarBounds(vm);
	var width = bounds.right - bounds.left;
	var height = bounds.bottom - bounds.top;
	var border = parseBorderWidth(vm, width / 2, height / 2);

	return {
		outer: {
			x: bounds.left,
			y: bounds.top,
			w: width,
			h: height
		},
		inner: {
			x: bounds.left + border.l,
			y: bounds.top + border.t,
			w: width - border.l - border.r,
			h: height - border.t - border.b
		}
	};
}

function inRange(vm, x, y) {
	var skipX = x === null;
	var skipY = y === null;
	var bounds = !vm || (skipX && skipY) ? false : getBarBounds(vm);

	return bounds
		&& (skipX || x >= bounds.left && x <= bounds.right)
		&& (skipY || y >= bounds.top && y <= bounds.bottom);
}

var element_rectangle = core_element.extend({
	_type: 'rectangle',

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var rects = boundingRects(vm);
		var outer = rects.outer;
		var inner = rects.inner;

		ctx.fillStyle = vm.backgroundColor;
		ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

		if (outer.w === inner.w && outer.h === inner.h) {
			return;
		}

		ctx.save();
		ctx.beginPath();
		ctx.rect(outer.x, outer.y, outer.w, outer.h);
		ctx.clip();
		ctx.fillStyle = vm.borderColor;
		ctx.rect(inner.x, inner.y, inner.w, inner.h);
		ctx.fill('evenodd');
		ctx.restore();
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		return inRange(this._view, mouseX, mouseY);
	},

	inLabelRange: function(mouseX, mouseY) {
		var vm = this._view;
		return isVertical(vm)
			? inRange(vm, mouseX, null)
			: inRange(vm, null, mouseY);
	},

	inXRange: function(mouseX) {
		return inRange(this._view, mouseX, null);
	},

	inYRange: function(mouseY) {
		return inRange(this._view, null, mouseY);
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(vm)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;

		return isVertical(vm)
			? vm.width * Math.abs(vm.y - vm.base)
			: vm.height * Math.abs(vm.x - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});

var elements = {};
var Arc = element_arc;
var Line = element_line;
var Point = element_point;
var Rectangle = element_rectangle;
elements.Arc = Arc;
elements.Line = Line;
elements.Point = Point;
elements.Rectangle = Rectangle;

var deprecated = helpers$1._deprecated;
var valueOrDefault$3 = helpers$1.valueOrDefault;

core_defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

core_defaults._set('global', {
	datasets: {
		bar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

/**
 * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
 * @private
 */
function computeMinSampleSize(scale, pixels) {
	var min = scale._length;
	var prev, curr, i, ilen;

	for (i = 1, ilen = pixels.length; i < ilen; ++i) {
		min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
	}

	for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
		curr = scale.getPixelForTick(i);
		min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
		prev = curr;
	}

	return min;
}

/**
 * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
 * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
 * mode currently always generates bars equally sized (until we introduce scriptable options?).
 * @private
 */
function computeFitCategoryTraits(index, ruler, options) {
	var thickness = options.barThickness;
	var count = ruler.stackCount;
	var curr = ruler.pixels[index];
	var min = helpers$1.isNullOrUndef(thickness)
		? computeMinSampleSize(ruler.scale, ruler.pixels)
		: -1;
	var size, ratio;

	if (helpers$1.isNullOrUndef(thickness)) {
		size = min * options.categoryPercentage;
		ratio = options.barPercentage;
	} else {
		// When bar thickness is enforced, category and bar percentages are ignored.
		// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
		// and deprecate barPercentage since this value is ignored when thickness is absolute.
		size = thickness * count;
		ratio = 1;
	}

	return {
		chunk: size / count,
		ratio: ratio,
		start: curr - (size / 2)
	};
}

/**
 * Computes an "optimal" category that globally arranges bars side by side (no gap when
 * percentage options are 1), based on the previous and following categories. This mode
 * generates bars with different widths when data are not evenly spaced.
 * @private
 */
function computeFlexCategoryTraits(index, ruler, options) {
	var pixels = ruler.pixels;
	var curr = pixels[index];
	var prev = index > 0 ? pixels[index - 1] : null;
	var next = index < pixels.length - 1 ? pixels[index + 1] : null;
	var percent = options.categoryPercentage;
	var start, size;

	if (prev === null) {
		// first data: its size is double based on the next point or,
		// if it's also the last data, we use the scale size.
		prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
	}

	if (next === null) {
		// last data: its size is also double based on the previous point.
		next = curr + curr - prev;
	}

	start = curr - (curr - Math.min(prev, next)) / 2 * percent;
	size = Math.abs(next - prev) / 2 * percent;

	return {
		chunk: size / ruler.stackCount,
		ratio: options.barPercentage,
		start: start
	};
}

var controller_bar = core_datasetController.extend({

	dataElementType: elements.Rectangle,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderSkipped',
		'borderWidth',
		'barPercentage',
		'barThickness',
		'categoryPercentage',
		'maxBarThickness',
		'minBarLength'
	],

	initialize: function() {
		var me = this;
		var meta, scaleOpts;

		core_datasetController.prototype.initialize.apply(me, arguments);

		meta = me.getMeta();
		meta.stack = me.getDataset().stack;
		meta.bar = true;

		scaleOpts = me._getIndexScale().options;
		deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
		deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
		deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
		deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
		deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
	},

	update: function(reset) {
		var me = this;
		var rects = me.getMeta().data;
		var i, ilen;

		me._ruler = me.getRuler();

		for (i = 0, ilen = rects.length; i < ilen; ++i) {
			me.updateElement(rects[i], i, reset);
		}
	},

	updateElement: function(rectangle, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var dataset = me.getDataset();
		var options = me._resolveDataElementOptions(rectangle, index);

		rectangle._xScale = me.getScaleForId(meta.xAxisID);
		rectangle._yScale = me.getScaleForId(meta.yAxisID);
		rectangle._datasetIndex = me.index;
		rectangle._index = index;
		rectangle._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderSkipped: options.borderSkipped,
			borderWidth: options.borderWidth,
			datasetLabel: dataset.label,
			label: me.chart.data.labels[index]
		};

		if (helpers$1.isArray(dataset.data[index])) {
			rectangle._model.borderSkipped = null;
		}

		me._updateElementGeometry(rectangle, index, reset, options);

		rectangle.pivot();
	},

	/**
	 * @private
	 */
	_updateElementGeometry: function(rectangle, index, reset, options) {
		var me = this;
		var model = rectangle._model;
		var vscale = me._getValueScale();
		var base = vscale.getBasePixel();
		var horizontal = vscale.isHorizontal();
		var ruler = me._ruler || me.getRuler();
		var vpixels = me.calculateBarValuePixels(me.index, index, options);
		var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

		model.horizontal = horizontal;
		model.base = reset ? base : vpixels.base;
		model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
		model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
		model.height = horizontal ? ipixels.size : undefined;
		model.width = horizontal ? undefined : ipixels.size;
	},

	/**
	 * Returns the stacks based on groups and bar visibility.
	 * @param {number} [last] - The dataset index
	 * @returns {string[]} The list of stack IDs
	 * @private
	 */
	_getStacks: function(last) {
		var me = this;
		var scale = me._getIndexScale();
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var stacked = scale.options.stacked;
		var ilen = metasets.length;
		var stacks = [];
		var i, meta;

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			// stacked   | meta.stack
			//           | found | not found | undefined
			// false     |   x   |     x     |     x
			// true      |       |     x     |
			// undefined |       |     x     |     x
			if (stacked === false || stacks.indexOf(meta.stack) === -1 ||
				(stacked === undefined && meta.stack === undefined)) {
				stacks.push(meta.stack);
			}
			if (meta.index === last) {
				break;
			}
		}

		return stacks;
	},

	/**
	 * Returns the effective number of stacks based on groups and bar visibility.
	 * @private
	 */
	getStackCount: function() {
		return this._getStacks().length;
	},

	/**
	 * Returns the stack index for the given dataset based on groups and bar visibility.
	 * @param {number} [datasetIndex] - The dataset index
	 * @param {string} [name] - The stack name to find
	 * @returns {number} The stack index
	 * @private
	 */
	getStackIndex: function(datasetIndex, name) {
		var stacks = this._getStacks(datasetIndex);
		var index = (name !== undefined)
			? stacks.indexOf(name)
			: -1; // indexOf returns -1 if element is not present

		return (index === -1)
			? stacks.length - 1
			: index;
	},

	/**
	 * @private
	 */
	getRuler: function() {
		var me = this;
		var scale = me._getIndexScale();
		var pixels = [];
		var i, ilen;

		for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
			pixels.push(scale.getPixelForValue(null, i, me.index));
		}

		return {
			pixels: pixels,
			start: scale._startPixel,
			end: scale._endPixel,
			stackCount: me.getStackCount(),
			scale: scale
		};
	},

	/**
	 * Note: pixel values are not clamped to the scale area.
	 * @private
	 */
	calculateBarValuePixels: function(datasetIndex, index, options) {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var isHorizontal = scale.isHorizontal();
		var datasets = chart.data.datasets;
		var metasets = scale._getMatchingVisibleMetas(me._type);
		var value = scale._parseValue(datasets[datasetIndex].data[index]);
		var minBarLength = options.minBarLength;
		var stacked = scale.options.stacked;
		var stack = me.getMeta().stack;
		var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
		var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
		var ilen = metasets.length;
		var i, imeta, ivalue, base, head, size, stackLength;

		if (stacked || (stacked === undefined && stack !== undefined)) {
			for (i = 0; i < ilen; ++i) {
				imeta = metasets[i];

				if (imeta.index === datasetIndex) {
					break;
				}

				if (imeta.stack === stack) {
					stackLength = scale._parseValue(datasets[imeta.index].data[index]);
					ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

					if ((value.min < 0 && ivalue < 0) || (value.max >= 0 && ivalue > 0)) {
						start += ivalue;
					}
				}
			}
		}

		base = scale.getPixelForValue(start);
		head = scale.getPixelForValue(start + length);
		size = head - base;

		if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
			size = minBarLength;
			if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
				head = base - minBarLength;
			} else {
				head = base + minBarLength;
			}
		}

		return {
			size: size,
			base: base,
			head: head,
			center: head + size / 2
		};
	},

	/**
	 * @private
	 */
	calculateBarIndexPixels: function(datasetIndex, index, ruler, options) {
		var me = this;
		var range = options.barThickness === 'flex'
			? computeFlexCategoryTraits(index, ruler, options)
			: computeFitCategoryTraits(index, ruler, options);

		var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
		var center = range.start + (range.chunk * stackIndex) + (range.chunk / 2);
		var size = Math.min(
			valueOrDefault$3(options.maxBarThickness, Infinity),
			range.chunk * range.ratio);

		return {
			base: center - size / 2,
			head: center + size / 2,
			center: center,
			size: size
		};
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var scale = me._getValueScale();
		var rects = me.getMeta().data;
		var dataset = me.getDataset();
		var ilen = rects.length;
		var i = 0;

		helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

		for (; i < ilen; ++i) {
			var val = scale._parseValue(dataset.data[i]);
			if (!isNaN(val.min) && !isNaN(val.max)) {
				rects[i].draw();
			}
		}

		helpers$1.canvas.unclipArea(chart.ctx);
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function() {
		var me = this;
		var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
		var indexOpts = me._getIndexScale().options;
		var valueOpts = me._getValueScale().options;

		values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
		values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
		values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
		values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
		values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

		return values;
	}

});

var valueOrDefault$4 = helpers$1.valueOrDefault;
var resolve$1 = helpers$1.options.resolve;

core_defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});

var controller_bubble = core_datasetController.extend({
	/**
	 * @protected
	 */
	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
		'hoverRadius',
		'hitRadius',
		'pointStyle',
		'rotation'
	],

	/**
	 * @protected
	 */
	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var points = meta.data;

		// Update Points
		helpers$1.each(points, function(point, index) {
			me.updateElement(point, index, reset);
		});
	},

	/**
	 * @protected
	 */
	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var xScale = me.getScaleForId(meta.xAxisID);
		var yScale = me.getScaleForId(meta.yAxisID);
		var options = me._resolveDataElementOptions(point, index);
		var data = me.getDataset().data[index];
		var dsIndex = me.index;

		var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
		var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = dsIndex;
		point._index = index;
		point._model = {
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			hitRadius: options.hitRadius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			radius: reset ? 0 : options.radius,
			skip: custom.skip || isNaN(x) || isNaN(y),
			x: x,
			y: y,
		};

		point.pivot();
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
		model.radius = options.radius + options.hoverRadius;
	},

	/**
	 * @private
	 */
	_resolveDataElementOptions: function(point, index) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var custom = point.custom || {};
		var data = dataset.data[index] || {};
		var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

		// Scriptable options
		var context = {
			chart: chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		// In case values were cached (and thus frozen), we need to clone the values
		if (me._cachedDataOpts === values) {
			values = helpers$1.extend({}, values);
		}

		// Custom radius resolution
		values.radius = resolve$1([
			custom.radius,
			data.r,
			me._config.radius,
			chart.options.elements.point.radius
		], context, index);

		return values;
	}
});

var valueOrDefault$5 = helpers$1.valueOrDefault;

var PI$1 = Math.PI;
var DOUBLE_PI$1 = PI$1 * 2;
var HALF_PI$1 = PI$1 / 2;

core_defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: -HALF_PI$1,

	// The total circumference of the chart.
	circumference: DOUBLE_PI$1,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers$1.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

var controller_doughnut = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
	getRingIndex: function(datasetIndex) {
		var ringIndex = 0;

		for (var j = 0; j < datasetIndex; ++j) {
			if (this.chart.isDatasetVisible(j)) {
				++ringIndex;
			}
		}

		return ringIndex;
	},

	update: function(reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var ratioX = 1;
		var ratioY = 1;
		var offsetX = 0;
		var offsetY = 0;
		var meta = me.getMeta();
		var arcs = meta.data;
		var cutout = opts.cutoutPercentage / 100 || 0;
		var circumference = opts.circumference;
		var chartWeight = me._getRingWeight(me.index);
		var maxWidth, maxHeight, i, ilen;

		// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
		if (circumference < DOUBLE_PI$1) {
			var startAngle = opts.rotation % DOUBLE_PI$1;
			startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
			var endAngle = startAngle + circumference;
			var startX = Math.cos(startAngle);
			var startY = Math.sin(startAngle);
			var endX = Math.cos(endAngle);
			var endY = Math.sin(endAngle);
			var contains0 = (startAngle <= 0 && endAngle >= 0) || endAngle >= DOUBLE_PI$1;
			var contains90 = (startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1) || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
			var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
			var contains270 = (startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1) || endAngle >= PI$1 + HALF_PI$1;
			var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
			var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
			var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
			var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
			ratioX = (maxX - minX) / 2;
			ratioY = (maxY - minY) / 2;
			offsetX = -(maxX + minX) / 2;
			offsetY = -(maxY + minY) / 2;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
		}

		chart.borderWidth = me.getMaxBorderWidth();
		maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
		maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
		chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
		chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
		chart.offsetX = offsetX * chart.outerRadius;
		chart.offsetY = offsetY * chart.outerRadius;

		meta.total = me.calculateTotal();

		me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
		me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			me.updateElement(arcs[i], i, reset);
		}
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var animationOpts = opts.animation;
		var centerX = (chartArea.left + chartArea.right) / 2;
		var centerY = (chartArea.top + chartArea.bottom) / 2;
		var startAngle = opts.rotation; // non reset case handled later
		var endAngle = opts.rotation; // non reset case handled later
		var dataset = me.getDataset();
		var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
		var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
		var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX + chart.offsetX,
				y: centerY + chart.offsetY,
				startAngle: startAngle,
				endAngle: endAngle,
				circumference: circumference,
				outerRadius: outerRadius,
				innerRadius: innerRadius,
				label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
			}
		});

		var model = arc._model;

		// Set correct angles if not resetting
		if (!reset || !animationOpts.animateRotate) {
			if (index === 0) {
				model.startAngle = opts.rotation;
			} else {
				model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
			}

			model.endAngle = model.startAngle + model.circumference;
		}

		arc.pivot();
	},

	calculateTotal: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var total = 0;
		var value;

		helpers$1.each(meta.data, function(element, index) {
			value = dataset.data[index];
			if (!isNaN(value) && !element.hidden) {
				total += Math.abs(value);
			}
		});

		/* if (total === 0) {
			total = NaN;
		}*/

		return total;
	},

	calculateCircumference: function(value) {
		var total = this.getMeta().total;
		if (total > 0 && !isNaN(value)) {
			return DOUBLE_PI$1 * (Math.abs(value) / total);
		}
		return 0;
	},

	// gets the max border or hover width to properly scale pie charts
	getMaxBorderWidth: function(arcs) {
		var me = this;
		var max = 0;
		var chart = me.chart;
		var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

		if (!arcs) {
			// Find the outmost visible dataset
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					arcs = meta.data;
					if (i !== me.index) {
						controller = meta.controller;
					}
					break;
				}
			}
		}

		if (!arcs) {
			return 0;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arc = arcs[i];
			if (controller) {
				controller._configure();
				options = controller._resolveDataElementOptions(arc, i);
			} else {
				options = arc._options;
			}
			if (options.borderAlign !== 'inner') {
				borderWidth = options.borderWidth;
				hoverWidth = options.hoverBorderWidth;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
		}
		return max;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
	 * @private
	 */
	_getRingWeightOffset: function(datasetIndex) {
		var ringWeightOffset = 0;

		for (var i = 0; i < datasetIndex; ++i) {
			if (this.chart.isDatasetVisible(i)) {
				ringWeightOffset += this._getRingWeight(i);
			}
		}

		return ringWeightOffset;
	},

	/**
	 * @private
	 */
	_getRingWeight: function(dataSetIndex) {
		return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
	},

	/**
	 * Returns the sum of all visibile data set weights.  This value can be 0.
	 * @private
	 */
	_getVisibleDatasetWeightTotal: function() {
		return this._getRingWeightOffset(this.chart.data.datasets.length);
	}
});

core_defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			type: 'category',
			position: 'left',
			offset: true,
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		mode: 'index',
		axis: 'y'
	}
});

core_defaults._set('global', {
	datasets: {
		horizontalBar: {
			categoryPercentage: 0.8,
			barPercentage: 0.9
		}
	}
});

var controller_horizontalBar = controller_bar.extend({
	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.getMeta().xAxisID;
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.getMeta().yAxisID;
	}
});

var valueOrDefault$6 = helpers$1.valueOrDefault;
var resolve$2 = helpers$1.options.resolve;
var isPointInArea = helpers$1.canvas._isPointInArea;

core_defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

function scaleClip(scale, halfBorderWidth) {
	var tickOpts = scale && scale.options.ticks || {};
	var reverse = tickOpts.reverse;
	var min = tickOpts.min === undefined ? halfBorderWidth : 0;
	var max = tickOpts.max === undefined ? halfBorderWidth : 0;
	return {
		start: reverse ? max : min,
		end: reverse ? min : max
	};
}

function defaultClip(xScale, yScale, borderWidth) {
	var halfBorderWidth = borderWidth / 2;
	var x = scaleClip(xScale, halfBorderWidth);
	var y = scaleClip(yScale, halfBorderWidth);

	return {
		top: y.end,
		right: x.end,
		bottom: y.start,
		left: x.start
	};
}

function toClip(value) {
	var t, r, b, l;

	if (helpers$1.isObject(value)) {
		t = value.top;
		r = value.right;
		b = value.bottom;
		l = value.left;
	} else {
		t = r = b = l = value;
	}

	return {
		top: t,
		right: r,
		bottom: b,
		left: l
	};
}


var controller_line = core_datasetController.extend({

	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderCapStyle',
		'borderColor',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'borderWidth',
		'cubicInterpolationMode',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var options = me.chart.options;
		var config = me._config;
		var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
		var i, ilen;

		me._xScale = me.getScaleForId(meta.xAxisID);
		me._yScale = me.getScaleForId(meta.yAxisID);

		// Update Line
		if (showLine) {
			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = me._yScale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();
		}

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		if (showLine && line._model.tension !== 0) {
			me.updateBezierControlPoints();
		}

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var meta = me.getMeta();
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var datasetIndex = me.index;
		var value = dataset.data[index];
		var xScale = me._xScale;
		var yScale = me._yScale;
		var lineModel = meta.dataset._model;
		var x, y;

		var options = me._resolveDataElementOptions(point, index);

		x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
		y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

		// Utility
		point._xScale = xScale;
		point._yScale = yScale;
		point._options = options;
		point._datasetIndex = datasetIndex;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x,
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
			steppedLine: lineModel ? lineModel.steppedLine : false,
			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function(element) {
		var me = this;
		var config = me._config;
		var custom = element.custom || {};
		var options = me.chart.options;
		var lineOptions = options.elements.line;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		// The default behavior of lines is to break at null values, according
		// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
		// This option gives lines the ability to span gaps
		values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
		values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
		values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

		return values;
	},

	calculatePointY: function(value, index, datasetIndex) {
		var me = this;
		var chart = me.chart;
		var yScale = me._yScale;
		var sumPos = 0;
		var sumNeg = 0;
		var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

		if (yScale.options.stacked) {
			rightValue = +yScale.getRightValue(value);
			metasets = chart._getSortedVisibleDatasetMetas();
			ilen = metasets.length;

			for (i = 0; i < ilen; ++i) {
				dsMeta = metasets[i];
				if (dsMeta.index === datasetIndex) {
					break;
				}

				ds = chart.data.datasets[dsMeta.index];
				if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
					stackedRightValue = +yScale.getRightValue(ds.data[index]);
					if (stackedRightValue < 0) {
						sumNeg += stackedRightValue || 0;
					} else {
						sumPos += stackedRightValue || 0;
					}
				}
			}

			if (rightValue < 0) {
				return yScale.getPixelForValue(sumNeg + rightValue);
			}
			return yScale.getPixelForValue(sumPos + rightValue);
		}
		return yScale.getPixelForValue(value);
	},

	updateBezierControlPoints: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var lineModel = meta.dataset._model;
		var area = chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (lineModel.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		if (lineModel.cubicInterpolationMode === 'monotone') {
			helpers$1.splineCurveMonotone(points);
		} else {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(
					helpers$1.previousItem(points, i)._model,
					model,
					helpers$1.nextItem(points, i)._model,
					lineModel.tension
				);
				model.controlPointPreviousX = controlPoints.previous.x;
				model.controlPointPreviousY = controlPoints.previous.y;
				model.controlPointNextX = controlPoints.next.x;
				model.controlPointNextY = controlPoints.next.y;
			}
		}

		if (chart.options.elements.line.capBezierPoints) {
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				if (isPointInArea(model, area)) {
					if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					}
					if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			}
		}
	},

	draw: function() {
		var me = this;
		var chart = me.chart;
		var meta = me.getMeta();
		var points = meta.data || [];
		var area = chart.chartArea;
		var canvas = chart.canvas;
		var i = 0;
		var ilen = points.length;
		var clip;

		if (me._showLine) {
			clip = meta.dataset._model.clip;

			helpers$1.canvas.clipArea(chart.ctx, {
				left: clip.left === false ? 0 : area.left - clip.left,
				right: clip.right === false ? canvas.width : area.right + clip.right,
				top: clip.top === false ? 0 : area.top - clip.top,
				bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
			});

			meta.dataset.draw();

			helpers$1.canvas.unclipArea(chart.ctx);
		}

		// Draw the points
		for (; i < ilen; ++i) {
			points[i].draw(area);
		}
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
	},
});

var resolve$3 = helpers$1.options.resolve;

core_defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');
		if (datasets.length) {
			for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
				if (labels[i]) {
					listItem.appendChild(document.createTextNode(labels[i]));
				}
			}
		}

		return list.outerHTML;
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var style = meta.controller.getStyle(i);

						return {
							text: label,
							fillStyle: style.backgroundColor,
							strokeStyle: style.borderColor,
							lineWidth: style.borderWidth,
							hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

var controller_polarArea = core_datasetController.extend({

	dataElementType: elements.Arc,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_dataElementOptions: [
		'backgroundColor',
		'borderColor',
		'borderWidth',
		'borderAlign',
		'hoverBackgroundColor',
		'hoverBorderColor',
		'hoverBorderWidth',
	],

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var dataset = me.getDataset();
		var meta = me.getMeta();
		var start = me.chart.options.startAngle || 0;
		var starts = me._starts = [];
		var angles = me._angles = [];
		var arcs = meta.data;
		var i, ilen, angle;

		me._updateRadius();

		meta.count = me.countVisibleElements();

		for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
			starts[i] = start;
			angle = me._computeAngle(i);
			angles[i] = angle;
			start += angle;
		}

		for (i = 0, ilen = arcs.length; i < ilen; ++i) {
			arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			me.updateElement(arcs[i], i, reset);
		}
	},

	/**
	 * @private
	 */
	_updateRadius: function() {
		var me = this;
		var chart = me.chart;
		var chartArea = chart.chartArea;
		var opts = chart.options;
		var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

		chart.outerRadius = Math.max(minSize / 2, 0);
		chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
		chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

		me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
		me.innerRadius = me.outerRadius - chart.radiusLength;
	},

	updateElement: function(arc, index, reset) {
		var me = this;
		var chart = me.chart;
		var dataset = me.getDataset();
		var opts = chart.options;
		var animationOpts = opts.animation;
		var scale = chart.scale;
		var labels = chart.data.labels;

		var centerX = scale.xCenter;
		var centerY = scale.yCenter;

		// var negHalfPI = -0.5 * Math.PI;
		var datasetStartAngle = opts.startAngle;
		var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var startAngle = me._starts[index];
		var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

		var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
		var options = arc._options || {};

		helpers$1.extend(arc, {
			// Utility
			_datasetIndex: me.index,
			_index: index,
			_scale: scale,

			// Desired view properties
			_model: {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				borderAlign: options.borderAlign,
				x: centerX,
				y: centerY,
				innerRadius: 0,
				outerRadius: reset ? resetRadius : distance,
				startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
				endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
				label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
			}
		});

		arc.pivot();
	},

	countVisibleElements: function() {
		var dataset = this.getDataset();
		var meta = this.getMeta();
		var count = 0;

		helpers$1.each(meta.data, function(element, index) {
			if (!isNaN(dataset.data[index]) && !element.hidden) {
				count++;
			}
		});

		return count;
	},

	/**
	 * @protected
	 */
	setHoverStyle: function(arc) {
		var model = arc._model;
		var options = arc._options;
		var getHoverColor = helpers$1.getHoverColor;
		var valueOrDefault = helpers$1.valueOrDefault;

		arc.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
		};

		model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
	},

	/**
	 * @private
	 */
	_computeAngle: function(index) {
		var me = this;
		var count = this.getMeta().count;
		var dataset = me.getDataset();
		var meta = me.getMeta();

		if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
			return 0;
		}

		// Scriptable options
		var context = {
			chart: me.chart,
			dataIndex: index,
			dataset: dataset,
			datasetIndex: me.index
		};

		return resolve$3([
			me.chart.options.elements.arc.angle,
			(2 * Math.PI) / count
		], context, index);
	}
});

core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
core_defaults._set('pie', {
	cutoutPercentage: 0
});

// Pie charts are Doughnut chart with different defaults
var controller_pie = controller_doughnut;

var valueOrDefault$7 = helpers$1.valueOrDefault;

core_defaults._set('radar', {
	spanGaps: false,
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			fill: 'start',
			tension: 0 // no bezier in radar
		}
	}
});

var controller_radar = core_datasetController.extend({
	datasetElementType: elements.Line,

	dataElementType: elements.Point,

	linkScales: helpers$1.noop,

	/**
	 * @private
	 */
	_datasetElementOptions: [
		'backgroundColor',
		'borderWidth',
		'borderColor',
		'borderCapStyle',
		'borderDash',
		'borderDashOffset',
		'borderJoinStyle',
		'fill'
	],

	/**
	 * @private
	 */
	_dataElementOptions: {
		backgroundColor: 'pointBackgroundColor',
		borderColor: 'pointBorderColor',
		borderWidth: 'pointBorderWidth',
		hitRadius: 'pointHitRadius',
		hoverBackgroundColor: 'pointHoverBackgroundColor',
		hoverBorderColor: 'pointHoverBorderColor',
		hoverBorderWidth: 'pointHoverBorderWidth',
		hoverRadius: 'pointHoverRadius',
		pointStyle: 'pointStyle',
		radius: 'pointRadius',
		rotation: 'pointRotation'
	},

	/**
	 * @private
	 */
	_getIndexScaleId: function() {
		return this.chart.scale.id;
	},

	/**
	 * @private
	 */
	_getValueScaleId: function() {
		return this.chart.scale.id;
	},

	update: function(reset) {
		var me = this;
		var meta = me.getMeta();
		var line = meta.dataset;
		var points = meta.data || [];
		var scale = me.chart.scale;
		var config = me._config;
		var i, ilen;

		// Compatibility: If the properties are defined with only the old name, use those values
		if (config.tension !== undefined && config.lineTension === undefined) {
			config.lineTension = config.tension;
		}

		// Utility
		line._scale = scale;
		line._datasetIndex = me.index;
		// Data
		line._children = points;
		line._loop = true;
		// Model
		line._model = me._resolveDatasetElementOptions(line);

		line.pivot();

		// Update Points
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			me.updateElement(points[i], i, reset);
		}

		// Update bezier control points
		me.updateBezierControlPoints();

		// Now pivot the point for animation
		for (i = 0, ilen = points.length; i < ilen; ++i) {
			points[i].pivot();
		}
	},

	updateElement: function(point, index, reset) {
		var me = this;
		var custom = point.custom || {};
		var dataset = me.getDataset();
		var scale = me.chart.scale;
		var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
		var options = me._resolveDataElementOptions(point, index);
		var lineModel = me.getMeta().dataset._model;
		var x = reset ? scale.xCenter : pointPosition.x;
		var y = reset ? scale.yCenter : pointPosition.y;

		// Utility
		point._scale = scale;
		point._options = options;
		point._datasetIndex = me.index;
		point._index = index;

		// Desired view properties
		point._model = {
			x: x, // value not used in dataset scale, but we want a consistent API between scales
			y: y,
			skip: custom.skip || isNaN(x) || isNaN(y),
			// Appearance
			radius: options.radius,
			pointStyle: options.pointStyle,
			rotation: options.rotation,
			backgroundColor: options.backgroundColor,
			borderColor: options.borderColor,
			borderWidth: options.borderWidth,
			tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

			// Tooltip
			hitRadius: options.hitRadius
		};
	},

	/**
	 * @private
	 */
	_resolveDatasetElementOptions: function() {
		var me = this;
		var config = me._config;
		var options = me.chart.options;
		var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

		values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
		values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

		return values;
	},

	updateBezierControlPoints: function() {
		var me = this;
		var meta = me.getMeta();
		var area = me.chart.chartArea;
		var points = meta.data || [];
		var i, ilen, model, controlPoints;

		// Only consider points that are drawn in case the spanGaps option is used
		if (meta.dataset._model.spanGaps) {
			points = points.filter(function(pt) {
				return !pt._model.skip;
			});
		}

		function capControlPoint(pt, min, max) {
			return Math.max(Math.min(pt, max), min);
		}

		for (i = 0, ilen = points.length; i < ilen; ++i) {
			model = points[i]._model;
			controlPoints = helpers$1.splineCurve(
				helpers$1.previousItem(points, i, true)._model,
				model,
				helpers$1.nextItem(points, i, true)._model,
				model.tension
			);

			// Prevent the bezier going outside of the bounds of the graph
			model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
			model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
			model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
			model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
		}
	},

	setHoverStyle: function(point) {
		var model = point._model;
		var options = point._options;
		var getHoverColor = helpers$1.getHoverColor;

		point.$previousStyle = {
			backgroundColor: model.backgroundColor,
			borderColor: model.borderColor,
			borderWidth: model.borderWidth,
			radius: model.radius
		};

		model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
		model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
		model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
		model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
	}
});

core_defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

core_defaults._set('global', {
	datasets: {
		scatter: {
			showLine: false
		}
	}
});

// Scatter charts use line controllers
var controller_scatter = controller_line;

// NOTE export a map in which the key represents the controller type, not
// the class, and so must be CamelCase in order to be correctly retrieved
// by the controller in core.controller.js (`controllers[meta.type]`).

var controllers = {
	bar: controller_bar,
	bubble: controller_bubble,
	doughnut: controller_doughnut,
	horizontalBar: controller_horizontalBar,
	line: controller_line,
	polarArea: controller_polarArea,
	pie: controller_pie,
	radar: controller_radar,
	scatter: controller_scatter
};

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {object} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers$1.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param {Chart} chart - the chart
 * @param {function} handler - the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var metasets = chart._getSortedVisibleDatasetMetas();
	var metadata, i, j, ilen, jlen, element;

	for (i = 0, ilen = metasets.length; i < ilen; ++i) {
		metadata = metasets[i].data;
		for (j = 0, jlen = metadata.length; j < jlen; ++j) {
			element = metadata[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param {ChartElement[]} items - elements to filter
 * @param {object} position - the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param {Chart} chart - the chart to look at elements from
 * @param {object} position - the point to be nearest to
 * @param {boolean} intersect - if true, only consider items that intersect the position
 * @param {function} distanceMetric - function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);
		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {string} axis - the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart._getSortedVisibleDatasetMetas().forEach(function(meta) {
		var element = meta.data[items[0]._index];

		// don't count items that are skipped (null data)
		if (element && !element._view.skip) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
var core_interaction = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			return getNearestItems(chart, position, options.intersect, distanceMetric);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param {Chart} chart - the chart we are returning items from
		 * @param {Event} e - the event we are find things at
		 * @param {IInteractionOptions} options - options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};

var extend = helpers$1.extend;

function filterByPosition(array, position) {
	return helpers$1.where(array, function(v) {
		return v.pos === position;
	});
}

function sortByWeight(array, reverse) {
	return array.sort(function(a, b) {
		var v0 = reverse ? b : a;
		var v1 = reverse ? a : b;
		return v0.weight === v1.weight ?
			v0.index - v1.index :
			v0.weight - v1.weight;
	});
}

function wrapBoxes(boxes) {
	var layoutBoxes = [];
	var i, ilen, box;

	for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
		box = boxes[i];
		layoutBoxes.push({
			index: i,
			box: box,
			pos: box.position,
			horizontal: box.isHorizontal(),
			weight: box.weight
		});
	}
	return layoutBoxes;
}

function setLayoutDims(layouts, params) {
	var i, ilen, layout;
	for (i = 0, ilen = layouts.length; i < ilen; ++i) {
		layout = layouts[i];
		// store width used instead of chartArea.w in fitBoxes
		layout.width = layout.horizontal
			? layout.box.fullWidth && params.availableWidth
			: params.vBoxMaxWidth;
		// store height used instead of chartArea.h in fitBoxes
		layout.height = layout.horizontal && params.hBoxMaxHeight;
	}
}

function buildLayoutBoxes(boxes) {
	var layoutBoxes = wrapBoxes(boxes);
	var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
	var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
	var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
	var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

	return {
		leftAndTop: left.concat(top),
		rightAndBottom: right.concat(bottom),
		chartArea: filterByPosition(layoutBoxes, 'chartArea'),
		vertical: left.concat(right),
		horizontal: top.concat(bottom)
	};
}

function getCombinedMax(maxPadding, chartArea, a, b) {
	return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}

function updateDims(chartArea, params, layout) {
	var box = layout.box;
	var maxPadding = chartArea.maxPadding;
	var newWidth, newHeight;

	if (layout.size) {
		// this layout was already counted for, lets first reduce old size
		chartArea[layout.pos] -= layout.size;
	}
	layout.size = layout.horizontal ? box.height : box.width;
	chartArea[layout.pos] += layout.size;

	if (box.getPadding) {
		var boxPadding = box.getPadding();
		maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
		maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
		maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
		maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
	}

	newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
	newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

	if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
		chartArea.w = newWidth;
		chartArea.h = newHeight;

		// return true if chart area changed in layout's direction
		return layout.horizontal ? newWidth !== chartArea.w : newHeight !== chartArea.h;
	}
}

function handleMaxPadding(chartArea) {
	var maxPadding = chartArea.maxPadding;

	function updatePos(pos) {
		var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
		chartArea[pos] += change;
		return change;
	}
	chartArea.y += updatePos('top');
	chartArea.x += updatePos('left');
	updatePos('right');
	updatePos('bottom');
}

function getMargins(horizontal, chartArea) {
	var maxPadding = chartArea.maxPadding;

	function marginForPositions(positions) {
		var margin = {left: 0, top: 0, right: 0, bottom: 0};
		positions.forEach(function(pos) {
			margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
		});
		return margin;
	}

	return horizontal
		? marginForPositions(['left', 'right'])
		: marginForPositions(['top', 'bottom']);
}

function fitBoxes(boxes, chartArea, params) {
	var refitBoxes = [];
	var i, ilen, layout, box, refit, changed;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;

		box.update(
			layout.width || chartArea.w,
			layout.height || chartArea.h,
			getMargins(layout.horizontal, chartArea)
		);
		if (updateDims(chartArea, params, layout)) {
			changed = true;
			if (refitBoxes.length) {
				// Dimensions changed and there were non full width boxes before this
				// -> we have to refit those
				refit = true;
			}
		}
		if (!box.fullWidth) { // fullWidth boxes don't need to be re-fitted in any case
			refitBoxes.push(layout);
		}
	}

	return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
}

function placeBoxes(boxes, chartArea, params) {
	var userPadding = params.padding;
	var x = chartArea.x;
	var y = chartArea.y;
	var i, ilen, layout, box;

	for (i = 0, ilen = boxes.length; i < ilen; ++i) {
		layout = boxes[i];
		box = layout.box;
		if (layout.horizontal) {
			box.left = box.fullWidth ? userPadding.left : chartArea.left;
			box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
			box.top = y;
			box.bottom = y + box.height;
			box.width = box.right - box.left;
			y = box.bottom;
		} else {
			box.left = x;
			box.right = x + box.width;
			box.top = chartArea.top;
			box.bottom = chartArea.top + chartArea.h;
			box.height = box.bottom - box.top;
			x = box.right;
		}
	}

	chartArea.x = x;
	chartArea.y = y;
}

core_defaults._set('global', {
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

/**
 * @interface ILayoutItem
 * @prop {string} position - The position of the item in the chart layout. Possible values are
 * 'left', 'top', 'right', 'bottom', and 'chartArea'
 * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
 * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
 * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
 * @prop {function} update - Takes two parameters: width and height. Returns size of item
 * @prop {function} getPadding -  Returns an object with padding on the edges
 * @prop {number} width - Width of item. Must be valid after update()
 * @prop {number} height - Height of item. Must be valid after update()
 * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
 * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
 * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
 * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
 */

// The layout service is very self explanatory.  It's responsible for the layout within a chart.
// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
// It is this service's responsibility of carrying out that layout.
var core_layouts = {
	defaults: {},

	/**
	 * Register a box to a chart.
	 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
	 * @param {Chart} chart - the chart to use
	 * @param {ILayoutItem} item - the item to add to be layed out
	 */
	addBox: function(chart, item) {
		if (!chart.boxes) {
			chart.boxes = [];
		}

		// initialize item with default values
		item.fullWidth = item.fullWidth || false;
		item.position = item.position || 'top';
		item.weight = item.weight || 0;
		item._layers = item._layers || function() {
			return [{
				z: 0,
				draw: function() {
					item.draw.apply(item, arguments);
				}
			}];
		};

		chart.boxes.push(item);
	},

	/**
	 * Remove a layoutItem from a chart
	 * @param {Chart} chart - the chart to remove the box from
	 * @param {ILayoutItem} layoutItem - the item to remove from the layout
	 */
	removeBox: function(chart, layoutItem) {
		var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
		if (index !== -1) {
			chart.boxes.splice(index, 1);
		}
	},

	/**
	 * Sets (or updates) options on the given `item`.
	 * @param {Chart} chart - the chart in which the item lives (or will be added to)
	 * @param {ILayoutItem} item - the item to configure with the given options
	 * @param {object} options - the new item options.
	 */
	configure: function(chart, item, options) {
		var props = ['fullWidth', 'position', 'weight'];
		var ilen = props.length;
		var i = 0;
		var prop;

		for (; i < ilen; ++i) {
			prop = props[i];
			if (options.hasOwnProperty(prop)) {
				item[prop] = options[prop];
			}
		}
	},

	/**
	 * Fits boxes of the given chart into the given size by having each box measure itself
	 * then running a fitting algorithm
	 * @param {Chart} chart - the chart
	 * @param {number} width - the width to fit into
	 * @param {number} height - the height to fit into
	 */
	update: function(chart, width, height) {
		if (!chart) {
			return;
		}

		var layoutOptions = chart.options.layout || {};
		var padding = helpers$1.options.toPadding(layoutOptions.padding);

		var availableWidth = width - padding.width;
		var availableHeight = height - padding.height;
		var boxes = buildLayoutBoxes(chart.boxes);
		var verticalBoxes = boxes.vertical;
		var horizontalBoxes = boxes.horizontal;

		// Essentially we now have any number of boxes on each of the 4 sides.
		// Our canvas looks like the following.
		// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
		// B1 is the bottom axis
		// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
		// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
		// an error will be thrown.
		//
		// |----------------------------------------------------|
		// |                  T1 (Full Width)                   |
		// |----------------------------------------------------|
		// |    |    |                 T2                  |    |
		// |    |----|-------------------------------------|----|
		// |    |    | C1 |                           | C2 |    |
		// |    |    |----|                           |----|    |
		// |    |    |                                     |    |
		// | L1 | L2 |           ChartArea (C0)            | R1 |
		// |    |    |                                     |    |
		// |    |    |----|                           |----|    |
		// |    |    | C3 |                           | C4 |    |
		// |    |----|-------------------------------------|----|
		// |    |    |                 B1                  |    |
		// |----------------------------------------------------|
		// |                  B2 (Full Width)                   |
		// |----------------------------------------------------|
		//

		var params = Object.freeze({
			outerWidth: width,
			outerHeight: height,
			padding: padding,
			availableWidth: availableWidth,
			vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
			hBoxMaxHeight: availableHeight / 2
		});
		var chartArea = extend({
			maxPadding: extend({}, padding),
			w: availableWidth,
			h: availableHeight,
			x: padding.left,
			y: padding.top
		}, padding);

		setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

		// First fit vertical boxes
		fitBoxes(verticalBoxes, chartArea, params);

		// Then fit horizontal boxes
		if (fitBoxes(horizontalBoxes, chartArea, params)) {
			// if the area changed, re-fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);
		}

		handleMaxPadding(chartArea);

		// Finally place the boxes to correct coordinates
		placeBoxes(boxes.leftAndTop, chartArea, params);

		// Move to opposite side of chart
		chartArea.x += chartArea.w;
		chartArea.y += chartArea.h;

		placeBoxes(boxes.rightAndBottom, chartArea, params);

		chart.chartArea = {
			left: chartArea.left,
			top: chartArea.top,
			right: chartArea.left + chartArea.w,
			bottom: chartArea.top + chartArea.h
		};

		// Finally update boxes in chartArea (radial scale for example)
		helpers$1.each(boxes.chartArea, function(layout) {
			var box = layout.box;
			extend(box, chart.chartArea);
			box.update(chartArea.w, chartArea.h);
		});
	}
};

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

var platform_basic = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};

var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";

var platform_dom$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
'default': platform_dom
});

var stylesheet = getCjsExportFromNamespace(platform_dom$1);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers$1.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			// eslint-disable-next-line getter-return
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers$1.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers$1.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

function createDiv(cls) {
	var el = document.createElement('div');
	el.className = cls || '';
	return el;
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var maxSize = 1000000;

	// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
	// https://github.com/chartjs/Chart.js/issues/5902
	var resizer = createDiv(CSS_SIZE_MONITOR);
	var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
	var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

	expand.appendChild(createDiv());
	shrink.appendChild(createDiv());

	resizer.appendChild(expand);
	resizer.appendChild(shrink);
	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};

	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers$1.each(ANIMATION_START_EVENTS, function(type) {
		addListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers$1.each(ANIMATION_START_EVENTS, function(type) {
			removeListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			var container = chart.options.maintainAspectRatio && node.parentNode;
			var w = container ? container.clientWidth : 0;
			listener(createEvent('resize', chart));
			if (container && container.clientWidth < w && chart.canvas) {
				// If the container size shrank during chart resize, let's assume
				// scrollbar appeared. So we resize again with the scrollbar visible -
				// effectively making chart smaller and the scrollbar hidden again.
				// Because we are inside `throttled`, and currently `ticking`, scroll
				// events are ignored during this whole 2 resize process.
				// If we assumed wrong and something else happened, we are resizing
				// twice in a frame (potential performance issue)
				listener(createEvent('resize', chart));
			}
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

/**
 * Injects CSS styles inline if the styles are not already present.
 * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
 * @param {string} css - the CSS to be injected.
 */
function injectCSS(rootNode, css) {
	// https://stackoverflow.com/q/3922139
	var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
	if (!expando.containsStyles) {
		expando.containsStyles = true;
		css = '/* Chart.js */\n' + css;
		var style = document.createElement('style');
		style.setAttribute('type', 'text/css');
		style.appendChild(document.createTextNode(css));
		rootNode.appendChild(style);
	}
}

var platform_dom$2 = {
	/**
	 * When `true`, prevents the automatic injection of the stylesheet required to
	 * correctly detect when the chart is added to the DOM and then resized. This
	 * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
	 * to be manually imported to make this library compatible with any CSP.
	 * See https://github.com/chartjs/Chart.js/issues/5208
	 */
	disableCSSInjection: false,

	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	/**
	 * Initializes resources that depend on platform options.
	 * @param {HTMLCanvasElement} canvas - The Canvas element.
	 * @private
	 */
	_ensureLoaded: function(canvas) {
		if (!this.disableCSSInjection) {
			// If the canvas is in a shadow DOM, then the styles must also be inserted
			// into the same shadow DOM.
			// https://github.com/chartjs/Chart.js/issues/5763
			var root = canvas.getRootNode ? canvas.getRootNode() : document;
			var targetNode = root.host ? root : document.head;
			injectCSS(targetNode, stylesheet);
		}
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			// Load platform resources on first chart creation, to make it possible to
			// import the library before setting platform options.
			this._ensureLoaded(item);
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers$1.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers$1.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		// eslint-disable-next-line no-self-assign
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.addEvent = addListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers$1.removeEvent = removeListener;

// @TODO Make possible to select another platform at build time.
var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
var platform = helpers$1.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {string} type - The ({@link IEvent}) type to listen for
	 * @param {function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart - Chart from which to remove the listener
	 * @param {string} type - The ({@link IEvent}) type to remove
	 * @param {function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

core_defaults._set('global', {
	plugins: {}
});

/**
 * The plugin service singleton
 * @namespace Chart.plugins
 * @since 2.1.0
 */
var core_plugins = {
	/**
	 * Globally registered plugins.
	 * @private
	 */
	_plugins: [],

	/**
	 * This identifier is used to invalidate the descriptors cache attached to each chart
	 * when a global plugin is registered or unregistered. In this case, the cache ID is
	 * incremented and descriptors are regenerated during following API calls.
	 * @private
	 */
	_cacheId: 0,

	/**
	 * Registers the given plugin(s) if not already registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	register: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			if (p.indexOf(plugin) === -1) {
				p.push(plugin);
			}
		});

		this._cacheId++;
	},

	/**
	 * Unregisters the given plugin(s) only if registered.
	 * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
	 */
	unregister: function(plugins) {
		var p = this._plugins;
		([]).concat(plugins).forEach(function(plugin) {
			var idx = p.indexOf(plugin);
			if (idx !== -1) {
				p.splice(idx, 1);
			}
		});

		this._cacheId++;
	},

	/**
	 * Remove all registered plugins.
	 * @since 2.1.5
	 */
	clear: function() {
		this._plugins = [];
		this._cacheId++;
	},

	/**
	 * Returns the number of registered plugins?
	 * @returns {number}
	 * @since 2.1.5
	 */
	count: function() {
		return this._plugins.length;
	},

	/**
	 * Returns all registered plugin instances.
	 * @returns {IPlugin[]} array of plugin objects.
	 * @since 2.1.5
	 */
	getAll: function() {
		return this._plugins;
	},

	/**
	 * Calls enabled plugins for `chart` on the specified hook and with the given args.
	 * This method immediately returns as soon as a plugin explicitly returns false. The
	 * returned value can be used, for instance, to interrupt the current action.
	 * @param {Chart} chart - The chart instance for which plugins should be called.
	 * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
	 * @param {Array} [args] - Extra arguments to apply to the hook call.
	 * @returns {boolean} false if any of the plugins return false, else returns true.
	 */
	notify: function(chart, hook, args) {
		var descriptors = this.descriptors(chart);
		var ilen = descriptors.length;
		var i, descriptor, plugin, params, method;

		for (i = 0; i < ilen; ++i) {
			descriptor = descriptors[i];
			plugin = descriptor.plugin;
			method = plugin[hook];
			if (typeof method === 'function') {
				params = [chart].concat(args || []);
				params.push(descriptor.options);
				if (method.apply(plugin, params) === false) {
					return false;
				}
			}
		}

		return true;
	},

	/**
	 * Returns descriptors of enabled plugins for the given chart.
	 * @returns {object[]} [{ plugin, options }]
	 * @private
	 */
	descriptors: function(chart) {
		var cache = chart.$plugins || (chart.$plugins = {});
		if (cache.id === this._cacheId) {
			return cache.descriptors;
		}

		var plugins = [];
		var descriptors = [];
		var config = (chart && chart.config) || {};
		var options = (config.options && config.options.plugins) || {};

		this._plugins.concat(config.plugins || []).forEach(function(plugin) {
			var idx = plugins.indexOf(plugin);
			if (idx !== -1) {
				return;
			}

			var id = plugin.id;
			var opts = options[id];
			if (opts === false) {
				return;
			}

			if (opts === true) {
				opts = helpers$1.clone(core_defaults.global.plugins[id]);
			}

			plugins.push(plugin);
			descriptors.push({
				plugin: plugin,
				options: opts || {}
			});
		});

		cache.descriptors = descriptors;
		cache.id = this._cacheId;
		return descriptors;
	},

	/**
	 * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
	 * but in some cases, this reference can be changed by the user when updating options.
	 * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
	 * @private
	 */
	_invalidate: function(chart) {
		delete chart.$plugins;
	}
};

var core_scaleService = {
	// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
	// use the new chart options to grab the correct scale
	constructors: {},
	// Use a registration function so that we can move to an ES6 map when we no longer need to support
	// old browsers

	// Scale config defaults
	defaults: {},
	registerScaleType: function(type, scaleConstructor, scaleDefaults) {
		this.constructors[type] = scaleConstructor;
		this.defaults[type] = helpers$1.clone(scaleDefaults);
	},
	getScaleConstructor: function(type) {
		return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
	},
	getScaleDefaults: function(type) {
		// Return the scale defaults merged with the global settings so that we always use the latest ones
		return this.defaults.hasOwnProperty(type) ? helpers$1.merge({}, [core_defaults.scale, this.defaults[type]]) : {};
	},
	updateScaleDefaults: function(type, additions) {
		var me = this;
		if (me.defaults.hasOwnProperty(type)) {
			me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
		}
	},
	addScalesToLayout: function(chart) {
		// Adds each scale to the chart.boxes array to be sized accordingly
		helpers$1.each(chart.scales, function(scale) {
			// Set ILayoutItem parameters for backwards compatibility
			scale.fullWidth = scale.options.fullWidth;
			scale.position = scale.options.position;
			scale.weight = scale.options.weight;
			core_layouts.addBox(chart, scale);
		});
	}
};

var valueOrDefault$8 = helpers$1.valueOrDefault;
var getRtlHelper = helpers$1.rtl.getRtlAdapter;

core_defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers$1.noop,
			title: function(tooltipItems, data) {
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];
					if (item.label) {
						title = item.label;
					} else if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers$1.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers$1.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
					label += tooltipItem.value;
				} else {
					label += tooltipItem.yLabel;
				}
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers$1.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers$1.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers$1.noop,
			footer: helpers$1.noop,
			afterFooter: helpers$1.noop
		}
	}
});

var positioners = {
	/**
	 * Average mode places the tooltip at the average position of the elements shown
	 * @function Chart.Tooltip.positioners.average
	 * @param elements {ChartElement[]} the elements being displayed in the tooltip
	 * @returns {object} tooltip position
	 */
	average: function(elements) {
		if (!elements.length) {
			return false;
		}

		var i, len;
		var x = 0;
		var y = 0;
		var count = 0;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var pos = el.tooltipPosition();
				x += pos.x;
				y += pos.y;
				++count;
			}
		}

		return {
			x: x / count,
			y: y / count
		};
	},

	/**
	 * Gets the tooltip position nearest of the item nearest to the event position
	 * @function Chart.Tooltip.positioners.nearest
	 * @param elements {Chart.Element[]} the tooltip elements
	 * @param eventPosition {object} the position of the event in canvas coordinates
	 * @returns {object} the tooltip position
	 */
	nearest: function(elements, eventPosition) {
		var x = eventPosition.x;
		var y = eventPosition.y;
		var minDistance = Number.POSITIVE_INFINITY;
		var i, len, nearestElement;

		for (i = 0, len = elements.length; i < len; ++i) {
			var el = elements[i];
			if (el && el.hasValue()) {
				var center = el.getCenterPoint();
				var d = helpers$1.distanceBetweenPoints(eventPosition, center);

				if (d < minDistance) {
					minDistance = d;
					nearestElement = el;
				}
			}
		}

		if (nearestElement) {
			var tp = nearestElement.tooltipPosition();
			x = tp.x;
			y = tp.y;
		}

		return {
			x: x,
			y: y
		};
	}
};

// Helper to push or concat based on if the 2nd parameter is an array or not
function pushOrConcat(base, toPush) {
	if (toPush) {
		if (helpers$1.isArray(toPush)) {
			// base = base.concat(toPush);
			Array.prototype.push.apply(base, toPush);
		} else {
			base.push(toPush);
		}
	}

	return base;
}

/**
 * Returns array of strings split by newline
 * @param {string} value - The value to split by newline.
 * @returns {string[]} value if newline present - Returned from String split() method
 * @function
 */
function splitNewlines(str) {
	if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
		return str.split('\n');
	}
	return str;
}


/**
 * Private helper to create a tooltip item model
 * @param element - the chart element (point, arc, bar) to create the tooltip item for
 * @return new tooltip item
 */
function createTooltipItem(element) {
	var xScale = element._xScale;
	var yScale = element._yScale || element._scale; // handle radar || polarArea charts
	var index = element._index;
	var datasetIndex = element._datasetIndex;
	var controller = element._chart.getDatasetMeta(datasetIndex).controller;
	var indexScale = controller._getIndexScale();
	var valueScale = controller._getValueScale();

	return {
		xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
		yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
		label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
		value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
		index: index,
		datasetIndex: datasetIndex,
		x: element._model.x,
		y: element._model.y
	};
}

/**
 * Helper to get the reset model for the tooltip
 * @param tooltipOpts {object} the tooltip options
 */
function getBaseModel(tooltipOpts) {
	var globalDefaults = core_defaults.global;

	return {
		// Positioning
		xPadding: tooltipOpts.xPadding,
		yPadding: tooltipOpts.yPadding,
		xAlign: tooltipOpts.xAlign,
		yAlign: tooltipOpts.yAlign,

		// Drawing direction and text direction
		rtl: tooltipOpts.rtl,
		textDirection: tooltipOpts.textDirection,

		// Body
		bodyFontColor: tooltipOpts.bodyFontColor,
		_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
		_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
		_bodyAlign: tooltipOpts.bodyAlign,
		bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
		bodySpacing: tooltipOpts.bodySpacing,

		// Title
		titleFontColor: tooltipOpts.titleFontColor,
		_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
		_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
		titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
		_titleAlign: tooltipOpts.titleAlign,
		titleSpacing: tooltipOpts.titleSpacing,
		titleMarginBottom: tooltipOpts.titleMarginBottom,

		// Footer
		footerFontColor: tooltipOpts.footerFontColor,
		_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
		_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
		footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
		_footerAlign: tooltipOpts.footerAlign,
		footerSpacing: tooltipOpts.footerSpacing,
		footerMarginTop: tooltipOpts.footerMarginTop,

		// Appearance
		caretSize: tooltipOpts.caretSize,
		cornerRadius: tooltipOpts.cornerRadius,
		backgroundColor: tooltipOpts.backgroundColor,
		opacity: 0,
		legendColorBackground: tooltipOpts.multiKeyBackground,
		displayColors: tooltipOpts.displayColors,
		borderColor: tooltipOpts.borderColor,
		borderWidth: tooltipOpts.borderWidth
	};
}

/**
 * Get the size of the tooltip
 */
function getTooltipSize(tooltip, model) {
	var ctx = tooltip._chart.ctx;

	var height = model.yPadding * 2; // Tooltip Padding
	var width = 0;

	// Count of all lines in the body
	var body = model.body;
	var combinedBodyLength = body.reduce(function(count, bodyItem) {
		return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
	}, 0);
	combinedBodyLength += model.beforeBody.length + model.afterBody.length;

	var titleLineCount = model.title.length;
	var footerLineCount = model.footer.length;
	var titleFontSize = model.titleFontSize;
	var bodyFontSize = model.bodyFontSize;
	var footerFontSize = model.footerFontSize;

	height += titleLineCount * titleFontSize; // Title Lines
	height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
	height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
	height += combinedBodyLength * bodyFontSize; // Body Lines
	height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
	height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
	height += footerLineCount * (footerFontSize); // Footer Lines
	height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

	// Title width
	var widthPadding = 0;
	var maxLineWidth = function(line) {
		width = Math.max(width, ctx.measureText(line).width + widthPadding);
	};

	ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
	helpers$1.each(model.title, maxLineWidth);

	// Body width
	ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
	helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

	// Body lines may include some extra width due to the color box
	widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
	helpers$1.each(body, function(bodyItem) {
		helpers$1.each(bodyItem.before, maxLineWidth);
		helpers$1.each(bodyItem.lines, maxLineWidth);
		helpers$1.each(bodyItem.after, maxLineWidth);
	});

	// Reset back to 0
	widthPadding = 0;

	// Footer width
	ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
	helpers$1.each(model.footer, maxLineWidth);

	// Add padding
	width += 2 * model.xPadding;

	return {
		width: width,
		height: height
	};
}

/**
 * Helper to get the alignment of a tooltip given the size
 */
function determineAlignment(tooltip, size) {
	var model = tooltip._model;
	var chart = tooltip._chart;
	var chartArea = tooltip._chart.chartArea;
	var xAlign = 'center';
	var yAlign = 'center';

	if (model.y < size.height) {
		yAlign = 'top';
	} else if (model.y > (chart.height - size.height)) {
		yAlign = 'bottom';
	}

	var lf, rf; // functions to determine left, right alignment
	var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
	var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
	var midX = (chartArea.left + chartArea.right) / 2;
	var midY = (chartArea.top + chartArea.bottom) / 2;

	if (yAlign === 'center') {
		lf = function(x) {
			return x <= midX;
		};
		rf = function(x) {
			return x > midX;
		};
	} else {
		lf = function(x) {
			return x <= (size.width / 2);
		};
		rf = function(x) {
			return x >= (chart.width - (size.width / 2));
		};
	}

	olf = function(x) {
		return x + size.width + model.caretSize + model.caretPadding > chart.width;
	};
	orf = function(x) {
		return x - size.width - model.caretSize - model.caretPadding < 0;
	};
	yf = function(y) {
		return y <= midY ? 'top' : 'bottom';
	};

	if (lf(model.x)) {
		xAlign = 'left';

		// Is tooltip too wide and goes over the right side of the chart.?
		if (olf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	} else if (rf(model.x)) {
		xAlign = 'right';

		// Is tooltip too wide and goes outside left edge of canvas?
		if (orf(model.x)) {
			xAlign = 'center';
			yAlign = yf(model.y);
		}
	}

	var opts = tooltip._options;
	return {
		xAlign: opts.xAlign ? opts.xAlign : xAlign,
		yAlign: opts.yAlign ? opts.yAlign : yAlign
	};
}

/**
 * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
 */
function getBackgroundPoint(vm, size, alignment, chart) {
	// Background Position
	var x = vm.x;
	var y = vm.y;

	var caretSize = vm.caretSize;
	var caretPadding = vm.caretPadding;
	var cornerRadius = vm.cornerRadius;
	var xAlign = alignment.xAlign;
	var yAlign = alignment.yAlign;
	var paddingAndSize = caretSize + caretPadding;
	var radiusAndPadding = cornerRadius + caretPadding;

	if (xAlign === 'right') {
		x -= size.width;
	} else if (xAlign === 'center') {
		x -= (size.width / 2);
		if (x + size.width > chart.width) {
			x = chart.width - size.width;
		}
		if (x < 0) {
			x = 0;
		}
	}

	if (yAlign === 'top') {
		y += paddingAndSize;
	} else if (yAlign === 'bottom') {
		y -= size.height + paddingAndSize;
	} else {
		y -= (size.height / 2);
	}

	if (yAlign === 'center') {
		if (xAlign === 'left') {
			x += paddingAndSize;
		} else if (xAlign === 'right') {
			x -= paddingAndSize;
		}
	} else if (xAlign === 'left') {
		x -= radiusAndPadding;
	} else if (xAlign === 'right') {
		x += radiusAndPadding;
	}

	return {
		x: x,
		y: y
	};
}

function getAlignedX(vm, align) {
	return align === 'center'
		? vm.x + vm.width / 2
		: align === 'right'
			? vm.x + vm.width - vm.xPadding
			: vm.x + vm.xPadding;
}

/**
 * Helper to build before and after body lines
 */
function getBeforeAfterBodyLines(callback) {
	return pushOrConcat([], splitNewlines(callback));
}

var exports$4 = core_element.extend({
	initialize: function() {
		this._model = getBaseModel(this._options);
		this._lastActive = [];
	},

	// Get the title
	// Args are: (tooltipItem, data)
	getTitle: function() {
		var me = this;
		var opts = me._options;
		var callbacks = opts.callbacks;

		var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
		var title = callbacks.title.apply(me, arguments);
		var afterTitle = callbacks.afterTitle.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeTitle));
		lines = pushOrConcat(lines, splitNewlines(title));
		lines = pushOrConcat(lines, splitNewlines(afterTitle));

		return lines;
	},

	// Args are: (tooltipItem, data)
	getBeforeBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
	},

	// Args are: (tooltipItem, data)
	getBody: function(tooltipItems, data) {
		var me = this;
		var callbacks = me._options.callbacks;
		var bodyItems = [];

		helpers$1.each(tooltipItems, function(tooltipItem) {
			var bodyItem = {
				before: [],
				lines: [],
				after: []
			};
			pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
			pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
			pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

			bodyItems.push(bodyItem);
		});

		return bodyItems;
	},

	// Args are: (tooltipItem, data)
	getAfterBody: function() {
		return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
	},

	// Get the footer and beforeFooter and afterFooter lines
	// Args are: (tooltipItem, data)
	getFooter: function() {
		var me = this;
		var callbacks = me._options.callbacks;

		var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
		var footer = callbacks.footer.apply(me, arguments);
		var afterFooter = callbacks.afterFooter.apply(me, arguments);

		var lines = [];
		lines = pushOrConcat(lines, splitNewlines(beforeFooter));
		lines = pushOrConcat(lines, splitNewlines(footer));
		lines = pushOrConcat(lines, splitNewlines(afterFooter));

		return lines;
	},

	update: function(changed) {
		var me = this;
		var opts = me._options;

		// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
		// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
		// which breaks any animations.
		var existingModel = me._model;
		var model = me._model = getBaseModel(opts);
		var active = me._active;

		var data = me._data;

		// In the case where active.length === 0 we need to keep these at existing values for good animations
		var alignment = {
			xAlign: existingModel.xAlign,
			yAlign: existingModel.yAlign
		};
		var backgroundPoint = {
			x: existingModel.x,
			y: existingModel.y
		};
		var tooltipSize = {
			width: existingModel.width,
			height: existingModel.height
		};
		var tooltipPosition = {
			x: existingModel.caretX,
			y: existingModel.caretY
		};

		var i, len;

		if (active.length) {
			model.opacity = 1;

			var labelColors = [];
			var labelTextColors = [];
			tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

			var tooltipItems = [];
			for (i = 0, len = active.length; i < len; ++i) {
				tooltipItems.push(createTooltipItem(active[i]));
			}

			// If the user provided a filter function, use it to modify the tooltip items
			if (opts.filter) {
				tooltipItems = tooltipItems.filter(function(a) {
					return opts.filter(a, data);
				});
			}

			// If the user provided a sorting function, use it to modify the tooltip items
			if (opts.itemSort) {
				tooltipItems = tooltipItems.sort(function(a, b) {
					return opts.itemSort(a, b, data);
				});
			}

			// Determine colors for boxes
			helpers$1.each(tooltipItems, function(tooltipItem) {
				labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
				labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
			});


			// Build the Text Lines
			model.title = me.getTitle(tooltipItems, data);
			model.beforeBody = me.getBeforeBody(tooltipItems, data);
			model.body = me.getBody(tooltipItems, data);
			model.afterBody = me.getAfterBody(tooltipItems, data);
			model.footer = me.getFooter(tooltipItems, data);

			// Initial positioning and colors
			model.x = tooltipPosition.x;
			model.y = tooltipPosition.y;
			model.caretPadding = opts.caretPadding;
			model.labelColors = labelColors;
			model.labelTextColors = labelTextColors;

			// data points
			model.dataPoints = tooltipItems;

			// We need to determine alignment of the tooltip
			tooltipSize = getTooltipSize(this, model);
			alignment = determineAlignment(this, tooltipSize);
			// Final Size and Position
			backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
		} else {
			model.opacity = 0;
		}

		model.xAlign = alignment.xAlign;
		model.yAlign = alignment.yAlign;
		model.x = backgroundPoint.x;
		model.y = backgroundPoint.y;
		model.width = tooltipSize.width;
		model.height = tooltipSize.height;

		// Point where the caret on the tooltip points to
		model.caretX = tooltipPosition.x;
		model.caretY = tooltipPosition.y;

		me._model = model;

		if (changed && opts.custom) {
			opts.custom.call(me, model);
		}

		return me;
	},

	drawCaret: function(tooltipPoint, size) {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

		ctx.lineTo(caretPosition.x1, caretPosition.y1);
		ctx.lineTo(caretPosition.x2, caretPosition.y2);
		ctx.lineTo(caretPosition.x3, caretPosition.y3);
	},
	getCaretPosition: function(tooltipPoint, size, vm) {
		var x1, x2, x3, y1, y2, y3;
		var caretSize = vm.caretSize;
		var cornerRadius = vm.cornerRadius;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var ptX = tooltipPoint.x;
		var ptY = tooltipPoint.y;
		var width = size.width;
		var height = size.height;

		if (yAlign === 'center') {
			y2 = ptY + (height / 2);

			if (xAlign === 'left') {
				x1 = ptX;
				x2 = x1 - caretSize;
				x3 = x1;

				y1 = y2 + caretSize;
				y3 = y2 - caretSize;
			} else {
				x1 = ptX + width;
				x2 = x1 + caretSize;
				x3 = x1;

				y1 = y2 - caretSize;
				y3 = y2 + caretSize;
			}
		} else {
			if (xAlign === 'left') {
				x2 = ptX + cornerRadius + (caretSize);
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else if (xAlign === 'right') {
				x2 = ptX + width - cornerRadius - caretSize;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			} else {
				x2 = vm.caretX;
				x1 = x2 - caretSize;
				x3 = x2 + caretSize;
			}
			if (yAlign === 'top') {
				y1 = ptY;
				y2 = y1 - caretSize;
				y3 = y1;
			} else {
				y1 = ptY + height;
				y2 = y1 + caretSize;
				y3 = y1;
				// invert drawing order
				var tmp = x3;
				x3 = x1;
				x1 = tmp;
			}
		}
		return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
	},

	drawTitle: function(pt, vm, ctx) {
		var title = vm.title;
		var length = title.length;
		var titleFontSize, titleSpacing, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._titleAlign);

			ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
			ctx.textBaseline = 'middle';

			titleFontSize = vm.titleFontSize;
			titleSpacing = vm.titleSpacing;

			ctx.fillStyle = vm.titleFontColor;
			ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
				pt.y += titleFontSize + titleSpacing; // Line Height and spacing

				if (i + 1 === length) {
					pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
				}
			}
		}
	},

	drawBody: function(pt, vm, ctx) {
		var bodyFontSize = vm.bodyFontSize;
		var bodySpacing = vm.bodySpacing;
		var bodyAlign = vm._bodyAlign;
		var body = vm.body;
		var drawColorBoxes = vm.displayColors;
		var xLinePadding = 0;
		var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

		var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

		var fillLineOfText = function(line) {
			ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
			pt.y += bodyFontSize + bodySpacing;
		};

		var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
		var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

		ctx.textAlign = bodyAlign;
		ctx.textBaseline = 'middle';
		ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

		pt.x = getAlignedX(vm, bodyAlignForCalculation);

		// Before body lines
		ctx.fillStyle = vm.bodyFontColor;
		helpers$1.each(vm.beforeBody, fillLineOfText);

		xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right'
			? bodyAlign === 'center' ? (bodyFontSize / 2 + 1) : (bodyFontSize + 2)
			: 0;

		// Draw body lines now
		for (i = 0, ilen = body.length; i < ilen; ++i) {
			bodyItem = body[i];
			textColor = vm.labelTextColors[i];
			labelColors = vm.labelColors[i];

			ctx.fillStyle = textColor;
			helpers$1.each(bodyItem.before, fillLineOfText);

			lines = bodyItem.lines;
			for (j = 0, jlen = lines.length; j < jlen; ++j) {
				// Draw Legend-like boxes if needed
				if (drawColorBoxes) {
					var rtlColorX = rtlHelper.x(colorX);

					// Fill a white rect so that colours merge nicely if the opacity is < 1
					ctx.fillStyle = vm.legendColorBackground;
					ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Border
					ctx.lineWidth = 1;
					ctx.strokeStyle = labelColors.borderColor;
					ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

					// Inner square
					ctx.fillStyle = labelColors.backgroundColor;
					ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
					ctx.fillStyle = textColor;
				}

				fillLineOfText(lines[j]);
			}

			helpers$1.each(bodyItem.after, fillLineOfText);
		}

		// Reset back to 0 for after body
		xLinePadding = 0;

		// After body lines
		helpers$1.each(vm.afterBody, fillLineOfText);
		pt.y -= bodySpacing; // Remove last body spacing
	},

	drawFooter: function(pt, vm, ctx) {
		var footer = vm.footer;
		var length = footer.length;
		var footerFontSize, i;

		if (length) {
			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			pt.x = getAlignedX(vm, vm._footerAlign);
			pt.y += vm.footerMarginTop;

			ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
			ctx.textBaseline = 'middle';

			footerFontSize = vm.footerFontSize;

			ctx.fillStyle = vm.footerFontColor;
			ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

			for (i = 0; i < length; ++i) {
				ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
				pt.y += footerFontSize + vm.footerSpacing;
			}
		}
	},

	drawBackground: function(pt, vm, ctx, tooltipSize) {
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;
		var xAlign = vm.xAlign;
		var yAlign = vm.yAlign;
		var x = pt.x;
		var y = pt.y;
		var width = tooltipSize.width;
		var height = tooltipSize.height;
		var radius = vm.cornerRadius;

		ctx.beginPath();
		ctx.moveTo(x + radius, y);
		if (yAlign === 'top') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width - radius, y);
		ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
		if (yAlign === 'center' && xAlign === 'right') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + width, y + height - radius);
		ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
		if (yAlign === 'bottom') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x + radius, y + height);
		ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
		if (yAlign === 'center' && xAlign === 'left') {
			this.drawCaret(pt, tooltipSize);
		}
		ctx.lineTo(x, y + radius);
		ctx.quadraticCurveTo(x, y, x + radius, y);
		ctx.closePath();

		ctx.fill();

		if (vm.borderWidth > 0) {
			ctx.stroke();
		}
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;

		if (vm.opacity === 0) {
			return;
		}

		var tooltipSize = {
			width: vm.width,
			height: vm.height
		};
		var pt = {
			x: vm.x,
			y: vm.y
		};

		// IE11/Edge does not like very small opacities, so snap to 0
		var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

		// Truthy/falsey value for empty tooltip
		var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

		if (this._options.enabled && hasTooltipContent) {
			ctx.save();
			ctx.globalAlpha = opacity;

			// Draw Background
			this.drawBackground(pt, vm, ctx, tooltipSize);

			// Draw Title, Body, and Footer
			pt.y += vm.yPadding;

			helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

			// Titles
			this.drawTitle(pt, vm, ctx);

			// Body
			this.drawBody(pt, vm, ctx);

			// Footer
			this.drawFooter(pt, vm, ctx);

			helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

			ctx.restore();
		}
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 * @returns {boolean} true if the tooltip changed
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me._options;
		var changed = false;

		me._lastActive = me._lastActive || [];

		// Find Active Elements for tooltips
		if (e.type === 'mouseout') {
			me._active = [];
		} else {
			me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			if (options.reverse) {
				me._active.reverse();
			}
		}

		// Remember Last Actives
		changed = !helpers$1.arrayEquals(me._active, me._lastActive);

		// Only handle target event on tooltip change
		if (changed) {
			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				me.update(true);
				me.pivot();
			}
		}

		return changed;
	}
});

/**
 * @namespace Chart.Tooltip.positioners
 */
var positioners_1 = positioners;

var core_tooltip = exports$4;
core_tooltip.positioners = positioners_1;

var valueOrDefault$9 = helpers$1.valueOrDefault;

core_defaults._set('global', {
	elements: {},
	events: [
		'mousemove',
		'mouseout',
		'click',
		'touchstart',
		'touchmove'
	],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	maintainAspectRatio: true,
	responsive: true,
	responsiveAnimationDuration: 0
});

/**
 * Recursively merge the given config objects representing the `scales` option
 * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
 * returns a deep copy of the result, thus doesn't alter inputs.
 */
function mergeScaleConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			if (key === 'xAxes' || key === 'yAxes') {
				var slen = source[key].length;
				var i, type, scale;

				if (!target[key]) {
					target[key] = [];
				}

				for (i = 0; i < slen; ++i) {
					scale = source[key][i];
					type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

					if (i >= target[key].length) {
						target[key].push({});
					}

					if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
						// new/untyped scale or type changed: let's apply the new defaults
						// then merge source scale to correctly overwrite the defaults.
						helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
					} else {
						// scales type are the same
						helpers$1.merge(target[key][i], scale);
					}
				}
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

/**
 * Recursively merge the given config objects as the root options by handling
 * default scale options for the `scales` and `scale` properties, then returns
 * a deep copy of the result, thus doesn't alter inputs.
 */
function mergeConfig(/* config objects ... */) {
	return helpers$1.merge({}, [].slice.call(arguments), {
		merger: function(key, target, source, options) {
			var tval = target[key] || {};
			var sval = source[key];

			if (key === 'scales') {
				// scale config merging is complex. Add our own function here for that
				target[key] = mergeScaleConfig(tval, sval);
			} else if (key === 'scale') {
				// used in polar area & radar charts since there is only one scale
				target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
			} else {
				helpers$1._merger(key, target, source, options);
			}
		}
	});
}

function initConfig(config) {
	config = config || {};

	// Do NOT use mergeConfig for the data object because this method merges arrays
	// and so would change references to labels and datasets, preventing data updates.
	var data = config.data = config.data || {};
	data.datasets = data.datasets || [];
	data.labels = data.labels || [];

	config.options = mergeConfig(
		core_defaults.global,
		core_defaults[config.type],
		config.options || {});

	return config;
}

function updateConfig(chart) {
	var newOptions = chart.options;

	helpers$1.each(chart.scales, function(scale) {
		core_layouts.removeBox(chart, scale);
	});

	newOptions = mergeConfig(
		core_defaults.global,
		core_defaults[chart.config.type],
		newOptions);

	chart.options = chart.config.options = newOptions;
	chart.ensureScalesHaveIDs();
	chart.buildOrUpdateScales();

	// Tooltip
	chart.tooltip._options = newOptions.tooltips;
	chart.tooltip.initialize();
}

function nextAvailableScaleId(axesOpts, prefix, index) {
	var id;
	var hasId = function(obj) {
		return obj.id === id;
	};

	do {
		id = prefix + index++;
	} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

	return id;
}

function positionIsHorizontal(position) {
	return position === 'top' || position === 'bottom';
}

function compare2Level(l1, l2) {
	return function(a, b) {
		return a[l1] === b[l1]
			? a[l2] - b[l2]
			: a[l1] - b[l1];
	};
}

var Chart = function(item, config) {
	this.construct(item, config);
	return this;
};

helpers$1.extend(Chart.prototype, /** @lends Chart */ {
	/**
	 * @private
	 */
	construct: function(item, config) {
		var me = this;

		config = initConfig(config);

		var context = platform.acquireContext(item, config);
		var canvas = context && context.canvas;
		var height = canvas && canvas.height;
		var width = canvas && canvas.width;

		me.id = helpers$1.uid();
		me.ctx = context;
		me.canvas = canvas;
		me.config = config;
		me.width = width;
		me.height = height;
		me.aspectRatio = height ? width / height : null;
		me.options = config.options;
		me._bufferedRender = false;
		me._layers = [];

		/**
		 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
		 * the "instance" still need to be defined since it might be called from plugins.
		 * @prop Chart#chart
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		me.chart = me;
		me.controller = me; // chart.chart.controller #inception

		// Add the chart instance to the global namespace
		Chart.instances[me.id] = me;

		// Define alias to the config data: `chart.data === chart.config.data`
		Object.defineProperty(me, 'data', {
			get: function() {
				return me.config.data;
			},
			set: function(value) {
				me.config.data = value;
			}
		});

		if (!context || !canvas) {
			// The given item is not a compatible context2d element, let's return before finalizing
			// the chart initialization but after setting basic chart / controller properties that
			// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
			// https://github.com/chartjs/Chart.js/issues/2807
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}

		me.initialize();
		me.update();
	},

	/**
	 * @private
	 */
	initialize: function() {
		var me = this;

		// Before init plugin notification
		core_plugins.notify(me, 'beforeInit');

		helpers$1.retinaScale(me, me.options.devicePixelRatio);

		me.bindEvents();

		if (me.options.responsive) {
			// Initial resize before chart draws (must be silent to preserve initial animations).
			me.resize(true);
		}

		me.initToolTip();

		// After init plugin notification
		core_plugins.notify(me, 'afterInit');

		return me;
	},

	clear: function() {
		helpers$1.canvas.clear(this);
		return this;
	},

	stop: function() {
		// Stops any current animation loop occurring
		core_animations.cancelAnimation(this);
		return this;
	},

	resize: function(silent) {
		var me = this;
		var options = me.options;
		var canvas = me.canvas;
		var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

		// the canvas render width and height will be casted to integers so make sure that
		// the canvas display style uses the same integer values to avoid blurring effect.

		// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
		var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
		var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

		if (me.width === newWidth && me.height === newHeight) {
			return;
		}

		canvas.width = me.width = newWidth;
		canvas.height = me.height = newHeight;
		canvas.style.width = newWidth + 'px';
		canvas.style.height = newHeight + 'px';

		helpers$1.retinaScale(me, options.devicePixelRatio);

		if (!silent) {
			// Notify any plugins about the resize
			var newSize = {width: newWidth, height: newHeight};
			core_plugins.notify(me, 'resize', [newSize]);

			// Notify of resize
			if (options.onResize) {
				options.onResize(me, newSize);
			}

			me.stop();
			me.update({
				duration: options.responsiveAnimationDuration
			});
		}
	},

	ensureScalesHaveIDs: function() {
		var options = this.options;
		var scalesOptions = options.scales || {};
		var scaleOptions = options.scale;

		helpers$1.each(scalesOptions.xAxes, function(xAxisOptions, index) {
			if (!xAxisOptions.id) {
				xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
			}
		});

		helpers$1.each(scalesOptions.yAxes, function(yAxisOptions, index) {
			if (!yAxisOptions.id) {
				yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
			}
		});

		if (scaleOptions) {
			scaleOptions.id = scaleOptions.id || 'scale';
		}
	},

	/**
	 * Builds a map of scale ID to scale object for future lookup.
	 */
	buildOrUpdateScales: function() {
		var me = this;
		var options = me.options;
		var scales = me.scales || {};
		var items = [];
		var updated = Object.keys(scales).reduce(function(obj, id) {
			obj[id] = false;
			return obj;
		}, {});

		if (options.scales) {
			items = items.concat(
				(options.scales.xAxes || []).map(function(xAxisOptions) {
					return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
				}),
				(options.scales.yAxes || []).map(function(yAxisOptions) {
					return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
				})
			);
		}

		if (options.scale) {
			items.push({
				options: options.scale,
				dtype: 'radialLinear',
				isDefault: true,
				dposition: 'chartArea'
			});
		}

		helpers$1.each(items, function(item) {
			var scaleOptions = item.options;
			var id = scaleOptions.id;
			var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

			if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
				scaleOptions.position = item.dposition;
			}

			updated[id] = true;
			var scale = null;
			if (id in scales && scales[id].type === scaleType) {
				scale = scales[id];
				scale.options = scaleOptions;
				scale.ctx = me.ctx;
				scale.chart = me;
			} else {
				var scaleClass = core_scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}
				scale = new scaleClass({
					id: id,
					type: scaleType,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});
				scales[scale.id] = scale;
			}

			scale.mergeTicksOptions();

			// TODO(SB): I think we should be able to remove this custom case (options.scale)
			// and consider it as a regular scale part of the "scales"" map only! This would
			// make the logic easier and remove some useless? custom code.
			if (item.isDefault) {
				me.scale = scale;
			}
		});
		// clear up discarded scales
		helpers$1.each(updated, function(hasUpdated, id) {
			if (!hasUpdated) {
				delete scales[id];
			}
		});

		me.scales = scales;

		core_scaleService.addScalesToLayout(this);
	},

	buildOrUpdateControllers: function() {
		var me = this;
		var newControllers = [];
		var datasets = me.data.datasets;
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			var dataset = datasets[i];
			var meta = me.getDatasetMeta(i);
			var type = dataset.type || me.config.type;

			if (meta.type && meta.type !== type) {
				me.destroyDatasetMeta(i);
				meta = me.getDatasetMeta(i);
			}
			meta.type = type;
			meta.order = dataset.order || 0;
			meta.index = i;

			if (meta.controller) {
				meta.controller.updateIndex(i);
				meta.controller.linkScales();
			} else {
				var ControllerClass = controllers[meta.type];
				if (ControllerClass === undefined) {
					throw new Error('"' + meta.type + '" is not a chart type.');
				}

				meta.controller = new ControllerClass(me, i);
				newControllers.push(meta.controller);
			}
		}

		return newControllers;
	},

	/**
	 * Reset the elements of all datasets
	 * @private
	 */
	resetElements: function() {
		var me = this;
		helpers$1.each(me.data.datasets, function(dataset, datasetIndex) {
			me.getDatasetMeta(datasetIndex).controller.reset();
		}, me);
	},

	/**
	* Resets the chart back to it's state before the initial animation
	*/
	reset: function() {
		this.resetElements();
		this.tooltip.initialize();
	},

	update: function(config) {
		var me = this;
		var i, ilen;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		updateConfig(me);

		// plugins options references might have change, let's invalidate the cache
		// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
		core_plugins._invalidate(me);

		if (core_plugins.notify(me, 'beforeUpdate') === false) {
			return;
		}

		// In case the entire data object changed
		me.tooltip._data = me.data;

		// Make sure dataset controllers are updated and new controllers are reset
		var newControllers = me.buildOrUpdateControllers();

		// Make sure all dataset controllers have correct meta data counts
		for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
			me.getDatasetMeta(i).controller.buildOrUpdateElements();
		}

		me.updateLayout();

		// Can only reset the new controllers after the scales have been updated
		if (me.options.animation && me.options.animation.duration) {
			helpers$1.each(newControllers, function(controller) {
				controller.reset();
			});
		}

		me.updateDatasets();

		// Need to reset tooltip in case it is displayed with elements that are removed
		// after update.
		me.tooltip.initialize();

		// Last active contains items that were previously in the tooltip.
		// When we reset the tooltip, we need to clear it
		me.lastActive = [];

		// Do this before render so that any plugins that need final scale updates can use it
		core_plugins.notify(me, 'afterUpdate');

		me._layers.sort(compare2Level('z', '_idx'));

		if (me._bufferedRender) {
			me._bufferedRequest = {
				duration: config.duration,
				easing: config.easing,
				lazy: config.lazy
			};
		} else {
			me.render(config);
		}
	},

	/**
	 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
	 * hook, in which case, plugins will not be called on `afterLayout`.
	 * @private
	 */
	updateLayout: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeLayout') === false) {
			return;
		}

		core_layouts.update(this, this.width, this.height);

		me._layers = [];
		helpers$1.each(me.boxes, function(box) {
			// _configure is called twice, once in core.scale.update and once here.
			// Here the boxes are fully updated and at their final positions.
			if (box._configure) {
				box._configure();
			}
			me._layers.push.apply(me._layers, box._layers());
		}, me);

		me._layers.forEach(function(item, index) {
			item._idx = index;
		});

		/**
		 * Provided for backward compatibility, use `afterLayout` instead.
		 * @method IPlugin#afterScaleUpdate
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		core_plugins.notify(me, 'afterScaleUpdate');
		core_plugins.notify(me, 'afterLayout');
	},

	/**
	 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
	 * @private
	 */
	updateDatasets: function() {
		var me = this;

		if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
			return;
		}

		for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.updateDataset(i);
		}

		core_plugins.notify(me, 'afterDatasetsUpdate');
	},

	/**
	 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
	 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
	 * @private
	 */
	updateDataset: function(index) {
		var me = this;
		var meta = me.getDatasetMeta(index);
		var args = {
			meta: meta,
			index: index
		};

		if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
			return;
		}

		meta.controller._update();

		core_plugins.notify(me, 'afterDatasetUpdate', [args]);
	},

	render: function(config) {
		var me = this;

		if (!config || typeof config !== 'object') {
			// backwards compatibility
			config = {
				duration: config,
				lazy: arguments[1]
			};
		}

		var animationOptions = me.options.animation;
		var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
		var lazy = config.lazy;

		if (core_plugins.notify(me, 'beforeRender') === false) {
			return;
		}

		var onComplete = function(animation) {
			core_plugins.notify(me, 'afterRender');
			helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
		};

		if (animationOptions && duration) {
			var animation = new core_animation({
				numSteps: duration / 16.66, // 60 fps
				easing: config.easing || animationOptions.easing,

				render: function(chart, animationObject) {
					var easingFunction = helpers$1.easing.effects[animationObject.easing];
					var currentStep = animationObject.currentStep;
					var stepDecimal = currentStep / animationObject.numSteps;

					chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
				},

				onAnimationProgress: animationOptions.onProgress,
				onAnimationComplete: onComplete
			});

			core_animations.addAnimation(me, animation, duration, lazy);
		} else {
			me.draw();

			// See https://github.com/chartjs/Chart.js/issues/3781
			onComplete(new core_animation({numSteps: 0, chart: me}));
		}

		return me;
	},

	draw: function(easingValue) {
		var me = this;
		var i, layers;

		me.clear();

		if (helpers$1.isNullOrUndef(easingValue)) {
			easingValue = 1;
		}

		me.transition(easingValue);

		if (me.width <= 0 || me.height <= 0) {
			return;
		}

		if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
			return;
		}

		// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
		// currently be part of layers. Instead, we draw
		// layers <= 0 before(default, backward compat), and the rest after
		layers = me._layers;
		for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
			layers[i].draw(me.chartArea);
		}

		me.drawDatasets(easingValue);

		// Rest of layers
		for (; i < layers.length; ++i) {
			layers[i].draw(me.chartArea);
		}

		me._drawTooltip(easingValue);

		core_plugins.notify(me, 'afterDraw', [easingValue]);
	},

	/**
	 * @private
	 */
	transition: function(easingValue) {
		var me = this;

		for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
			if (me.isDatasetVisible(i)) {
				me.getDatasetMeta(i).controller.transition(easingValue);
			}
		}

		me.tooltip.transition(easingValue);
	},

	/**
	 * @private
	 */
	_getSortedDatasetMetas: function(filterVisible) {
		var me = this;
		var datasets = me.data.datasets || [];
		var result = [];
		var i, ilen;

		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!filterVisible || me.isDatasetVisible(i)) {
				result.push(me.getDatasetMeta(i));
			}
		}

		result.sort(compare2Level('order', 'index'));

		return result;
	},

	/**
	 * @private
	 */
	_getSortedVisibleDatasetMetas: function() {
		return this._getSortedDatasetMetas(true);
	},

	/**
	 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
	 * @private
	 */
	drawDatasets: function(easingValue) {
		var me = this;
		var metasets, i;

		if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
			return;
		}

		metasets = me._getSortedVisibleDatasetMetas();
		for (i = metasets.length - 1; i >= 0; --i) {
			me.drawDataset(metasets[i], easingValue);
		}

		core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
	},

	/**
	 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
	 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
	 * @private
	 */
	drawDataset: function(meta, easingValue) {
		var me = this;
		var args = {
			meta: meta,
			index: meta.index,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
			return;
		}

		meta.controller.draw(easingValue);

		core_plugins.notify(me, 'afterDatasetDraw', [args]);
	},

	/**
	 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
	 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
	 * @private
	 */
	_drawTooltip: function(easingValue) {
		var me = this;
		var tooltip = me.tooltip;
		var args = {
			tooltip: tooltip,
			easingValue: easingValue
		};

		if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
			return;
		}

		tooltip.draw();

		core_plugins.notify(me, 'afterTooltipDraw', [args]);
	},

	/**
	 * Get the single element that was clicked on
	 * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
	 */
	getElementAtEvent: function(e) {
		return core_interaction.modes.single(this, e);
	},

	getElementsAtEvent: function(e) {
		return core_interaction.modes.label(this, e, {intersect: true});
	},

	getElementsAtXAxis: function(e) {
		return core_interaction.modes['x-axis'](this, e, {intersect: true});
	},

	getElementsAtEventForMode: function(e, mode, options) {
		var method = core_interaction.modes[mode];
		if (typeof method === 'function') {
			return method(this, e, options);
		}

		return [];
	},

	getDatasetAtEvent: function(e) {
		return core_interaction.modes.dataset(this, e, {intersect: true});
	},

	getDatasetMeta: function(datasetIndex) {
		var me = this;
		var dataset = me.data.datasets[datasetIndex];
		if (!dataset._meta) {
			dataset._meta = {};
		}

		var meta = dataset._meta[me.id];
		if (!meta) {
			meta = dataset._meta[me.id] = {
				type: null,
				data: [],
				dataset: null,
				controller: null,
				hidden: null,			// See isDatasetVisible() comment
				xAxisID: null,
				yAxisID: null,
				order: dataset.order || 0,
				index: datasetIndex
			};
		}

		return meta;
	},

	getVisibleDatasetCount: function() {
		var count = 0;
		for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
			if (this.isDatasetVisible(i)) {
				count++;
			}
		}
		return count;
	},

	isDatasetVisible: function(datasetIndex) {
		var meta = this.getDatasetMeta(datasetIndex);

		// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
		// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
		return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
	},

	generateLegend: function() {
		return this.options.legendCallback(this);
	},

	/**
	 * @private
	 */
	destroyDatasetMeta: function(datasetIndex) {
		var id = this.id;
		var dataset = this.data.datasets[datasetIndex];
		var meta = dataset._meta && dataset._meta[id];

		if (meta) {
			meta.controller.destroy();
			delete dataset._meta[id];
		}
	},

	destroy: function() {
		var me = this;
		var canvas = me.canvas;
		var i, ilen;

		me.stop();

		// dataset controllers need to cleanup associated data
		for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
			me.destroyDatasetMeta(i);
		}

		if (canvas) {
			me.unbindEvents();
			helpers$1.canvas.clear(me);
			platform.releaseContext(me.ctx);
			me.canvas = null;
			me.ctx = null;
		}

		core_plugins.notify(me, 'destroy');

		delete Chart.instances[me.id];
	},

	toBase64Image: function() {
		return this.canvas.toDataURL.apply(this.canvas, arguments);
	},

	initToolTip: function() {
		var me = this;
		me.tooltip = new core_tooltip({
			_chart: me,
			_chartInstance: me, // deprecated, backward compatibility
			_data: me.data,
			_options: me.options.tooltips
		}, me);
	},

	/**
	 * @private
	 */
	bindEvents: function() {
		var me = this;
		var listeners = me._listeners = {};
		var listener = function() {
			me.eventHandler.apply(me, arguments);
		};

		helpers$1.each(me.options.events, function(type) {
			platform.addEventListener(me, type, listener);
			listeners[type] = listener;
		});

		// Elements used to detect size change should not be injected for non responsive charts.
		// See https://github.com/chartjs/Chart.js/issues/2210
		if (me.options.responsive) {
			listener = function() {
				me.resize();
			};

			platform.addEventListener(me, 'resize', listener);
			listeners.resize = listener;
		}
	},

	/**
	 * @private
	 */
	unbindEvents: function() {
		var me = this;
		var listeners = me._listeners;
		if (!listeners) {
			return;
		}

		delete me._listeners;
		helpers$1.each(listeners, function(listener, type) {
			platform.removeEventListener(me, type, listener);
		});
	},

	updateHoverStyle: function(elements, mode, enabled) {
		var prefix = enabled ? 'set' : 'remove';
		var element, i, ilen;

		for (i = 0, ilen = elements.length; i < ilen; ++i) {
			element = elements[i];
			if (element) {
				this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
			}
		}

		if (mode === 'dataset') {
			this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
		}
	},

	/**
	 * @private
	 */
	eventHandler: function(e) {
		var me = this;
		var tooltip = me.tooltip;

		if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
			return;
		}

		// Buffer any update calls so that renders do not occur
		me._bufferedRender = true;
		me._bufferedRequest = null;

		var changed = me.handleEvent(e);
		// for smooth tooltip animations issue #4989
		// the tooltip should be the source of change
		// Animation check workaround:
		// tooltip._start will be null when tooltip isn't animating
		if (tooltip) {
			changed = tooltip._start
				? tooltip.handleEvent(e)
				: changed | tooltip.handleEvent(e);
		}

		core_plugins.notify(me, 'afterEvent', [e]);

		var bufferedRequest = me._bufferedRequest;
		if (bufferedRequest) {
			// If we have an update that was triggered, we need to do a normal render
			me.render(bufferedRequest);
		} else if (changed && !me.animating) {
			// If entering, leaving, or changing elements, animate the change via pivot
			me.stop();

			// We only need to render at this point. Updating will cause scales to be
			// recomputed generating flicker & using more memory than necessary.
			me.render({
				duration: me.options.hover.animationDuration,
				lazy: true
			});
		}

		me._bufferedRender = false;
		me._bufferedRequest = null;

		return me;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event the event to handle
	 * @return {boolean} true if the chart needs to re-render
	 */
	handleEvent: function(e) {
		var me = this;
		var options = me.options || {};
		var hoverOptions = options.hover;
		var changed = false;

		me.lastActive = me.lastActive || [];

		// Find Active Elements for hover and tooltips
		if (e.type === 'mouseout') {
			me.active = [];
		} else {
			me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
		}

		// Invoke onHover hook
		// Need to call with native event here to not break backwards compatibility
		helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

		if (e.type === 'mouseup' || e.type === 'click') {
			if (options.onClick) {
				// Use e.native here for backwards compatibility
				options.onClick.call(me, e.native, me.active);
			}
		}

		// Remove styling for last active (even if it may still be active)
		if (me.lastActive.length) {
			me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
		}

		// Built in hover styling
		if (me.active.length && hoverOptions.mode) {
			me.updateHoverStyle(me.active, hoverOptions.mode, true);
		}

		changed = !helpers$1.arrayEquals(me.active, me.lastActive);

		// Remember Last Actives
		me.lastActive = me.active;

		return changed;
	}
});

/**
 * NOTE(SB) We actually don't use this container anymore but we need to keep it
 * for backward compatibility. Though, it can still be useful for plugins that
 * would need to work on multiple charts?!
 */
Chart.instances = {};

var core_controller = Chart;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart instead.
 * @class Chart.Controller
 * @deprecated since version 2.6
 * @todo remove at version 3
 * @private
 */
Chart.Controller = Chart;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
Chart.types = {};

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.configMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.configMerge = mergeConfig;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.helpers.scaleMerge
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
helpers$1.scaleMerge = mergeScaleConfig;

var core_helpers = function() {

	// -- Basic js utility methods

	helpers$1.where = function(collection, filterCallback) {
		if (helpers$1.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers$1.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers$1.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers$1.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers$1.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers$1.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers$1.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers$1.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers$1.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return ((rounded - epsilon) <= x) && ((rounded + epsilon) >= x);
	};
	helpers$1.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers$1.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers$1.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers$1.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers$1.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};

	/**
	 * Returns the number of decimal places
	 * i.e. the number of digits after the decimal point, of the value of this Number.
	 * @param {number} x - A number.
	 * @returns {number} The number of decimal places.
	 * @private
	 */
	helpers$1._decimalPlaces = function(x) {
		if (!helpers$1.isFinite(x)) {
			return;
		}
		var e = 1;
		var p = 0;
		while (Math.round(x * e) / e !== x) {
			e *= 10;
			p++;
		}
		return p;
	};

	// Gets the angle from vertical upright to the point about a centre.
	helpers$1.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers$1.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.helpers.aliasPixel
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	helpers$1.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};

	/**
	 * Returns the aligned pixel value to avoid anti-aliasing blur
	 * @param {Chart} chart - The chart instance.
	 * @param {number} pixel - A pixel value.
	 * @param {number} width - The width of the element.
	 * @returns {number} The aligned pixel value.
	 * @private
	 */
	helpers$1._alignPixel = function(chart, pixel, width) {
		var devicePixelRatio = chart.currentDevicePixelRatio;
		var halfWidth = width / 2;
		return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
	};

	helpers$1.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers$1.EPSILON = Number.EPSILON || 1e-14;
	helpers$1.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers$1.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers$1.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers$1.niceNum = function(range, round) {
		var exponent = Math.floor(helpers$1.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers$1.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers$1.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.target || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	/**
	 * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
	 * @param {HTMLElement} domNode - the node to check the constraint on
	 * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
	 * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
	 * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
	 */
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = helpers$1._getParentNode(domNode);
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers$1.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers$1.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	/**
	 * @private
 	 */
	helpers$1._calculatePadding = function(container, padding, parentDimension) {
		padding = helpers$1.getStyle(container, padding);

		return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
	};
	/**
	 * @private
	 */
	helpers$1._getParentNode = function(domNode) {
		var parent = domNode.parentNode;
		if (parent && parent.toString() === '[object ShadowRoot]') {
			parent = parent.host;
		}
		return parent;
	};
	helpers$1.getMaximumWidth = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientWidth;
		}

		var clientWidth = container.clientWidth;
		var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
		var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

		var w = clientWidth - paddingLeft - paddingRight;
		var cw = helpers$1.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers$1.getMaximumHeight = function(domNode) {
		var container = helpers$1._getParentNode(domNode);
		if (!container) {
			return domNode.clientHeight;
		}

		var clientHeight = container.clientHeight;
		var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
		var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

		var h = clientHeight - paddingTop - paddingBottom;
		var ch = helpers$1.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers$1.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers$1.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		if (!canvas.style.height && !canvas.style.width) {
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		}
	};
	// -- Canvas methods
	helpers$1.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers$1.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		var ilen = arrayOfThings.length;
		var i, j, jlen, thing, nestedThing;
		for (i = 0; i < ilen; i++) {
			thing = arrayOfThings[i];

			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
				longest = helpers$1.measureText(ctx, data, gc, longest, thing);
			} else if (helpers$1.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				for (j = 0, jlen = thing.length; j < jlen; j++) {
					nestedThing = thing[j];
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
						longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
					}
				}
			}
		}

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers$1.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};

	/**
	 * @deprecated
	 */
	helpers$1.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers$1.each(arrayOfThings, function(thing) {
			if (helpers$1.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers$1.color = !chartjsColor ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

	helpers$1.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient) ?
			colorValue :
			helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};

function abstract() {
	throw new Error(
		'This method is not implemented: either no adapter can ' +
		'be found or an incomplete integration was provided.'
	);
}

/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */

/**
 * Currently supported unit string values.
 * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
 * @memberof Chart._adapters._date
 * @name Unit
 */

/**
 * @class
 */
function DateAdapter(options) {
	this.options = options || {};
}

helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */ {
	/**
	 * Returns a map of time formats for the supported formatting units defined
	 * in Unit as well as 'datetime' representing a detailed date/time string.
	 * @returns {{string: string}}
	 */
	formats: abstract,

	/**
	 * Parses the given `value` and return the associated timestamp.
	 * @param {any} value - the value to parse (usually comes from the data)
	 * @param {string} [format] - the expected data format
	 * @returns {(number|null)}
	 * @function
	 */
	parse: abstract,

	/**
	 * Returns the formatted date in the specified `format` for a given `timestamp`.
	 * @param {number} timestamp - the timestamp to format
	 * @param {string} format - the date/time token
	 * @return {string}
	 * @function
	 */
	format: abstract,

	/**
	 * Adds the specified `amount` of `unit` to the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {number} amount - the amount to add
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	add: abstract,

	/**
	 * Returns the number of `unit` between the given timestamps.
	 * @param {number} max - the input timestamp (reference)
	 * @param {number} min - the timestamp to substract
	 * @param {Unit} unit - the unit as string
	 * @return {number}
	 * @function
	 */
	diff: abstract,

	/**
	 * Returns start of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @param {number} [weekday] - the ISO day of the week with 1 being Monday
	 * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
	 * @function
	 */
	startOf: abstract,

	/**
	 * Returns end of `unit` for the given `timestamp`.
	 * @param {number} timestamp - the input timestamp
	 * @param {Unit} unit - the unit as string
	 * @function
	 */
	endOf: abstract,

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility for scale.getValueForPixel(),
	 * this method should be overridden only by the moment adapter.
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(value) {
		return value;
	}
});

DateAdapter.override = function(members) {
	helpers$1.extend(DateAdapter.prototype, members);
};

var _date = DateAdapter;

var core_adapters = {
	_date: _date
};

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
var core_ticks = {
	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {string|string[]} the label to display
		 */
		values: function(value) {
			return helpers$1.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {number} the value to be formatted
		 * @param index {number} the position of the tickValue parameter in the ticks array
		 * @param ticks {number[]} the list of ticks being converted
		 * @return {string} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers$1.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
				if (maxTick < 1e-4) { // all ticks are small numbers; use scientific notation
					var logTick = helpers$1.log10(Math.abs(tickValue));
					var numExponential = Math.floor(logTick) - Math.floor(logDelta);
					numExponential = Math.max(Math.min(numExponential, 20), 0);
					tickString = tickValue.toExponential(numExponential);
				} else {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				}
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers$1.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};

var isArray = helpers$1.isArray;
var isNullOrUndef = helpers$1.isNullOrUndef;
var valueOrDefault$a = helpers$1.valueOrDefault;
var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

core_defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: core_ticks.formatters.values,
		minor: {},
		major: {}
	}
});

/** Returns a new array containing numItems from arr */
function sample(arr, numItems) {
	var result = [];
	var increment = arr.length / numItems;
	var i = 0;
	var len = arr.length;

	for (; i < len; i += increment) {
		result.push(arr[Math.floor(i)]);
	}
	return result;
}

function getPixelForGridLine(scale, index, offsetGridLines) {
	var length = scale.getTicks().length;
	var validIndex = Math.min(index, length - 1);
	var lineValue = scale.getPixelForTick(validIndex);
	var start = scale._startPixel;
	var end = scale._endPixel;
	var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
	var offset;

	if (offsetGridLines) {
		if (length === 1) {
			offset = Math.max(lineValue - start, end - lineValue);
		} else if (index === 0) {
			offset = (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
		}
		lineValue += validIndex < index ? offset : -offset;

		// Return undefined if the pixel is out of the range
		if (lineValue < start - epsilon || lineValue > end + epsilon) {
			return;
		}
	}
	return lineValue;
}

function garbageCollect(caches, length) {
	helpers$1.each(caches, function(cache) {
		var gc = cache.gc;
		var gcLen = gc.length / 2;
		var i;
		if (gcLen > length) {
			for (i = 0; i < gcLen; ++i) {
				delete cache.data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
	});
}

/**
 * Returns {width, height, offset} objects for the first, last, widest, highest tick
 * labels where offset indicates the anchor point offset from the top in pixels.
 */
function computeLabelSizes(ctx, tickFonts, ticks, caches) {
	var length = ticks.length;
	var widths = [];
	var heights = [];
	var offsets = [];
	var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

	for (i = 0; i < length; ++i) {
		label = ticks[i].label;
		tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
		ctx.font = fontString = tickFont.string;
		cache = caches[fontString] = caches[fontString] || {data: {}, gc: []};
		lineHeight = tickFont.lineHeight;
		width = height = 0;
		// Undefined labels and arrays should not be measured
		if (!isNullOrUndef(label) && !isArray(label)) {
			width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
			height = lineHeight;
		} else if (isArray(label)) {
			// if it is an array let's measure each element
			for (j = 0, jlen = label.length; j < jlen; ++j) {
				nestedLabel = label[j];
				// Undefined labels and arrays should not be measured
				if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
					width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
					height += lineHeight;
				}
			}
		}
		widths.push(width);
		heights.push(height);
		offsets.push(lineHeight / 2);
	}
	garbageCollect(caches, length);

	widest = widths.indexOf(Math.max.apply(null, widths));
	highest = heights.indexOf(Math.max.apply(null, heights));

	function valueAt(idx) {
		return {
			width: widths[idx] || 0,
			height: heights[idx] || 0,
			offset: offsets[idx] || 0
		};
	}

	return {
		first: valueAt(0),
		last: valueAt(length - 1),
		widest: valueAt(widest),
		highest: valueAt(highest)
	};
}

function getTickMarkLength(options) {
	return options.drawTicks ? options.tickMarkLength : 0;
}

function getScaleLabelHeight(options) {
	var font, padding;

	if (!options.display) {
		return 0;
	}

	font = helpers$1.options._parseFont(options);
	padding = helpers$1.options.toPadding(options.padding);

	return font.lineHeight + padding.height;
}

function parseFontOptions(options, nestedOpts) {
	return helpers$1.extend(helpers$1.options._parseFont({
		fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
		fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
		fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
		lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
	}), {
		color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
	});
}

function parseTickFontOptions(options) {
	var minor = parseFontOptions(options, options.minor);
	var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

	return {minor: minor, major: major};
}

function nonSkipped(ticksToFilter) {
	var filtered = [];
	var item, index, len;
	for (index = 0, len = ticksToFilter.length; index < len; ++index) {
		item = ticksToFilter[index];
		if (typeof item._index !== 'undefined') {
			filtered.push(item);
		}
	}
	return filtered;
}

function getEvenSpacing(arr) {
	var len = arr.length;
	var i, diff;

	if (len < 2) {
		return false;
	}

	for (diff = arr[0], i = 1; i < len; ++i) {
		if (arr[i] - arr[i - 1] !== diff) {
			return false;
		}
	}
	return diff;
}

function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
	var evenMajorSpacing = getEvenSpacing(majorIndices);
	var spacing = (ticks.length - 1) / ticksLimit;
	var factors, factor, i, ilen;

	// If the major ticks are evenly spaced apart, place the minor ticks
	// so that they divide the major ticks into even chunks
	if (!evenMajorSpacing) {
		return Math.max(spacing, 1);
	}

	factors = helpers$1.math._factorize(evenMajorSpacing);
	for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
		factor = factors[i];
		if (factor > spacing) {
			return factor;
		}
	}
	return Math.max(spacing, 1);
}

function getMajorIndices(ticks) {
	var result = [];
	var i, ilen;
	for (i = 0, ilen = ticks.length; i < ilen; i++) {
		if (ticks[i].major) {
			result.push(i);
		}
	}
	return result;
}

function skipMajors(ticks, majorIndices, spacing) {
	var count = 0;
	var next = majorIndices[0];
	var i, tick;

	spacing = Math.ceil(spacing);
	for (i = 0; i < ticks.length; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = majorIndices[count * spacing];
		} else {
			delete tick.label;
		}
	}
}

function skip(ticks, spacing, majorStart, majorEnd) {
	var start = valueOrDefault$a(majorStart, 0);
	var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
	var count = 0;
	var length, i, tick, next;

	spacing = Math.ceil(spacing);
	if (majorEnd) {
		length = majorEnd - majorStart;
		spacing = length / Math.floor(length / spacing);
	}

	next = start;

	while (next < 0) {
		count++;
		next = Math.round(start + count * spacing);
	}

	for (i = Math.max(start, 0); i < end; i++) {
		tick = ticks[i];
		if (i === next) {
			tick._index = i;
			count++;
			next = Math.round(start + count * spacing);
		} else {
			delete tick.label;
		}
	}
}

var Scale = core_element.extend({

	zeroLineIndex: 0,

	/**
	 * Get the padding needed for the scale
	 * @method getPadding
	 * @private
	 * @returns {Padding} the necessary padding
	 */
	getPadding: function() {
		var me = this;
		return {
			left: me.paddingLeft || 0,
			top: me.paddingTop || 0,
			right: me.paddingRight || 0,
			bottom: me.paddingBottom || 0
		};
	},

	/**
	 * Returns the scale tick objects ({label, major})
	 * @since 2.7
	 */
	getTicks: function() {
		return this._ticks;
	},

	/**
	* @private
	*/
	_getLabels: function() {
		var data = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
	},

	// These methods are ordered by lifecyle. Utilities then follow.
	// Any function defined here is inherited by all scale types.
	// Any function can be extended by the scale type

	/**
	 * Provided for backward compatibility, not available anymore
	 * @function Chart.Scale.mergeTicksOptions
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 */
	mergeTicksOptions: function() {
		// noop
	},

	beforeUpdate: function() {
		helpers$1.callback(this.options.beforeUpdate, [this]);
	},

	/**
	 * @param {number} maxWidth - the max width in pixels
	 * @param {number} maxHeight - the max height in pixels
	 * @param {object} margins - the space between the edge of the other scales and edge of the chart
	 *   This space comes from two sources:
	 *     - padding - space that's required to show the labels at the edges of the scale
	 *     - thickness of scales or legends in another orientation
	 */
	update: function(maxWidth, maxHeight, margins) {
		var me = this;
		var tickOpts = me.options.ticks;
		var sampleSize = tickOpts.sampleSize;
		var i, ilen, labels, ticks, samplingEnabled;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = helpers$1.extend({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, margins);

		me._ticks = null;
		me.ticks = null;
		me._labelSizes = null;
		me._maxLabelLines = 0;
		me.longestLabelWidth = 0;
		me.longestTextCache = me.longestTextCache || {};
		me._gridLineItems = null;
		me._labelItems = null;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();

		// Data min/max
		me.beforeDataLimits();
		me.determineDataLimits();
		me.afterDataLimits();

		// Ticks - `this.ticks` is now DEPRECATED!
		// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
		// and must not be accessed directly from outside this class. `this.ticks` being
		// around for long time and not marked as private, we can't change its structure
		// without unexpected breaking changes. If you need to access the scale ticks,
		// use scale.getTicks() instead.

		me.beforeBuildTicks();

		// New implementations should return an array of objects but for BACKWARD COMPAT,
		// we still support no return (`this.ticks` internally set by calling this method).
		ticks = me.buildTicks() || [];

		// Allow modification of ticks in callback.
		ticks = me.afterBuildTicks(ticks) || ticks;

		// Ensure ticks contains ticks in new tick format
		if ((!ticks || !ticks.length) && me.ticks) {
			ticks = [];
			for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
				ticks.push({
					value: me.ticks[i],
					major: false
				});
			}
		}

		me._ticks = ticks;

		// Compute tick rotation and fit using a sampled subset of labels
		// We generally don't need to compute the size of every single label for determining scale size
		samplingEnabled = sampleSize < ticks.length;
		labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

		// _configure is called twice, once here, once from core.controller.updateLayout.
		// Here we haven't been positioned yet, but dimensions are correct.
		// Variables set in _configure are needed for calculateTickRotation, and
		// it's ok that coordinates are not correct there, only dimensions matter.
		me._configure();

		// Tick Rotation
		me.beforeCalculateTickRotation();
		me.calculateTickRotation();
		me.afterCalculateTickRotation();

		me.beforeFit();
		me.fit();
		me.afterFit();

		// Auto-skip
		me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

		if (samplingEnabled) {
			// Generate labels using all non-skipped ticks
			labels = me._convertTicksToLabels(me._ticksToDraw);
		}

		me.ticks = labels;   // BACKWARD COMPATIBILITY

		// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

		me.afterUpdate();

		// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
		// make maxWidth and maxHeight private
		return me.minSize;
	},

	/**
	 * @private
	 */
	_configure: function() {
		var me = this;
		var reversePixels = me.options.ticks.reverse;
		var startPixel, endPixel;

		if (me.isHorizontal()) {
			startPixel = me.left;
			endPixel = me.right;
		} else {
			startPixel = me.top;
			endPixel = me.bottom;
			// by default vertical scales are from bottom to top, so pixels are reversed
			reversePixels = !reversePixels;
		}
		me._startPixel = startPixel;
		me._endPixel = endPixel;
		me._reversePixels = reversePixels;
		me._length = endPixel - startPixel;
	},

	afterUpdate: function() {
		helpers$1.callback(this.options.afterUpdate, [this]);
	},

	//

	beforeSetDimensions: function() {
		helpers$1.callback(this.options.beforeSetDimensions, [this]);
	},
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;
	},
	afterSetDimensions: function() {
		helpers$1.callback(this.options.afterSetDimensions, [this]);
	},

	// Data limits
	beforeDataLimits: function() {
		helpers$1.callback(this.options.beforeDataLimits, [this]);
	},
	determineDataLimits: helpers$1.noop,
	afterDataLimits: function() {
		helpers$1.callback(this.options.afterDataLimits, [this]);
	},

	//
	beforeBuildTicks: function() {
		helpers$1.callback(this.options.beforeBuildTicks, [this]);
	},
	buildTicks: helpers$1.noop,
	afterBuildTicks: function(ticks) {
		var me = this;
		// ticks is empty for old axis implementations here
		if (isArray(ticks) && ticks.length) {
			return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
		}
		// Support old implementations (that modified `this.ticks` directly in buildTicks)
		me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
		return ticks;
	},

	beforeTickToLabelConversion: function() {
		helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
	},
	convertTicksToLabels: function() {
		var me = this;
		// Convert ticks to strings
		var tickOpts = me.options.ticks;
		me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
	},
	afterTickToLabelConversion: function() {
		helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
	},

	//

	beforeCalculateTickRotation: function() {
		helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
	},
	calculateTickRotation: function() {
		var me = this;
		var options = me.options;
		var tickOpts = options.ticks;
		var numTicks = me.getTicks().length;
		var minRotation = tickOpts.minRotation || 0;
		var maxRotation = tickOpts.maxRotation;
		var labelRotation = minRotation;
		var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

		if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
			me.labelRotation = minRotation;
			return;
		}

		labelSizes = me._getLabelSizes();
		maxLabelWidth = labelSizes.widest.width;
		maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

		// Estimate the width of each grid based on the canvas width, the maximum
		// label width and the number of tick intervals
		maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
		tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

		// Allow 3 pixels x2 padding either side for label readability
		if (maxLabelWidth + 6 > tickWidth) {
			tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
			maxHeight = me.maxHeight - getTickMarkLength(options.gridLines)
				- tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
			maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
			labelRotation = helpers$1.toDegrees(Math.min(
				Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)),
				Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)
			));
			labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
		}

		me.labelRotation = labelRotation;
	},
	afterCalculateTickRotation: function() {
		helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
	},

	//

	beforeFit: function() {
		helpers$1.callback(this.options.beforeFit, [this]);
	},
	fit: function() {
		var me = this;
		// Reset
		var minSize = me.minSize = {
			width: 0,
			height: 0
		};

		var chart = me.chart;
		var opts = me.options;
		var tickOpts = opts.ticks;
		var scaleLabelOpts = opts.scaleLabel;
		var gridLineOpts = opts.gridLines;
		var display = me._isVisible();
		var isBottom = opts.position === 'bottom';
		var isHorizontal = me.isHorizontal();

		// Width
		if (isHorizontal) {
			minSize.width = me.maxWidth;
		} else if (display) {
			minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// height
		if (!isHorizontal) {
			minSize.height = me.maxHeight; // fill all the height
		} else if (display) {
			minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
		}

		// Don't bother fitting the ticks if we are not showing the labels
		if (tickOpts.display && display) {
			var tickFonts = parseTickFontOptions(tickOpts);
			var labelSizes = me._getLabelSizes();
			var firstLabelSize = labelSizes.first;
			var lastLabelSize = labelSizes.last;
			var widestLabelSize = labelSizes.widest;
			var highestLabelSize = labelSizes.highest;
			var lineSpace = tickFonts.minor.lineHeight * 0.4;
			var tickPadding = tickOpts.padding;

			if (isHorizontal) {
				// A horizontal axis is more constrained by the height.
				var isRotated = me.labelRotation !== 0;
				var angleRadians = helpers$1.toRadians(me.labelRotation);
				var cosRotation = Math.cos(angleRadians);
				var sinRotation = Math.sin(angleRadians);

				var labelHeight = sinRotation * widestLabelSize.width
					+ cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0))
					+ (isRotated ? 0 : lineSpace); // padding

				minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

				var offsetLeft = me.getPixelForTick(0) - me.left;
				var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
				var paddingLeft, paddingRight;

				// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
				// which means that the right padding is dominated by the font height
				if (isRotated) {
					paddingLeft = isBottom ?
						cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset :
						sinRotation * (firstLabelSize.height - firstLabelSize.offset);
					paddingRight = isBottom ?
						sinRotation * (lastLabelSize.height - lastLabelSize.offset) :
						cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
				} else {
					paddingLeft = firstLabelSize.width / 2;
					paddingRight = lastLabelSize.width / 2;
				}

				// Adjust padding taking into account changes in offsets
				// and add 3 px to move away from canvas edges
				me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
				me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
			} else {
				// A vertical axis is more constrained by the width. Labels are the
				// dominant factor here, so get that length first and account for padding
				var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

				minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

				me.paddingTop = firstLabelSize.height / 2;
				me.paddingBottom = lastLabelSize.height / 2;
			}
		}

		me.handleMargins();

		if (isHorizontal) {
			me.width = me._length = chart.width - me.margins.left - me.margins.right;
			me.height = minSize.height;
		} else {
			me.width = minSize.width;
			me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
		}
	},

	/**
	 * Handle margins and padding interactions
	 * @private
	 */
	handleMargins: function() {
		var me = this;
		if (me.margins) {
			me.margins.left = Math.max(me.paddingLeft, me.margins.left);
			me.margins.top = Math.max(me.paddingTop, me.margins.top);
			me.margins.right = Math.max(me.paddingRight, me.margins.right);
			me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
		}
	},

	afterFit: function() {
		helpers$1.callback(this.options.afterFit, [this]);
	},

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},
	isFullWidth: function() {
		return this.options.fullWidth;
	},

	// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
	getRightValue: function(rawValue) {
		// Null and undefined values first
		if (isNullOrUndef(rawValue)) {
			return NaN;
		}
		// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
		if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
			return NaN;
		}

		// If it is in fact an object, dive in one more level
		if (rawValue) {
			if (this.isHorizontal()) {
				if (rawValue.x !== undefined) {
					return this.getRightValue(rawValue.x);
				}
			} else if (rawValue.y !== undefined) {
				return this.getRightValue(rawValue.y);
			}
		}

		// Value is good, return it
		return rawValue;
	},

	_convertTicksToLabels: function(ticks) {
		var me = this;
		var labels, i, ilen;

		me.ticks = ticks.map(function(tick) {
			return tick.value;
		});

		me.beforeTickToLabelConversion();

		// New implementations should return the formatted tick labels but for BACKWARD
		// COMPAT, we still support no return (`this.ticks` internally changed by calling
		// this method and supposed to contain only string values).
		labels = me.convertTicksToLabels(ticks) || me.ticks;

		me.afterTickToLabelConversion();

		// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			ticks[i].label = labels[i];
		}

		return labels;
	},

	/**
	 * @private
	 */
	_getLabelSizes: function() {
		var me = this;
		var labelSizes = me._labelSizes;

		if (!labelSizes) {
			me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
			me.longestLabelWidth = labelSizes.widest.width;
		}

		return labelSizes;
	},

	/**
	 * @private
	 */
	_parseValue: function(value) {
		var start, end, min, max;

		if (isArray(value)) {
			start = +this.getRightValue(value[0]);
			end = +this.getRightValue(value[1]);
			min = Math.min(start, end);
			max = Math.max(start, end);
		} else {
			value = +this.getRightValue(value);
			start = undefined;
			end = value;
			min = value;
			max = value;
		}

		return {
			min: min,
			max: max,
			start: start,
			end: end
		};
	},

	/**
	* @private
	*/
	_getScaleLabel: function(rawValue) {
		var v = this._parseValue(rawValue);
		if (v.start !== undefined) {
			return '[' + v.start + ', ' + v.end + ']';
		}

		return +this.getRightValue(rawValue);
	},

	/**
	 * Used to get the value to display in the tooltip for the data at the given index
	 * @param index
	 * @param datasetIndex
	 */
	getLabelForIndex: helpers$1.noop,

	/**
	 * Returns the location of the given data point. Value can either be an index or a numerical value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param value
	 * @param index
	 * @param datasetIndex
	 */
	getPixelForValue: helpers$1.noop,

	/**
	 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 * @param pixel
	 */
	getValueForPixel: helpers$1.noop,

	/**
	 * Returns the location of the tick at the given index
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForTick: function(index) {
		var me = this;
		var offset = me.options.offset;
		var numTicks = me._ticks.length;
		var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

		return index < 0 || index > numTicks - 1
			? null
			: me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
	},

	/**
	 * Utility for getting the pixel location of a percentage of scale
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getPixelForDecimal: function(decimal) {
		var me = this;

		if (me._reversePixels) {
			decimal = 1 - decimal;
		}

		return me._startPixel + decimal * me._length;
	},

	getDecimalForPixel: function(pixel) {
		var decimal = (pixel - this._startPixel) / this._length;
		return this._reversePixels ? 1 - decimal : decimal;
	},

	/**
	 * Returns the pixel for the minimum chart value
	 * The coordinate (0, 0) is at the upper-left corner of the canvas
	 */
	getBasePixel: function() {
		return this.getPixelForValue(this.getBaseValue());
	},

	getBaseValue: function() {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0;
	},

	/**
	 * Returns a subset of ticks to be plotted to avoid overlapping labels.
	 * @private
	 */
	_autoSkip: function(ticks) {
		var me = this;
		var tickOpts = me.options.ticks;
		var axisLength = me._length;
		var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
		var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
		var numMajorIndices = majorIndices.length;
		var first = majorIndices[0];
		var last = majorIndices[numMajorIndices - 1];
		var i, ilen, spacing, avgMajorSpacing;

		// If there are too many major ticks to display them all
		if (numMajorIndices > ticksLimit) {
			skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
			return nonSkipped(ticks);
		}

		spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

		if (numMajorIndices > 0) {
			for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
				skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
			}
			avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
			skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
			skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
			return nonSkipped(ticks);
		}
		skip(ticks, spacing);
		return nonSkipped(ticks);
	},

	/**
	 * @private
	 */
	_tickSize: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		// Calculate space needed by label in axis direction.
		var rot = helpers$1.toRadians(me.labelRotation);
		var cos = Math.abs(Math.cos(rot));
		var sin = Math.abs(Math.sin(rot));

		var labelSizes = me._getLabelSizes();
		var padding = optionTicks.autoSkipPadding || 0;
		var w = labelSizes ? labelSizes.widest.width + padding : 0;
		var h = labelSizes ? labelSizes.highest.height + padding : 0;

		// Calculate space needed for 1 tick in axis direction.
		return me.isHorizontal()
			? h * cos > w * sin ? w / cos : h / sin
			: h * sin < w * cos ? h / cos : w / sin;
	},

	/**
	 * @private
	 */
	_isVisible: function() {
		var me = this;
		var chart = me.chart;
		var display = me.options.display;
		var i, ilen, meta;

		if (display !== 'auto') {
			return !!display;
		}

		// When 'auto', the scale is visible if at least one associated dataset is visible.
		for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				meta = chart.getDatasetMeta(i);
				if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
					return true;
				}
			}
		}

		return false;
	},

	/**
	 * @private
	 */
	_computeGridLineItems: function(chartArea) {
		var me = this;
		var chart = me.chart;
		var options = me.options;
		var gridLines = options.gridLines;
		var position = options.position;
		var offsetGridLines = gridLines.offsetGridLines;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

		var tl = getTickMarkLength(gridLines);
		var items = [];
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var axisHalfWidth = axisWidth / 2;
		var alignPixel = helpers$1._alignPixel;
		var alignBorderValue = function(pixel) {
			return alignPixel(chart, pixel, axisWidth);
		};
		var borderValue, i, tick, lineValue, alignedLineValue;
		var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

		if (position === 'top') {
			borderValue = alignBorderValue(me.bottom);
			ty1 = me.bottom - tl;
			ty2 = borderValue - axisHalfWidth;
			y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
			y2 = chartArea.bottom;
		} else if (position === 'bottom') {
			borderValue = alignBorderValue(me.top);
			y1 = chartArea.top;
			y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
			ty1 = borderValue + axisHalfWidth;
			ty2 = me.top + tl;
		} else if (position === 'left') {
			borderValue = alignBorderValue(me.right);
			tx1 = me.right - tl;
			tx2 = borderValue - axisHalfWidth;
			x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
			x2 = chartArea.right;
		} else {
			borderValue = alignBorderValue(me.left);
			x1 = chartArea.left;
			x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
			tx1 = borderValue + axisHalfWidth;
			tx2 = me.left + tl;
		}

		for (i = 0; i < ticksLength; ++i) {
			tick = ticks[i] || {};

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(tick.label) && i < ticks.length) {
				continue;
			}

			if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
				// Draw the first index specially
				lineWidth = gridLines.zeroLineWidth;
				lineColor = gridLines.zeroLineColor;
				borderDash = gridLines.zeroLineBorderDash || [];
				borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
			} else {
				lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
				lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
				borderDash = gridLines.borderDash || [];
				borderDashOffset = gridLines.borderDashOffset || 0.0;
			}

			lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

			// Skip if the pixel is out of the range
			if (lineValue === undefined) {
				continue;
			}

			alignedLineValue = alignPixel(chart, lineValue, lineWidth);

			if (isHorizontal) {
				tx1 = tx2 = x1 = x2 = alignedLineValue;
			} else {
				ty1 = ty2 = y1 = y2 = alignedLineValue;
			}

			items.push({
				tx1: tx1,
				ty1: ty1,
				tx2: tx2,
				ty2: ty2,
				x1: x1,
				y1: y1,
				x2: x2,
				y2: y2,
				width: lineWidth,
				color: lineColor,
				borderDash: borderDash,
				borderDashOffset: borderDashOffset,
			});
		}

		items.ticksLength = ticksLength;
		items.borderValue = borderValue;

		return items;
	},

	/**
	 * @private
	 */
	_computeLabelItems: function() {
		var me = this;
		var options = me.options;
		var optionTicks = options.ticks;
		var position = options.position;
		var isMirrored = optionTicks.mirror;
		var isHorizontal = me.isHorizontal();
		var ticks = me._ticksToDraw;
		var fonts = parseTickFontOptions(optionTicks);
		var tickPadding = optionTicks.padding;
		var tl = getTickMarkLength(options.gridLines);
		var rotation = -helpers$1.toRadians(me.labelRotation);
		var items = [];
		var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

		if (position === 'top') {
			y = me.bottom - tl - tickPadding;
			textAlign = !rotation ? 'center' : 'left';
		} else if (position === 'bottom') {
			y = me.top + tl + tickPadding;
			textAlign = !rotation ? 'center' : 'right';
		} else if (position === 'left') {
			x = me.right - (isMirrored ? 0 : tl) - tickPadding;
			textAlign = isMirrored ? 'left' : 'right';
		} else {
			x = me.left + (isMirrored ? 0 : tl) + tickPadding;
			textAlign = isMirrored ? 'right' : 'left';
		}

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			tick = ticks[i];
			label = tick.label;

			// autoskipper skipped this tick (#4635)
			if (isNullOrUndef(label)) {
				continue;
			}

			pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
			font = tick.major ? fonts.major : fonts.minor;
			lineHeight = font.lineHeight;
			lineCount = isArray(label) ? label.length : 1;

			if (isHorizontal) {
				x = pixel;
				textOffset = position === 'top'
					? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight
					: (!rotation ? 0.5 : 0) * lineHeight;
			} else {
				y = pixel;
				textOffset = (1 - lineCount) * lineHeight / 2;
			}

			items.push({
				x: x,
				y: y,
				rotation: rotation,
				label: label,
				font: font,
				textOffset: textOffset,
				textAlign: textAlign
			});
		}

		return items;
	},

	/**
	 * @private
	 */
	_drawGrid: function(chartArea) {
		var me = this;
		var gridLines = me.options.gridLines;

		if (!gridLines.display) {
			return;
		}

		var ctx = me.ctx;
		var chart = me.chart;
		var alignPixel = helpers$1._alignPixel;
		var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
		var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
		var width, color, i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			width = item.width;
			color = item.color;

			if (width && color) {
				ctx.save();
				ctx.lineWidth = width;
				ctx.strokeStyle = color;
				if (ctx.setLineDash) {
					ctx.setLineDash(item.borderDash);
					ctx.lineDashOffset = item.borderDashOffset;
				}

				ctx.beginPath();

				if (gridLines.drawTicks) {
					ctx.moveTo(item.tx1, item.ty1);
					ctx.lineTo(item.tx2, item.ty2);
				}

				if (gridLines.drawOnChartArea) {
					ctx.moveTo(item.x1, item.y1);
					ctx.lineTo(item.x2, item.y2);
				}

				ctx.stroke();
				ctx.restore();
			}
		}

		if (axisWidth) {
			// Draw the line at the edge of the axis
			var firstLineWidth = axisWidth;
			var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
			var borderValue = items.borderValue;
			var x1, x2, y1, y2;

			if (me.isHorizontal()) {
				x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
				x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
				y1 = y2 = borderValue;
			} else {
				y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
				y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
				x1 = x2 = borderValue;
			}

			ctx.lineWidth = axisWidth;
			ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var optionTicks = me.options.ticks;

		if (!optionTicks.display) {
			return;
		}

		var ctx = me.ctx;
		var items = me._labelItems || (me._labelItems = me._computeLabelItems());
		var i, j, ilen, jlen, item, tickFont, label, y;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			tickFont = item.font;

			// Make sure we draw text in the correct color and font
			ctx.save();
			ctx.translate(item.x, item.y);
			ctx.rotate(item.rotation);
			ctx.font = tickFont.string;
			ctx.fillStyle = tickFont.color;
			ctx.textBaseline = 'middle';
			ctx.textAlign = item.textAlign;

			label = item.label;
			y = item.textOffset;
			if (isArray(label)) {
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					// We just make sure the multiline element is a string here..
					ctx.fillText('' + label[j], 0, y);
					y += tickFont.lineHeight;
				}
			} else {
				ctx.fillText(label, 0, y);
			}
			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawTitle: function() {
		var me = this;
		var ctx = me.ctx;
		var options = me.options;
		var scaleLabel = options.scaleLabel;

		if (!scaleLabel.display) {
			return;
		}

		var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
		var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
		var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
		var halfLineHeight = scaleLabelFont.lineHeight / 2;
		var position = options.position;
		var rotation = 0;
		var scaleLabelX, scaleLabelY;

		if (me.isHorizontal()) {
			scaleLabelX = me.left + me.width / 2; // midpoint of the width
			scaleLabelY = position === 'bottom'
				? me.bottom - halfLineHeight - scaleLabelPadding.bottom
				: me.top + halfLineHeight + scaleLabelPadding.top;
		} else {
			var isLeft = position === 'left';
			scaleLabelX = isLeft
				? me.left + halfLineHeight + scaleLabelPadding.top
				: me.right - halfLineHeight - scaleLabelPadding.top;
			scaleLabelY = me.top + me.height / 2;
			rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
		}

		ctx.save();
		ctx.translate(scaleLabelX, scaleLabelY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';
		ctx.fillStyle = scaleLabelFontColor; // render in correct colour
		ctx.font = scaleLabelFont.string;
		ctx.fillText(scaleLabel.labelString, 0, 0);
		ctx.restore();
	},

	draw: function(chartArea) {
		var me = this;

		if (!me._isVisible()) {
			return;
		}

		me._drawGrid(chartArea);
		me._drawTitle();
		me._drawLabels();
	},

	/**
	 * @private
	 */
	_layers: function() {
		var me = this;
		var opts = me.options;
		var tz = opts.ticks && opts.ticks.z || 0;
		var gz = opts.gridLines && opts.gridLines.z || 0;

		if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
			// backward compatibility: draw has been overridden by custom scale
			return [{
				z: tz,
				draw: function() {
					me.draw.apply(me, arguments);
				}
			}];
		}

		return [{
			z: gz,
			draw: function() {
				me._drawGrid.apply(me, arguments);
				me._drawTitle.apply(me, arguments);
			}
		}, {
			z: tz,
			draw: function() {
				me._drawLabels.apply(me, arguments);
			}
		}];
	},

	/**
	 * @private
	 */
	_getMatchingVisibleMetas: function(type) {
		var me = this;
		var isHorizontal = me.isHorizontal();
		return me.chart._getSortedVisibleDatasetMetas()
			.filter(function(meta) {
				return (!type || meta.type === type)
					&& (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
	}
});

Scale.prototype._draw = Scale.prototype.draw;

var core_scale = Scale;

var isNullOrUndef$1 = helpers$1.isNullOrUndef;

var defaultConfig = {
	position: 'bottom'
};

var scale_category = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var labels = me._getLabels();
		var ticksOpts = me.options.ticks;
		var min = ticksOpts.min;
		var max = ticksOpts.max;
		var minIndex = 0;
		var maxIndex = labels.length - 1;
		var findIndex;

		if (min !== undefined) {
			// user specified min value
			findIndex = labels.indexOf(min);
			if (findIndex >= 0) {
				minIndex = findIndex;
			}
		}

		if (max !== undefined) {
			// user specified max value
			findIndex = labels.indexOf(max);
			if (findIndex >= 0) {
				maxIndex = findIndex;
			}
		}

		me.minIndex = minIndex;
		me.maxIndex = maxIndex;
		me.min = labels[minIndex];
		me.max = labels[maxIndex];
	},

	buildTicks: function() {
		var me = this;
		var labels = me._getLabels();
		var minIndex = me.minIndex;
		var maxIndex = me.maxIndex;

		// If we are viewing some subset of labels, slice the original array
		me.ticks = (minIndex === 0 && maxIndex === labels.length - 1) ? labels : labels.slice(minIndex, maxIndex + 1);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var chart = me.chart;

		if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
			return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
		}

		return me._getLabels()[index];
	},

	_configure: function() {
		var me = this;
		var offset = me.options.offset;
		var ticks = me.ticks;

		core_scale.prototype._configure.call(me);

		if (!me.isHorizontal()) {
			// For backward compatibility, vertical category scale reverse is inverted.
			me._reversePixels = !me._reversePixels;
		}

		if (!ticks) {
			return;
		}

		me._startValue = me.minIndex - (offset ? 0.5 : 0);
		me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
	},

	// Used to get data value locations.  Value can either be an index or a numerical value
	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var valueCategory, labels, idx;

		if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
			value = me.chart.data.datasets[datasetIndex].data[index];
		}

		// If value is a data object, then index is the index in the data array,
		// not the index of the scale. We need to change that.
		if (!isNullOrUndef$1(value)) {
			valueCategory = me.isHorizontal() ? value.x : value.y;
		}
		if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
			labels = me._getLabels();
			value = helpers$1.valueOrDefault(valueCategory, value);
			idx = labels.indexOf(value);
			index = idx !== -1 ? idx : index;
			if (isNaN(index)) {
				index = value;
			}
		}
		return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
	},

	getPixelForTick: function(index) {
		var ticks = this.ticks;
		return index < 0 || index > ticks.length - 1
			? null
			: this.getPixelForValue(ticks[index], index + this.minIndex);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
		return Math.min(Math.max(value, 0), me.ticks.length - 1);
	},

	getBasePixel: function() {
		return this.bottom;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults = defaultConfig;
scale_category._defaults = _defaults;

var noop = helpers$1.noop;
var isNullOrUndef$2 = helpers$1.isNullOrUndef;

/**
 * Generate a set of linear ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks(generationOptions, dataRange) {
	var ticks = [];
	// To get a "nice" value for the tick spacing, we will use the appropriately named
	// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
	// for details.

	var MIN_SPACING = 1e-14;
	var stepSize = generationOptions.stepSize;
	var unit = stepSize || 1;
	var maxNumSpaces = generationOptions.maxTicks - 1;
	var min = generationOptions.min;
	var max = generationOptions.max;
	var precision = generationOptions.precision;
	var rmin = dataRange.min;
	var rmax = dataRange.max;
	var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
	var factor, niceMin, niceMax, numSpaces;

	// Beyond MIN_SPACING floating point numbers being to lose precision
	// such that we can't do the math necessary to generate ticks
	if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
		return [rmin, rmax];
	}

	numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
	if (numSpaces > maxNumSpaces) {
		// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
		spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
	}

	if (stepSize || isNullOrUndef$2(precision)) {
		// If a precision is not specified, calculate factor based on spacing
		factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
	} else {
		// If the user specified a precision, round to that number of decimal places
		factor = Math.pow(10, precision);
		spacing = Math.ceil(spacing * factor) / factor;
	}

	niceMin = Math.floor(rmin / spacing) * spacing;
	niceMax = Math.ceil(rmax / spacing) * spacing;

	// If min, max and stepSize is set and they make an evenly spaced scale use it.
	if (stepSize) {
		// If very close to our whole number, use it.
		if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
			niceMin = min;
		}
		if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
			niceMax = max;
		}
	}

	numSpaces = (niceMax - niceMin) / spacing;
	// If very close to our rounded value, use it.
	if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
		numSpaces = Math.round(numSpaces);
	} else {
		numSpaces = Math.ceil(numSpaces);
	}

	niceMin = Math.round(niceMin * factor) / factor;
	niceMax = Math.round(niceMax * factor) / factor;
	ticks.push(isNullOrUndef$2(min) ? niceMin : min);
	for (var j = 1; j < numSpaces; ++j) {
		ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
	}
	ticks.push(isNullOrUndef$2(max) ? niceMax : max);

	return ticks;
}

var scale_linearbase = core_scale.extend({
	getRightValue: function(value) {
		if (typeof value === 'string') {
			return +value;
		}
		return core_scale.prototype.getRightValue.call(this, value);
	},

	handleTickRangeOptions: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
		// do nothing since that would make the chart weird. If the user really wants a weird chart
		// axis, they can manually override it
		if (tickOpts.beginAtZero) {
			var minSign = helpers$1.sign(me.min);
			var maxSign = helpers$1.sign(me.max);

			if (minSign < 0 && maxSign < 0) {
				// move the top up to 0
				me.max = 0;
			} else if (minSign > 0 && maxSign > 0) {
				// move the bottom down to 0
				me.min = 0;
			}
		}

		var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
		var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

		if (tickOpts.min !== undefined) {
			me.min = tickOpts.min;
		} else if (tickOpts.suggestedMin !== undefined) {
			if (me.min === null) {
				me.min = tickOpts.suggestedMin;
			} else {
				me.min = Math.min(me.min, tickOpts.suggestedMin);
			}
		}

		if (tickOpts.max !== undefined) {
			me.max = tickOpts.max;
		} else if (tickOpts.suggestedMax !== undefined) {
			if (me.max === null) {
				me.max = tickOpts.suggestedMax;
			} else {
				me.max = Math.max(me.max, tickOpts.suggestedMax);
			}
		}

		if (setMin !== setMax) {
			// We set the min or the max but not both.
			// So ensure that our range is good
			// Inverted or 0 length range can happen when
			// ticks.min is set, and no datasets are visible
			if (me.min >= me.max) {
				if (setMin) {
					me.max = me.min + 1;
				} else {
					me.min = me.max - 1;
				}
			}
		}

		if (me.min === me.max) {
			me.max++;

			if (!tickOpts.beginAtZero) {
				me.min--;
			}
		}
	},

	getTickLimit: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var stepSize = tickOpts.stepSize;
		var maxTicksLimit = tickOpts.maxTicksLimit;
		var maxTicks;

		if (stepSize) {
			maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
		} else {
			maxTicks = me._computeTickLimit();
			maxTicksLimit = maxTicksLimit || 11;
		}

		if (maxTicksLimit) {
			maxTicks = Math.min(maxTicksLimit, maxTicks);
		}

		return maxTicks;
	},

	_computeTickLimit: function() {
		return Number.POSITIVE_INFINITY;
	},

	handleDirectionalChanges: noop,

	buildTicks: function() {
		var me = this;
		var opts = me.options;
		var tickOpts = opts.ticks;

		// Figure out what the max number of ticks we can support it is based on the size of
		// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
		// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
		// the graph. Make sure we always have at least 2 ticks
		var maxTicks = me.getTickLimit();
		maxTicks = Math.max(2, maxTicks);

		var numericGeneratorOptions = {
			maxTicks: maxTicks,
			min: tickOpts.min,
			max: tickOpts.max,
			precision: tickOpts.precision,
			stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
		};
		var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

		me.handleDirectionalChanges();

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			ticks.reverse();

			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
	},

	convertTicksToLabels: function() {
		var me = this;
		me.ticksAsNumbers = me.ticks.slice();
		me.zeroLineIndex = me.ticks.indexOf(0);

		core_scale.prototype.convertTicksToLabels.call(me);
	},

	_configure: function() {
		var me = this;
		var ticks = me.getTicks();
		var start = me.min;
		var end = me.max;
		var offset;

		core_scale.prototype._configure.call(me);

		if (me.options.offset && ticks.length) {
			offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
			start -= offset;
			end += offset;
		}
		me._startValue = start;
		me._endValue = end;
		me._valueRange = end - start;
	}
});

var defaultConfig$1 = {
	position: 'left',
	ticks: {
		callback: core_ticks.formatters.linear
	}
};

var DEFAULT_MIN = 0;
var DEFAULT_MAX = 1;

function getOrCreateStack(stacks, stacked, meta) {
	var key = [
		meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '',
		meta.stack
	].join('.');

	if (stacks[key] === undefined) {
		stacks[key] = {
			pos: [],
			neg: []
		};
	}

	return stacks[key];
}

function stackData(scale, stacks, meta, data) {
	var opts = scale.options;
	var stacked = opts.stacked;
	var stack = getOrCreateStack(stacks, stacked, meta);
	var pos = stack.pos;
	var neg = stack.neg;
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		pos[i] = pos[i] || 0;
		neg[i] = neg[i] || 0;

		if (opts.relativePoints) {
			pos[i] = 100;
		} else if (value.min < 0 || value.max < 0) {
			neg[i] += value.min;
		} else {
			pos[i] += value.max;
		}
	}
}

function updateMinMax(scale, meta, data) {
	var ilen = data.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = scale._parseValue(data[i]);
		if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
			continue;
		}

		scale.min = Math.min(scale.min, value.min);
		scale.max = Math.max(scale.max, value.max);
	}
}

var scale_linear = scale_linearbase.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var metasets = me._getMatchingVisibleMetas();
		var hasStacks = opts.stacked;
		var stacks = {};
		var ilen = metasets.length;
		var i, meta, data, values;

		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;

		if (hasStacks === undefined) {
			for (i = 0; !hasStacks && i < ilen; ++i) {
				meta = metasets[i];
				hasStacks = meta.stack !== undefined;
			}
		}

		for (i = 0; i < ilen; ++i) {
			meta = metasets[i];
			data = datasets[meta.index].data;
			if (hasStacks) {
				stackData(me, stacks, meta, data);
			} else {
				updateMinMax(me, meta, data);
			}
		}

		helpers$1.each(stacks, function(stackValues) {
			values = stackValues.pos.concat(stackValues.neg);
			me.min = Math.min(me.min, helpers$1.min(values));
			me.max = Math.max(me.max, helpers$1.max(values));
		});

		me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
		me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		var me = this;
		var tickFont;

		if (me.isHorizontal()) {
			return Math.ceil(me.width / 40);
		}
		tickFont = helpers$1.options._parseFont(me.options.ticks);
		return Math.ceil(me.height / tickFont.lineHeight);
	},

	// Called after the ticks are built. We need
	handleDirectionalChanges: function() {
		if (!this.isHorizontal()) {
			// We are in a vertical orientation. The top value is the highest. So reverse the array
			this.ticks.reverse();
		}
	},

	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	// Utils
	getPixelForValue: function(value) {
		var me = this;
		return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
	},

	getValueForPixel: function(pixel) {
		return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
	},

	getPixelForTick: function(index) {
		var ticks = this.ticksAsNumbers;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$1 = defaultConfig$1;
scale_linear._defaults = _defaults$1;

var valueOrDefault$b = helpers$1.valueOrDefault;
var log10 = helpers$1.math.log10;

/**
 * Generate a set of logarithmic ticks
 * @param generationOptions the options used to generate the ticks
 * @param dataRange the range of the data
 * @returns {number[]} array of tick values
 */
function generateTicks$1(generationOptions, dataRange) {
	var ticks = [];

	var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

	var endExp = Math.floor(log10(dataRange.max));
	var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
	var exp, significand;

	if (tickVal === 0) {
		exp = Math.floor(log10(dataRange.minNotZero));
		significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

		ticks.push(tickVal);
		tickVal = significand * Math.pow(10, exp);
	} else {
		exp = Math.floor(log10(tickVal));
		significand = Math.floor(tickVal / Math.pow(10, exp));
	}
	var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

	do {
		ticks.push(tickVal);

		++significand;
		if (significand === 10) {
			significand = 1;
			++exp;
			precision = exp >= 0 ? 1 : precision;
		}

		tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
	} while (exp < endExp || (exp === endExp && significand < endSignificand));

	var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
	ticks.push(lastTick);

	return ticks;
}

var defaultConfig$2 = {
	position: 'left',

	// label settings
	ticks: {
		callback: core_ticks.formatters.logarithmic
	}
};

// TODO(v3): change this to positiveOrDefault
function nonNegativeOrDefault(value, defaultValue) {
	return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
}

var scale_logarithmic = core_scale.extend({
	determineDataLimits: function() {
		var me = this;
		var opts = me.options;
		var chart = me.chart;
		var datasets = chart.data.datasets;
		var isHorizontal = me.isHorizontal();
		function IDMatches(meta) {
			return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
		}
		var datasetIndex, meta, value, data, i, ilen;

		// Calculate Range
		me.min = Number.POSITIVE_INFINITY;
		me.max = Number.NEGATIVE_INFINITY;
		me.minNotZero = Number.POSITIVE_INFINITY;

		var hasStacks = opts.stacked;
		if (hasStacks === undefined) {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
					meta.stack !== undefined) {
					hasStacks = true;
					break;
				}
			}
		}

		if (opts.stacked || hasStacks) {
			var valuesPerStack = {};

			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				var key = [
					meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
					meta.stack
				].join('.');

				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = [];
					}

					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						var values = valuesPerStack[key];
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}
						values[i] = values[i] || 0;
						values[i] += value.max;
					}
				}
			}

			helpers$1.each(valuesPerStack, function(valuesForType) {
				if (valuesForType.length > 0) {
					var minVal = helpers$1.min(valuesForType);
					var maxVal = helpers$1.max(valuesForType);
					me.min = Math.min(me.min, minVal);
					me.max = Math.max(me.max, maxVal);
				}
			});

		} else {
			for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
				meta = chart.getDatasetMeta(datasetIndex);
				if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
					data = datasets[datasetIndex].data;
					for (i = 0, ilen = data.length; i < ilen; i++) {
						value = me._parseValue(data[i]);
						// invalid, hidden and negative values are ignored
						if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
							continue;
						}

						me.min = Math.min(value.min, me.min);
						me.max = Math.max(value.max, me.max);

						if (value.min !== 0) {
							me.minNotZero = Math.min(value.min, me.minNotZero);
						}
					}
				}
			}
		}

		me.min = helpers$1.isFinite(me.min) ? me.min : null;
		me.max = helpers$1.isFinite(me.max) ? me.max : null;
		me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

		// Common base implementation to handle ticks.min, ticks.max
		this.handleTickRangeOptions();
	},

	handleTickRangeOptions: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var DEFAULT_MIN = 1;
		var DEFAULT_MAX = 10;

		me.min = nonNegativeOrDefault(tickOpts.min, me.min);
		me.max = nonNegativeOrDefault(tickOpts.max, me.max);

		if (me.min === me.max) {
			if (me.min !== 0 && me.min !== null) {
				me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
				me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
			} else {
				me.min = DEFAULT_MIN;
				me.max = DEFAULT_MAX;
			}
		}
		if (me.min === null) {
			me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
		}
		if (me.max === null) {
			me.max = me.min !== 0
				? Math.pow(10, Math.floor(log10(me.min)) + 1)
				: DEFAULT_MAX;
		}
		if (me.minNotZero === null) {
			if (me.min > 0) {
				me.minNotZero = me.min;
			} else if (me.max < 1) {
				me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
			} else {
				me.minNotZero = DEFAULT_MIN;
			}
		}
	},

	buildTicks: function() {
		var me = this;
		var tickOpts = me.options.ticks;
		var reverse = !me.isHorizontal();

		var generationOptions = {
			min: nonNegativeOrDefault(tickOpts.min),
			max: nonNegativeOrDefault(tickOpts.max)
		};
		var ticks = me.ticks = generateTicks$1(generationOptions, me);

		// At this point, we need to update our max and min given the tick values since we have expanded the
		// range of the scale
		me.max = helpers$1.max(ticks);
		me.min = helpers$1.min(ticks);

		if (tickOpts.reverse) {
			reverse = !reverse;
			me.start = me.max;
			me.end = me.min;
		} else {
			me.start = me.min;
			me.end = me.max;
		}
		if (reverse) {
			ticks.reverse();
		}
	},

	convertTicksToLabels: function() {
		this.tickValues = this.ticks.slice();

		core_scale.prototype.convertTicksToLabels.call(this);
	},

	// Get the correct tooltip label
	getLabelForIndex: function(index, datasetIndex) {
		return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
	},

	getPixelForTick: function(index) {
		var ticks = this.tickValues;
		if (index < 0 || index > ticks.length - 1) {
			return null;
		}
		return this.getPixelForValue(ticks[index]);
	},

	/**
	 * Returns the value of the first tick.
	 * @param {number} value - The minimum not zero value.
	 * @return {number} The first tick value.
	 * @private
	 */
	_getFirstTickValue: function(value) {
		var exp = Math.floor(log10(value));
		var significand = Math.floor(value / Math.pow(10, exp));

		return significand * Math.pow(10, exp);
	},

	_configure: function() {
		var me = this;
		var start = me.min;
		var offset = 0;

		core_scale.prototype._configure.call(me);

		if (start === 0) {
			start = me._getFirstTickValue(me.minNotZero);
			offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
		}

		me._startValue = log10(start);
		me._valueOffset = offset;
		me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
	},

	getPixelForValue: function(value) {
		var me = this;
		var decimal = 0;

		value = +me.getRightValue(value);

		if (value > me.min && value > 0) {
			decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
		}
		return me.getPixelForDecimal(decimal);
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var decimal = me.getDecimalForPixel(pixel);
		return decimal === 0 && me.min === 0
			? 0
			: Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$2 = defaultConfig$2;
scale_logarithmic._defaults = _defaults$2;

var valueOrDefault$c = helpers$1.valueOrDefault;
var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
var resolve$4 = helpers$1.options.resolve;

var defaultConfig$3 = {
	display: true,

	// Boolean - Whether to animate scaling the chart from the centre
	animate: true,
	position: 'chartArea',

	angleLines: {
		display: true,
		color: 'rgba(0,0,0,0.1)',
		lineWidth: 1,
		borderDash: [],
		borderDashOffset: 0.0
	},

	gridLines: {
		circular: false
	},

	// label settings
	ticks: {
		// Boolean - Show a backdrop to the scale label
		showLabelBackdrop: true,

		// String - The colour of the label backdrop
		backdropColor: 'rgba(255,255,255,0.75)',

		// Number - The backdrop padding above & below the label in pixels
		backdropPaddingY: 2,

		// Number - The backdrop padding to the side of the label in pixels
		backdropPaddingX: 2,

		callback: core_ticks.formatters.linear
	},

	pointLabels: {
		// Boolean - if true, show point labels
		display: true,

		// Number - Point label font size in pixels
		fontSize: 10,

		// Function - Used to convert point labels
		callback: function(label) {
			return label;
		}
	}
};

function getTickBackdropHeight(opts) {
	var tickOpts = opts.ticks;

	if (tickOpts.display && opts.display) {
		return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
	}
	return 0;
}

function measureLabelSize(ctx, lineHeight, label) {
	if (helpers$1.isArray(label)) {
		return {
			w: helpers$1.longestText(ctx, ctx.font, label),
			h: label.length * lineHeight
		};
	}

	return {
		w: ctx.measureText(label).width,
		h: lineHeight
	};
}

function determineLimits(angle, pos, size, min, max) {
	if (angle === min || angle === max) {
		return {
			start: pos - (size / 2),
			end: pos + (size / 2)
		};
	} else if (angle < min || angle > max) {
		return {
			start: pos - size,
			end: pos
		};
	}

	return {
		start: pos,
		end: pos + size
	};
}

/**
 * Helper function to fit a radial linear scale with point labels
 */
function fitWithPointLabels(scale) {

	// Right, this is really confusing and there is a lot of maths going on here
	// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
	//
	// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
	//
	// Solution:
	//
	// We assume the radius of the polygon is half the size of the canvas at first
	// at each index we check if the text overlaps.
	//
	// Where it does, we store that angle and that index.
	//
	// After finding the largest index and angle we calculate how much we need to remove
	// from the shape radius to move the point inwards by that x.
	//
	// We average the left and right distances to get the maximum shape radius that can fit in the box
	// along with labels.
	//
	// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
	// on each side, removing that from the size, halving it and adding the left x protrusion width.
	//
	// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
	// and position it in the most space efficient manner
	//
	// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

	var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

	// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
	// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
	var furthestLimits = {
		l: 0,
		r: scale.width,
		t: 0,
		b: scale.height - scale.paddingTop
	};
	var furthestAngles = {};
	var i, textSize, pointPosition;

	scale.ctx.font = plFont.string;
	scale._pointLabelSizes = [];

	var valueCount = scale.chart.data.labels.length;
	for (i = 0; i < valueCount; i++) {
		pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
		textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
		scale._pointLabelSizes[i] = textSize;

		// Add quarter circle to make degree 0 mean top of circle
		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians) % 360;
		var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
		var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

		if (hLimits.start < furthestLimits.l) {
			furthestLimits.l = hLimits.start;
			furthestAngles.l = angleRadians;
		}

		if (hLimits.end > furthestLimits.r) {
			furthestLimits.r = hLimits.end;
			furthestAngles.r = angleRadians;
		}

		if (vLimits.start < furthestLimits.t) {
			furthestLimits.t = vLimits.start;
			furthestAngles.t = angleRadians;
		}

		if (vLimits.end > furthestLimits.b) {
			furthestLimits.b = vLimits.end;
			furthestAngles.b = angleRadians;
		}
	}

	scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
}

function getTextAlignForAngle(angle) {
	if (angle === 0 || angle === 180) {
		return 'center';
	} else if (angle < 180) {
		return 'left';
	}

	return 'right';
}

function fillText(ctx, text, position, lineHeight) {
	var y = position.y + lineHeight / 2;
	var i, ilen;

	if (helpers$1.isArray(text)) {
		for (i = 0, ilen = text.length; i < ilen; ++i) {
			ctx.fillText(text[i], position.x, y);
			y += lineHeight;
		}
	} else {
		ctx.fillText(text, position.x, y);
	}
}

function adjustPointPositionForLabelHeight(angle, textSize, position) {
	if (angle === 90 || angle === 270) {
		position.y -= (textSize.h / 2);
	} else if (angle > 270 || angle < 90) {
		position.y -= textSize.h;
	}
}

function drawPointLabels(scale) {
	var ctx = scale.ctx;
	var opts = scale.options;
	var pointLabelOpts = opts.pointLabels;
	var tickBackdropHeight = getTickBackdropHeight(opts);
	var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	var plFont = helpers$1.options._parseFont(pointLabelOpts);

	ctx.save();

	ctx.font = plFont.string;
	ctx.textBaseline = 'middle';

	for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
		// Extra pixels out for some label spacing
		var extra = (i === 0 ? tickBackdropHeight / 2 : 0);
		var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

		// Keep this in loop since we may support array properties here
		var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
		ctx.fillStyle = pointLabelFontColor;

		var angleRadians = scale.getIndexAngle(i);
		var angle = helpers$1.toDegrees(angleRadians);
		ctx.textAlign = getTextAlignForAngle(angle);
		adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
		fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
	}
	ctx.restore();
}

function drawRadiusLine(scale, gridLineOpts, radius, index) {
	var ctx = scale.ctx;
	var circular = gridLineOpts.circular;
	var valueCount = scale.chart.data.labels.length;
	var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
	var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
	var pointPosition;

	if ((!circular && !valueCount) || !lineColor || !lineWidth) {
		return;
	}

	ctx.save();
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	if (ctx.setLineDash) {
		ctx.setLineDash(gridLineOpts.borderDash || []);
		ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
	}

	ctx.beginPath();
	if (circular) {
		// Draw circular arcs between the points
		ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
	} else {
		// Draw straight lines connecting each index
		pointPosition = scale.getPointPosition(0, radius);
		ctx.moveTo(pointPosition.x, pointPosition.y);

		for (var i = 1; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, radius);
			ctx.lineTo(pointPosition.x, pointPosition.y);
		}
	}
	ctx.closePath();
	ctx.stroke();
	ctx.restore();
}

function numberOrZero(param) {
	return helpers$1.isNumber(param) ? param : 0;
}

var scale_radialLinear = scale_linearbase.extend({
	setDimensions: function() {
		var me = this;

		// Set the unconstrained dimension before label rotation
		me.width = me.maxWidth;
		me.height = me.maxHeight;
		me.paddingTop = getTickBackdropHeight(me.options) / 2;
		me.xCenter = Math.floor(me.width / 2);
		me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
		me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var min = Number.POSITIVE_INFINITY;
		var max = Number.NEGATIVE_INFINITY;

		helpers$1.each(chart.data.datasets, function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);

				helpers$1.each(dataset.data, function(rawValue, index) {
					var value = +me.getRightValue(rawValue);
					if (isNaN(value) || meta.data[index].hidden) {
						return;
					}

					min = Math.min(value, min);
					max = Math.max(value, max);
				});
			}
		});

		me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
		me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

		// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
		me.handleTickRangeOptions();
	},

	// Returns the maximum number of ticks based on the scale dimension
	_computeTickLimit: function() {
		return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
	},

	convertTicksToLabels: function() {
		var me = this;

		scale_linearbase.prototype.convertTicksToLabels.call(me);

		// Point labels
		me.pointLabels = me.chart.data.labels.map(function() {
			var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
			return label || label === 0 ? label : '';
		});
	},

	getLabelForIndex: function(index, datasetIndex) {
		return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
	},

	fit: function() {
		var me = this;
		var opts = me.options;

		if (opts.display && opts.pointLabels.display) {
			fitWithPointLabels(me);
		} else {
			me.setCenterPoint(0, 0, 0, 0);
		}
	},

	/**
	 * Set radius reductions and determine new radius and center point
	 * @private
	 */
	setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
		var me = this;
		var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
		var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
		var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
		var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

		radiusReductionLeft = numberOrZero(radiusReductionLeft);
		radiusReductionRight = numberOrZero(radiusReductionRight);
		radiusReductionTop = numberOrZero(radiusReductionTop);
		radiusReductionBottom = numberOrZero(radiusReductionBottom);

		me.drawingArea = Math.min(
			Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
			Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
		me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
	},

	setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
		var me = this;
		var maxRight = me.width - rightMovement - me.drawingArea;
		var maxLeft = leftMovement + me.drawingArea;
		var maxTop = topMovement + me.drawingArea;
		var maxBottom = (me.height - me.paddingTop) - bottomMovement - me.drawingArea;

		me.xCenter = Math.floor(((maxLeft + maxRight) / 2) + me.left);
		me.yCenter = Math.floor(((maxTop + maxBottom) / 2) + me.top + me.paddingTop);
	},

	getIndexAngle: function(index) {
		var chart = this.chart;
		var angleMultiplier = 360 / chart.data.labels.length;
		var options = chart.options || {};
		var startAngle = options.startAngle || 0;

		// Start from the top instead of right, so remove a quarter of the circle
		var angle = (index * angleMultiplier + startAngle) % 360;

		return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
	},

	getDistanceFromCenterForValue: function(value) {
		var me = this;

		if (helpers$1.isNullOrUndef(value)) {
			return NaN;
		}

		// Take into account half font size + the yPadding of the top value
		var scalingFactor = me.drawingArea / (me.max - me.min);
		if (me.options.ticks.reverse) {
			return (me.max - value) * scalingFactor;
		}
		return (value - me.min) * scalingFactor;
	},

	getPointPosition: function(index, distanceFromCenter) {
		var me = this;
		var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
		return {
			x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
			y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
		};
	},

	getPointPositionForValue: function(index, value) {
		return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
	},

	getBasePosition: function(index) {
		var me = this;
		var min = me.min;
		var max = me.max;

		return me.getPointPositionForValue(index || 0,
			me.beginAtZero ? 0 :
			min < 0 && max < 0 ? max :
			min > 0 && max > 0 ? min :
			0);
	},

	/**
	 * @private
	 */
	_drawGrid: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var gridLineOpts = opts.gridLines;
		var angleLineOpts = opts.angleLines;
		var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
		var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
		var i, offset, position;

		if (opts.pointLabels.display) {
			drawPointLabels(me);
		}

		if (gridLineOpts.display) {
			helpers$1.each(me.ticks, function(label, index) {
				if (index !== 0) {
					offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
					drawRadiusLine(me, gridLineOpts, offset, index);
				}
			});
		}

		if (angleLineOpts.display && lineWidth && lineColor) {
			ctx.save();
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = lineColor;
			if (ctx.setLineDash) {
				ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
				ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
			}

			for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
				offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
				position = me.getPointPosition(i, offset);
				ctx.beginPath();
				ctx.moveTo(me.xCenter, me.yCenter);
				ctx.lineTo(position.x, position.y);
				ctx.stroke();
			}

			ctx.restore();
		}
	},

	/**
	 * @private
	 */
	_drawLabels: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;
		var tickOpts = opts.ticks;

		if (!tickOpts.display) {
			return;
		}

		var startAngle = me.getIndexAngle(0);
		var tickFont = helpers$1.options._parseFont(tickOpts);
		var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
		var offset, width;

		ctx.save();
		ctx.font = tickFont.string;
		ctx.translate(me.xCenter, me.yCenter);
		ctx.rotate(startAngle);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		helpers$1.each(me.ticks, function(label, index) {
			if (index === 0 && !tickOpts.reverse) {
				return;
			}

			offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

			if (tickOpts.showLabelBackdrop) {
				width = ctx.measureText(label).width;
				ctx.fillStyle = tickOpts.backdropColor;

				ctx.fillRect(
					-width / 2 - tickOpts.backdropPaddingX,
					-offset - tickFont.size / 2 - tickOpts.backdropPaddingY,
					width + tickOpts.backdropPaddingX * 2,
					tickFont.size + tickOpts.backdropPaddingY * 2
				);
			}

			ctx.fillStyle = tickFontColor;
			ctx.fillText(label, 0, -offset);
		});

		ctx.restore();
	},

	/**
	 * @private
	 */
	_drawTitle: helpers$1.noop
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$3 = defaultConfig$3;
scale_radialLinear._defaults = _defaults$3;

var deprecated$1 = helpers$1._deprecated;
var resolve$5 = helpers$1.options.resolve;
var valueOrDefault$d = helpers$1.valueOrDefault;

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: 1000
	},
	second: {
		common: true,
		size: 1000,
		steps: 60
	},
	minute: {
		common: true,
		size: 60000,
		steps: 60
	},
	hour: {
		common: true,
		size: 3600000,
		steps: 24
	},
	day: {
		common: true,
		size: 86400000,
		steps: 30
	},
	week: {
		common: false,
		size: 604800000,
		steps: 4
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: 12
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: 4
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

function getMin(options) {
	return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
}

function getMax(options) {
	return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate$1(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

function toTimestamp(scale, input) {
	var adapter = scale._adapter;
	var options = scale.options.time;
	var parser = options.parser;
	var format = parser || options.format;
	var value = input;

	if (typeof parser === 'function') {
		value = parser(value);
	}

	// Only parse if its not a timestamp already
	if (!helpers$1.isFinite(value)) {
		value = typeof format === 'string'
			? adapter.parse(value, format)
			: adapter.parse(value);
	}

	if (value !== null) {
		return +value;
	}

	// Labels are in an incompatible format and no `parser` has been provided.
	// The user might still use the deprecated `format` option for parsing.
	if (!parser && typeof format === 'function') {
		value = format(input);

		// `format` could return something else than a timestamp, if so, parse it
		if (!helpers$1.isFinite(value)) {
			value = adapter.parse(value);
		}
	}

	return value;
}

function parse(scale, input) {
	if (helpers$1.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = toTimestamp(scale, scale.getRightValue(input));
	if (value === null) {
		return value;
	}

	if (options.round) {
		value = +scale._adapter.startOf(value, options.round);
	}

	return value;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
	var i, unit;

	for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(scale, min, max, capacity) {
	var adapter = scale._adapter;
	var options = scale.options;
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var first = min;
	var ticks = [];
	var time;

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = +adapter.startOf(first, 'isoWeek', weekday);
	}

	// Align first ticks on unit
	first = +adapter.startOf(first, weekday ? 'day' : minor);

	// Prevent browser from freezing in case user options request millions of milliseconds
	if (adapter.diff(max, min, minor) > 100000 * stepSize) {
		throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
	}

	for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
		ticks.push(time);
	}

	if (time === max || options.bounds === 'ticks') {
		ticks.push(time);
	}

	return ticks;
}

/**
 * Returns the start and end offsets from edges in the form of {start, end}
 * where each value is a relative width to the scale and ranges between 0 and 1.
 * They add extra margins on the both sides by scaling down the original scale.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var start = 0;
	var end = 0;
	var first, last;

	if (options.offset && ticks.length) {
		first = interpolate$1(table, 'time', ticks[0], 'pos');
		if (ticks.length === 1) {
			start = 1 - first;
		} else {
			start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
		}
		last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
		if (ticks.length === 1) {
			end = last;
		} else {
			end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
		}
	}

	return {start: start, end: end, factor: 1 / (start + 1 + end)};
}

function setMajorTicks(scale, ticks, map, majorUnit) {
	var adapter = scale._adapter;
	var first = +adapter.startOf(ticks[0].value, majorUnit);
	var last = ticks[ticks.length - 1].value;
	var major, index;

	for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
		index = map[major];
		if (index >= 0) {
			ticks[index].major = true;
		}
	}
	return ticks;
}

function ticksFromTimestamps(scale, values, majorUnit) {
	var ticks = [];
	var map = {};
	var ilen = values.length;
	var i, value;

	for (i = 0; i < ilen; ++i) {
		value = values[i];
		map[value] = i;

		ticks.push({
			value: value,
			major: false
		});
	}

	// We set the major ticks separately from the above loop because calling startOf for every tick
	// is expensive when there is a large number of ticks
	return (ilen === 0 || !majorUnit) ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}

var defaultConfig$4 = {
	position: 'bottom',

	/**
	 * Data distribution along the scale:
	 * - 'linear': data are spread according to their time (distances can vary),
	 * - 'series': data are spread at the same distance from each other.
	 * @see https://github.com/chartjs/Chart.js/pull/4507
	 * @since 2.7.0
	 */
	distribution: 'linear',

	/**
	 * Scale boundary strategy (bypassed by min/max time options)
	 * - `data`: make sure data are fully visible, ticks outside are removed
	 * - `ticks`: make sure ticks are fully visible, data outside are truncated
	 * @see https://github.com/chartjs/Chart.js/pull/4556
	 * @since 2.7.0
	 */
	bounds: 'data',

	adapters: {},
	time: {
		parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
		unit: false, // false == automatic or override with week, month, year, etc.
		round: false, // none, or override with week, month, year, etc.
		displayFormat: false, // DEPRECATED
		isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
		minUnit: 'millisecond',
		displayFormats: {}
	},
	ticks: {
		autoSkip: false,

		/**
		 * Ticks generation input values:
		 * - 'auto': generates "optimal" ticks based on scale size and time options.
		 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
		 * - 'labels': generates ticks from user given `data.labels` values ONLY.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		source: 'auto',

		major: {
			enabled: false
		}
	}
};

var scale_time = core_scale.extend({
	initialize: function() {
		this.mergeTicksOptions();
		core_scale.prototype.initialize.call(this);
	},

	update: function() {
		var me = this;
		var options = me.options;
		var time = options.time || (options.time = {});
		var adapter = me._adapter = new core_adapters._date(options.adapters.date);

		// DEPRECATIONS: output a message only one time per update
		deprecated$1('time scale', time.format, 'time.format', 'time.parser');
		deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
		deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

		// Backward compatibility: before introducing adapter, `displayFormats` was
		// supposed to contain *all* unit/string pairs but this can't be resolved
		// when loading the scale (adapters are loaded afterward), so let's populate
		// missing formats on update
		helpers$1.mergeIf(time.displayFormats, adapter.formats());

		return core_scale.prototype.update.apply(me, arguments);
	},

	/**
	 * Allows data to be referenced via 't' attribute
	 */
	getRightValue: function(rawValue) {
		if (rawValue && rawValue.t !== undefined) {
			rawValue = rawValue.t;
		}
		return core_scale.prototype.getRightValue.call(this, rawValue);
	},

	determineDataLimits: function() {
		var me = this;
		var chart = me.chart;
		var adapter = me._adapter;
		var options = me.options;
		var unit = options.time.unit || 'day';
		var min = MAX_INTEGER;
		var max = MIN_INTEGER;
		var timestamps = [];
		var datasets = [];
		var labels = [];
		var i, j, ilen, jlen, data, timestamp, labelsAdded;
		var dataLabels = me._getLabels();

		for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
			labels.push(parse(me, dataLabels[i]));
		}

		for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
			if (chart.isDatasetVisible(i)) {
				data = chart.data.datasets[i].data;

				// Let's consider that all data have the same format.
				if (helpers$1.isObject(data[0])) {
					datasets[i] = [];

					for (j = 0, jlen = data.length; j < jlen; ++j) {
						timestamp = parse(me, data[j]);
						timestamps.push(timestamp);
						datasets[i][j] = timestamp;
					}
				} else {
					datasets[i] = labels.slice(0);
					if (!labelsAdded) {
						timestamps = timestamps.concat(labels);
						labelsAdded = true;
					}
				}
			} else {
				datasets[i] = [];
			}
		}

		if (labels.length) {
			min = Math.min(min, labels[0]);
			max = Math.max(max, labels[labels.length - 1]);
		}

		if (timestamps.length) {
			timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
			min = Math.min(min, timestamps[0]);
			max = Math.max(max, timestamps[timestamps.length - 1]);
		}

		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// In case there is no valid min/max, set limits based on unit time option
		min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
		max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

		// Make sure that max is strictly higher than min (required by the lookup table)
		me.min = Math.min(min, max);
		me.max = Math.max(min + 1, max);

		// PRIVATE
		me._table = [];
		me._timestamps = {
			data: timestamps,
			datasets: datasets,
			labels: labels
		};
	},

	buildTicks: function() {
		var me = this;
		var min = me.min;
		var max = me.max;
		var options = me.options;
		var tickOpts = options.ticks;
		var timeOpts = options.time;
		var timestamps = me._timestamps;
		var ticks = [];
		var capacity = me.getLabelCapacity(min);
		var source = tickOpts.source;
		var distribution = options.distribution;
		var i, ilen, timestamp;

		if (source === 'data' || (source === 'auto' && distribution === 'series')) {
			timestamps = timestamps.data;
		} else if (source === 'labels') {
			timestamps = timestamps.labels;
		} else {
			timestamps = generate(me, min, max, capacity);
		}

		if (options.bounds === 'ticks' && timestamps.length) {
			min = timestamps[0];
			max = timestamps[timestamps.length - 1];
		}

		// Enforce limits with user min/max options
		min = parse(me, getMin(options)) || min;
		max = parse(me, getMax(options)) || max;

		// Remove ticks outside the min/max range
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			timestamp = timestamps[i];
			if (timestamp >= min && timestamp <= max) {
				ticks.push(timestamp);
			}
		}

		me.min = min;
		me.max = max;

		// PRIVATE
		// determineUnitForFormatting relies on the number of ticks so we don't use it when
		// autoSkip is enabled because we don't yet know what the final number of ticks will be
		me._unit = timeOpts.unit || (tickOpts.autoSkip
			? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity)
			: determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
		me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined
			: determineMajorUnit(me._unit);
		me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
		me._offsets = computeOffsets(me._table, ticks, min, max, options);

		if (tickOpts.reverse) {
			ticks.reverse();
		}

		return ticksFromTimestamps(me, ticks, me._majorUnit);
	},

	getLabelForIndex: function(index, datasetIndex) {
		var me = this;
		var adapter = me._adapter;
		var data = me.chart.data;
		var timeOpts = me.options.time;
		var label = data.labels && index < data.labels.length ? data.labels[index] : '';
		var value = data.datasets[datasetIndex].data[index];

		if (helpers$1.isObject(value)) {
			label = me.getRightValue(value);
		}
		if (timeOpts.tooltipFormat) {
			return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
		}
		if (typeof label === 'string') {
			return label;
		}
		return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
	},

	/**
	 * Function to format an individual tick mark
	 * @private
	 */
	tickFormatFunction: function(time, index, ticks, format) {
		var me = this;
		var adapter = me._adapter;
		var options = me.options;
		var formats = options.time.displayFormats;
		var minorFormat = formats[me._unit];
		var majorUnit = me._majorUnit;
		var majorFormat = formats[majorUnit];
		var tick = ticks[index];
		var tickOpts = options.ticks;
		var major = majorUnit && majorFormat && tick && tick.major;
		var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
		var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
		var formatter = resolve$5([
			nestedTickOpts.callback,
			nestedTickOpts.userCallback,
			tickOpts.callback,
			tickOpts.userCallback
		]);

		return formatter ? formatter(label, index, ticks) : label;
	},

	convertTicksToLabels: function(ticks) {
		var labels = [];
		var i, ilen;

		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
		}

		return labels;
	},

	/**
	 * @private
	 */
	getPixelForOffset: function(time) {
		var me = this;
		var offsets = me._offsets;
		var pos = interpolate$1(me._table, 'time', time, 'pos');
		return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
	},

	getPixelForValue: function(value, index, datasetIndex) {
		var me = this;
		var time = null;

		if (index !== undefined && datasetIndex !== undefined) {
			time = me._timestamps.datasets[datasetIndex][index];
		}

		if (time === null) {
			time = parse(me, value);
		}

		if (time !== null) {
			return me.getPixelForOffset(time);
		}
	},

	getPixelForTick: function(index) {
		var ticks = this.getTicks();
		return index >= 0 && index < ticks.length ?
			this.getPixelForOffset(ticks[index].value) :
			null;
	},

	getValueForPixel: function(pixel) {
		var me = this;
		var offsets = me._offsets;
		var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
		var time = interpolate$1(me._table, 'pos', pos, 'time');

		// DEPRECATION, we should return time directly
		return me._adapter._create(time);
	},

	/**
	 * @private
	 */
	_getLabelSize: function(label) {
		var me = this;
		var ticksOpts = me.options.ticks;
		var tickLabelWidth = me.ctx.measureText(label).width;
		var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
		var cosRotation = Math.cos(angle);
		var sinRotation = Math.sin(angle);
		var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

		return {
			w: (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation),
			h: (tickLabelWidth * sinRotation) + (tickFontSize * cosRotation)
		};
	},

	/**
	 * Crude approximation of what the label width might be
	 * @private
	 */
	getLabelWidth: function(label) {
		return this._getLabelSize(label).w;
	},

	/**
	 * @private
	 */
	getLabelCapacity: function(exampleTime) {
		var me = this;
		var timeOpts = me.options.time;
		var displayFormats = timeOpts.displayFormats;

		// pick the longest format (milliseconds) for guestimation
		var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
		var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
		var size = me._getLabelSize(exampleLabel);
		var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

		if (me.options.offset) {
			capacity--;
		}

		return capacity > 0 ? capacity : 1;
	}
});

// INTERNAL: static default options, registered in src/index.js
var _defaults$4 = defaultConfig$4;
scale_time._defaults = _defaults$4;

var scales = {
	category: scale_category,
	linear: scale_linear,
	logarithmic: scale_logarithmic,
	radialLinear: scale_radialLinear,
	time: scale_time
};

var FORMATS = {
	datetime: 'MMM D, YYYY, h:mm:ss a',
	millisecond: 'h:mm:ss.SSS a',
	second: 'h:mm:ss a',
	minute: 'h:mm a',
	hour: 'hA',
	day: 'MMM D',
	week: 'll',
	month: 'MMM YYYY',
	quarter: '[Q]Q - YYYY',
	year: 'YYYY'
};

core_adapters._date.override(typeof moment === 'function' ? {
	_id: 'moment', // DEBUG ONLY

	formats: function() {
		return FORMATS;
	},

	parse: function(value, format) {
		if (typeof value === 'string' && typeof format === 'string') {
			value = moment(value, format);
		} else if (!(value instanceof moment)) {
			value = moment(value);
		}
		return value.isValid() ? value.valueOf() : null;
	},

	format: function(time, format) {
		return moment(time).format(format);
	},

	add: function(time, amount, unit) {
		return moment(time).add(amount, unit).valueOf();
	},

	diff: function(max, min, unit) {
		return moment(max).diff(moment(min), unit);
	},

	startOf: function(time, unit, weekday) {
		time = moment(time);
		if (unit === 'isoWeek') {
			return time.isoWeekday(weekday).valueOf();
		}
		return time.startOf(unit).valueOf();
	},

	endOf: function(time, unit) {
		return moment(time).endOf(unit).valueOf();
	},

	// DEPRECATIONS

	/**
	 * Provided for backward compatibility with scale.getValueForPixel().
	 * @deprecated since version 2.8.0
	 * @todo remove at version 3
	 * @private
	 */
	_create: function(time) {
		return moment(time);
	},
} : {});

core_defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

var mappers = {
	dataset: function(source) {
		var index = source.fill;
		var chart = source.chart;
		var meta = chart.getDatasetMeta(index);
		var visible = meta && chart.isDatasetVisible(index);
		var points = (visible && meta.dataset._children) || [];
		var length = points.length || 0;

		return !length ? null : function(point, i) {
			return (i < length && points[i]._view) || null;
		};
	},

	boundary: function(source) {
		var boundary = source.boundary;
		var x = boundary ? boundary.x : null;
		var y = boundary ? boundary.y : null;

		if (helpers$1.isArray(boundary)) {
			return function(point, i) {
				return boundary[i];
			};
		}

		return function(point) {
			return {
				x: x === null ? point.x : x,
				y: y === null ? point.y : y,
			};
		};
	}
};

// @todo if (fill[0] === '#')
function decodeFill(el, index, count) {
	var model = el._model || {};
	var fill = model.fill;
	var target;

	if (fill === undefined) {
		fill = !!model.backgroundColor;
	}

	if (fill === false || fill === null) {
		return false;
	}

	if (fill === true) {
		return 'origin';
	}

	target = parseFloat(fill, 10);
	if (isFinite(target) && Math.floor(target) === target) {
		if (fill[0] === '-' || fill[0] === '+') {
			target = index + target;
		}

		if (target === index || target < 0 || target >= count) {
			return false;
		}

		return target;
	}

	switch (fill) {
	// compatibility
	case 'bottom':
		return 'start';
	case 'top':
		return 'end';
	case 'zero':
		return 'origin';
	// supported boundaries
	case 'origin':
	case 'start':
	case 'end':
		return fill;
	// invalid fill values
	default:
		return false;
	}
}

function computeLinearBoundary(source) {
	var model = source.el._model || {};
	var scale = source.el._scale || {};
	var fill = source.fill;
	var target = null;
	var horizontal;

	if (isFinite(fill)) {
		return null;
	}

	// Backward compatibility: until v3, we still need to support boundary values set on
	// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
	// controllers might still use it (e.g. the Smith chart).

	if (fill === 'start') {
		target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
	} else if (fill === 'end') {
		target = model.scaleTop === undefined ? scale.top : model.scaleTop;
	} else if (model.scaleZero !== undefined) {
		target = model.scaleZero;
	} else if (scale.getBasePixel) {
		target = scale.getBasePixel();
	}

	if (target !== undefined && target !== null) {
		if (target.x !== undefined && target.y !== undefined) {
			return target;
		}

		if (helpers$1.isFinite(target)) {
			horizontal = scale.isHorizontal();
			return {
				x: horizontal ? target : null,
				y: horizontal ? null : target
			};
		}
	}

	return null;
}

function computeCircularBoundary(source) {
	var scale = source.el._scale;
	var options = scale.options;
	var length = scale.chart.data.labels.length;
	var fill = source.fill;
	var target = [];
	var start, end, center, i, point;

	if (!length) {
		return null;
	}

	start = options.ticks.reverse ? scale.max : scale.min;
	end = options.ticks.reverse ? scale.min : scale.max;
	center = scale.getPointPositionForValue(0, start);
	for (i = 0; i < length; ++i) {
		point = fill === 'start' || fill === 'end'
			? scale.getPointPositionForValue(i, fill === 'start' ? start : end)
			: scale.getBasePosition(i);
		if (options.gridLines.circular) {
			point.cx = center.x;
			point.cy = center.y;
			point.angle = scale.getIndexAngle(i) - Math.PI / 2;
		}
		target.push(point);
	}
	return target;
}

function computeBoundary(source) {
	var scale = source.el._scale || {};

	if (scale.getPointPositionForValue) {
		return computeCircularBoundary(source);
	}
	return computeLinearBoundary(source);
}

function resolveTarget(sources, index, propagate) {
	var source = sources[index];
	var fill = source.fill;
	var visited = [index];
	var target;

	if (!propagate) {
		return fill;
	}

	while (fill !== false && visited.indexOf(fill) === -1) {
		if (!isFinite(fill)) {
			return fill;
		}

		target = sources[fill];
		if (!target) {
			return false;
		}

		if (target.visible) {
			return fill;
		}

		visited.push(fill);
		fill = target.fill;
	}

	return false;
}

function createMapper(source) {
	var fill = source.fill;
	var type = 'dataset';

	if (fill === false) {
		return null;
	}

	if (!isFinite(fill)) {
		type = 'boundary';
	}

	return mappers[type](source);
}

function isDrawable(point) {
	return point && !point.skip;
}

function drawArea(ctx, curve0, curve1, len0, len1) {
	var i, cx, cy, r;

	if (!len0 || !len1) {
		return;
	}

	// building first area curve (normal)
	ctx.moveTo(curve0[0].x, curve0[0].y);
	for (i = 1; i < len0; ++i) {
		helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
	}

	if (curve1[0].angle !== undefined) {
		cx = curve1[0].cx;
		cy = curve1[0].cy;
		r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
		for (i = len1 - 1; i > 0; --i) {
			ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
		}
		return;
	}

	// joining the two area curves
	ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

	// building opposite area curve (reverse)
	for (i = len1 - 1; i > 0; --i) {
		helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
	}
}

function doFill(ctx, points, mapper, view, color, loop) {
	var count = points.length;
	var span = view.spanGaps;
	var curve0 = [];
	var curve1 = [];
	var len0 = 0;
	var len1 = 0;
	var i, ilen, index, p0, p1, d0, d1, loopOffset;

	ctx.beginPath();

	for (i = 0, ilen = count; i < ilen; ++i) {
		index = i % count;
		p0 = points[index]._view;
		p1 = mapper(p0, index, view);
		d0 = isDrawable(p0);
		d1 = isDrawable(p1);

		if (loop && loopOffset === undefined && d0) {
			loopOffset = i + 1;
			ilen = count + loopOffset;
		}

		if (d0 && d1) {
			len0 = curve0.push(p0);
			len1 = curve1.push(p1);
		} else if (len0 && len1) {
			if (!span) {
				drawArea(ctx, curve0, curve1, len0, len1);
				len0 = len1 = 0;
				curve0 = [];
				curve1 = [];
			} else {
				if (d0) {
					curve0.push(p0);
				}
				if (d1) {
					curve1.push(p1);
				}
			}
		}
	}

	drawArea(ctx, curve0, curve1, len0, len1);

	ctx.closePath();
	ctx.fillStyle = color;
	ctx.fill();
}

var plugin_filler = {
	id: 'filler',

	afterDatasetsUpdate: function(chart, options) {
		var count = (chart.data.datasets || []).length;
		var propagate = options.propagate;
		var sources = [];
		var meta, i, el, source;

		for (i = 0; i < count; ++i) {
			meta = chart.getDatasetMeta(i);
			el = meta.dataset;
			source = null;

			if (el && el._model && el instanceof elements.Line) {
				source = {
					visible: chart.isDatasetVisible(i),
					fill: decodeFill(el, i, count),
					chart: chart,
					el: el
				};
			}

			meta.$filler = source;
			sources.push(source);
		}

		for (i = 0; i < count; ++i) {
			source = sources[i];
			if (!source) {
				continue;
			}

			source.fill = resolveTarget(sources, i, propagate);
			source.boundary = computeBoundary(source);
			source.mapper = createMapper(source);
		}
	},

	beforeDatasetsDraw: function(chart) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var ctx = chart.ctx;
		var meta, i, el, view, points, mapper, color;

		for (i = metasets.length - 1; i >= 0; --i) {
			meta = metasets[i].$filler;

			if (!meta || !meta.visible) {
				continue;
			}

			el = meta.el;
			view = el._view;
			points = el._children || [];
			mapper = meta.mapper;
			color = view.backgroundColor || core_defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers$1.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers$1.canvas.unclipArea(ctx);
			}
		}
	}
};

var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
var noop$1 = helpers$1.noop;
var valueOrDefault$e = helpers$1.valueOrDefault;

core_defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		align: 'center',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,
		onLeave: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var datasets = chart.data.datasets;
				var options = chart.options.legend || {};
				var usePointStyle = options.labels && options.labels.usePointStyle;

				return chart._getSortedDatasetMetas().map(function(meta) {
					var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

					return {
						text: datasets[meta.index].label,
						fillStyle: style.backgroundColor,
						hidden: !chart.isDatasetVisible(meta.index),
						lineCap: style.borderCapStyle,
						lineDash: style.borderDash,
						lineDashOffset: style.borderDashOffset,
						lineJoin: style.borderJoinStyle,
						lineWidth: style.borderWidth,
						strokeStyle: style.borderColor,
						pointStyle: style.pointStyle,
						rotation: style.rotation,

						// Below is extra data used for toggling the datasets
						datasetIndex: meta.index
					};
				}, this);
			}
		}
	},

	legendCallback: function(chart) {
		var list = document.createElement('ul');
		var datasets = chart.data.datasets;
		var i, ilen, listItem, listItemSpan;

		list.setAttribute('class', chart.id + '-legend');

		for (i = 0, ilen = datasets.length; i < ilen; i++) {
			listItem = list.appendChild(document.createElement('li'));
			listItemSpan = listItem.appendChild(document.createElement('span'));
			listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
			if (datasets[i].label) {
				listItem.appendChild(document.createTextNode(datasets[i].label));
			}
		}

		return list.outerHTML;
	}
});

/**
 * Helper function to get the box width based on the usePointStyle option
 * @param {object} labelopts - the label options on the legend
 * @param {number} fontSize - the label font size
 * @return {number} width of the color box area
 */
function getBoxWidth(labelOpts, fontSize) {
	return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ?
		fontSize :
		labelOpts.boxWidth;
}

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Legend = core_element.extend({

	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];

		/**
 		 * @private
 		 */
		me._hoveredItem = null;

		// Are we in doughnut mode which has a different data type
		me.doughnutMode = false;
	},

	// These methods are ordered by lifecycle. Utilities then follow.
	// Any function defined here is inherited by all legend types.
	// Any function can be extended by the legend type

	beforeUpdate: noop$1,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;
	},
	afterUpdate: noop$1,

	//

	beforeSetDimensions: noop$1,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$1,

	//

	beforeBuildLabels: noop$1,
	buildLabels: function() {
		var me = this;
		var labelOpts = me.options.labels || {};
		var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

		if (labelOpts.filter) {
			legendItems = legendItems.filter(function(item) {
				return labelOpts.filter(item, me.chart.data);
			});
		}

		if (me.options.reverse) {
			legendItems.reverse();
		}

		me.legendItems = legendItems;
	},
	afterBuildLabels: noop$1,

	//

	beforeFit: noop$1,
	fit: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var display = opts.display;

		var ctx = me.ctx;

		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;

		// Reset hit boxes
		var hitboxes = me.legendHitBoxes = [];

		var minSize = me.minSize;
		var isHorizontal = me.isHorizontal();

		if (isHorizontal) {
			minSize.width = me.maxWidth; // fill all the width
			minSize.height = display ? 10 : 0;
		} else {
			minSize.width = display ? 10 : 0;
			minSize.height = me.maxHeight; // fill all the height
		}

		// Increase sizes here
		if (!display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}
		ctx.font = labelFont.string;

		if (isHorizontal) {
			// Labels

			// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
			var lineWidths = me.lineWidths = [0];
			var totalHeight = 0;

			ctx.textAlign = 'left';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
					totalHeight += fontSize + labelOpts.padding;
					lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
				}

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: width,
					height: fontSize
				};

				lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
			});

			minSize.height += totalHeight;

		} else {
			var vPadding = labelOpts.padding;
			var columnWidths = me.columnWidths = [];
			var columnHeights = me.columnHeights = [];
			var totalWidth = labelOpts.padding;
			var currentColWidth = 0;
			var currentColHeight = 0;

			helpers$1.each(me.legendItems, function(legendItem, i) {
				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

				// If too tall, go to new column
				if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
					totalWidth += currentColWidth + labelOpts.padding;
					columnWidths.push(currentColWidth); // previous column width
					columnHeights.push(currentColHeight);
					currentColWidth = 0;
					currentColHeight = 0;
				}

				// Get max width
				currentColWidth = Math.max(currentColWidth, itemWidth);
				currentColHeight += fontSize + vPadding;

				// Store the hitbox width and height here. Final position will be updated in `draw`
				hitboxes[i] = {
					left: 0,
					top: 0,
					width: itemWidth,
					height: fontSize
				};
			});

			totalWidth += currentColWidth;
			columnWidths.push(currentColWidth);
			columnHeights.push(currentColHeight);
			minSize.width += totalWidth;
		}

		me.width = minSize.width;
		me.height = minSize.height;
	},
	afterFit: noop$1,

	// Shared Methods
	isHorizontal: function() {
		return this.options.position === 'top' || this.options.position === 'bottom';
	},

	// Actually draw the legend on the canvas
	draw: function() {
		var me = this;
		var opts = me.options;
		var labelOpts = opts.labels;
		var globalDefaults = core_defaults.global;
		var defaultColor = globalDefaults.defaultColor;
		var lineDefault = globalDefaults.elements.line;
		var legendHeight = me.height;
		var columnHeights = me.columnHeights;
		var legendWidth = me.width;
		var lineWidths = me.lineWidths;

		if (!opts.display) {
			return;
		}

		var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
		var ctx = me.ctx;
		var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
		var labelFont = helpers$1.options._parseFont(labelOpts);
		var fontSize = labelFont.size;
		var cursor;

		// Canvas setup
		ctx.textAlign = rtlHelper.textAlign('left');
		ctx.textBaseline = 'middle';
		ctx.lineWidth = 0.5;
		ctx.strokeStyle = fontColor; // for strikethrough effect
		ctx.fillStyle = fontColor; // render in correct colour
		ctx.font = labelFont.string;

		var boxWidth = getBoxWidth(labelOpts, fontSize);
		var hitboxes = me.legendHitBoxes;

		// current position
		var drawLegendBox = function(x, y, legendItem) {
			if (isNaN(boxWidth) || boxWidth <= 0) {
				return;
			}

			// Set the ctx for the box
			ctx.save();

			var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
			ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
			ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
			ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
			ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
			ctx.lineWidth = lineWidth;
			ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

			if (ctx.setLineDash) {
				// IE 9 and 10 do not support line dash
				ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
			}

			if (labelOpts && labelOpts.usePointStyle) {
				// Recalculate x and y for drawPoint() because its expecting
				// x and y to be center of figure (instead of top left)
				var radius = boxWidth * Math.SQRT2 / 2;
				var centerX = rtlHelper.xPlus(x, boxWidth / 2);
				var centerY = y + fontSize / 2;

				// Draw pointStyle as legend symbol
				helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
			} else {
				// Draw box as legend symbol
				ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				if (lineWidth !== 0) {
					ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
				}
			}

			ctx.restore();
		};

		var fillText = function(x, y, legendItem, textWidth) {
			var halfFontSize = fontSize / 2;
			var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
			var yMiddle = y + halfFontSize;

			ctx.fillText(legendItem.text, xLeft, yMiddle);

			if (legendItem.hidden) {
				// Strikethrough the text if hidden
				ctx.beginPath();
				ctx.lineWidth = 2;
				ctx.moveTo(xLeft, yMiddle);
				ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
				ctx.stroke();
			}
		};

		var alignmentOffset = function(dimension, blockSize) {
			switch (opts.align) {
			case 'start':
				return labelOpts.padding;
			case 'end':
				return dimension - blockSize;
			default: // center
				return (dimension - blockSize + labelOpts.padding) / 2;
			}
		};

		// Horizontal
		var isHorizontal = me.isHorizontal();
		if (isHorizontal) {
			cursor = {
				x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
				y: me.top + labelOpts.padding,
				line: 0
			};
		} else {
			cursor = {
				x: me.left + labelOpts.padding,
				y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
				line: 0
			};
		}

		helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

		var itemHeight = fontSize + labelOpts.padding;
		helpers$1.each(me.legendItems, function(legendItem, i) {
			var textWidth = ctx.measureText(legendItem.text).width;
			var width = boxWidth + (fontSize / 2) + textWidth;
			var x = cursor.x;
			var y = cursor.y;

			rtlHelper.setWidth(me.minSize.width);

			// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
			// instead of me.right and me.bottom because me.width and me.height
			// may have been changed since me.minSize was calculated
			if (isHorizontal) {
				if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
					y = cursor.y += itemHeight;
					cursor.line++;
					x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
				}
			} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
				x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
				cursor.line++;
				y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
			}

			var realX = rtlHelper.x(x);

			drawLegendBox(realX, y, legendItem);

			hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
			hitboxes[i].top = y;

			// Fill the actual label
			fillText(realX, y, legendItem, textWidth);

			if (isHorizontal) {
				cursor.x += width + labelOpts.padding;
			} else {
				cursor.y += itemHeight;
			}
		});

		helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
	},

	/**
	 * @private
	 */
	_getLegendItemAt: function(x, y) {
		var me = this;
		var i, hitBox, lh;

		if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
			// See if we are touching one of the dataset boxes
			lh = me.legendHitBoxes;
			for (i = 0; i < lh.length; ++i) {
				hitBox = lh[i];

				if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
					// Touching an element
					return me.legendItems[i];
				}
			}
		}

		return null;
	},

	/**
	 * Handle an event
	 * @private
	 * @param {IEvent} event - The event to handle
	 */
	handleEvent: function(e) {
		var me = this;
		var opts = me.options;
		var type = e.type === 'mouseup' ? 'click' : e.type;
		var hoveredItem;

		if (type === 'mousemove') {
			if (!opts.onHover && !opts.onLeave) {
				return;
			}
		} else if (type === 'click') {
			if (!opts.onClick) {
				return;
			}
		} else {
			return;
		}

		// Chart event already has relative position in it
		hoveredItem = me._getLegendItemAt(e.x, e.y);

		if (type === 'click') {
			if (hoveredItem && opts.onClick) {
				// use e.native for backwards compatibility
				opts.onClick.call(me, e.native, hoveredItem);
			}
		} else {
			if (opts.onLeave && hoveredItem !== me._hoveredItem) {
				if (me._hoveredItem) {
					opts.onLeave.call(me, e.native, me._hoveredItem);
				}
				me._hoveredItem = hoveredItem;
			}

			if (opts.onHover && hoveredItem) {
				// use e.native for backwards compatibility
				opts.onHover.call(me, e.native, hoveredItem);
			}
		}
	}
});

function createNewLegendAndAttach(chart, legendOpts) {
	var legend = new Legend({
		ctx: chart.ctx,
		options: legendOpts,
		chart: chart
	});

	core_layouts.configure(chart, legend, legendOpts);
	core_layouts.addBox(chart, legend);
	chart.legend = legend;
}

var plugin_legend = {
	id: 'legend',

	/**
	 * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
	 * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Legend,

	beforeInit: function(chart) {
		var legendOpts = chart.options.legend;

		if (legendOpts) {
			createNewLegendAndAttach(chart, legendOpts);
		}
	},

	beforeUpdate: function(chart) {
		var legendOpts = chart.options.legend;
		var legend = chart.legend;

		if (legendOpts) {
			helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

			if (legend) {
				core_layouts.configure(chart, legend, legendOpts);
				legend.options = legendOpts;
			} else {
				createNewLegendAndAttach(chart, legendOpts);
			}
		} else if (legend) {
			core_layouts.removeBox(chart, legend);
			delete chart.legend;
		}
	},

	afterEvent: function(chart, e) {
		var legend = chart.legend;
		if (legend) {
			legend.handleEvent(e);
		}
	}
};

var noop$2 = helpers$1.noop;

core_defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

/**
 * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
 */
var Title = core_element.extend({
	initialize: function(config) {
		var me = this;
		helpers$1.extend(me, config);

		// Contains hit boxes for each dataset (in dataset order)
		me.legendHitBoxes = [];
	},

	// These methods are ordered by lifecycle. Utilities then follow.

	beforeUpdate: noop$2,
	update: function(maxWidth, maxHeight, margins) {
		var me = this;

		// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
		me.beforeUpdate();

		// Absorb the master measurements
		me.maxWidth = maxWidth;
		me.maxHeight = maxHeight;
		me.margins = margins;

		// Dimensions
		me.beforeSetDimensions();
		me.setDimensions();
		me.afterSetDimensions();
		// Labels
		me.beforeBuildLabels();
		me.buildLabels();
		me.afterBuildLabels();

		// Fit
		me.beforeFit();
		me.fit();
		me.afterFit();
		//
		me.afterUpdate();

		return me.minSize;

	},
	afterUpdate: noop$2,

	//

	beforeSetDimensions: noop$2,
	setDimensions: function() {
		var me = this;
		// Set the unconstrained dimension before label rotation
		if (me.isHorizontal()) {
			// Reset position before calculating rotation
			me.width = me.maxWidth;
			me.left = 0;
			me.right = me.width;
		} else {
			me.height = me.maxHeight;

			// Reset position before calculating rotation
			me.top = 0;
			me.bottom = me.height;
		}

		// Reset padding
		me.paddingLeft = 0;
		me.paddingTop = 0;
		me.paddingRight = 0;
		me.paddingBottom = 0;

		// Reset minSize
		me.minSize = {
			width: 0,
			height: 0
		};
	},
	afterSetDimensions: noop$2,

	//

	beforeBuildLabels: noop$2,
	buildLabels: noop$2,
	afterBuildLabels: noop$2,

	//

	beforeFit: noop$2,
	fit: function() {
		var me = this;
		var opts = me.options;
		var minSize = me.minSize = {};
		var isHorizontal = me.isHorizontal();
		var lineCount, textSize;

		if (!opts.display) {
			me.width = minSize.width = me.height = minSize.height = 0;
			return;
		}

		lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
		textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

		me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
		me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
	},
	afterFit: noop$2,

	// Shared Methods
	isHorizontal: function() {
		var pos = this.options.position;
		return pos === 'top' || pos === 'bottom';
	},

	// Actually draw the title block on the canvas
	draw: function() {
		var me = this;
		var ctx = me.ctx;
		var opts = me.options;

		if (!opts.display) {
			return;
		}

		var fontOpts = helpers$1.options._parseFont(opts);
		var lineHeight = fontOpts.lineHeight;
		var offset = lineHeight / 2 + opts.padding;
		var rotation = 0;
		var top = me.top;
		var left = me.left;
		var bottom = me.bottom;
		var right = me.right;
		var maxWidth, titleX, titleY;

		ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
		ctx.font = fontOpts.string;

		// Horizontal
		if (me.isHorizontal()) {
			titleX = left + ((right - left) / 2); // midpoint of the width
			titleY = top + offset;
			maxWidth = right - left;
		} else {
			titleX = opts.position === 'left' ? left + offset : right - offset;
			titleY = top + ((bottom - top) / 2);
			maxWidth = bottom - top;
			rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
		}

		ctx.save();
		ctx.translate(titleX, titleY);
		ctx.rotate(rotation);
		ctx.textAlign = 'center';
		ctx.textBaseline = 'middle';

		var text = opts.text;
		if (helpers$1.isArray(text)) {
			var y = 0;
			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], 0, y, maxWidth);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, 0, 0, maxWidth);
		}

		ctx.restore();
	}
});

function createNewTitleBlockAndAttach(chart, titleOpts) {
	var title = new Title({
		ctx: chart.ctx,
		options: titleOpts,
		chart: chart
	});

	core_layouts.configure(chart, title, titleOpts);
	core_layouts.addBox(chart, title);
	chart.titleBlock = title;
}

var plugin_title = {
	id: 'title',

	/**
	 * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
	 * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
	 * the plugin, which one will be re-exposed in the chart.js file.
	 * https://github.com/chartjs/Chart.js/pull/2640
	 * @private
	 */
	_element: Title,

	beforeInit: function(chart) {
		var titleOpts = chart.options.title;

		if (titleOpts) {
			createNewTitleBlockAndAttach(chart, titleOpts);
		}
	},

	beforeUpdate: function(chart) {
		var titleOpts = chart.options.title;
		var titleBlock = chart.titleBlock;

		if (titleOpts) {
			helpers$1.mergeIf(titleOpts, core_defaults.global.title);

			if (titleBlock) {
				core_layouts.configure(chart, titleBlock, titleOpts);
				titleBlock.options = titleOpts;
			} else {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		} else if (titleBlock) {
			core_layouts.removeBox(chart, titleBlock);
			delete chart.titleBlock;
		}
	}
};

var plugins = {};
var filler = plugin_filler;
var legend = plugin_legend;
var title = plugin_title;
plugins.filler = filler;
plugins.legend = legend;
plugins.title = title;

/**
 * @namespace Chart
 */


core_controller.helpers = helpers$1;

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
core_helpers();

core_controller._adapters = core_adapters;
core_controller.Animation = core_animation;
core_controller.animationService = core_animations;
core_controller.controllers = controllers;
core_controller.DatasetController = core_datasetController;
core_controller.defaults = core_defaults;
core_controller.Element = core_element;
core_controller.elements = elements;
core_controller.Interaction = core_interaction;
core_controller.layouts = core_layouts;
core_controller.platform = platform;
core_controller.plugins = core_plugins;
core_controller.Scale = core_scale;
core_controller.scaleService = core_scaleService;
core_controller.Ticks = core_ticks;
core_controller.Tooltip = core_tooltip;

// Register built-in scales

core_controller.helpers.each(scales, function(scale, type) {
	core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
});

// Load to register built-in adapters (as side effects)


// Loading built-in plugins

for (var k in plugins) {
	if (plugins.hasOwnProperty(k)) {
		core_controller.plugins.register(plugins[k]);
	}
}

core_controller.platform.initialize();

var src = core_controller;
if (typeof window !== 'undefined') {
	window.Chart = core_controller;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Chart
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 * @private
 */
core_controller.Chart = core_controller;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Legend
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Legend = plugins.legend._element;

/**
 * Provided for backward compatibility, not available anymore
 * @namespace Chart.Title
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.Title = plugins.title._element;

/**
 * Provided for backward compatibility, use Chart.plugins instead
 * @namespace Chart.pluginService
 * @deprecated since version 2.1.5
 * @todo remove at version 3
 * @private
 */
core_controller.pluginService = core_controller.plugins;

/**
 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
 * effect, instead simply create/register plugins via plain JavaScript objects.
 * @interface Chart.PluginBase
 * @deprecated since version 2.5.0
 * @todo remove at version 3
 * @private
 */
core_controller.PluginBase = core_controller.Element.extend({});

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
core_controller.canvasHelpers = core_controller.helpers.canvas;

/**
 * Provided for backward compatibility, use Chart.layouts instead.
 * @namespace Chart.layoutService
 * @deprecated since version 2.7.3
 * @todo remove at version 3
 * @private
 */
core_controller.layoutService = core_controller.layouts;

/**
 * Provided for backward compatibility, not available anymore.
 * @namespace Chart.LinearScaleBase
 * @deprecated since version 2.8
 * @todo remove at version 3
 * @private
 */
core_controller.LinearScaleBase = scale_linearbase;

/**
 * Provided for backward compatibility, instead we should create a new Chart
 * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
 * @deprecated since version 2.8.0
 * @todo remove at version 3
 */
core_controller.helpers.each(
	[
		'Bar',
		'Bubble',
		'Doughnut',
		'Line',
		'PolarArea',
		'Radar',
		'Scatter'
	],
	function(klass) {
		core_controller[klass] = function(ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	}
);

return src;

})));


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.getFlagSharedShowFlightSearchResults === false || _vm.getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel === true),expression:"getFlagSharedShowFlightSearchResults === false || getFlagSharedShowFlightSearchResultsAndBestPriceCaroussel === true"}],key:_vm.componentKey,attrs:{"id":"content"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('div',{staticClass:"block",staticStyle:{"margin-bottom":"20px !important"}},[(_vm.modulo === 'booking')?[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.headlinecontent[_vm.getCurrentLocale]))])]:_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?[_c('h1',{staticClass:"idea-title"},[_vm._m(1),_vm._v(_vm._s(_vm.headlinecontent_flightplan[_vm.getCurrentLocale]))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"image-carousel style3 flex-slider",attrs:{"data-item-width":"270","data-item-margin":"30"}},[_c('ul',{staticClass:"slides image-box style9"},[_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'FUE' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('FUE')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/fue_fuerteventura_270x160.png","alt":"Fuerteventura","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'FUE'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'FUE'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Fuerteventura (FUE)"),_c('small',[_vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details",staticStyle:{"margin-bottom":"50px"}},[(_vm.modulo === 'booking')?_c('span',[_vm._m(2),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('FUE') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('FUE')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('FUE')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('FUE') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('FUE') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('FUE') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=fuerteventura&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=fuerteventura&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=fuerteventura&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=fuerteventura&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'LPA' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('LPA')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/lpa_grancanaria_270x160.png","alt":"Gran Canaria","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'LPA'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'LPA'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Gran Canaria (LPA)"),_c('small',[_vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details",staticStyle:{"margin-bottom":"50px"}},[(_vm.modulo === 'booking')?_c('span',[_vm._m(5),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('LPA') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('LPA')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('LPA')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('LPA') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('LPA') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('LPA') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=gran_canaria&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=gran_canaria&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(7),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=gran_canaria&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=gran_canaria&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'TFS' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('TFS')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/tfs_teneriffa_270x160.png","alt":"Teneriffa","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'TFS'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'TFS'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Teneriffa (TFS)"),_c('small',[_vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details",staticStyle:{"margin-bottom":"50px"}},[(_vm.modulo === 'booking')?_c('span',[_vm._m(8),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('TFS') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('TFS')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('TFS')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('TFS') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('TFS') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('TFS') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=teneriffa&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=teneriffa&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(10),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=teneriffa&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=teneriffa&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'PMI' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('PMI')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/pmi_mallorca_270x160.png","alt":"Mallorca","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'PMI'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'PMI'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Mallorca (PMI)"),_c('small',[_vm._v(_vm._s(_vm.spain[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(11),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('PMI') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('PMI')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('PMI')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('PMI') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('PMI') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('PMI') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=mallorca&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=mallorca&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(13),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=mallorca&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=mallorca&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'KGS' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('KGS')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/kos_kos_270x160.png","alt":"Kos","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'KGS'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'KGS'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Kos (KGS)"),_c('small',[_vm._v(_vm._s(_vm.greece[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(14),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('KGS') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('KGS')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('KGS')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('KGS') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('KGS') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('KGS') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kos&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(16),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kos&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'CFU' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('CFU')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/cfu_corfu_270x160.png","alt":"Korfu","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'CFU'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'CFU'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Korfu (CFU)"),_c('small',[_vm._v(_vm._s(_vm.greece[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(17),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('CFU') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('CFU')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('CFU')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('CFU') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('CFU') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('CFU') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=korfu_paxi&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=Korfu&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(19),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=korfu_paxi&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=Korfu&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'HER' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('HER')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/her_heraklion_270x160.png","alt":"Heraklion","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'HER'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'HER'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Heraklion (HER)"),_c('small',[_vm._v(_vm._s(_vm.greece[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(20),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HER') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('HER')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('HER')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HER') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HER') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HER') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kreta&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kreta&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(22),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=kreta&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=kreta&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'RHO' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('RHO')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/rho_rhodos_270x160.png","alt":"Rhodos","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'RHO'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'RHO'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Rhodos (RHO)"),_c('small',[_vm._v(_vm._s(_vm.greece[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(23),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('RHO') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('RHO')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('RHO')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('RHO') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('RHO') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('RHO') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=rhodos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=rhodos&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(25),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=rhodos&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=rhodos&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'BOJ' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('BOJ')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/boj_burgas_270x160.png","alt":"Burgas","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'BOJ'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'BOJ'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Burgas (BOJ)"),_c('small',[_vm._v(_vm._s(_vm.bulgary[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(26),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('BOJ') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('BOJ')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('BOJ')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('BOJ') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('BOJ') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('BOJ') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(28),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'AYT' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('AYT')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/ayt_antalya_270x160.png","alt":"Antalya","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'AYT'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'AYT'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Antalya (AYT)"),_c('small',[_vm._v(_vm._s(_vm.turkey[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(29),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('AYT') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('AYT')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('AYT')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('AYT') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('AYT') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('AYT') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(30),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=tuerkei&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=tuerkei&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(31),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=tuerkei&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=tuerkei&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'HRG' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('HRG')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/hrg_hurghada_270x160.png","alt":"Hurghada","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'HRG'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'HRG'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Hurghada (HRG)"),_c('small',[_vm._v(_vm._s(_vm.egypt[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(32),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HRG') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('HRG')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('HRG')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HRG') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HRG') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('HRG') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=hurghada_safaga&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=hurghada_safaga&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(34),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&destination=hurghada_safaga&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=hurghada_safaga&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])]),_vm._v(" "),_c('li',[_c('div',{staticStyle:{"margin-top":"4px"}},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getOffersSelectedDestination.destinationOfferAptCode === 'VAR' }},[_c('figure',[_c('a',{staticClass:"hover-effect",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('VAR')}}},[_c('img',{attrs:{"src":"/res/images/keydestinations/var_varna_270x160.png","alt":"Varna","width":"270","height":"160"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getOffersSelectedDestination.destinationOfferAptCode === 'VAR'),expression:"getOffersSelectedDestination.destinationOfferAptCode === 'VAR'"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.destinationwasclicked[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h3',{staticClass:"box-title"},[_vm._v("Varna (VAR)"),_c('small',[_vm._v(_vm._s(_vm.bulgary[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"details"},[(_vm.modulo === 'booking')?_c('span',[_vm._m(35),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('VAR') !== 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale]))]),_vm._v(" "),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.clicktoseebestprices[_vm.getCurrentLocale]),expression:"clicktoseebestprices[getCurrentLocale]"}],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Destination('VAR')}}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.get_LowestPriceForKeyDes('VAR')))+"\n                                        ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('VAR') !== 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('VAR') === 0)?_c('span',{staticClass:"price"},[_c('small',[_vm._v(" ")])]):_vm._e(),_vm._v(" "),(_vm.get_LowestPriceForKeyDes('VAR') === 0)?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.flights[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.nooffers[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(36),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'flightplan')?_c('span',[_vm._m(37),_vm._v(" "),_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.click[_vm.getCurrentLocale]))]),_c('a',{attrs:{"href":"https://www.schauinsland-reisen.de/search?product_type=package&departure=DUS-KSF-BRE-HAM-BER-DRS-ERF-LEJ&duration=7-21&date=20210401-20211031&destination=bulgarien_albena_umgebung-bulgarien_goldstrand_varna-bulgarien_sonnenstrand_burgas_nessebar&etcc_cmp=sundair_verlinkung&etcc_med=webseite&etcc_par=sundair&etcc_ctv=bulgarien&etcc_ori=sundair_startseite_teaser","target":"_blank"}},[_vm._v(_vm._s(_vm.here[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.packagetours[_vm.getCurrentLocale])),_c('small',[_vm._v(_vm._s(_vm.offers2[_vm.getCurrentLocale]))])])]):_vm._e()])])])])])]),_vm._v(" "),(_vm.getOffersSelectedDestination.price !== undefined)?_c('span',{staticClass:"text-small pull-left"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.onClick_Reset_KeyDestinations($event)}}},[_vm._v(_vm._s(_vm.reset[_vm.getCurrentLocale]))])]):_vm._e()],2)]),_vm._v(" "),(_vm.getOffersSelectedDestination.price !== undefined)?_c('div',{staticClass:"container block image-container animated fadeIn",staticStyle:{"animation-duration":"3s","visibility":"visible"},attrs:{"data-animation-type":"fadeIn","data-animation-duration":"3"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"main"}},[_c('div',{staticClass:"cruise-list"},[_c('div',{staticClass:"listing-style3 cruise"},[_c('article',{staticClass:"box"},[_c('figure',{staticClass:"details col-sm-3",staticStyle:{"margin-top":"7px"}},[_c('a',{},[_c('img',{attrs:{"width":"270","height":"160","alt":"","src":'/res/images/keydestinations/' + _vm.getOffersSelectedDestination.destinationOfferAptCode.toLowerCase() + '.png'}})])]),_vm._v(" "),_c('div',{key:_vm.fakeCounter,staticClass:"details col-sm-9"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 col-md-6"},[_c('div',{staticClass:"selector",staticStyle:{"text-align":"end"}},[_c('label',{staticClass:"smallSelectorDescs"},[_vm._v(" ")]),_vm._v(" "),_c('v-select',{key:"i",ref:"depArprtCodeKeyDes",staticClass:"style-chooser",class:{ 'buttonglowing': _vm.getBookingOffersListFlightsMonthlyOffers.reduce(function(a, b){ return a + b; }, 0) === 0 },staticStyle:{"margin-bottom":"20px"},attrs:{"name":"depArprtCodeKeyDes","clearable":false,"options":_vm.getBookingDeparturesKeyDes,"label":"l","value":_vm.i,"placeholder":this.departureairport[this.getCurrentLocale]},on:{"input":_vm.onSelect_DepartureAirportKeyDes},model:{value:(_vm.depArprtCodeKeyDes),callback:function ($$v) {_vm.depArprtCodeKeyDes=$$v},expression:"depArprtCodeKeyDes"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 col-md-2"},[_c('div',{staticClass:"selector",staticStyle:{"text-align":"end"}},[_c('label',{staticClass:"smallSelectorDescs"},[_vm._v(_vm._s(_vm.adult[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"k",ref:"noADT",staticClass:"style-chooser",staticStyle:{"margin-bottom":"20px"},attrs:{"name":"noADT","options":_vm.getListOfPaxes,"clearable":false,"label":"v","value":"v"},on:{"input":_vm.onSelect_DepartureAirportKeyDes},model:{value:(_vm.noADT),callback:function ($$v) {_vm.noADT=$$v},expression:"noADT"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 col-md-2"},[_c('div',{staticClass:"selector",staticStyle:{"text-align":"end"}},[_c('label',{staticClass:"smallSelectorDescs"},[_vm._v(_vm._s(_vm.child[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"k",ref:"noCHD",staticClass:"style-chooser",staticStyle:{"margin-bottom":"20px"},attrs:{"name":"noCHD","options":_vm.getListOfPaxes,"clearable":false,"label":"v","value":"v"},on:{"input":_vm.onSelect_DepartureAirportKeyDes},model:{value:(_vm.noCHD),callback:function ($$v) {_vm.noCHD=$$v},expression:"noCHD"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-xs-2 col-md-2"},[_c('div',{staticClass:"selector",staticStyle:{"text-align":"end"}},[_c('label',{staticClass:"smallSelectorDescs"},[_vm._v(_vm._s(_vm.infant[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('v-select',{key:"k",ref:"noINF",staticClass:"style-chooser",staticStyle:{"margin-bottom":"20px"},attrs:{"name":"noINF","options":_vm.getListOfPaxes,"clearable":false,"label":"v","value":"v"},on:{"input":_vm.onSelect_DepartureAirportKeyDes},model:{value:(_vm.noINF),callback:function ($$v) {_vm.noINF=$$v},expression:"noINF"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('h4',{staticClass:"box-title pull-left"},[_vm._v(_vm._s(_vm.getOffersSelectedDestination.desCityName)),_c('small',[_vm._v(_vm._s(_vm.nextmonths[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('span',{staticClass:"price pull-right"},[_c('small',{staticStyle:{"text-align":"end"}},[_vm._v(_vm._s(_vm.from2[_vm.getCurrentLocale]))]),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getOffersSelectedDestination.price)))])]),_vm._v(" "),_c('div',{staticClass:"character clearfix"},[_vm._m(38),_vm._v(" "),_c('div',{staticClass:"col-xs-6 date"},[_c('i',{staticClass:"soap-icon-clock yellow-color"}),_vm._v(" "),_c('div',[_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.mydate[_vm.getCurrentLocale]))]),_c('br'),_vm._v(_vm._s(_vm.next6months[_vm.getCurrentLocale])+"\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 departure"},[_c('i',{staticClass:"soap-icon-departure yellow-color"}),_vm._v(" "),_c('div',[_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.fromDes[_vm.getCurrentLocale]))]),_c('br'),_vm._v(_vm._s(_vm.choosenStartAirport)+"\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 departure"},[_c('i',{staticClass:"soap-icon-departure yellow-color"}),_vm._v(" "),_c('div',[_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.destination[_vm.getCurrentLocale]))]),_c('br'),_vm._v(_vm._s(_vm.getOffersSelectedDestination.desCityName)+", "+_vm._s(_vm.getOffersSelectedDestination.destinationOfferAptCode)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])]),_vm._v(" "),(_vm.getBookingOffersListFlightsMonthlyOffers.reduce(function(a, b){ return a + b; }, 0) > 0)?_c('div',{key:_vm.fakeCounter,staticStyle:{"background":"#fff","padding":"20px"}},[_c('sdr-shared-keydestinations-bar-charts',{attrs:{"chartdata":this.get_barchartsChartdata(),"options":_vm.barchartsOptions}}),_vm._v(" "),(_vm.getBookingOffersChoosenFlightByUser === null)?_c('a',{staticClass:"button btn-large uppercase full-width silver",staticStyle:{"margin-top":"40px"}},[_vm._v(_vm._s(_vm.findflights[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getBookingOffersChoosenFlightByUser !== null)?_c('button',{staticClass:"btn-large icon-check uppercase full-width",staticStyle:{"margin-top":"40px"},attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.onClick_Submit_FindFlightsViaOffers()}}},[_vm._v(_vm._s(_vm.getButtonName()))]):_vm._e()],1):_vm._e()])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-plane-right circle yellow-color takeoff-effect"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"floatingicon"},[_c('i',{staticClass:"soap-icon-hotel circle yellow-color"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-1 cruise-logo"},[_c('img',{staticStyle:{"height":"30px"},attrs:{"src":"/res/images/logo-centered2.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FurtherServices_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea1a5f12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FurtherServices_vue__ = __webpack_require__(425);
function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea1a5f12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FurtherServices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea1a5f12_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FurtherServices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(424);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("32dd0a84", content, true, {});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "a[target=_blank][data-v-ea1a5f12]:after{font-family:FontAwesome;content:\" \\F08E\"}.toggle-container .panel.style1 .panel-content[data-v-ea1a5f12]{padding:10px 40px 15px 55px}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-ea1a5f12]{font-size:1.5em}.toggle-container .panel h4.panel-title[data-v-ea1a5f12]{font-size:1.2em}.toggle-container .panel.style1 .panel-content[data-v-ea1a5f12]{padding:10px 15px 15px}}", ""]);

// exports


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getFlagSharedShowFlightSearchResults === false)?_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"travel-ideas"},[_c('h1',{staticClass:"idea-title travel-ideas"},[_vm._m(0),_vm._v(_vm._s(_vm.contentheadline[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"toggle-container with-image box",attrs:{"id":"accordion3","data-image-animation-type":"zoomIn","data-image-animation-duration":"1"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":"#acc7","data-toggle":"collapse","data-parent":"#accordion3"}},[_vm._v(_vm._s(_vm.furtherservices_seat[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"acc7"}},[_c('div',{staticClass:"panel-content"},[_c('p'),_c('div',{staticClass:"intro box"},[_c('p',[_vm._v(_vm._s(_vm.furtherservices_seat_headline[_vm.getCurrentLocale]))]),_c('br'),_vm._v(" "),_c('div',{staticClass:"image-box style14"},[_c('article',{staticClass:"box"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h5',{staticClass:"box-title"},[_vm._v("Comfort Seat")]),_vm._v(" "),_c('label',{staticClass:"price-wrapper"},[_c('span',{staticClass:"price-per-unit"},[_vm._v("30,00 €")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.furtherservices_seat_comfortseat[_vm.getCurrentLocale])+"\n                                                        ")])])]),_vm._v(" "),_c('article',{staticClass:"box"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h5',{staticClass:"box-title"},[_vm._v("Best Seat")]),_vm._v(" "),_c('label',{staticClass:"price-wrapper"},[_c('span',{staticClass:"price-per-unit"},[_vm._v("20,00 €")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.furtherservices_seat_bestseat[_vm.getCurrentLocale])+"\n                                                        ")])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('article',{staticClass:"box"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h5',{staticClass:"box-title"},[_vm._v("Exit Seat")]),_vm._v(" "),_c('label',{staticClass:"price-wrapper"},[_c('span',{staticClass:"price-per-unit"},[_vm._v("30,00 €")]),_vm._v(" "),_c('br'),_vm._v(_vm._s(_vm.furtherservices_seat_exitseat[_vm.getCurrentLocale])+"\n                                                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"long-description"},[_c('p',[_vm._v(_vm._s(_vm.furtherservices_seat_text1[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_c('br'),_vm._v(" "),_c('h4',{staticStyle:{"color":"#D6254D"},domProps:{"innerHTML":_vm._s(_vm.furtherservices_seat_text2[_vm.getCurrentLocale])}}),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.furtherservices_seat_text3[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/infos-seat-reservation/#/seat-reservation","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_c('p')]),_vm._v(" "),_c('p')])])]),_vm._v(" "),_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":"#acc8","data-toggle":"collapse","data-parent":"#accordion3"}},[_vm._v(_vm._s(_vm.furtherservices_luggage[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"acc8"}},[_c('div',{staticClass:"panel-content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_text1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_text2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_text3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.luggage_text3b[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/infos-luggage/#/luggage","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.luggage_text4[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.luggage_text5[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/infos-additional-services/#/additional-services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_textlistheader[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box"},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li3[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_textcontact[_vm.getCurrentLocale])}})])])]),_vm._v(" "),_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":"#acc9","data-toggle":"collapse","data-parent":"#accordion3"}},[_vm._v(_vm._s(_vm.furtherservices_sportequipment[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"acc9"}},[_c('div',{staticClass:"panel-content"},[_c('p',[_vm._v(_vm._s(_vm.sportequipment_text1[_vm.getCurrentLocale]))]),_vm._v(" "),_c('ul',{staticClass:"check-circle box"},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li6[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li7[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li8[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li9[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.sportequipment_li10[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.sportequipment_text3[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/infos-additional-services/#/additional-services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.sportequipment_text4[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"toggle-container with-image box",attrs:{"id":"accordion4","data-image-animation-type":"zoomIn","data-image-animation-duration":"1"}},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":"#acc11","data-toggle":"collapse","data-parent":"#accordion4"}},[_vm._v(_vm._s(_vm.furtherservices_meal[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"acc11"}},[_c('div',{staticClass:"panel-content"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.meal_text1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.meal_text2[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.meal_text3[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")])])])]),_vm._v(" "),_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":"#acc12","data-toggle":"collapse","data-parent":"#accordion4"}},[_vm._v(_vm._s(_vm.furtherservices_furtherservices[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":"acc12"}},[_c('div',{staticClass:"panel-content"},[_c('p',[_vm._v(_vm._s(_vm.furtherservices_text1[_vm.getCurrentLocale]))]),_vm._v(" "),_c('ul',{staticClass:"check-circle box"},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.furtherservices_li1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.furtherservices_li2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.furtherservices_li3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.furtherservices_li4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.furtherservices_text2[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.furtherservices_text3[_vm.getCurrentLocale])+" "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"/infos-additional-services/#/additional-services","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".")])])])])])])])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container animated fadeIn",staticStyle:{"animation-duration":"3s","visibility":"visible"},attrs:{"data-animation-type":"fadeIn","data-animation-duration":"3"}},[_c('img',{attrs:{"src":"/res/images/travelextras/tabs03.png","alt":"img1"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{staticStyle:{"background-color":"#FF6600"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","heigth":"30"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{staticStyle:{"background-color":"#9900CC"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","heigth":"30"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"box"},[_c('figure',[_c('img',{staticStyle:{"background-color":"#22B14C"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","heigth":"30"}})]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h5',{staticClass:"box-title"},[_vm._v("Standard Seat")]),_vm._v(" "),_c('label',{staticClass:"price-wrapper"},[_c('span',{staticClass:"price-per-unit"},[_vm._v("15,00 €")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('img',{staticStyle:{"background-color":"#3399FF"},attrs:{"src":"/res/images/services/seats/types/seat1.png","alt":"","width":"30","heigth":"30"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container animated fadeIn",staticStyle:{"animation-duration":"3s","visibility":"visible"},attrs:{"data-animation-type":"fadeIn","data-animation-duration":"3"}},[_c('img',{attrs:{"src":"/res/images/travelextras/tabs02.png","alt":"img1"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoBoxSundairApp_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2191d7ed_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoBoxSundairApp_vue__ = __webpack_require__(429);
function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2191d7ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromoBoxSundairApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2191d7ed_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromoBoxSundairApp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("7ba7b1e3", content, true, {});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getFlagSharedShowFlightSearchResults === false)?_c('div',{staticClass:"global-map-area mobile-section",attrs:{"data-stellar-background-ratio":"0.5"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"table-wrapper hidden-table-sm"},[_c('div',{staticClass:"col-md-6 description section table-cell"},[_c('h1',[_vm._v(_vm._s(_vm.title[_vm.getCurrentLocale]))]),_vm._v(" "),_c('div',{staticClass:"review clearfix"},[_vm._m(0),_vm._v("\n                       "),_c('label',[_c('small',{staticClass:"white-color uppercase"},[_vm._v(_vm._s(_vm.rateus[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.info[_vm.getCurrentLocale])}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_vm._m(3)])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"five-stars-container pull-left"},[_c('div',{staticClass:"five-stars transparent-bg",staticStyle:{"width":"100%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.sundair.Sundair&hl=de","target":"_new"}},[_c('img',{attrs:{"src":"/res/images/storeicons/google-play-badge.png","width":"200"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://apps.apple.com/us/app/id1176981108","target":"_new"}},[_c('img',{attrs:{"src":"/res/images/storeicons/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg","width":"165"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 image-wrapper table-cell hidden-sm"},[_c('img',{staticClass:"animated",attrs:{"src":"/res/images/banner-sdr/mockup.svg","alt":"","data-animation-type":"fadeInUp"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',[_c('section',{class:{ 'image-bg2': _vm.CONF_MOURNING == 'false', 'image-bg2-mourning': _vm.CONF_MOURNING == 'true' },attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(_vm.CONF_MOURNING == 'false')?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n                        "+_vm._s(_vm.alertmessage2[_vm.getCurrentLocale])+"\n                        "),_c('span',{staticClass:"close"})]):_vm._e(),_vm._v(" "),(_vm.CONF_MOURNING == 'true')?_c('sdr-mourning',{staticStyle:{"padding-bottom":"40px"},attrs:{"modulo":"booking"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('sdr-shared-flightsearch-tabs',{attrs:{"modulo":"booking"}})],1),_vm._v(" "),_c('div',{staticClass:"sidebar col-sm-4 col-md-3"},[_c('sdr-contact-box')],1)],1)])]),_vm._v(" "),_c('sdr-shared-flightsearchresults',{attrs:{"modulo":"booking"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Passengers_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_337f883c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Passengers_vue__ = __webpack_require__(456);
function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-337f883c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Passengers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_337f883c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Passengers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(433);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("95015fb0", content, true, {});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".icon-check3[data-v-337f883c]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check3[data-v-337f883c]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-337f883c]{font-size:1.5em}a.button.btn-large[data-v-337f883c],button.btn-large[data-v-337f883c],input[type=button].button.btn-large[data-v-337f883c]{font-size:1em}}", ""]);

// exports


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Passenger_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a741ab0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Passenger_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(435)
  __webpack_require__(437)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a741ab0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Passenger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a741ab0c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Passenger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(436);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("d3cd81ee", content, true, {});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".selector.micha span.custom-select-services{opacity:.6!important;color:green}", ""]);

// exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(438);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("8b5f0c06", content, true, {});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".likeh2[data-v-a741ab0c]{font-size:1.6667em;line-height:1.25em}.toggle-container .panel.style2 .panel-title>a[data-v-a741ab0c]{padding-left:0;padding-right:0}.toggle-container .panel.style2 .panel-title>a.collapsed[data-v-a741ab0c]:after{background:#ec008b}.toggle-container .panel.style2 .panel-title>a[data-v-a741ab0c]:after{right:0;bottom:17px}.toggle-container .panel.style2 .panel-title>a.collapsed[data-v-a741ab0c]:hover{color:#ec008b}hr[data-v-a741ab0c]{margin-bottom:20px}.toggle-container .panel.style2 .panel-title>a[data-v-a741ab0c]{color:#303d50}.glyphicon.circle[data-v-a741ab0c],[class*=\" soap-icon\"].circle[data-v-a741ab0c],[class^=soap-icon].circle[data-v-a741ab0c]{background:#fefe00;color:#0a142d}.spacebetweenpaxes[data-v-a741ab0c]{margin-bottom:59px}input[data-v-a741ab0c]:focus{outline:none}.selector select:focus+.custom-select[data-v-a741ab0c],input.input-text[data-v-a741ab0c]:focus,textarea[data-v-a741ab0c]:focus{outline:none;border:1px solid #d3e4f7;box-shadow:0 0 8px #d3e4f7}input.input-text.invalid[data-v-a741ab0c]{border:1px solid red;background-color:#fdecf8}.selector select.invalid[data-v-a741ab0c]{border:1px solid red}.errormsg[data-v-a741ab0c]{margin-bottom:3px;margin-top:3px;color:red}.seatmap-modal-content[data-v-a741ab0c]{padding:10px;font-style:13px;background-color:#fff}.v--modal-overlay[data-modal=seatmap-modal][data-v-a741ab0c]{background:rgba(0,0,0,.5);z-index:555555!important}.demo-modal-class[data-v-a741ab0c]{border-radius:5px;background:#f7f7f7;box-shadow:5px 5px 30px 0 rgba(46,61,73,.6)}.image-box.style12 .details[data-v-a741ab0c]{padding-top:0}.booking-section[data-v-a741ab0c]{box-shadow:0 1px 4px 0 rgba(0,0,0,.1);border-radius:1.5px}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.toggle-container .panel h2.panel-title[data-v-a741ab0c],h2[data-v-a741ab0c],h3[data-v-a741ab0c]{font-size:1.3333em}.booking-section[data-v-a741ab0c]{padding:20px 10px}.toggle-container .panel.style2 .panel-content[data-v-a741ab0c]{padding:0 0 30px}}.alert.alert-help[data-v-a741ab0c]:before{content:\"\"}.alert[data-v-a741ab0c]:before{border:0;left:0}.alert[data-v-a741ab0c]{margin-bottom:5px;padding-left:10px}.alert.alert-help[data-v-a741ab0c]{background:#dcecf6;color:#406f8c}.alert .close[data-v-a741ab0c],.info-box .close[data-v-a741ab0c]{color:#406f8c}button[disabled][data-v-a741ab0c],html input[disabled][data-v-a741ab0c]{cursor:default;opacity:.6;color:green}input.input-text[data-v-a741ab0c],span.custom-select-services[data-v-a741ab0c],textarea[data-v-a741ab0c]{padding-left:8px}", ""]);

// exports


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37a65bde_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__ = __webpack_require__(450);
function injectStyle (ssrContext) {
  __webpack_require__(440)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37a65bde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37a65bde_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(441);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("e42e28e4", content, true, {});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".toggle-container .panel.style2 .panel-title>a.collapsed[data-v-37a65bde]:after{content:\"\\F067\";color:#fff;background:#ec008b}.toggle-container .panel.style2 .panel-title>a[data-v-37a65bde]{xpadding-top:40px}.tab-container.full-width-style .tab-content .tab-content-title[data-v-37a65bde]{padding-left:20px;padding-bottom:14px}.price[data-v-37a65bde]{float:none;padding-right:0;padding-top:20px;text-transform:none}.tab-container.full-width-style .tab-content .tab-content-title[data-v-37a65bde]{color:#954a76}.tab-container .tab-content .tab-pane[data-v-37a65bde]{padding-top:0}.toggle-container .panel.style2 .panel-title[data-v-37a65bde]{margin-top:5px}.toggle-container .panel.style2 .panel-title>a.collapsed[data-v-37a65bde]:hover{color:#ec008b}.toggle-container .panel.style2 .panel-title>a[data-v-37a65bde]{color:#303d50}.box[data-v-37a65bde]{margin-bottom:0}.alert.alert-help[data-v-37a65bde]{background:#74d9f9}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h3[data-v-37a65bde]{font-size:1.3333em}.tab-container.full-width-style ul.tabs li a[data-v-37a65bde]{font-size:1em}.tab-container .tab-content .tab-pane[data-v-37a65bde]{padding:1px}.toggle-container .panel.style2 .panel-content[data-v-37a65bde]{padding:0 1px 30px 3px}.toggle-container .panel h4.panel-title[data-v-37a65bde]{font-size:1.2em}.toggle-container .panel.style2 .panel-title>a[data-v-37a65bde]:after{right:1px}}", ""]);

// exports


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceDetails_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be7fc4e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDetails_vue__ = __webpack_require__(449);
function injectStyle (ssrContext) {
  __webpack_require__(443)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7be7fc4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7be7fc4e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(444);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6c196928", content, true, {});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "a[target=_blank][data-v-7be7fc4e]:after{font-family:FontAwesome;content:\" \\F08E\"}.hotel-list[data-v-7be7fc4e]{margin-top:0}.box[data-v-7be7fc4e]{margin-bottom:0}.skin-color[data-v-7be7fc4e]{text-transform:uppercase;font-size:.8333em}.listing-style3.hotel .details>*>[data-v-7be7fc4e]{vertical-align:bottom;padding-bottom:5px}.listing-style3.hotel .details .button[data-v-7be7fc4e]{margin-bottom:5px}.listing-style3 [class^=soap-icon].circle[data-v-7be7fc4e]:hover{color:#9e4d84}.listing-style3.hotel .details [class^=soap-icon].circle[data-v-7be7fc4e]{margin-top:0}.vue-js-switch[data-v-7be7fc4e]{font-size:.9167em}.tab-container .tab-content .tab-pane .row[data-v-7be7fc4e]{margin-bottom:0}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h4[data-v-7be7fc4e]{font-size:1.2em}.price[data-v-7be7fc4e]{font-size:1.4em}.ipadKorrektur[data-v-7be7fc4e]{padding-left:0}}", ""]);

// exports


/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlusMinusField_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4e5c06_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlusMinusField_vue__ = __webpack_require__(448);
function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b4e5c06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlusMinusField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4e5c06_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PlusMinusField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(447);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1e732038", content, true, {});

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".minusplusnumber[data-v-6b4e5c06]{border:1px solid silver;border-radius:5px;xbackground-color:#a2cb5a;Xmargin:0 5px 0 5px;display:inline-block;user-select:none}.minusplusnumber div[data-v-6b4e5c06]{display:inline-block}.minusplusnumber #field_container input[data-v-6b4e5c06]{width:35px;text-align:center;font-size:12px;padding:3px;border:none;background-color:#fff;color:#000}.minusplusnumber .mpbtn[data-v-6b4e5c06]{padding:3px 10px;cursor:pointer;border-radius:5px;color:#fff;font-size:.9167em;font-weight:600;background-color:#a2cb5a}.minusplusnumber .mpbtn[data-v-6b4e5c06]:hover{background-color:#81a04c}.minusplusnumber .mpbtn[data-v-6b4e5c06]:active{background-color:#6e8842}", ""]);

// exports


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minusplusnumber"},[_c('div',{staticClass:"mpbtn minus",on:{"click":function($event){_vm.mpminus()}}},[_vm._v("\n\t\t-\n\t")]),_vm._v(" "),_c('div',{attrs:{"id":"field_container"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newValue),expression:"newValue"}],attrs:{"type":"number","disabled":""},domProps:{"value":(_vm.newValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newValue=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mpbtn plus",on:{"click":function($event){_vm.mpplus()}}},[_vm._v("\n\t\t+\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-content"},[_c('div',{staticStyle:{"background-color":"#F5F5F5","padding-left":"10px","padding-right":"10px","padding-bottom":"10px","padding-top":"10px"}},[_c('div',{staticClass:"hotel-list listing-style3 hotel"},[_c('div',{staticClass:"hot-deals-list"},[_c('div',{staticClass:"row hotel-list image-box hotel listing-style1 add-clearfix"},[_c('div',{staticClass:"col-md-12"},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getBookingCartIsSrvcAlreadyInCart({ id_pax: _vm.id_pax, srvcs: _vm.srvcs }) }},[_c('figure',[_c('a',{staticClass:"hover-effect"},[_c('img',{attrs:{"width":"200","height":"50","alt":"","src":_vm.srvcs_image}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingCartIsSrvcAlreadyInCart({ id_pax: _vm.id_pax, srvcs: _vm.srvcs })),expression:"getBookingCartIsSrvcAlreadyInCart({ id_pax: id_pax, srvcs: srvcs })"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.added[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details col-sm-12 col-md-12"},[_c('div',[_c('div',[_c('h4',{staticClass:"box-title"},[_vm._v("\n                                            "+_vm._s(_vm.srvcs.description)+"\n                                            "),_c('small',[_c('i',{staticClass:"soap-icon-departure yellow-color"}),_vm._v("\n                                                "+_vm._s(_vm.srvcs.code)+"\n                                            ")])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"amenities"},[_c('i',{class:_vm.soap_icon,staticStyle:{"color":"#9e4d84"}})])])]),_vm._v(" "),_c('div',{staticClass:"second-row"},[_c('div',[(_vm.srvcs.acceptComment === true)?_c('span',[_c('br'),_vm._v(" "),_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.comment[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-10"},[_c('textarea',{ref:"inputService_comment",staticClass:"full-width",attrs:{"rows":"3"}}),_vm._v(" "),(_vm.commentFieldIsEmpty)?_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.commentfieldisemptytext[_vm.getCurrentLocale]))]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.srvcs.remark !=='')?_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.remark[_vm.getCurrentLocale])+":")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.srvcs.remark)}}),_vm._v(" "),(_vm.srvcs_type ==='MEAL')?_c('p',{staticStyle:{"margin-top":"30px"}},[_vm._v("\n                                            "+_vm._s(_vm.meal_text2[_vm.getCurrentLocale])+"\n                                            "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".\n                                        ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-4",staticStyle:{"padding-left":"0px"}},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"soap-icon-plus yellow-color"}),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.count[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[_c('plusminsfield',{ref:"userInputSrvcsDetails_Count",attrs:{"value":1,"min":1,"max":_vm.srvcs.maxBookablePax}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-8 ipadKorrektur",staticStyle:{"padding-left":"0px"}},[_c('div',{staticClass:"icon"},[_c('i',{staticClass:"soap-icon-status yellow-color"}),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.servicebookingfor[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"4px"}},[(_vm.getDoesSrvcsExistOnOutOrRet('out', _vm.srvcs.code))?_c('toggle-button',{ref:"userInputSrvcsDetails_ToggleOut",attrs:{"value":true,"labels":{ checked: _vm.outward[_vm.getCurrentLocale], unchecked: _vm.no[_vm.getCurrentLocale] },"color":{ checked: '#A2CB5A', unchecked: '#D9D9D8' },"width":"85","height":"30"}}):_vm._e(),_vm._v(" "),(!_vm.getDoesSrvcsExistOnOutOrRet('out', _vm.srvcs.code))?_c('toggle-button',{ref:"userInputSrvcsDetails_ToggleOut",attrs:{"value":false,"labels":{ checked: _vm.outward[_vm.getCurrentLocale], unchecked: _vm.no[_vm.getCurrentLocale] },"color":{ checked: '#A2CB5A', unchecked: '#D9D9D8' },"width":"85","height":"30","disabled":""}}):_vm._e(),_vm._v(" "),(_vm.getDoesSrvcsExistOnOutOrRet('ret', _vm.srvcs.code))?_c('toggle-button',{ref:"userInputSrvcsDetails_ToggleRet",attrs:{"value":true,"labels":{ checked: _vm.returnflight[_vm.getCurrentLocale], unchecked: _vm.no[_vm.getCurrentLocale] },"color":{ checked: '#A2CB5A', unchecked: '#D9D9D8' },"width":"85","height":"30"}}):_vm._e(),_vm._v(" "),(!_vm.getDoesSrvcsExistOnOutOrRet('ret', _vm.srvcs.code))?_c('toggle-button',{ref:"userInputSrvcsDetails_ToggleRet",attrs:{"value":false,"labels":{ checked: _vm.returnflight[_vm.getCurrentLocale], unchecked: _vm.no[_vm.getCurrentLocale] },"color":{ checked: '#A2CB5A', unchecked: '#D9D9D8' },"width":"85","height":"30","disabled":""}}):_vm._e()],1)])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"price"},[_c('small',[_vm._v("a/"+_vm._s(_vm.perleg[_vm.getCurrentLocale]))]),_vm._v("\n                                            "+_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.srvcs.price))+"\n                                        ")]),_vm._v(" "),_c('a',{staticClass:"button btn-small full-width text-center green",attrs:{"title":""},on:{"click":function($event){$event.preventDefault();_vm.srvcsSelected({ id_pax: _vm.id_pax, srvcs: _vm.srvcs })}}},[_vm._v(_vm._s(_vm.btn_addservices[_vm.getCurrentLocale]))])])])])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax}},[(_vm.modulo === 'booking')?[_c('div',{staticClass:"tab-container full-width-style white-bg"},[_c('ul',{staticClass:"tabs"},[_c('li',{class:{ active: _vm.getActiveTabBooking('MEAL') }},[(_vm.getBookingSrvcsMealExists)?_c('a',{attrs:{"href":'#first-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-breakfast circle"}),_vm._v(_vm._s(_vm.cat_meals[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTabBooking('SERVICE') }},[(_vm.getBookingSrvcsServiceExists)?_c('a',{attrs:{"href":'#second-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-family circle"}),_vm._v(_vm._s(_vm.cat_service[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTabBooking('PETS') }},[(_vm.getBookingSrvcsPetsExists)?_c('a',{attrs:{"href":'#third-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-dog circle"}),_vm._v(_vm._s(_vm.cat_pets[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTabBooking('SPORTBAG') }},[(_vm.getBookingSrvcsSportbagExists)?_c('a',{attrs:{"href":'#fourth-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-playplace circle"}),_vm._v(_vm._s(_vm.cat_sportbag[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTabBooking('BAGGAGE') }},[(_vm.getBookingSrvcsBaggageExists)?_c('a',{attrs:{"href":'#fifth-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-suitcase circle"}),_vm._v(_vm._s(_vm.cat_baggage[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTabBooking('MEDICAL') }},[(_vm.getBookingSrvcsMedicalExists)?_c('a',{attrs:{"href":'#sixth-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-baggage-4 circle"}),_vm._v(_vm._s(_vm.cat_medical[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[(_vm.getBookingSrvcsMealExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTabBooking('MEAL'), active: _vm.getActiveTabBooking('MEAL') },attrs:{"id":'first-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_meals[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_meals'}},_vm._l((_vm.getBookingPassengersSrvcsMeals),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_meals'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-breakfast circle","srvcs_image":"/res/images/services/meals/meals_1.png","srvcs_type":"MEAL","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsServiceExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTabBooking('SERVICE'), active: _vm.getActiveTabBooking('SERVICE') },attrs:{"id":'second-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_service[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_service'}},_vm._l((_vm.getBookingPassengersSrvcsService),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax+ '_service'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-family circle","srvcs_image":"/res/images/services/services/services_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsPetsExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTabBooking('PETS'), active: _vm.getActiveTabBooking('PETS') },attrs:{"id":'third-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_pets[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_pets'}},_vm._l((_vm.getBookingPassengersSrvcsPets),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_pets'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-dog circle","srvcs_image":"/res/images/services/pets/pets_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsSportbagExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTabBooking('SPORTBAG'), active: _vm.getActiveTabBooking('SPORTBAG') },attrs:{"id":'fourth-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_sportbag[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_sportbag'}},_vm._l((_vm.getBookingPassengersSrvcsSportbag),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_sportbag'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-playplace circle","srvcs_image":"/res/images/services/sportequipment/sportequipment_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsBaggageExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTabBooking('BAGGAGE'), active: _vm.getActiveTabBooking('BAGGAGE') },attrs:{"id":'fifth-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_baggage[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_baggage'}},_vm._l((_vm.getBookingPassengersSrvcsBaggage),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_baggage'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-suitcase circle","srvcs_image":"/res/images/services/baggage/baggage_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsMedicalExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTabBooking('MEDICAL'), active: _vm.getActiveTabBooking('MEDICAL') },attrs:{"id":'sixth-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_medical[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_medical'}},_vm._l((_vm.getBookingPassengersSrvcsMedical),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_medical'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-baggage-4 circle","srvcs_image":"/res/images/services/medical/medical_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e()])])]:_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?[_c('div',{staticClass:"tab-container full-width-style white-bg"},[_c('ul',{staticClass:"tabs"},[_c('li',{class:{ active: _vm.getActiveTab('MEAL') }},[(_vm.getServicesSrvcsMealExists)?_c('a',{attrs:{"href":'#first-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-breakfast circle"}),_vm._v(_vm._s(_vm.cat_meals[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTab('SERVICE') }},[(_vm.getServicesSrvcsServiceExists)?_c('a',{attrs:{"href":'#second-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-family circle"}),_vm._v(_vm._s(_vm.cat_service[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTab('PETS') }},[(_vm.getServicesSrvcsPetsExists)?_c('a',{attrs:{"href":'#third-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-dog circle"}),_vm._v(_vm._s(_vm.cat_pets[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTab('SPORTBAG') }},[(_vm.getServicesSrvcsSportbagExists)?_c('a',{attrs:{"href":'#fourth-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-playplace circle"}),_vm._v(_vm._s(_vm.cat_sportbag[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTab('BAGGAGE') }},[(_vm.getServicesSrvcsBaggageExists)?_c('a',{attrs:{"href":'#fifth-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-suitcase circle"}),_vm._v(_vm._s(_vm.cat_baggage[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('li',{class:{ active: _vm.getActiveTab('MEDICAL') }},[(_vm.getServicesSrvcsMedicalExists)?_c('a',{attrs:{"href":'#sixth-tab_' + _vm.id_pax,"data-toggle":"tab"}},[_c('i',{staticClass:"soap-icon-suitcase circle"}),_vm._v(_vm._s(_vm.cat_medical[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[(_vm.getServicesSrvcsMealExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTab('MEAL'), active: _vm.getActiveTab('MEAL') },attrs:{"id":'first-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_meals[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_meals'}},_vm._l((_vm.getServicesPassengersSrvcsOfType({ type: 'meal' })),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_meals'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-breakfast circle","srvcs_image":"/res/images/services/meals/meals_1.png","srvcs_type":"MEAL","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getServicesSrvcsServiceExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTab('SERVICE'), active: _vm.getActiveTab('SERVICE') },attrs:{"id":'second-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_service[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_service'}},_vm._l((_vm.getServicesPassengersSrvcsOfType({ type: 'service' })),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax+ '_service'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-family circle","srvcs_image":"/res/images/services/services/services_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getServicesSrvcsPetsExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTab('PETS'), active: _vm.getActiveTab('PETS') },attrs:{"id":'third-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_pets[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_pets'}},_vm._l((_vm.getServicesPassengersSrvcsOfType({ type: 'pets' })),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_pets'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-dog circle","srvcs_image":"/res/images/services/pets/pets_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getServicesSrvcsSportbagExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTab('SPORTBAG'), active: _vm.getActiveTab('SPORTBAG') },attrs:{"id":'fourth-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_sportbag[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_sportbag'}},_vm._l((_vm.getServicesPassengersSrvcsOfType({ type: 'sportbag' })),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_sportbag'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-playplace circle","srvcs_image":"/res/images/services/sportequipment/sportequipment_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getServicesSrvcsBaggageExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTab('BAGGAGE'), active: _vm.getActiveTab('BAGGAGE') },attrs:{"id":'fifth-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_baggage[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_baggage'}},_vm._l((_vm.getServicesPassengersSrvcsOfType({ type: 'baggage' })),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_baggage'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-suitcase circle","srvcs_image":"/res/images/services/baggage/baggage_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e(),_vm._v(" "),(_vm.getServicesSrvcsMedicalExists)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getActiveTab('MEDICAL'), active: _vm.getActiveTab('MEDICAL') },attrs:{"id":'sixth-tab_' + _vm.id_pax}},[_c('h3',{staticClass:"tab-content-title"},[_vm._v(_vm._s(_vm.category[_vm.getCurrentLocale])+": '"+_vm._s(_vm.cat_medical[_vm.getCurrentLocale])+"'")]),_vm._v(" "),_c('div',{staticClass:"toggle-container box",attrs:{"id":'accordion' + _vm.id_pax + '_medical'}},_vm._l((_vm.getServicesPassengersSrvcsOfType({ type: 'medical' })),function(srvcs,index){return _c('div',{key:srvcs.id,staticClass:"panel style2"},[_c('h4',{staticClass:"panel-title"},[_c('a',{class:{ collapsed: index !== 0 },attrs:{"href":'#acc1' + _vm.id_pax + '_' + srvcs.id,"data-toggle":"collapse","data-parent":'#accordion' + _vm.id_pax + '_medical'}},[_vm._v(" >>> "+_vm._s(srvcs.description)+" ")])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",class:{ in: index === 0 },attrs:{"id":'acc1' + _vm.id_pax + '_' + srvcs.id}},[_c('sdr-service-details',{attrs:{"id_pax":_vm.id_pax,"srvcs":srvcs,"soap_icon":"soap-icon-baggage-4 circle","srvcs_image":"/res/images/services/medical/medical_1.png","modulo":_vm.modulo}})],1)])}))]):_vm._e()])])]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeatDetails_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5b7deee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeatDetails_vue__ = __webpack_require__(454);
function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5b7deee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SeatDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5b7deee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SeatDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(453);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1f3f2608", content, true, {});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.bldTpl_Stmp_Cmpl(_vm.flightdirection, _vm.pax))}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.getBookingPassengers(_vm.modulo)),function(pax,index){return _c('div',{key:index,staticClass:"booking-section sdr-box",class:{ spacebetweenpaxes: index !== (_vm.getBookingPassengers(_vm.modulo).length - 1) }},[(pax.type ==='ADT')?[_c('div',{staticClass:"person-information",staticStyle:{"padding-bottom":"20px"}},[(_vm.get_areWeInServicesBookingNoMode === false)?_c('h2',{staticStyle:{"padding-bottom":"15px","color":"#4f657e"}},[_c('i',{staticClass:"soap-icon-passenger circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_adult[_vm.getCurrentLocale])+") - "+_vm._s(_vm.form_enteryourdata[_vm.getCurrentLocale])+"."),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) !== ''),expression:"travelsWithInfantNumber(pax.id_pax) !== ''"}],staticClass:"pull-right price small",staticStyle:{"font-size":"10px","padding-top":"12px"}},[_vm._v(_vm._s(_vm.travelswithinfant[_vm.getCurrentLocale])+" "+_vm._s(_vm.travelsWithInfantNumber(pax.id_pax))+" "),_c('i',{staticClass:"soap-icon-man-1 circle"})])]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('h2',{staticStyle:{"padding-bottom":"15px","color":"#4f657e"}},[_c('i',{staticClass:"soap-icon-passenger circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_adult[_vm.getCurrentLocale])+")"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) !== ''),expression:"travelsWithInfantNumber(pax.id_pax) !== ''"}],staticClass:"pull-right price small",staticStyle:{"font-size":"10px","padding-top":"12px"}},[_vm._v(_vm._s(_vm.travelswithinfant[_vm.getCurrentLocale])+" "+_vm._s(_vm.travelsWithInfantNumber(pax.id_pax))+" "),_c('i',{staticClass:"soap-icon-man-1 circle"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"xmargin-bottom":"45px"}},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_salutation[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === false)?_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_salutation_' + pax.id_pax,"name":'inputPax_salutation_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildSalutations()),function(sal,indexsal){return _c('option',{key:indexsal,domProps:{"value":sal.value}},[_vm._v(_vm._s(sal.text))])}))]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_salutation_' + pax.id_pax,"name":'inputPax_salutation_' + pax.id_pax,"disabled":""}},_vm._l((_vm.buildSalutations()),function(sal,indexsal){return _c('option',{key:indexsal,domProps:{"value":sal.value,"selected":sal.value === _vm.get_ServicesBookingnoSearchResults[0].passengers[index].salutation}},[_vm._v(_vm._s(sal.text))])}))]):_vm._e()])]),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === false)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_firstname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","value":"","placeholder":"","id":'inputPax_firstName_' + pax.id_pax,"name":'inputPax_firstName_' + pax.id_pax}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_lastname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","value":"","placeholder":"","id":'inputPax_lastName_' + pax.id_pax,"name":'inputPax_lastName_' + pax.id_pax}})])]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_firstname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","placeholder":"","id":'inputPax_firstName_' + pax.id_pax,"name":'inputPax_firstName_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true},domProps:{"value":_vm.get_areWeInServicesBookingNoMode === true ? _vm.get_ServicesBookingnoSearchResults[0].passengers[index].firstName : ''}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_lastname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","placeholder":"","id":'inputPax_lastName_' + pax.id_pax,"name":'inputPax_lastName_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true},domProps:{"value":_vm.get_areWeInServicesBookingNoMode === true ? _vm.get_ServicesBookingnoSearchResults[0].passengers[index].lastName : ''}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-8"},[_c('label',[_vm._v(_vm._s(_vm.form_birthdate[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === false)?_c('div',{staticClass:"constant-column-5"},[_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateDay_' + pax.id_pax,"name":'inputPax_BirthdateDay_' + pax.id_pax}},_vm._l((31),function(day){return _c('option',{key:day,domProps:{"value":day}},[_vm._v(_vm._s(day))])}))]),_vm._v(" "),_c('div',{staticClass:"selector",class:{ micha: _vm.get_areWeInServicesBookingNoMode === true }},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateMonth_' + pax.id_pax,"name":'inputPax_BirthdateMonth_' + pax.id_pax}},_vm._l((_vm.buildMonths()),function(month,index){return _c('option',{key:index,domProps:{"value":month.value}},[_vm._v(_vm._s(month.text))])}))]),_vm._v(" "),_c('div',{staticClass:"selector",class:{ micha: _vm.get_areWeInServicesBookingNoMode === true }},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateYear_' + pax.id_pax,"name":'inputPax_BirthdateYear_' + pax.id_pax}},_vm._l((_vm.buildYears('ADT')),function(year,index){return _c('option',{key:index,domProps:{"value":year.value}},[_vm._v(_vm._s(year.text))])}))])]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('div',{staticClass:"constant-column-5"},[_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateDay_' + pax.id_pax,"name":'inputPax_BirthdateDay_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((31),function(day,indexd){return _c('option',{key:indexd,domProps:{"value":day,"selected":day === new Date(_vm.get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getDate()}},[_vm._v(_vm._s(day))])}))]),_vm._v(" "),_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateMonth_' + pax.id_pax,"name":'inputPax_BirthdateMonth_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildMonths()),function(month,indexm){return _c('option',{key:indexm,domProps:{"value":month.value,"selected":month.value === new Date(_vm.get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getMonth() + 1}},[_vm._v(_vm._s(month.text))])}))]),_vm._v(" "),_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateYear_' + pax.id_pax,"name":'inputPax_BirthdateYear_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildYears('ADT')),function(year,indexy){return _c('option',{key:indexy,domProps:{"value":year.value,"selected":year.value === new Date(_vm.get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getFullYear()}},[_vm._v(_vm._s(year.text))])}))])]):_vm._e()])])])]:_vm._e(),_vm._v(" "),(pax.type ==='CHD')?[_c('div',{staticClass:"person-information",staticStyle:{"padding-bottom":"20px"}},[_c('h2',{staticStyle:{"padding-bottom":"15px","color":"#4f657e"}},[_c('i',{staticClass:"soap-icon-passenger circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_child[_vm.getCurrentLocale])+") - "+_vm._s(_vm.form_enteryourdata[_vm.getCurrentLocale])+".")]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"xmargin-bottom":"45px"}},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_gender[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === false)?_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_gender_' + pax.id_pax,"name":'inputPax_gender_' + pax.id_pax}},_vm._l((_vm.buildGenders()),function(gender,indexgen){return _c('option',{key:indexgen,domProps:{"value":gender.value}},[_vm._v(_vm._s(gender.text))])}))]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_gender_' + pax.id_pax,"name":'inputPax_gender_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildGenders()),function(gender,indexgen){return _c('option',{key:indexgen,domProps:{"value":gender.value,"selected":gender.value === _vm.get_ServicesBookingnoSearchResults[0].passengers[index].gender.toLowerCase()}},[_vm._v(_vm._s(gender.text))])}))]):_vm._e()])]),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === false)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_firstname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","value":"","placeholder":"","id":'inputPax_firstName_' + pax.id_pax,"name":'inputPax_firstName_' + pax.id_pax}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_lastname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","value":"","placeholder":"","id":'inputPax_lastName_' + pax.id_pax,"name":'inputPax_lastName_' + pax.id_pax}})])]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_firstname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","placeholder":"","id":'inputPax_firstName_' + pax.id_pax,"name":'inputPax_firstName_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true},domProps:{"value":_vm.get_areWeInServicesBookingNoMode === true ? _vm.get_ServicesBookingnoSearchResults[0].passengers[index].firstName : ''}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_lastname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","placeholder":"","id":'inputPax_lastName_' + pax.id_pax,"name":'inputPax_lastName_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true},domProps:{"value":_vm.get_areWeInServicesBookingNoMode === true ? _vm.get_ServicesBookingnoSearchResults[0].passengers[index].lastName : ''}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-8"},[_c('label',[_vm._v(_vm._s(_vm.form_birthdate[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === false)?_c('div',{staticClass:"constant-column-5"},[_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateDay_' + pax.id_pax,"name":'inputPax_BirthdateDay_' + pax.id_pax}},_vm._l((31),function(day){return _c('option',{key:day,domProps:{"value":day}},[_vm._v(_vm._s(day))])}))]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateMonth_' + pax.id_pax,"name":'inputPax_BirthdateMonth_' + pax.id_pax}},_vm._l((_vm.buildMonths()),function(month,index){return _c('option',{key:index,domProps:{"value":month.value}},[_vm._v(_vm._s(month.text))])}))]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateYear_' + pax.id_pax,"name":'inputPax_BirthdateYear_' + pax.id_pax}},_vm._l((_vm.buildYears('CHD')),function(year,index){return _c('option',{key:index,domProps:{"value":year.value}},[_vm._v(_vm._s(year.text))])}))])]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('div',{staticClass:"constant-column-5"},[_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateDay_' + pax.id_pax,"name":'inputPax_BirthdateDay_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((31),function(day,indexd){return _c('option',{key:indexd,domProps:{"value":day,"selected":day === new Date(_vm.get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getDate()}},[_vm._v(_vm._s(day))])}))]),_vm._v(" "),_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateMonth_' + pax.id_pax,"name":'inputPax_BirthdateMonth_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildMonths()),function(month,indexm){return _c('option',{key:indexm,domProps:{"value":month.value,"selected":month.value === new Date(_vm.get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getMonth() + 1}},[_vm._v(_vm._s(month.text))])}))]),_vm._v(" "),_c('div',{staticClass:"selector micha"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateYear_' + pax.id_pax,"name":'inputPax_BirthdateYear_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildYears('CHD')),function(year,indexy){return _c('option',{key:indexy,domProps:{"value":year.value,"selected":year.value === new Date(_vm.get_ServicesBookingnoSearchResults[0].passengers[index].birthdate).getFullYear()}},[_vm._v(_vm._s(year.text))])}))])]):_vm._e()])])])]:_vm._e(),_vm._v(" "),(pax.type ==='INF' && _vm.modulo === 'booking')?[_c('div',{staticClass:"person-information",staticStyle:{"padding-bottom":"20px"}},[_c('h2',{staticStyle:{"padding-bottom":"15px","color":"#4f657e"}},[_c('i',{staticClass:"soap-icon-man-1 circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_infant[_vm.getCurrentLocale])+") -  "+_vm._s(_vm.form_enteryourdata[_vm.getCurrentLocale])+".")]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"xmargin-bottom":"45px"}},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_gender[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_gender_' + pax.id_pax,"name":'inputPax_gender_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildGenders()),function(gender,index){return _c('option',{key:index,domProps:{"value":gender.value}},[_vm._v(_vm._s(gender.text))])}))])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_firstname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","value":"","placeholder":"","id":'inputPax_firstName_' + pax.id_pax,"name":'inputPax_firstName_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_lastname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","value":"","placeholder":"","id":'inputPax_lastName_' + pax.id_pax,"name":'inputPax_lastName_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-8"},[_c('label',[_vm._v(_vm._s(_vm.form_birthdate[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"constant-column-5"},[_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateDay_' + pax.id_pax,"name":'inputPax_BirthdateDay_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((31),function(day){return _c('option',{key:day,domProps:{"value":day}},[_vm._v(_vm._s(day))])}))]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateMonth_' + pax.id_pax,"name":'inputPax_BirthdateMonth_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildMonths()),function(month,index){return _c('option',{key:index,domProps:{"value":month.value}},[_vm._v(_vm._s(month.text))])}))]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":'inputPax_BirthdateYear_' + pax.id_pax,"name":'inputPax_BirthdateYear_' + pax.id_pax,"disabled":_vm.get_areWeInServicesBookingNoMode === true}},_vm._l((_vm.buildYears('INF')),function(year,index){return _c('option',{key:index,domProps:{"value":year.value}},[_vm._v(_vm._s(year.text))])}))])])])])])]:_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?[(pax.type !=='INF' && _vm.getBookingDoesAnySrvcsExistAtAll === true)?_c('span',{staticStyle:{"padding-top":"40px","color":"red","font-size":"14px"}},[_vm._v(_vm._s(_vm.starsaremandatory[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(pax.type !=='INF' && _vm.getBookingDoesAnySrvcsExistAtAll === true)?_c('hr',{}):_vm._e(),_vm._v(" "),(_vm.getBookingDoesAnySrvcsExistAtAll === true)?_c('div',{staticClass:"toggle-container box"},[_c('div',{staticClass:"panel style2"},[_c('h2',{staticClass:"panel-title idea-title"},[(pax.type !=='INF' && pax.type ==='ADT')?_c('a',{staticClass:"collapsed",staticStyle:{"padding-bottom":"15px"},attrs:{"href":'#maintgg_' + pax.id_pax,"data-toggle":"collapse"}},[_c('i',{staticClass:"soap-icon-fork circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_adult[_vm.getCurrentLocale])+") - "+_vm._s(_vm.form_addservices[_vm.getCurrentLocale])+".")]):_vm._e(),_vm._v(" "),(pax.type !=='INF' && pax.type ==='CHD')?_c('a',{staticClass:"collapsed",staticStyle:{"padding-bottom":"15px"},attrs:{"href":'#maintgg_' + pax.id_pax,"data-toggle":"collapse"}},[_c('i',{staticClass:"soap-icon-fork circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_child[_vm.getCurrentLocale])+") - "+_vm._s(_vm.form_addservices[_vm.getCurrentLocale])+".")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'maintgg_' + pax.id_pax}},[(_vm.getBookingSrvcsInsuranceExist === true)?_c('span',[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px","background":""}},[_vm._m(0,true),_vm._v(_vm._s(_vm.headline_chooseyourflextarif[_vm.getCurrentLocale])+":")])]),_vm._v(" "),_c('div',{staticClass:"image-box style12"},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getBookingCartHasPaxAlreadyReservedAnInsurance({ id_pax: pax.id_pax, type: 'outward' }) === true },staticStyle:{"background-color":"#BD6196","padding-top":"5px","padding-left":"2px","border":"1px solid #000"}},[_c('figure',[_c('a',{staticClass:"hover-effect"},[_c('img',{attrs:{"src":"/res/images/services/seats/insurance1.png"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingCartHasPaxAlreadyReservedAnInsurance({ id_pax: pax.id_pax, type: 'outward' }) === true),expression:"getBookingCartHasPaxAlreadyReservedAnInsurance({ id_pax: pax.id_pax, type: 'outward' }) === true"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.added[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h4',{staticClass:"box-title",staticStyle:{"margin-bottom":"0px","color":"#FFF"}},[_vm._v(_vm._s(_vm.flextarifpreselection[_vm.getCurrentLocale])+": ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"#FFF"},domProps:{"innerHTML":_vm._s(_vm.flextariftext[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('span',{staticClass:"price",staticStyle:{"color":"#FFF"}},[_c('small',[_vm._v(" ")]),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getBookingSrvcsInsuranceObject.price)))]),_vm._v(" "),_c('a',{staticClass:"button btn-small green",on:{"click":function($event){$event.preventDefault();_vm.onClick_SrvcInsurance({ pax: pax })}}},[_vm._v(_vm._s(_vm.btn_chooseservices[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"20px","margin-bottom":"20px"}})])]):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsSeatExistOnOut || _vm.getBookingSrvcsSeatExistOnRet)?_c('span',[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px","background":""}},[_vm._m(1,true),_vm._v(_vm._s(_vm.headline_chooseyourseat[_vm.getCurrentLocale])+":")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.longseattext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"20px","margin-bottom":"20px"}}),_vm._v(" "),_c('div',{staticClass:"image-box style12"},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== '' }},[_c('figure',{staticStyle:{"xpadding-top":"9px"}},[_c('a',{staticClass:"hover-effect"},[_c('img',{attrs:{"src":"/res/images/services/seats/seats1.png"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== ''),expression:"getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== ''"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.added[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) !== ''),expression:"travelsWithInfantNumber(pax.id_pax) !== ''"}],staticClass:"box-title",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.seatpreselection[_vm.getCurrentLocale])+": ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) !== ''),expression:"travelsWithInfantNumber(pax.id_pax) !== ''"}],staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.seatwithbabytext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) === ''),expression:"travelsWithInfantNumber(pax.id_pax) === ''"}],staticClass:"box-title",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.seatpreselection[_vm.getCurrentLocale])+": ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) === ''),expression:"travelsWithInfantNumber(pax.id_pax) === ''"}],staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.seatwithoutbabytext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seattext[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.startingat[_vm.getCurrentLocale]))]),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(15)))]),_vm._v(" "),_c('a',{staticClass:"button btn-small green",on:{"click":function($event){$event.preventDefault();_vm.onClick_SrvcSeat({ pax: pax })}}},[_vm._v(_vm._s(_vm.btn_chooseservices[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"20px","margin-bottom":"20px"}})])]):_vm._e(),_vm._v(" "),(_vm.getBookingDoesAnySrvcsExistAtAllWOSeats === true)?_c('span',[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"30px","color":"#4f657e"}},[_vm._m(2,true),_vm._v(_vm._s(_vm.headline_chooseyourservices[_vm.getCurrentLocale])+":")])]),_vm._v(" "),_c('div',{staticClass:"panel-content"},[(pax.type !=='INF')?_c('sdr-services-list',{attrs:{"id_pax":pax.id_pax,"modulo":_vm.modulo}}):_vm._e()],1)]):_vm._e()])])]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?[(pax.type !=='INF' && _vm.getServicesDoesAnySrvcsExistAtAll === true)?_c('span',{staticStyle:{"padding-top":"40px","color":"red","font-size":"14px"}},[_vm._v(_vm._s(_vm.starsaremandatory[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(pax.type !=='INF' && _vm.getServicesDoesAnySrvcsExistAtAll === true)?_c('hr',{}):_vm._e(),_vm._v(" "),(pax.type !=='INF' && _vm.get_areWeInServicesBookingNoMode === true)?_c('div',{staticClass:"alert alert-help"},[_c('h4',[_vm._v(_vm._s(_vm.yourearlierservices[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'outward' }).length > 0)?[_c('b',[_vm._v(_vm._s(_vm.bluebox_outward[_vm.getCurrentLocale]))]),_vm._v(" "),_vm._l((_vm.get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'outward' })),function(paxsrvcs,indexX){return _c('span',{key:indexX},[_vm._v("\n                        "+_vm._s(paxsrvcs.label + ' (' + paxsrvcs.quantity + 'x); ')+"\n                    ")])})]:_vm._e(),_vm._v(" "),(_vm.get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'outward' }).length === 0)?[_c('b',[_vm._v(_vm._s(_vm.bluebox_outward[_vm.getCurrentLocale]))]),_vm._v(" "+_vm._s(_vm.none[_vm.getCurrentLocale])+"\n                ")]:_vm._e(),_vm._v(" "),(_vm.get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'return' }).length > 0 && _vm.get_ServicesBookingnoHasReturnFlight === true)?[_c('br'),_c('br'),_c('b',[_vm._v(_vm._s(_vm.bluebox_return[_vm.getCurrentLocale]))]),_vm._v(" "),_vm._l((_vm.get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'return' })),function(paxsrvcs,indexX){return _c('span',{key:indexX},[_vm._v("\n                        "+_vm._s(paxsrvcs.label + ' (' + paxsrvcs.quantity + 'x); ')+"\n                    ")])})]:_vm._e(),_vm._v(" "),(_vm.get_ServicesBookingnoServicesPerPax({ id_pax: pax.id_pax, type: 'return' }).length === 0 && _vm.get_ServicesBookingnoHasReturnFlight === true)?[_c('br'),_c('br'),_c('b',[_vm._v(_vm._s(_vm.bluebox_return[_vm.getCurrentLocale]))]),_vm._v(" "+_vm._s(_vm.none[_vm.getCurrentLocale])+"\n                ")]:_vm._e(),_vm._v(" "),_c('span',{staticClass:"close"})],2):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getServicesDoesAnySrvcsExistAtAll === true)?_c('div',{staticClass:"toggle-container box"},[_c('div',{staticClass:"panel style2"},[_c('h2',{staticClass:"panel-title idea-title"},[(pax.type !=='INF' && pax.type ==='ADT')?_c('a',{staticClass:"collapsed",staticStyle:{"padding-bottom":"15px"},attrs:{"href":'#maintgg_' + pax.id_pax,"data-toggle":"collapse"}},[_c('i',{staticClass:"soap-icon-fork circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_adult[_vm.getCurrentLocale])+") - "+_vm._s(_vm.form_addservices[_vm.getCurrentLocale])+".")]):_vm._e(),_vm._v(" "),(pax.type !=='INF' && pax.type ==='CHD')?_c('a',{staticClass:"collapsed",staticStyle:{"padding-bottom":"15px"},attrs:{"href":'#maintgg_' + pax.id_pax,"data-toggle":"collapse"}},[_c('i',{staticClass:"soap-icon-fork circle"}),_vm._v(" "+_vm._s(_vm.form_pax[_vm.getCurrentLocale])+" "+_vm._s(pax.index)+": ("+_vm._s(_vm.form_child[_vm.getCurrentLocale])+") - "+_vm._s(_vm.form_addservices[_vm.getCurrentLocale])+".")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'maintgg_' + pax.id_pax}},[(_vm.getBookingSrvcsSeatExistOnOut || _vm.getBookingSrvcsSeatExistOnRet)?_c('span',[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px","background":""}},[_vm._m(3,true),_vm._v(_vm._s(_vm.headline_chooseyourseat[_vm.getCurrentLocale])+":")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.longseattext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"20px","margin-bottom":"20px"}}),_vm._v(" "),_c('div',{staticClass:"image-box style12"},[_c('article',{staticClass:"box",class:{ 'has-discount': _vm.getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== '' }},[_c('figure',{staticStyle:{"xpadding-top":"9px"}},[_c('a',{staticClass:"hover-effect"},[_c('img',{attrs:{"src":"/res/images/services/seats/seats1.png"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== ''),expression:"getBookingCartHasPaxAlreadyReservedASeat({ id_pax: pax.id_pax, type: 'both' }) !== ''"}],staticClass:"discount"},[_c('span',{staticClass:"discount-text"},[_vm._v(_vm._s(_vm.added[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_c('div',{staticClass:"details"},[_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) !== ''),expression:"travelsWithInfantNumber(pax.id_pax) !== ''"}],staticClass:"box-title",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.seatpreselection[_vm.getCurrentLocale])+": ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) !== ''),expression:"travelsWithInfantNumber(pax.id_pax) !== ''"}],staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.seatwithbabytext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) === ''),expression:"travelsWithInfantNumber(pax.id_pax) === ''"}],staticClass:"box-title",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.seatpreselection[_vm.getCurrentLocale])+": ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.travelsWithInfantNumber(pax.id_pax) === ''),expression:"travelsWithInfantNumber(pax.id_pax) === ''"}],staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.seatwithoutbabytext[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seattext[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('div',{staticClass:"action"},[_c('span',{staticClass:"price"},[_c('small',[_vm._v(_vm._s(_vm.startingat[_vm.getCurrentLocale]))]),_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(15)))]),_vm._v(" "),_c('a',{staticClass:"button btn-small green",on:{"click":function($event){$event.preventDefault();_vm.onClick_SrvcSeat({ pax: pax })}}},[_vm._v(_vm._s(_vm.btn_chooseservices[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"20px","margin-bottom":"20px"}})])]):_vm._e(),_vm._v(" "),(_vm.getServicesDoesAnySrvcsExistAtAllWOSeats === true)?_c('span',[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"30px","color":"#4f657e"}},[_vm._m(4,true),_vm._v(_vm._s(_vm.headline_chooseyourservices[_vm.getCurrentLocale])+":")])]),_vm._v(" "),_c('div',{staticClass:"panel-content"},[(pax.type !=='INF')?_c('sdr-services-list',{attrs:{"id_pax":pax.id_pax,"modulo":_vm.modulo}}):_vm._e()],1)]):_vm._e()])])]):_vm._e()]:_vm._e()],2)}),_vm._v(" "),_c('modal',{attrs:{"name":"seatmap-modal","transition":"nice-modal-fade","classes":"demo-modal-class","min-width":200,"min-height":200,"pivot-y":0.5,"adaptive":true,"scrollable":true,"reset":true,"width":"600px","height":"auto"},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"seatmap-modal-content"},[_c('section',{staticStyle:{"padding-top":"10px"},attrs:{"id":"content"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h3',{staticClass:"idea-title",staticStyle:{"margin-bottom":"10px"}},[_c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})]),_vm._v(_vm._s(_vm.modal_headline_seatmaps[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"tab-container style1",staticStyle:{"background-color":"white"}},[_c('ul',{staticClass:"tabs full-width"},[(_vm.getBookingSrvcsSeatExistOnOut === true)?_c('li',{class:{ active: _vm.getBookingSrvcsSeatExistOnOut === true }},[_c('a',{attrs:{"href":"#outwardseats","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.modal_tabheadline_seatforout[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsSeatExistOnRet === true)?_c('li',{class:{ active: _vm.getBookingSrvcsSeatExistOnOut === false && _vm.getBookingSrvcsSeatExistOnRet === true }},[_c('a',{attrs:{"href":"#returnseats","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.modal_tabheadline_seatforret[_vm.getCurrentLocale]))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[(_vm.getBookingSrvcsSeatExistOnOut === true)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getBookingSrvcsSeatExistOnOut === true, active: _vm.getBookingSrvcsSeatExistOnOut === true },attrs:{"id":"outwardseats"}},[_c('sdr-seatdetails',{key:_vm.seatComponentKeyOutward,attrs:{"flightdirection":"outward","pax":_vm.seatmapdata.pax}})],1):_vm._e(),_vm._v(" "),(_vm.getBookingSrvcsSeatExistOnRet === true)?_c('div',{staticClass:"tab-pane fade",class:{ in: _vm.getBookingSrvcsSeatExistOnRet === true && _vm.getBookingSrvcsSeatExistOnOut === false, active: _vm.getBookingSrvcsSeatExistOnRet === true && _vm.getBookingSrvcsSeatExistOnOut === false },attrs:{"id":"returnseats"}},[_c('sdr-seatdetails',{key:_vm.seatComponentKeyReturn,attrs:{"flightdirection":"return","pax":_vm.seatmapdata.pax}})],1):_vm._e()]),_vm._v(" "),_c('a',{staticClass:"button btn-large icon-check uppercase full-width sundair",staticStyle:{"margin-top":"15px"},on:{"click":function($event){$event.preventDefault();_vm.onClick_CloseModal()}}},[_vm._v(_vm._s(_vm.close[_vm.getCurrentLocale]))]),_c('br')])])])])])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index",staticStyle:{"background":"#dde0e2"}},[_c('i',{staticClass:"soap-icon-bottom"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index",staticStyle:{"background":"#dde0e2"}},[_c('i',{staticClass:"soap-icon-bottom"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index",staticStyle:{"background":"#dde0e2"}},[_c('i',{staticClass:"soap-icon-bottom"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index",staticStyle:{"background":"#dde0e2"}},[_c('i',{staticClass:"soap-icon-bottom"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index",staticStyle:{"background":"#dde0e2"}},[_c('i',{staticClass:"soap-icon-bottom"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gray-area",attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"second","module":_vm.modulo}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"container shortcode travel-ideas"},[(_vm.get_areWeInServicesBookingNoMode === false)?_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(0),_vm._v(_vm._s(_vm.pleaseselectservicesheadline[_vm.getCurrentLocale])+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.get_areWeInServicesBookingNoMode === true)?_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(1),_vm._v(_vm._s(_vm.pleaseselectservicesheadlineinbookinno[_vm.getCurrentLocale])+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sms-6 col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('sdr-passenger',{attrs:{"modulo":_vm.modulo}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getFlagBookingPassengersAreReadyForValidation === true)?_c('button',{staticClass:"btn-large icon-check uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getFlagBookingPassengersAreReadyForValidation !== true)?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sms-6 col-sm-4 col-md-3"},[_c('sdr-shared-cart',{attrs:{"modulo":_vm.modulo}}),_vm._v(" "),_c('sdr-contact-box')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__ = __webpack_require__(199);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a18bd19_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__ = __webpack_require__(460);
function injectStyle (ssrContext) {
  __webpack_require__(458)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a18bd19"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a18bd19_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(459);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("099c2d7d", content, true, {});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "input[data-v-7a18bd19]:focus{outline:none}.selector select:focus+.custom-select[data-v-7a18bd19],input.input-text[data-v-7a18bd19]:focus,textarea[data-v-7a18bd19]:focus{outline:none;border:1px solid #d3e4f7;box-shadow:0 0 8px #d3e4f7}input.input-text.invalid[data-v-7a18bd19]{border:1px solid red;background-color:#fdecf8}.selector select.invalid[data-v-7a18bd19]{border:1px solid red}.errormsg[data-v-7a18bd19]{margin-bottom:3px;margin-top:3px;color:red}.icon-check3[data-v-7a18bd19]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check3[data-v-7a18bd19]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-7a18bd19]{font-size:1.5em}h2[data-v-7a18bd19]{font-size:1.4em}a.button.btn-large[data-v-7a18bd19],button.btn-large[data-v-7a18bd19],input[type=button].button.btn-large[data-v-7a18bd19]{font-size:1em}.booking-section[data-v-7a18bd19]{padding:20px 15px}}", ""]);

// exports


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gray-area",attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"third","module":_vm.modulo}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(0),_vm._v(_vm._s(_vm.pleaseselectpayment[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"col-sms-6 col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"booking-section sdr-box"},[_c('div',{staticClass:"person-information"},[_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.yourpersonaldata[_vm.getCurrentLocale])+":")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_companyname[_vm.getCurrentLocale])+":"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_company_payment),expression:"inputPax_company_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_company_payment.$error },attrs:{"type":"text","id":"inputPax_company_payment","name":"inputPax_company_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_company_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_company_payment=$event.target.value},function($event){_vm.$v.inputPax_company_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_company_payment.$dirty && !_vm.$v.inputPax_company_payment.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_company[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_company_payment.$dirty && !_vm.$v.inputPax_company_payment.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_company[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row",staticStyle:{"margin-bottom":"45px"}},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_salutation[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_salutation_payment),expression:"inputPax_salutation_payment"}],staticClass:"full-width",attrs:{"id":"inputPax_salutation_payment","name":"inputPax_salutation_payment"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.inputPax_salutation_payment=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.buildSalutations()),function(sal,index){return _c('option',{key:index,domProps:{"value":sal.value}},[_vm._v(_vm._s(sal.text))])}))])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_firstname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_firstName_payment),expression:"inputPax_firstName_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_firstName_payment.$error },attrs:{"type":"text","id":"'inputPax_firstName_payment","name":"inputPax_firstName_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_firstName_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_firstName_payment=$event.target.value},function($event){_vm.$v.inputPax_firstName_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_firstName_payment.$dirty && !_vm.$v.inputPax_firstName_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_firstName_payment.$dirty && !_vm.$v.inputPax_firstName_payment.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_firstname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_firstName_payment.$dirty && !_vm.$v.inputPax_firstName_payment.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_firstname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_firstName_payment.$dirty && !_vm.$v.inputPax_firstName_payment.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_lastname[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_lastName_payment),expression:"inputPax_lastName_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_lastName_payment.$error },attrs:{"type":"text","id":"inputPax_lastName_payment","name":"inputPax_lastName_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_lastName_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_lastName_payment=$event.target.value},function($event){_vm.$v.inputPax_lastName_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_lastName_payment.$dirty && !_vm.$v.inputPax_lastName_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_lastName_payment.$dirty && !_vm.$v.inputPax_lastName_payment.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_lastname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_lastName_payment.$dirty && !_vm.$v.inputPax_lastName_payment.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_lastname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_lastName_payment.$dirty && !_vm.$v.inputPax_lastName_payment.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_address[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_address_payment),expression:"inputPax_address_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_address_payment.$error },attrs:{"type":"text","id":"'inputPax_address_payment","name":"inputPax_address_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_address_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_address_payment=$event.target.value},function($event){_vm.$v.inputPax_address_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_address_payment.$dirty && !_vm.$v.inputPax_address_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_address_payment.$dirty && !_vm.$v.inputPax_address_payment.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_lastname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_address_payment.$dirty && !_vm.$v.inputPax_address_payment.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_lastname[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_plz[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_plz_payment),expression:"inputPax_plz_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_plz_payment.$error },attrs:{"type":"text","id":"inputPax_plz_payment","name":"inputPax_plz_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_plz_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_plz_payment=$event.target.value},function($event){_vm.$v.inputPax_plz_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_plz_payment.$dirty && !_vm.$v.inputPax_plz_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_plz_payment.$dirty && !_vm.$v.inputPax_plz_payment.numeric)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_numeric[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_plz_payment.$dirty && !_vm.$v.inputPax_plz_payment.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_plz[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_plz_payment.$dirty && !_vm.$v.inputPax_plz_payment.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_plz[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_residence[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_residence_payment),expression:"inputPax_residence_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_residence_payment.$error },attrs:{"type":"text","id":"'inputPax_residence_payment","name":"inputPax_residence_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_residence_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_residence_payment=$event.target.value},function($event){_vm.$v.inputPax_residence_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_residence_payment.$dirty && !_vm.$v.inputPax_residence_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_residence_payment.$dirty && !_vm.$v.inputPax_residence_payment.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_residence_payment.$dirty && !_vm.$v.inputPax_residence_payment.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_residence[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_residence_payment.$dirty && !_vm.$v.inputPax_residence_payment.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_residence[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_country[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_country_payment),expression:"inputPax_country_payment"}],staticClass:"full-width",attrs:{"id":"inputPax_country_payment","name":"inputPax_country_payment"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.inputPax_country_payment=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.buildCountries()),function(country,index){return _c('option',{key:index,domProps:{"value":country.id}},[_vm._v(_vm._s(country.country)+"\n                                            ")])}))])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_phone[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_phone_payment),expression:"inputPax_phone_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_phone_payment.$error },attrs:{"type":"text","id":"inputPax_phone_payment","name":"inputPax_phone_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_phone_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_phone_payment=$event.target.value},function($event){_vm.$v.inputPax_phone_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_phone_payment.$dirty && !_vm.$v.inputPax_phone_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_phone_payment.$dirty && !_vm.$v.inputPax_phone_payment.numericspaces)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_numericspaces[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_phone_payment.$dirty && !_vm.$v.inputPax_phone_payment.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_phone[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPax_phone_payment.$dirty && !_vm.$v.inputPax_phone_payment.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_phone[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_email[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPax_email_payment),expression:"inputPax_email_payment"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPax_email_payment.$error },attrs:{"type":"text","id":"inputPax_email_payment","name":"inputPax_email_payment","value":"","placeholder":""},domProps:{"value":(_vm.inputPax_email_payment)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPax_email_payment=$event.target.value},function($event){_vm.$v.inputPax_email_payment.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPax_email_payment.$dirty && !_vm.$v.inputPax_email_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(!_vm.$v.inputPax_email_payment.email)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_email[_vm.getCurrentLocale]))]):_vm._e()])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v(_vm._s(_vm.starsaremandatory[_vm.getCurrentLocale]))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),(!_vm.isItAnOOPayment)?_c('div',{staticClass:"choose-information"},[_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.selectpaymentinfo[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-12 col-md-10"},[_c('div',{staticClass:"selector"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPay_payment),expression:"inputPay_payment"}],staticClass:"full-width",class:{ invalid: !_vm.$v.inputPay_payment.required },attrs:{"id":"inputPay_payment","name":"inputPay_payment"},on:{"input":function($event){_vm.$v.inputPay_payment.$touch()},"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.inputPay_payment=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.onChangePaymentMethod($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(this.paymentmethod_pleaseselect[this.getCurrentLocale]))]),_vm._v(" "),_vm._l((_vm.buildPayments()),function(sal,index){return _c('option',{key:index,domProps:{"value":sal.value}},[_vm._v(_vm._s(sal.text))])})],2),_vm._v(" "),(!_vm.$v.inputPay_payment.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required_2[_vm.getCurrentLocale]))]):_vm._e()])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('hr'),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCreditcardFake),expression:"showCreditcardFake"}],staticClass:"card-information"},[_c('h2',[_vm._v(_vm._s(_vm.yourcardinfo[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_cc_type[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":"inputPayment_cc_type","name":"inputPayment_cc_type"}},_vm._l((_vm.buildCreditcards()),function(card,index){return _c('option',{key:index,domProps:{"value":card.id}},[_vm._v(_vm._s(card.card))])}))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_cc_holder[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPayment_cc_holder),expression:"inputPayment_cc_holder"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPayment_cc_holder.$error },attrs:{"type":"text","id":"'inputPayment_cc_holder","name":"inputPayment_cc_holder","value":"","placeholder":""},domProps:{"value":(_vm.inputPayment_cc_holder)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPayment_cc_holder=$event.target.value},function($event){_vm.$v.inputPayment_cc_holder.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPayment_cc_holder.$dirty && !_vm.$v.inputPayment_cc_holder.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_holder.$dirty && !_vm.$v.inputPayment_cc_holder.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_company[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_holder.$dirty && !_vm.$v.inputPayment_cc_holder.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_company[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_holder.$dirty && !_vm.$v.inputPayment_cc_holder.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_cc_number[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPayment_cc_number),expression:"inputPayment_cc_number"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPayment_cc_number.$error },attrs:{"type":"text","id":"'inputPayment_cc_number","name":"inputPayment_cc_number","value":"","placeholder":""},domProps:{"value":(_vm.inputPayment_cc_number)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPayment_cc_number=$event.target.value},function($event){_vm.$v.inputPayment_cc_number.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPayment_cc_number.$dirty && !_vm.$v.inputPayment_cc_number.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_number.$dirty && !_vm.$v.inputPayment_cc_number.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_ccnumber[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_number.$dirty && !_vm.$v.inputPayment_cc_number.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_max_ccnumber[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_cc_cvc[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPayment_cc_cvc),expression:"inputPayment_cc_cvc"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPayment_cc_cvc.$error },attrs:{"type":"text","id":"'inputPayment_cc_cvc","name":"inputPayment_cc_cvc","value":"","placeholder":""},domProps:{"value":(_vm.inputPayment_cc_cvc)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPayment_cc_cvc=$event.target.value},function($event){_vm.$v.inputPayment_cc_cvc.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPayment_cc_cvc.$dirty && !_vm.$v.inputPayment_cc_cvc.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_cvc.$dirty && !_vm.$v.inputPayment_cc_cvc.numeric)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_numeric[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_cvc.$dirty && !_vm.$v.inputPayment_cc_cvc.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_cccvc[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_cc_cvc.$dirty && !_vm.$v.inputPayment_cc_cvc.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_cccvc[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_cc_expirationdate[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"constant-column-2"},[_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":"inputPayment_cc_expirationmonth","name":"inputPayment_cc_expirationmonth"}},_vm._l((_vm.buildMonths()),function(month,index){return _c('option',{key:index,domProps:{"value":month.value}},[_vm._v(_vm._s(month.text)+"\n                                                ")])}))]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":"inputPayment_cc_expirationyear","name":"inputPayment_cc_expirationyear"}},_vm._l((_vm.buildYears()),function(year,index){return _c('option',{key:index,domProps:{"value":year.value}},[_vm._v(_vm._s(year.text)+"\n                                                ")])}))])])])]),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.creditcardnote[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.creditcardnote2[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCreditcard),expression:"showCreditcard"}],staticClass:"card-information"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.creditcardnote[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.creditcardnote2[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDebit),expression:"showDebit"}],staticClass:"debit-information"},[_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.yourdebitinfo[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_dd_accountholder[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPayment_dd_accountholder),expression:"inputPayment_dd_accountholder"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPayment_dd_accountholder.$error },attrs:{"type":"text","id":"'inputPayment_dd_accountholder","name":"inputPayment_dd_accountholder","value":"","placeholder":""},domProps:{"value":(_vm.inputPayment_dd_accountholder)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPayment_dd_accountholder=$event.target.value},function($event){_vm.$v.inputPayment_dd_accountholder.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPayment_dd_accountholder.$dirty && !_vm.$v.inputPayment_dd_accountholder.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_accountholder.$dirty && !_vm.$v.inputPayment_dd_accountholder.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_company[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_accountholder.$dirty && !_vm.$v.inputPayment_dd_accountholder.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_company[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_accountholder.$dirty && !_vm.$v.inputPayment_dd_accountholder.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_dd_iban[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPayment_dd_iban),expression:"inputPayment_dd_iban"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPayment_dd_iban.$error },attrs:{"type":"text","id":"'inputPayment_dd_iban","name":"inputPayment_dd_iban","value":"","placeholder":""},domProps:{"value":(_vm.inputPayment_dd_iban)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPayment_dd_iban=$event.target.value},function($event){_vm.$v.inputPayment_dd_iban.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPayment_dd_iban.$dirty && !_vm.$v.inputPayment_dd_iban.required)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_iban.$dirty && !_vm.$v.inputPayment_dd_iban.alphaNum)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_alphanum[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_iban.$dirty && !_vm.$v.inputPayment_dd_iban.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_iban[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_iban.$dirty && !_vm.$v.inputPayment_dd_iban.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_iban[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_iban.$dirty && !_vm.$v.inputPayment_dd_iban.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_min_iban[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_iban.$dirty && !_vm.$v.inputPayment_dd_iban.ibanletters)?_c('p',{staticClass:"errormsg"},[_vm._v("\n                                        "+_vm._s(_vm.errmsg_countrycode_iban[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.form_dd_bic[_vm.getCurrentLocale])+":"),_c('span',{staticStyle:{"color":"red","font-size":"14px"}},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputPayment_dd_bic),expression:"inputPayment_dd_bic"}],staticClass:"input-text full-width",class:{ invalid: _vm.$v.inputPayment_dd_bic.$error },attrs:{"type":"text","id":"'inputPayment_dd_bic","name":"inputPayment_dd_bic","value":"","placeholder":""},domProps:{"value":(_vm.inputPayment_dd_bic)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputPayment_dd_bic=$event.target.value},function($event){_vm.$v.inputPayment_dd_bic.$touch()}]}}),_vm._v(" "),(_vm.$v.inputPayment_dd_bic.$dirty && !_vm.$v.inputPayment_dd_bic.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_bic.$dirty && !_vm.$v.inputPayment_dd_bic.alphaNum)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_alphanum[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputPayment_dd_bic.$dirty && !_vm.$v.inputPayment_dd_bic.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_bic[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.debitnote[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCash),expression:"showCash"}]},[_c('h2',[_vm._v(_vm._s(_vm.yourcashinfo[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('h3',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.cashnote[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCreditcard || _vm.showDebit),expression:"showCreditcard || showDebit"}]},[_c('br'),_c('hr')])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.checkValidity())?_c('button',{staticClass:"btn-large icon-check uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(!_vm.checkValidity())?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sms-6 col-sm-4 col-md-3"},[_c('sdr-shared-cart',{attrs:{"modulo":_vm.modulo}}),_vm._v(" "),_c('sdr-contact-box')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967cc756_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__(467);
function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-967cc756"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_967cc756_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(463);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a613fdae", content, true, {});

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "#flight-details .flights[data-v-967cc756]{padding-bottom:0}#flight-details .flights .first-flight .logo[data-v-967cc756]:after{bottom:23px}.totalbutton[data-v-967cc756]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.tab-container ul.tabs li.active>a[data-v-967cc756],.tab-container ul.tabs li:hover>a[data-v-967cc756],dl.term-description dt[data-v-967cc756]{color:#9e4d84}.cruise-itinerary td[data-v-967cc756]{line-height:2.5em;border:1px solid #f5f5f5}.booking-details .other-details[data-v-967cc756]{background-color:#f5f5f5}.booking-details .other-details .total-price-value[data-v-967cc756]{font-size:1.9167em}.total-price-value-small[data-v-967cc756]{color:#98ce44;font-size:1.4em;text-align:right}.booking-details .other-details dd[data-v-967cc756],.booking-details .other-details dt[data-v-967cc756]{padding-top:.4em;padding-bottom:.4em}#flight-fare-rules .topics li.active[data-v-967cc756],.hotel-faqs .topics li.active[data-v-967cc756],.icon-box.style9>i[data-v-967cc756]{background:#9e4d84}.size-modal2-content[data-v-967cc756]{padding:10px;font-style:13px;background-color:#fff;padding-right:50px}.v--modal-overlay[data-modal=size-modal2][data-v-967cc756]{background:rgba(0,0,0,.5);z-index:555555!important}.demo-modal-class[data-v-967cc756]{border-radius:5px;background:#f7f7f7;box-shadow:5px 5px 30px 0 rgba(46,61,73,.6)}.size-modal3-content[data-v-967cc756]{padding:10px;font-style:13px;background-color:#fff;padding-right:10px}.v--modal-overlay[data-modal=size-modal3][data-v-967cc756]{background:rgba(0,0,0,.5);z-index:555555!important}.icon-check3[data-v-967cc756]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check3[data-v-967cc756]:after{content:\"\";position:absolute;top:0;right:10px;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-967cc756]{font-size:1.5em}h2[data-v-967cc756]{font-size:1.4em}a.button.btn-large[data-v-967cc756],button.btn-large[data-v-967cc756],input[type=button].button.btn-large[data-v-967cc756]{font-size:1em}.booking-section[data-v-967cc756]{padding:20px 15px}}", ""]);

// exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(465);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9c6b6fd4", content, true, {});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "#flight-details .flights[data-v-62e5720f]{padding-bottom:0}#flight-details .flights .first-flight .logo[data-v-62e5720f]:after{bottom:23px}.totalbutton[data-v-62e5720f]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.tab-container ul.tabs li.active>a[data-v-62e5720f],.tab-container ul.tabs li:hover>a[data-v-62e5720f],dl.term-description dt[data-v-62e5720f]{color:#9e4d84}.cruise-itinerary td[data-v-62e5720f]{line-height:2.5em;border:1px solid #f5f5f5}.booking-details .other-details[data-v-62e5720f]{background-color:#f5f5f5}.booking-details .other-details .total-price-value[data-v-62e5720f]{font-size:1.9167em}.total-price-value-small[data-v-62e5720f]{color:#98ce44;font-size:1.4em;text-align:right}.booking-details .other-details dd[data-v-62e5720f],.booking-details .other-details dt[data-v-62e5720f]{padding-top:.4em;padding-bottom:.4em}#flight-fare-rules .topics li.active[data-v-62e5720f],.hotel-faqs .topics li.active[data-v-62e5720f],.icon-box.style9>i[data-v-62e5720f]{background:#9e4d84}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-62e5720f]{font-size:1.5em}h2[data-v-62e5720f]{font-size:1.4em}a.button.btn-large[data-v-62e5720f],button.btn-large[data-v-62e5720f],input[type=button].button.btn-large[data-v-62e5720f]{font-size:1em}.booking-section[data-v-62e5720f]{padding:20px 15px}}", ""]);

// exports


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.modulo === 'booking')?[(_vm.flightdirection === 'outward')?_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.tab_header_flightdetailsoutward[_vm.getCurrentLocale])+":")]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.tab_header_flightdetailsreturn[_vm.getCurrentLocale])+":")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?[(_vm.flightdirection === 'outward')?_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.tab_header_flightdetailsoutwardservices[_vm.getCurrentLocale])+":")]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.tab_header_flightdetailsreturnservices[_vm.getCurrentLocale])+":")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"intro table-wrapper full-width hidden-table-sm box",staticStyle:{"border-spacing":"8px"}},[_c('div',{staticClass:"col-md-4 table-cell sdr-box"},[_c('dl',{staticClass:"term-description"},[_c('dt',[_vm._v(_vm._s(_vm.airline[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v("Nouvelair")]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.flighttype[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v("Economy")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 table-cell"},[_c('div',{staticClass:"detailed-features booking-details"},[_c('div',{staticClass:"sdr-box"},[(_vm.flightdirection === 'outward')?_c('a',{staticClass:"button btn-mini yellow pull-right",staticStyle:{"color":"#4f657e"},attrs:{"href":"#"}},[_vm._v("STOPS: "+_vm._s(_vm.getBookingLockfaresResults.outwardFlight.stopAirport === null ? '0' : '1'))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('a',{staticClass:"button btn-mini yellow pull-right",staticStyle:{"color":"#4f657e"},attrs:{"href":"#"}},[_vm._v("STOPS: "+_vm._s(_vm.getBookingLockfaresResults.outwardFlight.stopAirport === null ? '0' : '1')+" ")]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('h4',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingDepArprtName)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.getBookingDesArprtName)),_c('small',[_vm._v(_vm._s(_vm.outwardflight[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return' && _vm.getBookingUsersSearchData_OjArprtCode === '')?_c('h4',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingDesArprtName)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.getBookingDepArprtName)),_c('small',[_vm._v(_vm._s(_vm.returnflight[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return' && _vm.getBookingUsersSearchData_OjArprtCode !== '')?_c('h4',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingDepArprtNameReturnToOther)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.getBookingDesArprtNameReturnToOther)),_c('small',[_vm._v(_vm._s(_vm.returnflight[_vm.getCurrentLocale]))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"table-wrapper flights"},[_c('div',{staticClass:"table-row first-flight"},[_c('div',{staticClass:"table-cell logo"},[_c('img',{staticStyle:{"padding-bottom":"3px"},attrs:{"src":"/res/images/sdr140x30.png","alt":""}}),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('label',[_vm._v(_vm._s(_vm.getBookingLockfaresResults.outwardFlight.flightNo))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('label',[_vm._v(_vm._s(_vm.getBookingLockfaresResults.inboundFlight.flightNo))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"table-cell timing-detail"},[_c('div',{staticClass:"timing"},[_c('div',{staticClass:"check-in"},[_c('label',[_vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.getBookingCart[0].outward.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.getBookingCart[0].return.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"duration text-center"},[_c('i',{staticClass:"soap-icon-clock"}),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.getBookingCart[0].outward.dur)))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.getBookingCart[0].return.dur)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"check-out"},[_c('label',[_vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(" "+_vm._s(_vm._f("moment")(_vm.getBookingCart[0].outward.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("moment")(_vm.getBookingCart[0].return.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e()])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"intro table-wrapper full-width hidden-table-sm box",staticStyle:{"border-spacing":"8px"}},[_c('div',{staticClass:"col-md-4 table-cell sdr-box"},[_c('dl',{staticClass:"term-description"},[_c('dt',[_vm._v(_vm._s(_vm.airline[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v("Nouvelair")]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.flighttype[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v("Economy")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 table-cell"},[_c('div',{staticClass:"detailed-features booking-details"},[_c('div',{staticClass:"sdr-box"},[(_vm.flightdirection === 'outward')?_c('h4',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingDepArprtName)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.getBookingDesArprtName)),_c('small',[_vm._v(_vm._s(_vm.outwardflight[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return' && _vm.getBookingUsersSearchData_OjArprtCode === '')?_c('h4',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingDesArprtName)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.getBookingDepArprtName)),_c('small',[_vm._v(_vm._s(_vm.returnflight[_vm.getCurrentLocale]))])]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return' && _vm.getBookingUsersSearchData_OjArprtCode !== '')?_c('h4',{staticClass:"box-title",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.from[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingDepArprtNameReturnToOther)+" "+_vm._s(_vm.to[_vm.getCurrentLocale])+"  "+_vm._s(_vm.getBookingDesArprtNameReturnToOther)),_c('small',[_vm._v(_vm._s(_vm.returnflight[_vm.getCurrentLocale]))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"table-wrapper flights"},[_c('div',{staticClass:"table-row first-flight"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"table-cell timing-detail"},[_c('div',{staticClass:"timing"},[_c('div',{staticClass:"check-in"},[_c('label',[_vm._v(_vm._s(_vm.takeoff[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.getBookingCart[0].outward.depDT))+", "+_vm._s(_vm._f("momentTime")(_vm.getBookingCart[0].outward.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.getBookingCart[0].return.depDT))+", "+_vm._s(_vm._f("momentTime")(_vm.getBookingCart[0].return.depDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"duration text-center"},[_c('i',{staticClass:"soap-icon-clock"}),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.getBookingCart[0].outward.dur)))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("durationFlightCart")(_vm.getBookingCart[0].return.dur)))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"check-out"},[_c('label',[_vm._v(_vm._s(_vm.landing[_vm.getCurrentLocale]))]),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.getBookingCart[0].outward.desDT))+", "+_vm._s(_vm._f("momentTime")(_vm.getBookingCart[0].outward.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('span',[_vm._v(_vm._s(_vm._f("dateFlightCart")(_vm.getBookingCart[0].return.desDT))+", "+_vm._s(_vm._f("momentTime")(_vm.getBookingCart[0].return.desDT))+_vm._s(_vm.uhr[_vm.getCurrentLocale]))]):_vm._e()])])])])])])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.getBookingCart),function(pax,index){return _c('div',{key:index,staticClass:"booking-section sdr-box",staticStyle:{"padding":"0px","padding-top":"10px"}},[_c('h4',{staticClass:"paxheadline",staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.trnslPaxTypes(pax.type))+" "+_vm._s(pax.counter)+": "+_vm._s(_vm.trnslPaxSalutations(pax.paxCredentials.salutation))+" "+_vm._s(pax.paxCredentials.firstName)+" "+_vm._s(pax.paxCredentials.lastName)+" ("+_vm._s(_vm.born[_vm.getCurrentLocale])+": "+_vm._s(_vm._f("birthdate")(pax.paxCredentials.birthdate))+")")]),_vm._v(" "),_c('div',{staticClass:"table-cell cruise-itinerary"},[_c('div',{staticClass:"sdr-box",staticStyle:{"padding-top":"0px","padding-bottom":"0px","padding-left":"0px","padding-right":"0px"}},[(_vm.flightdirection === 'outward')?_c('table',[_c('tbody',[_c('tr',[(_vm.modulo === 'booking')?_c('td',[_vm._v(_vm._s(_vm.flightprice[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('td',[_vm._v(_vm._s(_vm.flightpriceservices[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),(_vm.modulo === 'booking')?_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward.totalprice !== undefined ? pax.outward.totalprice : '0')))]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('td',{staticClass:"total-price-value-small"},[_vm._v(" - ")]):_vm._e()]),_vm._v(" "),(pax.outward_seat.seatno !== undefined)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.seat[_vm.getCurrentLocale])+": "),_c('b',[_vm._v(_vm._s(_vm._f("truncate")(pax.outward_seat.seatno,17, '...')))])]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.outward_seat.price !== undefined ? pax.outward_seat.price : '0')))])]):_vm._e(),_vm._v(" "),_vm._l((pax.outward_srvcs),function(srvcs,index2){return _c('tr',{key:index2},[(srvcs.code !== 'FLEX OPTION')?_c('td',[_vm._v(_vm._s(srvcs.description))]):_vm._e(),_vm._v(" "),(srvcs.code !== 'FLEX OPTION')?_c('td',{staticStyle:{"text-transform":"none"}},[(srvcs.userInputSrvcsDetails_Count > 1)?_c('span',[_vm._v(_vm._s(srvcs.userInputSrvcsDetails_Count)+"x a "+_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price)))]):_vm._e()]):_vm._e(),_vm._v(" "),(srvcs.code !== 'FLEX OPTION')?_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0')))]):_vm._e(),_vm._v(" "),(srvcs.code === 'FLEX OPTION')?_c('td',{staticStyle:{"background-color":"#BD6196","color":"#fff","padding-left":"3px"}},[_vm._v(_vm._s(srvcs.description))]):_vm._e(),_vm._v(" "),(srvcs.code === 'FLEX OPTION')?_c('td',{staticStyle:{"text-transform":"none","background-color":"#BD6196","color":"#fff"}},[(srvcs.userInputSrvcsDetails_Count > 1)?_c('span',[_vm._v(_vm._s(srvcs.userInputSrvcsDetails_Count)+"x a "+_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price)))]):_vm._e()]):_vm._e(),_vm._v(" "),(srvcs.code === 'FLEX OPTION')?_c('td',{staticClass:"total-price-value-small",staticStyle:{"background-color":"#BD6196","color":"#fff"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0')))]):_vm._e()])})],2)]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('table',[_c('tbody',[_c('tr',[(_vm.modulo === 'booking')?_c('td',[_vm._v(_vm._s(_vm.flightprice[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('td',[_vm._v(_vm._s(_vm.flightpriceservices[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),(_vm.modulo === 'booking')?_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return.totalprice !== undefined ? pax.return.totalprice : '0')))]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('td',{staticClass:"total-price-value-small"},[_vm._v(" - ")]):_vm._e()]),_vm._v(" "),(pax.return_seat.seatno !== undefined)?_c('tr',[_c('td',[_vm._v(_vm._s(_vm.seat[_vm.getCurrentLocale])+": "),_c('b',[_vm._v(_vm._s(_vm._f("truncate")(pax.return_seat.seatno,17, '...')))])]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(pax.return_seat.price !== undefined ? pax.return_seat.price : '0')))])]):_vm._e(),_vm._v(" "),_vm._l((pax.return_srvcs),function(srvcs,index2){return _c('tr',{key:index2},[_c('td',[_vm._v(_vm._s(srvcs.description))]),_vm._v(" "),_c('td',{staticStyle:{"text-transform":"none"}},[(srvcs.userInputSrvcsDetails_Count > 1)?_c('span',[_vm._v(_vm._s(srvcs.userInputSrvcsDetails_Count)+"x a "+_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price)))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"total-price-value-small"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(srvcs.price !== undefined ? parseFloat(srvcs.price) * parseFloat(srvcs.userInputSrvcsDetails_Count) : '0')))])])})],2)]):_vm._e()])])])}),_vm._v(" "),(_vm.flightdirection === 'outward')?_c('div',{staticClass:"booking-details sdr-box",staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('article',{staticClass:"detailed-logo",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"details"},[_c('dl',{staticClass:"other-details"},[_c('dt',{staticClass:"total-price"},[_vm._v(_vm._s(_vm.totaloutwardprice[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"total-price-value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getBookingCartOutwardTotal)))])])])])]):_vm._e(),_vm._v(" "),(_vm.flightdirection === 'return')?_c('div',{staticClass:"booking-details sdr-box",staticStyle:{"padding-left":"0px","padding-right":"0px"}},[_c('article',{staticClass:"detailed-logo",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"details"},[_c('dl',{staticClass:"other-details"},[_c('dt',{staticClass:"total-price"},[_vm._v(_vm._s(_vm.totalreturnprice[_vm.getCurrentLocale])+":")]),_c('dd',{staticClass:"total-price-value"},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(_vm.getBookingCartReturnTotal)))])])])])]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell logo"},[_c('img',{staticStyle:{"padding-bottom":"3px"},attrs:{"src":"/res/images/sdr140x30.png","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gray-area",attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"fourth","module":_vm.modulo}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(0),_vm._v("\n                    "+_vm._s(_vm.pleaseselectoverview[_vm.getCurrentLocale])+"\n                ")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',{staticClass:"col-sms-6 col-sm-8 col-md-9",attrs:{"id":"main"}},[(_vm.getFlagSharedAgencyLoggedIn === true)?_c('div',{staticClass:"pull-right",staticStyle:{"color":"red","font-size":"18px","margin-bottom":"15px"}},[_vm._v(_vm._s(_vm.agencycommision[_vm.getCurrentLocale])+" "+_vm._s(_vm.getSharedAgencyLoginResultsAmountAndValue(_vm.modulo)))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tab-container",attrs:{"id":"flight-features"}},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flight-details","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.tab_flightdetails[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"flight-details"}},[_c('sdr-flight-details',{attrs:{"flightdirection":"outward","modulo":_vm.modulo}}),_vm._v(" "),(_vm.getBookingFlightIdSelectedReturn !== null)?_c('div',[_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('sdr-flight-details',{attrs:{"flightdirection":"return","modulo":_vm.modulo}})],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-large full-width totalbutton sundair",class:{ sundairsrvcs: _vm.modulo === 'services' },staticStyle:{"cursor":"initial","outline":"none !important","outline-style":"none !important"},attrs:{"type":"button"}},[_vm._v("\n                                    "+_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.getBookingCartOutwardTotal) + Number(_vm.getBookingCartReturnTotal)))+"\n                                    "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.5em"}},[_vm._v(_vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale]))])])],1)])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.modulo === 'booking')?_c('div',{staticClass:"booking-information sdr-box"},[_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dl',{staticClass:"term-description"},[_c('dt',[_vm._v(_vm._s(_vm.payment_firstname[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.firstName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_lastname[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.lastName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_email[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.email))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_phone[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.phone))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_address[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.address))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_zipcode[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.zipCode))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_city[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.city))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_countrycode[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.countryCode))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getBookingProcessBookingObject.payment.type !== 'OO')?_c('p',{staticClass:"red-color"},[_vm._v("\n                            "+_vm._s(_vm.paymentismadeby[_vm.getCurrentLocale])+"\n                            "+_vm._s(_vm.getBookingProcessBookingObject.payment.ccPayment !== undefined ?
                            _vm.creditcard[_vm.getCurrentLocale] : null)+"\n                            "+_vm._s(_vm.getBookingProcessBookingObject.payment.ddPayment !== undefined ?
                            _vm.debit[_vm.getCurrentLocale] : null)+"\n                            "+_vm._s(_vm.getBookingProcessBookingObject.payment.type === 'CS' ? _vm.cashpayment[_vm.getCurrentLocale]
                            : null)+"\n                            .")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services' )?_c('div',{staticClass:"booking-information sdr-box"},[_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dl',{staticClass:"term-description"},[_c('dt',[_vm._v(_vm._s(_vm.payment_firstname[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.firstName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_lastname[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.lastName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_email[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.email))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_phone[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.phone))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_address[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.address))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_zipcode[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.zipCode))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_city[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.city))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_countrycode[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.countryCode))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getServicesProcessBookingObject.payment.type !== 'OO')?_c('p',{staticClass:"red-color"},[_vm._v("\n                            "+_vm._s(_vm.paymentismadeby[_vm.getCurrentLocale])+"\n                            "+_vm._s(_vm.getServicesProcessBookingObject.payment.ccPayment !== undefined ? _vm.creditcard[_vm.getCurrentLocale] : null)+"\n                            "+_vm._s(_vm.getServicesProcessBookingObject.payment.ddPayment !== undefined ? _vm.debit[_vm.getCurrentLocale] : null)+"\n                            "+_vm._s(_vm.getServicesProcessBookingObject.payment.type === 'CS' ? _vm.cashpayment[_vm.getCurrentLocale] : null)+"\n                        .")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"booking-section sdr-box"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h2',{staticClass:"idea-title red-color",staticStyle:{"margin-bottom":"15px"}},[_vm._m(1),_vm._v("\n                                "+_vm._s(_vm.pleaseconfirm[_vm.getCurrentLocale])+":\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('p-check',{staticClass:"p-svg p-round p-pulse",attrs:{"color":"success","value":"ABB","id":"check"},model:{value:(_vm.checkedBoxes),callback:function ($$v) {_vm.checkedBoxes=$$v},expression:"checkedBoxes"}},[_c('svg',{staticClass:"svg svg-icon",attrs:{"slot":"extra","viewBox":"0 0 20 20"},slot:"extra"},[_c('path',{staticStyle:{"stroke":"white","fill":"white"},attrs:{"d":"M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"}})])]),_vm._v(" \n                            "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('ABB')}}},[_c('span',{staticClass:"xskin-color",staticStyle:{"font-size":"1.0833em"}},[_vm._v(_vm._s(_vm.form_confirmabb_1[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-check',{staticClass:"p-svg p-round p-pulse",attrs:{"color":"success","value":"AGB","id":"check"},model:{value:(_vm.checkedBoxes),callback:function ($$v) {_vm.checkedBoxes=$$v},expression:"checkedBoxes"}},[_c('svg',{staticClass:"svg svg-icon",attrs:{"slot":"extra","viewBox":"0 0 20 20"},slot:"extra"},[_c('path',{staticStyle:{"stroke":"white","fill":"white"},attrs:{"d":"M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"}})])]),_vm._v(" \n                            "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('AGB')}}},[_c('span',{staticClass:"xskin-color",staticStyle:{"font-size":"1.0833em"}},[_vm._v(_vm._s(_vm.form_confirmagb_1[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p-check',{staticClass:"p-svg p-round p-pulse",attrs:{"color":"success","value":"PRIVACY","id":"check"},model:{value:(_vm.checkedBoxes),callback:function ($$v) {_vm.checkedBoxes=$$v},expression:"checkedBoxes"}},[_c('svg',{staticClass:"svg svg-icon",attrs:{"slot":"extra","viewBox":"0 0 20 20"},slot:"extra"},[_c('path',{staticStyle:{"stroke":"white","fill":"white"},attrs:{"d":"M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"}})])]),_vm._v(" \n                            "),_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.call_getwebcomponent('PCPE')}}},[_c('span',{staticClass:"xskin-color",staticStyle:{"font-size":"1.0833em"}},[_vm._v(_vm._s(_vm.form_confirmprivacy_1[_vm.getCurrentLocale]))])])],1)]),_vm._v(" "),(_vm.getFlagBookingOverviewIsReadyForProcess !== true)?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.getFlagBookingOverviewIsReadyForProcess === true)?_c('button',{staticClass:"btn-large icon-check uppercase full-width",class:{ sundairsrvcs: _vm.modulo === 'services', 'icon-check3': _vm.modulo === 'services' },attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.proceed[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sms-6 col-sm-4 col-md-3"},[_c('sdr-shared-cart',{attrs:{"modulo":_vm.modulo}}),_vm._v(" "),_c('sdr-contact-box')],1)])]),_vm._v(" "),_c('modal',{attrs:{"name":"size-modal2","transition":"nice-modal-fade","classes":"demo-modal-class","min-width":200,"min-height":200,"pivot-y":0.5,"adaptive":true,"scrollable":true,"reset":true,"xwidth":"40%","height":"auto"},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed,"before-close":_vm.beforeClose}},[_c('div',{staticClass:"size-modal2-content"},[_c('h2',[_vm._v(_vm._s(_vm.webcomponenttype))]),_vm._v(" "),(_vm.sections.length > 1)?_c('span',_vm._l((_vm.sections),function(section,index){return _c('div',{key:index,staticClass:"toggle-container box",staticStyle:{"margin-bottom":"0px"},attrs:{"id":"accordion1"}},[_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":'#acc1_' + index,"data-toggle":"collapse","data-parent":"#accordion1"}},[_vm._v(_vm._s(section.title))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'acc1_' + index}},[_c('div',{staticClass:"panel-content"},[_c('span',{domProps:{"innerHTML":_vm._s(section.content)}})])])])])})):_vm._e(),_vm._v(" "),(_vm.sections.length === 1)?_c('span',[_c('div',{staticClass:"panel style1"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.sections[0].content)}})])]):_vm._e()])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index",staticStyle:{"background":"#D13E47"}},[_c('i',{staticClass:"soap-icon-notice circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6147_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__ = __webpack_require__(475);
function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-003a6147"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_003a6147_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Confirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(470);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1c15665f", content, true, {});

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".booking-information>.booking-confirmation .main-message[data-v-003a6147]{color:#ec008b}dl.term-description dt[data-v-003a6147]{color:#9e4d84}.totalbutton[data-v-003a6147]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.swal-button[data-v-003a6147]{padding:0!important}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-003a6147]{font-size:1.5em}h2[data-v-003a6147]{font-size:1.4em}a.button.btn-large[data-v-003a6147],button.btn-large[data-v-003a6147],input[type=button].button.btn-large[data-v-003a6147]{font-size:1em}.booking-information[data-v-003a6147]{padding:20px 15px}}", ""]);

// exports


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingNoGoBackBox_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ba3e54_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingNoGoBackBox_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07ba3e54"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BookingNoGoBackBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07ba3e54_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingNoGoBackBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(473);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("21963acd", content, true, {});

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdr-box book-with-us-box",staticStyle:{"border":"1px solid #ec008b"}},[_c('h4',[_vm._v(_vm._s(_vm.needhelp[_vm.getCurrentLocale]))]),_vm._v(" "),_c('ul',[_c('li',[_c('i',{staticClass:"soap-icon-trunk-3 circle"}),_vm._v(" "),_c('h5',{staticClass:"title"},[_c('a',{staticClass:"skin-color",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.sideboxhelptext1[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.sideboxhelptext2[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-medium icon-check uppercase full-width",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.onClick_GoBack()}}},[_vm._v(_vm._s(_vm.goback[_vm.getCurrentLocale]))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gray-area",attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"fifth","module":_vm.modulo}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(0),_vm._v(_vm._s(_vm.bookingconfirmation[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[(_vm.modulo === 'booking')?_c('div',{staticClass:"booking-information sdr-box"},[_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingProcessBookingResults.bookingCode)+", "+_vm._s(_vm.pleaseselectconfirmation2[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingProcessBookingResults.idInvoice))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"booking-confirmation clearfix"},[_c('i',{staticClass:"soap-icon-recommend icon circle"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('h4',{staticClass:"main-message"},[_vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dl',{staticClass:"term-description"},[_c('dt',[_vm._v(_vm._s(_vm.payment_firstname[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.firstName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_lastname[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.lastName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_email[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.email))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_phone[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.phone))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_address[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.address))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_zipcode[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.zipCode))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_city[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.city))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_countrycode[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getBookingProcessBookingObject.customer.countryCode))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getBookingProcessBookingObject.payment.type !== 'OO')?_c('p',{staticClass:"red-color"},[_vm._v("\n                        "+_vm._s(_vm.paymentismadeby[_vm.getCurrentLocale])+"\n                        "+_vm._s(_vm.getBookingProcessBookingObject.payment.ccPayment !== undefined ? _vm.creditcard[_vm.getCurrentLocale] : null)+"\n                        "+_vm._s(_vm.getBookingProcessBookingObject.payment.ddPayment !== undefined ? _vm.debit[_vm.getCurrentLocale] : null)+"\n                        "+_vm._s(_vm.getBookingProcessBookingObject.payment.type === 'CS' ? _vm.cashpayment[_vm.getCurrentLocale] : null)+"\n                    .")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.modulo === 'services')?_c('div',{staticClass:"booking-information sdr-box"},[_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale])+" "+_vm._s(_vm.getServicesProcessBookingResults.newSpecialsResponse.invoice.bookingCode)+", "+_vm._s(_vm.pleaseselectconfirmation2[_vm.getCurrentLocale])+" "+_vm._s(_vm.getServicesProcessBookingResults.newSpecialsResponse.invoice.idInvoice))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"booking-confirmation clearfix"},[_c('i',{staticClass:"soap-icon-recommend icon circle"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('h4',{staticClass:"main-message"},[_vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.payment[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('dl',{staticClass:"term-description"},[_c('dt',[_vm._v(_vm._s(_vm.payment_firstname[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.firstName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_lastname[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.lastName))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_email[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.email))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_phone[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.phone))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_address[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.address))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_zipcode[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.zipCode))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_city[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.city))]),_vm._v(" "),_c('dt',[_vm._v(_vm._s(_vm.payment_countrycode[_vm.getCurrentLocale])+":")]),_c('dd',[_vm._v(_vm._s(_vm.getServicesProcessBookingObject.customer.countryCode))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',{staticStyle:{"color":"#4f657e"}},[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.getServicesProcessBookingObject.payment.type !== 'OO')?_c('p',{staticClass:"red-color"},[_vm._v("\n                        "+_vm._s(_vm.paymentismadeby[_vm.getCurrentLocale])+"\n                        "+_vm._s(_vm.getServicesProcessBookingObject.payment.ccPayment !== undefined ? _vm.creditcard[_vm.getCurrentLocale] : null)+"\n                        "+_vm._s(_vm.getServicesProcessBookingObject.payment.ddPayment !== undefined ? _vm.debit[_vm.getCurrentLocale] : null)+"\n                        "+_vm._s(_vm.getServicesProcessBookingObject.payment.type === 'CS' ? _vm.cashpayment[_vm.getCurrentLocale] : null)+"\n                    .")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"tab-container",attrs:{"id":"flight-features"}},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flight-details","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.tab_flightdetails[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"flight-details"}},[_c('sdr-flight-details',{attrs:{"flightdirection":"outward","modulo":_vm.modulo}}),_vm._v(" "),(_vm.getBookingFlightIdSelectedReturn !== null)?_c('div',[_c('br'),_c('hr'),_c('br'),_vm._v(" "),_c('sdr-flight-details',{attrs:{"flightdirection":"return","modulo":_vm.modulo}})],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn-large full-width totalbutton",class:{ sundairsrvcs: _vm.modulo === 'services' },staticStyle:{"cursor":"initial"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.getBookingCartOutwardTotal) + Number(_vm.getBookingCartReturnTotal)))),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"0.5em"}},[_vm._v(_vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale]))])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sms-6 col-sm-4 col-md-3"},[_c('sdr-contact-box'),_vm._v(" "),(_vm.modulo === 'services' && _vm.get_areWeInServicesBookingNoMode === true)?_c('sdr-bookingnogoback-box'):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routesinfos; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_infos_luggage_Home_vue__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_infos_important_infos_Home_vue__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_infos_dangerous_goods_Home_vue__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_infos_prohibited_items_Home_vue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_infos_additional_services_Home_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_infos_serviceonboard_Home_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_infos_seat_reservation_Home_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_infos_fare_conditions_Home_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_infos_group_booking_Home_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_infos_infoalert_Home_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_infos_dataprotection_Home_vue__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_infos_info3g_Home_vue__ = __webpack_require__(531);
/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Infos'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
 // lugagge
 // covid => important-infos
 // dangerous-goods
 // prohibited-items
 // additional-services
 // serviceonboard
 // seat-reservation
 // fare-conditions
// import HomeInfosComplaints from '../../../components/infos/complaints/Home.vue'; // complaints
 // group-booking
 // infoalert (Ticket:APP)
 // data protection (Bast Wish)
 // infoalert (Ticket:APP)

var routesinfos = [{ path: '/luggage', component: __WEBPACK_IMPORTED_MODULE_0__components_infos_luggage_Home_vue__["a" /* default */] }, { path: '/important-infos', component: __WEBPACK_IMPORTED_MODULE_1__components_infos_important_infos_Home_vue__["a" /* default */] }, { path: '/dangerous-goods', component: __WEBPACK_IMPORTED_MODULE_2__components_infos_dangerous_goods_Home_vue__["a" /* default */] }, { path: '/prohibited-items', component: __WEBPACK_IMPORTED_MODULE_3__components_infos_prohibited_items_Home_vue__["a" /* default */] }, { path: '/additional-services', component: __WEBPACK_IMPORTED_MODULE_4__components_infos_additional_services_Home_vue__["a" /* default */] }, { path: '/serviceonboard', component: __WEBPACK_IMPORTED_MODULE_5__components_infos_serviceonboard_Home_vue__["a" /* default */] }, { path: '/seat-reservation', component: __WEBPACK_IMPORTED_MODULE_6__components_infos_seat_reservation_Home_vue__["a" /* default */] }, { path: '/fare-conditions', component: __WEBPACK_IMPORTED_MODULE_7__components_infos_fare_conditions_Home_vue__["a" /* default */] },
// { path: '/complaints', component: HomeInfosComplaints },
{ path: '/group-booking', component: __WEBPACK_IMPORTED_MODULE_8__components_infos_group_booking_Home_vue__["a" /* default */] }, { path: '/infoalert', component: __WEBPACK_IMPORTED_MODULE_9__components_infos_infoalert_Home_vue__["a" /* default */] }, { path: '/dataprotection', component: __WEBPACK_IMPORTED_MODULE_10__components_infos_dataprotection_Home_vue__["a" /* default */] }, { path: '/info3g', component: __WEBPACK_IMPORTED_MODULE_11__components_infos_info3g_Home_vue__["a" /* default */] }];

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af3c8e5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(478)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0af3c8e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af3c8e5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(479);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0354864d", content, true, {});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "ul.arrow-square[data-v-0af3c8e5],ul.arrow[data-v-0af3c8e5],ul.check-circle[data-v-0af3c8e5],ul.check-square[data-v-0af3c8e5],ul.check[data-v-0af3c8e5],ul.chevron[data-v-0af3c8e5],ul.circle[data-v-0af3c8e5],ul.decimal[data-v-0af3c8e5],ul.lower-latin[data-v-0af3c8e5],ul.triangle[data-v-0af3c8e5],ul.upper-latin[data-v-0af3c8e5],ul.upper-roman[data-v-0af3c8e5]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-0af3c8e5]{font-size:1.6em}.booking-information[data-v-0af3c8e5]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(481);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("475885d7", content, true, {});

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sdr-box"},[_c('h5',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.aboutsundair[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.aboutsundairtext[_vm.getCurrentLocale])}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(484);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9c409960", content, true, {});

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-map-area promo-box no-margin",attrs:{"data-stellar-background-ratio":"0.5"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content-section description pull-right col-sm-9"},[_c('div',{staticClass:"table-wrapper hidden-table-sm"},[_c('div',{staticClass:"table-cell"},[_c('h1',{staticClass:"m-title animated",attrs:{"data-animation-type":"fadeInDown"}},[_vm._v("\n                        "+_vm._s(_vm.promotext1[_vm.getCurrentLocale])),_c('br'),_vm._v(" "),_c('em',[_vm._v(_vm._s(_vm.promotext2[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"action-section table-cell"},[_c('button',{staticClass:"btn-large animated",attrs:{"data-animation-type":"bounce","data-animation-delay":"0.5","onclick":"window.location.href = '/booking';"}},[_vm._v(_vm._s(_vm.booknowwithus[_vm.getCurrentLocale]))])])])]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container col-sm-4"},[_c('img',{staticClass:"animated",attrs:{"src":"/res/images/shared/familie.png","alt":"","width":"","height":"195","data-animation-type":"fadeInUp"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.luggage_h4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.luggage_h5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.luggage_h5_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.luggage_h5_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_3[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_6[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_6[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_7[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_8[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.luggage_h5_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_9[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_10[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_7[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_8[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_9[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_10[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_11[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_12[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.luggage_li_13[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.luggage_p_11[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('p',[_vm._v("Update: 27.01.2021")])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4784d60c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(492);
function injectStyle (ssrContext) {
  __webpack_require__(488)
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4784d60c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4784d60c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(489);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2e850bca", content, true, {});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "ul.arrow-square[data-v-4784d60c],ul.arrow[data-v-4784d60c],ul.check-circle[data-v-4784d60c],ul.check-square[data-v-4784d60c],ul.check[data-v-4784d60c],ul.chevron[data-v-4784d60c],ul.circle[data-v-4784d60c],ul.decimal[data-v-4784d60c],ul.lower-latin[data-v-4784d60c],ul.triangle[data-v-4784d60c],ul.upper-latin[data-v-4784d60c],ul.upper-roman[data-v-4784d60c]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-4784d60c]{font-size:1.6em}.booking-information[data-v-4784d60c]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(491);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("60cd4dbc", content, true, {});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".test ul{list-style:square!important;margin:15px}.test li:not(:last-child){margin-bottom:-10px}", ""]);

// exports


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[(_vm.getCurrentLocale ==='de')?_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.get_CovidText_DE.headline))]):_vm._e(),_vm._v(" "),(_vm.getCurrentLocale ==='en')?_c('h1',{staticClass:"idea-title"},[_vm._m(1),_vm._v(_vm._s(_vm.get_CovidText_EN.headline))]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[(_vm.getCurrentLocale ==='de')?_c('span',{staticClass:"test",domProps:{"innerHTML":_vm._s(_vm.get_CovidText_DE.content)}}):_vm._e(),_vm._v(" "),(_vm.getCurrentLocale ==='en')?_c('span',{staticClass:"test",domProps:{"innerHTML":_vm._s(_vm.get_CovidText_EN.content)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339b0776_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(496);
function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-339b0776"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339b0776_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(495);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6f8d3b7c", content, true, {});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "ul.arrow-square[data-v-339b0776],ul.arrow[data-v-339b0776],ul.check-circle[data-v-339b0776],ul.check-square[data-v-339b0776],ul.check[data-v-339b0776],ul.chevron[data-v-339b0776],ul.circle[data-v-339b0776],ul.decimal[data-v-339b0776],ul.lower-latin[data-v-339b0776],ul.triangle[data-v-339b0776],ul.upper-latin[data-v-339b0776],ul.upper-roman[data-v-339b0776]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-339b0776]{font-size:1.6em}.booking-information[data-v-339b0776]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.goods_h4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.goods_h5_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.goods_p_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.goods_p_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.goods_h5_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.goods_h5_21[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_6[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_7[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_8[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_9[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_10[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_11[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_12[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_13[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_14[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_15[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_16[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.goods_h5_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.goods_p_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_17[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_18[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_19[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_20[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.goods_li_21[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.goods_p_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.goods_p_5[_vm.getCurrentLocale])}}),_c('p'),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"https://www.lba.de/DE/Betrieb/Gefahrgut/Passagierinformation/Passagierinformation_node.html","target":"_new"}},[_vm._v("https://www.lba.de/DE/Betrieb/Gefahrgut/Passagierinformation/Passagierinformation_node.html")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76fbd6ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(500);
function injectStyle (ssrContext) {
  __webpack_require__(498)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76fbd6ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76fbd6ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(499);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("f5f044a0", content, true, {});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "ul.arrow-square[data-v-76fbd6ec],ul.arrow[data-v-76fbd6ec],ul.check-circle[data-v-76fbd6ec],ul.check-square[data-v-76fbd6ec],ul.check[data-v-76fbd6ec],ul.chevron[data-v-76fbd6ec],ul.circle[data-v-76fbd6ec],ul.decimal[data-v-76fbd6ec],ul.lower-latin[data-v-76fbd6ec],ul.triangle[data-v-76fbd6ec],ul.upper-latin[data-v-76fbd6ec],ul.upper-roman[data-v-76fbd6ec]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-76fbd6ec]{font-size:1.6em}.booking-information[data-v-76fbd6ec]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.prohibited_h4_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.prohibited_h5_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_6[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_7[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.prohibited_h4_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.prohibited_h5_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_8[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_9[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_10[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_11[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_12[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_13[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_14[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_15[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_16[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_17[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_18[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_19[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_20[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_21[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_22[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_23[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_24[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_25[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_26[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_6[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_27[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_28[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_29[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_30[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_31[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_32[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_7[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_33[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_34[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_35[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.prohibited_p_8[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_36[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_37[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_38[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_39[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_40[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_41[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_42[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.prohibited_li_43[_vm.getCurrentLocale])}})])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be65f4e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5be65f4e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5be65f4e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(503);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2d4867dc", content, true, {});

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-5be65f4e]{font-size:1.6em}.booking-information[data-v-5be65f4e]{padding:20px 30px 30px;padding:20px 3px 30px}}", ""]);

// exports


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('center',[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.add_h4_1[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',[_vm._v(" ")]),_vm._v(" "),_c('th',{domProps:{"innerHTML":_vm._s(_vm.add_th_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('th',{domProps:{"innerHTML":_vm._s(_vm.add_th_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('th',{domProps:{"innerHTML":_vm._s(_vm.add_th_3[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{domProps:{"innerHTML":_vm._s(_vm.add_th_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('th',[_vm._v(" ")]),_vm._v(" "),_c('th',{domProps:{"innerHTML":_vm._s(_vm.add_th_5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('th',{domProps:{"innerHTML":_vm._s(_vm.add_th_6[_vm.getCurrentLocale])}})])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_1_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_1_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_1_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_1_4[_vm.getCurrentLocale])}},[_vm._v("/td>\n                                ")])]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_2_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_2_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_2_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_2_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_3_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_3_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_3_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_3_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_4_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_4_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_4_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_4_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_6_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_6_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_6_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_6_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_7_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_7_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_7_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_7_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_8_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_8_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_8_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_8_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_9_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_9_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_9_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_9_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_10_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_10_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_10_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_10_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_11_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_11_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_11_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_11_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_12_1[_vm.getCurrentLocale])}},[_c('b')]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_13_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_13_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_13_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_13_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_14_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_14_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_14_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_14_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_15_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_15_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_15_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_15_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_16_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_16_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_16_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_16_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_18_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_18_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_18_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_18_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_19_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_19_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_19_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_19_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_20_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_20_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_20_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_20_4[_vm.getCurrentLocale])}})]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_21_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_22_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_22_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_22_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_23_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_23_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_23_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_24_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_24_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_24_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_25_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_25_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_25_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_26_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_26_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_26_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('tr',[_c('th',{attrs:{"scope":"row"},domProps:{"innerHTML":_vm._s(_vm.add_row_27_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])]),_vm._v(" "),_c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_28_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_28_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',{domProps:{"innerHTML":_vm._s(_vm.add_row_28_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('td',[_vm._v(" ")])])])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.add_p_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.add_p_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.add_p_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.add_p_31[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.add_p_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.add_footer_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Update: 24.03.2023")])],1)]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")]),_vm._v(" "),_c('td',[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1791e816_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(508);
function injectStyle (ssrContext) {
  __webpack_require__(506)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1791e816"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1791e816_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(507);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0a6ff878", content, true, {});

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "a[target=_blank][data-v-1791e816]:after{font-family:FontAwesome;content:\" \\F08E\"}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-1791e816]{font-size:1.6em}.booking-information[data-v-1791e816]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v("\n                            "+_vm._s(_vm.titleinfo[_vm.getCurrentLocale])+"\n                        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.servicesonboard_h4_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.servicesonboard_p_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',[_vm._v("\n                            "+_vm._s(_vm.meal_text2[_vm.getCurrentLocale])+"\n                            "),_c('a',{staticStyle:{"font-size":"15.9996px","color":"#D6254D"},attrs:{"href":"https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf","target":"_blank"}},[_vm._v(_vm._s(_vm.furtherservices_seat_here[_vm.getCurrentLocale]))]),_vm._v(".\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f521672_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(512);
function injectStyle (ssrContext) {
  __webpack_require__(510)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f521672"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f521672_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(511);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("251efc3b", content, true, {});

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "ul.arrow-square[data-v-6f521672],ul.arrow[data-v-6f521672],ul.check-circle[data-v-6f521672],ul.check-square[data-v-6f521672],ul.check[data-v-6f521672],ul.chevron[data-v-6f521672],ul.circle[data-v-6f521672],ul.decimal[data-v-6f521672],ul.lower-latin[data-v-6f521672],ul.triangle[data-v-6f521672],ul.upper-latin[data-v-6f521672],ul.upper-roman[data-v-6f521672]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-6f521672]{font-size:1.6em}.booking-information[data-v-6f521672]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.seat_h4_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.seat_h5_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_5[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_5[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_6[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.seat_h5_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_7[_vm.getCurrentLocale])}}),_vm._v(" "),_c('ul',{staticClass:"check-circle box",staticStyle:{"margin-bottom":"10px","margin-left":"15px"}},[_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_1_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('li',{domProps:{"innerHTML":_vm._s(_vm.seat_li_5[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_8[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_9[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('br'),_c('p',{domProps:{"innerHTML":_vm._s(_vm.seat_p_10[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.phone[_vm.getCurrentLocale])+":  +49 (0)30 53 67 67 91"),_c('br'),_vm._v("\n                        "+_vm._s(_vm.email[_vm.getCurrentLocale])+": "),_c('a',{attrs:{"href":"mailto:kundenservice@sundair.com"}},[_vm._v("Kundenservice@Sundair.com")])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1718ee9f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(516);
function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1718ee9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1718ee9f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(515);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4d7918c3", content, true, {});

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-1718ee9f]{font-size:1.6em}.booking-information[data-v-1718ee9f]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.fare_h4_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.fare_p_1[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.fare_h4_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.fare_p_2[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.fare_h4_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.fare_p_3[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('h4',{domProps:{"innerHTML":_vm._s(_vm.fare_h4_4[_vm.getCurrentLocale])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.fare_p_4[_vm.getCurrentLocale])}})])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b05bc810_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(520);
function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b05bc810"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b05bc810_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(519);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("62308664", content, true, {});

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".radio input[type=radio][data-v-b05bc810]{filter:alpha(opacity=1);-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=1)\";-moz-opacity:1;-khtml-opacity:1;opacity:1}.selector select[data-v-b05bc810]{opacity:1}input[data-v-b05bc810]:focus{outline:none}.selector select:focus+.custom-select[data-v-b05bc810],input.input-text[data-v-b05bc810]:focus,textarea[data-v-b05bc810]:focus{outline:none;border:1px solid #d3e4f7;box-shadow:0 0 8px #d3e4f7}input.input-text.invalid[data-v-b05bc810]{border:1px solid red;background-color:#fdecf8}.selector select.invalid[data-v-b05bc810]{border:1px solid red}.errormsg[data-v-b05bc810]{margin-bottom:3px;margin-top:3px;color:red}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-b05bc810]{font-size:1.6em}.booking-section[data-v-b05bc810]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner imagebg-container",staticStyle:{"height":"350px","background-image":"url(/res/images/group-booking/groupbooking-banner.jpg)"}},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"big-caption"},[_vm._v(_vm._s(_vm.bannerline1[_vm.getCurrentLocale])+" "),_c('em',[_vm._v(_vm._s(_vm.now[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('h2',{staticClass:"med-caption yellow-color"},[_vm._v(_vm._s(_vm.bannerline2[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sentSuccessful === false),expression:"sentSuccessful === false"}],staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.titleinfo[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"sdr-box booking-section"},[_c('h3',[_vm._v(_vm._s(_vm.welcome[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.welcometext1[_vm.getCurrentLocale])}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"sdr-box booking-section"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit($event)}}},[_c('div',[_c('h2',[_vm._v(_vm._s(_vm.groupbooking[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.request[_vm.getCurrentLocale])+":")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group row choose-travel"},[_c('div',{staticClass:"col-xs-12 col-md-5 constant-column-2"},[_c('div',[_c('label',{staticClass:"radio radio-inline",staticStyle:{"margin-left":"0px"}},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"1","checked":""},on:{"change":function($event){_vm.outwardonly = false}}}),_vm._v(_vm._s(_vm.outwardandreturnflight[_vm.getCurrentLocale])+"\n                                            ")])]),_vm._v(" "),_c('div',[_c('label',{staticClass:"radio radio-inline"},[_c('input',{attrs:{"type":"radio","name":"choose-travel","value":"2"},on:{"change":function($event){_vm.outwardonly = true}}}),_vm._v(_vm._s(_vm.outwardonlyflight[_vm.getCurrentLocale])+"\n                                            ")])])])]),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_departureairport[_vm.getCurrentLocale])+":*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_departureairport),expression:"inputGroupbooking_departureairport"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_departureairport.$error },attrs:{"type":"text","id":"inputGroupbooking_departureairport","name":"inputGroupbooking_departureairport","placeholder":_vm.placeholder_departureairport[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_departureairport)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_departureairport=$event.target.value},function($event){_vm.$v.inputGroupbooking_departureairport.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_departureairport.$dirty && !_vm.$v.inputGroupbooking_departureairport.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_destinationairport[_vm.getCurrentLocale])+":*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_destinationairport),expression:"inputGroupbooking_destinationairport"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_destinationairport.$error },attrs:{"type":"text","id":"inputGroupbooking_destinationairport","name":"inputGroupbooking_destinationairport","placeholder":_vm.placeholder_destinationairport[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_destinationairport)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_destinationairport=$event.target.value},function($event){_vm.$v.inputGroupbooking_destinationairport.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_destinationairport.$dirty && !_vm.$v.inputGroupbooking_destinationairport.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_departuredate[_vm.getCurrentLocale])+":*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_departuredate),expression:"inputGroupbooking_departuredate"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_departuredate.$error },attrs:{"type":"text","id":"inputGroupbooking_departuredate","name":"inputGroupbooking_departuredate","placeholder":_vm.placeholder_departuredate[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_departuredate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_departuredate=$event.target.value},function($event){_vm.$v.inputGroupbooking_departuredate.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_departuredate.$dirty && !_vm.$v.inputGroupbooking_departuredate.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.outwardonly === false),expression:"outwardonly === false"}]},[_vm._v(_vm._s(_vm.label_destinationdate[_vm.getCurrentLocale])+":*")]),_vm._v(" "),_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.outwardonly === false),expression:"outwardonly === false"},{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_destinationdate),expression:"inputGroupbooking_destinationdate"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_destinationdate.$error },attrs:{"type":"text","id":"inputGroupbooking_destinationdate","name":"inputGroupbooking_destinationdate","placeholder":_vm.placeholder_destinationdate[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_destinationdate)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_destinationdate=$event.target.value},function($event){_vm.$v.inputGroupbooking_destinationdate.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_destinationdate.$dirty && !_vm.$v.inputGroupbooking_destinationdate.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-xs-12 col-md-5 constant-column-2"},[_c('div',[_c('label',[_vm._v(_vm._s(_vm.label_adultschilds[_vm.getCurrentLocale])+":*")]),_vm._v(" "),_c('div',{staticClass:"selector"},[_c('select',{staticClass:"full-width",attrs:{"id":"inputGroupbooking_adultschildscount","name":"inputGroupbooking_adultschildscount"}},_vm._l((_vm.range(10, 174)),function(adultsCount){return _c('option',{key:adultsCount,domProps:{"value":adultsCount}},[_vm._v(_vm._s(adultsCount))])}))])]),_vm._v(" "),_c('div',[_c('label',[_vm._v(_vm._s(_vm.label_infants[_vm.getCurrentLocale])+":*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_infantscount),expression:"inputGroupbooking_infantscount"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_infantscount.$error },attrs:{"type":"text","id":"inputGroupbooking_infantscount","name":"inputGroupbooking_infantscount","placeholder":""},domProps:{"value":(_vm.inputGroupbooking_infantscount)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_infantscount=$event.target.value},function($event){_vm.$v.inputGroupbooking_infantscount.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_infantscount.$dirty && !_vm.$v.inputGroupbooking_infantscount.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e()])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('h2',[_vm._v(_vm._s(_vm.groupdetails[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_groupname[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","id":"inputGroupbooking_groupname","name":"inputGroupbooking_groupname","placeholder":_vm.placeholder_groupname[_vm.getCurrentLocale]}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_street[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_street),expression:"inputGroupbooking_street"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_street.$error },attrs:{"type":"text","id":"inputGroupbooking_street","name":"inputGroupbooking_street","placeholder":_vm.placeholder_street[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_street)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_street=$event.target.value},function($event){_vm.$v.inputGroupbooking_street.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_street.$dirty && !_vm.$v.inputGroupbooking_street.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_streetno[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_streetno),expression:"inputGroupbooking_streetno"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_streetno.$error },attrs:{"type":"text","id":"inputGroupbooking_streetno","name":"inputGroupbooking_streetno","placeholder":_vm.placeholder_streetno[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_streetno)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_streetno=$event.target.value},function($event){_vm.$v.inputGroupbooking_streetno.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_streetno.$dirty && !_vm.$v.inputGroupbooking_streetno.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_zip[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_zip),expression:"inputGroupbooking_zip"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_zip.$error },attrs:{"type":"text","id":"inputGroupbooking_zip","name":"inputGroupbooking_zip","placeholder":_vm.placeholder_zip[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_zip)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_zip=$event.target.value},function($event){_vm.$v.inputGroupbooking_zip.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_zip.$dirty && !_vm.$v.inputGroupbooking_zip.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_zip.$dirty && !_vm.$v.inputGroupbooking_zip.numeric)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_numeric[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_zip.$dirty && !_vm.$v.inputGroupbooking_zip.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_plz[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_zip.$dirty && !_vm.$v.inputGroupbooking_zip.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_plz[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_place[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_place),expression:"inputGroupbooking_place"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_place.$error },attrs:{"type":"text","id":"inputGroupbooking_place","name":"inputGroupbooking_place","placeholder":_vm.placeholder_place[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_place)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_place=$event.target.value},function($event){_vm.$v.inputGroupbooking_place.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_place.$dirty && !_vm.$v.inputGroupbooking_place.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_place.$dirty && !_vm.$v.inputGroupbooking_place.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_place.$dirty && !_vm.$v.inputGroupbooking_place.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_residence[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_place.$dirty && !_vm.$v.inputGroupbooking_place.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_residence[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_country[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","id":"inputGroupbooking_country","name":"inputGroupbooking_country","placeholder":_vm.placeholder_country[_vm.getCurrentLocale]}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('h2',[_vm._v(_vm._s(_vm.contactfor[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_salutation[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","id":"inputGroupbooking_salutation","name":"inputGroupbooking_salutation","placeholder":_vm.placeholder_salutation[_vm.getCurrentLocale]}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_firstname[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_firstname),expression:"inputGroupbooking_firstname"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_firstname.$error },attrs:{"type":"text","id":"inputGroupbooking_firstname","name":"inputGroupbooking_firstname","placeholder":_vm.placeholder_firstname[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_firstname)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_firstname=$event.target.value},function($event){_vm.$v.inputGroupbooking_firstname.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_firstname.$dirty && !_vm.$v.inputGroupbooking_firstname.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_firstname.$dirty && !_vm.$v.inputGroupbooking_firstname.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_firstname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_firstname.$dirty && !_vm.$v.inputGroupbooking_firstname.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_firstname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_firstname.$dirty && !_vm.$v.inputGroupbooking_firstname.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_lastname[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_lastname),expression:"inputGroupbooking_lastname"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_lastname.$error },attrs:{"type":"text","id":"inputGroupbooking_lastname","name":"inputGroupbooking_lastname","placeholder":_vm.placeholder_lastname[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_lastname)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_lastname=$event.target.value},function($event){_vm.$v.inputGroupbooking_lastname.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_lastname.$dirty && !_vm.$v.inputGroupbooking_lastname.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_lastname.$dirty && !_vm.$v.inputGroupbooking_lastname.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_firstname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_lastname.$dirty && !_vm.$v.inputGroupbooking_lastname.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_firstname[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_lastname.$dirty && !_vm.$v.inputGroupbooking_lastname.letterspaces)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_letterspaces[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_phone[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_phone),expression:"inputGroupbooking_phone"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_phone.$error },attrs:{"type":"text","id":"inputGroupbooking_phone","name":"inputGroupbooking_phone","placeholder":_vm.placeholder_phone[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_phone)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_phone=$event.target.value},function($event){_vm.$v.inputGroupbooking_phone.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_phone.$dirty && !_vm.$v.inputGroupbooking_phone.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_phone.$dirty && !_vm.$v.inputGroupbooking_phone.numericspaces)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_numericspaces[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_phone.$dirty && !_vm.$v.inputGroupbooking_phone.minLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_min_phone[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.$v.inputGroupbooking_phone.$dirty && !_vm.$v.inputGroupbooking_phone.maxLength)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_max_phone[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_mobile[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","id":"inputGroupbooking_mobile","name":"inputGroupbooking_mobile","placeholder":_vm.placeholder_mobile[_vm.getCurrentLocale]}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_fax[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('input',{staticClass:"input-text full-width",attrs:{"type":"text","id":"inputGroupbooking_fax","name":"inputGroupbooking_fax","placeholder":_vm.placeholder_fax[_vm.getCurrentLocale]}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_email[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_email),expression:"inputGroupbooking_email"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_email.$error },attrs:{"type":"text","id":"inputGroupbooking_email","name":"inputGroupbooking_email","placeholder":_vm.placeholder_email[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_email)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_email=$event.target.value},function($event){_vm.$v.inputGroupbooking_email.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_email.$dirty && !_vm.$v.inputGroupbooking_email.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(!_vm.$v.inputGroupbooking_email.email)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_email[_vm.getCurrentLocale]))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-5"},[_c('label',[_vm._v(_vm._s(_vm.label_emailrepeat[_vm.getCurrentLocale])+":*"),_c('small')]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputGroupbooking_emailrepeat),expression:"inputGroupbooking_emailrepeat"}],staticClass:"input-text full-width",class:{ invalid : _vm.$v.inputGroupbooking_emailrepeat.$error },attrs:{"type":"text","id":"inputGroupbooking_emailrepeat","name":"inputGroupbooking_emailrepeat","placeholder":_vm.placeholder_emailrepeat[_vm.getCurrentLocale]},domProps:{"value":(_vm.inputGroupbooking_emailrepeat)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.inputGroupbooking_emailrepeat=$event.target.value},function($event){_vm.$v.inputGroupbooking_emailrepeat.$touch()}]}}),_vm._v(" "),(_vm.$v.inputGroupbooking_emailrepeat.$dirty && !_vm.$v.inputGroupbooking_emailrepeat.required)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_required[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(!_vm.$v.inputGroupbooking_emailrepeat.email)?_c('p',{staticClass:"errormsg"},[_vm._v(_vm._s(_vm.errmsg_email[_vm.getCurrentLocale]))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-md-10"},[_c('label',[_vm._v(_vm._s(_vm.label_remark[_vm.getCurrentLocale]))]),_vm._v(" "),_c('textarea',{staticClass:"full-width",attrs:{"rows":"10","id":"inputGroupbooking_remark","name":"inputGroupbooking_remark","placeholder":_vm.placeholder_remark[_vm.getCurrentLocale]}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-6 col-md-5"},[(!_vm.vldt_Form_Groups())?_c('a',{staticClass:"button btn-large uppercase full-width silver"},[_vm._v(_vm._s(_vm.send_request[_vm.getCurrentLocale]))]):_vm._e(),_vm._v(" "),(_vm.vldt_Form_Groups())?_c('button',{staticClass:"btn-large icon-check uppercase full-width",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.send_request[_vm.getCurrentLocale]))]):_vm._e()])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sentSuccessful === true),expression:"sentSuccessful === true"}],staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(1),_vm._v(_vm._s(_vm.wasssentsuccesful[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c5ac1d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(526);
function injectStyle (ssrContext) {
  __webpack_require__(522)
  __webpack_require__(524)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c5ac1d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c5ac1d8_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(523);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("70e0af10", content, true, {});

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "a[target=_blank][data-v-3c5ac1d8]:after{font-family:FontAwesome;content:\" \\F08E\"}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-3c5ac1d8]{font-size:1.6em}.booking-information[data-v-3c5ac1d8]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(525);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("17ebcb18", content, true, {});

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".test ul{list-style:square!important;margin:15px}", ""]);

// exports


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[(_vm.getCurrentLocale ==='de')?_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v(_vm._s(_vm.get_InfoalertText_DE.headline))]):_vm._e(),_vm._v(" "),(_vm.getCurrentLocale ==='en')?_c('h1',{staticClass:"idea-title"},[_vm._m(1),_vm._v(_vm._s(_vm.get_InfoalertText_EN.headline))]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[(_vm.getCurrentLocale ==='de')?_c('span',{staticClass:"test",domProps:{"innerHTML":_vm._s(_vm.get_InfoalertText_DE.content)}}):_vm._e(),_vm._v(" "),(_vm.getCurrentLocale ==='en')?_c('span',{staticClass:"test",domProps:{"innerHTML":_vm._s(_vm.get_InfoalertText_EN.content)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c37ca978_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(530);
function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c37ca978"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c37ca978_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(529);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("bd9979d8", content, true, {});

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "a[target=_blank][data-v-c37ca978]:after{font-family:FontAwesome;content:\" \\F08E\"}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-c37ca978]{font-size:1.6em}.booking-information[data-v-c37ca978]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v("\n                            "+_vm._s(_vm.titleinfo[_vm.getCurrentLocale])+"\n                        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[(_vm.sections.length > 1)?_c('span',_vm._l((_vm.sections),function(section,index){return _c('div',{key:index,staticClass:"toggle-container box",staticStyle:{"margin-bottom":"0px"},attrs:{"id":"accordion1"}},[_c('div',{staticClass:"panel style1"},[_c('h4',{staticClass:"panel-title"},[_c('a',{staticClass:"collapsed",attrs:{"href":'#acc1_' + index,"data-toggle":"collapse","data-parent":"#accordion1"}},[_vm._v(_vm._s(section.title))])]),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",attrs:{"id":'acc1_' + index}},[_c('div',{staticClass:"panel-content"},[_c('span',{staticStyle:{"font-size":"1.0833em"},domProps:{"innerHTML":_vm._s(section.content)}})])])])])})):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5fd4ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(534);
function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e5fd4ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e5fd4ca_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4a7046fc", content, true, {});

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "a[target=_blank][data-v-6e5fd4ca]:after{font-family:FontAwesome;content:\" \\F08E\"}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-6e5fd4ca]{font-size:1.6em}.booking-information[data-v-6e5fd4ca]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports


/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title"},[_vm._m(0),_vm._v("\n                            "+_vm._s(_vm.titleinfo[_vm.getCurrentLocale])+"\n                        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"booking-information sdr-box"},[_c('h4',{domProps:{"innerHTML":_vm._s(_vm.info_h4_1[_vm.getCurrentLocale])}}),_c('br'),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.info_10[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_c('p',[_vm._v("Update: 13.12.2021")])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-md-3"},[_c('sdr-aboutsundair-box'),_vm._v(" "),_c('sdr-contact-box')],1)])])]),_vm._v(" "),_c('sdr-promobox')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-star circle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routescheckout; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_checkout_Home_vue__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_checkout_success_Success_vue__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_checkout_abort_Abort_vue__ = __webpack_require__(544);
/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Checkout'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
 // 'Home-Checkout' ..
 // 'Checkout => Success' ..
 // 'Checkout => Abort' ..

var routescheckout = [{ path: '', component: __WEBPACK_IMPORTED_MODULE_0__components_checkout_Home_vue__["a" /* default */] }, { path: '/success/:modulo?', name: 'Success', component: __WEBPACK_IMPORTED_MODULE_1__components_checkout_success_Success_vue__["a" /* default */], props: true }, { path: '/abort/:modulo?', name: 'Abort', component: __WEBPACK_IMPORTED_MODULE_2__components_checkout_abort_Abort_vue__["a" /* default */], props: true }];

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c859a31_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(539);
function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c859a31"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c859a31_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(538);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("52ea2bfc", content, true, {});

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gray-area",attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"main"}},[_vm._v("\n             \n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d0e613_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__ = __webpack_require__(543);
function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31d0e613"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Success_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31d0e613_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Success_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(542);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6523bc43", content, true, {});

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".booking-information>.booking-confirmation .main-message[data-v-31d0e613]{color:#ec008b}dl.term-description dt[data-v-31d0e613]{color:#9e4d84}.totalbutton[data-v-31d0e613]{padding-right:7px;height:43px;font-size:1.6667em;line-height:15px;text-align:right;height:57px}.swal-button[data-v-31d0e613]{padding:0!important}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-31d0e613]{font-size:1.5em}h2[data-v-31d0e613]{font-size:1.4em}a.button.btn-large[data-v-31d0e613],button.btn-large[data-v-31d0e613],input[type=button].button.btn-large[data-v-31d0e613]{font-size:1em}.booking-information[data-v-31d0e613]{padding:20px 15px}}", ""]);

// exports


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gray-area",attrs:{"id":"content"}},[(_vm.show_BookingConfirmation === true)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"fifth","module":"booking"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(0),_vm._v(_vm._s(_vm.bookingconfirmation[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"booking-information sdr-box"},[_c('h2',[_vm._v(_vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingProcessBookingResults.bookingCode)+", "+_vm._s(_vm.pleaseselectconfirmation2[_vm.getCurrentLocale])+" "+_vm._s(_vm.getBookingProcessBookingResults.idInvoice))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"booking-confirmation clearfix"},[_c('i',{staticClass:"soap-icon-recommend icon circle"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('h4',{staticClass:"main-message"},[_vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"red-color"},[_vm._v(_vm._s(_vm.creditcard[_vm.getCurrentLocale])+".")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"tab-container",attrs:{"id":"flight-features"}},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flight-details","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.yourinvoicetotal[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"flight-details"}},[_c('button',{staticClass:"btn-large full-width totalbutton",staticStyle:{"cursor":"initial"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.getBookingProcessBookingResults.totalBooking)))),_c('br'),_c('span',{staticStyle:{"font-size":"0.5em"}},[_vm._v(_vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale]))])])])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sm-4 col-md-3"},[_c('sdr-contact-box')],1)])]):_vm._e(),_vm._v(" "),(_vm.show_BlankoConfirmation === true)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"fifth","module":"services"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(1),_vm._v(_vm._s(_vm.bookingconfirmation[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"booking-information sdr-box"},[_c('h2',[_vm._v(_vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale])+" "+_vm._s(_vm.getServicesProcessBookingResults.newSpecialsResponse.invoice.bookingCode)+", "+_vm._s(_vm.pleaseselectconfirmation2[_vm.getCurrentLocale])+" "+_vm._s(_vm.getServicesProcessBookingResults.newSpecialsResponse.invoice.idInvoice))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"booking-confirmation clearfix"},[_c('i',{staticClass:"soap-icon-recommend icon circle"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('h4',{staticClass:"main-message"},[_vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"red-color"},[_vm._v(_vm._s(_vm.creditcard[_vm.getCurrentLocale])+".")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"tab-container",attrs:{"id":"flight-features"}},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flight-details","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.yourinvoicetotal[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"flight-details"}},[_c('button',{staticClass:"btn-large full-width totalbutton",staticStyle:{"cursor":"initial"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.getServicesProcessBookingResults.newSpecialsResponse.amount)))),_c('br'),_c('span',{staticStyle:{"font-size":"0.5em"}},[_vm._v(_vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale]))])])])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sm-4 col-md-3"},[_c('sdr-contact-box')],1)])]):_vm._e(),_vm._v(" "),(_vm.show_RebookingConfirmation === true)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"active_item":"sixth","module":"rebooking"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px"}},[_vm._m(2),_vm._v(_vm._s(_vm.bookingconfirmation[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"booking-information sdr-box"},[_c('h2',[_vm._v(_vm._s(_vm.pleaseselectconfirmation[_vm.getCurrentLocale])+" "+_vm._s(_vm.get_RebookingProcessRebookingResults.bookingCode)+", "+_vm._s(_vm.pleaseselectconfirmation2[_vm.getCurrentLocale])+" "+_vm._s(_vm.get_RebookingProcessRebookingResults.idInvoice))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"booking-confirmation clearfix"},[_c('i',{staticClass:"soap-icon-recommend icon circle"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('h4',{staticClass:"main-message"},[_vm._v(_vm._s(_vm.thankyou[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.emailhassent[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale])+":")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.forsecurity[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"red-color"},[_vm._v(_vm._s(_vm.creditcard[_vm.getCurrentLocale])+".")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"tab-container",attrs:{"id":"flight-features"}},[_c('ul',{staticClass:"tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#flight-details","data-toggle":"tab"}},[_vm._v(_vm._s(_vm.yourinvoicetotal[_vm.getCurrentLocale]))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane fade in active",attrs:{"id":"flight-details"}},[_c('button',{staticClass:"btn-large full-width totalbutton",staticStyle:{"cursor":"initial"}},[_vm._v(_vm._s(_vm._f("rndAmntRUAFWZ")(Number(_vm.get_RebookingProcessRebookingResults.rebookingPrice)))),_c('br'),_c('span',{staticStyle:{"font-size":"0.5em"}},[_vm._v(_vm._s(_vm.tincludedtaxes[_vm.getCurrentLocale]))])])])])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sm-4 col-md-3"},[_c('sdr-contact-box')],1)])]):_vm._e(),_vm._v(" "),(_vm.show_Error_Container === true)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"module":"booking"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px","color":"red"}},[_vm._m(3),_vm._v("\n                    "+_vm._s(_vm.pleaseselectoverview[_vm.getCurrentLocale])+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"booking-information sdr-box",staticStyle:{"border":"1px solid red"}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"booking-confirmation clearfix"},[_c('i',{staticClass:"soap-icon-notice icon circle"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('h4',{staticClass:"main-message"},[_vm._v(_vm._s(_vm.explanation[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.explanationsub[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('a',{staticClass:"print-button button btn-small sundair",attrs:{"href":"https://www.sundair.com"}},[_vm._v(_vm._s(_vm.goback[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.solution[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.solutiontext[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',[_c('p',{staticClass:"red-color"},[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"red-color underline view-link",attrs:{"href":"#"}},[_vm._v("https://www.sundair.com/")])]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sm-4 col-md-3"},[_c('sdr-contact-box')],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-arrow-right circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-error circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"end"}},[_c('img',{attrs:{"src":"/res/images/icon/warning.png","width":"25%"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Abort_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba607522_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Abort_vue__ = __webpack_require__(547);
function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba607522"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Abort_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba607522_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Abort_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(546);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9e74b9a0", content, true, {});

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".booking-information>.booking-confirmation .main-message[data-v-ba607522]{color:red}.travel-ideas .idea-title .index[data-v-ba607522]{background:red}.booking-information>.booking-confirmation>.icon[data-v-ba607522]{color:red}", ""]);

// exports


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gray-area",attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('sdr-breadcrumbs',{attrs:{"module":"booking"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"container shortcode travel-ideas"},[_c('h1',{staticClass:"idea-title",staticStyle:{"margin-bottom":"20px","color":"red"}},[_vm._m(0),_vm._v("\n                    "+_vm._s(_vm.pleaseselectoverview[_vm.getCurrentLocale])+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-9",attrs:{"id":"main"}},[_c('div',{staticClass:"booking-information sdr-box",staticStyle:{"border":"1px solid red"}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"booking-confirmation clearfix"},[_c('i',{staticClass:"soap-icon-notice icon circle"}),_vm._v(" "),_c('div',{staticClass:"message"},[_c('h4',{staticClass:"main-message"},[_vm._v(_vm._s(_vm.explanation[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.explanationsub[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('a',{staticClass:"print-button button btn-small sundair",attrs:{"href":"https://www.sundair.com"}},[_vm._v(_vm._s(_vm.goback[_vm.getCurrentLocale]))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.solution[_vm.getCurrentLocale]))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.solutiontext[_vm.getCurrentLocale])}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',[_c('p',{staticClass:"red-color"},[_vm._v(_vm._s(_vm.paymentmethod[_vm.getCurrentLocale]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"red-color underline view-link",attrs:{"href":"#"}},[_vm._v("https://www.sundair.com/")])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"sidebar col-sm-4 col-md-3"},[_c('sdr-contact-box')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"index"},[_c('i',{staticClass:"soap-icon-error circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"end"}},[_c('img',{attrs:{"src":"/res/images/icon/warning.png","width":"25%"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js